(function (t, e, i, n) {
  "use strict";
  var s,
    o,
    r,
    a,
    l,
    h,
    c,
    u,
    d,
    p,
    f,
    m,
    g,
    v,
    _,
    y,
    b,
    w,
    x,
    C,
    k,
    T,
    D,
    I,
    E,
    S,
    A,
    P =
      [].indexOf ||
      function (t) {
        for (var e = 0, i = this.length; i > e; e++)
          if (e in this && this[e] === t) return e;
        return -1;
      };
  (r = (k = "notify") + "!blank"),
    (D = {
      t: "top",
      m: "middle",
      b: "bottom",
      l: "left",
      c: "center",
      r: "right",
    }),
    (g = ["l", "c", "r"]),
    (A = ["t", "m", "b"]),
    (b = ["t", "b", "l", "r"]),
    (w = { t: "b", m: null, b: "t", l: "r", c: null, r: "l" }),
    (x = function (t) {
      var e;
      return (
        (e = []),
        i.each(t.split(/\W+/), function (t, i) {
          var s;
          return (s = i.toLowerCase().charAt(0)), D[s] ? e.push(s) : n;
        }),
        e
      );
    }),
    (S = {}),
    (a = {
      name: "core",
      html:
        '<div class="' +
        (C = k + "js") +
        '-wrapper">\n  <div class="' +
        C +
        '-arrow"></div>\n  <div class="' +
        C +
        '-container"></div>\n</div>',
      css:
        "." +
        C +
        "-corner {\n  position: fixed;\n  margin: 5px;\n  z-index: 1050;\n}\n\n." +
        C +
        "-corner ." +
        C +
        "-wrapper,\n." +
        C +
        "-corner ." +
        C +
        "-container {\n  position: relative;\n  display: block;\n  height: inherit;\n  width: inherit;\n  margin: 3px;\n}\n\n." +
        C +
        "-wrapper {\n  z-index: 1;\n  position: absolute;\n  display: inline-block;\n  height: 0;\n  width: 0;\n}\n\n." +
        C +
        "-container {\n  display: none;\n  z-index: 1;\n  position: absolute;\n}\n\n." +
        C +
        "-hidable {\n  cursor: pointer;\n}\n\n[data-notify-text],[data-notify-html] {\n  position: relative;\n}\n\n." +
        C +
        "-arrow {\n  position: absolute;\n  z-index: 2;\n  width: 0;\n  height: 0;\n}",
    }),
    (E = { "border-radius": ["-webkit-", "-moz-"] }),
    (f = function (t) {
      return S[t];
    }),
    (o = function (e, n) {
      var s, o, r, a;
      if (!e) throw "Missing Style name";
      if (!n) throw "Missing Style definition";
      if (!n.html) throw "Missing Style HTML";
      return (
        (null != (a = S[e]) ? a.cssElem : void 0) &&
          (t.console && console.warn(k + ": overwriting style '" + e + "'"),
          S[e].cssElem.remove()),
        (n.name = e),
        (S[e] = n),
        (s = ""),
        n.classes &&
          i.each(n.classes, function (t, e) {
            return (
              (s += "." + C + "-" + n.name + "-" + t + " {\n"),
              i.each(e, function (t, e) {
                return (
                  E[t] &&
                    i.each(E[t], function (i, n) {
                      return (s += "  " + n + t + ": " + e + ";\n");
                    }),
                  (s += "  " + t + ": " + e + ";\n")
                );
              }),
              (s += "}\n")
            );
          }),
        n.css && (s += "/* styles for " + n.name + " */\n" + n.css),
        s && ((n.cssElem = y(s)), n.cssElem.attr("id", "notify-" + n.name)),
        (r = {}),
        (o = i(n.html)),
        d("html", o, r),
        d("text", o, r),
        (n.fields = r)
      );
    }),
    (y = function (t) {
      var e;
      (e = l("style")).attr("type", "text/css"), i("head").append(e);
      try {
        e.html(t);
      } catch (i) {
        e[0].styleSheet.cssText = t;
      }
      return e;
    }),
    (d = function (t, e, n) {
      var s;
      return (
        "html" !== t && (t = "text"),
        u(e, "[" + (s = "data-notify-" + t) + "]").each(function () {
          var e;
          return (e = i(this).attr(s)) || (e = r), (n[e] = t);
        })
      );
    }),
    (u = function (t, e) {
      return t.is(e) ? t : t.find(e);
    }),
    (T = {
      clickToHide: !0,
      autoHide: !0,
      autoHideDelay: 5e3,
      arrowShow: !0,
      arrowSize: 5,
      breakNewLines: !0,
      elementPosition: "bottom",
      globalPosition: "top right",
      style: "bootstrap",
      className: "error",
      showAnimation: "slideDown",
      showDuration: 400,
      hideAnimation: "slideUp",
      hideDuration: 200,
      gap: 5,
    }),
    (_ = function (t, e) {
      var n;
      return ((n = function () {}).prototype = t), i.extend(!0, new n(), e);
    }),
    (h = function (t) {
      return i.extend(T, t);
    }),
    (l = function (t) {
      return i("<" + t + "></" + t + ">");
    }),
    (m = {}),
    (p = function (t) {
      var e;
      return (
        t.is("[type=radio]") &&
          ((e = t
            .parents("form:first")
            .find("[type=radio]")
            .filter(function (e, n) {
              return i(n).attr("name") === t.attr("name");
            })),
          (t = e.first())),
        t
      );
    }),
    (v = function (t, e, i) {
      var s;
      if ("string" == typeof i) i = parseInt(i, 10);
      else if ("number" != typeof i) return;
      if (!isNaN(i))
        return (
          (s = D[w[e.charAt(0)]]),
          e,
          t[s] !== n && ((e = D[s.charAt(0)]), (i = -i)),
          t[e] === n ? (t[e] = i) : (t[e] += i),
          null
        );
    }),
    (I = function (t, e, i) {
      if ("l" === t || "t" === t) return 0;
      if ("c" === t || "m" === t) return i / 2 - e / 2;
      if ("r" === t || "b" === t) return i - e;
      throw "Invalid alignment";
    }),
    (c = function (t) {
      return (c.e = c.e || l("div")), c.e.text(t).html();
    }),
    (s = (function () {
      function t(t, e, n) {
        "string" == typeof n && (n = { className: n }),
          (this.options = _(T, i.isPlainObject(n) ? n : {})),
          this.loadHTML(),
          (this.wrapper = i(a.html)),
          this.options.clickToHide && this.wrapper.addClass(C + "-hidable"),
          this.wrapper.data(C, this),
          (this.arrow = this.wrapper.find("." + C + "-arrow")),
          (this.container = this.wrapper.find("." + C + "-container")),
          this.container.append(this.userContainer),
          t &&
            t.length &&
            ((this.elementType = t.attr("type")),
            (this.originalElement = t),
            (this.elem = p(t)),
            this.elem.data(C, this),
            this.elem.before(this.wrapper)),
          this.container.hide(),
          this.run(e);
      }
      return (
        (t.prototype.loadHTML = function () {
          var t;
          return (
            (t = this.getStyle()),
            (this.userContainer = i(t.html)),
            (this.userFields = t.fields)
          );
        }),
        (t.prototype.show = function (t, e) {
          var i,
            s,
            o,
            r,
            a,
            l = this;
          if (
            ((s = function () {
              return t || l.elem || l.destroy(), e ? e() : n;
            }),
            (a = this.container.parent().parents(":hidden").length > 0),
            (o = this.container.add(this.arrow)),
            (i = []),
            a && t)
          )
            r = "show";
          else if (a && !t) r = "hide";
          else if (!a && t)
            (r = this.options.showAnimation), i.push(this.options.showDuration);
          else {
            if (a || t) return s();
            (r = this.options.hideAnimation), i.push(this.options.hideDuration);
          }
          return i.push(s), o[r].apply(o, i);
        }),
        (t.prototype.setGlobalPosition = function () {
          var t, e, n, s, o, r, a, h;
          return (
            (a = (h = this.getPosition())[0]),
            (r = h[1]),
            (o = D[a]),
            (t = D[r]),
            (e = m[(s = a + "|" + r)]) ||
              ((e = m[s] = l("div")),
              ((n = {})[o] = 0),
              "middle" === t
                ? (n.top = "45%")
                : "center" === t
                ? (n.left = "45%")
                : (n[t] = 0),
              e.css(n).addClass(C + "-corner"),
              i("body").append(e)),
            e.prepend(this.wrapper)
          );
        }),
        (t.prototype.setElementPosition = function () {
          var t,
            e,
            s,
            o,
            r,
            a,
            l,
            h,
            c,
            u,
            d,
            p,
            f,
            m,
            _,
            y,
            x,
            C,
            k,
            T,
            E,
            S,
            O,
            M,
            z,
            $,
            N,
            H;
          for (
            k = (S = this.getPosition())[0],
              C = S[1],
              S[2],
              d = this.elem.position(),
              h = this.elem.outerHeight(),
              p = this.elem.outerWidth(),
              c = this.elem.innerHeight(),
              u = this.elem.innerWidth(),
              O = this.wrapper.position(),
              r = this.container.height(),
              a = this.container.width(),
              m = D[k],
              (l = {})[(x = D[(y = w[k])])] = "b" === k ? h : "r" === k ? p : 0,
              v(l, "top", d.top - O.top),
              v(l, "left", d.left - O.left),
              M = 0,
              $ = (H = ["top", "left"]).length;
            $ > M;
            M++
          )
            (T = H[M]),
              (_ = parseInt(this.elem.css("margin-" + T), 10)) && v(l, T, _);
          if (
            ((f = Math.max(
              0,
              this.options.gap - (this.options.arrowShow ? s : 0)
            )),
            v(l, x, f),
            this.options.arrowShow)
          ) {
            for (
              s = this.options.arrowSize,
                e = i.extend({}, l),
                t =
                  this.userContainer.css("border-color") ||
                  this.userContainer.css("background-color") ||
                  "white",
                z = 0,
                N = b.length;
              N > z;
              z++
            )
              (E = D[(T = b[z])]),
                T !== y &&
                  ((o = E === m ? t : "transparent"),
                  (e["border-" + E] = s + "px solid " + o));
            v(l, D[y], s), P.call(b, C) >= 0 && v(e, D[C], 2 * s);
          } else this.arrow.hide();
          return (
            P.call(A, k) >= 0
              ? (v(l, "left", I(C, a, p)), e && v(e, "left", I(C, s, u)))
              : P.call(g, k) >= 0 &&
                (v(l, "top", I(C, r, h)), e && v(e, "top", I(C, s, c))),
            this.container.is(":visible") && (l.display = "block"),
            this.container.removeAttr("style").css(l),
            e ? this.arrow.removeAttr("style").css(e) : n
          );
        }),
        (t.prototype.getPosition = function () {
          var t, e, i, n, s, o, r, a;
          if (
            ((e =
              this.options.position ||
              (this.elem
                ? this.options.elementPosition
                : this.options.globalPosition)),
            0 === (t = x(e)).length && (t[0] = "b"),
            (i = t[0]),
            0 > P.call(b, i))
          )
            throw "Must be one of [" + b + "]";
          return (
            (1 === t.length ||
              ((n = t[0]),
              P.call(A, n) >= 0 && ((s = t[1]), 0 > P.call(g, s))) ||
              ((o = t[0]),
              P.call(g, o) >= 0 && ((r = t[1]), 0 > P.call(A, r)))) &&
              (t[1] = ((a = t[0]), P.call(g, a) >= 0 ? "m" : "l")),
            2 === t.length && (t[2] = t[1]),
            t
          );
        }),
        (t.prototype.getStyle = function (t) {
          var e;
          if (
            (t || (t = this.options.style), t || (t = "default"), !(e = S[t]))
          )
            throw "Missing style: " + t;
          return e;
        }),
        (t.prototype.updateClasses = function () {
          var t, e;
          return (
            (t = ["base"]),
            i.isArray(this.options.className)
              ? (t = t.concat(this.options.className))
              : this.options.className && t.push(this.options.className),
            (e = this.getStyle()),
            (t = i
              .map(t, function (t) {
                return C + "-" + e.name + "-" + t;
              })
              .join(" ")),
            this.userContainer.attr("class", t)
          );
        }),
        (t.prototype.run = function (t, e) {
          var s,
            o,
            a,
            l,
            h,
            d = this;
          if (
            (i.isPlainObject(e)
              ? i.extend(this.options, e)
              : "string" === i.type(e) && (this.options.className = e),
            this.container && !t)
          )
            return this.show(!1), n;
          if (this.container || t) {
            for (a in ((o = {}), i.isPlainObject(t) ? (o = t) : (o[r] = t), o))
              (s = o[a]),
                (l = this.userFields[a]) &&
                  ("text" === l &&
                    ((s = c(s)),
                    this.options.breakNewLines &&
                      (s = s.replace(/\n/g, "<br/>"))),
                  (h = a === r ? "" : "=" + a),
                  u(this.userContainer, "[data-notify-" + l + h + "]").html(s));
            return (
              this.updateClasses(),
              this.elem ? this.setElementPosition() : this.setGlobalPosition(),
              this.show(!0),
              this.options.autoHide
                ? (clearTimeout(this.autohideTimer),
                  (this.autohideTimer = setTimeout(function () {
                    return d.show(!1);
                  }, this.options.autoHideDelay)))
                : n
            );
          }
        }),
        (t.prototype.destroy = function () {
          return this.wrapper.remove();
        }),
        t
      );
    })()),
    (i[k] = function (t, e, n) {
      return (
        (t && t.nodeName) || t.jquery
          ? i(t)[k](e, n)
          : ((n = e), new s(null, (e = t), n)),
        t
      );
    }),
    (i.fn[k] = function (t, e) {
      return (
        i(this).each(function () {
          var n;
          return (n = p(i(this)).data(C)) ? n.run(t, e) : new s(i(this), t, e);
        }),
        this
      );
    }),
    i.extend(i[k], {
      defaults: h,
      addStyle: o,
      pluginOptions: T,
      getStyle: f,
      insertCSS: y,
    }),
    i(function () {
      return (
        y(a.css).attr("id", "core-notify"),
        i(e).on("click", "." + C + "-hidable", function () {
          return i(this).trigger("notify-hide");
        }),
        i(e).on("notify-hide", "." + C + "-wrapper", function () {
          var t;
          return null != (t = i(this).data(C)) ? t.show(!1) : void 0;
        })
      );
    });
})(window, document, jQuery),
  $.notify.addStyle("bootstrap", {
    html: "<div>\n<span data-notify-text></span>\n</div>",
    classes: {
      base: {
        "font-weight": "bold",
        padding: "8px 15px 8px 14px",
        "text-shadow": "0 1px 0 rgba(255, 255, 255, 0.5)",
        "background-color": "#fcf8e3",
        border: "1px solid #fbeed5",
        "border-radius": "4px",
        "white-space": "nowrap",
        "padding-left": "25px",
        "background-repeat": "no-repeat",
        "background-position": "3px 7px",
      },
      error: {
        color: "#B94A48",
        "background-color": "#F2DEDE",
        "border-color": "#EED3D7",
        "background-image":
          "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAtRJREFUeNqkVc1u00AQHq+dOD+0poIQfkIjalW0SEGqRMuRnHos3DjwAH0ArlyQeANOOSMeAA5VjyBxKBQhgSpVUKKQNGloFdw4cWw2jtfMOna6JOUArDTazXi/b3dm55socPqQhFka++aHBsI8GsopRJERNFlY88FCEk9Yiwf8RhgRyaHFQpPHCDmZG5oX2ui2yilkcTT1AcDsbYC1NMAyOi7zTX2Agx7A9luAl88BauiiQ/cJaZQfIpAlngDcvZZMrl8vFPK5+XktrWlx3/ehZ5r9+t6e+WVnp1pxnNIjgBe4/6dAysQc8dsmHwPcW9C0h3fW1hans1ltwJhy0GxK7XZbUlMp5Ww2eyan6+ft/f2FAqXGK4CvQk5HueFz7D6GOZtIrK+srupdx1GRBBqNBtzc2AiMr7nPplRdKhb1q6q6zjFhrklEFOUutoQ50xcX86ZlqaZpQrfbBdu2R6/G19zX6XSgh6RX5ubyHCM8nqSID6ICrGiZjGYYxojEsiw4PDwMSL5VKsC8Yf4VRYFzMzMaxwjlJSlCyAQ9l0CW44PBADzXhe7xMdi9HtTrdYjFYkDQL0cn4Xdq2/EAE+InCnvADTf2eah4Sx9vExQjkqXT6aAERICMewd/UAp/IeYANM2joxt+q5VI+ieq2i0Wg3l6DNzHwTERPgo1ko7XBXj3vdlsT2F+UuhIhYkp7u7CarkcrFOCtR3H5JiwbAIeImjT/YQKKBtGjRFCU5IUgFRe7fF4cCNVIPMYo3VKqxwjyNAXNepuopyqnld602qVsfRpEkkz+GFL1wPj6ySXBpJtWVa5xlhpcyhBNwpZHmtX8AGgfIExo0ZpzkWVTBGiXCSEaHh62/PoR0p/vHaczxXGnj4bSo+G78lELU80h1uogBwWLf5YlsPmgDEd4M236xjm+8nm4IuE/9u+/PH2JXZfbwz4zw1WbO+SQPpXfwG/BBgAhCNZiSb/pOQAAAAASUVORK5CYII=)",
      },
      success: {
        color: "#111111",
        "background-color": "#e4d0db",
        "border-color": "#d1b7c5",
        "background-image":
          "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAutJREFUeNq0lctPE0Ecx38zu/RFS1EryqtgJFA08YCiMZIAQQ4eRG8eDGdPJiYeTIwHTfwPiAcvXIwXLwoXPaDxkWgQ6islKlJLSQWLUraPLTv7Gme32zoF9KSTfLO7v53vZ3d/M7/fIth+IO6INt2jjoA7bjHCJoAlzCRw59YwHYjBnfMPqAKWQYKjGkfCJqAF0xwZjipQtA3MxeSG87VhOOYegVrUCy7UZM9S6TLIdAamySTclZdYhFhRHloGYg7mgZv1Zzztvgud7V1tbQ2twYA34LJmF4p5dXF1KTufnE+SxeJtuCZNsLDCQU0+RyKTF27Unw101l8e6hns3u0PBalORVVVkcaEKBJDgV3+cGM4tKKmI+ohlIGnygKX00rSBfszz/n2uXv81wd6+rt1orsZCHRdr1Imk2F2Kob3hutSxW8thsd8AXNaln9D7CTfA6O+0UgkMuwVvEFFUbbAcrkcTA8+AtOk8E6KiQiDmMFSDqZItAzEVQviRkdDdaFgPp8HSZKAEAL5Qh7Sq2lIJBJwv2scUqkUnKoZgNhcDKhKg5aH+1IkcouCAdFGAQsuWZYhOjwFHQ96oagWgRoUov1T9kRBEODAwxM2QtEUl+Wp+Ln9VRo6BcMw4ErHRYjH4/B26AlQoQQTRdHWwcd9AH57+UAXddvDD37DmrBBV34WfqiXPl61g+vr6xA9zsGeM9gOdsNXkgpEtTwVvwOklXLKm6+/p5ezwk4B+j6droBs2CsGa/gNs6RIxazl4Tc25mpTgw/apPR1LYlNRFAzgsOxkyXYLIM1V8NMwyAkJSctD1eGVKiq5wWjSPdjmeTkiKvVW4f2YPHWl3GAVq6ymcyCTgovM3FzyRiDe2TaKcEKsLpJvNHjZgPNqEtyi6mZIm4SRFyLMUsONSSdkPeFtY1n0mczoY3BHTLhwPRy9/lzcziCw9ACI+yql0VLzcGAZbYSM5CCSZg1/9oc/nn7+i8N9p/8An4JMADxhH+xHfuiKwAAAABJRU5ErkJggg==)",
      },
      info: {
        color: "#3A87AD",
        "background-color": "#D9EDF7",
        "border-color": "#BCE8F1",
        "background-image":
          "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3QYFAhkSsdes/QAAA8dJREFUOMvVlGtMW2UYx//POaWHXg6lLaW0ypAtw1UCgbniNOLcVOLmAjHZolOYlxmTGXVZdAnRfXQm+7SoU4mXaOaiZsEpC9FkiQs6Z6bdCnNYruM6KNBw6YWewzl9z+sHImEWv+vz7XmT95f/+3/+7wP814v+efDOV3/SoX3lHAA+6ODeUFfMfjOWMADgdk+eEKz0pF7aQdMAcOKLLjrcVMVX3xdWN29/GhYP7SvnP0cWfS8caSkfHZsPE9Fgnt02JNutQ0QYHB2dDz9/pKX8QjjuO9xUxd/66HdxTeCHZ3rojQObGQBcuNjfplkD3b19Y/6MrimSaKgSMmpGU5WevmE/swa6Oy73tQHA0Rdr2Mmv/6A1n9w9suQ7097Z9lM4FlTgTDrzZTu4StXVfpiI48rVcUDM5cmEksrFnHxfpTtU/3BFQzCQF/2bYVoNbH7zmItbSoMj40JSzmMyX5qDvriA7QdrIIpA+3cdsMpu0nXI8cV0MtKXCPZev+gCEM1S2NHPvWfP/hL+7FSr3+0p5RBEyhEN5JCKYr8XnASMT0xBNyzQGQeI8fjsGD39RMPk7se2bd5ZtTyoFYXftF6y37gx7NeUtJJOTFlAHDZLDuILU3j3+H5oOrD3yWbIztugaAzgnBKJuBLpGfQrS8wO4FZgV+c1IxaLgWVU0tMLEETCos4xMzEIv9cJXQcyagIwigDGwJgOAtHAwAhisQUjy0ORGERiELgG4iakkzo4MYAxcM5hAMi1WWG1yYCJIcMUaBkVRLdGeSU2995TLWzcUAzONJ7J6FBVBYIggMzmFbvdBV44Corg8vjhzC+EJEl8U1kJtgYrhCzgc/vvTwXKSib1paRFVRVORDAJAsw5FuTaJEhWM2SHB3mOAlhkNxwuLzeJsGwqWzf5TFNdKgtY5qHp6ZFf67Y/sAVadCaVY5YACDDb3Oi4NIjLnWMw2QthCBIsVhsUTU9tvXsjeq9+X1d75/KEs4LNOfcdf/+HthMnvwxOD0wmHaXr7ZItn2wuH2SnBzbZAbPJwpPx+VQuzcm7dgRCB57a1uBzUDRL4bfnI0RE0eaXd9W89mpjqHZnUI5Hh2l2dkZZUhOqpi2qSmpOmZ64Tuu9qlz/SEXo6MEHa3wOip46F1n7633eekV8ds8Wxjn37Wl63VVa+ej5oeEZ/82ZBETJjpJ1Rbij2D3Z/1trXUvLsblCK0XfOx0SX2kMsn9dX+d+7Kf6h8o4AIykuffjT8L20LU+w4AZd5VvEPY+XpWqLV327HR7DzXuDnD8r+ovkBehJ8i+y8YAAAAASUVORK5CYII=)",
      },
      warn: {
        color: "#111111",
        "background-color": "#e4d0db",
        "border-color": "#d1b7c5",
        "background-image":
          "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAABJlBMVEXr6eb/2oD/wi7/xjr/0mP/ykf/tQD/vBj/3o7/uQ//vyL/twebhgD/4pzX1K3z8e349vK6tHCilCWbiQymn0jGworr6dXQza3HxcKkn1vWvV/5uRfk4dXZ1bD18+/52YebiAmyr5S9mhCzrWq5t6ufjRH54aLs0oS+qD751XqPhAybhwXsujG3sm+Zk0PTwG6Shg+PhhObhwOPgQL4zV2nlyrf27uLfgCPhRHu7OmLgAafkyiWkD3l49ibiAfTs0C+lgCniwD4sgDJxqOilzDWowWFfAH08uebig6qpFHBvH/aw26FfQTQzsvy8OyEfz20r3jAvaKbhgG9q0nc2LbZxXanoUu/u5WSggCtp1anpJKdmFz/zlX/1nGJiYmuq5Dx7+sAAADoPUZSAAAAAXRSTlMAQObYZgAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAHdElNRQfdBgUBGhh4aah5AAAAlklEQVQY02NgoBIIE8EUcwn1FkIXM1Tj5dDUQhPU502Mi7XXQxGz5uVIjGOJUUUW81HnYEyMi2HVcUOICQZzMMYmxrEyMylJwgUt5BljWRLjmJm4pI1hYp5SQLGYxDgmLnZOVxuooClIDKgXKMbN5ggV1ACLJcaBxNgcoiGCBiZwdWxOETBDrTyEFey0jYJ4eHjMGWgEAIpRFRCUt08qAAAAAElFTkSuQmCC)",
      },
    },
  }),
  (function (t, e) {
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
      ? define(e)
      : (t.Popper = e());
  })(this, function () {
    "use strict";
    function t(t) {
      return t && "[object Function]" === {}.toString.call(t);
    }
    function e(t, e) {
      if (1 !== t.nodeType) return [];
      var i = getComputedStyle(t, null);
      return e ? i[e] : i;
    }
    function i(t) {
      return "HTML" === t.nodeName ? t : t.parentNode || t.host;
    }
    function n(t) {
      if (!t) return document.body;
      switch (t.nodeName) {
        case "HTML":
        case "BODY":
          return t.ownerDocument.body;
        case "#document":
          return t.body;
      }
      var s = e(t),
        o = s.overflow,
        r = s.overflowX,
        a = s.overflowY;
      return /(auto|scroll|overlay)/.test(o + a + r) ? t : n(i(t));
    }
    function s(t) {
      return 11 === t ? V : 10 === t ? K : V || K;
    }
    function o(t) {
      if (!t) return document.documentElement;
      for (
        var i = s(10) ? document.body : null, n = t.offsetParent;
        n === i && t.nextElementSibling;

      )
        n = (t = t.nextElementSibling).offsetParent;
      var r = n && n.nodeName;
      return r && "BODY" !== r && "HTML" !== r
        ? -1 !== ["TD", "TABLE"].indexOf(n.nodeName) &&
          "static" === e(n, "position")
          ? o(n)
          : n
        : t
        ? t.ownerDocument.documentElement
        : document.documentElement;
    }
    function r(t) {
      return null === t.parentNode ? t : r(t.parentNode);
    }
    function a(t, e) {
      if (!(t && t.nodeType && e && e.nodeType))
        return document.documentElement;
      var i = t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_FOLLOWING,
        n = i ? t : e,
        s = i ? e : t,
        l = document.createRange();
      l.setStart(n, 0), l.setEnd(s, 0);
      var h = l.commonAncestorContainer;
      if ((t !== h && e !== h) || n.contains(s))
        return (function (t) {
          var e = t.nodeName;
          return "BODY" !== e && ("HTML" === e || o(t.firstElementChild) === t);
        })(h)
          ? h
          : o(h);
      var c = r(t);
      return c.host ? a(c.host, e) : a(t, r(e).host);
    }
    function l(t) {
      var e =
          "top" ===
          (1 < arguments.length && void 0 !== arguments[1]
            ? arguments[1]
            : "top")
            ? "scrollTop"
            : "scrollLeft",
        i = t.nodeName;
      if ("BODY" === i || "HTML" === i) {
        var n = t.ownerDocument.documentElement;
        return (t.ownerDocument.scrollingElement || n)[e];
      }
      return t[e];
    }
    function h(t, e) {
      var i = 2 < arguments.length && void 0 !== arguments[2] && arguments[2],
        n = l(e, "top"),
        s = l(e, "left"),
        o = i ? -1 : 1;
      return (
        (t.top += n * o),
        (t.bottom += n * o),
        (t.left += s * o),
        (t.right += s * o),
        t
      );
    }
    function c(t, e) {
      var i = "x" === e ? "Left" : "Top",
        n = "Left" == i ? "Right" : "Bottom";
      return (
        parseFloat(t["border" + i + "Width"], 10) +
        parseFloat(t["border" + n + "Width"], 10)
      );
    }
    function u(t, e, i, n) {
      return R(
        e["offset" + t],
        e["scroll" + t],
        i["client" + t],
        i["offset" + t],
        i["scroll" + t],
        s(10)
          ? i["offset" + t] +
              n["margin" + ("Height" === t ? "Top" : "Left")] +
              n["margin" + ("Height" === t ? "Bottom" : "Right")]
          : 0
      );
    }
    function d() {
      var t = document.body,
        e = document.documentElement,
        i = s(10) && getComputedStyle(e);
      return { height: u("Height", t, e, i), width: u("Width", t, e, i) };
    }
    function p(t) {
      return X({}, t, { right: t.left + t.width, bottom: t.top + t.height });
    }
    function f(t) {
      var i = {};
      try {
        if (s(10)) {
          i = t.getBoundingClientRect();
          var n = l(t, "top"),
            o = l(t, "left");
          (i.top += n), (i.left += o), (i.bottom += n), (i.right += o);
        } else i = t.getBoundingClientRect();
      } catch (t) {}
      var r = {
          left: i.left,
          top: i.top,
          width: i.right - i.left,
          height: i.bottom - i.top,
        },
        a = "HTML" === t.nodeName ? d() : {},
        h = a.width || t.clientWidth || r.right - r.left,
        u = a.height || t.clientHeight || r.bottom - r.top,
        f = t.offsetWidth - h,
        m = t.offsetHeight - u;
      if (f || m) {
        var g = e(t);
        (f -= c(g, "x")), (m -= c(g, "y")), (r.width -= f), (r.height -= m);
      }
      return p(r);
    }
    function m(t, i) {
      var o = 2 < arguments.length && void 0 !== arguments[2] && arguments[2],
        r = s(10),
        a = "HTML" === i.nodeName,
        l = f(t),
        c = f(i),
        u = n(t),
        d = e(i),
        m = parseFloat(d.borderTopWidth, 10),
        g = parseFloat(d.borderLeftWidth, 10);
      o &&
        "HTML" === i.nodeName &&
        ((c.top = R(c.top, 0)), (c.left = R(c.left, 0)));
      var v = p({
        top: l.top - c.top - m,
        left: l.left - c.left - g,
        width: l.width,
        height: l.height,
      });
      if (((v.marginTop = 0), (v.marginLeft = 0), !r && a)) {
        var _ = parseFloat(d.marginTop, 10),
          y = parseFloat(d.marginLeft, 10);
        (v.top -= m - _),
          (v.bottom -= m - _),
          (v.left -= g - y),
          (v.right -= g - y),
          (v.marginTop = _),
          (v.marginLeft = y);
      }
      return (
        (r && !o ? i.contains(u) : i === u && "BODY" !== u.nodeName) &&
          (v = h(v, i)),
        v
      );
    }
    function g(t) {
      var e = 1 < arguments.length && void 0 !== arguments[1] && arguments[1],
        i = t.ownerDocument.documentElement,
        n = m(t, i),
        s = R(i.clientWidth, window.innerWidth || 0),
        o = R(i.clientHeight, window.innerHeight || 0),
        r = e ? 0 : l(i),
        a = e ? 0 : l(i, "left");
      return p({
        top: r - n.top + n.marginTop,
        left: a - n.left + n.marginLeft,
        width: s,
        height: o,
      });
    }
    function v(t) {
      var n = t.nodeName;
      return (
        "BODY" !== n &&
        "HTML" !== n &&
        ("fixed" === e(t, "position") || v(i(t)))
      );
    }
    function _(t) {
      if (!t || !t.parentElement || s()) return document.documentElement;
      for (var i = t.parentElement; i && "none" === e(i, "transform"); )
        i = i.parentElement;
      return i || document.documentElement;
    }
    function y(t, e, s, o) {
      var r = 4 < arguments.length && void 0 !== arguments[4] && arguments[4],
        l = { top: 0, left: 0 },
        h = r ? _(t) : a(t, e);
      if ("viewport" === o) l = g(h, r);
      else {
        var c;
        "scrollParent" === o
          ? "BODY" === (c = n(i(e))).nodeName &&
            (c = t.ownerDocument.documentElement)
          : (c = "window" === o ? t.ownerDocument.documentElement : o);
        var u = m(c, h, r);
        if ("HTML" !== c.nodeName || v(h)) l = u;
        else {
          var p = d(),
            f = p.height,
            y = p.width;
          (l.top += u.top - u.marginTop),
            (l.bottom = f + u.top),
            (l.left += u.left - u.marginLeft),
            (l.right = y + u.left);
        }
      }
      return (l.left += s), (l.top += s), (l.right -= s), (l.bottom -= s), l;
    }
    function b(t) {
      return t.width * t.height;
    }
    function w(t, e, i, n, s) {
      var o =
        5 < arguments.length && void 0 !== arguments[5] ? arguments[5] : 0;
      if (-1 === t.indexOf("auto")) return t;
      var r = y(i, n, o, s),
        a = {
          top: { width: r.width, height: e.top - r.top },
          right: { width: r.right - e.right, height: r.height },
          bottom: { width: r.width, height: r.bottom - e.bottom },
          left: { width: e.left - r.left, height: r.height },
        },
        l = Object.keys(a)
          .map(function (t) {
            return X({ key: t }, a[t], { area: b(a[t]) });
          })
          .sort(function (t, e) {
            return e.area - t.area;
          }),
        h = l.filter(function (t) {
          var e = t.width,
            n = t.height;
          return e >= i.clientWidth && n >= i.clientHeight;
        }),
        c = 0 < h.length ? h[0].key : l[0].key,
        u = t.split("-")[1];
      return c + (u ? "-" + u : "");
    }
    function x(t, e, i) {
      var n =
        3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
      return m(i, n ? _(e) : a(e, i), n);
    }
    function C(t) {
      var e = getComputedStyle(t),
        i = parseFloat(e.marginTop) + parseFloat(e.marginBottom),
        n = parseFloat(e.marginLeft) + parseFloat(e.marginRight);
      return { width: t.offsetWidth + n, height: t.offsetHeight + i };
    }
    function k(t) {
      var e = { left: "right", right: "left", bottom: "top", top: "bottom" };
      return t.replace(/left|right|bottom|top/g, function (t) {
        return e[t];
      });
    }
    function T(t, e, i) {
      i = i.split("-")[0];
      var n = C(t),
        s = { width: n.width, height: n.height },
        o = -1 !== ["right", "left"].indexOf(i),
        r = o ? "top" : "left",
        a = o ? "left" : "top",
        l = o ? "height" : "width",
        h = o ? "width" : "height";
      return (
        (s[r] = e[r] + e[l] / 2 - n[l] / 2),
        (s[a] = i === a ? e[a] - n[h] : e[k(a)]),
        s
      );
    }
    function D(t, e) {
      return Array.prototype.find ? t.find(e) : t.filter(e)[0];
    }
    function I(e, i, n) {
      return (
        (void 0 === n
          ? e
          : e.slice(
              0,
              (function (t, e, i) {
                if (Array.prototype.findIndex)
                  return t.findIndex(function (t) {
                    return t[e] === i;
                  });
                var n = D(t, function (t) {
                  return t[e] === i;
                });
                return t.indexOf(n);
              })(e, "name", n)
            )
        ).forEach(function (e) {
          e.function &&
            console.warn(
              "`modifier.function` is deprecated, use `modifier.fn`!"
            );
          var n = e.function || e.fn;
          e.enabled &&
            t(n) &&
            ((i.offsets.popper = p(i.offsets.popper)),
            (i.offsets.reference = p(i.offsets.reference)),
            (i = n(i, e)));
        }),
        i
      );
    }
    function E(t, e) {
      return t.some(function (t) {
        var i = t.name;
        return t.enabled && i === e;
      });
    }
    function S(t) {
      for (
        var e = [!1, "ms", "Webkit", "Moz", "O"],
          i = t.charAt(0).toUpperCase() + t.slice(1),
          n = 0;
        n < e.length;
        n++
      ) {
        var s = e[n],
          o = s ? "" + s + i : t;
        if (void 0 !== document.body.style[o]) return o;
      }
      return null;
    }
    function A(t) {
      var e = t.ownerDocument;
      return e ? e.defaultView : window;
    }
    function P(t, e, i, s) {
      (i.updateBound = s),
        A(t).addEventListener("resize", i.updateBound, { passive: !0 });
      var o = n(t);
      return (
        (function t(e, i, s, o) {
          var r = "BODY" === e.nodeName,
            a = r ? e.ownerDocument.defaultView : e;
          a.addEventListener(i, s, { passive: !0 }),
            r || t(n(a.parentNode), i, s, o),
            o.push(a);
        })(o, "scroll", i.updateBound, i.scrollParents),
        (i.scrollElement = o),
        (i.eventsEnabled = !0),
        i
      );
    }
    function O() {
      var t, e;
      this.state.eventsEnabled &&
        (cancelAnimationFrame(this.scheduleUpdate),
        (this.state =
          ((t = this.reference),
          (e = this.state),
          A(t).removeEventListener("resize", e.updateBound),
          e.scrollParents.forEach(function (t) {
            t.removeEventListener("scroll", e.updateBound);
          }),
          (e.updateBound = null),
          (e.scrollParents = []),
          (e.scrollElement = null),
          (e.eventsEnabled = !1),
          e)));
    }
    function M(t) {
      return "" !== t && !isNaN(parseFloat(t)) && isFinite(t);
    }
    function z(t, e) {
      Object.keys(e).forEach(function (i) {
        var n = "";
        -1 !==
          ["width", "height", "top", "right", "bottom", "left"].indexOf(i) &&
          M(e[i]) &&
          (n = "px"),
          (t.style[i] = e[i] + n);
      });
    }
    function $(t, e, i) {
      var n = D(t, function (t) {
          return t.name === e;
        }),
        s =
          !!n &&
          t.some(function (t) {
            return t.name === i && t.enabled && t.order < n.order;
          });
      if (!s) {
        var o = "`" + e + "`";
        console.warn(
          "`" +
            i +
            "` modifier is required by " +
            o +
            " modifier in order to work, be sure to include it before " +
            o +
            "!"
        );
      }
      return s;
    }
    function N(t) {
      var e = 1 < arguments.length && void 0 !== arguments[1] && arguments[1],
        i = tt.indexOf(t),
        n = tt.slice(i + 1).concat(tt.slice(0, i));
      return e ? n.reverse() : n;
    }
    function H(t, e, i, n) {
      var s = [0, 0],
        o = -1 !== ["right", "left"].indexOf(n),
        r = t.split(/(\+|\-)/).map(function (t) {
          return t.trim();
        }),
        a = r.indexOf(
          D(r, function (t) {
            return -1 !== t.search(/,|\s/);
          })
        );
      r[a] &&
        -1 === r[a].indexOf(",") &&
        console.warn(
          "Offsets separated by white space(s) are deprecated, use a comma (,) instead."
        );
      var l = /\s*,\s*|\s+/,
        h =
          -1 === a
            ? [r]
            : [
                r.slice(0, a).concat([r[a].split(l)[0]]),
                [r[a].split(l)[1]].concat(r.slice(a + 1)),
              ];
      return (
        (h = h.map(function (t, n) {
          var s = (1 === n ? !o : o) ? "height" : "width",
            r = !1;
          return t
            .reduce(function (t, e) {
              return "" === t[t.length - 1] && -1 !== ["+", "-"].indexOf(e)
                ? ((t[t.length - 1] = e), (r = !0), t)
                : r
                ? ((t[t.length - 1] += e), (r = !1), t)
                : t.concat(e);
            }, [])
            .map(function (t) {
              return (function (t, e, i, n) {
                var s = t.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),
                  o = +s[1],
                  r = s[2];
                if (!o) return t;
                if (0 === r.indexOf("%")) {
                  var a;
                  switch (r) {
                    case "%p":
                      a = i;
                      break;
                    case "%":
                    case "%r":
                    default:
                      a = n;
                  }
                  return (p(a)[e] / 100) * o;
                }
                return "vh" === r || "vw" === r
                  ? (("vh" === r
                      ? R(
                          document.documentElement.clientHeight,
                          window.innerHeight || 0
                        )
                      : R(
                          document.documentElement.clientWidth,
                          window.innerWidth || 0
                        )) /
                      100) *
                      o
                  : o;
              })(t, s, e, i);
            });
        })).forEach(function (t, e) {
          t.forEach(function (i, n) {
            M(i) && (s[e] += i * ("-" === t[n - 1] ? -1 : 1));
          });
        }),
        s
      );
    }
    for (
      var W = Math.min,
        F = Math.round,
        L = Math.floor,
        R = Math.max,
        j = "undefined" != typeof window && "undefined" != typeof document,
        B = ["Edge", "Trident", "Firefox"],
        q = 0,
        U = 0;
      U < B.length;
      U += 1
    )
      if (j && 0 <= navigator.userAgent.indexOf(B[U])) {
        q = 1;
        break;
      }
    var Y =
        j && window.Promise
          ? function (t) {
              var e = !1;
              return function () {
                e ||
                  ((e = !0),
                  window.Promise.resolve().then(function () {
                    (e = !1), t();
                  }));
              };
            }
          : function (t) {
              var e = !1;
              return function () {
                e ||
                  ((e = !0),
                  setTimeout(function () {
                    (e = !1), t();
                  }, q));
              };
            },
      V = j && !(!window.MSInputMethodContext || !document.documentMode),
      K = j && /MSIE 10/.test(navigator.userAgent),
      Q = function (t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      },
      Z = (function () {
        function t(t, e) {
          for (var i, n = 0; n < e.length; n++)
            ((i = e[n]).enumerable = i.enumerable || !1),
              (i.configurable = !0),
              "value" in i && (i.writable = !0),
              Object.defineProperty(t, i.key, i);
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      })(),
      G = function (t, e, i) {
        return (
          e in t
            ? Object.defineProperty(t, e, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (t[e] = i),
          t
        );
      },
      X =
        Object.assign ||
        function (t) {
          for (var e, i = 1; i < arguments.length; i++)
            for (var n in (e = arguments[i]))
              Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
          return t;
        },
      J = [
        "auto-start",
        "auto",
        "auto-end",
        "top-start",
        "top",
        "top-end",
        "right-start",
        "right",
        "right-end",
        "bottom-end",
        "bottom",
        "bottom-start",
        "left-end",
        "left",
        "left-start",
      ],
      tt = J.slice(3),
      et = "flip",
      it = "clockwise",
      nt = "counterclockwise",
      st = (function () {
        function e(i, n) {
          var s = this,
            o =
              2 < arguments.length && void 0 !== arguments[2]
                ? arguments[2]
                : {};
          Q(this, e),
            (this.scheduleUpdate = function () {
              return requestAnimationFrame(s.update);
            }),
            (this.update = Y(this.update.bind(this))),
            (this.options = X({}, e.Defaults, o)),
            (this.state = {
              isDestroyed: !1,
              isCreated: !1,
              scrollParents: [],
            }),
            (this.reference = i && i.jquery ? i[0] : i),
            (this.popper = n && n.jquery ? n[0] : n),
            (this.options.modifiers = {}),
            Object.keys(X({}, e.Defaults.modifiers, o.modifiers)).forEach(
              function (t) {
                s.options.modifiers[t] = X(
                  {},
                  e.Defaults.modifiers[t] || {},
                  o.modifiers ? o.modifiers[t] : {}
                );
              }
            ),
            (this.modifiers = Object.keys(this.options.modifiers)
              .map(function (t) {
                return X({ name: t }, s.options.modifiers[t]);
              })
              .sort(function (t, e) {
                return t.order - e.order;
              })),
            this.modifiers.forEach(function (e) {
              e.enabled &&
                t(e.onLoad) &&
                e.onLoad(s.reference, s.popper, s.options, e, s.state);
            }),
            this.update();
          var r = this.options.eventsEnabled;
          r && this.enableEventListeners(), (this.state.eventsEnabled = r);
        }
        return (
          Z(e, [
            {
              key: "update",
              value: function () {
                return function () {
                  if (!this.state.isDestroyed) {
                    var t = {
                      instance: this,
                      styles: {},
                      arrowStyles: {},
                      attributes: {},
                      flipped: !1,
                      offsets: {},
                    };
                    (t.offsets.reference = x(
                      this.state,
                      this.popper,
                      this.reference,
                      this.options.positionFixed
                    )),
                      (t.placement = w(
                        this.options.placement,
                        t.offsets.reference,
                        this.popper,
                        this.reference,
                        this.options.modifiers.flip.boundariesElement,
                        this.options.modifiers.flip.padding
                      )),
                      (t.originalPlacement = t.placement),
                      (t.positionFixed = this.options.positionFixed),
                      (t.offsets.popper = T(
                        this.popper,
                        t.offsets.reference,
                        t.placement
                      )),
                      (t.offsets.popper.position = this.options.positionFixed
                        ? "fixed"
                        : "absolute"),
                      (t = I(this.modifiers, t)),
                      this.state.isCreated
                        ? this.options.onUpdate(t)
                        : ((this.state.isCreated = !0),
                          this.options.onCreate(t));
                  }
                }.call(this);
              },
            },
            {
              key: "destroy",
              value: function () {
                return function () {
                  return (
                    (this.state.isDestroyed = !0),
                    E(this.modifiers, "applyStyle") &&
                      (this.popper.removeAttribute("x-placement"),
                      (this.popper.style.position = ""),
                      (this.popper.style.top = ""),
                      (this.popper.style.left = ""),
                      (this.popper.style.right = ""),
                      (this.popper.style.bottom = ""),
                      (this.popper.style.willChange = ""),
                      (this.popper.style[S("transform")] = "")),
                    this.disableEventListeners(),
                    this.options.removeOnDestroy &&
                      this.popper.parentNode.removeChild(this.popper),
                    this
                  );
                }.call(this);
              },
            },
            {
              key: "enableEventListeners",
              value: function () {
                return function () {
                  this.state.eventsEnabled ||
                    (this.state = P(
                      this.reference,
                      this.options,
                      this.state,
                      this.scheduleUpdate
                    ));
                }.call(this);
              },
            },
            {
              key: "disableEventListeners",
              value: function () {
                return O.call(this);
              },
            },
          ]),
          e
        );
      })();
    return (
      (st.Utils = ("undefined" == typeof window ? global : window).PopperUtils),
      (st.placements = J),
      (st.Defaults = {
        placement: "bottom",
        positionFixed: !1,
        eventsEnabled: !0,
        removeOnDestroy: !1,
        onCreate: function () {},
        onUpdate: function () {},
        modifiers: {
          shift: {
            order: 100,
            enabled: !0,
            fn: function (t) {
              var e = t.placement,
                i = e.split("-")[0],
                n = e.split("-")[1];
              if (n) {
                var s = t.offsets,
                  o = s.reference,
                  r = s.popper,
                  a = -1 !== ["bottom", "top"].indexOf(i),
                  l = a ? "left" : "top",
                  h = a ? "width" : "height",
                  c = {
                    start: G({}, l, o[l]),
                    end: G({}, l, o[l] + o[h] - r[h]),
                  };
                t.offsets.popper = X({}, r, c[n]);
              }
              return t;
            },
          },
          offset: {
            order: 200,
            enabled: !0,
            fn: function (t, e) {
              var i,
                n = e.offset,
                s = t.placement,
                o = t.offsets,
                r = o.popper,
                a = o.reference,
                l = s.split("-")[0];
              return (
                (i = M(+n) ? [+n, 0] : H(n, r, a, l)),
                "left" === l
                  ? ((r.top += i[0]), (r.left -= i[1]))
                  : "right" === l
                  ? ((r.top += i[0]), (r.left += i[1]))
                  : "top" === l
                  ? ((r.left += i[0]), (r.top -= i[1]))
                  : "bottom" === l && ((r.left += i[0]), (r.top += i[1])),
                (t.popper = r),
                t
              );
            },
            offset: 0,
          },
          preventOverflow: {
            order: 300,
            enabled: !0,
            fn: function (t, e) {
              var i = e.boundariesElement || o(t.instance.popper);
              t.instance.reference === i && (i = o(i));
              var n = S("transform"),
                s = t.instance.popper.style,
                r = s.top,
                a = s.left,
                l = s[n];
              (s.top = ""), (s.left = ""), (s[n] = "");
              var h = y(
                t.instance.popper,
                t.instance.reference,
                e.padding,
                i,
                t.positionFixed
              );
              (s.top = r), (s.left = a), (s[n] = l), (e.boundaries = h);
              var c = e.priority,
                u = t.offsets.popper,
                d = {
                  primary: function (t) {
                    var i = u[t];
                    return (
                      u[t] < h[t] &&
                        !e.escapeWithReference &&
                        (i = R(u[t], h[t])),
                      G({}, t, i)
                    );
                  },
                  secondary: function (t) {
                    var i = "right" === t ? "left" : "top",
                      n = u[i];
                    return (
                      u[t] > h[t] &&
                        !e.escapeWithReference &&
                        (n = W(
                          u[i],
                          h[t] - ("right" === t ? u.width : u.height)
                        )),
                      G({}, i, n)
                    );
                  },
                };
              return (
                c.forEach(function (t) {
                  var e =
                    -1 === ["left", "top"].indexOf(t) ? "secondary" : "primary";
                  u = X({}, u, d[e](t));
                }),
                (t.offsets.popper = u),
                t
              );
            },
            priority: ["left", "right", "top", "bottom"],
            padding: 5,
            boundariesElement: "scrollParent",
          },
          keepTogether: {
            order: 400,
            enabled: !0,
            fn: function (t) {
              var e = t.offsets,
                i = e.popper,
                n = e.reference,
                s = t.placement.split("-")[0],
                o = L,
                r = -1 !== ["top", "bottom"].indexOf(s),
                a = r ? "right" : "bottom",
                l = r ? "left" : "top",
                h = r ? "width" : "height";
              return (
                i[a] < o(n[l]) && (t.offsets.popper[l] = o(n[l]) - i[h]),
                i[l] > o(n[a]) && (t.offsets.popper[l] = o(n[a])),
                t
              );
            },
          },
          arrow: {
            order: 500,
            enabled: !0,
            fn: function (t, i) {
              var n;
              if (!$(t.instance.modifiers, "arrow", "keepTogether")) return t;
              var s = i.element;
              if ("string" == typeof s) {
                if (!(s = t.instance.popper.querySelector(s))) return t;
              } else if (!t.instance.popper.contains(s))
                return (
                  console.warn(
                    "WARNING: `arrow.element` must be child of its popper element!"
                  ),
                  t
                );
              var o = t.placement.split("-")[0],
                r = t.offsets,
                a = r.popper,
                l = r.reference,
                h = -1 !== ["left", "right"].indexOf(o),
                c = h ? "height" : "width",
                u = h ? "Top" : "Left",
                d = u.toLowerCase(),
                f = h ? "left" : "top",
                m = h ? "bottom" : "right",
                g = C(s)[c];
              l[m] - g < a[d] && (t.offsets.popper[d] -= a[d] - (l[m] - g)),
                l[d] + g > a[m] && (t.offsets.popper[d] += l[d] + g - a[m]),
                (t.offsets.popper = p(t.offsets.popper));
              var v = l[d] + l[c] / 2 - g / 2,
                _ = e(t.instance.popper),
                y = parseFloat(_["margin" + u], 10),
                b = parseFloat(_["border" + u + "Width"], 10),
                w = v - t.offsets.popper[d] - y - b;
              return (
                (w = R(W(a[c] - g, w), 0)),
                (t.arrowElement = s),
                (t.offsets.arrow = (G((n = {}), d, F(w)), G(n, f, ""), n)),
                t
              );
            },
            element: "[x-arrow]",
          },
          flip: {
            order: 600,
            enabled: !0,
            fn: function (t, e) {
              if (E(t.instance.modifiers, "inner")) return t;
              if (t.flipped && t.placement === t.originalPlacement) return t;
              var i = y(
                  t.instance.popper,
                  t.instance.reference,
                  e.padding,
                  e.boundariesElement,
                  t.positionFixed
                ),
                n = t.placement.split("-")[0],
                s = k(n),
                o = t.placement.split("-")[1] || "",
                r = [];
              switch (e.behavior) {
                case et:
                  r = [n, s];
                  break;
                case it:
                  r = N(n);
                  break;
                case nt:
                  r = N(n, !0);
                  break;
                default:
                  r = e.behavior;
              }
              return (
                r.forEach(function (a, l) {
                  if (n !== a || r.length === l + 1) return t;
                  (n = t.placement.split("-")[0]), (s = k(n));
                  var h = t.offsets.popper,
                    c = t.offsets.reference,
                    u = L,
                    d =
                      ("left" === n && u(h.right) > u(c.left)) ||
                      ("right" === n && u(h.left) < u(c.right)) ||
                      ("top" === n && u(h.bottom) > u(c.top)) ||
                      ("bottom" === n && u(h.top) < u(c.bottom)),
                    p = u(h.left) < u(i.left),
                    f = u(h.right) > u(i.right),
                    m = u(h.top) < u(i.top),
                    g = u(h.bottom) > u(i.bottom),
                    v =
                      ("left" === n && p) ||
                      ("right" === n && f) ||
                      ("top" === n && m) ||
                      ("bottom" === n && g),
                    _ = -1 !== ["top", "bottom"].indexOf(n),
                    y =
                      !!e.flipVariations &&
                      ((_ && "start" === o && p) ||
                        (_ && "end" === o && f) ||
                        (!_ && "start" === o && m) ||
                        (!_ && "end" === o && g));
                  (d || v || y) &&
                    ((t.flipped = !0),
                    (d || v) && (n = r[l + 1]),
                    y &&
                      (o = (function (t) {
                        return "end" === t
                          ? "start"
                          : "start" === t
                          ? "end"
                          : t;
                      })(o)),
                    (t.placement = n + (o ? "-" + o : "")),
                    (t.offsets.popper = X(
                      {},
                      t.offsets.popper,
                      T(t.instance.popper, t.offsets.reference, t.placement)
                    )),
                    (t = I(t.instance.modifiers, t, "flip")));
                }),
                t
              );
            },
            behavior: "flip",
            padding: 5,
            boundariesElement: "viewport",
          },
          inner: {
            order: 700,
            enabled: !1,
            fn: function (t) {
              var e = t.placement,
                i = e.split("-")[0],
                n = t.offsets,
                s = n.popper,
                o = n.reference,
                r = -1 !== ["left", "right"].indexOf(i),
                a = -1 === ["top", "left"].indexOf(i);
              return (
                (s[r ? "left" : "top"] =
                  o[i] - (a ? s[r ? "width" : "height"] : 0)),
                (t.placement = k(e)),
                (t.offsets.popper = p(s)),
                t
              );
            },
          },
          hide: {
            order: 800,
            enabled: !0,
            fn: function (t) {
              if (!$(t.instance.modifiers, "hide", "preventOverflow")) return t;
              var e = t.offsets.reference,
                i = D(t.instance.modifiers, function (t) {
                  return "preventOverflow" === t.name;
                }).boundaries;
              if (
                e.bottom < i.top ||
                e.left > i.right ||
                e.top > i.bottom ||
                e.right < i.left
              ) {
                if (!0 === t.hide) return t;
                (t.hide = !0), (t.attributes["x-out-of-boundaries"] = "");
              } else {
                if (!1 === t.hide) return t;
                (t.hide = !1), (t.attributes["x-out-of-boundaries"] = !1);
              }
              return t;
            },
          },
          computeStyle: {
            order: 850,
            enabled: !0,
            fn: function (t, e) {
              var i = e.x,
                n = e.y,
                s = t.offsets.popper,
                r = D(t.instance.modifiers, function (t) {
                  return "applyStyle" === t.name;
                }).gpuAcceleration;
              void 0 !== r &&
                console.warn(
                  "WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!"
                );
              var a,
                l,
                h = void 0 === r ? e.gpuAcceleration : r,
                c = f(o(t.instance.popper)),
                u = { position: s.position },
                d = {
                  left: L(s.left),
                  top: F(s.top),
                  bottom: F(s.bottom),
                  right: L(s.right),
                },
                p = "bottom" === i ? "top" : "bottom",
                m = "right" === n ? "left" : "right",
                g = S("transform");
              if (
                ((l = "bottom" == p ? -c.height + d.bottom : d.top),
                (a = "right" == m ? -c.width + d.right : d.left),
                h && g)
              )
                (u[g] = "translate3d(" + a + "px, " + l + "px, 0)"),
                  (u[p] = 0),
                  (u[m] = 0),
                  (u.willChange = "transform");
              else {
                var v = "bottom" == p ? -1 : 1,
                  _ = "right" == m ? -1 : 1;
                (u[p] = l * v), (u[m] = a * _), (u.willChange = p + ", " + m);
              }
              var y = { "x-placement": t.placement };
              return (
                (t.attributes = X({}, y, t.attributes)),
                (t.styles = X({}, u, t.styles)),
                (t.arrowStyles = X({}, t.offsets.arrow, t.arrowStyles)),
                t
              );
            },
            gpuAcceleration: !0,
            x: "bottom",
            y: "right",
          },
          applyStyle: {
            order: 900,
            enabled: !0,
            fn: function (t) {
              return (
                z(t.instance.popper, t.styles),
                (function (t, e) {
                  Object.keys(e).forEach(function (i) {
                    !1 === e[i]
                      ? t.removeAttribute(i)
                      : t.setAttribute(i, e[i]);
                  });
                })(t.instance.popper, t.attributes),
                t.arrowElement &&
                  Object.keys(t.arrowStyles).length &&
                  z(t.arrowElement, t.arrowStyles),
                t
              );
            },
            onLoad: function (t, e, i, n, s) {
              var o = x(s, e, t, i.positionFixed),
                r = w(
                  i.placement,
                  o,
                  e,
                  t,
                  i.modifiers.flip.boundariesElement,
                  i.modifiers.flip.padding
                );
              return (
                e.setAttribute("x-placement", r),
                z(e, { position: i.positionFixed ? "fixed" : "absolute" }),
                i
              );
            },
            gpuAcceleration: void 0,
          },
        },
      }),
      st
    );
  }),
  (function (t, e) {
    "object" == typeof exports && "undefined" != typeof module
      ? e(exports, require("jquery"), require("popper.js"))
      : "function" == typeof define && define.amd
      ? define(["exports", "jquery", "popper.js"], e)
      : e((t.bootstrap = {}), t.jQuery, t.Popper);
  })(this, function (t, e, i) {
    "use strict";
    function n(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(t, n.key, n);
      }
    }
    function s(t, e, i) {
      return e && n(t.prototype, e), i && n(t, i), t;
    }
    function o(t) {
      for (var e = 1; e < arguments.length; e++) {
        var i = null != arguments[e] ? arguments[e] : {},
          n = Object.keys(i);
        "function" == typeof Object.getOwnPropertySymbols &&
          (n = n.concat(
            Object.getOwnPropertySymbols(i).filter(function (t) {
              return Object.getOwnPropertyDescriptor(i, t).enumerable;
            })
          )),
          n.forEach(function (e) {
            var n, s, o;
            (n = t),
              (o = i[(s = e)]),
              s in n
                ? Object.defineProperty(n, s, {
                    value: o,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (n[s] = o);
          });
      }
      return t;
    }
    (e = e && e.hasOwnProperty("default") ? e.default : e),
      (i = i && i.hasOwnProperty("default") ? i.default : i);
    var r,
      a,
      l,
      h,
      c,
      u,
      d,
      p,
      f,
      m,
      g,
      v,
      _,
      y,
      b,
      w,
      x,
      C,
      k,
      T,
      D,
      I,
      E,
      S,
      A,
      P,
      O,
      M,
      z,
      $,
      N,
      H,
      W,
      F,
      L,
      R,
      j,
      B,
      q,
      U,
      Y,
      V,
      K,
      Q,
      Z,
      G,
      X,
      J,
      tt,
      et,
      it,
      nt,
      st,
      ot,
      rt,
      at,
      lt,
      ht,
      ct,
      ut,
      dt,
      pt,
      ft,
      mt,
      gt,
      vt,
      _t,
      yt,
      bt,
      wt,
      xt,
      Ct,
      kt,
      Tt,
      Dt,
      It,
      Et,
      St,
      At,
      Pt,
      Ot,
      Mt,
      zt,
      $t,
      Nt,
      Ht,
      Wt,
      Ft,
      Lt,
      Rt,
      jt,
      Bt,
      qt,
      Ut,
      Yt,
      Vt,
      Kt,
      Qt,
      Zt,
      Gt,
      Xt,
      Jt,
      te,
      ee,
      ie,
      ne,
      se,
      oe,
      re,
      ae,
      le,
      he,
      ce,
      ue,
      de,
      pe,
      fe,
      me,
      ge,
      ve,
      _e,
      ye,
      be,
      we,
      xe,
      Ce,
      ke,
      Te,
      De,
      Ie,
      Ee = (function (t) {
        var e = "transitionend";
        var i = {
          TRANSITION_END: "bsTransitionEnd",
          getUID: function (t) {
            for (
              ;
              (t += ~~(1e6 * Math.random())), document.getElementById(t);

            );
            return t;
          },
          getSelectorFromElement: function (t) {
            var e = t.getAttribute("data-target");
            (e && "#" !== e) || (e = t.getAttribute("href") || "");
            try {
              return document.querySelector(e) ? e : null;
            } catch (t) {
              return null;
            }
          },
          getTransitionDurationFromElement: function (e) {
            if (!e) return 0;
            var i = t(e).css("transition-duration");
            return parseFloat(i)
              ? ((i = i.split(",")[0]), 1e3 * parseFloat(i))
              : 0;
          },
          reflow: function (t) {
            return t.offsetHeight;
          },
          triggerTransitionEnd: function (i) {
            t(i).trigger(e);
          },
          supportsTransitionEnd: function () {
            return Boolean(e);
          },
          isElement: function (t) {
            return (t[0] || t).nodeType;
          },
          typeCheckConfig: function (t, e, n) {
            for (var s in n)
              if (Object.prototype.hasOwnProperty.call(n, s)) {
                var o = n[s],
                  r = e[s],
                  a =
                    r && i.isElement(r)
                      ? "element"
                      : ((l = r),
                        {}.toString
                          .call(l)
                          .match(/\s([a-z]+)/i)[1]
                          .toLowerCase());
                if (!new RegExp(o).test(a))
                  throw new Error(
                    t.toUpperCase() +
                      ': Option "' +
                      s +
                      '" provided type "' +
                      a +
                      '" but expected type "' +
                      o +
                      '".'
                  );
              }
            var l;
          },
        };
        return (
          (t.fn.emulateTransitionEnd = function (e) {
            var n = this,
              s = !1;
            return (
              t(this).one(i.TRANSITION_END, function () {
                s = !0;
              }),
              setTimeout(function () {
                s || i.triggerTransitionEnd(n);
              }, e),
              this
            );
          }),
          (t.event.special[i.TRANSITION_END] = {
            bindType: e,
            delegateType: e,
            handle: function (e) {
              if (t(e.target).is(this))
                return e.handleObj.handler.apply(this, arguments);
            },
          }),
          i
        );
      })(e),
      Se =
        ((a = "alert"),
        (h = "." + (l = "bs.alert")),
        (c = (r = e).fn[a]),
        (u = {
          CLOSE: "close" + h,
          CLOSED: "closed" + h,
          CLICK_DATA_API: "click" + h + ".data-api",
        }),
        "alert",
        "fade",
        "show",
        (d = (function () {
          function t(t) {
            this._element = t;
          }
          var e = t.prototype;
          return (
            (e.close = function (t) {
              var e = this._element;
              t && (e = this._getRootElement(t)),
                this._triggerCloseEvent(e).isDefaultPrevented() ||
                  this._removeElement(e);
            }),
            (e.dispose = function () {
              r.removeData(this._element, l), (this._element = null);
            }),
            (e._getRootElement = function (t) {
              var e = Ee.getSelectorFromElement(t),
                i = !1;
              return (
                e && (i = document.querySelector(e)),
                i || (i = r(t).closest(".alert")[0]),
                i
              );
            }),
            (e._triggerCloseEvent = function (t) {
              var e = r.Event(u.CLOSE);
              return r(t).trigger(e), e;
            }),
            (e._removeElement = function (t) {
              var e = this;
              if ((r(t).removeClass("show"), r(t).hasClass("fade"))) {
                var i = Ee.getTransitionDurationFromElement(t);
                r(t)
                  .one(Ee.TRANSITION_END, function (i) {
                    return e._destroyElement(t, i);
                  })
                  .emulateTransitionEnd(i);
              } else this._destroyElement(t);
            }),
            (e._destroyElement = function (t) {
              r(t).detach().trigger(u.CLOSED).remove();
            }),
            (t._jQueryInterface = function (e) {
              return this.each(function () {
                var i = r(this),
                  n = i.data(l);
                n || ((n = new t(this)), i.data(l, n)),
                  "close" === e && n[e](this);
              });
            }),
            (t._handleDismiss = function (t) {
              return function (e) {
                e && e.preventDefault(), t.close(this);
              };
            }),
            s(t, null, [
              {
                key: "VERSION",
                get: function () {
                  return "4.1.3";
                },
              },
            ]),
            t
          );
        })()),
        r(document).on(
          u.CLICK_DATA_API,
          '[data-dismiss="alert"]',
          d._handleDismiss(new d())
        ),
        (r.fn[a] = d._jQueryInterface),
        (r.fn[a].Constructor = d),
        (r.fn[a].noConflict = function () {
          return (r.fn[a] = c), d._jQueryInterface;
        }),
        d),
      Ae =
        ((f = "button"),
        (g = "." + (m = "bs.button")),
        (v = ".data-api"),
        (_ = (p = e).fn[f]),
        (y = "active"),
        "btn",
        (b = '[data-toggle^="button"]'),
        '[data-toggle="buttons"]',
        "input",
        ".active",
        (w = ".btn"),
        (x = {
          CLICK_DATA_API: "click" + g + v,
          FOCUS_BLUR_DATA_API: "focus" + g + v + " blur" + g + v,
        }),
        (C = (function () {
          function t(t) {
            this._element = t;
          }
          var e = t.prototype;
          return (
            (e.toggle = function () {
              var t = !0,
                e = !0,
                i = p(this._element).closest('[data-toggle="buttons"]')[0];
              if (i) {
                var n = this._element.querySelector("input");
                if (n) {
                  if ("radio" === n.type)
                    if (n.checked && this._element.classList.contains(y))
                      t = !1;
                    else {
                      var s = i.querySelector(".active");
                      s && p(s).removeClass(y);
                    }
                  if (t) {
                    if (
                      n.hasAttribute("disabled") ||
                      i.hasAttribute("disabled") ||
                      n.classList.contains("disabled") ||
                      i.classList.contains("disabled")
                    )
                      return;
                    (n.checked = !this._element.classList.contains(y)),
                      p(n).trigger("change");
                  }
                  n.focus(), (e = !1);
                }
              }
              e &&
                this._element.setAttribute(
                  "aria-pressed",
                  !this._element.classList.contains(y)
                ),
                t && p(this._element).toggleClass(y);
            }),
            (e.dispose = function () {
              p.removeData(this._element, m), (this._element = null);
            }),
            (t._jQueryInterface = function (e) {
              return this.each(function () {
                var i = p(this).data(m);
                i || ((i = new t(this)), p(this).data(m, i)),
                  "toggle" === e && i[e]();
              });
            }),
            s(t, null, [
              {
                key: "VERSION",
                get: function () {
                  return "4.1.3";
                },
              },
            ]),
            t
          );
        })()),
        p(document)
          .on(x.CLICK_DATA_API, b, function (t) {
            t.preventDefault();
            var e = t.target;
            p(e).hasClass("btn") || (e = p(e).closest(w)),
              C._jQueryInterface.call(p(e), "toggle");
          })
          .on(x.FOCUS_BLUR_DATA_API, b, function (t) {
            var e = p(t.target).closest(w)[0];
            p(e).toggleClass("focus", /^focus(in)?$/.test(t.type));
          }),
        (p.fn[f] = C._jQueryInterface),
        (p.fn[f].Constructor = C),
        (p.fn[f].noConflict = function () {
          return (p.fn[f] = _), C._jQueryInterface;
        }),
        C),
      Pe =
        ((T = "carousel"),
        (I = "." + (D = "bs.carousel")),
        (E = ".data-api"),
        (S = (k = e).fn[T]),
        (A = {
          interval: 5e3,
          keyboard: !0,
          slide: !1,
          pause: "hover",
          wrap: !0,
        }),
        (P = {
          interval: "(number|boolean)",
          keyboard: "boolean",
          slide: "(boolean|string)",
          pause: "(string|boolean)",
          wrap: "boolean",
        }),
        (O = "next"),
        (M = "prev"),
        "left",
        "right",
        (z = {
          SLIDE: "slide" + I,
          SLID: "slid" + I,
          KEYDOWN: "keydown" + I,
          MOUSEENTER: "mouseenter" + I,
          MOUSELEAVE: "mouseleave" + I,
          TOUCHEND: "touchend" + I,
          LOAD_DATA_API: "load" + I + E,
          CLICK_DATA_API: "click" + I + E,
        }),
        "carousel",
        ($ = "active"),
        "slide",
        "carousel-item-right",
        "carousel-item-left",
        "carousel-item-next",
        "carousel-item-prev",
        ".active",
        (N = ".active.carousel-item"),
        ".carousel-item",
        ".carousel-item-next, .carousel-item-prev",
        (H = ".carousel-indicators"),
        "[data-slide], [data-slide-to]",
        '[data-ride="carousel"]',
        (W = (function () {
          function t(t, e) {
            (this._items = null),
              (this._interval = null),
              (this._activeElement = null),
              (this._isPaused = !1),
              (this._isSliding = !1),
              (this.touchTimeout = null),
              (this._config = this._getConfig(e)),
              (this._element = k(t)[0]),
              (this._indicatorsElement = this._element.querySelector(H)),
              this._addEventListeners();
          }
          var e = t.prototype;
          return (
            (e.next = function () {
              this._isSliding || this._slide(O);
            }),
            (e.nextWhenVisible = function () {
              !document.hidden &&
                k(this._element).is(":visible") &&
                "hidden" !== k(this._element).css("visibility") &&
                this.next();
            }),
            (e.prev = function () {
              this._isSliding || this._slide(M);
            }),
            (e.pause = function (t) {
              t || (this._isPaused = !0),
                this._element.querySelector(
                  ".carousel-item-next, .carousel-item-prev"
                ) && (Ee.triggerTransitionEnd(this._element), this.cycle(!0)),
                clearInterval(this._interval),
                (this._interval = null);
            }),
            (e.cycle = function (t) {
              t || (this._isPaused = !1),
                this._interval &&
                  (clearInterval(this._interval), (this._interval = null)),
                this._config.interval &&
                  !this._isPaused &&
                  (this._interval = setInterval(
                    (document.visibilityState
                      ? this.nextWhenVisible
                      : this.next
                    ).bind(this),
                    this._config.interval
                  ));
            }),
            (e.to = function (t) {
              var e = this;
              this._activeElement = this._element.querySelector(N);
              var i = this._getItemIndex(this._activeElement);
              if (!(t > this._items.length - 1 || t < 0))
                if (this._isSliding)
                  k(this._element).one(z.SLID, function () {
                    return e.to(t);
                  });
                else {
                  if (i === t) return this.pause(), void this.cycle();
                  var n = i < t ? O : M;
                  this._slide(n, this._items[t]);
                }
            }),
            (e.dispose = function () {
              k(this._element).off(I),
                k.removeData(this._element, D),
                (this._items = null),
                (this._config = null),
                (this._element = null),
                (this._interval = null),
                (this._isPaused = null),
                (this._isSliding = null),
                (this._activeElement = null),
                (this._indicatorsElement = null);
            }),
            (e._getConfig = function (t) {
              return (t = o({}, A, t)), Ee.typeCheckConfig(T, t, P), t;
            }),
            (e._addEventListeners = function () {
              var t = this;
              this._config.keyboard &&
                k(this._element).on(z.KEYDOWN, function (e) {
                  return t._keydown(e);
                }),
                "hover" === this._config.pause &&
                  (k(this._element)
                    .on(z.MOUSEENTER, function (e) {
                      return t.pause(e);
                    })
                    .on(z.MOUSELEAVE, function (e) {
                      return t.cycle(e);
                    }),
                  "ontouchstart" in document.documentElement &&
                    k(this._element).on(z.TOUCHEND, function () {
                      t.pause(),
                        t.touchTimeout && clearTimeout(t.touchTimeout),
                        (t.touchTimeout = setTimeout(function (e) {
                          return t.cycle(e);
                        }, 500 + t._config.interval));
                    }));
            }),
            (e._keydown = function (t) {
              if (!/input|textarea/i.test(t.target.tagName))
                switch (t.which) {
                  case 37:
                    t.preventDefault(), this.prev();
                    break;
                  case 39:
                    t.preventDefault(), this.next();
                }
            }),
            (e._getItemIndex = function (t) {
              return (
                (this._items =
                  t && t.parentNode
                    ? [].slice.call(
                        t.parentNode.querySelectorAll(".carousel-item")
                      )
                    : []),
                this._items.indexOf(t)
              );
            }),
            (e._getItemByDirection = function (t, e) {
              var i = t === O,
                n = t === M,
                s = this._getItemIndex(e),
                o = this._items.length - 1;
              if (((n && 0 === s) || (i && s === o)) && !this._config.wrap)
                return e;
              var r = (s + (t === M ? -1 : 1)) % this._items.length;
              return -1 === r
                ? this._items[this._items.length - 1]
                : this._items[r];
            }),
            (e._triggerSlideEvent = function (t, e) {
              var i = this._getItemIndex(t),
                n = this._getItemIndex(this._element.querySelector(N)),
                s = k.Event(z.SLIDE, {
                  relatedTarget: t,
                  direction: e,
                  from: n,
                  to: i,
                });
              return k(this._element).trigger(s), s;
            }),
            (e._setActiveIndicatorElement = function (t) {
              if (this._indicatorsElement) {
                var e = [].slice.call(
                  this._indicatorsElement.querySelectorAll(".active")
                );
                k(e).removeClass($);
                var i = this._indicatorsElement.children[this._getItemIndex(t)];
                i && k(i).addClass($);
              }
            }),
            (e._slide = function (t, e) {
              var i,
                n,
                s,
                o = this,
                r = this._element.querySelector(N),
                a = this._getItemIndex(r),
                l = e || (r && this._getItemByDirection(t, r)),
                h = this._getItemIndex(l),
                c = Boolean(this._interval);
              if (
                (t === O
                  ? ((i = "carousel-item-left"),
                    (n = "carousel-item-next"),
                    (s = "left"))
                  : ((i = "carousel-item-right"),
                    (n = "carousel-item-prev"),
                    (s = "right")),
                l && k(l).hasClass($))
              )
                this._isSliding = !1;
              else if (
                !this._triggerSlideEvent(l, s).isDefaultPrevented() &&
                r &&
                l
              ) {
                (this._isSliding = !0),
                  c && this.pause(),
                  this._setActiveIndicatorElement(l);
                var u = k.Event(z.SLID, {
                  relatedTarget: l,
                  direction: s,
                  from: a,
                  to: h,
                });
                if (k(this._element).hasClass("slide")) {
                  k(l).addClass(n),
                    Ee.reflow(l),
                    k(r).addClass(i),
                    k(l).addClass(i);
                  var d = Ee.getTransitionDurationFromElement(r);
                  k(r)
                    .one(Ee.TRANSITION_END, function () {
                      k(l)
                        .removeClass(i + " " + n)
                        .addClass($),
                        k(r).removeClass($ + " " + n + " " + i),
                        (o._isSliding = !1),
                        setTimeout(function () {
                          return k(o._element).trigger(u);
                        }, 0);
                    })
                    .emulateTransitionEnd(d);
                } else
                  k(r).removeClass($),
                    k(l).addClass($),
                    (this._isSliding = !1),
                    k(this._element).trigger(u);
                c && this.cycle();
              }
            }),
            (t._jQueryInterface = function (e) {
              return this.each(function () {
                var i = k(this).data(D),
                  n = o({}, A, k(this).data());
                "object" == typeof e && (n = o({}, n, e));
                var s = "string" == typeof e ? e : n.slide;
                if (
                  (i || ((i = new t(this, n)), k(this).data(D, i)),
                  "number" == typeof e)
                )
                  i.to(e);
                else if ("string" == typeof s) {
                  if (void 0 === i[s])
                    throw new TypeError('No method named "' + s + '"');
                  i[s]();
                } else n.interval && (i.pause(), i.cycle());
              });
            }),
            (t._dataApiClickHandler = function (e) {
              var i = Ee.getSelectorFromElement(this);
              if (i) {
                var n = k(i)[0];
                if (n && k(n).hasClass("carousel")) {
                  var s = o({}, k(n).data(), k(this).data()),
                    r = this.getAttribute("data-slide-to");
                  r && (s.interval = !1),
                    t._jQueryInterface.call(k(n), s),
                    r && k(n).data(D).to(r),
                    e.preventDefault();
                }
              }
            }),
            s(t, null, [
              {
                key: "VERSION",
                get: function () {
                  return "4.1.3";
                },
              },
              {
                key: "Default",
                get: function () {
                  return A;
                },
              },
            ]),
            t
          );
        })()),
        k(document).on(
          z.CLICK_DATA_API,
          "[data-slide], [data-slide-to]",
          W._dataApiClickHandler
        ),
        k(window).on(z.LOAD_DATA_API, function () {
          for (
            var t = [].slice.call(
                document.querySelectorAll('[data-ride="carousel"]')
              ),
              e = 0,
              i = t.length;
            e < i;
            e++
          ) {
            var n = k(t[e]);
            W._jQueryInterface.call(n, n.data());
          }
        }),
        (k.fn[T] = W._jQueryInterface),
        (k.fn[T].Constructor = W),
        (k.fn[T].noConflict = function () {
          return (k.fn[T] = S), W._jQueryInterface;
        }),
        W),
      Oe =
        ((L = "collapse"),
        (j = "." + (R = "bs.collapse")),
        (B = (F = e).fn[L]),
        (q = { toggle: !0, parent: "" }),
        (U = { toggle: "boolean", parent: "(string|element)" }),
        (Y = {
          SHOW: "show" + j,
          SHOWN: "shown" + j,
          HIDE: "hide" + j,
          HIDDEN: "hidden" + j,
          CLICK_DATA_API: "click" + j + ".data-api",
        }),
        (V = "show"),
        (K = "collapse"),
        (Q = "collapsing"),
        (Z = "collapsed"),
        "width",
        "height",
        ".show, .collapsing",
        (G = '[data-toggle="collapse"]'),
        (X = (function () {
          function t(t, e) {
            (this._isTransitioning = !1),
              (this._element = t),
              (this._config = this._getConfig(e)),
              (this._triggerArray = F.makeArray(
                document.querySelectorAll(
                  '[data-toggle="collapse"][href="#' +
                    t.id +
                    '"],[data-toggle="collapse"][data-target="#' +
                    t.id +
                    '"]'
                )
              ));
            for (
              var i = [].slice.call(document.querySelectorAll(G)),
                n = 0,
                s = i.length;
              n < s;
              n++
            ) {
              var o = i[n],
                r = Ee.getSelectorFromElement(o),
                a = [].slice
                  .call(document.querySelectorAll(r))
                  .filter(function (e) {
                    return e === t;
                  });
              null !== r &&
                0 < a.length &&
                ((this._selector = r), this._triggerArray.push(o));
            }
            (this._parent = this._config.parent ? this._getParent() : null),
              this._config.parent ||
                this._addAriaAndCollapsedClass(
                  this._element,
                  this._triggerArray
                ),
              this._config.toggle && this.toggle();
          }
          var e = t.prototype;
          return (
            (e.toggle = function () {
              F(this._element).hasClass(V) ? this.hide() : this.show();
            }),
            (e.show = function () {
              var e,
                i,
                n = this;
              if (
                !(
                  this._isTransitioning ||
                  F(this._element).hasClass(V) ||
                  (this._parent &&
                    0 ===
                      (e = [].slice
                        .call(
                          this._parent.querySelectorAll(".show, .collapsing")
                        )
                        .filter(function (t) {
                          return (
                            t.getAttribute("data-parent") === n._config.parent
                          );
                        })).length &&
                    (e = null),
                  e &&
                    (i = F(e).not(this._selector).data(R)) &&
                    i._isTransitioning)
                )
              ) {
                var s = F.Event(Y.SHOW);
                if ((F(this._element).trigger(s), !s.isDefaultPrevented())) {
                  e &&
                    (t._jQueryInterface.call(F(e).not(this._selector), "hide"),
                    i || F(e).data(R, null));
                  var o = this._getDimension();
                  F(this._element).removeClass(K).addClass(Q),
                    (this._element.style[o] = 0),
                    this._triggerArray.length &&
                      F(this._triggerArray)
                        .removeClass(Z)
                        .attr("aria-expanded", !0),
                    this.setTransitioning(!0);
                  var r = "scroll" + (o[0].toUpperCase() + o.slice(1)),
                    a = Ee.getTransitionDurationFromElement(this._element);
                  F(this._element)
                    .one(Ee.TRANSITION_END, function () {
                      F(n._element).removeClass(Q).addClass(K).addClass(V),
                        (n._element.style[o] = ""),
                        n.setTransitioning(!1),
                        F(n._element).trigger(Y.SHOWN);
                    })
                    .emulateTransitionEnd(a),
                    (this._element.style[o] = this._element[r] + "px");
                }
              }
            }),
            (e.hide = function () {
              var t = this;
              if (!this._isTransitioning && F(this._element).hasClass(V)) {
                var e = F.Event(Y.HIDE);
                if ((F(this._element).trigger(e), !e.isDefaultPrevented())) {
                  var i = this._getDimension();
                  (this._element.style[i] =
                    this._element.getBoundingClientRect()[i] + "px"),
                    Ee.reflow(this._element),
                    F(this._element).addClass(Q).removeClass(K).removeClass(V);
                  var n = this._triggerArray.length;
                  if (0 < n)
                    for (var s = 0; s < n; s++) {
                      var o = this._triggerArray[s],
                        r = Ee.getSelectorFromElement(o);
                      null !== r &&
                        (F(
                          [].slice.call(document.querySelectorAll(r))
                        ).hasClass(V) ||
                          F(o).addClass(Z).attr("aria-expanded", !1));
                    }
                  this.setTransitioning(!0), (this._element.style[i] = "");
                  var a = Ee.getTransitionDurationFromElement(this._element);
                  F(this._element)
                    .one(Ee.TRANSITION_END, function () {
                      t.setTransitioning(!1),
                        F(t._element)
                          .removeClass(Q)
                          .addClass(K)
                          .trigger(Y.HIDDEN);
                    })
                    .emulateTransitionEnd(a);
                }
              }
            }),
            (e.setTransitioning = function (t) {
              this._isTransitioning = t;
            }),
            (e.dispose = function () {
              F.removeData(this._element, R),
                (this._config = null),
                (this._parent = null),
                (this._element = null),
                (this._triggerArray = null),
                (this._isTransitioning = null);
            }),
            (e._getConfig = function (t) {
              return (
                ((t = o({}, q, t)).toggle = Boolean(t.toggle)),
                Ee.typeCheckConfig(L, t, U),
                t
              );
            }),
            (e._getDimension = function () {
              return F(this._element).hasClass("width") ? "width" : "height";
            }),
            (e._getParent = function () {
              var e = this,
                i = null;
              Ee.isElement(this._config.parent)
                ? ((i = this._config.parent),
                  void 0 !== this._config.parent.jquery &&
                    (i = this._config.parent[0]))
                : (i = document.querySelector(this._config.parent));
              var n =
                  '[data-toggle="collapse"][data-parent="' +
                  this._config.parent +
                  '"]',
                s = [].slice.call(i.querySelectorAll(n));
              return (
                F(s).each(function (i, n) {
                  e._addAriaAndCollapsedClass(t._getTargetFromElement(n), [n]);
                }),
                i
              );
            }),
            (e._addAriaAndCollapsedClass = function (t, e) {
              if (t) {
                var i = F(t).hasClass(V);
                e.length && F(e).toggleClass(Z, !i).attr("aria-expanded", i);
              }
            }),
            (t._getTargetFromElement = function (t) {
              var e = Ee.getSelectorFromElement(t);
              return e ? document.querySelector(e) : null;
            }),
            (t._jQueryInterface = function (e) {
              return this.each(function () {
                var i = F(this),
                  n = i.data(R),
                  s = o({}, q, i.data(), "object" == typeof e && e ? e : {});
                if (
                  (!n && s.toggle && /show|hide/.test(e) && (s.toggle = !1),
                  n || ((n = new t(this, s)), i.data(R, n)),
                  "string" == typeof e)
                ) {
                  if (void 0 === n[e])
                    throw new TypeError('No method named "' + e + '"');
                  n[e]();
                }
              });
            }),
            s(t, null, [
              {
                key: "VERSION",
                get: function () {
                  return "4.1.3";
                },
              },
              {
                key: "Default",
                get: function () {
                  return q;
                },
              },
            ]),
            t
          );
        })()),
        F(document).on(Y.CLICK_DATA_API, G, function (t) {
          "A" === t.currentTarget.tagName && t.preventDefault();
          var e = F(this),
            i = Ee.getSelectorFromElement(this),
            n = [].slice.call(document.querySelectorAll(i));
          F(n).each(function () {
            var t = F(this),
              i = t.data(R) ? "toggle" : e.data();
            X._jQueryInterface.call(t, i);
          });
        }),
        (F.fn[L] = X._jQueryInterface),
        (F.fn[L].Constructor = X),
        (F.fn[L].noConflict = function () {
          return (F.fn[L] = B), X._jQueryInterface;
        }),
        X),
      Me =
        ((tt = "dropdown"),
        (it = "." + (et = "bs.dropdown")),
        (nt = ".data-api"),
        (st = (J = e).fn[tt]),
        (ot = new RegExp("38|40|27")),
        (rt = {
          HIDE: "hide" + it,
          HIDDEN: "hidden" + it,
          SHOW: "show" + it,
          SHOWN: "shown" + it,
          CLICK: "click" + it,
          CLICK_DATA_API: "click" + it + nt,
          KEYDOWN_DATA_API: "keydown" + it + nt,
          KEYUP_DATA_API: "keyup" + it + nt,
        }),
        (at = "disabled"),
        (lt = "show"),
        "dropup",
        "dropright",
        "dropleft",
        (ht = "dropdown-menu-right"),
        "position-static",
        (ct = '[data-toggle="dropdown"]'),
        ".dropdown form",
        (ut = ".dropdown-menu"),
        ".navbar-nav",
        ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)",
        "top-start",
        "top-end",
        "bottom-start",
        "bottom-end",
        "right-start",
        "left-start",
        (dt = {
          offset: 0,
          flip: !0,
          boundary: "scrollParent",
          reference: "toggle",
          display: "dynamic",
        }),
        (pt = {
          offset: "(number|string|function)",
          flip: "boolean",
          boundary: "(string|element)",
          reference: "(string|element)",
          display: "string",
        }),
        (ft = (function () {
          function t(t, e) {
            (this._element = t),
              (this._popper = null),
              (this._config = this._getConfig(e)),
              (this._menu = this._getMenuElement()),
              (this._inNavbar = this._detectNavbar()),
              this._addEventListeners();
          }
          var e = t.prototype;
          return (
            (e.toggle = function () {
              if (!this._element.disabled && !J(this._element).hasClass(at)) {
                var e = t._getParentFromElement(this._element),
                  n = J(this._menu).hasClass(lt);
                if ((t._clearMenus(), !n)) {
                  var s = { relatedTarget: this._element },
                    o = J.Event(rt.SHOW, s);
                  if ((J(e).trigger(o), !o.isDefaultPrevented())) {
                    if (!this._inNavbar) {
                      if (void 0 === i)
                        throw new TypeError(
                          "Bootstrap dropdown require Popper.js (https://popper.js.org)"
                        );
                      var r = this._element;
                      "parent" === this._config.reference
                        ? (r = e)
                        : Ee.isElement(this._config.reference) &&
                          ((r = this._config.reference),
                          void 0 !== this._config.reference.jquery &&
                            (r = this._config.reference[0])),
                        "scrollParent" !== this._config.boundary &&
                          J(e).addClass("position-static"),
                        (this._popper = new i(
                          r,
                          this._menu,
                          this._getPopperConfig()
                        ));
                    }
                    "ontouchstart" in document.documentElement &&
                      0 === J(e).closest(".navbar-nav").length &&
                      J(document.body).children().on("mouseover", null, J.noop),
                      this._element.focus(),
                      this._element.setAttribute("aria-expanded", !0),
                      J(this._menu).toggleClass(lt),
                      J(e).toggleClass(lt).trigger(J.Event(rt.SHOWN, s));
                  }
                }
              }
            }),
            (e.dispose = function () {
              J.removeData(this._element, et),
                J(this._element).off(it),
                (this._element = null),
                (this._menu = null) !== this._popper &&
                  (this._popper.destroy(), (this._popper = null));
            }),
            (e.update = function () {
              (this._inNavbar = this._detectNavbar()),
                null !== this._popper && this._popper.scheduleUpdate();
            }),
            (e._addEventListeners = function () {
              var t = this;
              J(this._element).on(rt.CLICK, function (e) {
                e.preventDefault(), e.stopPropagation(), t.toggle();
              });
            }),
            (e._getConfig = function (t) {
              return (
                (t = o(
                  {},
                  this.constructor.Default,
                  J(this._element).data(),
                  t
                )),
                Ee.typeCheckConfig(tt, t, this.constructor.DefaultType),
                t
              );
            }),
            (e._getMenuElement = function () {
              if (!this._menu) {
                var e = t._getParentFromElement(this._element);
                e && (this._menu = e.querySelector(ut));
              }
              return this._menu;
            }),
            (e._getPlacement = function () {
              var t = J(this._element.parentNode),
                e = "bottom-start";
              return (
                t.hasClass("dropup")
                  ? ((e = "top-start"),
                    J(this._menu).hasClass(ht) && (e = "top-end"))
                  : t.hasClass("dropright")
                  ? (e = "right-start")
                  : t.hasClass("dropleft")
                  ? (e = "left-start")
                  : J(this._menu).hasClass(ht) && (e = "bottom-end"),
                e
              );
            }),
            (e._detectNavbar = function () {
              return 0 < J(this._element).closest(".navbar").length;
            }),
            (e._getPopperConfig = function () {
              var t = this,
                e = {};
              "function" == typeof this._config.offset
                ? (e.fn = function (e) {
                    return (
                      (e.offsets = o(
                        {},
                        e.offsets,
                        t._config.offset(e.offsets) || {}
                      )),
                      e
                    );
                  })
                : (e.offset = this._config.offset);
              var i = {
                placement: this._getPlacement(),
                modifiers: {
                  offset: e,
                  flip: { enabled: this._config.flip },
                  preventOverflow: { boundariesElement: this._config.boundary },
                },
              };
              return (
                "static" === this._config.display &&
                  (i.modifiers.applyStyle = { enabled: !1 }),
                i
              );
            }),
            (t._jQueryInterface = function (e) {
              return this.each(function () {
                var i = J(this).data(et);
                if (
                  (i ||
                    ((i = new t(this, "object" == typeof e ? e : null)),
                    J(this).data(et, i)),
                  "string" == typeof e)
                ) {
                  if (void 0 === i[e])
                    throw new TypeError('No method named "' + e + '"');
                  i[e]();
                }
              });
            }),
            (t._clearMenus = function (e) {
              if (
                !e ||
                (3 !== e.which && ("keyup" !== e.type || 9 === e.which))
              )
                for (
                  var i = [].slice.call(document.querySelectorAll(ct)),
                    n = 0,
                    s = i.length;
                  n < s;
                  n++
                ) {
                  var o = t._getParentFromElement(i[n]),
                    r = J(i[n]).data(et),
                    a = { relatedTarget: i[n] };
                  if ((e && "click" === e.type && (a.clickEvent = e), r)) {
                    var l = r._menu;
                    if (
                      J(o).hasClass(lt) &&
                      !(
                        e &&
                        (("click" === e.type &&
                          /input|textarea/i.test(e.target.tagName)) ||
                          ("keyup" === e.type && 9 === e.which)) &&
                        J.contains(o, e.target)
                      )
                    ) {
                      var h = J.Event(rt.HIDE, a);
                      J(o).trigger(h),
                        h.isDefaultPrevented() ||
                          ("ontouchstart" in document.documentElement &&
                            J(document.body)
                              .children()
                              .off("mouseover", null, J.noop),
                          i[n].setAttribute("aria-expanded", "false"),
                          J(l).removeClass(lt),
                          J(o).removeClass(lt).trigger(J.Event(rt.HIDDEN, a)));
                    }
                  }
                }
            }),
            (t._getParentFromElement = function (t) {
              var e,
                i = Ee.getSelectorFromElement(t);
              return i && (e = document.querySelector(i)), e || t.parentNode;
            }),
            (t._dataApiKeydownHandler = function (e) {
              if (
                (/input|textarea/i.test(e.target.tagName)
                  ? !(
                      32 === e.which ||
                      (27 !== e.which &&
                        ((40 !== e.which && 38 !== e.which) ||
                          J(e.target).closest(ut).length))
                    )
                  : ot.test(e.which)) &&
                (e.preventDefault(),
                e.stopPropagation(),
                !this.disabled && !J(this).hasClass(at))
              ) {
                var i = t._getParentFromElement(this),
                  n = J(i).hasClass(lt);
                if (
                  (n || (27 === e.which && 32 === e.which)) &&
                  (!n || (27 !== e.which && 32 !== e.which))
                ) {
                  var s = [].slice.call(
                    i.querySelectorAll(
                      ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)"
                    )
                  );
                  if (0 !== s.length) {
                    var o = s.indexOf(e.target);
                    38 === e.which && 0 < o && o--,
                      40 === e.which && o < s.length - 1 && o++,
                      o < 0 && (o = 0),
                      s[o].focus();
                  }
                } else {
                  if (27 === e.which) {
                    var r = i.querySelector(ct);
                    J(r).trigger("focus");
                  }
                  J(this).trigger("click");
                }
              }
            }),
            s(t, null, [
              {
                key: "VERSION",
                get: function () {
                  return "4.1.3";
                },
              },
              {
                key: "Default",
                get: function () {
                  return dt;
                },
              },
              {
                key: "DefaultType",
                get: function () {
                  return pt;
                },
              },
            ]),
            t
          );
        })()),
        J(document)
          .on(rt.KEYDOWN_DATA_API, ct, ft._dataApiKeydownHandler)
          .on(rt.KEYDOWN_DATA_API, ut, ft._dataApiKeydownHandler)
          .on(rt.CLICK_DATA_API + " " + rt.KEYUP_DATA_API, ft._clearMenus)
          .on(rt.CLICK_DATA_API, ct, function (t) {
            t.preventDefault(),
              t.stopPropagation(),
              ft._jQueryInterface.call(J(this), "toggle");
          })
          .on(rt.CLICK_DATA_API, ".dropdown form", function (t) {
            t.stopPropagation();
          }),
        (J.fn[tt] = ft._jQueryInterface),
        (J.fn[tt].Constructor = ft),
        (J.fn[tt].noConflict = function () {
          return (J.fn[tt] = st), ft._jQueryInterface;
        }),
        ft),
      ze =
        ((gt = "modal"),
        (_t = "." + (vt = "bs.modal")),
        (yt = (mt = e).fn[gt]),
        (bt = { backdrop: !0, keyboard: !0, focus: !0, show: !0 }),
        (wt = {
          backdrop: "(boolean|string)",
          keyboard: "boolean",
          focus: "boolean",
          show: "boolean",
        }),
        (xt = {
          HIDE: "hide" + _t,
          HIDDEN: "hidden" + _t,
          SHOW: "show" + _t,
          SHOWN: "shown" + _t,
          FOCUSIN: "focusin" + _t,
          RESIZE: "resize" + _t,
          CLICK_DISMISS: "click.dismiss" + _t,
          KEYDOWN_DISMISS: "keydown.dismiss" + _t,
          MOUSEUP_DISMISS: "mouseup.dismiss" + _t,
          MOUSEDOWN_DISMISS: "mousedown.dismiss" + _t,
          CLICK_DATA_API: "click" + _t + ".data-api",
        }),
        "modal-scrollbar-measure",
        "modal-backdrop",
        (Ct = "modal-open"),
        (kt = "fade"),
        (Tt = "show"),
        (Dt = ".modal-dialog"),
        '[data-toggle="modal"]',
        '[data-dismiss="modal"]',
        (It = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top"),
        (Et = ".sticky-top"),
        (St = (function () {
          function t(t, e) {
            (this._config = this._getConfig(e)),
              (this._element = t),
              (this._dialog = t.querySelector(Dt)),
              (this._backdrop = null),
              (this._isShown = !1),
              (this._isBodyOverflowing = !1),
              (this._ignoreBackdropClick = !1),
              (this._scrollbarWidth = 0);
          }
          var e = t.prototype;
          return (
            (e.toggle = function (t) {
              return this._isShown ? this.hide() : this.show(t);
            }),
            (e.show = function (t) {
              var e = this;
              if (!this._isTransitioning && !this._isShown) {
                mt(this._element).hasClass(kt) && (this._isTransitioning = !0);
                var i = mt.Event(xt.SHOW, { relatedTarget: t });
                mt(this._element).trigger(i),
                  this._isShown ||
                    i.isDefaultPrevented() ||
                    ((this._isShown = !0),
                    this._checkScrollbar(),
                    this._setScrollbar(),
                    this._adjustDialog(),
                    mt(document.body).addClass(Ct),
                    this._setEscapeEvent(),
                    this._setResizeEvent(),
                    mt(this._element).on(
                      xt.CLICK_DISMISS,
                      '[data-dismiss="modal"]',
                      function (t) {
                        return e.hide(t);
                      }
                    ),
                    mt(this._dialog).on(xt.MOUSEDOWN_DISMISS, function () {
                      mt(e._element).one(xt.MOUSEUP_DISMISS, function (t) {
                        mt(t.target).is(e._element) &&
                          (e._ignoreBackdropClick = !0);
                      });
                    }),
                    this._showBackdrop(function () {
                      return e._showElement(t);
                    }));
              }
            }),
            (e.hide = function (t) {
              var e = this;
              if (
                (t && t.preventDefault(),
                !this._isTransitioning && this._isShown)
              ) {
                var i = mt.Event(xt.HIDE);
                if (
                  (mt(this._element).trigger(i),
                  this._isShown && !i.isDefaultPrevented())
                ) {
                  this._isShown = !1;
                  var n = mt(this._element).hasClass(kt);
                  if (
                    (n && (this._isTransitioning = !0),
                    this._setEscapeEvent(),
                    this._setResizeEvent(),
                    mt(document).off(xt.FOCUSIN),
                    mt(this._element).removeClass(Tt),
                    mt(this._element).off(xt.CLICK_DISMISS),
                    mt(this._dialog).off(xt.MOUSEDOWN_DISMISS),
                    n)
                  ) {
                    var s = Ee.getTransitionDurationFromElement(this._element);
                    mt(this._element)
                      .one(Ee.TRANSITION_END, function (t) {
                        return e._hideModal(t);
                      })
                      .emulateTransitionEnd(s);
                  } else this._hideModal();
                }
              }
            }),
            (e.dispose = function () {
              mt.removeData(this._element, vt),
                mt(window, document, this._element, this._backdrop).off(_t),
                (this._config = null),
                (this._element = null),
                (this._dialog = null),
                (this._backdrop = null),
                (this._isShown = null),
                (this._isBodyOverflowing = null),
                (this._ignoreBackdropClick = null),
                (this._scrollbarWidth = null);
            }),
            (e.handleUpdate = function () {
              this._adjustDialog();
            }),
            (e._getConfig = function (t) {
              return (t = o({}, bt, t)), Ee.typeCheckConfig(gt, t, wt), t;
            }),
            (e._showElement = function (t) {
              var e = this,
                i = mt(this._element).hasClass(kt);
              (this._element.parentNode &&
                this._element.parentNode.nodeType === Node.ELEMENT_NODE) ||
                document.body.appendChild(this._element),
                (this._element.style.display = "block"),
                this._element.removeAttribute("aria-hidden"),
                (this._element.scrollTop = 0),
                i && Ee.reflow(this._element),
                mt(this._element).addClass(Tt),
                this._config.focus && this._enforceFocus();
              var n = mt.Event(xt.SHOWN, { relatedTarget: t }),
                s = function () {
                  e._config.focus && e._element.focus(),
                    (e._isTransitioning = !1),
                    mt(e._element).trigger(n);
                };
              if (i) {
                var o = Ee.getTransitionDurationFromElement(this._element);
                mt(this._dialog)
                  .one(Ee.TRANSITION_END, s)
                  .emulateTransitionEnd(o);
              } else s();
            }),
            (e._enforceFocus = function () {
              var t = this;
              mt(document)
                .off(xt.FOCUSIN)
                .on(xt.FOCUSIN, function (e) {
                  document !== e.target &&
                    t._element !== e.target &&
                    0 === mt(t._element).has(e.target).length &&
                    t._element.focus();
                });
            }),
            (e._setEscapeEvent = function () {
              var t = this;
              this._isShown && this._config.keyboard
                ? mt(this._element).on(xt.KEYDOWN_DISMISS, function (e) {
                    27 === e.which && (e.preventDefault(), t.hide());
                  })
                : this._isShown || mt(this._element).off(xt.KEYDOWN_DISMISS);
            }),
            (e._setResizeEvent = function () {
              var t = this;
              this._isShown
                ? mt(window).on(xt.RESIZE, function (e) {
                    return t.handleUpdate(e);
                  })
                : mt(window).off(xt.RESIZE);
            }),
            (e._hideModal = function () {
              var t = this;
              (this._element.style.display = "none"),
                this._element.setAttribute("aria-hidden", !0),
                (this._isTransitioning = !1),
                this._showBackdrop(function () {
                  mt(document.body).removeClass(Ct),
                    t._resetAdjustments(),
                    t._resetScrollbar(),
                    mt(t._element).trigger(xt.HIDDEN);
                });
            }),
            (e._removeBackdrop = function () {
              this._backdrop &&
                (mt(this._backdrop).remove(), (this._backdrop = null));
            }),
            (e._showBackdrop = function (t) {
              var e = this,
                i = mt(this._element).hasClass(kt) ? kt : "";
              if (this._isShown && this._config.backdrop) {
                if (
                  ((this._backdrop = document.createElement("div")),
                  (this._backdrop.className = "modal-backdrop"),
                  i && this._backdrop.classList.add(i),
                  mt(this._backdrop).appendTo(document.body),
                  mt(this._element).on(xt.CLICK_DISMISS, function (t) {
                    e._ignoreBackdropClick
                      ? (e._ignoreBackdropClick = !1)
                      : t.target === t.currentTarget &&
                        ("static" === e._config.backdrop
                          ? e._element.focus()
                          : e.hide());
                  }),
                  i && Ee.reflow(this._backdrop),
                  mt(this._backdrop).addClass(Tt),
                  !t)
                )
                  return;
                if (!i) return void t();
                var n = Ee.getTransitionDurationFromElement(this._backdrop);
                mt(this._backdrop)
                  .one(Ee.TRANSITION_END, t)
                  .emulateTransitionEnd(n);
              } else if (!this._isShown && this._backdrop) {
                mt(this._backdrop).removeClass(Tt);
                var s = function () {
                  e._removeBackdrop(), t && t();
                };
                if (mt(this._element).hasClass(kt)) {
                  var o = Ee.getTransitionDurationFromElement(this._backdrop);
                  mt(this._backdrop)
                    .one(Ee.TRANSITION_END, s)
                    .emulateTransitionEnd(o);
                } else s();
              } else t && t();
            }),
            (e._adjustDialog = function () {
              var t =
                this._element.scrollHeight >
                document.documentElement.clientHeight;
              !this._isBodyOverflowing &&
                t &&
                (this._element.style.paddingLeft = this._scrollbarWidth + "px"),
                this._isBodyOverflowing &&
                  !t &&
                  (this._element.style.paddingRight =
                    this._scrollbarWidth + "px");
            }),
            (e._resetAdjustments = function () {
              (this._element.style.paddingLeft = ""),
                (this._element.style.paddingRight = "");
            }),
            (e._checkScrollbar = function () {
              var t = document.body.getBoundingClientRect();
              (this._isBodyOverflowing = t.left + t.right < window.innerWidth),
                (this._scrollbarWidth = this._getScrollbarWidth());
            }),
            (e._setScrollbar = function () {
              var t = this;
              if (this._isBodyOverflowing) {
                var e = [].slice.call(document.querySelectorAll(It)),
                  i = [].slice.call(document.querySelectorAll(Et));
                mt(e).each(function (e, i) {
                  var n = i.style.paddingRight,
                    s = mt(i).css("padding-right");
                  mt(i)
                    .data("padding-right", n)
                    .css(
                      "padding-right",
                      parseFloat(s) + t._scrollbarWidth + "px"
                    );
                }),
                  mt(i).each(function (e, i) {
                    var n = i.style.marginRight,
                      s = mt(i).css("margin-right");
                    mt(i)
                      .data("margin-right", n)
                      .css(
                        "margin-right",
                        parseFloat(s) - t._scrollbarWidth + "px"
                      );
                  });
                var n = document.body.style.paddingRight,
                  s = mt(document.body).css("padding-right");
                mt(document.body)
                  .data("padding-right", n)
                  .css(
                    "padding-right",
                    parseFloat(s) + this._scrollbarWidth + "px"
                  );
              }
            }),
            (e._resetScrollbar = function () {
              var t = [].slice.call(document.querySelectorAll(It));
              mt(t).each(function (t, e) {
                var i = mt(e).data("padding-right");
                mt(e).removeData("padding-right"),
                  (e.style.paddingRight = i || "");
              });
              var e = [].slice.call(document.querySelectorAll("" + Et));
              mt(e).each(function (t, e) {
                var i = mt(e).data("margin-right");
                void 0 !== i &&
                  mt(e).css("margin-right", i).removeData("margin-right");
              });
              var i = mt(document.body).data("padding-right");
              mt(document.body).removeData("padding-right"),
                (document.body.style.paddingRight = i || "");
            }),
            (e._getScrollbarWidth = function () {
              var t = document.createElement("div");
              (t.className = "modal-scrollbar-measure"),
                document.body.appendChild(t);
              var e = t.getBoundingClientRect().width - t.clientWidth;
              return document.body.removeChild(t), e;
            }),
            (t._jQueryInterface = function (e, i) {
              return this.each(function () {
                var n = mt(this).data(vt),
                  s = o(
                    {},
                    bt,
                    mt(this).data(),
                    "object" == typeof e && e ? e : {}
                  );
                if (
                  (n || ((n = new t(this, s)), mt(this).data(vt, n)),
                  "string" == typeof e)
                ) {
                  if (void 0 === n[e])
                    throw new TypeError('No method named "' + e + '"');
                  n[e](i);
                } else s.show && n.show(i);
              });
            }),
            s(t, null, [
              {
                key: "VERSION",
                get: function () {
                  return "4.1.3";
                },
              },
              {
                key: "Default",
                get: function () {
                  return bt;
                },
              },
            ]),
            t
          );
        })()),
        mt(document).on(
          xt.CLICK_DATA_API,
          '[data-toggle="modal"]',
          function (t) {
            var e,
              i = this,
              n = Ee.getSelectorFromElement(this);
            n && (e = document.querySelector(n));
            var s = mt(e).data(vt)
              ? "toggle"
              : o({}, mt(e).data(), mt(this).data());
            ("A" !== this.tagName && "AREA" !== this.tagName) ||
              t.preventDefault();
            var r = mt(e).one(xt.SHOW, function (t) {
              t.isDefaultPrevented() ||
                r.one(xt.HIDDEN, function () {
                  mt(i).is(":visible") && i.focus();
                });
            });
            St._jQueryInterface.call(mt(e), s, this);
          }
        ),
        (mt.fn[gt] = St._jQueryInterface),
        (mt.fn[gt].Constructor = St),
        (mt.fn[gt].noConflict = function () {
          return (mt.fn[gt] = yt), St._jQueryInterface;
        }),
        St),
      $e =
        ((Pt = "tooltip"),
        (Mt = "." + (Ot = "bs.tooltip")),
        (zt = (At = e).fn[Pt]),
        ($t = "bs-tooltip"),
        (Nt = new RegExp("(^|\\s)" + $t + "\\S+", "g")),
        (Ft = {
          animation: !0,
          template:
            '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
          trigger: "hover focus",
          title: "",
          delay: 0,
          html: !(Wt = {
            AUTO: "auto",
            TOP: "top",
            RIGHT: "right",
            BOTTOM: "bottom",
            LEFT: "left",
          }),
          selector: !(Ht = {
            animation: "boolean",
            template: "string",
            title: "(string|element|function)",
            trigger: "string",
            delay: "(number|object)",
            html: "boolean",
            selector: "(string|boolean)",
            placement: "(string|function)",
            offset: "(number|string)",
            container: "(string|element|boolean)",
            fallbackPlacement: "(string|array)",
            boundary: "(string|element)",
          }),
          placement: "top",
          offset: 0,
          container: !1,
          fallbackPlacement: "flip",
          boundary: "scrollParent",
        }),
        "out",
        (Rt = {
          HIDE: "hide" + Mt,
          HIDDEN: "hidden" + Mt,
          SHOW: (Lt = "show") + Mt,
          SHOWN: "shown" + Mt,
          INSERTED: "inserted" + Mt,
          CLICK: "click" + Mt,
          FOCUSIN: "focusin" + Mt,
          FOCUSOUT: "focusout" + Mt,
          MOUSEENTER: "mouseenter" + Mt,
          MOUSELEAVE: "mouseleave" + Mt,
        }),
        (jt = "fade"),
        (Bt = "show"),
        ".tooltip-inner",
        ".arrow",
        (qt = "hover"),
        (Ut = "focus"),
        "click",
        "manual",
        (Yt = (function () {
          function t(t, e) {
            if (void 0 === i)
              throw new TypeError(
                "Bootstrap tooltips require Popper.js (https://popper.js.org)"
              );
            (this._isEnabled = !0),
              (this._timeout = 0),
              (this._hoverState = ""),
              (this._activeTrigger = {}),
              (this._popper = null),
              (this.element = t),
              (this.config = this._getConfig(e)),
              (this.tip = null),
              this._setListeners();
          }
          var e = t.prototype;
          return (
            (e.enable = function () {
              this._isEnabled = !0;
            }),
            (e.disable = function () {
              this._isEnabled = !1;
            }),
            (e.toggleEnabled = function () {
              this._isEnabled = !this._isEnabled;
            }),
            (e.toggle = function (t) {
              if (this._isEnabled)
                if (t) {
                  var e = this.constructor.DATA_KEY,
                    i = At(t.currentTarget).data(e);
                  i ||
                    ((i = new this.constructor(
                      t.currentTarget,
                      this._getDelegateConfig()
                    )),
                    At(t.currentTarget).data(e, i)),
                    (i._activeTrigger.click = !i._activeTrigger.click),
                    i._isWithActiveTrigger()
                      ? i._enter(null, i)
                      : i._leave(null, i);
                } else {
                  if (At(this.getTipElement()).hasClass(Bt))
                    return void this._leave(null, this);
                  this._enter(null, this);
                }
            }),
            (e.dispose = function () {
              clearTimeout(this._timeout),
                At.removeData(this.element, this.constructor.DATA_KEY),
                At(this.element).off(this.constructor.EVENT_KEY),
                At(this.element).closest(".modal").off("hide.bs.modal"),
                this.tip && At(this.tip).remove(),
                (this._isEnabled = null),
                (this._timeout = null),
                (this._hoverState = null),
                (this._activeTrigger = null) !== this._popper &&
                  this._popper.destroy(),
                (this._popper = null),
                (this.element = null),
                (this.config = null),
                (this.tip = null);
            }),
            (e.show = function () {
              var t = this;
              if ("none" === At(this.element).css("display"))
                throw new Error("Please use show on visible elements");
              var e = At.Event(this.constructor.Event.SHOW);
              if (this.isWithContent() && this._isEnabled) {
                At(this.element).trigger(e);
                var n = At.contains(
                  this.element.ownerDocument.documentElement,
                  this.element
                );
                if (e.isDefaultPrevented() || !n) return;
                var s = this.getTipElement(),
                  o = Ee.getUID(this.constructor.NAME);
                s.setAttribute("id", o),
                  this.element.setAttribute("aria-describedby", o),
                  this.setContent(),
                  this.config.animation && At(s).addClass(jt);
                var r =
                    "function" == typeof this.config.placement
                      ? this.config.placement.call(this, s, this.element)
                      : this.config.placement,
                  a = this._getAttachment(r);
                this.addAttachmentClass(a);
                var l =
                  !1 === this.config.container
                    ? document.body
                    : At(document).find(this.config.container);
                At(s).data(this.constructor.DATA_KEY, this),
                  At.contains(
                    this.element.ownerDocument.documentElement,
                    this.tip
                  ) || At(s).appendTo(l),
                  At(this.element).trigger(this.constructor.Event.INSERTED),
                  (this._popper = new i(this.element, s, {
                    placement: a,
                    modifiers: {
                      offset: { offset: this.config.offset },
                      flip: { behavior: this.config.fallbackPlacement },
                      arrow: { element: ".arrow" },
                      preventOverflow: {
                        boundariesElement: this.config.boundary,
                      },
                    },
                    onCreate: function (e) {
                      e.originalPlacement !== e.placement &&
                        t._handlePopperPlacementChange(e);
                    },
                    onUpdate: function (e) {
                      t._handlePopperPlacementChange(e);
                    },
                  })),
                  At(s).addClass(Bt),
                  "ontouchstart" in document.documentElement &&
                    At(document.body).children().on("mouseover", null, At.noop);
                var h = function () {
                  t.config.animation && t._fixTransition();
                  var e = t._hoverState;
                  (t._hoverState = null),
                    At(t.element).trigger(t.constructor.Event.SHOWN),
                    "out" === e && t._leave(null, t);
                };
                if (At(this.tip).hasClass(jt)) {
                  var c = Ee.getTransitionDurationFromElement(this.tip);
                  At(this.tip)
                    .one(Ee.TRANSITION_END, h)
                    .emulateTransitionEnd(c);
                } else h();
              }
            }),
            (e.hide = function (t) {
              var e = this,
                i = this.getTipElement(),
                n = At.Event(this.constructor.Event.HIDE),
                s = function () {
                  e._hoverState !== Lt &&
                    i.parentNode &&
                    i.parentNode.removeChild(i),
                    e._cleanTipClass(),
                    e.element.removeAttribute("aria-describedby"),
                    At(e.element).trigger(e.constructor.Event.HIDDEN),
                    null !== e._popper && e._popper.destroy(),
                    t && t();
                };
              if ((At(this.element).trigger(n), !n.isDefaultPrevented())) {
                if (
                  (At(i).removeClass(Bt),
                  "ontouchstart" in document.documentElement &&
                    At(document.body)
                      .children()
                      .off("mouseover", null, At.noop),
                  (this._activeTrigger.click = !1),
                  (this._activeTrigger[Ut] = !1),
                  (this._activeTrigger[qt] = !1),
                  At(this.tip).hasClass(jt))
                ) {
                  var o = Ee.getTransitionDurationFromElement(i);
                  At(i).one(Ee.TRANSITION_END, s).emulateTransitionEnd(o);
                } else s();
                this._hoverState = "";
              }
            }),
            (e.update = function () {
              null !== this._popper && this._popper.scheduleUpdate();
            }),
            (e.isWithContent = function () {
              return Boolean(this.getTitle());
            }),
            (e.addAttachmentClass = function (t) {
              At(this.getTipElement()).addClass($t + "-" + t);
            }),
            (e.getTipElement = function () {
              return (
                (this.tip = this.tip || At(this.config.template)[0]), this.tip
              );
            }),
            (e.setContent = function () {
              var t = this.getTipElement();
              this.setElementContent(
                At(t.querySelectorAll(".tooltip-inner")),
                this.getTitle()
              ),
                At(t).removeClass(jt + " " + Bt);
            }),
            (e.setElementContent = function (t, e) {
              var i = this.config.html;
              "object" == typeof e && (e.nodeType || e.jquery)
                ? i
                  ? At(e).parent().is(t) || t.empty().append(e)
                  : t.text(At(e).text())
                : t[i ? "html" : "text"](e);
            }),
            (e.getTitle = function () {
              var t = this.element.getAttribute("data-original-title");
              return (
                t ||
                  (t =
                    "function" == typeof this.config.title
                      ? this.config.title.call(this.element)
                      : this.config.title),
                t
              );
            }),
            (e._getAttachment = function (t) {
              return Wt[t.toUpperCase()];
            }),
            (e._setListeners = function () {
              var t = this;
              this.config.trigger.split(" ").forEach(function (e) {
                if ("click" === e)
                  At(t.element).on(
                    t.constructor.Event.CLICK,
                    t.config.selector,
                    function (e) {
                      return t.toggle(e);
                    }
                  );
                else if ("manual" !== e) {
                  var i =
                      e === qt
                        ? t.constructor.Event.MOUSEENTER
                        : t.constructor.Event.FOCUSIN,
                    n =
                      e === qt
                        ? t.constructor.Event.MOUSELEAVE
                        : t.constructor.Event.FOCUSOUT;
                  At(t.element)
                    .on(i, t.config.selector, function (e) {
                      return t._enter(e);
                    })
                    .on(n, t.config.selector, function (e) {
                      return t._leave(e);
                    });
                }
                At(t.element)
                  .closest(".modal")
                  .on("hide.bs.modal", function () {
                    return t.hide();
                  });
              }),
                this.config.selector
                  ? (this.config = o({}, this.config, {
                      trigger: "manual",
                      selector: "",
                    }))
                  : this._fixTitle();
            }),
            (e._fixTitle = function () {
              var t = typeof this.element.getAttribute("data-original-title");
              (this.element.getAttribute("title") || "string" !== t) &&
                (this.element.setAttribute(
                  "data-original-title",
                  this.element.getAttribute("title") || ""
                ),
                this.element.setAttribute("title", ""));
            }),
            (e._enter = function (t, e) {
              var i = this.constructor.DATA_KEY;
              (e = e || At(t.currentTarget).data(i)) ||
                ((e = new this.constructor(
                  t.currentTarget,
                  this._getDelegateConfig()
                )),
                At(t.currentTarget).data(i, e)),
                t && (e._activeTrigger["focusin" === t.type ? Ut : qt] = !0),
                At(e.getTipElement()).hasClass(Bt) || e._hoverState === Lt
                  ? (e._hoverState = Lt)
                  : (clearTimeout(e._timeout),
                    (e._hoverState = Lt),
                    e.config.delay && e.config.delay.show
                      ? (e._timeout = setTimeout(function () {
                          e._hoverState === Lt && e.show();
                        }, e.config.delay.show))
                      : e.show());
            }),
            (e._leave = function (t, e) {
              var i = this.constructor.DATA_KEY;
              (e = e || At(t.currentTarget).data(i)) ||
                ((e = new this.constructor(
                  t.currentTarget,
                  this._getDelegateConfig()
                )),
                At(t.currentTarget).data(i, e)),
                t && (e._activeTrigger["focusout" === t.type ? Ut : qt] = !1),
                e._isWithActiveTrigger() ||
                  (clearTimeout(e._timeout),
                  (e._hoverState = "out"),
                  e.config.delay && e.config.delay.hide
                    ? (e._timeout = setTimeout(function () {
                        "out" === e._hoverState && e.hide();
                      }, e.config.delay.hide))
                    : e.hide());
            }),
            (e._isWithActiveTrigger = function () {
              for (var t in this._activeTrigger)
                if (this._activeTrigger[t]) return !0;
              return !1;
            }),
            (e._getConfig = function (t) {
              return (
                "number" ==
                  typeof (t = o(
                    {},
                    this.constructor.Default,
                    At(this.element).data(),
                    "object" == typeof t && t ? t : {}
                  )).delay && (t.delay = { show: t.delay, hide: t.delay }),
                "number" == typeof t.title && (t.title = t.title.toString()),
                "number" == typeof t.content &&
                  (t.content = t.content.toString()),
                Ee.typeCheckConfig(Pt, t, this.constructor.DefaultType),
                t
              );
            }),
            (e._getDelegateConfig = function () {
              var t = {};
              if (this.config)
                for (var e in this.config)
                  this.constructor.Default[e] !== this.config[e] &&
                    (t[e] = this.config[e]);
              return t;
            }),
            (e._cleanTipClass = function () {
              var t = At(this.getTipElement()),
                e = t.attr("class").match(Nt);
              null !== e && e.length && t.removeClass(e.join(""));
            }),
            (e._handlePopperPlacementChange = function (t) {
              var e = t.instance;
              (this.tip = e.popper),
                this._cleanTipClass(),
                this.addAttachmentClass(this._getAttachment(t.placement));
            }),
            (e._fixTransition = function () {
              var t = this.getTipElement(),
                e = this.config.animation;
              null === t.getAttribute("x-placement") &&
                (At(t).removeClass(jt),
                (this.config.animation = !1),
                this.hide(),
                this.show(),
                (this.config.animation = e));
            }),
            (t._jQueryInterface = function (e) {
              return this.each(function () {
                var i = At(this).data(Ot),
                  n = "object" == typeof e && e;
                if (
                  (i || !/dispose|hide/.test(e)) &&
                  (i || ((i = new t(this, n)), At(this).data(Ot, i)),
                  "string" == typeof e)
                ) {
                  if (void 0 === i[e])
                    throw new TypeError('No method named "' + e + '"');
                  i[e]();
                }
              });
            }),
            s(t, null, [
              {
                key: "VERSION",
                get: function () {
                  return "4.1.3";
                },
              },
              {
                key: "Default",
                get: function () {
                  return Ft;
                },
              },
              {
                key: "NAME",
                get: function () {
                  return Pt;
                },
              },
              {
                key: "DATA_KEY",
                get: function () {
                  return Ot;
                },
              },
              {
                key: "Event",
                get: function () {
                  return Rt;
                },
              },
              {
                key: "EVENT_KEY",
                get: function () {
                  return Mt;
                },
              },
              {
                key: "DefaultType",
                get: function () {
                  return Ht;
                },
              },
            ]),
            t
          );
        })()),
        (At.fn[Pt] = Yt._jQueryInterface),
        (At.fn[Pt].Constructor = Yt),
        (At.fn[Pt].noConflict = function () {
          return (At.fn[Pt] = zt), Yt._jQueryInterface;
        }),
        Yt),
      Ne =
        ((Kt = "popover"),
        (Zt = "." + (Qt = "bs.popover")),
        (Gt = (Vt = e).fn[Kt]),
        (Xt = "bs-popover"),
        (Jt = new RegExp("(^|\\s)" + Xt + "\\S+", "g")),
        (te = o({}, $e.Default, {
          placement: "right",
          trigger: "click",
          content: "",
          template:
            '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
        })),
        (ee = o({}, $e.DefaultType, { content: "(string|element|function)" })),
        "fade",
        ".popover-header",
        ".popover-body",
        (ie = {
          HIDE: "hide" + Zt,
          HIDDEN: "hidden" + Zt,
          SHOW: "show" + Zt,
          SHOWN: "shown" + Zt,
          INSERTED: "inserted" + Zt,
          CLICK: "click" + Zt,
          FOCUSIN: "focusin" + Zt,
          FOCUSOUT: "focusout" + Zt,
          MOUSEENTER: "mouseenter" + Zt,
          MOUSELEAVE: "mouseleave" + Zt,
        }),
        (ne = (function (t) {
          var e, i;
          function n() {
            return t.apply(this, arguments) || this;
          }
          (i = t),
            ((e = n).prototype = Object.create(i.prototype)),
            ((e.prototype.constructor = e).__proto__ = i);
          var o = n.prototype;
          return (
            (o.isWithContent = function () {
              return this.getTitle() || this._getContent();
            }),
            (o.addAttachmentClass = function (t) {
              Vt(this.getTipElement()).addClass(Xt + "-" + t);
            }),
            (o.getTipElement = function () {
              return (
                (this.tip = this.tip || Vt(this.config.template)[0]), this.tip
              );
            }),
            (o.setContent = function () {
              var t = Vt(this.getTipElement());
              this.setElementContent(
                t.find(".popover-header"),
                this.getTitle()
              );
              var e = this._getContent();
              "function" == typeof e && (e = e.call(this.element)),
                this.setElementContent(t.find(".popover-body"), e),
                t.removeClass("fade show");
            }),
            (o._getContent = function () {
              return (
                this.element.getAttribute("data-content") || this.config.content
              );
            }),
            (o._cleanTipClass = function () {
              var t = Vt(this.getTipElement()),
                e = t.attr("class").match(Jt);
              null !== e && 0 < e.length && t.removeClass(e.join(""));
            }),
            (n._jQueryInterface = function (t) {
              return this.each(function () {
                var e = Vt(this).data(Qt),
                  i = "object" == typeof t ? t : null;
                if (
                  (e || !/destroy|hide/.test(t)) &&
                  (e || ((e = new n(this, i)), Vt(this).data(Qt, e)),
                  "string" == typeof t)
                ) {
                  if (void 0 === e[t])
                    throw new TypeError('No method named "' + t + '"');
                  e[t]();
                }
              });
            }),
            s(n, null, [
              {
                key: "VERSION",
                get: function () {
                  return "4.1.3";
                },
              },
              {
                key: "Default",
                get: function () {
                  return te;
                },
              },
              {
                key: "NAME",
                get: function () {
                  return Kt;
                },
              },
              {
                key: "DATA_KEY",
                get: function () {
                  return Qt;
                },
              },
              {
                key: "Event",
                get: function () {
                  return ie;
                },
              },
              {
                key: "EVENT_KEY",
                get: function () {
                  return Zt;
                },
              },
              {
                key: "DefaultType",
                get: function () {
                  return ee;
                },
              },
            ]),
            n
          );
        })($e)),
        (Vt.fn[Kt] = ne._jQueryInterface),
        (Vt.fn[Kt].Constructor = ne),
        (Vt.fn[Kt].noConflict = function () {
          return (Vt.fn[Kt] = Gt), ne._jQueryInterface;
        }),
        ne),
      He =
        ((oe = "scrollspy"),
        (ae = "." + (re = "bs.scrollspy")),
        (le = (se = e).fn[oe]),
        (he = { offset: 10, method: "auto", target: "" }),
        (ce = {
          offset: "number",
          method: "string",
          target: "(string|element)",
        }),
        (ue = {
          ACTIVATE: "activate" + ae,
          SCROLL: "scroll" + ae,
          LOAD_DATA_API: "load" + ae + ".data-api",
        }),
        "dropdown-item",
        (de = "active"),
        '[data-spy="scroll"]',
        ".active",
        (pe = ".nav, .list-group"),
        (fe = ".nav-link"),
        ".nav-item",
        (me = ".list-group-item"),
        ".dropdown",
        (ge = ".dropdown-item"),
        ".dropdown-toggle",
        "offset",
        (ve = "position"),
        (_e = (function () {
          function t(t, e) {
            var i = this;
            (this._element = t),
              (this._scrollElement = "BODY" === t.tagName ? window : t),
              (this._config = this._getConfig(e)),
              (this._selector =
                this._config.target +
                " " +
                fe +
                "," +
                this._config.target +
                " " +
                me +
                "," +
                this._config.target +
                " " +
                ge),
              (this._offsets = []),
              (this._targets = []),
              (this._activeTarget = null),
              (this._scrollHeight = 0),
              se(this._scrollElement).on(ue.SCROLL, function (t) {
                return i._process(t);
              }),
              this.refresh(),
              this._process();
          }
          var e = t.prototype;
          return (
            (e.refresh = function () {
              var t = this,
                e =
                  this._scrollElement === this._scrollElement.window
                    ? "offset"
                    : ve,
                i = "auto" === this._config.method ? e : this._config.method,
                n = i === ve ? this._getScrollTop() : 0;
              (this._offsets = []),
                (this._targets = []),
                (this._scrollHeight = this._getScrollHeight()),
                [].slice
                  .call(document.querySelectorAll(this._selector))
                  .map(function (t) {
                    var e,
                      s = Ee.getSelectorFromElement(t);
                    if ((s && (e = document.querySelector(s)), e)) {
                      var o = e.getBoundingClientRect();
                      if (o.width || o.height) return [se(e)[i]().top + n, s];
                    }
                    return null;
                  })
                  .filter(function (t) {
                    return t;
                  })
                  .sort(function (t, e) {
                    return t[0] - e[0];
                  })
                  .forEach(function (e) {
                    t._offsets.push(e[0]), t._targets.push(e[1]);
                  });
            }),
            (e.dispose = function () {
              se.removeData(this._element, re),
                se(this._scrollElement).off(ae),
                (this._element = null),
                (this._scrollElement = null),
                (this._config = null),
                (this._selector = null),
                (this._offsets = null),
                (this._targets = null),
                (this._activeTarget = null),
                (this._scrollHeight = null);
            }),
            (e._getConfig = function (t) {
              if (
                "string" !=
                typeof (t = o({}, he, "object" == typeof t && t ? t : {}))
                  .target
              ) {
                var e = se(t.target).attr("id");
                e || ((e = Ee.getUID(oe)), se(t.target).attr("id", e)),
                  (t.target = "#" + e);
              }
              return Ee.typeCheckConfig(oe, t, ce), t;
            }),
            (e._getScrollTop = function () {
              return this._scrollElement === window
                ? this._scrollElement.pageYOffset
                : this._scrollElement.scrollTop;
            }),
            (e._getScrollHeight = function () {
              return (
                this._scrollElement.scrollHeight ||
                Math.max(
                  document.body.scrollHeight,
                  document.documentElement.scrollHeight
                )
              );
            }),
            (e._getOffsetHeight = function () {
              return this._scrollElement === window
                ? window.innerHeight
                : this._scrollElement.getBoundingClientRect().height;
            }),
            (e._process = function () {
              var t = this._getScrollTop() + this._config.offset,
                e = this._getScrollHeight(),
                i = this._config.offset + e - this._getOffsetHeight();
              if ((this._scrollHeight !== e && this.refresh(), i <= t)) {
                var n = this._targets[this._targets.length - 1];
                this._activeTarget !== n && this._activate(n);
              } else {
                if (
                  this._activeTarget &&
                  t < this._offsets[0] &&
                  0 < this._offsets[0]
                )
                  return (this._activeTarget = null), void this._clear();
                for (var s = this._offsets.length; s--; )
                  this._activeTarget !== this._targets[s] &&
                    t >= this._offsets[s] &&
                    (void 0 === this._offsets[s + 1] ||
                      t < this._offsets[s + 1]) &&
                    this._activate(this._targets[s]);
              }
            }),
            (e._activate = function (t) {
              (this._activeTarget = t), this._clear();
              var e = this._selector.split(",");
              e = e.map(function (e) {
                return (
                  e + '[data-target="' + t + '"],' + e + '[href="' + t + '"]'
                );
              });
              var i = se([].slice.call(document.querySelectorAll(e.join(","))));
              i.hasClass("dropdown-item")
                ? (i.closest(".dropdown").find(".dropdown-toggle").addClass(de),
                  i.addClass(de))
                : (i.addClass(de),
                  i
                    .parents(pe)
                    .prev(fe + ", " + me)
                    .addClass(de),
                  i.parents(pe).prev(".nav-item").children(fe).addClass(de)),
                se(this._scrollElement).trigger(ue.ACTIVATE, {
                  relatedTarget: t,
                });
            }),
            (e._clear = function () {
              var t = [].slice.call(document.querySelectorAll(this._selector));
              se(t).filter(".active").removeClass(de);
            }),
            (t._jQueryInterface = function (e) {
              return this.each(function () {
                var i = se(this).data(re);
                if (
                  (i ||
                    ((i = new t(this, "object" == typeof e && e)),
                    se(this).data(re, i)),
                  "string" == typeof e)
                ) {
                  if (void 0 === i[e])
                    throw new TypeError('No method named "' + e + '"');
                  i[e]();
                }
              });
            }),
            s(t, null, [
              {
                key: "VERSION",
                get: function () {
                  return "4.1.3";
                },
              },
              {
                key: "Default",
                get: function () {
                  return he;
                },
              },
            ]),
            t
          );
        })()),
        se(window).on(ue.LOAD_DATA_API, function () {
          for (
            var t = [].slice.call(
                document.querySelectorAll('[data-spy="scroll"]')
              ),
              e = t.length;
            e--;

          ) {
            var i = se(t[e]);
            _e._jQueryInterface.call(i, i.data());
          }
        }),
        (se.fn[oe] = _e._jQueryInterface),
        (se.fn[oe].Constructor = _e),
        (se.fn[oe].noConflict = function () {
          return (se.fn[oe] = le), _e._jQueryInterface;
        }),
        _e),
      We =
        ((we = "." + (be = "bs.tab")),
        (xe = (ye = e).fn.tab),
        (Ce = {
          HIDE: "hide" + we,
          HIDDEN: "hidden" + we,
          SHOW: "show" + we,
          SHOWN: "shown" + we,
          CLICK_DATA_API: "click" + we + ".data-api",
        }),
        "dropdown-menu",
        (ke = "active"),
        "disabled",
        "fade",
        "show",
        ".dropdown",
        ".nav, .list-group",
        (Te = ".active"),
        (De = "> li > .active"),
        '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',
        ".dropdown-toggle",
        "> .dropdown-menu .active",
        (Ie = (function () {
          function t(t) {
            this._element = t;
          }
          var e = t.prototype;
          return (
            (e.show = function () {
              var t = this;
              if (
                !(
                  (this._element.parentNode &&
                    this._element.parentNode.nodeType === Node.ELEMENT_NODE &&
                    ye(this._element).hasClass(ke)) ||
                  ye(this._element).hasClass("disabled")
                )
              ) {
                var e,
                  i,
                  n = ye(this._element).closest(".nav, .list-group")[0],
                  s = Ee.getSelectorFromElement(this._element);
                if (n) {
                  var o = "UL" === n.nodeName ? De : Te;
                  i = (i = ye.makeArray(ye(n).find(o)))[i.length - 1];
                }
                var r = ye.Event(Ce.HIDE, { relatedTarget: this._element }),
                  a = ye.Event(Ce.SHOW, { relatedTarget: i });
                if (
                  (i && ye(i).trigger(r),
                  ye(this._element).trigger(a),
                  !a.isDefaultPrevented() && !r.isDefaultPrevented())
                ) {
                  s && (e = document.querySelector(s)),
                    this._activate(this._element, n);
                  var l = function () {
                    var e = ye.Event(Ce.HIDDEN, { relatedTarget: t._element }),
                      n = ye.Event(Ce.SHOWN, { relatedTarget: i });
                    ye(i).trigger(e), ye(t._element).trigger(n);
                  };
                  e ? this._activate(e, e.parentNode, l) : l();
                }
              }
            }),
            (e.dispose = function () {
              ye.removeData(this._element, be), (this._element = null);
            }),
            (e._activate = function (t, e, i) {
              var n = this,
                s = (
                  "UL" === e.nodeName ? ye(e).find(De) : ye(e).children(Te)
                )[0],
                o = i && s && ye(s).hasClass("fade"),
                r = function () {
                  return n._transitionComplete(t, s, i);
                };
              if (s && o) {
                var a = Ee.getTransitionDurationFromElement(s);
                ye(s).one(Ee.TRANSITION_END, r).emulateTransitionEnd(a);
              } else r();
            }),
            (e._transitionComplete = function (t, e, i) {
              if (e) {
                ye(e).removeClass("show " + ke);
                var n = ye(e.parentNode).find("> .dropdown-menu .active")[0];
                n && ye(n).removeClass(ke),
                  "tab" === e.getAttribute("role") &&
                    e.setAttribute("aria-selected", !1);
              }
              if (
                (ye(t).addClass(ke),
                "tab" === t.getAttribute("role") &&
                  t.setAttribute("aria-selected", !0),
                Ee.reflow(t),
                ye(t).addClass("show"),
                t.parentNode && ye(t.parentNode).hasClass("dropdown-menu"))
              ) {
                var s = ye(t).closest(".dropdown")[0];
                if (s) {
                  var o = [].slice.call(s.querySelectorAll(".dropdown-toggle"));
                  ye(o).addClass(ke);
                }
                t.setAttribute("aria-expanded", !0);
              }
              i && i();
            }),
            (t._jQueryInterface = function (e) {
              return this.each(function () {
                var i = ye(this),
                  n = i.data(be);
                if (
                  (n || ((n = new t(this)), i.data(be, n)),
                  "string" == typeof e)
                ) {
                  if (void 0 === n[e])
                    throw new TypeError('No method named "' + e + '"');
                  n[e]();
                }
              });
            }),
            s(t, null, [
              {
                key: "VERSION",
                get: function () {
                  return "4.1.3";
                },
              },
            ]),
            t
          );
        })()),
        ye(document).on(
          Ce.CLICK_DATA_API,
          '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',
          function (t) {
            t.preventDefault(), Ie._jQueryInterface.call(ye(this), "show");
          }
        ),
        (ye.fn.tab = Ie._jQueryInterface),
        (ye.fn.tab.Constructor = Ie),
        (ye.fn.tab.noConflict = function () {
          return (ye.fn.tab = xe), Ie._jQueryInterface;
        }),
        Ie);
    !(function (t) {
      if (void 0 === t)
        throw new TypeError(
          "Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript."
        );
      var e = t.fn.jquery.split(" ")[0].split(".");
      if (
        (e[0] < 2 && e[1] < 9) ||
        (1 === e[0] && 9 === e[1] && e[2] < 1) ||
        4 <= e[0]
      )
        throw new Error(
          "Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0"
        );
    })(e),
      (t.Util = Ee),
      (t.Alert = Se),
      (t.Button = Ae),
      (t.Carousel = Pe),
      (t.Collapse = Oe),
      (t.Dropdown = Me),
      (t.Modal = ze),
      (t.Popover = Ne),
      (t.Scrollspy = He),
      (t.Tab = We),
      (t.Tooltip = $e),
      Object.defineProperty(t, "__esModule", { value: !0 });
  }),
  (function (t, e, i, n) {
    function s(e, i) {
      (this.settings = null),
        (this.options = t.extend({}, s.Defaults, i)),
        (this.$element = t(e)),
        (this._handlers = {}),
        (this._plugins = {}),
        (this._supress = {}),
        (this._current = null),
        (this._speed = null),
        (this._coordinates = []),
        (this._breakpoint = null),
        (this._width = null),
        (this._items = []),
        (this._clones = []),
        (this._mergers = []),
        (this._widths = []),
        (this._invalidated = {}),
        (this._pipe = []),
        (this._drag = {
          time: null,
          target: null,
          pointer: null,
          stage: { start: null, current: null },
          direction: null,
        }),
        (this._states = {
          current: {},
          tags: {
            initializing: ["busy"],
            animating: ["busy"],
            dragging: ["interacting"],
          },
        }),
        t.each(
          ["onResize", "onThrottledResize"],
          t.proxy(function (e, i) {
            this._handlers[i] = t.proxy(this[i], this);
          }, this)
        ),
        t.each(
          s.Plugins,
          t.proxy(function (t, e) {
            this._plugins[t.charAt(0).toLowerCase() + t.slice(1)] = new e(this);
          }, this)
        ),
        t.each(
          s.Workers,
          t.proxy(function (e, i) {
            this._pipe.push({ filter: i.filter, run: t.proxy(i.run, this) });
          }, this)
        ),
        this.setup(),
        this.initialize();
    }
    (s.Defaults = {
      items: 3,
      loop: !1,
      center: !1,
      rewind: !1,
      checkVisibility: !0,
      mouseDrag: !0,
      touchDrag: !0,
      pullDrag: !0,
      freeDrag: !1,
      margin: 0,
      stagePadding: 0,
      merge: !1,
      mergeFit: !0,
      autoWidth: !1,
      startPosition: 0,
      rtl: !1,
      smartSpeed: 250,
      fluidSpeed: !1,
      dragEndSpeed: !1,
      responsive: {},
      responsiveRefreshRate: 200,
      responsiveBaseElement: e,
      fallbackEasing: "swing",
      slideTransition: "",
      info: !1,
      nestedItemSelector: !1,
      itemElement: "div",
      stageElement: "div",
      refreshClass: "owl-refresh",
      loadedClass: "owl-loaded",
      loadingClass: "owl-loading",
      rtlClass: "owl-rtl",
      responsiveClass: "owl-responsive",
      dragClass: "owl-drag",
      itemClass: "owl-item",
      stageClass: "owl-stage",
      stageOuterClass: "owl-stage-outer",
      grabClass: "owl-grab",
    }),
      (s.Width = { Default: "default", Inner: "inner", Outer: "outer" }),
      (s.Type = { Event: "event", State: "state" }),
      (s.Plugins = {}),
      (s.Workers = [
        {
          filter: ["width", "settings"],
          run: function () {
            this._width = this.$element.width();
          },
        },
        {
          filter: ["width", "items", "settings"],
          run: function (t) {
            t.current =
              this._items && this._items[this.relative(this._current)];
          },
        },
        {
          filter: ["items", "settings"],
          run: function () {
            this.$stage.children(".cloned").remove();
          },
        },
        {
          filter: ["width", "items", "settings"],
          run: function (t) {
            var e = this.settings.margin || "",
              i = !this.settings.autoWidth,
              n = this.settings.rtl,
              s = {
                width: "auto",
                "margin-left": n ? e : "",
                "margin-right": n ? "" : e,
              };
            !i && this.$stage.children().css(s), (t.css = s);
          },
        },
        {
          filter: ["width", "items", "settings"],
          run: function (t) {
            var e =
                (this.width() / this.settings.items).toFixed(3) -
                this.settings.margin,
              i = null,
              n = this._items.length,
              s = !this.settings.autoWidth,
              o = [];
            for (t.items = { merge: !1, width: e }; n--; )
              (i = this._mergers[n]),
                (i =
                  (this.settings.mergeFit &&
                    Math.min(i, this.settings.items)) ||
                  i),
                (t.items.merge = i > 1 || t.items.merge),
                (o[n] = s ? e * i : this._items[n].width());
            this._widths = o;
          },
        },
        {
          filter: ["items", "settings"],
          run: function () {
            var e = [],
              i = this._items,
              n = this.settings,
              s = Math.max(2 * n.items, 4),
              o = 2 * Math.ceil(i.length / 2),
              r = n.loop && i.length ? (n.rewind ? s : Math.max(s, o)) : 0,
              a = "",
              l = "";
            for (r /= 2; r > 0; )
              e.push(this.normalize(e.length / 2, !0)),
                (a += i[e[e.length - 1]][0].outerHTML),
                e.push(this.normalize(i.length - 1 - (e.length - 1) / 2, !0)),
                (l = i[e[e.length - 1]][0].outerHTML + l),
                (r -= 1);
            (this._clones = e),
              t(a).addClass("cloned").appendTo(this.$stage),
              t(l).addClass("cloned").prependTo(this.$stage);
          },
        },
        {
          filter: ["width", "items", "settings"],
          run: function () {
            for (
              var t = this.settings.rtl ? 1 : -1,
                e = this._clones.length + this._items.length,
                i = -1,
                n = 0,
                s = 0,
                o = [];
              ++i < e;

            )
              (n = o[i - 1] || 0),
                (s = this._widths[this.relative(i)] + this.settings.margin),
                o.push(n + s * t);
            this._coordinates = o;
          },
        },
        {
          filter: ["width", "items", "settings"],
          run: function () {
            var t = this.settings.stagePadding,
              e = this._coordinates,
              i = {
                width: Math.ceil(Math.abs(e[e.length - 1])) + 2 * t,
                "padding-left": t || "",
                "padding-right": t || "",
              };
            this.$stage.css(i);
          },
        },
        {
          filter: ["width", "items", "settings"],
          run: function (t) {
            var e = this._coordinates.length,
              i = !this.settings.autoWidth,
              n = this.$stage.children();
            if (i && t.items.merge)
              for (; e--; )
                (t.css.width = this._widths[this.relative(e)]),
                  n.eq(e).css(t.css);
            else i && ((t.css.width = t.items.width), n.css(t.css));
          },
        },
        {
          filter: ["items"],
          run: function () {
            this._coordinates.length < 1 && this.$stage.removeAttr("style");
          },
        },
        {
          filter: ["width", "items", "settings"],
          run: function (t) {
            (t.current = t.current
              ? this.$stage.children().index(t.current)
              : 0),
              (t.current = Math.max(
                this.minimum(),
                Math.min(this.maximum(), t.current)
              )),
              this.reset(t.current);
          },
        },
        {
          filter: ["position"],
          run: function () {
            this.animate(this.coordinates(this._current));
          },
        },
        {
          filter: ["width", "position", "items", "settings"],
          run: function () {
            var t,
              e,
              i,
              n,
              s = this.settings.rtl ? 1 : -1,
              o = 2 * this.settings.stagePadding,
              r = this.coordinates(this.current()) + o,
              a = r + this.width() * s,
              l = [];
            for (i = 0, n = this._coordinates.length; i < n; i++)
              (t = this._coordinates[i - 1] || 0),
                (e = Math.abs(this._coordinates[i]) + o * s),
                ((this.op(t, "<=", r) && this.op(t, ">", a)) ||
                  (this.op(e, "<", r) && this.op(e, ">", a))) &&
                  l.push(i);
            this.$stage.children(".active").removeClass("active"),
              this.$stage
                .children(":eq(" + l.join("), :eq(") + ")")
                .addClass("active"),
              this.$stage.children(".center").removeClass("center"),
              this.settings.center &&
                this.$stage.children().eq(this.current()).addClass("center");
          },
        },
      ]),
      (s.prototype.initializeStage = function () {
        (this.$stage = this.$element.find("." + this.settings.stageClass)),
          this.$stage.length ||
            (this.$element.addClass(this.options.loadingClass),
            (this.$stage = t("<" + this.settings.stageElement + ">", {
              class: this.settings.stageClass,
            }).wrap(t("<div/>", { class: this.settings.stageOuterClass }))),
            this.$element.append(this.$stage.parent()));
      }),
      (s.prototype.initializeItems = function () {
        var e = this.$element.find(".owl-item");
        if (e.length)
          return (
            (this._items = e.get().map(function (e) {
              return t(e);
            })),
            (this._mergers = this._items.map(function () {
              return 1;
            })),
            void this.refresh()
          );
        this.replace(this.$element.children().not(this.$stage.parent())),
          this.isVisible() ? this.refresh() : this.invalidate("width"),
          this.$element
            .removeClass(this.options.loadingClass)
            .addClass(this.options.loadedClass);
      }),
      (s.prototype.initialize = function () {
        var t, e, i;
        (this.enter("initializing"),
        this.trigger("initialize"),
        this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl),
        this.settings.autoWidth && !this.is("pre-loading")) &&
          ((t = this.$element.find("img")),
          (e = this.settings.nestedItemSelector
            ? "." + this.settings.nestedItemSelector
            : n),
          (i = this.$element.children(e).width()),
          t.length && i <= 0 && this.preloadAutoWidthImages(t));
        this.initializeStage(),
          this.initializeItems(),
          this.registerEventHandlers(),
          this.leave("initializing"),
          this.trigger("initialized");
      }),
      (s.prototype.isVisible = function () {
        return !this.settings.checkVisibility || this.$element.is(":visible");
      }),
      (s.prototype.setup = function () {
        var e = this.viewport(),
          i = this.options.responsive,
          n = -1,
          s = null;
        i
          ? (t.each(i, function (t) {
              t <= e && t > n && (n = Number(t));
            }),
            "function" ==
              typeof (s = t.extend({}, this.options, i[n])).stagePadding &&
              (s.stagePadding = s.stagePadding()),
            delete s.responsive,
            s.responsiveClass &&
              this.$element.attr(
                "class",
                this.$element
                  .attr("class")
                  .replace(
                    new RegExp(
                      "(" + this.options.responsiveClass + "-)\\S+\\s",
                      "g"
                    ),
                    "$1" + n
                  )
              ))
          : (s = t.extend({}, this.options)),
          this.trigger("change", { property: { name: "settings", value: s } }),
          (this._breakpoint = n),
          (this.settings = s),
          this.invalidate("settings"),
          this.trigger("changed", {
            property: { name: "settings", value: this.settings },
          });
      }),
      (s.prototype.optionsLogic = function () {
        this.settings.autoWidth &&
          ((this.settings.stagePadding = !1), (this.settings.merge = !1));
      }),
      (s.prototype.prepare = function (e) {
        var i = this.trigger("prepare", { content: e });
        return (
          i.data ||
            (i.data = t("<" + this.settings.itemElement + "/>")
              .addClass(this.options.itemClass)
              .append(e)),
          this.trigger("prepared", { content: i.data }),
          i.data
        );
      }),
      (s.prototype.update = function () {
        for (
          var e = 0,
            i = this._pipe.length,
            n = t.proxy(function (t) {
              return this[t];
            }, this._invalidated),
            s = {};
          e < i;

        )
          (this._invalidated.all ||
            t.grep(this._pipe[e].filter, n).length > 0) &&
            this._pipe[e].run(s),
            e++;
        (this._invalidated = {}), !this.is("valid") && this.enter("valid");
      }),
      (s.prototype.width = function (t) {
        switch ((t = t || s.Width.Default)) {
          case s.Width.Inner:
          case s.Width.Outer:
            return this._width;
          default:
            return (
              this._width -
              2 * this.settings.stagePadding +
              this.settings.margin
            );
        }
      }),
      (s.prototype.refresh = function () {
        this.enter("refreshing"),
          this.trigger("refresh"),
          this.setup(),
          this.optionsLogic(),
          this.$element.addClass(this.options.refreshClass),
          this.update(),
          this.$element.removeClass(this.options.refreshClass),
          this.leave("refreshing"),
          this.trigger("refreshed");
      }),
      (s.prototype.onThrottledResize = function () {
        e.clearTimeout(this.resizeTimer),
          (this.resizeTimer = e.setTimeout(
            this._handlers.onResize,
            this.settings.responsiveRefreshRate
          ));
      }),
      (s.prototype.onResize = function () {
        return (
          !!this._items.length &&
          this._width !== this.$element.width() &&
          !!this.isVisible() &&
          (this.enter("resizing"),
          this.trigger("resize").isDefaultPrevented()
            ? (this.leave("resizing"), !1)
            : (this.invalidate("width"),
              this.refresh(),
              this.leave("resizing"),
              void this.trigger("resized")))
        );
      }),
      (s.prototype.registerEventHandlers = function () {
        t.support.transition &&
          this.$stage.on(
            t.support.transition.end + ".owl.core",
            t.proxy(this.onTransitionEnd, this)
          ),
          !1 !== this.settings.responsive &&
            this.on(e, "resize", this._handlers.onThrottledResize),
          this.settings.mouseDrag &&
            (this.$element.addClass(this.options.dragClass),
            this.$stage.on(
              "mousedown.owl.core",
              t.proxy(this.onDragStart, this)
            ),
            this.$stage.on(
              "dragstart.owl.core selectstart.owl.core",
              function () {
                return !1;
              }
            )),
          this.settings.touchDrag &&
            (this.$stage.on(
              "touchstart.owl.core",
              t.proxy(this.onDragStart, this)
            ),
            this.$stage.on(
              "touchcancel.owl.core",
              t.proxy(this.onDragEnd, this)
            ));
      }),
      (s.prototype.onDragStart = function (e) {
        var n = null;
        3 !== e.which &&
          (t.support.transform
            ? (n = {
                x: (n = this.$stage
                  .css("transform")
                  .replace(/.*\(|\)| /g, "")
                  .split(","))[16 === n.length ? 12 : 4],
                y: n[16 === n.length ? 13 : 5],
              })
            : ((n = this.$stage.position()),
              (n = {
                x: this.settings.rtl
                  ? n.left +
                    this.$stage.width() -
                    this.width() +
                    this.settings.margin
                  : n.left,
                y: n.top,
              })),
          this.is("animating") &&
            (t.support.transform ? this.animate(n.x) : this.$stage.stop(),
            this.invalidate("position")),
          this.$element.toggleClass(
            this.options.grabClass,
            "mousedown" === e.type
          ),
          this.speed(0),
          (this._drag.time = new Date().getTime()),
          (this._drag.target = t(e.target)),
          (this._drag.stage.start = n),
          (this._drag.stage.current = n),
          (this._drag.pointer = this.pointer(e)),
          t(i).on(
            "mouseup.owl.core touchend.owl.core",
            t.proxy(this.onDragEnd, this)
          ),
          t(i).one(
            "mousemove.owl.core touchmove.owl.core",
            t.proxy(function (e) {
              var n = this.difference(this._drag.pointer, this.pointer(e));
              t(i).on(
                "mousemove.owl.core touchmove.owl.core",
                t.proxy(this.onDragMove, this)
              ),
                (Math.abs(n.x) < Math.abs(n.y) && this.is("valid")) ||
                  (e.preventDefault(),
                  this.enter("dragging"),
                  this.trigger("drag"));
            }, this)
          ));
      }),
      (s.prototype.onDragMove = function (t) {
        var e = null,
          i = null,
          n = null,
          s = this.difference(this._drag.pointer, this.pointer(t)),
          o = this.difference(this._drag.stage.start, s);
        this.is("dragging") &&
          (t.preventDefault(),
          this.settings.loop
            ? ((e = this.coordinates(this.minimum())),
              (i = this.coordinates(this.maximum() + 1) - e),
              (o.x = ((((o.x - e) % i) + i) % i) + e))
            : ((e = this.settings.rtl
                ? this.coordinates(this.maximum())
                : this.coordinates(this.minimum())),
              (i = this.settings.rtl
                ? this.coordinates(this.minimum())
                : this.coordinates(this.maximum())),
              (n = this.settings.pullDrag ? (-1 * s.x) / 5 : 0),
              (o.x = Math.max(Math.min(o.x, e + n), i + n))),
          (this._drag.stage.current = o),
          this.animate(o.x));
      }),
      (s.prototype.onDragEnd = function (e) {
        var n = this.difference(this._drag.pointer, this.pointer(e)),
          s = this._drag.stage.current,
          o = (n.x > 0) ^ this.settings.rtl ? "left" : "right";
        t(i).off(".owl.core"),
          this.$element.removeClass(this.options.grabClass),
          ((0 !== n.x && this.is("dragging")) || !this.is("valid")) &&
            (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed),
            this.current(
              this.closest(s.x, 0 !== n.x ? o : this._drag.direction)
            ),
            this.invalidate("position"),
            this.update(),
            (this._drag.direction = o),
            (Math.abs(n.x) > 3 ||
              new Date().getTime() - this._drag.time > 300) &&
              this._drag.target.one("click.owl.core", function () {
                return !1;
              })),
          this.is("dragging") &&
            (this.leave("dragging"), this.trigger("dragged"));
      }),
      (s.prototype.closest = function (e, i) {
        var s = -1,
          o = this.width(),
          r = this.coordinates();
        return (
          this.settings.freeDrag ||
            t.each(
              r,
              t.proxy(function (t, a) {
                return (
                  "left" === i && e > a - 30 && e < a + 30
                    ? (s = t)
                    : "right" === i && e > a - o - 30 && e < a - o + 30
                    ? (s = t + 1)
                    : this.op(e, "<", a) &&
                      this.op(e, ">", r[t + 1] !== n ? r[t + 1] : a - o) &&
                      (s = "left" === i ? t + 1 : t),
                  -1 === s
                );
              }, this)
            ),
          this.settings.loop ||
            (this.op(e, ">", r[this.minimum()])
              ? (s = e = this.minimum())
              : this.op(e, "<", r[this.maximum()]) && (s = e = this.maximum())),
          s
        );
      }),
      (s.prototype.animate = function (e) {
        var i = this.speed() > 0;
        this.is("animating") && this.onTransitionEnd(),
          i && (this.enter("animating"), this.trigger("translate")),
          t.support.transform3d && t.support.transition
            ? this.$stage.css({
                transform: "translate3d(" + e + "px,0px,0px)",
                transition:
                  this.speed() / 1e3 +
                  "s" +
                  (this.settings.slideTransition
                    ? " " + this.settings.slideTransition
                    : ""),
              })
            : i
            ? this.$stage.animate(
                { left: e + "px" },
                this.speed(),
                this.settings.fallbackEasing,
                t.proxy(this.onTransitionEnd, this)
              )
            : this.$stage.css({ left: e + "px" });
      }),
      (s.prototype.is = function (t) {
        return this._states.current[t] && this._states.current[t] > 0;
      }),
      (s.prototype.current = function (t) {
        if (t === n) return this._current;
        if (0 === this._items.length) return n;
        if (((t = this.normalize(t)), this._current !== t)) {
          var e = this.trigger("change", {
            property: { name: "position", value: t },
          });
          e.data !== n && (t = this.normalize(e.data)),
            (this._current = t),
            this.invalidate("position"),
            this.trigger("changed", {
              property: { name: "position", value: this._current },
            });
        }
        return this._current;
      }),
      (s.prototype.invalidate = function (e) {
        return (
          "string" === t.type(e) &&
            ((this._invalidated[e] = !0),
            this.is("valid") && this.leave("valid")),
          t.map(this._invalidated, function (t, e) {
            return e;
          })
        );
      }),
      (s.prototype.reset = function (t) {
        (t = this.normalize(t)) !== n &&
          ((this._speed = 0),
          (this._current = t),
          this.suppress(["translate", "translated"]),
          this.animate(this.coordinates(t)),
          this.release(["translate", "translated"]));
      }),
      (s.prototype.normalize = function (t, e) {
        var i = this._items.length,
          s = e ? 0 : this._clones.length;
        return (
          !this.isNumeric(t) || i < 1
            ? (t = n)
            : (t < 0 || t >= i + s) &&
              (t = ((((t - s / 2) % i) + i) % i) + s / 2),
          t
        );
      }),
      (s.prototype.relative = function (t) {
        return (t -= this._clones.length / 2), this.normalize(t, !0);
      }),
      (s.prototype.maximum = function (t) {
        var e,
          i,
          n,
          s = this.settings,
          o = this._coordinates.length;
        if (s.loop) o = this._clones.length / 2 + this._items.length - 1;
        else if (s.autoWidth || s.merge) {
          if ((e = this._items.length))
            for (
              i = this._items[--e].width(), n = this.$element.width();
              e-- &&
              !((i += this._items[e].width() + this.settings.margin) > n);

            );
          o = e + 1;
        } else
          o = s.center ? this._items.length - 1 : this._items.length - s.items;
        return t && (o -= this._clones.length / 2), Math.max(o, 0);
      }),
      (s.prototype.minimum = function (t) {
        return t ? 0 : this._clones.length / 2;
      }),
      (s.prototype.items = function (t) {
        return t === n
          ? this._items.slice()
          : ((t = this.normalize(t, !0)), this._items[t]);
      }),
      (s.prototype.mergers = function (t) {
        return t === n
          ? this._mergers.slice()
          : ((t = this.normalize(t, !0)), this._mergers[t]);
      }),
      (s.prototype.clones = function (e) {
        var i = this._clones.length / 2,
          s = i + this._items.length,
          o = function (t) {
            return t % 2 == 0 ? s + t / 2 : i - (t + 1) / 2;
          };
        return e === n
          ? t.map(this._clones, function (t, e) {
              return o(e);
            })
          : t.map(this._clones, function (t, i) {
              return t === e ? o(i) : null;
            });
      }),
      (s.prototype.speed = function (t) {
        return t !== n && (this._speed = t), this._speed;
      }),
      (s.prototype.coordinates = function (e) {
        var i,
          s = 1,
          o = e - 1;
        return e === n
          ? t.map(
              this._coordinates,
              t.proxy(function (t, e) {
                return this.coordinates(e);
              }, this)
            )
          : (this.settings.center
              ? (this.settings.rtl && ((s = -1), (o = e + 1)),
                (i = this._coordinates[e]),
                (i +=
                  ((this.width() - i + (this._coordinates[o] || 0)) / 2) * s))
              : (i = this._coordinates[o] || 0),
            (i = Math.ceil(i)));
      }),
      (s.prototype.duration = function (t, e, i) {
        return 0 === i
          ? 0
          : Math.min(Math.max(Math.abs(e - t), 1), 6) *
              Math.abs(i || this.settings.smartSpeed);
      }),
      (s.prototype.to = function (t, e) {
        var i = this.current(),
          n = null,
          s = t - this.relative(i),
          o = (s > 0) - (s < 0),
          r = this._items.length,
          a = this.minimum(),
          l = this.maximum();
        this.settings.loop
          ? (!this.settings.rewind && Math.abs(s) > r / 2 && (s += -1 * o * r),
            (n = (((((t = i + s) - a) % r) + r) % r) + a) !== t &&
              n - s <= l &&
              n - s > 0 &&
              ((i = n - s), (t = n), this.reset(i)))
          : this.settings.rewind
          ? (t = ((t % (l += 1)) + l) % l)
          : (t = Math.max(a, Math.min(l, t))),
          this.speed(this.duration(i, t, e)),
          this.current(t),
          this.isVisible() && this.update();
      }),
      (s.prototype.next = function (t) {
        (t = t || !1), this.to(this.relative(this.current()) + 1, t);
      }),
      (s.prototype.prev = function (t) {
        (t = t || !1), this.to(this.relative(this.current()) - 1, t);
      }),
      (s.prototype.onTransitionEnd = function (t) {
        if (
          t !== n &&
          (t.stopPropagation(),
          (t.target || t.srcElement || t.originalTarget) !== this.$stage.get(0))
        )
          return !1;
        this.leave("animating"), this.trigger("translated");
      }),
      (s.prototype.viewport = function () {
        var n;
        return (
          this.options.responsiveBaseElement !== e
            ? (n = t(this.options.responsiveBaseElement).width())
            : e.innerWidth
            ? (n = e.innerWidth)
            : i.documentElement && i.documentElement.clientWidth
            ? (n = i.documentElement.clientWidth)
            : console.warn("Can not detect viewport width."),
          n
        );
      }),
      (s.prototype.replace = function (e) {
        this.$stage.empty(),
          (this._items = []),
          e && (e = e instanceof jQuery ? e : t(e)),
          this.settings.nestedItemSelector &&
            (e = e.find("." + this.settings.nestedItemSelector)),
          e
            .filter(function () {
              return 1 === this.nodeType;
            })
            .each(
              t.proxy(function (t, e) {
                (e = this.prepare(e)),
                  this.$stage.append(e),
                  this._items.push(e),
                  this._mergers.push(
                    1 *
                      e
                        .find("[data-merge]")
                        .addBack("[data-merge]")
                        .attr("data-merge") || 1
                  );
              }, this)
            ),
          this.reset(
            this.isNumeric(this.settings.startPosition)
              ? this.settings.startPosition
              : 0
          ),
          this.invalidate("items");
      }),
      (s.prototype.add = function (e, i) {
        var s = this.relative(this._current);
        (i = i === n ? this._items.length : this.normalize(i, !0)),
          (e = e instanceof jQuery ? e : t(e)),
          this.trigger("add", { content: e, position: i }),
          (e = this.prepare(e)),
          0 === this._items.length || i === this._items.length
            ? (0 === this._items.length && this.$stage.append(e),
              0 !== this._items.length && this._items[i - 1].after(e),
              this._items.push(e),
              this._mergers.push(
                1 *
                  e
                    .find("[data-merge]")
                    .addBack("[data-merge]")
                    .attr("data-merge") || 1
              ))
            : (this._items[i].before(e),
              this._items.splice(i, 0, e),
              this._mergers.splice(
                i,
                0,
                1 *
                  e
                    .find("[data-merge]")
                    .addBack("[data-merge]")
                    .attr("data-merge") || 1
              )),
          this._items[s] && this.reset(this._items[s].index()),
          this.invalidate("items"),
          this.trigger("added", { content: e, position: i });
      }),
      (s.prototype.remove = function (t) {
        (t = this.normalize(t, !0)) !== n &&
          (this.trigger("remove", { content: this._items[t], position: t }),
          this._items[t].remove(),
          this._items.splice(t, 1),
          this._mergers.splice(t, 1),
          this.invalidate("items"),
          this.trigger("removed", { content: null, position: t }));
      }),
      (s.prototype.preloadAutoWidthImages = function (e) {
        e.each(
          t.proxy(function (e, i) {
            this.enter("pre-loading"),
              (i = t(i)),
              t(new Image())
                .one(
                  "load",
                  t.proxy(function (t) {
                    i.attr("src", t.target.src),
                      i.css("opacity", 1),
                      this.leave("pre-loading"),
                      !this.is("pre-loading") &&
                        !this.is("initializing") &&
                        this.refresh();
                  }, this)
                )
                .attr(
                  "src",
                  i.attr("src") ||
                    i.attr("data-src") ||
                    i.attr("data-src-retina")
                );
          }, this)
        );
      }),
      (s.prototype.destroy = function () {
        for (var n in (this.$element.off(".owl.core"),
        this.$stage.off(".owl.core"),
        t(i).off(".owl.core"),
        !1 !== this.settings.responsive &&
          (e.clearTimeout(this.resizeTimer),
          this.off(e, "resize", this._handlers.onThrottledResize)),
        this._plugins))
          this._plugins[n].destroy();
        this.$stage.children(".cloned").remove(),
          this.$stage.unwrap(),
          this.$stage.children().contents().unwrap(),
          this.$stage.children().unwrap(),
          this.$stage.remove(),
          this.$element
            .removeClass(this.options.refreshClass)
            .removeClass(this.options.loadingClass)
            .removeClass(this.options.loadedClass)
            .removeClass(this.options.rtlClass)
            .removeClass(this.options.dragClass)
            .removeClass(this.options.grabClass)
            .attr(
              "class",
              this.$element
                .attr("class")
                .replace(
                  new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"),
                  ""
                )
            )
            .removeData("owl.carousel");
      }),
      (s.prototype.op = function (t, e, i) {
        var n = this.settings.rtl;
        switch (e) {
          case "<":
            return n ? t > i : t < i;
          case ">":
            return n ? t < i : t > i;
          case ">=":
            return n ? t <= i : t >= i;
          case "<=":
            return n ? t >= i : t <= i;
        }
      }),
      (s.prototype.on = function (t, e, i, n) {
        t.addEventListener
          ? t.addEventListener(e, i, n)
          : t.attachEvent && t.attachEvent("on" + e, i);
      }),
      (s.prototype.off = function (t, e, i, n) {
        t.removeEventListener
          ? t.removeEventListener(e, i, n)
          : t.detachEvent && t.detachEvent("on" + e, i);
      }),
      (s.prototype.trigger = function (e, i, n, o, r) {
        var a = { item: { count: this._items.length, index: this.current() } },
          l = t.camelCase(
            t
              .grep(["on", e, n], function (t) {
                return t;
              })
              .join("-")
              .toLowerCase()
          ),
          h = t.Event(
            [e, "owl", n || "carousel"].join(".").toLowerCase(),
            t.extend({ relatedTarget: this }, a, i)
          );
        return (
          this._supress[e] ||
            (t.each(this._plugins, function (t, e) {
              e.onTrigger && e.onTrigger(h);
            }),
            this.register({ type: s.Type.Event, name: e }),
            this.$element.trigger(h),
            this.settings &&
              "function" == typeof this.settings[l] &&
              this.settings[l].call(this, h)),
          h
        );
      }),
      (s.prototype.enter = function (e) {
        t.each(
          [e].concat(this._states.tags[e] || []),
          t.proxy(function (t, e) {
            this._states.current[e] === n && (this._states.current[e] = 0),
              this._states.current[e]++;
          }, this)
        );
      }),
      (s.prototype.leave = function (e) {
        t.each(
          [e].concat(this._states.tags[e] || []),
          t.proxy(function (t, e) {
            this._states.current[e]--;
          }, this)
        );
      }),
      (s.prototype.register = function (e) {
        if (e.type === s.Type.Event) {
          if (
            (t.event.special[e.name] || (t.event.special[e.name] = {}),
            !t.event.special[e.name].owl)
          ) {
            var i = t.event.special[e.name]._default;
            (t.event.special[e.name]._default = function (t) {
              return !i ||
                !i.apply ||
                (t.namespace && -1 !== t.namespace.indexOf("owl"))
                ? t.namespace && t.namespace.indexOf("owl") > -1
                : i.apply(this, arguments);
            }),
              (t.event.special[e.name].owl = !0);
          }
        } else
          e.type === s.Type.State &&
            (this._states.tags[e.name]
              ? (this._states.tags[e.name] = this._states.tags[e.name].concat(
                  e.tags
                ))
              : (this._states.tags[e.name] = e.tags),
            (this._states.tags[e.name] = t.grep(
              this._states.tags[e.name],
              t.proxy(function (i, n) {
                return t.inArray(i, this._states.tags[e.name]) === n;
              }, this)
            )));
      }),
      (s.prototype.suppress = function (e) {
        t.each(
          e,
          t.proxy(function (t, e) {
            this._supress[e] = !0;
          }, this)
        );
      }),
      (s.prototype.release = function (e) {
        t.each(
          e,
          t.proxy(function (t, e) {
            delete this._supress[e];
          }, this)
        );
      }),
      (s.prototype.pointer = function (t) {
        var i = { x: null, y: null };
        return (
          (t =
            (t = t.originalEvent || t || e.event).touches && t.touches.length
              ? t.touches[0]
              : t.changedTouches && t.changedTouches.length
              ? t.changedTouches[0]
              : t).pageX
            ? ((i.x = t.pageX), (i.y = t.pageY))
            : ((i.x = t.clientX), (i.y = t.clientY)),
          i
        );
      }),
      (s.prototype.isNumeric = function (t) {
        return !isNaN(parseFloat(t));
      }),
      (s.prototype.difference = function (t, e) {
        return { x: t.x - e.x, y: t.y - e.y };
      }),
      (t.fn.owlCarousel = function (e) {
        var i = Array.prototype.slice.call(arguments, 1);
        return this.each(function () {
          var n = t(this),
            o = n.data("owl.carousel");
          o ||
            ((o = new s(this, "object" == typeof e && e)),
            n.data("owl.carousel", o),
            t.each(
              [
                "next",
                "prev",
                "to",
                "destroy",
                "refresh",
                "replace",
                "add",
                "remove",
              ],
              function (e, i) {
                o.register({ type: s.Type.Event, name: i }),
                  o.$element.on(
                    i + ".owl.carousel.core",
                    t.proxy(function (t) {
                      t.namespace &&
                        t.relatedTarget !== this &&
                        (this.suppress([i]),
                        o[i].apply(this, [].slice.call(arguments, 1)),
                        this.release([i]));
                    }, o)
                  );
              }
            )),
            "string" == typeof e && "_" !== e.charAt(0) && o[e].apply(o, i);
        });
      }),
      (t.fn.owlCarousel.Constructor = s);
  })(window.Zepto || window.jQuery, window, document),
  (function (t, e, i, n) {
    var s = function (e) {
      (this._core = e),
        (this._interval = null),
        (this._visible = null),
        (this._handlers = {
          "initialized.owl.carousel": t.proxy(function (t) {
            t.namespace && this._core.settings.autoRefresh && this.watch();
          }, this),
        }),
        (this._core.options = t.extend({}, s.Defaults, this._core.options)),
        this._core.$element.on(this._handlers);
    };
    (s.Defaults = { autoRefresh: !0, autoRefreshInterval: 500 }),
      (s.prototype.watch = function () {
        this._interval ||
          ((this._visible = this._core.isVisible()),
          (this._interval = e.setInterval(
            t.proxy(this.refresh, this),
            this._core.settings.autoRefreshInterval
          )));
      }),
      (s.prototype.refresh = function () {
        this._core.isVisible() !== this._visible &&
          ((this._visible = !this._visible),
          this._core.$element.toggleClass("owl-hidden", !this._visible),
          this._visible &&
            this._core.invalidate("width") &&
            this._core.refresh());
      }),
      (s.prototype.destroy = function () {
        var t, i;
        for (t in (e.clearInterval(this._interval), this._handlers))
          this._core.$element.off(t, this._handlers[t]);
        for (i in Object.getOwnPropertyNames(this))
          "function" != typeof this[i] && (this[i] = null);
      }),
      (t.fn.owlCarousel.Constructor.Plugins.AutoRefresh = s);
  })(window.Zepto || window.jQuery, window, document),
  (function (t, e, i, n) {
    var s = function (e) {
      (this._core = e),
        (this._loaded = []),
        (this._handlers = {
          "initialized.owl.carousel change.owl.carousel resized.owl.carousel":
            t.proxy(function (e) {
              if (
                e.namespace &&
                this._core.settings &&
                this._core.settings.lazyLoad &&
                ((e.property && "position" == e.property.name) ||
                  "initialized" == e.type)
              ) {
                var i = this._core.settings,
                  n = (i.center && Math.ceil(i.items / 2)) || i.items,
                  s = (i.center && -1 * n) || 0,
                  o =
                    (e.property && void 0 !== e.property.value
                      ? e.property.value
                      : this._core.current()) + s,
                  r = this._core.clones().length,
                  a = t.proxy(function (t, e) {
                    this.load(e);
                  }, this);
                for (
                  i.lazyLoadEager > 0 &&
                  ((n += i.lazyLoadEager),
                  i.loop && ((o -= i.lazyLoadEager), n++));
                  s++ < n;

                )
                  this.load(r / 2 + this._core.relative(o)),
                    r && t.each(this._core.clones(this._core.relative(o)), a),
                    o++;
              }
            }, this),
        }),
        (this._core.options = t.extend({}, s.Defaults, this._core.options)),
        this._core.$element.on(this._handlers);
    };
    (s.Defaults = { lazyLoad: !1, lazyLoadEager: 0 }),
      (s.prototype.load = function (i) {
        var n = this._core.$stage.children().eq(i),
          s = n && n.find(".owl-lazy");
        !s ||
          t.inArray(n.get(0), this._loaded) > -1 ||
          (s.each(
            t.proxy(function (i, n) {
              var s,
                o = t(n),
                r =
                  (e.devicePixelRatio > 1 && o.attr("data-src-retina")) ||
                  o.attr("data-src") ||
                  o.attr("data-srcset");
              this._core.trigger("load", { element: o, url: r }, "lazy"),
                o.is("img")
                  ? o
                      .one(
                        "load.owl.lazy",
                        t.proxy(function () {
                          o.css("opacity", 1),
                            this._core.trigger(
                              "loaded",
                              { element: o, url: r },
                              "lazy"
                            );
                        }, this)
                      )
                      .attr("src", r)
                  : o.is("source")
                  ? o
                      .one(
                        "load.owl.lazy",
                        t.proxy(function () {
                          this._core.trigger(
                            "loaded",
                            { element: o, url: r },
                            "lazy"
                          );
                        }, this)
                      )
                      .attr("srcset", r)
                  : (((s = new Image()).onload = t.proxy(function () {
                      o.css({
                        "background-image": 'url("' + r + '")',
                        opacity: "1",
                      }),
                        this._core.trigger(
                          "loaded",
                          { element: o, url: r },
                          "lazy"
                        );
                    }, this)),
                    (s.src = r));
            }, this)
          ),
          this._loaded.push(n.get(0)));
      }),
      (s.prototype.destroy = function () {
        var t, e;
        for (t in this.handlers) this._core.$element.off(t, this.handlers[t]);
        for (e in Object.getOwnPropertyNames(this))
          "function" != typeof this[e] && (this[e] = null);
      }),
      (t.fn.owlCarousel.Constructor.Plugins.Lazy = s);
  })(window.Zepto || window.jQuery, window, document),
  (function (t, e, i, n) {
    var s = function (i) {
      (this._core = i),
        (this._previousHeight = null),
        (this._handlers = {
          "initialized.owl.carousel refreshed.owl.carousel": t.proxy(function (
            t
          ) {
            t.namespace && this._core.settings.autoHeight && this.update();
          },
          this),
          "changed.owl.carousel": t.proxy(function (t) {
            t.namespace &&
              this._core.settings.autoHeight &&
              "position" === t.property.name &&
              this.update();
          }, this),
          "loaded.owl.lazy": t.proxy(function (t) {
            t.namespace &&
              this._core.settings.autoHeight &&
              t.element.closest("." + this._core.settings.itemClass).index() ===
                this._core.current() &&
              this.update();
          }, this),
        }),
        (this._core.options = t.extend({}, s.Defaults, this._core.options)),
        this._core.$element.on(this._handlers),
        (this._intervalId = null);
      var n = this;
      t(e).on("load", function () {
        n._core.settings.autoHeight && n.update();
      }),
        t(e).resize(function () {
          n._core.settings.autoHeight &&
            (null != n._intervalId && clearTimeout(n._intervalId),
            (n._intervalId = setTimeout(function () {
              n.update();
            }, 250)));
        });
    };
    (s.Defaults = { autoHeight: !1, autoHeightClass: "owl-height" }),
      (s.prototype.update = function () {
        var e = this._core._current,
          i = e + this._core.settings.items,
          n = this._core.settings.lazyLoad,
          s = this._core.$stage.children().toArray().slice(e, i),
          o = [],
          r = 0;
        t.each(s, function (e, i) {
          o.push(t(i).height());
        }),
          (r = Math.max.apply(null, o)) <= 1 &&
            n &&
            this._previousHeight &&
            (r = this._previousHeight),
          (this._previousHeight = r),
          this._core.$stage
            .parent()
            .height(r)
            .addClass(this._core.settings.autoHeightClass);
      }),
      (s.prototype.destroy = function () {
        var t, e;
        for (t in this._handlers) this._core.$element.off(t, this._handlers[t]);
        for (e in Object.getOwnPropertyNames(this))
          "function" != typeof this[e] && (this[e] = null);
      }),
      (t.fn.owlCarousel.Constructor.Plugins.AutoHeight = s);
  })(window.Zepto || window.jQuery, window, document),
  (function (t, e, i, n) {
    var s = function (e) {
      (this._core = e),
        (this._videos = {}),
        (this._playing = null),
        (this._handlers = {
          "initialized.owl.carousel": t.proxy(function (t) {
            t.namespace &&
              this._core.register({
                type: "state",
                name: "playing",
                tags: ["interacting"],
              });
          }, this),
          "resize.owl.carousel": t.proxy(function (t) {
            t.namespace &&
              this._core.settings.video &&
              this.isInFullScreen() &&
              t.preventDefault();
          }, this),
          "refreshed.owl.carousel": t.proxy(function (t) {
            t.namespace &&
              this._core.is("resizing") &&
              this._core.$stage.find(".cloned .owl-video-frame").remove();
          }, this),
          "changed.owl.carousel": t.proxy(function (t) {
            t.namespace &&
              "position" === t.property.name &&
              this._playing &&
              this.stop();
          }, this),
          "prepared.owl.carousel": t.proxy(function (e) {
            if (e.namespace) {
              var i = t(e.content).find(".owl-video");
              i.length &&
                (i.css("display", "none"), this.fetch(i, t(e.content)));
            }
          }, this),
        }),
        (this._core.options = t.extend({}, s.Defaults, this._core.options)),
        this._core.$element.on(this._handlers),
        this._core.$element.on(
          "click.owl.video",
          ".owl-video-play-icon",
          t.proxy(function (t) {
            this.play(t);
          }, this)
        );
    };
    (s.Defaults = { video: !1, videoHeight: !1, videoWidth: !1 }),
      (s.prototype.fetch = function (t, e) {
        var i = t.attr("data-vimeo-id")
            ? "vimeo"
            : t.attr("data-vzaar-id")
            ? "vzaar"
            : "youtube",
          n =
            t.attr("data-vimeo-id") ||
            t.attr("data-youtube-id") ||
            t.attr("data-vzaar-id"),
          s = t.attr("data-width") || this._core.settings.videoWidth,
          o = t.attr("data-height") || this._core.settings.videoHeight,
          r = t.attr("href");
        if (!r) throw new Error("Missing video URL.");
        if (
          (n = r.match(
            /(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
          ))[3].indexOf("youtu") > -1
        )
          i = "youtube";
        else if (n[3].indexOf("vimeo") > -1) i = "vimeo";
        else {
          if (!(n[3].indexOf("vzaar") > -1))
            throw new Error("Video URL not supported.");
          i = "vzaar";
        }
        (n = n[6]),
          (this._videos[r] = { type: i, id: n, width: s, height: o }),
          e.attr("data-video", r),
          this.thumbnail(t, this._videos[r]);
      }),
      (s.prototype.thumbnail = function (e, i) {
        var n,
          s,
          o =
            i.width && i.height
              ? "width:" + i.width + "px;height:" + i.height + "px;"
              : "",
          r = e.find("img"),
          a = "src",
          l = "",
          h = this._core.settings,
          c = function (i) {
            '<div class="owl-video-play-icon"></div>',
              (n = h.lazyLoad
                ? t("<div/>", { class: "owl-video-tn " + l, srcType: i })
                : t("<div/>", {
                    class: "owl-video-tn",
                    style: "opacity:1;background-image:url(" + i + ")",
                  })),
              e.after(n),
              e.after('<div class="owl-video-play-icon"></div>');
          };
        if (
          (e.wrap(t("<div/>", { class: "owl-video-wrapper", style: o })),
          this._core.settings.lazyLoad && ((a = "data-src"), (l = "owl-lazy")),
          r.length)
        )
          return c(r.attr(a)), r.remove(), !1;
        "youtube" === i.type
          ? ((s = "//img.youtube.com/vi/" + i.id + "/hqdefault.jpg"), c(s))
          : "vimeo" === i.type
          ? t.ajax({
              type: "GET",
              url: "//vimeo.com/api/v2/video/" + i.id + ".json",
              jsonp: "callback",
              dataType: "jsonp",
              success: function (t) {
                (s = t[0].thumbnail_large), c(s);
              },
            })
          : "vzaar" === i.type &&
            t.ajax({
              type: "GET",
              url: "//vzaar.com/api/videos/" + i.id + ".json",
              jsonp: "callback",
              dataType: "jsonp",
              success: function (t) {
                (s = t.framegrab_url), c(s);
              },
            });
      }),
      (s.prototype.stop = function () {
        this._core.trigger("stop", null, "video"),
          this._playing.find(".owl-video-frame").remove(),
          this._playing.removeClass("owl-video-playing"),
          (this._playing = null),
          this._core.leave("playing"),
          this._core.trigger("stopped", null, "video");
      }),
      (s.prototype.play = function (e) {
        var i,
          n = t(e.target).closest("." + this._core.settings.itemClass),
          s = this._videos[n.attr("data-video")],
          o = s.width || "100%",
          r = s.height || this._core.$stage.height();
        this._playing ||
          (this._core.enter("playing"),
          this._core.trigger("play", null, "video"),
          (n = this._core.items(this._core.relative(n.index()))),
          this._core.reset(n.index()),
          (i = t(
            '<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>'
          )).attr("height", r),
          i.attr("width", o),
          "youtube" === s.type
            ? i.attr(
                "src",
                "//www.youtube.com/embed/" +
                  s.id +
                  "?autoplay=1&rel=0&v=" +
                  s.id
              )
            : "vimeo" === s.type
            ? i.attr("src", "//player.vimeo.com/video/" + s.id + "?autoplay=1")
            : "vzaar" === s.type &&
              i.attr(
                "src",
                "//view.vzaar.com/" + s.id + "/player?autoplay=true"
              ),
          t(i)
            .wrap('<div class="owl-video-frame" />')
            .insertAfter(n.find(".owl-video")),
          (this._playing = n.addClass("owl-video-playing")));
      }),
      (s.prototype.isInFullScreen = function () {
        var e =
          i.fullscreenElement ||
          i.mozFullScreenElement ||
          i.webkitFullscreenElement;
        return e && t(e).parent().hasClass("owl-video-frame");
      }),
      (s.prototype.destroy = function () {
        var t, e;
        for (t in (this._core.$element.off("click.owl.video"), this._handlers))
          this._core.$element.off(t, this._handlers[t]);
        for (e in Object.getOwnPropertyNames(this))
          "function" != typeof this[e] && (this[e] = null);
      }),
      (t.fn.owlCarousel.Constructor.Plugins.Video = s);
  })(window.Zepto || window.jQuery, window, document),
  (function (t, e, i, n) {
    var s = function (e) {
      (this.core = e),
        (this.core.options = t.extend({}, s.Defaults, this.core.options)),
        (this.swapping = !0),
        (this.previous = n),
        (this.next = n),
        (this.handlers = {
          "change.owl.carousel": t.proxy(function (t) {
            t.namespace &&
              "position" == t.property.name &&
              ((this.previous = this.core.current()),
              (this.next = t.property.value));
          }, this),
          "drag.owl.carousel dragged.owl.carousel translated.owl.carousel":
            t.proxy(function (t) {
              t.namespace && (this.swapping = "translated" == t.type);
            }, this),
          "translate.owl.carousel": t.proxy(function (t) {
            t.namespace &&
              this.swapping &&
              (this.core.options.animateOut || this.core.options.animateIn) &&
              this.swap();
          }, this),
        }),
        this.core.$element.on(this.handlers);
    };
    (s.Defaults = { animateOut: !1, animateIn: !1 }),
      (s.prototype.swap = function () {
        if (
          1 === this.core.settings.items &&
          t.support.animation &&
          t.support.transition
        ) {
          this.core.speed(0);
          var e,
            i = t.proxy(this.clear, this),
            n = this.core.$stage.children().eq(this.previous),
            s = this.core.$stage.children().eq(this.next),
            o = this.core.settings.animateIn,
            r = this.core.settings.animateOut;
          this.core.current() !== this.previous &&
            (r &&
              ((e =
                this.core.coordinates(this.previous) -
                this.core.coordinates(this.next)),
              n
                .one(t.support.animation.end, i)
                .css({ left: e + "px" })
                .addClass("animated owl-animated-out")
                .addClass(r)),
            o &&
              s
                .one(t.support.animation.end, i)
                .addClass("animated owl-animated-in")
                .addClass(o));
        }
      }),
      (s.prototype.clear = function (e) {
        t(e.target)
          .css({ left: "" })
          .removeClass("animated owl-animated-out owl-animated-in")
          .removeClass(this.core.settings.animateIn)
          .removeClass(this.core.settings.animateOut),
          this.core.onTransitionEnd();
      }),
      (s.prototype.destroy = function () {
        var t, e;
        for (t in this.handlers) this.core.$element.off(t, this.handlers[t]);
        for (e in Object.getOwnPropertyNames(this))
          "function" != typeof this[e] && (this[e] = null);
      }),
      (t.fn.owlCarousel.Constructor.Plugins.Animate = s);
  })(window.Zepto || window.jQuery, window, document),
  (function (t, e, i, n) {
    var s = function (e) {
      (this._core = e),
        (this._call = null),
        (this._time = 0),
        (this._timeout = 0),
        (this._paused = !0),
        (this._handlers = {
          "changed.owl.carousel": t.proxy(function (t) {
            t.namespace && "settings" === t.property.name
              ? this._core.settings.autoplay
                ? this.play()
                : this.stop()
              : t.namespace &&
                "position" === t.property.name &&
                this._paused &&
                (this._time = 0);
          }, this),
          "initialized.owl.carousel": t.proxy(function (t) {
            t.namespace && this._core.settings.autoplay && this.play();
          }, this),
          "play.owl.autoplay": t.proxy(function (t, e, i) {
            t.namespace && this.play(e, i);
          }, this),
          "stop.owl.autoplay": t.proxy(function (t) {
            t.namespace && this.stop();
          }, this),
          "mouseover.owl.autoplay": t.proxy(function () {
            this._core.settings.autoplayHoverPause &&
              this._core.is("rotating") &&
              this.pause();
          }, this),
          "mouseleave.owl.autoplay": t.proxy(function () {
            this._core.settings.autoplayHoverPause &&
              this._core.is("rotating") &&
              this.play();
          }, this),
          "touchstart.owl.core": t.proxy(function () {
            this._core.settings.autoplayHoverPause &&
              this._core.is("rotating") &&
              this.pause();
          }, this),
          "touchend.owl.core": t.proxy(function () {
            this._core.settings.autoplayHoverPause && this.play();
          }, this),
        }),
        this._core.$element.on(this._handlers),
        (this._core.options = t.extend({}, s.Defaults, this._core.options));
    };
    (s.Defaults = {
      autoplay: !1,
      autoplayTimeout: 5e3,
      autoplayHoverPause: !1,
      autoplaySpeed: !1,
    }),
      (s.prototype._next = function (n) {
        (this._call = e.setTimeout(
          t.proxy(this._next, this, n),
          this._timeout * (Math.round(this.read() / this._timeout) + 1) -
            this.read()
        )),
          this._core.is("interacting") ||
            i.hidden ||
            this._core.next(n || this._core.settings.autoplaySpeed);
      }),
      (s.prototype.read = function () {
        return new Date().getTime() - this._time;
      }),
      (s.prototype.play = function (i, n) {
        var s;
        this._core.is("rotating") || this._core.enter("rotating"),
          (i = i || this._core.settings.autoplayTimeout),
          (s = Math.min(this._time % (this._timeout || i), i)),
          this._paused
            ? ((this._time = this.read()), (this._paused = !1))
            : e.clearTimeout(this._call),
          (this._time += (this.read() % i) - s),
          (this._timeout = i),
          (this._call = e.setTimeout(t.proxy(this._next, this, n), i - s));
      }),
      (s.prototype.stop = function () {
        this._core.is("rotating") &&
          ((this._time = 0),
          (this._paused = !0),
          e.clearTimeout(this._call),
          this._core.leave("rotating"));
      }),
      (s.prototype.pause = function () {
        this._core.is("rotating") &&
          !this._paused &&
          ((this._time = this.read()),
          (this._paused = !0),
          e.clearTimeout(this._call));
      }),
      (s.prototype.destroy = function () {
        var t, e;
        for (t in (this.stop(), this._handlers))
          this._core.$element.off(t, this._handlers[t]);
        for (e in Object.getOwnPropertyNames(this))
          "function" != typeof this[e] && (this[e] = null);
      }),
      (t.fn.owlCarousel.Constructor.Plugins.autoplay = s);
  })(window.Zepto || window.jQuery, window, document),
  (function (t, e, i, n) {
    "use strict";
    var s = function (e) {
      (this._core = e),
        (this._initialized = !1),
        (this._pages = []),
        (this._controls = {}),
        (this._templates = []),
        (this.$element = this._core.$element),
        (this._overrides = {
          next: this._core.next,
          prev: this._core.prev,
          to: this._core.to,
        }),
        (this._handlers = {
          "prepared.owl.carousel": t.proxy(function (e) {
            e.namespace &&
              this._core.settings.dotsData &&
              this._templates.push(
                '<div class="' +
                  this._core.settings.dotClass +
                  '">' +
                  t(e.content)
                    .find("[data-dot]")
                    .addBack("[data-dot]")
                    .attr("data-dot") +
                  "</div>"
              );
          }, this),
          "added.owl.carousel": t.proxy(function (t) {
            t.namespace &&
              this._core.settings.dotsData &&
              this._templates.splice(t.position, 0, this._templates.pop());
          }, this),
          "remove.owl.carousel": t.proxy(function (t) {
            t.namespace &&
              this._core.settings.dotsData &&
              this._templates.splice(t.position, 1);
          }, this),
          "changed.owl.carousel": t.proxy(function (t) {
            t.namespace && "position" == t.property.name && this.draw();
          }, this),
          "initialized.owl.carousel": t.proxy(function (t) {
            t.namespace &&
              !this._initialized &&
              (this._core.trigger("initialize", null, "navigation"),
              this.initialize(),
              this.update(),
              this.draw(),
              (this._initialized = !0),
              this._core.trigger("initialized", null, "navigation"));
          }, this),
          "refreshed.owl.carousel": t.proxy(function (t) {
            t.namespace &&
              this._initialized &&
              (this._core.trigger("refresh", null, "navigation"),
              this.update(),
              this.draw(),
              this._core.trigger("refreshed", null, "navigation"));
          }, this),
        }),
        (this._core.options = t.extend({}, s.Defaults, this._core.options)),
        this.$element.on(this._handlers);
    };
    (s.Defaults = {
      nav: !1,
      navText: [
        '<span aria-label="Previous">&#x2039;</span>',
        '<span aria-label="Next">&#x203a;</span>',
      ],
      navSpeed: !1,
      navElement: 'button type="button" role="presentation"',
      navContainer: !1,
      navContainerClass: "owl-nav",
      navClass: ["owl-prev", "owl-next"],
      slideBy: 1,
      dotClass: "owl-dot",
      dotsClass: "owl-dots",
      dots: !0,
      dotsEach: !1,
      dotsData: !1,
      dotsSpeed: !1,
      dotsContainer: !1,
    }),
      (s.prototype.initialize = function () {
        var e,
          i = this._core.settings;
        for (e in ((this._controls.$relative = (
          i.navContainer
            ? t(i.navContainer)
            : t("<div>").addClass(i.navContainerClass).appendTo(this.$element)
        ).addClass("disabled")),
        (this._controls.$previous = t("<" + i.navElement + ">")
          .addClass(i.navClass[0])
          .html(i.navText[0])
          .prependTo(this._controls.$relative)
          .on(
            "click",
            t.proxy(function (t) {
              this.prev(i.navSpeed);
            }, this)
          )),
        (this._controls.$next = t("<" + i.navElement + ">")
          .addClass(i.navClass[1])
          .html(i.navText[1])
          .appendTo(this._controls.$relative)
          .on(
            "click",
            t.proxy(function (t) {
              this.next(i.navSpeed);
            }, this)
          )),
        i.dotsData ||
          (this._templates = [
            t('<button role="button">')
              .addClass(i.dotClass)
              .append(t("<span>"))
              .prop("outerHTML"),
          ]),
        (this._controls.$absolute = (
          i.dotsContainer
            ? t(i.dotsContainer)
            : t("<div>").addClass(i.dotsClass).appendTo(this.$element)
        ).addClass("disabled")),
        this._controls.$absolute.on(
          "click",
          "button",
          t.proxy(function (e) {
            var n = t(e.target).parent().is(this._controls.$absolute)
              ? t(e.target).index()
              : t(e.target).parent().index();
            e.preventDefault(), this.to(n, i.dotsSpeed);
          }, this)
        ),
        this._overrides))
          this._core[e] = t.proxy(this[e], this);
      }),
      (s.prototype.destroy = function () {
        var t, e, i, n, s;
        for (t in ((s = this._core.settings), this._handlers))
          this.$element.off(t, this._handlers[t]);
        for (e in this._controls)
          "$relative" === e && s.navContainer
            ? this._controls[e].html("")
            : this._controls[e].remove();
        for (n in this.overides) this._core[n] = this._overrides[n];
        for (i in Object.getOwnPropertyNames(this))
          "function" != typeof this[i] && (this[i] = null);
      }),
      (s.prototype.update = function () {
        var t,
          e,
          i = this._core.clones().length / 2,
          n = i + this._core.items().length,
          s = this._core.maximum(!0),
          o = this._core.settings,
          r = o.center || o.autoWidth || o.dotsData ? 1 : o.dotsEach || o.items;
        if (
          ("page" !== o.slideBy && (o.slideBy = Math.min(o.slideBy, o.items)),
          o.dots || "page" == o.slideBy)
        )
          for (this._pages = [], t = i, e = 0, 0; t < n; t++) {
            if (e >= r || 0 === e) {
              if (
                (this._pages.push({
                  start: Math.min(s, t - i),
                  end: t - i + r - 1,
                }),
                Math.min(s, t - i) === s)
              )
                break;
              (e = 0), 0;
            }
            e += this._core.mergers(this._core.relative(t));
          }
      }),
      (s.prototype.draw = function () {
        var e,
          i = this._core.settings,
          n = this._core.items().length <= i.items,
          s = this._core.relative(this._core.current()),
          o = i.loop || i.rewind;
        this._controls.$relative.toggleClass("disabled", !i.nav || n),
          i.nav &&
            (this._controls.$previous.toggleClass(
              "disabled",
              !o && s <= this._core.minimum(!0)
            ),
            this._controls.$next.toggleClass(
              "disabled",
              !o && s >= this._core.maximum(!0)
            )),
          this._controls.$absolute.toggleClass("disabled", !i.dots || n),
          i.dots &&
            ((e =
              this._pages.length - this._controls.$absolute.children().length),
            i.dotsData && 0 !== e
              ? this._controls.$absolute.html(this._templates.join(""))
              : e > 0
              ? this._controls.$absolute.append(
                  new Array(e + 1).join(this._templates[0])
                )
              : e < 0 && this._controls.$absolute.children().slice(e).remove(),
            this._controls.$absolute.find(".active").removeClass("active"),
            this._controls.$absolute
              .children()
              .eq(t.inArray(this.current(), this._pages))
              .addClass("active"));
      }),
      (s.prototype.onTrigger = function (e) {
        var i = this._core.settings;
        e.page = {
          index: t.inArray(this.current(), this._pages),
          count: this._pages.length,
          size:
            i &&
            (i.center || i.autoWidth || i.dotsData ? 1 : i.dotsEach || i.items),
        };
      }),
      (s.prototype.current = function () {
        var e = this._core.relative(this._core.current());
        return t
          .grep(
            this._pages,
            t.proxy(function (t, i) {
              return t.start <= e && t.end >= e;
            }, this)
          )
          .pop();
      }),
      (s.prototype.getPosition = function (e) {
        var i,
          n,
          s = this._core.settings;
        return (
          "page" == s.slideBy
            ? ((i = t.inArray(this.current(), this._pages)),
              (n = this._pages.length),
              e ? ++i : --i,
              (i = this._pages[((i % n) + n) % n].start))
            : ((i = this._core.relative(this._core.current())),
              (n = this._core.items().length),
              e ? (i += s.slideBy) : (i -= s.slideBy)),
          i
        );
      }),
      (s.prototype.next = function (e) {
        t.proxy(this._overrides.to, this._core)(this.getPosition(!0), e);
      }),
      (s.prototype.prev = function (e) {
        t.proxy(this._overrides.to, this._core)(this.getPosition(!1), e);
      }),
      (s.prototype.to = function (e, i, n) {
        var s;
        !n && this._pages.length
          ? ((s = this._pages.length),
            t.proxy(this._overrides.to, this._core)(
              this._pages[((e % s) + s) % s].start,
              i
            ))
          : t.proxy(this._overrides.to, this._core)(e, i);
      }),
      (t.fn.owlCarousel.Constructor.Plugins.Navigation = s);
  })(window.Zepto || window.jQuery, window, document),
  (function (t, e, i, n) {
    "use strict";
    var s = function (i) {
      (this._core = i),
        (this._hashes = {}),
        (this.$element = this._core.$element),
        (this._handlers = {
          "initialized.owl.carousel": t.proxy(function (i) {
            i.namespace &&
              "URLHash" === this._core.settings.startPosition &&
              t(e).trigger("hashchange.owl.navigation");
          }, this),
          "prepared.owl.carousel": t.proxy(function (e) {
            if (e.namespace) {
              var i = t(e.content)
                .find("[data-hash]")
                .addBack("[data-hash]")
                .attr("data-hash");
              if (!i) return;
              this._hashes[i] = e.content;
            }
          }, this),
          "changed.owl.carousel": t.proxy(function (i) {
            if (i.namespace && "position" === i.property.name) {
              var n = this._core.items(
                  this._core.relative(this._core.current())
                ),
                s = t
                  .map(this._hashes, function (t, e) {
                    return t === n ? e : null;
                  })
                  .join();
              if (!s || e.location.hash.slice(1) === s) return;
              e.location.hash = s;
            }
          }, this),
        }),
        (this._core.options = t.extend({}, s.Defaults, this._core.options)),
        this.$element.on(this._handlers),
        t(e).on(
          "hashchange.owl.navigation",
          t.proxy(function (t) {
            var i = e.location.hash.substring(1),
              n = this._core.$stage.children(),
              s = this._hashes[i] && n.index(this._hashes[i]);
            void 0 !== s &&
              s !== this._core.current() &&
              this._core.to(this._core.relative(s), !1, !0);
          }, this)
        );
    };
    (s.Defaults = { URLhashListener: !1 }),
      (s.prototype.destroy = function () {
        var i, n;
        for (i in (t(e).off("hashchange.owl.navigation"), this._handlers))
          this._core.$element.off(i, this._handlers[i]);
        for (n in Object.getOwnPropertyNames(this))
          "function" != typeof this[n] && (this[n] = null);
      }),
      (t.fn.owlCarousel.Constructor.Plugins.Hash = s);
  })(window.Zepto || window.jQuery, window, document),
  (function (t, e, i, n) {
    function s(e, i) {
      var s = !1,
        o = e.charAt(0).toUpperCase() + e.slice(1);
      return (
        t.each((e + " " + a.join(o + " ") + o).split(" "), function (t, e) {
          if (r[e] !== n) return (s = !i || e), !1;
        }),
        s
      );
    }
    function o(t) {
      return s(t, !0);
    }
    var r = t("<support>").get(0).style,
      a = "Webkit Moz O ms".split(" "),
      l = {
        transition: {
          end: {
            WebkitTransition: "webkitTransitionEnd",
            MozTransition: "transitionend",
            OTransition: "oTransitionEnd",
            transition: "transitionend",
          },
        },
        animation: {
          end: {
            WebkitAnimation: "webkitAnimationEnd",
            MozAnimation: "animationend",
            OAnimation: "oAnimationEnd",
            animation: "animationend",
          },
        },
      },
      h = function () {
        return !!s("transform");
      },
      c = function () {
        return !!s("perspective");
      },
      u = function () {
        return !!s("animation");
      };
    (function () {
      return !!s("transition");
    })() &&
      ((t.support.transition = new String(o("transition"))),
      (t.support.transition.end = l.transition.end[t.support.transition])),
      u() &&
        ((t.support.animation = new String(o("animation"))),
        (t.support.animation.end = l.animation.end[t.support.animation])),
      h() &&
        ((t.support.transform = new String(o("transform"))),
        (t.support.transform3d = c()));
  })(window.Zepto || window.jQuery, window, document),
  (function (t) {
    "function" == typeof define && define.amd
      ? define(["jquery"], t)
      : "object" == typeof exports
      ? (module.exports = t(require("jquery")))
      : t(jQuery);
  })(function (t) {
    var e = /\+/g;
    function i(t) {
      return o.raw ? t : encodeURIComponent(t);
    }
    function n(t) {
      return i(o.json ? JSON.stringify(t) : String(t));
    }
    function s(i, n) {
      var s = o.raw
        ? i
        : (function (t) {
            0 === t.indexOf('"') &&
              (t = t.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\"));
            try {
              return (
                (t = decodeURIComponent(t.replace(e, " "))),
                o.json ? JSON.parse(t) : t
              );
            } catch (t) {}
          })(i);
      return t.isFunction(n) ? n(s) : s;
    }
    var o = (t.cookie = function (e, r, a) {
      if (arguments.length > 1 && !t.isFunction(r)) {
        if ("number" == typeof (a = t.extend({}, o.defaults, a)).expires) {
          var l = a.expires,
            h = (a.expires = new Date());
          h.setMilliseconds(h.getMilliseconds() + 864e5 * l);
        }
        return (document.cookie = [
          i(e),
          "=",
          n(r),
          a.expires ? "; expires=" + a.expires.toUTCString() : "",
          a.path ? "; path=" + a.path : "",
          a.domain ? "; domain=" + a.domain : "",
          a.secure ? "; secure" : "",
        ].join(""));
      }
      for (
        var c,
          u = e ? void 0 : {},
          d = document.cookie ? document.cookie.split("; ") : [],
          p = 0,
          f = d.length;
        p < f;
        p++
      ) {
        var m = d[p].split("="),
          g = ((c = m.shift()), o.raw ? c : decodeURIComponent(c)),
          v = m.join("=");
        if (e === g) {
          u = s(v, r);
          break;
        }
        e || void 0 === (v = s(v)) || (u[g] = v);
      }
      return u;
    });
    (o.defaults = {}),
      (t.removeCookie = function (e, i) {
        return t.cookie(e, "", t.extend({}, i, { expires: -1 })), !t.cookie(e);
      });
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(e)
      : "object" == typeof exports
      ? (module.exports = e())
      : (t.PhotoSwipe = e());
  })(this, function () {
    "use strict";
    return function (t, e, i, n) {
      var s = {
        features: null,
        bind: function (t, e, i, n) {
          var s = (n ? "remove" : "add") + "EventListener";
          e = e.split(" ");
          for (var o = 0; o < e.length; o++) e[o] && t[s](e[o], i, !1);
        },
        isArray: function (t) {
          return t instanceof Array;
        },
        createEl: function (t, e) {
          var i = document.createElement(e || "div");
          return t && (i.className = t), i;
        },
        getScrollY: function () {
          var t = window.pageYOffset;
          return void 0 !== t ? t : document.documentElement.scrollTop;
        },
        unbind: function (t, e, i) {
          s.bind(t, e, i, !0);
        },
        removeClass: function (t, e) {
          var i = new RegExp("(\\s|^)" + e + "(\\s|$)");
          t.className = t.className
            .replace(i, " ")
            .replace(/^\s\s*/, "")
            .replace(/\s\s*$/, "");
        },
        addClass: function (t, e) {
          s.hasClass(t, e) || (t.className += (t.className ? " " : "") + e);
        },
        hasClass: function (t, e) {
          return (
            t.className &&
            new RegExp("(^|\\s)" + e + "(\\s|$)").test(t.className)
          );
        },
        getChildByClass: function (t, e) {
          for (var i = t.firstChild; i; ) {
            if (s.hasClass(i, e)) return i;
            i = i.nextSibling;
          }
        },
        arraySearch: function (t, e, i) {
          for (var n = t.length; n--; ) if (t[n][i] === e) return n;
          return -1;
        },
        extend: function (t, e, i) {
          for (var n in e)
            if (e.hasOwnProperty(n)) {
              if (i && t.hasOwnProperty(n)) continue;
              t[n] = e[n];
            }
        },
        easing: {
          sine: {
            out: function (t) {
              return Math.sin(t * (Math.PI / 2));
            },
            inOut: function (t) {
              return -(Math.cos(Math.PI * t) - 1) / 2;
            },
          },
          cubic: {
            out: function (t) {
              return --t * t * t + 1;
            },
          },
        },
        detectFeatures: function () {
          if (s.features) return s.features;
          var t = s.createEl().style,
            e = "",
            i = {};
          if (
            ((i.oldIE = document.all && !document.addEventListener),
            (i.touch = "ontouchstart" in window),
            window.requestAnimationFrame &&
              ((i.raf = window.requestAnimationFrame),
              (i.caf = window.cancelAnimationFrame)),
            (i.pointerEvent =
              !!window.PointerEvent || navigator.msPointerEnabled),
            !i.pointerEvent)
          ) {
            var n = navigator.userAgent;
            if (/iP(hone|od)/.test(navigator.platform)) {
              var o = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
              o &&
                o.length > 0 &&
                (o = parseInt(o[1], 10)) >= 1 &&
                o < 8 &&
                (i.isOldIOSPhone = !0);
            }
            var r = n.match(/Android\s([0-9\.]*)/),
              a = r ? r[1] : 0;
            (a = parseFloat(a)) >= 1 &&
              (a < 4.4 && (i.isOldAndroid = !0), (i.androidVersion = a)),
              (i.isMobileOpera = /opera mini|opera mobi/i.test(n));
          }
          for (
            var l,
              h,
              c = ["transform", "perspective", "animationName"],
              u = ["", "webkit", "Moz", "ms", "O"],
              d = 0;
            d < 4;
            d++
          ) {
            e = u[d];
            for (var p = 0; p < 3; p++)
              (l = c[p]),
                (h = e + (e ? l.charAt(0).toUpperCase() + l.slice(1) : l)),
                !i[l] && h in t && (i[l] = h);
            e &&
              !i.raf &&
              ((e = e.toLowerCase()),
              (i.raf = window[e + "RequestAnimationFrame"]),
              i.raf &&
                (i.caf =
                  window[e + "CancelAnimationFrame"] ||
                  window[e + "CancelRequestAnimationFrame"]));
          }
          if (!i.raf) {
            var f = 0;
            (i.raf = function (t) {
              var e = new Date().getTime(),
                i = Math.max(0, 16 - (e - f)),
                n = window.setTimeout(function () {
                  t(e + i);
                }, i);
              return (f = e + i), n;
            }),
              (i.caf = function (t) {
                clearTimeout(t);
              });
          }
          return (
            (i.svg =
              !!document.createElementNS &&
              !!document.createElementNS("http://www.w3.org/2000/svg", "svg")
                .createSVGRect),
            (s.features = i),
            i
          );
        },
      };
      s.detectFeatures(),
        s.features.oldIE &&
          (s.bind = function (t, e, i, n) {
            e = e.split(" ");
            for (
              var s,
                o = (n ? "detach" : "attach") + "Event",
                r = function () {
                  i.handleEvent.call(i);
                },
                a = 0;
              a < e.length;
              a++
            )
              if ((s = e[a]))
                if ("object" == typeof i && i.handleEvent) {
                  if (n) {
                    if (!i["oldIE" + s]) return !1;
                  } else i["oldIE" + s] = r;
                  t[o]("on" + s, i["oldIE" + s]);
                } else t[o]("on" + s, i);
          });
      var o = this,
        r = {
          allowPanToNext: !0,
          spacing: 0.12,
          bgOpacity: 1,
          mouseUsed: !1,
          loop: !0,
          pinchToClose: !0,
          closeOnScroll: !0,
          closeOnVerticalDrag: !0,
          verticalDragRange: 0.75,
          hideAnimationDuration: 333,
          showAnimationDuration: 333,
          showHideOpacity: !1,
          focus: !0,
          escKey: !0,
          arrowKeys: !0,
          mainScrollEndFriction: 0.35,
          panEndFriction: 0.35,
          isClickableElement: function (t) {
            return "A" === t.tagName;
          },
          getDoubleTapZoom: function (t, e) {
            return t ? 1 : e.initialZoomLevel < 0.7 ? 1 : 1.33;
          },
          maxSpreadZoom: 1.33,
          modal: !0,
          scaleMode: "fit",
        };
      s.extend(r, n);
      var a,
        l,
        h,
        c,
        u,
        d,
        p,
        f,
        m,
        g,
        v,
        _,
        y,
        b,
        w,
        x,
        C,
        k,
        T,
        D,
        I,
        E,
        S,
        A,
        P,
        O,
        M,
        z,
        $,
        N,
        H,
        W,
        F,
        L,
        R,
        j,
        B,
        q,
        U,
        Y,
        V,
        K,
        Q,
        Z,
        G,
        X,
        J,
        tt,
        et,
        it,
        nt,
        st,
        ot,
        rt,
        at,
        lt,
        ht = { x: 0, y: 0 },
        ct = { x: 0, y: 0 },
        ut = { x: 0, y: 0 },
        dt = {},
        pt = 0,
        ft = {},
        mt = { x: 0, y: 0 },
        gt = 0,
        vt = !0,
        _t = [],
        yt = {},
        bt = !1,
        wt = function (t, e) {
          s.extend(o, e.publicMethods), _t.push(t);
        },
        xt = function (t) {
          var e = Re();
          return t > e - 1 ? t - e : t < 0 ? e + t : t;
        },
        Ct = {},
        kt = function (t, e) {
          return Ct[t] || (Ct[t] = []), Ct[t].push(e);
        },
        Tt = function (t) {
          var e = Ct[t];
          if (e) {
            var i = Array.prototype.slice.call(arguments);
            i.shift();
            for (var n = 0; n < e.length; n++) e[n].apply(o, i);
          }
        },
        Dt = function () {
          return new Date().getTime();
        },
        It = function (t) {
          (rt = t), (o.bg.style.opacity = t * r.bgOpacity);
        },
        Et = function (t, e, i, n, s) {
          (!bt || (s && s !== o.currItem)) &&
            (n /= s ? s.fitRatio : o.currItem.fitRatio),
            (t[E] = _ + e + "px, " + i + "px" + y + " scale(" + n + ")");
        },
        St = function (t) {
          et &&
            (t &&
              (g > o.currItem.fitRatio
                ? bt || (Ze(o.currItem, !1, !0), (bt = !0))
                : bt && (Ze(o.currItem), (bt = !1))),
            Et(et, ut.x, ut.y, g));
        },
        At = function (t) {
          t.container &&
            Et(
              t.container.style,
              t.initialPosition.x,
              t.initialPosition.y,
              t.initialZoomLevel,
              t
            );
        },
        Pt = function (t, e) {
          e[E] = _ + t + "px, 0px" + y;
        },
        Ot = function (t, e) {
          if (!r.loop && e) {
            var i = c + (mt.x * pt - t) / mt.x,
              n = Math.round(t - ce.x);
            ((i < 0 && n > 0) || (i >= Re() - 1 && n < 0)) &&
              (t = ce.x + n * r.mainScrollEndFriction);
          }
          (ce.x = t), Pt(t, u);
        },
        Mt = function (t, e) {
          var i = ue[t] - ft[t];
          return ct[t] + ht[t] + i - i * (e / v);
        },
        zt = function (t, e) {
          (t.x = e.x), (t.y = e.y), e.id && (t.id = e.id);
        },
        $t = function (t) {
          (t.x = Math.round(t.x)), (t.y = Math.round(t.y));
        },
        Nt = null,
        Ht = function () {
          Nt &&
            (s.unbind(document, "mousemove", Ht),
            s.addClass(t, "pswp--has_mouse"),
            (r.mouseUsed = !0),
            Tt("mouseUsed")),
            (Nt = setTimeout(function () {
              Nt = null;
            }, 100));
        },
        Wt = function (t, e) {
          var i = Ye(o.currItem, dt, t);
          return e && (tt = i), i;
        },
        Ft = function (t) {
          return t || (t = o.currItem), t.initialZoomLevel;
        },
        Lt = function (t) {
          return t || (t = o.currItem), t.w > 0 ? r.maxSpreadZoom : 1;
        },
        Rt = function (t, e, i, n) {
          return n === o.currItem.initialZoomLevel
            ? ((i[t] = o.currItem.initialPosition[t]), !0)
            : ((i[t] = Mt(t, n)),
              i[t] > e.min[t]
                ? ((i[t] = e.min[t]), !0)
                : i[t] < e.max[t] && ((i[t] = e.max[t]), !0));
        },
        jt = function (t) {
          var e = "";
          r.escKey && 27 === t.keyCode
            ? (e = "close")
            : r.arrowKeys &&
              (37 === t.keyCode
                ? (e = "prev")
                : 39 === t.keyCode && (e = "next")),
            e &&
              (t.ctrlKey ||
                t.altKey ||
                t.shiftKey ||
                t.metaKey ||
                (t.preventDefault ? t.preventDefault() : (t.returnValue = !1),
                o[e]()));
        },
        Bt = function (t) {
          t && (K || V || it || B) && (t.preventDefault(), t.stopPropagation());
        },
        qt = function () {
          o.setScrollOffset(0, s.getScrollY());
        },
        Ut = {},
        Yt = 0,
        Vt = function (t) {
          Ut[t] && (Ut[t].raf && O(Ut[t].raf), Yt--, delete Ut[t]);
        },
        Kt = function (t) {
          Ut[t] && Vt(t), Ut[t] || (Yt++, (Ut[t] = {}));
        },
        Qt = function () {
          for (var t in Ut) Ut.hasOwnProperty(t) && Vt(t);
        },
        Zt = function (t, e, i, n, s, o, r) {
          var a,
            l = Dt();
          Kt(t);
          var h = function () {
            if (Ut[t]) {
              if ((a = Dt() - l) >= n) return Vt(t), o(i), void (r && r());
              o((i - e) * s(a / n) + e), (Ut[t].raf = P(h));
            }
          };
          h();
        },
        Gt = {
          shout: Tt,
          listen: kt,
          viewportSize: dt,
          options: r,
          isMainScrollAnimating: function () {
            return it;
          },
          getZoomLevel: function () {
            return g;
          },
          getCurrentIndex: function () {
            return c;
          },
          isDragging: function () {
            return U;
          },
          isZooming: function () {
            return X;
          },
          setScrollOffset: function (t, e) {
            (ft.x = t), (N = ft.y = e), Tt("updateScrollOffset", ft);
          },
          applyZoomPan: function (t, e, i, n) {
            (ut.x = e), (ut.y = i), (g = t), St(n);
          },
          init: function () {
            if (!a && !l) {
              var i;
              (o.framework = s),
                (o.template = t),
                (o.bg = s.getChildByClass(t, "pswp__bg")),
                (M = t.className),
                (a = !0),
                (H = s.detectFeatures()),
                (P = H.raf),
                (O = H.caf),
                (E = H.transform),
                ($ = H.oldIE),
                (o.scrollWrap = s.getChildByClass(t, "pswp__scroll-wrap")),
                (o.container = s.getChildByClass(
                  o.scrollWrap,
                  "pswp__container"
                )),
                (u = o.container.style),
                (o.itemHolders = x =
                  [
                    { el: o.container.children[0], wrap: 0, index: -1 },
                    { el: o.container.children[1], wrap: 0, index: -1 },
                    { el: o.container.children[2], wrap: 0, index: -1 },
                  ]),
                (x[0].el.style.display = x[2].el.style.display = "none"),
                (function () {
                  if (E) {
                    var e = H.perspective && !A;
                    return (
                      (_ = "translate" + (e ? "3d(" : "(")),
                      void (y = H.perspective ? ", 0px)" : ")")
                    );
                  }
                  (E = "left"),
                    s.addClass(t, "pswp--ie"),
                    (Pt = function (t, e) {
                      e.left = t + "px";
                    }),
                    (At = function (t) {
                      var e = t.fitRatio > 1 ? 1 : t.fitRatio,
                        i = t.container.style,
                        n = e * t.w,
                        s = e * t.h;
                      (i.width = n + "px"),
                        (i.height = s + "px"),
                        (i.left = t.initialPosition.x + "px"),
                        (i.top = t.initialPosition.y + "px");
                    }),
                    (St = function () {
                      if (et) {
                        var t = et,
                          e = o.currItem,
                          i = e.fitRatio > 1 ? 1 : e.fitRatio,
                          n = i * e.w,
                          s = i * e.h;
                        (t.width = n + "px"),
                          (t.height = s + "px"),
                          (t.left = ut.x + "px"),
                          (t.top = ut.y + "px");
                      }
                    });
                })(),
                (m = {
                  resize: o.updateSize,
                  orientationchange: function () {
                    clearTimeout(W),
                      (W = setTimeout(function () {
                        dt.x !== o.scrollWrap.clientWidth && o.updateSize();
                      }, 500));
                  },
                  scroll: qt,
                  keydown: jt,
                  click: Bt,
                });
              var n = H.isOldIOSPhone || H.isOldAndroid || H.isMobileOpera;
              for (
                (H.animationName && H.transform && !n) ||
                  (r.showAnimationDuration = r.hideAnimationDuration = 0),
                  i = 0;
                i < _t.length;
                i++
              )
                o["init" + _t[i]]();
              e && (o.ui = new e(o, s)).init(),
                Tt("firstUpdate"),
                (c = c || r.index || 0),
                (isNaN(c) || c < 0 || c >= Re()) && (c = 0),
                (o.currItem = Le(c)),
                (H.isOldIOSPhone || H.isOldAndroid) && (vt = !1),
                t.setAttribute("aria-hidden", "false"),
                r.modal &&
                  (vt
                    ? (t.style.position = "fixed")
                    : ((t.style.position = "absolute"),
                      (t.style.top = s.getScrollY() + "px"))),
                void 0 === N && (Tt("initialLayout"), (N = z = s.getScrollY()));
              var h = "pswp--open ";
              for (
                r.mainClass && (h += r.mainClass + " "),
                  r.showHideOpacity && (h += "pswp--animate_opacity "),
                  h += A ? "pswp--touch" : "pswp--notouch",
                  h += H.animationName ? " pswp--css_animation" : "",
                  h += H.svg ? " pswp--svg" : "",
                  s.addClass(t, h),
                  o.updateSize(),
                  d = -1,
                  gt = null,
                  i = 0;
                i < 3;
                i++
              )
                Pt((i + d) * mt.x, x[i].el.style);
              $ || s.bind(o.scrollWrap, f, o),
                kt("initialZoomInEnd", function () {
                  o.setContent(x[0], c - 1),
                    o.setContent(x[2], c + 1),
                    (x[0].el.style.display = x[2].el.style.display = "block"),
                    r.focus && t.focus(),
                    s.bind(document, "keydown", o),
                    H.transform && s.bind(o.scrollWrap, "click", o),
                    r.mouseUsed || s.bind(document, "mousemove", Ht),
                    s.bind(window, "resize scroll orientationchange", o),
                    Tt("bindEvents");
                }),
                o.setContent(x[1], c),
                o.updateCurrItem(),
                Tt("afterInit"),
                vt ||
                  (b = setInterval(function () {
                    Yt ||
                      U ||
                      X ||
                      g !== o.currItem.initialZoomLevel ||
                      o.updateSize();
                  }, 1e3)),
                s.addClass(t, "pswp--visible");
            }
          },
          close: function () {
            a &&
              ((a = !1),
              (l = !0),
              Tt("close"),
              s.unbind(window, "resize scroll orientationchange", o),
              s.unbind(window, "scroll", m.scroll),
              s.unbind(document, "keydown", o),
              s.unbind(document, "mousemove", Ht),
              H.transform && s.unbind(o.scrollWrap, "click", o),
              U && s.unbind(window, p, o),
              clearTimeout(W),
              Tt("unbindEvents"),
              je(o.currItem, null, !0, o.destroy));
          },
          destroy: function () {
            Tt("destroy"),
              Ne && clearTimeout(Ne),
              t.setAttribute("aria-hidden", "true"),
              (t.className = M),
              b && clearInterval(b),
              s.unbind(o.scrollWrap, f, o),
              s.unbind(window, "scroll", o),
              fe(),
              Qt(),
              (Ct = null);
          },
          panTo: function (t, e, i) {
            i ||
              (t > tt.min.x ? (t = tt.min.x) : t < tt.max.x && (t = tt.max.x),
              e > tt.min.y ? (e = tt.min.y) : e < tt.max.y && (e = tt.max.y)),
              (ut.x = t),
              (ut.y = e),
              St();
          },
          handleEvent: function (t) {
            (t = t || window.event), m[t.type] && m[t.type](t);
          },
          goTo: function (t) {
            var e = (t = xt(t)) - c;
            (gt = e),
              (c = t),
              (o.currItem = Le(c)),
              (pt -= e),
              Ot(mt.x * pt),
              Qt(),
              (it = !1),
              o.updateCurrItem();
          },
          next: function () {
            o.goTo(c + 1);
          },
          prev: function () {
            o.goTo(c - 1);
          },
          updateCurrZoomItem: function (t) {
            if ((t && Tt("beforeChange", 0), x[1].el.children.length)) {
              var e = x[1].el.children[0];
              et = s.hasClass(e, "pswp__zoom-wrap") ? e.style : null;
            } else et = null;
            (tt = o.currItem.bounds),
              (v = g = o.currItem.initialZoomLevel),
              (ut.x = tt.center.x),
              (ut.y = tt.center.y),
              t && Tt("afterChange");
          },
          invalidateCurrItems: function () {
            w = !0;
            for (var t = 0; t < 3; t++)
              x[t].item && (x[t].item.needsUpdate = !0);
          },
          updateCurrItem: function (t) {
            if (0 !== gt) {
              var e,
                i = Math.abs(gt);
              if (!(t && i < 2)) {
                (o.currItem = Le(c)),
                  (bt = !1),
                  Tt("beforeChange", gt),
                  i >= 3 && ((d += gt + (gt > 0 ? -3 : 3)), (i = 3));
                for (var n = 0; n < i; n++)
                  gt > 0
                    ? ((e = x.shift()),
                      (x[2] = e),
                      Pt((++d + 2) * mt.x, e.el.style),
                      o.setContent(e, c - i + n + 1 + 1))
                    : ((e = x.pop()),
                      x.unshift(e),
                      Pt(--d * mt.x, e.el.style),
                      o.setContent(e, c + i - n - 1 - 1));
                if (et && 1 === Math.abs(gt)) {
                  var s = Le(C);
                  s.initialZoomLevel !== g && (Ye(s, dt), Ze(s), At(s));
                }
                (gt = 0), o.updateCurrZoomItem(), (C = c), Tt("afterChange");
              }
            }
          },
          updateSize: function (e) {
            if (!vt && r.modal) {
              var i = s.getScrollY();
              if (
                (N !== i && ((t.style.top = i + "px"), (N = i)),
                !e && yt.x === window.innerWidth && yt.y === window.innerHeight)
              )
                return;
              (yt.x = window.innerWidth),
                (yt.y = window.innerHeight),
                (t.style.height = yt.y + "px");
            }
            if (
              ((dt.x = o.scrollWrap.clientWidth),
              (dt.y = o.scrollWrap.clientHeight),
              qt(),
              (mt.x = dt.x + Math.round(dt.x * r.spacing)),
              (mt.y = dt.y),
              Ot(mt.x * pt),
              Tt("beforeResize"),
              void 0 !== d)
            ) {
              for (var n, a, l, h = 0; h < 3; h++)
                (n = x[h]),
                  Pt((h + d) * mt.x, n.el.style),
                  (l = c + h - 1),
                  r.loop && Re() > 2 && (l = xt(l)),
                  (a = Le(l)) && (w || a.needsUpdate || !a.bounds)
                    ? (o.cleanSlide(a),
                      o.setContent(n, l),
                      1 === h && ((o.currItem = a), o.updateCurrZoomItem(!0)),
                      (a.needsUpdate = !1))
                    : -1 === n.index && l >= 0 && o.setContent(n, l),
                  a && a.container && (Ye(a, dt), Ze(a), At(a));
              w = !1;
            }
            (v = g = o.currItem.initialZoomLevel),
              (tt = o.currItem.bounds) &&
                ((ut.x = tt.center.x), (ut.y = tt.center.y), St(!0)),
              Tt("resize");
          },
          zoomTo: function (t, e, i, n, o) {
            e &&
              ((v = g),
              (ue.x = Math.abs(e.x) - ut.x),
              (ue.y = Math.abs(e.y) - ut.y),
              zt(ct, ut));
            var r = Wt(t, !1),
              a = {};
            Rt("x", r, a, t), Rt("y", r, a, t);
            var l = g,
              h = ut.x,
              c = ut.y;
            $t(a);
            var u = function (e) {
              1 === e
                ? ((g = t), (ut.x = a.x), (ut.y = a.y))
                : ((g = (t - l) * e + l),
                  (ut.x = (a.x - h) * e + h),
                  (ut.y = (a.y - c) * e + c)),
                o && o(e),
                St(1 === e);
            };
            i ? Zt("customZoomTo", 0, 1, i, n || s.easing.sine.inOut, u) : u(1);
          },
        },
        Xt = {},
        Jt = {},
        te = {},
        ee = {},
        ie = {},
        ne = [],
        se = {},
        oe = [],
        re = {},
        ae = 0,
        le = { x: 0, y: 0 },
        he = 0,
        ce = { x: 0, y: 0 },
        ue = { x: 0, y: 0 },
        de = { x: 0, y: 0 },
        pe = function (t, e) {
          return (
            (re.x = Math.abs(t.x - e.x)),
            (re.y = Math.abs(t.y - e.y)),
            Math.sqrt(re.x * re.x + re.y * re.y)
          );
        },
        fe = function () {
          Q && (O(Q), (Q = null));
        },
        me = function () {
          U && ((Q = P(me)), Se());
        },
        ge = function (t, e) {
          return (
            !(!t || t === document) &&
            !(
              t.getAttribute("class") &&
              t.getAttribute("class").indexOf("pswp__scroll-wrap") > -1
            ) &&
            (e(t) ? t : ge(t.parentNode, e))
          );
        },
        ve = {},
        _e = function (t, e) {
          return (
            (ve.prevent = !ge(t.target, r.isClickableElement)),
            Tt("preventDragEvent", t, e, ve),
            ve.prevent
          );
        },
        ye = function (t, e) {
          return (e.x = t.pageX), (e.y = t.pageY), (e.id = t.identifier), e;
        },
        be = function (t, e, i) {
          (i.x = 0.5 * (t.x + e.x)), (i.y = 0.5 * (t.y + e.y));
        },
        we = function () {
          var t = ut.y - o.currItem.initialPosition.y;
          return 1 - Math.abs(t / (dt.y / 2));
        },
        xe = {},
        Ce = {},
        ke = [],
        Te = function (t) {
          for (; ke.length > 0; ) ke.pop();
          return (
            S
              ? ((lt = 0),
                ne.forEach(function (t) {
                  0 === lt ? (ke[0] = t) : 1 === lt && (ke[1] = t), lt++;
                }))
              : t.type.indexOf("touch") > -1
              ? t.touches &&
                t.touches.length > 0 &&
                ((ke[0] = ye(t.touches[0], xe)),
                t.touches.length > 1 && (ke[1] = ye(t.touches[1], Ce)))
              : ((xe.x = t.pageX),
                (xe.y = t.pageY),
                (xe.id = ""),
                (ke[0] = xe)),
            ke
          );
        },
        De = function (t, e) {
          var i,
            n,
            s,
            a,
            l = ut[t] + e[t],
            h = e[t] > 0,
            c = ce.x + e.x,
            u = ce.x - se.x;
          return (
            (i = l > tt.min[t] || l < tt.max[t] ? r.panEndFriction : 1),
            (l = ut[t] + e[t] * i),
            (!r.allowPanToNext && g !== o.currItem.initialZoomLevel) ||
            (et
              ? "h" !== nt ||
                "x" !== t ||
                V ||
                (h
                  ? (l > tt.min[t] &&
                      ((i = r.panEndFriction),
                      tt.min[t],
                      (n = tt.min[t] - ct[t])),
                    (n <= 0 || u < 0) && Re() > 1
                      ? ((a = c), u < 0 && c > se.x && (a = se.x))
                      : tt.min.x !== tt.max.x && (s = l))
                  : (l < tt.max[t] &&
                      ((i = r.panEndFriction),
                      tt.max[t],
                      (n = ct[t] - tt.max[t])),
                    (n <= 0 || u > 0) && Re() > 1
                      ? ((a = c), u > 0 && c < se.x && (a = se.x))
                      : tt.min.x !== tt.max.x && (s = l)))
              : (a = c),
            "x" !== t)
              ? void (
                  it ||
                  Z ||
                  (g > o.currItem.fitRatio && (ut[t] += e[t] * i))
                )
              : (void 0 !== a && (Ot(a, !0), (Z = a !== se.x)),
                tt.min.x !== tt.max.x &&
                  (void 0 !== s ? (ut.x = s) : Z || (ut.x += e.x * i)),
                void 0 !== a)
          );
        },
        Ie = function (t) {
          if (!("mousedown" === t.type && t.button > 0)) {
            if (Fe) return void t.preventDefault();
            if (!q || "mousedown" !== t.type) {
              if ((_e(t, !0) && t.preventDefault(), Tt("pointerDown"), S)) {
                var e = s.arraySearch(ne, t.pointerId, "id");
                e < 0 && (e = ne.length),
                  (ne[e] = { x: t.pageX, y: t.pageY, id: t.pointerId });
              }
              var i = Te(t),
                n = i.length;
              (G = null),
                Qt(),
                (U && 1 !== n) ||
                  ((U = st = !0),
                  s.bind(window, p, o),
                  (j = at = ot = B = Z = K = Y = V = !1),
                  (nt = null),
                  Tt("firstTouchStart", i),
                  zt(ct, ut),
                  (ht.x = ht.y = 0),
                  zt(ee, i[0]),
                  zt(ie, ee),
                  (se.x = mt.x * pt),
                  (oe = [{ x: ee.x, y: ee.y }]),
                  (L = F = Dt()),
                  Wt(g, !0),
                  fe(),
                  me()),
                !X &&
                  n > 1 &&
                  !it &&
                  !Z &&
                  ((v = g),
                  (V = !1),
                  (X = Y = !0),
                  (ht.y = ht.x = 0),
                  zt(ct, ut),
                  zt(Xt, i[0]),
                  zt(Jt, i[1]),
                  be(Xt, Jt, de),
                  (ue.x = Math.abs(de.x) - ut.x),
                  (ue.y = Math.abs(de.y) - ut.y),
                  (J = pe(Xt, Jt)));
            }
          }
        },
        Ee = function (t) {
          if ((t.preventDefault(), S)) {
            var e = s.arraySearch(ne, t.pointerId, "id");
            if (e > -1) {
              var i = ne[e];
              (i.x = t.pageX), (i.y = t.pageY);
            }
          }
          if (U) {
            var n = Te(t);
            if (nt || K || X) G = n;
            else if (ce.x !== mt.x * pt) nt = "h";
            else {
              var o = Math.abs(n[0].x - ee.x) - Math.abs(n[0].y - ee.y);
              Math.abs(o) >= 10 && ((nt = o > 0 ? "h" : "v"), (G = n));
            }
          }
        },
        Se = function () {
          if (G) {
            var t = G.length;
            if (0 !== t)
              if (
                (zt(Xt, G[0]),
                (te.x = Xt.x - ee.x),
                (te.y = Xt.y - ee.y),
                X && t > 1)
              ) {
                if (
                  ((ee.x = Xt.x),
                  (ee.y = Xt.y),
                  !te.x &&
                    !te.y &&
                    (function (t, e) {
                      return t.x === e.x && t.y === e.y;
                    })(G[1], Jt))
                )
                  return;
                zt(Jt, G[1]), V || ((V = !0), Tt("zoomGestureStarted"));
                var e = pe(Xt, Jt),
                  i = ze(e);
                i >
                  o.currItem.initialZoomLevel +
                    o.currItem.initialZoomLevel / 15 && (at = !0);
                var n = 1,
                  s = Ft(),
                  a = Lt();
                if (i < s)
                  if (
                    r.pinchToClose &&
                    !at &&
                    v <= o.currItem.initialZoomLevel
                  ) {
                    var l = 1 - (s - i) / (s / 1.2);
                    It(l), Tt("onPinchClose", l), (ot = !0);
                  } else
                    (n = (s - i) / s) > 1 && (n = 1), (i = s - n * (s / 3));
                else
                  i > a &&
                    ((n = (i - a) / (6 * s)) > 1 && (n = 1), (i = a + n * s));
                n < 0 && (n = 0),
                  be(Xt, Jt, le),
                  (ht.x += le.x - de.x),
                  (ht.y += le.y - de.y),
                  zt(de, le),
                  (ut.x = Mt("x", i)),
                  (ut.y = Mt("y", i)),
                  (j = i > g),
                  (g = i),
                  St();
              } else {
                if (!nt) return;
                if (
                  (st &&
                    ((st = !1),
                    Math.abs(te.x) >= 10 && (te.x -= G[0].x - ie.x),
                    Math.abs(te.y) >= 10 && (te.y -= G[0].y - ie.y)),
                  (ee.x = Xt.x),
                  (ee.y = Xt.y),
                  0 === te.x && 0 === te.y)
                )
                  return;
                if (
                  "v" === nt &&
                  r.closeOnVerticalDrag &&
                  "fit" === r.scaleMode &&
                  g === o.currItem.initialZoomLevel
                ) {
                  (ht.y += te.y), (ut.y += te.y);
                  var h = we();
                  return (B = !0), Tt("onVerticalDrag", h), It(h), void St();
                }
                (function (t, e, i) {
                  if (t - L > 50) {
                    var n = oe.length > 2 ? oe.shift() : {};
                    (n.x = e), (n.y = i), oe.push(n), (L = t);
                  }
                })(Dt(), Xt.x, Xt.y),
                  (K = !0),
                  (tt = o.currItem.bounds),
                  De("x", te) || (De("y", te), $t(ut), St());
              }
          }
        },
        Ae = function (t) {
          if (H.isOldAndroid) {
            if (q && "mouseup" === t.type) return;
            t.type.indexOf("touch") > -1 &&
              (clearTimeout(q),
              (q = setTimeout(function () {
                q = 0;
              }, 600)));
          }
          var e;
          if ((Tt("pointerUp"), _e(t, !1) && t.preventDefault(), S)) {
            var i = s.arraySearch(ne, t.pointerId, "id");
            i > -1 &&
              ((e = ne.splice(i, 1)[0]),
              navigator.msPointerEnabled
                ? ((e.type = { 4: "mouse", 2: "touch", 3: "pen" }[
                    t.pointerType
                  ]),
                  e.type || (e.type = t.pointerType || "mouse"))
                : (e.type = t.pointerType || "mouse"));
          }
          var n,
            a = Te(t),
            l = a.length;
          if (("mouseup" === t.type && (l = 0), 2 === l)) return (G = null), !0;
          1 === l && zt(ie, a[0]),
            0 !== l ||
              nt ||
              it ||
              (e ||
                ("mouseup" === t.type
                  ? (e = { x: t.pageX, y: t.pageY, type: "mouse" })
                  : t.changedTouches &&
                    t.changedTouches[0] &&
                    (e = {
                      x: t.changedTouches[0].pageX,
                      y: t.changedTouches[0].pageY,
                      type: "touch",
                    })),
              Tt("touchRelease", t, e));
          var h = -1;
          if (
            (0 === l &&
              ((U = !1),
              s.unbind(window, p, o),
              fe(),
              X ? (h = 0) : -1 !== he && (h = Dt() - he)),
            (he = 1 === l ? Dt() : -1),
            (n = -1 !== h && h < 150 ? "zoom" : "swipe"),
            X &&
              l < 2 &&
              ((X = !1),
              1 === l && (n = "zoomPointerUp"),
              Tt("zoomGestureEnded")),
            (G = null),
            K || V || it || B)
          )
            if ((Qt(), R || (R = Pe()), R.calculateSwipeSpeed("x"), B))
              if (we() < r.verticalDragRange) o.close();
              else {
                var c = ut.y,
                  u = rt;
                Zt("verticalDrag", 0, 1, 300, s.easing.cubic.out, function (t) {
                  (ut.y = (o.currItem.initialPosition.y - c) * t + c),
                    It((1 - u) * t + u),
                    St();
                }),
                  Tt("onVerticalDrag", 1);
              }
            else {
              if ((Z || it) && 0 === l) {
                if (Me(n, R)) return;
                n = "zoomPointerUp";
              }
              if (!it)
                return "swipe" !== n
                  ? void $e()
                  : void (!Z && g > o.currItem.fitRatio && Oe(R));
            }
        },
        Pe = function () {
          var t,
            e,
            i = {
              lastFlickOffset: {},
              lastFlickDist: {},
              lastFlickSpeed: {},
              slowDownRatio: {},
              slowDownRatioReverse: {},
              speedDecelerationRatio: {},
              speedDecelerationRatioAbs: {},
              distanceOffset: {},
              backAnimDestination: {},
              backAnimStarted: {},
              calculateSwipeSpeed: function (n) {
                oe.length > 1
                  ? ((t = Dt() - L + 50), (e = oe[oe.length - 2][n]))
                  : ((t = Dt() - F), (e = ie[n])),
                  (i.lastFlickOffset[n] = ee[n] - e),
                  (i.lastFlickDist[n] = Math.abs(i.lastFlickOffset[n])),
                  i.lastFlickDist[n] > 20
                    ? (i.lastFlickSpeed[n] = i.lastFlickOffset[n] / t)
                    : (i.lastFlickSpeed[n] = 0),
                  Math.abs(i.lastFlickSpeed[n]) < 0.1 &&
                    (i.lastFlickSpeed[n] = 0),
                  (i.slowDownRatio[n] = 0.95),
                  (i.slowDownRatioReverse[n] = 1 - i.slowDownRatio[n]),
                  (i.speedDecelerationRatio[n] = 1);
              },
              calculateOverBoundsAnimOffset: function (t, e) {
                i.backAnimStarted[t] ||
                  (ut[t] > tt.min[t]
                    ? (i.backAnimDestination[t] = tt.min[t])
                    : ut[t] < tt.max[t] &&
                      (i.backAnimDestination[t] = tt.max[t]),
                  void 0 !== i.backAnimDestination[t] &&
                    ((i.slowDownRatio[t] = 0.7),
                    (i.slowDownRatioReverse[t] = 1 - i.slowDownRatio[t]),
                    i.speedDecelerationRatioAbs[t] < 0.05 &&
                      ((i.lastFlickSpeed[t] = 0),
                      (i.backAnimStarted[t] = !0),
                      Zt(
                        "bounceZoomPan" + t,
                        ut[t],
                        i.backAnimDestination[t],
                        e || 300,
                        s.easing.sine.out,
                        function (e) {
                          (ut[t] = e), St();
                        }
                      ))));
              },
              calculateAnimOffset: function (t) {
                i.backAnimStarted[t] ||
                  ((i.speedDecelerationRatio[t] =
                    i.speedDecelerationRatio[t] *
                    (i.slowDownRatio[t] +
                      i.slowDownRatioReverse[t] -
                      (i.slowDownRatioReverse[t] * i.timeDiff) / 10)),
                  (i.speedDecelerationRatioAbs[t] = Math.abs(
                    i.lastFlickSpeed[t] * i.speedDecelerationRatio[t]
                  )),
                  (i.distanceOffset[t] =
                    i.lastFlickSpeed[t] *
                    i.speedDecelerationRatio[t] *
                    i.timeDiff),
                  (ut[t] += i.distanceOffset[t]));
              },
              panAnimLoop: function () {
                if (
                  Ut.zoomPan &&
                  ((Ut.zoomPan.raf = P(i.panAnimLoop)),
                  (i.now = Dt()),
                  (i.timeDiff = i.now - i.lastNow),
                  (i.lastNow = i.now),
                  i.calculateAnimOffset("x"),
                  i.calculateAnimOffset("y"),
                  St(),
                  i.calculateOverBoundsAnimOffset("x"),
                  i.calculateOverBoundsAnimOffset("y"),
                  i.speedDecelerationRatioAbs.x < 0.05 &&
                    i.speedDecelerationRatioAbs.y < 0.05)
                )
                  return (
                    (ut.x = Math.round(ut.x)),
                    (ut.y = Math.round(ut.y)),
                    St(),
                    void Vt("zoomPan")
                  );
              },
            };
          return i;
        },
        Oe = function (t) {
          return (
            t.calculateSwipeSpeed("y"),
            (tt = o.currItem.bounds),
            (t.backAnimDestination = {}),
            (t.backAnimStarted = {}),
            Math.abs(t.lastFlickSpeed.x) <= 0.05 &&
            Math.abs(t.lastFlickSpeed.y) <= 0.05
              ? ((t.speedDecelerationRatioAbs.x =
                  t.speedDecelerationRatioAbs.y =
                    0),
                t.calculateOverBoundsAnimOffset("x"),
                t.calculateOverBoundsAnimOffset("y"),
                !0)
              : (Kt("zoomPan"), (t.lastNow = Dt()), void t.panAnimLoop())
          );
        },
        Me = function (t, e) {
          var i, n, a;
          if ((it || (ae = c), "swipe" === t)) {
            var l = ee.x - ie.x,
              h = e.lastFlickDist.x < 10;
            l > 30 && (h || e.lastFlickOffset.x > 20)
              ? (n = -1)
              : l < -30 && (h || e.lastFlickOffset.x < -20) && (n = 1);
          }
          n &&
            ((c += n) < 0
              ? ((c = r.loop ? Re() - 1 : 0), (a = !0))
              : c >= Re() && ((c = r.loop ? 0 : Re() - 1), (a = !0)),
            (a && !r.loop) || ((gt += n), (pt -= n), (i = !0)));
          var u,
            d = mt.x * pt,
            p = Math.abs(d - ce.x);
          return (
            i || d > ce.x == e.lastFlickSpeed.x > 0
              ? ((u =
                  Math.abs(e.lastFlickSpeed.x) > 0
                    ? p / Math.abs(e.lastFlickSpeed.x)
                    : 333),
                (u = Math.min(u, 400)),
                (u = Math.max(u, 250)))
              : (u = 333),
            ae === c && (i = !1),
            (it = !0),
            Tt("mainScrollAnimStart"),
            Zt("mainScroll", ce.x, d, u, s.easing.cubic.out, Ot, function () {
              Qt(),
                (it = !1),
                (ae = -1),
                (i || ae !== c) && o.updateCurrItem(),
                Tt("mainScrollAnimComplete");
            }),
            i && o.updateCurrItem(!0),
            i
          );
        },
        ze = function (t) {
          return (1 / J) * t * v;
        },
        $e = function () {
          var t = g,
            e = Ft(),
            i = Lt();
          g < e ? (t = e) : g > i && (t = i);
          var n,
            r = rt;
          return ot && !j && !at && g < e
            ? (o.close(), !0)
            : (ot &&
                (n = function (t) {
                  It((1 - r) * t + r);
                }),
              o.zoomTo(t, 0, 200, s.easing.cubic.out, n),
              !0);
        };
      wt("Gestures", {
        publicMethods: {
          initGestures: function () {
            var t = function (t, e, i, n, s) {
              (k = t + e), (T = t + i), (D = t + n), (I = s ? t + s : "");
            };
            (S = H.pointerEvent) && H.touch && (H.touch = !1),
              S
                ? navigator.msPointerEnabled
                  ? t("MSPointer", "Down", "Move", "Up", "Cancel")
                  : t("pointer", "down", "move", "up", "cancel")
                : H.touch
                ? (t("touch", "start", "move", "end", "cancel"), (A = !0))
                : t("mouse", "down", "move", "up"),
              (p = T + " " + D + " " + I),
              (f = k),
              S &&
                !A &&
                (A =
                  navigator.maxTouchPoints > 1 ||
                  navigator.msMaxTouchPoints > 1),
              (o.likelyTouchDevice = A),
              (m[k] = Ie),
              (m[T] = Ee),
              (m[D] = Ae),
              I && (m[I] = m[D]),
              H.touch &&
                ((f += " mousedown"),
                (p += " mousemove mouseup"),
                (m.mousedown = m[k]),
                (m.mousemove = m[T]),
                (m.mouseup = m[D])),
              A || (r.allowPanToNext = !1);
          },
        },
      });
      var Ne,
        He,
        We,
        Fe,
        Le,
        Re,
        je = function (e, i, n, a) {
          var l;
          Ne && clearTimeout(Ne),
            (Fe = !0),
            (We = !0),
            e.initialLayout
              ? ((l = e.initialLayout), (e.initialLayout = null))
              : (l = r.getThumbBoundsFn && r.getThumbBoundsFn(c));
          var u = n ? r.hideAnimationDuration : r.showAnimationDuration,
            d = function () {
              Vt("initialZoom"),
                n
                  ? (o.template.removeAttribute("style"),
                    o.bg.removeAttribute("style"))
                  : (It(1),
                    i && (i.style.display = "block"),
                    s.addClass(t, "pswp--animated-in"),
                    Tt("initialZoom" + (n ? "OutEnd" : "InEnd"))),
                a && a(),
                (Fe = !1);
            };
          if (!u || !l || void 0 === l.x)
            return (
              Tt("initialZoom" + (n ? "Out" : "In")),
              (g = e.initialZoomLevel),
              zt(ut, e.initialPosition),
              St(),
              (t.style.opacity = n ? 0 : 1),
              It(1),
              void (u
                ? setTimeout(function () {
                    d();
                  }, u)
                : d())
            );
          !(function () {
            var i = h,
              a = !o.currItem.src || o.currItem.loadError || r.showHideOpacity;
            e.miniImg && (e.miniImg.style.webkitBackfaceVisibility = "hidden"),
              n ||
                ((g = l.w / e.w),
                (ut.x = l.x),
                (ut.y = l.y - z),
                (o[a ? "template" : "bg"].style.opacity = 0.001),
                St()),
              Kt("initialZoom"),
              n && !i && s.removeClass(t, "pswp--animated-in"),
              a &&
                (n
                  ? s[(i ? "remove" : "add") + "Class"](
                      t,
                      "pswp--animate_opacity"
                    )
                  : setTimeout(function () {
                      s.addClass(t, "pswp--animate_opacity");
                    }, 30)),
              (Ne = setTimeout(
                function () {
                  if ((Tt("initialZoom" + (n ? "Out" : "In")), n)) {
                    var o = l.w / e.w,
                      r = { x: ut.x, y: ut.y },
                      h = g,
                      c = rt,
                      p = function (e) {
                        1 === e
                          ? ((g = o), (ut.x = l.x), (ut.y = l.y - N))
                          : ((g = (o - h) * e + h),
                            (ut.x = (l.x - r.x) * e + r.x),
                            (ut.y = (l.y - N - r.y) * e + r.y)),
                          St(),
                          a ? (t.style.opacity = 1 - e) : It(c - e * c);
                      };
                    i
                      ? Zt("initialZoom", 0, 1, u, s.easing.cubic.out, p, d)
                      : (p(1), (Ne = setTimeout(d, u + 20)));
                  } else
                    (g = e.initialZoomLevel),
                      zt(ut, e.initialPosition),
                      St(),
                      It(1),
                      a ? (t.style.opacity = 1) : It(1),
                      (Ne = setTimeout(d, u + 20));
                },
                n ? 25 : 90
              ));
          })();
        },
        Be = {},
        qe = [],
        Ue = {
          index: 0,
          errorMsg:
            '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
          forceProgressiveLoading: !1,
          preload: [1, 1],
          getNumItemsFn: function () {
            return He.length;
          },
        },
        Ye = function (t, e, i) {
          if (t.src && !t.loadError) {
            var n = !i;
            if (
              (n &&
                (t.vGap || (t.vGap = { top: 0, bottom: 0 }),
                Tt("parseVerticalMargin", t)),
              (Be.x = e.x),
              (Be.y = e.y - t.vGap.top - t.vGap.bottom),
              n)
            ) {
              var s = Be.x / t.w,
                o = Be.y / t.h;
              t.fitRatio = s < o ? s : o;
              var a = r.scaleMode;
              "orig" === a ? (i = 1) : "fit" === a && (i = t.fitRatio),
                i > 1 && (i = 1),
                (t.initialZoomLevel = i),
                t.bounds ||
                  (t.bounds = {
                    center: { x: 0, y: 0 },
                    max: { x: 0, y: 0 },
                    min: { x: 0, y: 0 },
                  });
            }
            if (!i) return;
            return (
              (function (t, e, i) {
                var n = t.bounds;
                (n.center.x = Math.round((Be.x - e) / 2)),
                  (n.center.y = Math.round((Be.y - i) / 2) + t.vGap.top),
                  (n.max.x = e > Be.x ? Math.round(Be.x - e) : n.center.x),
                  (n.max.y =
                    i > Be.y ? Math.round(Be.y - i) + t.vGap.top : n.center.y),
                  (n.min.x = e > Be.x ? 0 : n.center.x),
                  (n.min.y = i > Be.y ? t.vGap.top : n.center.y);
              })(t, t.w * i, t.h * i),
              n &&
                i === t.initialZoomLevel &&
                (t.initialPosition = t.bounds.center),
              t.bounds
            );
          }
          return (
            (t.w = t.h = 0),
            (t.initialZoomLevel = t.fitRatio = 1),
            (t.bounds = {
              center: { x: 0, y: 0 },
              max: { x: 0, y: 0 },
              min: { x: 0, y: 0 },
            }),
            (t.initialPosition = t.bounds.center),
            t.bounds
          );
        },
        Ve = function (t, e, i, n, s, r) {
          e.loadError ||
            (n &&
              ((e.imageAppended = !0),
              Ze(e, n, e === o.currItem && bt),
              i.appendChild(n),
              r &&
                setTimeout(function () {
                  e &&
                    e.loaded &&
                    e.placeholder &&
                    ((e.placeholder.style.display = "none"),
                    (e.placeholder = null));
                }, 500)));
        },
        Ke = function (t) {
          (t.loading = !0), (t.loaded = !1);
          var e = (t.img = s.createEl("pswp__img", "img")),
            i = function () {
              (t.loading = !1),
                (t.loaded = !0),
                t.loadComplete ? t.loadComplete(t) : (t.img = null),
                (e.onload = e.onerror = null),
                (e = null);
            };
          return (
            (e.onload = i),
            (e.onerror = function () {
              (t.loadError = !0), i();
            }),
            (e.src = t.src),
            e
          );
        },
        Qe = function (t, e) {
          if (t.src && t.loadError && t.container)
            return (
              e && (t.container.innerHTML = ""),
              (t.container.innerHTML = r.errorMsg.replace("%url%", t.src)),
              !0
            );
        },
        Ze = function (t, e, i) {
          if (t.src) {
            e || (e = t.container.lastChild);
            var n = i ? t.w : Math.round(t.w * t.fitRatio),
              s = i ? t.h : Math.round(t.h * t.fitRatio);
            t.placeholder &&
              !t.loaded &&
              ((t.placeholder.style.width = n + "px"),
              (t.placeholder.style.height = s + "px")),
              (e.style.width = n + "px"),
              (e.style.height = s + "px");
          }
        },
        Ge = function () {
          if (qe.length) {
            for (var t, e = 0; e < qe.length; e++)
              (t = qe[e]).holder.index === t.index &&
                Ve(t.index, t.item, t.baseDiv, t.img, 0, t.clearPlaceholder);
            qe = [];
          }
        };
      wt("Controller", {
        publicMethods: {
          lazyLoadItem: function (t) {
            t = xt(t);
            var e = Le(t);
            e &&
              ((!e.loaded && !e.loading) || w) &&
              (Tt("gettingData", t, e), e.src && Ke(e));
          },
          initController: function () {
            s.extend(r, Ue, !0),
              (o.items = He = i),
              (Le = o.getItemAt),
              (Re = r.getNumItemsFn),
              r.loop,
              Re() < 3 && (r.loop = !1),
              kt("beforeChange", function (t) {
                var e,
                  i = r.preload,
                  n = null === t || t >= 0,
                  s = Math.min(i[0], Re()),
                  a = Math.min(i[1], Re());
                for (e = 1; e <= (n ? a : s); e++) o.lazyLoadItem(c + e);
                for (e = 1; e <= (n ? s : a); e++) o.lazyLoadItem(c - e);
              }),
              kt("initialLayout", function () {
                o.currItem.initialLayout =
                  r.getThumbBoundsFn && r.getThumbBoundsFn(c);
              }),
              kt("mainScrollAnimComplete", Ge),
              kt("initialZoomInEnd", Ge),
              kt("destroy", function () {
                for (var t, e = 0; e < He.length; e++)
                  (t = He[e]).container && (t.container = null),
                    t.placeholder && (t.placeholder = null),
                    t.img && (t.img = null),
                    t.preloader && (t.preloader = null),
                    t.loadError && (t.loaded = t.loadError = !1);
                qe = null;
              });
          },
          getItemAt: function (t) {
            return t >= 0 && void 0 !== He[t] && He[t];
          },
          allowProgressiveImg: function () {
            return (
              r.forceProgressiveLoading ||
              !A ||
              r.mouseUsed ||
              screen.width > 1200
            );
          },
          setContent: function (t, e) {
            r.loop && (e = xt(e));
            var i = o.getItemAt(t.index);
            i && (i.container = null);
            var n,
              l = o.getItemAt(e);
            if (l) {
              Tt("gettingData", e, l), (t.index = e), (t.item = l);
              var h = (l.container = s.createEl("pswp__zoom-wrap"));
              if (
                (!l.src &&
                  l.html &&
                  (l.html.tagName
                    ? h.appendChild(l.html)
                    : (h.innerHTML = l.html)),
                Qe(l),
                Ye(l, dt),
                !l.src || l.loadError || l.loaded)
              )
                l.src &&
                  !l.loadError &&
                  (((n = s.createEl("pswp__img", "img")).style.opacity = 1),
                  (n.src = l.src),
                  Ze(l, n),
                  Ve(0, l, h, n));
              else {
                if (
                  ((l.loadComplete = function (i) {
                    if (a) {
                      if (t && t.index === e) {
                        if (Qe(i, !0))
                          return (
                            (i.loadComplete = i.img = null),
                            Ye(i, dt),
                            At(i),
                            void (t.index === c && o.updateCurrZoomItem())
                          );
                        i.imageAppended
                          ? !Fe &&
                            i.placeholder &&
                            ((i.placeholder.style.display = "none"),
                            (i.placeholder = null))
                          : H.transform && (it || Fe)
                          ? qe.push({
                              item: i,
                              baseDiv: h,
                              img: i.img,
                              index: e,
                              holder: t,
                              clearPlaceholder: !0,
                            })
                          : Ve(0, i, h, i.img, 0, !0);
                      }
                      (i.loadComplete = null),
                        (i.img = null),
                        Tt("imageLoadComplete", e, i);
                    }
                  }),
                  s.features.transform)
                ) {
                  var u = "pswp__img pswp__img--placeholder";
                  u += l.msrc ? "" : " pswp__img--placeholder--blank";
                  var d = s.createEl(u, l.msrc ? "img" : "");
                  l.msrc && (d.src = l.msrc),
                    Ze(l, d),
                    h.appendChild(d),
                    (l.placeholder = d);
                }
                l.loading || Ke(l),
                  o.allowProgressiveImg() &&
                    (!We && H.transform
                      ? qe.push({
                          item: l,
                          baseDiv: h,
                          img: l.img,
                          index: e,
                          holder: t,
                        })
                      : Ve(0, l, h, l.img, 0, !0));
              }
              We || e !== c ? At(l) : ((et = h.style), je(l, n || l.img)),
                (t.el.innerHTML = ""),
                t.el.appendChild(h);
            } else t.el.innerHTML = "";
          },
          cleanSlide: function (t) {
            t.img && (t.img.onload = t.img.onerror = null),
              (t.loaded = t.loading = t.img = t.imageAppended = !1);
          },
        },
      });
      var Xe,
        Je,
        ti = {},
        ei = function (t, e, i) {
          var n = document.createEvent("CustomEvent"),
            s = {
              origEvent: t,
              target: t.target,
              releasePoint: e,
              pointerType: i || "touch",
            };
          n.initCustomEvent("pswpTap", !0, !0, s), t.target.dispatchEvent(n);
        };
      wt("Tap", {
        publicMethods: {
          initTap: function () {
            kt("firstTouchStart", o.onTapStart),
              kt("touchRelease", o.onTapRelease),
              kt("destroy", function () {
                (ti = {}), (Xe = null);
              });
          },
          onTapStart: function (t) {
            t.length > 1 && (clearTimeout(Xe), (Xe = null));
          },
          onTapRelease: function (t, e) {
            if (e && !K && !Y && !Yt) {
              var i = e;
              if (
                Xe &&
                (clearTimeout(Xe),
                (Xe = null),
                (function (t, e) {
                  return Math.abs(t.x - e.x) < 25 && Math.abs(t.y - e.y) < 25;
                })(i, ti))
              )
                return void Tt("doubleTap", i);
              if ("mouse" === e.type) return void ei(t, e, "mouse");
              if (
                "BUTTON" === t.target.tagName.toUpperCase() ||
                s.hasClass(t.target, "pswp__single-tap")
              )
                return void ei(t, e);
              zt(ti, i),
                (Xe = setTimeout(function () {
                  ei(t, e), (Xe = null);
                }, 300));
            }
          },
        },
      }),
        wt("DesktopZoom", {
          publicMethods: {
            initDesktopZoom: function () {
              $ ||
                (A
                  ? kt("mouseUsed", function () {
                      o.setupDesktopZoom();
                    })
                  : o.setupDesktopZoom(!0));
            },
            setupDesktopZoom: function (e) {
              Je = {};
              var i = "wheel mousewheel DOMMouseScroll";
              kt("bindEvents", function () {
                s.bind(t, i, o.handleMouseWheel);
              }),
                kt("unbindEvents", function () {
                  Je && s.unbind(t, i, o.handleMouseWheel);
                }),
                (o.mouseZoomedIn = !1);
              var n,
                r = function () {
                  o.mouseZoomedIn &&
                    (s.removeClass(t, "pswp--zoomed-in"),
                    (o.mouseZoomedIn = !1)),
                    g < 1
                      ? s.addClass(t, "pswp--zoom-allowed")
                      : s.removeClass(t, "pswp--zoom-allowed"),
                    a();
                },
                a = function () {
                  n && (s.removeClass(t, "pswp--dragging"), (n = !1));
                };
              kt("resize", r),
                kt("afterChange", r),
                kt("pointerDown", function () {
                  o.mouseZoomedIn &&
                    ((n = !0), s.addClass(t, "pswp--dragging"));
                }),
                kt("pointerUp", a),
                e || r();
            },
            handleMouseWheel: function (t) {
              if (g <= o.currItem.fitRatio)
                return (
                  r.modal &&
                    (!r.closeOnScroll || Yt || U
                      ? t.preventDefault()
                      : E && Math.abs(t.deltaY) > 2 && ((h = !0), o.close())),
                  !0
                );
              if ((t.stopPropagation(), (Je.x = 0), "deltaX" in t))
                1 === t.deltaMode
                  ? ((Je.x = 18 * t.deltaX), (Je.y = 18 * t.deltaY))
                  : ((Je.x = t.deltaX), (Je.y = t.deltaY));
              else if ("wheelDelta" in t)
                t.wheelDeltaX && (Je.x = -0.16 * t.wheelDeltaX),
                  t.wheelDeltaY
                    ? (Je.y = -0.16 * t.wheelDeltaY)
                    : (Je.y = -0.16 * t.wheelDelta);
              else {
                if (!("detail" in t)) return;
                Je.y = t.detail;
              }
              Wt(g, !0);
              var e = ut.x - Je.x,
                i = ut.y - Je.y;
              (r.modal ||
                (e <= tt.min.x &&
                  e >= tt.max.x &&
                  i <= tt.min.y &&
                  i >= tt.max.y)) &&
                t.preventDefault(),
                o.panTo(e, i);
            },
            toggleDesktopZoom: function (e) {
              e = e || { x: dt.x / 2 + ft.x, y: dt.y / 2 + ft.y };
              var i = r.getDoubleTapZoom(!0, o.currItem),
                n = g === i;
              (o.mouseZoomedIn = !n),
                o.zoomTo(n ? o.currItem.initialZoomLevel : i, e, 333),
                s[(n ? "remove" : "add") + "Class"](t, "pswp--zoomed-in");
            },
          },
        });
      var ii,
        ni,
        si,
        oi,
        ri,
        ai,
        li,
        hi,
        ci,
        ui,
        di,
        pi,
        fi = { history: !0, galleryUID: 1 },
        mi = function () {
          return di.hash.substring(1);
        },
        gi = function () {
          ii && clearTimeout(ii), si && clearTimeout(si);
        },
        vi = function () {
          var t = mi(),
            e = {};
          if (t.length < 5) return e;
          var i,
            n = t.split("&");
          for (i = 0; i < n.length; i++)
            if (n[i]) {
              var s = n[i].split("=");
              s.length < 2 || (e[s[0]] = s[1]);
            }
          if (r.galleryPIDs) {
            var o = e.pid;
            for (e.pid = 0, i = 0; i < He.length; i++)
              if (He[i].pid === o) {
                e.pid = i;
                break;
              }
          } else e.pid = parseInt(e.pid, 10) - 1;
          return e.pid < 0 && (e.pid = 0), e;
        },
        _i = function () {
          if ((si && clearTimeout(si), Yt || U)) si = setTimeout(_i, 500);
          else {
            oi ? clearTimeout(ni) : (oi = !0);
            var t = c + 1,
              e = Le(c);
            e.hasOwnProperty("pid") && (t = e.pid);
            var i = li + "&gid=" + r.galleryUID + "&pid=" + t;
            hi || (-1 === di.hash.indexOf(i) && (ui = !0));
            var n = di.href.split("#")[0] + "#" + i;
            pi
              ? "#" + i !== window.location.hash &&
                history[hi ? "replaceState" : "pushState"](
                  "",
                  document.title,
                  n
                )
              : hi
              ? di.replace(n)
              : (di.hash = i),
              (hi = !0),
              (ni = setTimeout(function () {
                oi = !1;
              }, 60));
          }
        };
      wt("History", {
        publicMethods: {
          initHistory: function () {
            if ((s.extend(r, fi, !0), r.history)) {
              (di = window.location),
                (ui = !1),
                (ci = !1),
                (hi = !1),
                (li = mi()),
                (pi = "pushState" in history),
                li.indexOf("gid=") > -1 &&
                  (li = (li = li.split("&gid=")[0]).split("?gid=")[0]),
                kt("afterChange", o.updateURL),
                kt("unbindEvents", function () {
                  s.unbind(window, "hashchange", o.onHashChange);
                });
              var t = function () {
                (ai = !0),
                  ci ||
                    (ui
                      ? history.back()
                      : li
                      ? (di.hash = li)
                      : pi
                      ? history.pushState(
                          "",
                          document.title,
                          di.pathname + di.search
                        )
                      : (di.hash = "")),
                  gi();
              };
              kt("unbindEvents", function () {
                h && t();
              }),
                kt("destroy", function () {
                  ai || t();
                }),
                kt("firstUpdate", function () {
                  c = vi().pid;
                });
              var e = li.indexOf("pid=");
              e > -1 &&
                "&" === (li = li.substring(0, e)).slice(-1) &&
                (li = li.slice(0, -1)),
                setTimeout(function () {
                  a && s.bind(window, "hashchange", o.onHashChange);
                }, 40);
            }
          },
          onHashChange: function () {
            return mi() === li
              ? ((ci = !0), void o.close())
              : void (oi || ((ri = !0), o.goTo(vi().pid), (ri = !1)));
          },
          updateURL: function () {
            gi(), ri || (hi ? (ii = setTimeout(_i, 800)) : _i());
          },
        },
      }),
        s.extend(o, Gt);
    };
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(e)
      : "object" == typeof exports
      ? (module.exports = e())
      : (t.PhotoSwipeUI_Default = e());
  })(this, function () {
    "use strict";
    return function (t, e) {
      var i,
        n,
        s,
        o,
        r,
        a,
        l,
        h,
        c,
        u,
        d,
        p,
        f,
        m,
        g,
        v,
        _,
        y,
        b = this,
        w = !1,
        x = !0,
        C = !0,
        k = {
          barsSize: { top: 44, bottom: "auto" },
          closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
          timeToIdle: 4e3,
          timeToIdleOutside: 1e3,
          loadingIndicatorDelay: 1e3,
          addCaptionHTMLFn: function (t, e) {
            return t.title
              ? ((e.children[0].innerHTML = t.title), !0)
              : ((e.children[0].innerHTML = ""), !1);
          },
          closeEl: !0,
          captionEl: !0,
          fullscreenEl: !0,
          zoomEl: !0,
          shareEl: !0,
          counterEl: !0,
          arrowEl: !0,
          preloaderEl: !0,
          tapToClose: !1,
          tapToToggleControls: !0,
          clickToCloseNonZoomable: !0,
          shareButtons: [
            {
              id: "facebook",
              label: "Share on Facebook",
              url: "https://www.facebook.com/sharer/sharer.php?u={{url}}",
            },
            {
              id: "twitter",
              label: "Tweet",
              url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}",
            },
            {
              id: "pinterest",
              label: "Pin it",
              url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}",
            },
            {
              id: "download",
              label: "Download image",
              url: "{{raw_image_url}}",
              download: !0,
            },
          ],
          getImageURLForShare: function () {
            return t.currItem.src || "";
          },
          getPageURLForShare: function () {
            return window.location.href;
          },
          getTextForShare: function () {
            return t.currItem.title || "";
          },
          indexIndicatorSep: " / ",
          fitControlsWidth: 1200,
        },
        T = function (t) {
          if (v) return !0;
          (t = t || window.event), g.timeToIdle && g.mouseUsed && !c && $();
          for (
            var i,
              n,
              s = (t.target || t.srcElement).getAttribute("class") || "",
              o = 0;
            o < F.length;
            o++
          )
            (i = F[o]).onTap &&
              s.indexOf("pswp__" + i.name) > -1 &&
              (i.onTap(), (n = !0));
          if (n) {
            t.stopPropagation && t.stopPropagation(), (v = !0);
            var r = e.features.isOldAndroid ? 600 : 30;
            setTimeout(function () {
              v = !1;
            }, r);
          }
        },
        D = function () {
          return (
            !t.likelyTouchDevice ||
            g.mouseUsed ||
            screen.width > g.fitControlsWidth
          );
        },
        I = function (t, i, n) {
          e[(n ? "add" : "remove") + "Class"](t, "pswp__" + i);
        },
        E = function () {
          var t = 1 === g.getNumItemsFn();
          t !== m && (I(n, "ui--one-slide", t), (m = t));
        },
        S = function () {
          I(l, "share-modal--hidden", C);
        },
        A = function () {
          return (
            (C = !C)
              ? (e.removeClass(l, "pswp__share-modal--fade-in"),
                setTimeout(function () {
                  C && S();
                }, 300))
              : (S(),
                setTimeout(function () {
                  C || e.addClass(l, "pswp__share-modal--fade-in");
                }, 30)),
            C || O(),
            !1
          );
        },
        P = function (e) {
          var i = (e = e || window.event).target || e.srcElement;
          return (
            t.shout("shareLinkClick", e, i),
            !(
              !i.href ||
              (!i.hasAttribute("download") &&
                (window.open(
                  i.href,
                  "pswp_share",
                  "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" +
                    (window.screen ? Math.round(screen.width / 2 - 275) : 100)
                ),
                C || A(),
                1))
            )
          );
        },
        O = function () {
          for (var t, e, i, n, s = "", o = 0; o < g.shareButtons.length; o++)
            (t = g.shareButtons[o]),
              (e = g.getImageURLForShare(t)),
              (i = g.getPageURLForShare(t)),
              (n = g.getTextForShare(t)),
              (s +=
                '<a href="' +
                t.url
                  .replace("{{url}}", encodeURIComponent(i))
                  .replace("{{image_url}}", encodeURIComponent(e))
                  .replace("{{raw_image_url}}", e)
                  .replace("{{text}}", encodeURIComponent(n)) +
                '" target="_blank" class="pswp__share--' +
                t.id +
                '"' +
                (t.download ? "download" : "") +
                ">" +
                t.label +
                "</a>"),
              g.parseShareButtonOut && (s = g.parseShareButtonOut(t, s));
          (l.children[0].innerHTML = s), (l.children[0].onclick = P);
        },
        M = function (t) {
          for (var i = 0; i < g.closeElClasses.length; i++)
            if (e.hasClass(t, "pswp__" + g.closeElClasses[i])) return !0;
        },
        z = 0,
        $ = function () {
          clearTimeout(y), (z = 0), c && b.setIdle(!1);
        },
        N = function (t) {
          var e = (t = t || window.event).relatedTarget || t.toElement;
          (e && "HTML" !== e.nodeName) ||
            (clearTimeout(y),
            (y = setTimeout(function () {
              b.setIdle(!0);
            }, g.timeToIdleOutside)));
        },
        H = function (t) {
          p !== t && (I(d, "preloader--active", !t), (p = t));
        },
        W = function (t) {
          var i = t.vGap;
          if (D()) {
            var r = g.barsSize;
            if (g.captionEl && "auto" === r.bottom)
              if (
                (o ||
                  ((o = e.createEl(
                    "pswp__caption pswp__caption--fake"
                  )).appendChild(e.createEl("pswp__caption__center")),
                  n.insertBefore(o, s),
                  e.addClass(n, "pswp__ui--fit")),
                g.addCaptionHTMLFn(t, o, !0))
              ) {
                var a = o.clientHeight;
                i.bottom = parseInt(a, 10) || 44;
              } else i.bottom = r.top;
            else i.bottom = "auto" === r.bottom ? 0 : r.bottom;
            i.top = r.top;
          } else i.top = i.bottom = 0;
        },
        F = [
          {
            name: "caption",
            option: "captionEl",
            onInit: function (t) {
              s = t;
            },
          },
          {
            name: "share-modal",
            option: "shareEl",
            onInit: function (t) {
              l = t;
            },
            onTap: function () {
              A();
            },
          },
          {
            name: "button--share",
            option: "shareEl",
            onInit: function (t) {
              a = t;
            },
            onTap: function () {
              A();
            },
          },
          {
            name: "button--zoom",
            option: "zoomEl",
            onTap: t.toggleDesktopZoom,
          },
          {
            name: "counter",
            option: "counterEl",
            onInit: function (t) {
              r = t;
            },
          },
          { name: "button--close", option: "closeEl", onTap: t.close },
          { name: "button--arrow--left", option: "arrowEl", onTap: t.prev },
          { name: "button--arrow--right", option: "arrowEl", onTap: t.next },
          {
            name: "button--fs",
            option: "fullscreenEl",
            onTap: function () {
              i.isFullscreen() ? i.exit() : i.enter();
            },
          },
          {
            name: "preloader",
            option: "preloaderEl",
            onInit: function (t) {
              d = t;
            },
          },
        ];
      (b.init = function () {
        e.extend(t.options, k, !0),
          (g = t.options),
          (n = e.getChildByClass(t.scrollWrap, "pswp__ui")),
          (u = t.listen),
          (function () {
            var t;
            u("onVerticalDrag", function (t) {
              x && 0.95 > t
                ? b.hideControls()
                : !x && t >= 0.95 && b.showControls();
            }),
              u("onPinchClose", function (e) {
                x && 0.9 > e
                  ? (b.hideControls(), (t = !0))
                  : t && !x && e > 0.9 && b.showControls();
              }),
              u("zoomGestureEnded", function () {
                (t = !1) && !x && b.showControls();
              });
          })(),
          u("beforeChange", b.update),
          u("doubleTap", function (e) {
            var i = t.currItem.initialZoomLevel;
            t.getZoomLevel() !== i
              ? t.zoomTo(i, e, 333)
              : t.zoomTo(g.getDoubleTapZoom(!1, t.currItem), e, 333);
          }),
          u("preventDragEvent", function (t, e, i) {
            var n = t.target || t.srcElement;
            n &&
              n.getAttribute("class") &&
              t.type.indexOf("mouse") > -1 &&
              (n.getAttribute("class").indexOf("__caption") > 0 ||
                /(SMALL|STRONG|EM)/i.test(n.tagName)) &&
              (i.prevent = !1);
          }),
          u("bindEvents", function () {
            e.bind(n, "pswpTap click", T),
              e.bind(t.scrollWrap, "pswpTap", b.onGlobalTap),
              t.likelyTouchDevice ||
                e.bind(t.scrollWrap, "mouseover", b.onMouseOver);
          }),
          u("unbindEvents", function () {
            C || A(),
              _ && clearInterval(_),
              e.unbind(document, "mouseout", N),
              e.unbind(document, "mousemove", $),
              e.unbind(n, "pswpTap click", T),
              e.unbind(t.scrollWrap, "pswpTap", b.onGlobalTap),
              e.unbind(t.scrollWrap, "mouseover", b.onMouseOver),
              i &&
                (e.unbind(document, i.eventK, b.updateFullscreen),
                i.isFullscreen() && ((g.hideAnimationDuration = 0), i.exit()),
                (i = null));
          }),
          u("destroy", function () {
            g.captionEl &&
              (o && n.removeChild(o), e.removeClass(s, "pswp__caption--empty")),
              l && (l.children[0].onclick = null),
              e.removeClass(n, "pswp__ui--over-close"),
              e.addClass(n, "pswp__ui--hidden"),
              b.setIdle(!1);
          }),
          g.showAnimationDuration || e.removeClass(n, "pswp__ui--hidden"),
          u("initialZoomIn", function () {
            g.showAnimationDuration && e.removeClass(n, "pswp__ui--hidden");
          }),
          u("initialZoomOut", function () {
            e.addClass(n, "pswp__ui--hidden");
          }),
          u("parseVerticalMargin", W),
          (function () {
            var t,
              i,
              s,
              o = function (n) {
                if (n)
                  for (var o = n.length, r = 0; o > r; r++) {
                    (t = n[r]), (i = t.className);
                    for (var a = 0; a < F.length; a++)
                      (s = F[a]),
                        i.indexOf("pswp__" + s.name) > -1 &&
                          (g[s.option]
                            ? (e.removeClass(t, "pswp__element--disabled"),
                              s.onInit && s.onInit(t))
                            : e.addClass(t, "pswp__element--disabled"));
                  }
              };
            o(n.children);
            var r = e.getChildByClass(n, "pswp__top-bar");
            r && o(r.children);
          })(),
          g.shareEl && a && l && (C = !0),
          E(),
          g.timeToIdle &&
            u("mouseUsed", function () {
              e.bind(document, "mousemove", $),
                e.bind(document, "mouseout", N),
                (_ = setInterval(function () {
                  2 == ++z && b.setIdle(!0);
                }, g.timeToIdle / 2));
            }),
          g.fullscreenEl &&
            !e.features.isOldAndroid &&
            (i || (i = b.getFullscreenAPI()),
            i
              ? (e.bind(document, i.eventK, b.updateFullscreen),
                b.updateFullscreen(),
                e.addClass(t.template, "pswp--supports-fs"))
              : e.removeClass(t.template, "pswp--supports-fs")),
          g.preloaderEl &&
            (H(!0),
            u("beforeChange", function () {
              clearTimeout(f),
                (f = setTimeout(function () {
                  t.currItem && t.currItem.loading
                    ? (!t.allowProgressiveImg() ||
                        (t.currItem.img && !t.currItem.img.naturalWidth)) &&
                      H(!1)
                    : H(!0);
                }, g.loadingIndicatorDelay));
            }),
            u("imageLoadComplete", function (e, i) {
              t.currItem === i && H(!0);
            }));
      }),
        (b.setIdle = function (t) {
          (c = t), I(n, "ui--idle", t);
        }),
        (b.update = function () {
          x && t.currItem
            ? (b.updateIndexIndicator(),
              g.captionEl &&
                (g.addCaptionHTMLFn(t.currItem, s),
                I(s, "caption--empty", !t.currItem.title)),
              (w = !0))
            : (w = !1),
            C || A(),
            E();
        }),
        (b.updateFullscreen = function (n) {
          n &&
            setTimeout(function () {
              t.setScrollOffset(0, e.getScrollY());
            }, 50),
            e[(i.isFullscreen() ? "add" : "remove") + "Class"](
              t.template,
              "pswp--fs"
            );
        }),
        (b.updateIndexIndicator = function () {
          g.counterEl &&
            (r.innerHTML =
              t.getCurrentIndex() +
              1 +
              g.indexIndicatorSep +
              g.getNumItemsFn());
        }),
        (b.onGlobalTap = function (i) {
          var n = (i = i || window.event).target || i.srcElement;
          if (!v)
            if (i.detail && "mouse" === i.detail.pointerType) {
              if (M(n)) return void t.close();
              e.hasClass(n, "pswp__img") &&
                (1 === t.getZoomLevel() &&
                t.getZoomLevel() <= t.currItem.fitRatio
                  ? g.clickToCloseNonZoomable && t.close()
                  : t.toggleDesktopZoom(i.detail.releasePoint));
            } else if (
              (g.tapToToggleControls &&
                (x ? b.hideControls() : b.showControls()),
              g.tapToClose && (e.hasClass(n, "pswp__img") || M(n)))
            )
              return void t.close();
        }),
        (b.onMouseOver = function (t) {
          var e = (t = t || window.event).target || t.srcElement;
          I(n, "ui--over-close", M(e));
        }),
        (b.hideControls = function () {
          e.addClass(n, "pswp__ui--hidden"), (x = !1);
        }),
        (b.showControls = function () {
          (x = !0), w || b.update(), e.removeClass(n, "pswp__ui--hidden");
        }),
        (b.supportsFullscreen = function () {
          var t = document;
          return !!(
            t.exitFullscreen ||
            t.mozCancelFullScreen ||
            t.webkitExitFullscreen ||
            t.msExitFullscreen
          );
        }),
        (b.getFullscreenAPI = function () {
          var e,
            i = document.documentElement,
            n = "fullscreenchange";
          return (
            i.requestFullscreen
              ? (e = {
                  enterK: "requestFullscreen",
                  exitK: "exitFullscreen",
                  elementK: "fullscreenElement",
                  eventK: n,
                })
              : i.mozRequestFullScreen
              ? (e = {
                  enterK: "mozRequestFullScreen",
                  exitK: "mozCancelFullScreen",
                  elementK: "mozFullScreenElement",
                  eventK: "moz" + n,
                })
              : i.webkitRequestFullscreen
              ? (e = {
                  enterK: "webkitRequestFullscreen",
                  exitK: "webkitExitFullscreen",
                  elementK: "webkitFullscreenElement",
                  eventK: "webkit" + n,
                })
              : i.msRequestFullscreen &&
                (e = {
                  enterK: "msRequestFullscreen",
                  exitK: "msExitFullscreen",
                  elementK: "msFullscreenElement",
                  eventK: "MSFullscreenChange",
                }),
            e &&
              ((e.enter = function () {
                return (
                  (h = g.closeOnScroll),
                  (g.closeOnScroll = !1),
                  "webkitRequestFullscreen" !== this.enterK
                    ? t.template[this.enterK]()
                    : void t.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT)
                );
              }),
              (e.exit = function () {
                return (g.closeOnScroll = h), document[this.exitK]();
              }),
              (e.isFullscreen = function () {
                return document[this.elementK];
              })),
            e
          );
        });
    };
  }),
  (function (t) {
    "function" == typeof define && define.amd
      ? define(["jquery"], t)
      : "object" == typeof module && module.exports
      ? (module.exports = function (e, i) {
          return (
            void 0 === i &&
              (i =
                "undefined" != typeof window
                  ? require("jquery")
                  : require("jquery")(e)),
            t(i),
            i
          );
        })
      : t(jQuery);
  })(function (t) {
    "use strict";
    var e = t(document),
      i = t(window),
      n = ["a", "e", "i", "o", "u", "n", "c", "y"],
      s = [
        /[\xE0-\xE5]/g,
        /[\xE8-\xEB]/g,
        /[\xEC-\xEF]/g,
        /[\xF2-\xF6]/g,
        /[\xF9-\xFC]/g,
        /[\xF1]/g,
        /[\xE7]/g,
        /[\xFD-\xFF]/g,
      ],
      o = function (e, i) {
        (this.element = e),
          (this.$element = t(e)),
          (this.state = {
            multiple: !!this.$element.attr("multiple"),
            enabled: !1,
            opened: !1,
            currValue: -1,
            selectedIdx: -1,
            highlightedIdx: -1,
          }),
          (this.eventTriggers = {
            open: this.open,
            close: this.close,
            destroy: this.destroy,
            refresh: this.refresh,
            init: this.init,
          }),
          this.init(i);
      };
    (o.prototype = {
      utils: {
        isMobile: function () {
          return /android|ip(hone|od|ad)/i.test(navigator.userAgent);
        },
        escapeRegExp: function (t) {
          return t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        },
        replaceDiacritics: function (t) {
          for (var e = s.length; e--; ) t = t.toLowerCase().replace(s[e], n[e]);
          return t;
        },
        format: function (t) {
          var e = arguments;
          return ("" + t).replace(/\{(?:(\d+)|(\w+))\}/g, function (t, i, n) {
            return n && e[1] ? e[1][n] : e[i];
          });
        },
        nextEnabledItem: function (t, e) {
          for (; t[(e = (e + 1) % t.length)].disabled; );
          return e;
        },
        previousEnabledItem: function (t, e) {
          for (; t[(e = (e > 0 ? e : t.length) - 1)].disabled; );
          return e;
        },
        toDash: function (t) {
          return t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
        },
        triggerCallback: function (e, i) {
          var n = i.element,
            s = i.options["on" + e],
            o = [n].concat([].slice.call(arguments).slice(1));
          t.isFunction(s) && s.apply(n, o),
            t(n).trigger("selectric-" + this.toDash(e), o);
        },
        arrayToClassname: function (e) {
          var i = t.grep(e, function (t) {
            return !!t;
          });
          return t.trim(i.join(" "));
        },
      },
      init: function (e) {
        var i = this;
        if (
          ((i.options = t.extend(
            !0,
            {},
            t.fn.selectric.defaults,
            i.options,
            e
          )),
          i.utils.triggerCallback("BeforeInit", i),
          i.destroy(!0),
          i.options.disableOnMobile && i.utils.isMobile())
        )
          i.disableOnMobile = !0;
        else {
          i.classes = i.getClassNames();
          var n = t("<input/>", {
              class: i.classes.input,
              readonly: i.utils.isMobile(),
            }),
            s = t("<div/>", { class: i.classes.items, tabindex: -1 }),
            o = t("<div/>", { class: i.classes.scroll }),
            r = t("<div/>", {
              class: i.classes.prefix,
              html: i.options.arrowButtonMarkup,
            }),
            a = t("<span/>", { class: "label" }),
            l = i.$element.wrap("<div/>").parent().append(r.prepend(a), s, n),
            h = t("<div/>", { class: i.classes.hideselect });
          (i.elements = {
            input: n,
            items: s,
            itemsScroll: o,
            wrapper: r,
            label: a,
            outerWrapper: l,
          }),
            i.options.nativeOnMobile &&
              i.utils.isMobile() &&
              ((i.elements.input = void 0),
              h.addClass(i.classes.prefix + "-is-native"),
              i.$element.on("change", function () {
                i.refresh();
              })),
            i.$element.on(i.eventTriggers).wrap(h),
            (i.originalTabindex = i.$element.prop("tabindex")),
            i.$element.prop("tabindex", -1),
            i.populate(),
            i.activate(),
            i.utils.triggerCallback("Init", i);
        }
      },
      activate: function () {
        var t = this.elements.items
            .closest(":visible")
            .children(":hidden")
            .addClass(this.classes.tempshow),
          e = this.$element.width();
        t.removeClass(this.classes.tempshow),
          this.utils.triggerCallback("BeforeActivate", this),
          this.elements.outerWrapper.prop(
            "class",
            this.utils.arrayToClassname([
              this.classes.wrapper,
              this.$element
                .prop("class")
                .replace(/\S+/g, this.classes.prefix + "-$&"),
              this.options.responsive ? this.classes.responsive : "",
            ])
          ),
          this.options.inheritOriginalWidth &&
            e > 0 &&
            this.elements.outerWrapper.width(e),
          this.unbindEvents(),
          this.$element.prop("disabled")
            ? (this.elements.outerWrapper.addClass(this.classes.disabled),
              this.elements.input && this.elements.input.prop("disabled", !0))
            : ((this.state.enabled = !0),
              this.elements.outerWrapper.removeClass(this.classes.disabled),
              (this.$li = this.elements.items.removeAttr("style").find("li")),
              this.bindEvents()),
          this.utils.triggerCallback("Activate", this);
      },
      getClassNames: function () {
        var e = this,
          i = e.options.customClass,
          n = {};
        return (
          t.each(
            "Input Items Open Disabled TempShow HideSelect Wrapper Focus Hover Responsive Above Below Scroll Group GroupLabel".split(
              " "
            ),
            function (t, s) {
              var o = i.prefix + s;
              n[s.toLowerCase()] = i.camelCase ? o : e.utils.toDash(o);
            }
          ),
          (n.prefix = i.prefix),
          n
        );
      },
      setLabel: function () {
        var e = this,
          i = e.options.labelBuilder;
        if (e.state.multiple) {
          var n = t.isArray(e.state.currValue)
            ? e.state.currValue
            : [e.state.currValue];
          n = 0 === n.length ? [0] : n;
          var s = t.map(n, function (i) {
            return t.grep(e.lookupItems, function (t) {
              return t.index === i;
            })[0];
          });
          (s = t.grep(s, function (e) {
            return s.length > 1 || 0 === s.length ? "" !== t.trim(e.value) : e;
          })),
            (s = t.map(s, function (n) {
              return t.isFunction(i) ? i(n) : e.utils.format(i, n);
            })),
            e.options.multiple.maxLabelEntries &&
              (s.length >= e.options.multiple.maxLabelEntries + 1
                ? (s = s.slice(0, e.options.multiple.maxLabelEntries)).push(
                    t.isFunction(i)
                      ? i({ text: "..." })
                      : e.utils.format(i, { text: "..." })
                  )
                : s.slice(s.length - 1)),
            e.elements.label.html(s.join(e.options.multiple.separator));
        } else {
          var o = e.lookupItems[e.state.currValue];
          e.elements.label.html(t.isFunction(i) ? i(o) : e.utils.format(i, o));
        }
      },
      populate: function () {
        var e = this,
          i = e.$element.children(),
          n = e.$element.find("option"),
          s = n.filter(":selected"),
          o = n.index(s),
          r = 0,
          a = e.state.multiple ? [] : 0;
        s.length > 1 &&
          e.state.multiple &&
          ((o = []),
          s.each(function () {
            o.push(t(this).index());
          })),
          (e.state.currValue = ~o ? o : a),
          (e.state.selectedIdx = e.state.currValue),
          (e.state.highlightedIdx = e.state.currValue),
          (e.items = []),
          (e.lookupItems = []),
          i.length &&
            (i.each(function (i) {
              var n = t(this);
              if (n.is("optgroup")) {
                var s = {
                  element: n,
                  label: n.prop("label"),
                  groupDisabled: n.prop("disabled"),
                  items: [],
                };
                n.children().each(function (i) {
                  var n = t(this);
                  (s.items[i] = e.getItemData(
                    r,
                    n,
                    s.groupDisabled || n.prop("disabled")
                  )),
                    (e.lookupItems[r] = s.items[i]),
                    r++;
                }),
                  (e.items[i] = s);
              } else (e.items[i] = e.getItemData(r, n, n.prop("disabled"))), (e.lookupItems[r] = e.items[i]), r++;
            }),
            e.setLabel(),
            e.elements.items.append(
              e.elements.itemsScroll.html(e.getItemsMarkup(e.items))
            ));
      },
      getItemData: function (e, i, n) {
        return {
          index: e,
          element: i,
          value: i.val(),
          className: i.prop("class"),
          text: i.html(),
          slug: t.trim(this.utils.replaceDiacritics(i.html())),
          alt: i.attr("data-alt"),
          selected: i.prop("selected"),
          disabled: n,
        };
      },
      getItemsMarkup: function (e) {
        var i = this,
          n = "<ul>";
        return (
          t.isFunction(i.options.listBuilder) &&
            i.options.listBuilder &&
            (e = i.options.listBuilder(e)),
          t.each(e, function (e, s) {
            void 0 !== s.label
              ? ((n += i.utils.format(
                  '<ul class="{1}"><li class="{2}">{3}</li>',
                  i.utils.arrayToClassname([
                    i.classes.group,
                    s.groupDisabled ? "disabled" : "",
                    s.element.prop("class"),
                  ]),
                  i.classes.grouplabel,
                  s.element.prop("label")
                )),
                t.each(s.items, function (t, e) {
                  n += i.getItemMarkup(e.index, e);
                }),
                (n += "</ul>"))
              : (n += i.getItemMarkup(s.index, s));
          }),
          n + "</ul>"
        );
      },
      getItemMarkup: function (e, i) {
        var n = this.options.optionsItemBuilder,
          s = { value: i.value, text: i.text, slug: i.slug, index: i.index };
        return this.utils.format(
          '<li data-index="{1}" class="{2}">{3}</li>',
          e,
          this.utils.arrayToClassname([
            i.className,
            e === this.items.length - 1 ? "last" : "",
            i.disabled ? "disabled" : "",
            i.selected ? "selected" : "",
          ]),
          t.isFunction(n)
            ? this.utils.format(n(i, this.$element, e), i)
            : this.utils.format(n, s)
        );
      },
      unbindEvents: function () {
        this.elements.wrapper
          .add(this.$element)
          .add(this.elements.outerWrapper)
          .add(this.elements.input)
          .off(".sl");
      },
      bindEvents: function () {
        var e = this;
        e.elements.outerWrapper.on("mouseenter.sl mouseleave.sl", function (i) {
          t(this).toggleClass(e.classes.hover, "mouseenter" === i.type),
            e.options.openOnHover &&
              (clearTimeout(e.closeTimer),
              "mouseleave" === i.type
                ? (e.closeTimer = setTimeout(
                    t.proxy(e.close, e),
                    e.options.hoverIntentTimeout
                  ))
                : e.open());
        }),
          e.elements.wrapper.on("click.sl", function (t) {
            e.state.opened ? e.close() : e.open(t);
          }),
          (e.options.nativeOnMobile && e.utils.isMobile()) ||
            (e.$element.on("focus.sl", function () {
              e.elements.input.focus();
            }),
            e.elements.input
              .prop({ tabindex: e.originalTabindex, disabled: !1 })
              .on("keydown.sl", t.proxy(e.handleKeys, e))
              .on("focusin.sl", function (t) {
                e.elements.outerWrapper.addClass(e.classes.focus),
                  e.elements.input.one("blur", function () {
                    e.elements.input.blur();
                  }),
                  e.options.openOnFocus && !e.state.opened && e.open(t);
              })
              .on("focusout.sl", function () {
                e.elements.outerWrapper.removeClass(e.classes.focus);
              })
              .on("input propertychange", function () {
                var i = e.elements.input.val(),
                  n = new RegExp("^" + e.utils.escapeRegExp(i), "i");
                clearTimeout(e.resetStr),
                  (e.resetStr = setTimeout(function () {
                    e.elements.input.val("");
                  }, e.options.keySearchTimeout)),
                  i.length &&
                    t.each(e.items, function (t, i) {
                      if (!i.disabled) {
                        if (n.test(i.text) || n.test(i.slug))
                          return e.highlight(t), !1;
                        if (i.alt)
                          for (
                            var s = i.alt.split("|"), o = 0;
                            o < s.length && s[o];
                            o++
                          )
                            if (n.test(s[o].trim())) return e.highlight(t), !1;
                      }
                    });
              })),
          e.$li.on({
            mousedown: function (t) {
              t.preventDefault(), t.stopPropagation();
            },
            click: function () {
              return e.select(t(this).data("index")), !1;
            },
          });
      },
      handleKeys: function (e) {
        var i = e.which,
          n = this.options.keys,
          s = t.inArray(i, n.previous) > -1,
          o = t.inArray(i, n.next) > -1,
          r = t.inArray(i, n.select) > -1,
          a = t.inArray(i, n.open) > -1,
          l = this.state.highlightedIdx,
          h = (s && 0 === l) || (o && l + 1 === this.items.length),
          c = 0;
        if (((13 !== i && 32 !== i) || e.preventDefault(), s || o)) {
          if (!this.options.allowWrap && h) return;
          s && (c = this.utils.previousEnabledItem(this.lookupItems, l)),
            o && (c = this.utils.nextEnabledItem(this.lookupItems, l)),
            this.highlight(c);
        }
        if (r && this.state.opened)
          return (
            this.select(l),
            void (
              (this.state.multiple && this.options.multiple.keepMenuOpen) ||
              this.close()
            )
          );
        a && !this.state.opened && this.open();
      },
      refresh: function () {
        this.populate(),
          this.activate(),
          this.utils.triggerCallback("Refresh", this);
      },
      setOptionsDimensions: function () {
        var t = this.elements.items
            .closest(":visible")
            .children(":hidden")
            .addClass(this.classes.tempshow),
          e = this.options.maxHeight,
          i = this.elements.items.outerWidth(),
          n =
            this.elements.wrapper.outerWidth() -
            (i - this.elements.items.width());
        !this.options.expandToItemText || n > i
          ? (this.finalWidth = n)
          : (this.elements.items.css("overflow", "scroll"),
            this.elements.outerWrapper.width(9e4),
            (this.finalWidth = this.elements.items.width()),
            this.elements.items.css("overflow", ""),
            this.elements.outerWrapper.width("")),
          this.elements.items.width(this.finalWidth).height() > e &&
            this.elements.items.height(e),
          t.removeClass(this.classes.tempshow);
      },
      isInViewport: function () {
        if (!0 === this.options.forceRenderAbove)
          this.elements.outerWrapper.addClass(this.classes.above);
        else if (!0 === this.options.forceRenderBelow)
          this.elements.outerWrapper.addClass(this.classes.below);
        else {
          var t = i.scrollTop(),
            e = i.height(),
            n = this.elements.outerWrapper.offset().top,
            s =
              n + this.elements.outerWrapper.outerHeight() + this.itemsHeight <=
              t + e,
            o = n - this.itemsHeight > t,
            r = !s && o,
            a = !r;
          this.elements.outerWrapper.toggleClass(this.classes.above, r),
            this.elements.outerWrapper.toggleClass(this.classes.below, a);
        }
      },
      detectItemVisibility: function (e) {
        var i = this.$li.filter("[data-index]");
        this.state.multiple &&
          ((e = t.isArray(e) && 0 === e.length ? 0 : e),
          (e = t.isArray(e) ? Math.min.apply(Math, e) : e));
        var n = i.eq(e).outerHeight(),
          s = i[e].offsetTop,
          o = this.elements.itemsScroll.scrollTop(),
          r = s + 2 * n;
        this.elements.itemsScroll.scrollTop(
          r > o + this.itemsHeight
            ? r - this.itemsHeight
            : s - n < o
            ? s - n
            : o
        );
      },
      open: function (i) {
        var n = this;
        if (n.options.nativeOnMobile && n.utils.isMobile()) return !1;
        n.utils.triggerCallback("BeforeOpen", n),
          i &&
            (i.preventDefault(),
            n.options.stopPropagation && i.stopPropagation()),
          n.state.enabled &&
            (n.setOptionsDimensions(),
            t("." + n.classes.hideselect, "." + n.classes.open)
              .children()
              .selectric("close"),
            (n.state.opened = !0),
            (n.itemsHeight = n.elements.items.outerHeight()),
            (n.itemsInnerHeight = n.elements.items.height()),
            n.elements.outerWrapper.addClass(n.classes.open),
            n.elements.input.val(""),
            i && "focusin" !== i.type && n.elements.input.focus(),
            setTimeout(function () {
              e.on("click.sl", t.proxy(n.close, n)).on(
                "scroll.sl",
                t.proxy(n.isInViewport, n)
              );
            }, 1),
            n.isInViewport(),
            n.options.preventWindowScroll &&
              e.on(
                "mousewheel.sl DOMMouseScroll.sl",
                "." + n.classes.scroll,
                function (e) {
                  var i = e.originalEvent,
                    s = t(this).scrollTop(),
                    o = 0;
                  "detail" in i && (o = -1 * i.detail),
                    "wheelDelta" in i && (o = i.wheelDelta),
                    "wheelDeltaY" in i && (o = i.wheelDeltaY),
                    "deltaY" in i && (o = -1 * i.deltaY),
                    ((s === this.scrollHeight - n.itemsInnerHeight && o < 0) ||
                      (0 === s && o > 0)) &&
                      e.preventDefault();
                }
              ),
            n.detectItemVisibility(n.state.selectedIdx),
            n.highlight(n.state.multiple ? -1 : n.state.selectedIdx),
            n.utils.triggerCallback("Open", n));
      },
      close: function () {
        this.utils.triggerCallback("BeforeClose", this),
          e.off(".sl"),
          this.elements.outerWrapper.removeClass(this.classes.open),
          (this.state.opened = !1),
          this.utils.triggerCallback("Close", this);
      },
      change: function () {
        var e = this;
        e.utils.triggerCallback("BeforeChange", e),
          e.state.multiple
            ? (t.each(e.lookupItems, function (t) {
                (e.lookupItems[t].selected = !1),
                  e.$element.find("option").prop("selected", !1);
              }),
              t.each(e.state.selectedIdx, function (t, i) {
                (e.lookupItems[i].selected = !0),
                  e.$element.find("option").eq(i).prop("selected", !0);
              }),
              (e.state.currValue = e.state.selectedIdx),
              e.setLabel(),
              e.utils.triggerCallback("Change", e))
            : e.state.currValue !== e.state.selectedIdx &&
              (e.$element
                .prop(
                  "selectedIndex",
                  (e.state.currValue = e.state.selectedIdx)
                )
                .data("value", e.lookupItems[e.state.selectedIdx].text),
              e.setLabel(),
              e.utils.triggerCallback("Change", e));
      },
      highlight: function (t) {
        var e = this.$li.filter("[data-index]").removeClass("highlighted");
        this.utils.triggerCallback("BeforeHighlight", this),
          void 0 === t ||
            -1 === t ||
            this.lookupItems[t].disabled ||
            (e.eq((this.state.highlightedIdx = t)).addClass("highlighted"),
            this.detectItemVisibility(t),
            this.utils.triggerCallback("Highlight", this));
      },
      select: function (e) {
        var i = this,
          n = i.$li.filter("[data-index]");
        if (
          (i.utils.triggerCallback("BeforeSelect", i, e),
          void 0 !== e && -1 !== e && !i.lookupItems[e].disabled)
        ) {
          if (i.state.multiple) {
            i.state.selectedIdx = t.isArray(i.state.selectedIdx)
              ? i.state.selectedIdx
              : [i.state.selectedIdx];
            var s = t.inArray(e, i.state.selectedIdx);
            -1 !== s
              ? i.state.selectedIdx.splice(s, 1)
              : i.state.selectedIdx.push(e),
              n
                .removeClass("selected")
                .filter(function (e) {
                  return -1 !== t.inArray(e, i.state.selectedIdx);
                })
                .addClass("selected");
          } else
            n.removeClass("selected")
              .eq((i.state.selectedIdx = e))
              .addClass("selected");
          (i.state.multiple && i.options.multiple.keepMenuOpen) || i.close(),
            i.change(),
            i.utils.triggerCallback("Select", i, e);
        }
      },
      destroy: function (t) {
        this.state &&
          this.state.enabled &&
          (this.elements.items
            .add(this.elements.wrapper)
            .add(this.elements.input)
            .remove(),
          t || this.$element.removeData("selectric").removeData("value"),
          this.$element
            .prop("tabindex", this.originalTabindex)
            .off(".sl")
            .off(this.eventTriggers)
            .unwrap()
            .unwrap(),
          (this.state.enabled = !1));
      },
    }),
      (t.fn.selectric = function (e) {
        return this.each(function () {
          var i = t.data(this, "selectric");
          i && !i.disableOnMobile
            ? "string" == typeof e && i[e]
              ? i[e]()
              : i.init(e)
            : t.data(this, "selectric", new o(this, e));
        });
      }),
      (t.fn.selectric.defaults = {
        onChange: function (e) {
          t(e).change();
        },
        maxHeight: 300,
        keySearchTimeout: 500,
        arrowButtonMarkup: '<b class="button">&#x25be;</b>',
        disableOnMobile: !1,
        nativeOnMobile: !0,
        openOnFocus: !0,
        openOnHover: !1,
        hoverIntentTimeout: 500,
        expandToItemText: !1,
        responsive: !1,
        preventWindowScroll: !0,
        inheritOriginalWidth: !1,
        allowWrap: !0,
        forceRenderAbove: !1,
        forceRenderBelow: !1,
        stopPropagation: !0,
        optionsItemBuilder: "{text}",
        labelBuilder: "{text}",
        listBuilder: !1,
        keys: {
          previous: [37, 38],
          next: [39, 40],
          select: [9, 13, 27],
          open: [13, 32, 37, 38, 39, 40],
          close: [9, 27],
        },
        customClass: { prefix: "selectric", camelCase: !1 },
        multiple: { separator: ", ", keepMenuOpen: !0, maxLabelEntries: !1 },
      });
  }),
  (function (t) {
    var e,
      i = t.fn.domManip,
      n = "_tmplitem",
      s = /^[^<]*(<[\w\W]+>)[^>]*$|\{\{\! /,
      o = {},
      r = {},
      a = { key: 0, data: {} },
      l = 0,
      h = 0,
      c = [];
    function u(e, i, n, s) {
      var a = {
        data: s || (i ? i.data : {}),
        _wrap: i ? i._wrap : null,
        tmpl: null,
        parent: i || null,
        nodes: [],
        calls: _,
        nest: y,
        wrap: b,
        html: w,
        update: x,
      };
      return (
        e && t.extend(a, e, { nodes: [], parent: i }),
        n &&
          ((a.tmpl = n),
          (a._ctnt = a._ctnt || a.tmpl(t, a)),
          (a.key = ++l),
          ((c.length ? r : o)[l] = a)),
        a
      );
    }
    function d(e, i, s) {
      var o,
        r = s
          ? t.map(s, function (t) {
              return "string" == typeof t
                ? e.key
                  ? t.replace(
                      /(<\w+)(?=[\s>])(?![^>]*_tmplitem)([^>]*)/g,
                      "$1 " + n + '="' + e.key + '" $2'
                    )
                  : t
                : d(t, e, t._ctnt);
            })
          : e;
      return i
        ? r
        : ((r = r.join("")).replace(
            /^\s*([^<\s][^<]*)?(<[\w\W]+>)([^>]*[^>\s])?\s*$/,
            function (e, i, n, s) {
              v((o = t(n).get())),
                i && (o = p(i).concat(o)),
                s && (o = o.concat(p(s)));
            }
          ),
          o || p(r));
    }
    function p(e) {
      var i = document.createElement("div");
      return (i.innerHTML = e), t.makeArray(i.childNodes);
    }
    function f(e) {
      return new Function(
        "jQuery",
        "$item",
        "var $=jQuery,call,_=[],$data=$item.data;with($data){_.push('" +
          t
            .trim(e)
            .replace(/([\\'])/g, "\\$1")
            .replace(/[\r\t\n]/g, " ")
            .replace(/\$\{([^\}]*)\}/g, "{{= $1}}")
            .replace(
              /\{\{(\/?)(\w+|.)(?:\(((?:[^\}]|\}(?!\}))*?)?\))?(?:\s+(.*?)?)?(\(((?:[^\}]|\}(?!\}))*?)\))?\s*\}\}/g,
              function (e, i, n, s, o, r, a) {
                var l,
                  h,
                  c,
                  u = t.tmpl.tag[n];
                if (!u) throw "Template command not found: " + n;
                return (
                  (l = u._default || []),
                  r && !/\w$/.test(o) && ((o += r), (r = "")),
                  o
                    ? ((o = g(o)),
                      (a = a ? "," + g(a) + ")" : r ? ")" : ""),
                      (h = r
                        ? o.indexOf(".") > -1
                          ? o + r
                          : "(" + o + ").call($item" + a
                        : o),
                      (c = r
                        ? h
                        : "(typeof(" +
                          o +
                          ")==='function'?(" +
                          o +
                          ").call($item):(" +
                          o +
                          "))"))
                    : (c = h = l.$1 || "null"),
                  (s = g(s)),
                  "');" +
                    u[i ? "close" : "open"]
                      .split("$notnull_1")
                      .join(
                        o
                          ? "typeof(" +
                              o +
                              ")!=='undefined' && (" +
                              o +
                              ")!=null"
                          : "true"
                      )
                      .split("$1a")
                      .join(c)
                      .split("$1")
                      .join(h)
                      .split("$2")
                      .join(
                        s
                          ? s.replace(
                              /\s*([^\(]+)\s*(\((.*?)\))?/g,
                              function (t, e, i, n) {
                                return (n = n ? "," + n + ")" : i ? ")" : "")
                                  ? "(" + e + ").call($item" + n
                                  : t;
                              }
                            )
                          : l.$2 || ""
                      ) +
                    "_.push('"
                );
              }
            ) +
          "');}return _;"
      );
    }
    function m(e, i) {
      e._wrap = d(e, !0, t.isArray(i) ? i : [s.test(i) ? i : t(i).html()]).join(
        ""
      );
    }
    function g(t) {
      return t ? t.replace(/\\'/g, "'").replace(/\\\\/g, "\\") : null;
    }
    function v(e) {
      var i,
        s,
        a,
        c,
        d,
        p = "_" + h,
        f = {};
      for (a = 0, c = e.length; a < c; a++)
        if (1 === (i = e[a]).nodeType) {
          for (d = (s = i.getElementsByTagName("*")).length - 1; d >= 0; d--)
            m(s[d]);
          m(i);
        }
      function m(e) {
        var i,
          s,
          a,
          c,
          d = e;
        if ((c = e.getAttribute(n))) {
          for (
            ;
            d.parentNode &&
            1 === (d = d.parentNode).nodeType &&
            !(i = d.getAttribute(n));

          );
          i !== c &&
            ((d = d.parentNode
              ? 11 === d.nodeType
                ? 0
                : d.getAttribute(n) || 0
              : 0),
            (a = o[c]) ||
              (((a = u((a = r[c]), o[d] || r[d], null, !0)).key = ++l),
              (o[l] = a)),
            h && m(c)),
            e.removeAttribute(n);
        } else
          h &&
            (a = t.data(e, "tmplItem")) &&
            (m(a.key),
            (o[a.key] = a),
            (d = (d = t.data(e.parentNode, "tmplItem")) ? d.key : 0));
        if (a) {
          for (s = a; s && s.key != d; ) s.nodes.push(e), (s = s.parent);
          delete a._ctnt, delete a._wrap, t.data(e, "tmplItem", a);
        }
        function m(t) {
          a = f[(t += p)] =
            f[t] || u(a, o[a.parent.key + p] || a.parent, null, !0);
        }
      }
    }
    function _(t, e, i, n) {
      if (!t) return c.pop();
      c.push({ _: t, tmpl: e, item: this, data: i, options: n });
    }
    function y(e, i, n) {
      return t.tmpl(t.template(e), i, n, this);
    }
    function b(e, i) {
      var n = e.options || {};
      return (n.wrapped = i), t.tmpl(t.template(e.tmpl), e.data, n, e.item);
    }
    function w(e, i) {
      var n = this._wrap;
      return t.map(
        t(t.isArray(n) ? n.join("") : n).filter(e || "*"),
        function (t) {
          return i
            ? t.innerText || t.textContent
            : t.outerHTML ||
                (function (t) {
                  var e = document.createElement("div");
                  return e.appendChild(t.cloneNode(!0)), e.innerHTML;
                })(t);
        }
      );
    }
    function x() {
      var e = this.nodes;
      t.tmpl(null, null, null, this).insertBefore(e[0]), t(e).remove();
    }
    t.each(
      {
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith",
      },
      function (i, n) {
        t.fn[i] = function (s) {
          var r,
            a,
            l,
            c,
            u = [],
            d = t(s),
            p = 1 === this.length && this[0].parentNode;
          if (
            ((e = o || {}),
            p &&
              11 === p.nodeType &&
              1 === p.childNodes.length &&
              1 === d.length)
          )
            d[n](this[0]), (u = this);
          else {
            for (a = 0, l = d.length; a < l; a++)
              (h = a),
                (r = (a > 0 ? this.clone(!0) : this).get()),
                t.fn[n].apply(t(d[a]), r),
                (u = u.concat(r));
            (h = 0), (u = this.pushStack(u, i, d.selector));
          }
          return (c = e), (e = null), t.tmpl.complete(c), u;
        };
      }
    ),
      t.fn.extend({
        tmpl: function (e, i, n) {
          return t.tmpl(this[0], e, i, n);
        },
        tmplItem: function () {
          return t.tmplItem(this[0]);
        },
        template: function (e) {
          return t.template(e, this[0]);
        },
        domManip: function (n, s, r) {
          if (n[0] && n[0].nodeType) {
            for (
              var a, l = t.makeArray(arguments), c = n.length, u = 0;
              u < c && !(a = t.data(n[u++], "tmplItem"));

            );
            c > 1 && (l[0] = [t.makeArray(n)]),
              a &&
                h &&
                (l[2] = function (e) {
                  t.tmpl.afterManip(this, e, r);
                }),
              i.apply(this, l);
          } else i.apply(this, arguments);
          return (h = 0), !e && t.tmpl.complete(o), this;
        },
      }),
      t.extend({
        tmpl: function (e, i, n, s) {
          var l,
            h = !s;
          if (h) (s = a), (e = t.template[e] || t.template(null, e)), (r = {});
          else if (!e)
            return (
              (e = s.tmpl),
              (o[s.key] = s),
              (s.nodes = []),
              s.wrapped && m(s, s.wrapped),
              t(d(s, null, s.tmpl(t, s)))
            );
          return e
            ? ("function" == typeof i && (i = i.call(s || {})),
              n && n.wrapped && m(n, n.wrapped),
              (l = t.isArray(i)
                ? t.map(i, function (t) {
                    return t ? u(n, s, e, t) : null;
                  })
                : [u(n, s, e, i)]),
              h ? t(d(s, null, l)) : l)
            : [];
        },
        tmplItem: function (e) {
          var i;
          for (
            e instanceof t && (e = e[0]);
            e &&
            1 === e.nodeType &&
            !(i = t.data(e, "tmplItem")) &&
            (e = e.parentNode);

          );
          return i || a;
        },
        template: function (e, i) {
          return i
            ? ("string" == typeof i
                ? (i = f(i))
                : i instanceof t && (i = i[0] || {}),
              i.nodeType &&
                (i = t.data(i, "tmpl") || t.data(i, "tmpl", f(i.innerHTML))),
              "string" == typeof e ? (t.template[e] = i) : i)
            : e
            ? "string" != typeof e
              ? t.template(null, e)
              : t.template[e] || t.template(null, s.test(e) ? e : t(e))
            : null;
        },
        encode: function (t) {
          return ("" + t)
            .split("<")
            .join("&lt;")
            .split(">")
            .join("&gt;")
            .split('"')
            .join("&#34;")
            .split("'")
            .join("&#39;");
        },
      }),
      t.extend(t.tmpl, {
        tag: {
          tmpl: {
            _default: { $2: "null" },
            open: "if($notnull_1){_=_.concat($item.nest($1,$2));}",
          },
          wrap: {
            _default: { $2: "null" },
            open: "$item.calls(_,$1,$2);_=[];",
            close: "call=$item.calls();_=call._.concat($item.wrap(call,_));",
          },
          each: {
            _default: { $2: "$index, $value" },
            open: "if($notnull_1){$.each($1a,function($2){with(this){",
            close: "}});}",
          },
          if: { open: "if(($notnull_1) && $1a){", close: "}" },
          else: {
            _default: { $1: "true" },
            open: "}else if(($notnull_1) && $1a){",
          },
          html: { open: "if($notnull_1){_.push($1a);}" },
          "=": {
            _default: { $1: "$data" },
            open: "if($notnull_1){_.push($.encode($1a));}",
          },
          "!": { open: "" },
        },
        complete: function () {
          o = {};
        },
        afterManip: function (e, i, n) {
          var s =
            11 === i.nodeType
              ? t.makeArray(i.childNodes)
              : 1 === i.nodeType
              ? [i]
              : [];
          n.call(e, i), v(s), h++;
        },
      });
  })(jQuery),
  (jQuery.cookie = function (t, e, i) {
    if (void 0 === e) {
      var n = null;
      if (document.cookie && "" != document.cookie)
        for (var s = document.cookie.split(";"), o = 0; o < s.length; o++) {
          var r = jQuery.trim(s[o]);
          if (r.substring(0, t.length + 1) == t + "=") {
            n = decodeURIComponent(r.substring(t.length + 1));
            break;
          }
        }
      return n;
    }
    (i = i || {}), null === e && ((e = ""), (i.expires = -1));
    var a,
      l = "";
    i.expires &&
      ("number" == typeof i.expires || i.expires.toUTCString) &&
      ("number" == typeof i.expires
        ? (a = new Date()).setTime(a.getTime() + 24 * i.expires * 60 * 60 * 1e3)
        : (a = i.expires),
      (l = "; expires=" + a.toUTCString()));
    var h = i.path ? "; path=" + i.path : "",
      c = i.domain ? "; domain=" + i.domain : "",
      u = i.secure ? "; secure" : "";
    document.cookie = [t, "=", encodeURIComponent(e), l, h, c, u].join("");
  }),
  (Shopify.Products = (function () {
    var t = {
        howManyToShow: 10,
        howManyToStoreInMemory: 10,
        wrapperId: "recently-viewed-products",
        templateId: "recently-viewed-product-template",
        onComplete: null,
      },
      e = [],
      i = null,
      n = null,
      s = 0,
      o = {
        configuration: {
          expires: 90,
          path: "/",
          domain: window.location.hostname,
        },
        name: "shopify_recently_viewed",
        write: function (t) {
          jQuery.cookie(this.name, t.join(" "), this.configuration);
        },
        read: function () {
          var t = [],
            e = jQuery.cookie(this.name);
          return null !== e && (t = e.split(" ")), t;
        },
        destroy: function () {
          jQuery.cookie(this.name, null, this.configuration);
        },
        remove: function (t) {
          var e = this.read(),
            i = jQuery.inArray(t, e);
          -1 !== i && (e.splice(i, 1), this.write(e));
        },
      },
      r = function () {
        if (e.length && s < t.howManyToShow) {
          const getVariantData = (productTitle) => `{
            product(handle:"${productTitle}") {
              id
              title
              handle
              productType
              onlineStoreUrl
              featuredImage {
                url
              }
              metafield(namespace: "custom", key: "plp_overlay_text") {
                value
              }
              variants(first: 1) {
                edges {
                  node {
                    priceV2 {
                      amount
                    }
                    compareAtPrice {
                      amount
                    }
                  }
                }
              }
            }
          }`;

          const store_access_token = "07b33ee4b5ac4ec571d87fb6545b94a1";
          const store_domain = "malone-souliers.myshopify.com";

          // 4. Define options
          const options = {
            method: "post",
            headers: {
              "Content-Type": "application/graphql",
              "X-Shopify-Storefront-Access-Token": store_access_token,
            },
            body: getVariantData(e[0]),
          };

          // 5. Fetch data
          fetch(`https://${store_domain}/api/2024-07/graphql.json`, options)
            .then((res) => res.json())
            .then(function (t) {
              n.tmpl(t.data.product).appendTo(i), e.shift(), s++, r();
            });

          /*jQuery.ajax({
            dataType: "json",
            url: "/products/" + e[0] + ".js",
            cache: !1,
            success: function (t) {
              n.tmpl(t).appendTo(i), e.shift(), s++, r();
            },
            error: function () {
              o.remove(e[0]), e.shift(), r();
            },
          });*/
        } else {
          if ((i.show(), t.onComplete))
            try {
              t.onComplete();
            } catch (t) {}
        }
      };
    return {
      resizeImage: function (t, e) {
        if (null == e) return t;
        if ("master" == e) return t.replace(/http(s)?:/, "");
        var i = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
        if (null != i) {
          var n = t.split(i[0]),
            s = i[0];
          return (n[0] + "_" + e + s).replace(/http(s)?:/, "");
        }
        return null;
      },
      showRecentlyViewed: function (s) {
        s = s || {};
        jQuery.extend(t, s),
          (e = o.read()),
          (n = jQuery("#" + t.templateId)),
          (i = jQuery("#" + t.wrapperId)),
          (t.howManyToShow = Math.min(e.length, t.howManyToShow)),
          t.howManyToShow && n.length && i.length && r();
      },
      getConfig: function () {
        return t;
      },
      clearList: function () {
        o.destroy();
      },
      recordRecentlyViewed: function (e) {
        e = e || {};
        jQuery.extend(t, e);
        var i = o.read();
        if (-1 !== window.location.pathname.indexOf("/products/")) {
          var n = window.location.pathname.match(
              /\/products\/([a-z0-9\-]+)/
            )[1],
            s = jQuery.inArray(n, i);
          -1 === s
            ? (i.unshift(n), (i = i.splice(0, t.howManyToStoreInMemory)))
            : (i.splice(s, 1), i.unshift(n)),
            o.write(i);
        }
      },
    };
  })()),
  Shopify.Products.recordRecentlyViewed();
var malone,
  Froogaloop = (function () {
    function t(e) {
      return new t.fn.init(e);
    }
    function e(t, e, i) {
      if (!i.contentWindow.postMessage) return !1;
      (t = JSON.stringify({ method: t, value: e })),
        i.contentWindow.postMessage(t, r);
    }
    function i(t) {
      var e, i;
      try {
        i = (e = JSON.parse(t.data)).event || e.method;
      } catch (t) {}
      if (
        ("ready" != i || o || (o = !0),
        !/^https?:\/\/player.vimeo.com/.test(t.origin))
      )
        return !1;
      "*" === r && (r = t.origin), (t = e.value);
      var n = e.data,
        a = "" === a ? null : e.player_id;
      return (
        (e = a ? s[a][i] : s[i]),
        (i = []),
        !!e &&
          (void 0 !== t && i.push(t),
          n && i.push(n),
          a && i.push(a),
          0 < i.length ? e.apply(null, i) : e.call())
      );
    }
    function n(t, e, i) {
      i ? (s[i] || (s[i] = {}), (s[i][t] = e)) : (s[t] = e);
    }
    var s = {},
      o = !1,
      r = "*";
    return (
      (t.fn = t.prototype =
        {
          element: null,
          init: function (t) {
            return (
              "string" == typeof t && (t = document.getElementById(t)),
              (this.element = t),
              this
            );
          },
          api: function (t, i) {
            if (!this.element || !t) return !1;
            var s = this.element,
              o = "" !== s.id ? s.id : null,
              r = i && i.constructor && i.call && i.apply ? null : i,
              a = i && i.constructor && i.call && i.apply ? i : null;
            return a && n(t, a, o), e(t, r, s), this;
          },
          addEvent: function (t, i) {
            if (!this.element) return !1;
            var s = this.element,
              r = "" !== s.id ? s.id : null;
            return (
              n(t, i, r),
              "ready" != t
                ? e("addEventListener", t, s)
                : "ready" == t && o && i.call(null, r),
              this
            );
          },
          removeEvent: function (t) {
            if (!this.element) return !1;
            var i = this.element,
              n = "" !== i.id ? i.id : null;
            t: {
              if (n && s[n]) {
                if (!s[n][t]) {
                  n = !1;
                  break t;
                }
                s[n][t] = null;
              } else {
                if (!s[t]) {
                  n = !1;
                  break t;
                }
                s[t] = null;
              }
              n = !0;
            }
            "ready" != t && n && e("removeEventListener", t, i);
          },
        }),
      (t.fn.init.prototype = t.fn),
      window.addEventListener
        ? window.addEventListener("message", i, !1)
        : window.attachEvent("onmessage", i),
      (window.Froogaloop = window.$f = t)
    );
  })();
function _classCallCheck(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(t, e) {
  for (var i = 0; i < e.length; i++) {
    var n = e[i];
    (n.enumerable = n.enumerable || !1),
      (n.configurable = !0),
      "value" in n && (n.writable = !0),
      Object.defineProperty(t, n.key, n);
  }
}
function _createClass(t, e, i) {
  return (
    e && _defineProperties(t.prototype, e), i && _defineProperties(t, i), t
  );
}
function _typeof(t) {
  return (_typeof =
    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
      ? function (t) {
          return typeof t;
        }
      : function (t) {
          return t &&
            "function" == typeof Symbol &&
            t.constructor === Symbol &&
            t !== Symbol.prototype
            ? "symbol"
            : typeof t;
        })(t);
}
(window.theme = window.theme || {}),
  (window.theme = window.theme || {}),
  (theme.Sections = function () {
    (this.constructors = {}),
      (this.instances = []),
      $(document)
        .on("shopify:section:load", this._onSectionLoad.bind(this))
        .on("shopify:section:unload", this._onSectionUnload.bind(this))
        .on("shopify:section:select", this._onSelect.bind(this))
        .on("shopify:section:deselect", this._onDeselect.bind(this))
        .on("shopify:block:select", this._onBlockSelect.bind(this))
        .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
  }),
  (theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
    _createInstance: function (t, e) {
      var i = $(t),
        n = i.attr("data-section-id"),
        s = i.attr("data-section-type");
      if (((e = e || this.constructors[s]), !_.isUndefined(e))) {
        var o = _.assignIn(new e(t), { id: n, type: s, container: t });
        this.instances.push(o);
      }
    },
    _onSectionLoad: function (t) {
      var e = $("[data-section-id]", t.target)[0];
      e && this._createInstance(e);
    },
    _onSectionUnload: function (t) {
      this.instances = _.filter(this.instances, function (e) {
        var i = e.id === t.detail.sectionId;
        return i && _.isFunction(e.onUnload) && e.onUnload(t), !i;
      });
    },
    _onSelect: function (t) {
      var e = _.find(this.instances, function (e) {
        return e.id === t.detail.sectionId;
      });
      !_.isUndefined(e) && _.isFunction(e.onSelect) && e.onSelect(t);
    },
    _onDeselect: function (t) {
      var e = _.find(this.instances, function (e) {
        return e.id === t.detail.sectionId;
      });
      !_.isUndefined(e) && _.isFunction(e.onDeselect) && e.onDeselect(t);
    },
    _onBlockSelect: function (t) {
      var e = _.find(this.instances, function (e) {
        return e.id === t.detail.sectionId;
      });
      !_.isUndefined(e) && _.isFunction(e.onBlockSelect) && e.onBlockSelect(t);
    },
    _onBlockDeselect: function (t) {
      var e = _.find(this.instances, function (e) {
        return e.id === t.detail.sectionId;
      });
      !_.isUndefined(e) &&
        _.isFunction(e.onBlockDeselect) &&
        e.onBlockDeselect(t);
    },
    register: function (t, e) {
      (this.constructors[t] = e),
        $("[data-section-type=" + t + "]").each(
          function (t, i) {
            this._createInstance(i, e);
          }.bind(this)
        );
    },
  })),
  (window.slate = window.slate || {}),
  (slate.utils = {
    getParameterByName: function (t, e) {
      e || (e = window.location.href), (t = t.replace(/[[\]]/g, "\\$&"));
      var i = new RegExp("[?&]" + t + "(=([^&#]*)|&|#|$)").exec(e);
      return i
        ? i[2]
          ? decodeURIComponent(i[2].replace(/\+/g, " "))
          : ""
        : null;
    },
    keyboardKeys: {
      TAB: 9,
      ENTER: 13,
      ESCAPE: 27,
      LEFTARROW: 37,
      RIGHTARROW: 39,
    },
  }),
  (window.slate = window.slate || {}),
  (slate.rte = {
    wrapTable: function (t) {
      t.$tables.wrap('<div class="' + t.tableWrapperClass + '"></div>');
    },
    wrapIframe: function (t) {
      t.$iframes.each(function () {
        $(this).wrap('<div class="' + t.iframeWrapperClass + '"></div>'),
          (this.src = this.src);
      });
    },
  }),
  (window.slate = window.slate || {}),
  (theme.Images = (function () {
    return {
      preload: function (t, e) {
        "string" == typeof t && (t = [t]);
        for (var i = 0; i < t.length; i++) {
          var n = t[i];
          this.loadImage(this.getSizedImageUrl(n, e));
        }
      },
      loadImage: function (t) {
        new Image().src = t;
      },
      switchImage: function (t, e, i) {
        var n = this.imageSize(e.src),
          s = this.getSizedImageUrl(t.src, n);
        i ? i(s, t, e) : (e.src = s);
      },
      imageSize: function (t) {
        var e = t.match(
          /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
        );
        return null !== e ? (void 0 !== e[2] ? e[1] + e[2] : e[1]) : null;
      },
      getSizedImageUrl: function (t, e) {
        if (null === e) return t;
        if ("master" === e) return this.removeProtocol(t);
        var i = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (null !== i) {
          var n = t.split(i[0]),
            s = i[0];
          return this.removeProtocol(n[0] + "_" + e + s);
        }
        return null;
      },
      removeProtocol: function (t) {
        return t.replace(/http(s)?:/, "");
      },
    };
  })()),
  (theme.Currency = (function () {
    var t = "${{amount}}";
    return {
      formatMoney: function (e, i) {
        "string" == typeof e && (e = e.replace(".", ""));
        var n = "",
          s = /\{\{\s*(\w+)\s*\}\}/,
          o = i || t;
        function r(t, e, i, n) {
          if (((i = i || ","), (n = n || "."), isNaN(t) || null === t))
            return 0;
          var s = (t = (t / 100).toFixed(e)).split(".");
          return (
            s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
            (s[1] ? n + s[1] : "")
          );
        }
        switch (o.match(s)[1]) {
          case "amount":
            n = r(e, 2);
            break;
          case "amount_no_decimals":
            n = r(e, 0);
            break;
          case "amount_with_comma_separator":
            n = r(e, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            n = r(e, 0, ".", ",");
            break;
          case "amount_no_decimals_with_space_separator":
            n = r(e, 0, " ");
            break;
          case "amount_with_apostrophe_separator":
            n = r(e, 2, "'");
        }
        return o.replace(s, n);
      },
    };
  })()),
  (slate.Variants = (function () {
    function t(t) {
      (this.$container = t.$container),
        (this.product = t.product),
        (this.singleOptionSelector = t.singleOptionSelector),
        (this.originalSelectorId = t.originalSelectorId),
        (this.enableHistoryState = t.enableHistoryState),
        (this.currentVariant = this._getVariantFromOptions()),
        $(this.singleOptionSelector, this.$container).on(
          "change",
          this._onSelectChange.bind(this)
        );
    }
    return (
      (t.prototype = _.assignIn({}, t.prototype, {
        _getCurrentOptions: function () {
          var t = _.map(
            $(this.singleOptionSelector, this.$container),
            function (t) {
              var e = $(t),
                i = e.attr("type"),
                n = {};
              return "radio" === i || "checkbox" === i
                ? !!e[0].checked &&
                    ((n.value = e.val()), (n.index = e.data("index")), n)
                : ((n.value = e.val()), (n.index = e.data("index")), n);
            }
          );
          return (t = _.compact(t));
        },
        _getVariantFromOptions: function () {
          var t = this._getCurrentOptions(),
            e = this.product.variants;
          return _.find(e, function (e) {
            return t.every(function (t) {
              return _.isEqual(e[t.index], t.value);
            });
          });
        },
        _onSelectChange: function () {
          var t = this._getVariantFromOptions();
          this.$container.trigger({ type: "variantChange", variant: t }),
            t &&
              (this._updateMasterSelect(t),
              this._updateImages(t),
              this._updatePrice(t),
              (this.currentVariant = t),
              this.enableHistoryState && this._updateHistoryState(t));
        },
        _updateImages: function (t) {
          var e = t.featured_image || {},
            i = this.currentVariant.featured_image || {};
          t.featured_image &&
            e.src !== i.src &&
            this.$container.trigger({ type: "variantImageChange", variant: t });
        },
        _updatePrice: function (t) {
          (t.price === this.currentVariant.price &&
            t.compare_at_price === this.currentVariant.compare_at_price) ||
            this.$container.trigger({ type: "variantPriceChange", variant: t });
        },
        _updateHistoryState: function (t) {
          if (history.replaceState && t) {
            var e =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname +
              "?variant=" +
              t.id;
            window.history.replaceState({ path: e }, "", e);
          }
        },
        _updateMasterSelect: function (t) {
          $(this.originalSelectorId, this.$container).val(t.id);
        },
      })),
      t
    );
  })()),
  (theme.Product = (function () {
    function t(t) {
      var e = (this.$container = $(t)),
        i = e.attr("data-section-id");
      (this.ajaxEnabled = !0),
        (this.settings = {
          mediaQueryMediumUp: "screen and (min-width: 750px)",
          mediaQuerySmall: "screen and (max-width: 749px)",
          bpSmall: !1,
          enableHistoryState: e.data("enable-history-state") || !1,
          namespace: ".slideshow-" + i,
          sectionId: i,
          sliderActive: !1,
          zoomEnabled: !1,
        }),
        (this.selectors = {
          addToCart: "[data-add-to-cart]",
          addToCartText: "[data-add-to-cart-text]",
          cartCount: "[data-cart-count]",
          cartCountBubble: "[data-cart-count-bubble]",
          cartPopup: "[data-cart-popup]",
          cartPopupCartQuantity: "[data-cart-popup-cart-quantity]",
          cartPopupClose: "[data-cart-popup-close]",
          cartPopupDismiss: "[data-cart-popup-dismiss]",
          cartPopupImage: "[data-cart-popup-image]",
          cartPopupImageWrapper: "[data-cart-popup-image-wrapper]",
          cartPopupImagePlaceholder: "[data-cart-popup-image-placeholder]",
          cartPopupPlaceholderSize: "[data-placeholder-size]",
          cartPopupProductDetails: "[data-cart-popup-product-details]",
          cartPopupQuantity: "[data-cart-popup-quantity]",
          cartPopupQuantityLabel: "[data-cart-popup-quantity-label]",
          cartPopupTitle: "[data-cart-popup-title]",
          cartPopupWrapper: "[data-cart-popup-wrapper]",
          loader: "[data-loader]",
          loaderStatus: "[data-loader-status]",
          quantity: "[data-quantity-input]",
          SKU: ".variant-sku",
          productStatus: "[data-product-status]",
          originalSelectorId: "#ProductSelect-" + i,
          productForm: "[data-product-form]",
          errorMessage: "[data-error-message]",
          errorMessageWrapper: "[data-error-message-wrapper]",
          productImageWraps: ".product-single__photo",
          productThumbImages: ".product-single__thumbnail--" + i,
          productThumbs: ".product-single__thumbnails-" + i,
          productThumbListItem: ".product-single__thumbnails-item",
          productFeaturedImage: ".product-featured-img",
          productThumbsWrapper: ".thumbnails-wrapper",
          saleLabel: ".product-price__sale-label-" + i,
          singleOptionSelector: ".single-option-selector-" + i,
          shopifyPaymentButton: ".shopify-payment-button",
          priceContainer: "[data-price]",
          regularPrice: "[data-regular-price]",
          salePrice: "[data-sale-price]",
          unitPrice: "[data-unit-price]",
          unitPriceBaseUnit: "[data-unit-price-base-unit]",
        }),
        (this.classes = {
          cartPopupWrapperHidden: "cart-popup-wrapper--hidden",
          hidden: "hide",
          inputError: "input--error",
          productOnSale: "price--on-sale",
          productUnitAvailable: "price--unit-available",
          productUnavailable: "price--unavailable",
          cartImage: "cart-popup-item__image",
          productFormErrorMessageWrapperHidden:
            "product-form__error-message-wrapper--hidden",
          activeClass: "active-thumb",
        }),
        (this.$quantityInput = $(this.selectors.quantity, e)),
        (this.$errorMessageWrapper = $(this.selectors.errorMessageWrapper, e)),
        (this.$addToCart = $(this.selectors.addToCart, e)),
        (this.$addToCartText = $(
          this.selectors.addToCartText,
          this.$addToCart
        )),
        (this.$shopifyPaymentButton = $(
          this.selectors.shopifyPaymentButton,
          e
        )),
        (this.$loader = $(this.selectors.loader, this.$addToCart)),
        (this.$loaderStatus = $(this.selectors.loaderStatus, e)),
        $("#ProductJson-" + i).html() &&
          ((this.productSingleObject = JSON.parse(
            document.getElementById("ProductJson-" + i).innerHTML
          )),
          (this.settings.zoomEnabled = $(
            this.selectors.productImageWraps
          ).hasClass("js-zoom-enabled")),
          this._stringOverrides(),
          this._initVariants(),
          this._initAddToCart(),
          this.photoSwipe(),
          // this.stickyElements(),
          this.thumbnails());
    }
    return (
      (t.prototype = _.assignIn({}, t.prototype, {
        photoSwipe: function () {
          !(function (t) {
            for (
              var e = function (t) {
                  (t = t || window.event).preventDefault
                    ? t.preventDefault()
                    : (t.returnValue = !1);
                  var e = (function t(e, i) {
                    return e && (i(e) ? e : t(e.parentNode, i));
                  })(t.target || t.srcElement, function (t) {
                    return "A" === t.tagName;
                  });
                  if (e) {
                    for (
                      var n,
                        s = e.parentNode,
                        o = e.parentNode.childNodes,
                        r = o.length,
                        a = 0,
                        l = 0;
                      l < r;
                      l++
                    )
                      if (1 === o[l].nodeType) {
                        if (o[l] === e) {
                          n = a;
                          break;
                        }
                        a++;
                      }
                    return n >= 0 && i(n, s), !1;
                  }
                },
                i = function (t, e, i, n) {
                  var s,
                    o,
                    r,
                    a = document.querySelectorAll(".pswp")[0];
                  if (
                    ((r = (function (t) {
                      for (
                        var e,
                          i,
                          n,
                          s = t.childNodes,
                          o = s.length,
                          r = [],
                          a = 0;
                        a < o;
                        a++
                      )
                        if (1 === (t = s[a]).nodeType) {
                          (e = t.children),
                            (i = t.getAttribute("data-size").split("x")),
                            ((n = {
                              src: t.getAttribute("href"),
                              w: parseInt(i[0], 10),
                              h: parseInt(i[1], 10),
                              author: t.getAttribute("data-author"),
                            }).el = t),
                            e.length > 0 &&
                              ((n.msrc = e[0].getAttribute("src")),
                              e.length > 1 && (n.title = e[1].innerHTML));
                          var l = t.getAttribute("data-med");
                          l &&
                            ((i = t.getAttribute("data-med-size").split("x")),
                            (n.m = {
                              src: l,
                              w: parseInt(i[0], 10),
                              h: parseInt(i[1], 10),
                            })),
                            (n.o = { src: n.src, w: n.w, h: n.h }),
                            r.push(n);
                        }
                      return r;
                    })(e)),
                    (o = {
                      galleryUID: e.getAttribute("data-pswp-uid"),
                      getThumbBoundsFn: function (t) {
                        var e = r[t].el.children[0],
                          i =
                            window.pageYOffset ||
                            document.documentElement.scrollTop,
                          n = e.getBoundingClientRect();
                        return { x: n.left, y: n.top + i, w: n.width };
                      },
                      addCaptionHTMLFn: function (t, e, i) {
                        return t.title
                          ? ((e.children[0].innerHTML =
                              t.title +
                              "<br/><small>Photo: " +
                              t.author +
                              "</small>"),
                            !0)
                          : ((e.children[0].innerText = ""), !1);
                      },
                    }),
                    n)
                  )
                    if (o.galleryPIDs) {
                      for (var l = 0; l < r.length; l++)
                        if (r[l].pid == t) {
                          o.index = l;
                          break;
                        }
                    } else o.index = parseInt(t, 10) - 1;
                  else o.index = parseInt(t, 10);
                  if (!isNaN(o.index)) {
                    for (
                      var h = document.getElementsByName("gallery-style"),
                        c = 0,
                        u = h.length;
                      c < u;
                      c++
                    )
                      if (h[c].checked) {
                        "radio-all-controls" == h[c].id ||
                          ("radio-minimal-black" == h[c].id &&
                            ((o.mainClass = "pswp--minimal--dark"),
                            (o.barsSize = { top: 0, bottom: 0 }),
                            (o.captionEl = !1),
                            (o.fullscreenEl = !1),
                            (o.shareEl = !1),
                            (o.bgOpacity = 0.85),
                            (o.tapToClose = !0),
                            (o.tapToToggleControls = !1)));
                        break;
                      }
                    i && (o.showAnimationDuration = 0),
                      (s = new PhotoSwipe(a, PhotoSwipeUI_Default, r, o));
                    var d,
                      p,
                      f = !1,
                      m = !0;
                    s.listen("beforeResize", function () {
                      var t = window.devicePixelRatio
                        ? window.devicePixelRatio
                        : 1;
                      (t = Math.min(t, 2.5)),
                        (d = s.viewportSize.x * t) >= 1200 ||
                        (!s.likelyTouchDevice && d > 800) ||
                        screen.width > 1200
                          ? f || ((f = !0), (p = !0))
                          : f && ((f = !1), (p = !0)),
                        p && !m && s.invalidateCurrItems(),
                        m && (m = !1),
                        (p = !1);
                    }),
                      s.listen("gettingData", function (t, e) {
                        f
                          ? ((e.src = e.o.src), (e.w = e.o.w), (e.h = e.o.h))
                          : ((e.src = e.m.src), (e.w = e.m.w), (e.h = e.m.h));
                      }),
                      s.init();
                  }
                },
                n = document.querySelectorAll(t),
                s = 0,
                o = n.length;
              s < o;
              s++
            )
              n[s].setAttribute("data-pswp-uid", s + 1), (n[s].onclick = e);
            var r = (function () {
              var t = window.location.hash.substring(1),
                e = {};
              if (t.length < 5) return e;
              for (var i = t.split("&"), n = 0; n < i.length; n++)
                if (i[n]) {
                  var s = i[n].split("=");
                  s.length < 2 || (e[s[0]] = s[1]);
                }
              return e.gid && (e.gid = parseInt(e.gid, 10)), e;
            })();
            r.pid && r.gid && i(r.pid, n[r.gid - 1], !0, !0);
          })(".photoswipe a");
        },
        stickyElements: function () {
          $(window).scroll(function () {
            $(window).scrollTop() > 40
              ? $(
                  ".product-info .product-images-wrapper .product-images-content .product-thumbnails .thumbnails"
                ).addClass("sticky")
              : $(
                  ".product-info .product-images-wrapper .product-images-content .product-thumbnails .thumbnails"
                ).removeClass("sticky");
            var t =
              $(".product_wrapper").offset().top +
              $(".product_wrapper").outerHeight();
            $(
              ".product-info .product-images-wrapper .product-images-content .product-thumbnails .thumbnails"
            ).removeClass("active"),
              $(
                ".product-info .product-images-wrapper .product-images-content .product-thumbnails .thumbnails"
              ).offset().top +
                $(
                  ".product-info .product-images-wrapper .product-images-content .product-thumbnails .thumbnails"
                ).outerHeight() >
                t &&
                $(
                  ".product-info .product-images-wrapper .product-images-content .product-thumbnails .thumbnails"
                ).addClass("active");
            var e =
              $(".product_wrapper").offset().top +
              $(".product_wrapper").outerHeight();
            $(".product-info .summary").removeClass("active"),
              $(".product-info .summary").offset().top +
                $(".product-info .summary").outerHeight() >
                e && $(".product-info .summary").addClass("active");
          });
        },
        thumbnails: function () {
          // $(document).scroll(function () {
          //     $(".product-info .product-images-wrapper .product-images-content .product-thumbnails .thumbnails .item").each(function () {
          //         ($(this).hasClass("video")
          //             ? $(".product-info .product-images-wrapper .product-images-content .product-images .video").offset().top
          //             : $(".product-info .product-images-wrapper .product-images-content .product-images img[data-thumbnail-id='" + $(this).find("img").attr("data-thumbnail-id") + "']").offset().top) <
          //         $(window).scrollTop() + $(window).outerHeight() / 2 &&
          //         ($(".product-info .product-images-wrapper .product-images-content .product-thumbnails .thumbnails .item").removeClass("active"), $(this).addClass("active"));
          //     });
          // }),
          //     $(".product-info .product-images-wrapper .product-images-content .product-thumbnails .thumbnails .item").click(function () {
          //         $(this).hasClass("video")
          //             ? $("html, body").animate({ scrollTop: $(".product-info .product-images-wrapper .product-images-content .product-images .video").offset().top - $("#shopify-section-header").outerHeight() - 50 }, 500)
          //             : $("html, body").animate(
          //                 {
          //                     scrollTop:
          //                         $(".product-info .product-images-wrapper .product-images-content .product-images img[data-thumbnail-id='" + $(this).find("img").attr("data-thumbnail-id") + "']").offset().top -
          //                         $("#shopify-section-header").outerHeight() -
          //                         50,
          //                 },
          //                 500
          //             );
          //     }),
          $(".product-mobile-images-carousel").owlCarousel({
            items: 1,
            margin: 0,
            nav: false,
            autoHeight: false,
          });
        },
        _stringOverrides: function () {
          (theme.productStrings = theme.productStrings || {}),
            $.extend(theme.strings, theme.productStrings);
        },
        _initVariants: function () {
          var t = {
            $container: this.$container,
            enableHistoryState:
              this.$container.data("enable-history-state") || !1,
            singleOptionSelector: this.selectors.singleOptionSelector,
            originalSelectorId: this.selectors.originalSelectorId,
            product: this.productSingleObject,
          };
          (this.variants = new slate.Variants(t)),
            this.$container.on(
              "variantChange" + this.settings.namespace,
              this._updateAvailability.bind(this)
            ),
            this.$container.on(
              "variantImageChange" + this.settings.namespace,
              this._updateImages.bind(this)
            ),
            this.$container.on(
              "variantPriceChange" + this.settings.namespace,
              this._updatePrice.bind(this)
            );
        },
        _initAddToCart: function () {
          $(this.selectors.productForm, this.$container).on(
            "submit",
            function (t) {
              if (this.$addToCart.is("[aria-disabled]")) t.preventDefault();
              else if (this.ajaxEnabled) {
                t.preventDefault(),
                  (this.$previouslyFocusedElement = $(":focus"));
                var e = this.$quantityInput.val() <= 0;
                if (e)
                  this._showErrorMessage(theme.strings.quantityMinimumMessage);
                else if (e || !this.ajaxEnabled);
                else {
                  this._handleButtonLoadingState(!0);
                  var i = $(this.selectors.productForm, this.$container);
                  this._addItemToCart(i);
                }
              }
            }.bind(this)
          );
        },
        _addItemToCart: function (t) {
          var data_obj = t.serializeArray();
          // console.log("data_obj");
          // console.log(data_obj);
          for (var i = 0; i < data_obj.length; i++) {
            if (
              data_obj[i].name == "is_preorder" &&
              data_obj[i].value == "true"
            ) {
              // console.log("preorder_date true");
            }
          }
          var e = {
            url: "/cart/add.js",
            data: $(t).serializeArray(),
            dataType: "json",
          };
          $.post(e)
            .done(
              function (t) {
                addToCartOk(t), this._handleButtonLoadingState(!1);
              }.bind(this)
            )
            .fail(
              function (t) {
                this.$previouslyFocusedElement.focus();
                var e = t.responseJSON
                  ? t.responseJSON.description
                  : theme.strings.cartError;
                this._showErrorMessage(e), this._handleButtonLoadingState(!1);
              }.bind(this)
            );
        },
        _handleButtonLoadingState: function (t) {
          t
            ? (this.$addToCart.attr("aria-disabled", !0),
              this.$addToCartText.addClass(this.classes.hidden),
              this.$loader.removeClass(this.classes.hidden),
              this.$shopifyPaymentButton.attr("disabled", !0),
              this.$loaderStatus.attr("aria-hidden", !1))
            : (this.$addToCart.removeAttr("aria-disabled"),
              this.$addToCartText.removeClass(this.classes.hidden),
              this.$loader.addClass(this.classes.hidden),
              this.$shopifyPaymentButton.removeAttr("disabled"),
              this.$loaderStatus.attr("aria-hidden", !0));
        },
        _showErrorMessage: function (t) {
          alert(t);
        },
        _updateAddToCart: function (t) {
          var e = t.variant;
          e
            ? e.available
              ? (this.$addToCart
                  .removeAttr("aria-disabled")
                  .attr("aria-label", theme.strings.addToCart),
                $(this.selectors.addToCartText, this.$container).text(
                  theme.strings.addToCart
                ),
                this.$shopifyPaymentButton.show())
              : (this.$addToCart
                  .attr("aria-disabled", !0)
                  .attr("aria-label", theme.strings.soldOut),
                $(this.selectors.addToCartText, this.$container).text(
                  theme.strings.soldOut
                ),
                this.$shopifyPaymentButton.hide())
            : (this.$addToCart
                .attr("aria-disabled", !0)
                .attr("aria-label", theme.strings.unavailable),
              $(this.selectors.addToCartText, this.$container).text(
                theme.strings.unavailable
              ),
              this.$shopifyPaymentButton.hide());
        },
        _updateAvailability: function (t) {
          this._updateAddToCart(t), this._updatePrice(t);
        },
        _updateImages: function (t) {
          t.variant.featured_image.id;
        },
        _updatePrice: function (t) {
          var e = t.variant,
            i = $(this.selectors.priceContainer, this.$container),
            n = $(this.selectors.regularPrice, i),
            s = $(this.selectors.salePrice, i),
            o = $(this.selectors.unitPrice, i),
            r = $(this.selectors.unitPriceBaseUnit, i);
          i
            .removeClass(this.classes.productUnavailable)
            .removeClass(this.classes.productOnSale)
            .removeClass(this.classes.productUnitAvailable)
            .removeAttr("aria-hidden"),
            e
              ? (e.compare_at_price > e.price
                  ? (n.html(
                      theme.Currency.formatMoney(
                        e.compare_at_price,
                        theme.moneyFormat
                      )
                    ),
                    s.html(
                      theme.Currency.formatMoney(e.price, theme.moneyFormat)
                    ),
                    i.addClass(this.classes.productOnSale))
                  : n.html(
                      theme.Currency.formatMoney(e.price, theme.moneyFormat)
                    ),
                e.unit_price &&
                  (o.html(
                    theme.Currency.formatMoney(e.unit_price, theme.moneyFormat)
                  ),
                  r.html(this._getBaseUnit(e)),
                  i.addClass(this.classes.productUnitAvailable)))
              : i
                  .addClass(this.classes.productUnavailable)
                  .attr("aria-hidden", !0);
        },
        _getBaseUnit: function (t) {
          return 1 === t.unit_price_measurement.reference_value
            ? t.unit_price_measurement.reference_unit
            : t.unit_price_measurement.reference_value +
                t.unit_price_measurement.reference_unit;
        },
        onUnload: function () {
          this.$container.off(this.settings.namespace);
        },
      })),
      t
    );
  })()),
  (theme.HeaderSection = (function () {
    function t(t) {
      this.fixedHeader(),
        this.currencyForm(),
        this.menu(),
        this.search(),
        this.newsletter(),
        this.cart();
    }
    return (
      (t.prototype = $.extend({}, t.prototype, {
        fixedHeader: function () {
          $(window).on("resize scroll", function () {
            $("header .notification").length > 0 &&
              $("header .notification").outerHeight(),
              $(window).scrollTop() > 100
                ? $("header .top-center, header").addClass("fixed")
                : $("header .top-center, header").removeClass("fixed");
          });
        },
        currencyForm: function () {
          $("#currency_form select").on("change", function () {
            console.log("CHANGE CURRENCY");
            $(this).parents("form").submit();
          });
        },
        menu: function () {
          $("header .top-center .navbar .navbar-toggler").click(function () {
            $("#navbarNav").addClass("active"),
              $("header .top-center").addClass("opened-mobile-menu");
          }),
            $("header .top-center .navbar .close-navbar").click(function () {
              $("#navbarNav").removeClass("active"),
                $("header .top-center").removeClass("opened-mobile-menu");
            }),
            $(
              "header .top-center .navbar .navbar-nav li.nav-item .nav-link"
            ).click(function () {
              if (
                $(window).outerWidth() < 992 &&
                ($(this).next(".sub-menu").hasClass("active")
                  ? $(this).next(".sub-menu").removeClass("active")
                  : $(this).next(".sub-menu").addClass("active"),
                $(this).next(".sub-menu").length > 0)
              )
                return !1;
            });
        },
        search: function () {
          $(
            "header .top-center .right ul li.search a, header .close-search"
          ).click(function () {
            return (
              $("#instant-search").hasClass("active")
                ? $("#instant-search").removeClass("active")
                : $("#instant-search").addClass("active"),
              !1
            );
          }),
            setInterval(function () {
              $(
                "body .ui-autocomplete .ui-menu-item .as_magento_suggest .as_img_container .as_magento_img"
              ).each(function () {
                $(this).attr("src") != $(this).attr("src_t2") &&
                  $(this).attr(
                    "src",
                    $(this)
                      .attr("src_t2")
                      .replace("small", "large")
                      .replace("medium", "large")
                  );
              });
            }, 50);
        },
        newsletter: function () {
          $("#newsletter").length > 0 &&
            ($.cookie("newsletter") ||
              setTimeout(function () {
                $("#newsletter").addClass("active");
              }, $("#newsletter").attr("data-show-after")),
            $("#newsletter .close-newsletter").click(function () {
              return (
                $.cookie("newsletter", "true", { expires: 72e3 }),
                $("#newsletter").removeClass("active"),
                !1
              );
            }));
        },
        cart: function () {
          $("header .top-center .right ul li.cart a").click(function () {
            return (
              $(".header__wrap").hasClass("open-cart")
                ? $(".header__wrap").removeClass("open-cart")
                : $(".header__wrap").addClass("open-cart"),
              !1
            );
          }),
            $(document).click(function (t) {
              $(t.target).closest(".dropdown-cart, .right").length ||
                $(".header__wrap").removeClass("open-cart");
            });
        },
        forceReload: function () {
          this.fixedHeader(),
            this.currencyForm(),
            this.menu(),
            this.search(),
            this.newsletter(),
            this.cart();
        },
        onSelect: function () {},
        onDeselect: function () {},
        onUnload: function () {},
      })),
      t
    );
  })()),
  (theme.SliderSection = (function () {
    function t(t) {
      this.navigation(),
        this.setHeight(),
        this.init(),
        this.video(),
        this.darkWhite();
    }
    return (
      (t.prototype = $.extend({}, t.prototype, {
        navigation: function () {
          setTimeout(function () {
            $("#slider .owl-carousel .owl-next").addClass("active");
          }, 200),
            $("body").on(
              "animationend webkitAnimationEnd oAnimationEnd",
              "#slider .owl-carousel .owl-next svg circle",
              function () {
                $("#slider .owl-carousel").trigger("next.owl.carousel"),
                  $("#slider .owl-carousel .owl-next").removeClass("active"),
                  setTimeout(function () {
                    $("#slider .owl-carousel .owl-next").addClass("active");
                  }, 50);
              }
            ),
            $("body").on(
              "click",
              "#slider .owl-carousel .owl-next, #slider .owl-carousel .owl-prev",
              function () {
                $("#slider .owl-carousel .owl-next").removeClass("active");
              }
            );
        },
        setHeight: function () {
          $(window).on("load", function () {
            /*$("#slider .item img, #slider .item video, #slider, #slider .item .vimeo-wrapper").height($(window).outerHeight())*/
          }),
            $(window).on("load resize", function () {
              $(window).width() >
                767; /*&&$("#slider .item img, #slider .item video, #slider, #slider .item .vimeo-wrapper").height($(window).outerHeight())*/
            });
        },
        init: function () {
          $("#slider .owl-carousel")
            .owlCarousel({
              items: 1,
              margin: 0,
              nav: !0,
              loop: !1,
              navText: [
                '<svg><circle class="outer" cx="17" cy="17" r="17" transform="rotate(-90, 17, 17)"></circle></svg>',
                '<svg><circle class="outer" cx="17" cy="17" r="17" transform="rotate(-90, 17, 17)"></circle></svg>',
              ],
              animateOut: "fadeOut",
              animateIn: "fadeIn",
            })
            .on("dragged.owl.carousel", function (t) {
              $("#slider .owl-carousel .owl-next").removeClass("active");
            });
        },
        video: function () {
          $("#slider video").each(function () {
            this.controls = !1;
          }),
            $("#slider video").length > 0 &&
              ($("#slider video").each(function () {
                $(this).get(0).play();
              }),
              setTimeout(function () {
                $("#slider video").each(function () {
                  $(this).get(0).pause();
                });
              }, 1e3),
              setInterval(function () {
                $("#slider .owl-item.active video").length > 0 &&
                  $("#slider .owl-item.active video").each(function () {
                    $(this).get(0).play();
                  });
              }, 200));
        },
        darkWhite: function () {
          setInterval(function () {
            $("#slider .owl-item.active .dark-item").length > 0
              ? $("header .top-center, #slider").addClass("dark")
              : $("header .top-center, #slider").removeClass("dark");
          }, 200);
        },
        forceReload: function () {
          this.navigation(),
            this.setHeight(),
            this.init(),
            this.video(),
            this.darkWhite();
        },
        onSelect: function () {},
        onDeselect: function () {},
        onUnload: function () {},
      })),
      t
    );
  })()),
  (theme.InstagramSection = (function () {
    function t(t) {
      this.init();
    }
    return (
      (t.prototype = $.extend({}, t.prototype, {
        init: function () {
          $(".section-instagram .relative").addClass("first"),
            $(".section-instagram .relative.first")
              .clone()
              .appendTo(".section-instagram__wrap .wrap-relative"),
            $(".section-instagram .relative.first")
              .eq(1)
              .removeClass("first")
              .addClass("second"),
            $(".section-instagram .relative.first")
              .clone()
              .appendTo(".section-instagram__wrap .wrap-relative"),
            $(".section-instagram .relative.first")
              .eq(1)
              .removeClass("first")
              .addClass("third"),
            $(".section-instagram .relative.first")
              .clone()
              .appendTo(".section-instagram__wrap .wrap-relative"),
            $(".section-instagram .relative.first")
              .eq(1)
              .removeClass("first")
              .addClass("fourth"),
            $(".section-instagram .relative.first")
              .clone()
              .appendTo(".section-instagram__wrap .wrap-relative"),
            $(".section-instagram .relative.first")
              .eq(1)
              .removeClass("first")
              .addClass("fifth"),
            $(".section-instagram .relative.first")
              .clone()
              .appendTo(".section-instagram__wrap .wrap-relative"),
            $(".section-instagram .relative.first")
              .eq(1)
              .removeClass("first")
              .addClass("sixth"),
            $(".section-instagram .relative.first")
              .clone()
              .appendTo(".section-instagram__wrap .wrap-relative"),
            $(".section-instagram .relative.first")
              .eq(1)
              .removeClass("first")
              .addClass("seventh"),
            $(".section-instagram .relative.first")
              .clone()
              .appendTo(".section-instagram__wrap .wrap-relative"),
            $(".section-instagram .relative.first")
              .eq(1)
              .removeClass("first")
              .addClass("eighth"),
            $(".section-instagram .relative.first")
              .clone()
              .appendTo(".section-instagram__wrap .wrap-relative"),
            $(".section-instagram .relative.first")
              .eq(1)
              .removeClass("first")
              .addClass("ninth");
        },
        forceReload: function () {
          this.init();
        },
        onSelect: function () {},
        onDeselect: function () {},
        onUnload: function () {},
      })),
      t
    );
  })()),
  (theme.WeeklyCurationSection = (function () {
    function t(t) {
      this.init();
    }
    return (
      (t.prototype = $.extend({}, t.prototype, {
        init: function () {
          var t = !1;
          $(".section-weekly-curation__elements").on(
            "click",
            ".owl-item.active .section-weekly-curation__elements__element",
            function (t) {
              window.location.href = $(this).attr("data-href");
            }
          ),
            $(".section-weekly-curation__elements").on(
              "click",
              ".owl-item.active + .owl-item:not(.active) .section-weekly-curation__elements__element, .owl-item.active + .owl-item:not(.active) + .owl-item:not(.active) .section-weekly-curation__elements__element, .owl-item.active + .owl-item:not(.active) + .owl-item:not(.active) + .owl-item:not(.active) .section-weekly-curation__elements__element, .owl-item.active + .owl-item.active + .owl-item:not(.active) + .owl-item:not(.active) + .owl-item:not(.active) .section-weekly-curation__elements__element, .owl-item.active + .owl-item.active + .owl-item.active + .owl-item:not(.active) + .owl-item:not(.active) + .owl-item:not(.active) .section-weekly-curation__elements__element",
              function (e) {
                $(".section-weekly-curation__elements").trigger(
                  "next.owl.carousel"
                ),
                  (t = !0),
                  setTimeout(function () {
                    t = !1;
                  }, 100);
              }
            ),
            $(".section-weekly-curation__elements").on(
              "click",
              ".owl-item:not(.active) .section-weekly-curation__elements__element",
              function () {
                0 == t &&
                  $(".section-weekly-curation__elements").trigger(
                    "prev.owl.carousel"
                  );
              }
            );
        },
        forceReload: function () {
          this.init();
        },
        onSelect: function () {},
        onDeselect: function () {},
        onUnload: function () {},
      })),
      t
    );
  })()),
  (theme.LookbookSection = (function () {
    function t(t) {
      this.init();
    }
    return (
      (t.prototype = $.extend({}, t.prototype, {
        init: function () {
          $("#lookbook video").each(function () {
            this.controls = !1;
          });
        },
        forceReload: function () {
          this.init();
        },
        onSelect: function () {},
        onDeselect: function () {},
        onUnload: function () {},
      })),
      t
    );
  })()),
  (theme.RelatedProductsSection = (function () {
    function t(t) {
      this.recommended();
    }
    return (
      (t.prototype = $.extend({}, t.prototype, {
        recommended: function () {
          $(".recommended-products").owlCarousel({
            margin: 4,
            stagePadding: 20,
            items: 2,
            nav: true,
            dots: true,
            dotsEach: true,
            responsive: {
              768: {
                items: 4,
              },
              992: {
                items: 6,
                stagePadding: 30,
              },
            },
          });
        },
        forceReload: function () {
          this.recommended();
        },
        onSelect: function () {},
        onDeselect: function () {},
        onUnload: function () {},
      })),
      t
    );
  })()),
  (theme.ProductRecommendations = (function () {
    return function (t) {
      var e = (this.$container = $(t)),
        i = e.data("productId"),
        n =
          "/recommendations/products?&section_id=product-recommendations&limit=" +
          e.data("limit") +
          "&product_id=" +
          i +
          " .product-recommendations";
      e.parent().load(n, function () {
        setTimeout(function () {
          $(".recommended-products").owlCarousel({
            margin: 4,
            stagePadding: 20,
            items: 2,
            nav: true,
            dots: true,
            dotsEach: true,
            responsive: {
              768: {
                items: 4,
              },
              992: {
                items: 6,
                stagePadding: 30,
              },
            },
          });
        }, 500);
      });
    };
  })()),
  (theme.RecentlyViewSection = (function () {
    function t(t) {
      this.recently_viewed();
    }
    return (
      (t.prototype = $.extend({}, t.prototype, {
        recently_viewed: function () {
          Shopify.Products.showRecentlyViewed({
            onComplete: function () {
              $(".recently-viewed-products").owlCarousel({
                margin: 4,
                stagePadding: 20,
                items: 2,
                nav: true,
                dots: true,
                dotsEach: true,
                responsive: {
                  768: {
                    items: 4,
                  },
                  992: {
                    items: 6,
                    stagePadding: 0,
                  },
                },
              });
            },
          });
        },
        forceReload: function () {
          this.recently_viewed();
        },
        onSelect: function () {},
        onDeselect: function () {},
        onUnload: function () {},
      })),
      t
    );
  })()),
  (theme.AftercareVideoSection = (function () {
    function t(t) {
      this.init();
    }
    return (
      (t.prototype = $.extend({}, t.prototype, {
        init: function () {
          $("#aftercare #videos .video .video-wrapper .image").click(
            function () {
              $(this).parent().addClass("active");
              var t = $(this).parent().find("iframe")[0],
                e = $f(t);
              e.api("play"),
                setTimeout(function () {
                  e.api("play");
                }, 1e3);
            }
          );
        },
        forceReload: function () {
          this.init();
        },
        onSelect: function () {},
        onDeselect: function () {},
        onUnload: function () {},
      })),
      t
    );
  })()),
  $(document).ready(function () {
    var t = new theme.Sections();
    t.register("product-template", theme.Product),
      t.register("header-section", theme.HeaderSection),
      t.register("slider-section", theme.SliderSection),
      t.register("instagram-section", theme.InstagramSection),
      t.register("weekly-curation-section", theme.WeeklyCurationSection),
      t.register("lookbook-section", theme.LookbookSection),
      t.register("related-products-section", theme.RelatedProductsSection),
      t.register("product-recommendations", theme.ProductRecommendations),
      t.register("recently-view-section", theme.RecentlyViewSection),
      t.register("aftercare-video-section", theme.AftercareVideoSection);
  }),
  $(window).on("load", function () {
    setTimeout(function () {
      $("body").addClass("active");
    }, 200);
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("jquery-bridget/jquery-bridget", ["jquery"], function (i) {
          return e(t, i);
        })
      : "object" == typeof module && module.exports
      ? (module.exports = e(t, require("jquery")))
      : (t.jQueryBridget = e(t, t.jQuery));
  })(window, function (t, e) {
    "use strict";
    function i(i, o, a) {
      (a = a || e || t.jQuery) &&
        (o.prototype.option ||
          (o.prototype.option = function (t) {
            a.isPlainObject(t) &&
              (this.options = a.extend(!0, this.options, t));
          }),
        (a.fn[i] = function (t) {
          return "string" == typeof t
            ? (function (t, e, n) {
                var s,
                  o = "$()." + i + '("' + e + '")';
                return (
                  t.each(function (t, l) {
                    var h = a.data(l, i);
                    if (h) {
                      var c = h[e];
                      if (c && "_" != e.charAt(0)) {
                        var u = c.apply(h, n);
                        s = void 0 === s ? u : s;
                      } else r(o + " is not a valid method");
                    } else r(i + " not initialized. Cannot call methods, i.e. " + o);
                  }),
                  void 0 !== s ? s : t
                );
              })(this, t, s.call(arguments, 1))
            : ((function (t, e) {
                t.each(function (t, n) {
                  var s = a.data(n, i);
                  s
                    ? (s.option(e), s._init())
                    : ((s = new o(n, e)), a.data(n, i, s));
                });
              })(this, t),
              this);
        }),
        n(a));
    }
    function n(t) {
      !t || (t && t.bridget) || (t.bridget = i);
    }
    var s = Array.prototype.slice,
      o = t.console,
      r =
        void 0 === o
          ? function () {}
          : function (t) {
              o.error(t);
            };
    return n(e || t.jQuery), i;
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("ev-emitter/ev-emitter", e)
      : "object" == typeof module && module.exports
      ? (module.exports = e())
      : (t.EvEmitter = e());
  })("undefined" != typeof window ? window : this, function () {
    function t() {}
    var e = t.prototype;
    return (
      (e.on = function (t, e) {
        if (t && e) {
          var i = (this._events = this._events || {}),
            n = (i[t] = i[t] || []);
          return -1 == n.indexOf(e) && n.push(e), this;
        }
      }),
      (e.once = function (t, e) {
        if (t && e) {
          this.on(t, e);
          var i = (this._onceEvents = this._onceEvents || {});
          return ((i[t] = i[t] || {})[e] = !0), this;
        }
      }),
      (e.off = function (t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
          var n = i.indexOf(e);
          return -1 != n && i.splice(n, 1), this;
        }
      }),
      (e.emitEvent = function (t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
          (i = i.slice(0)), (e = e || []);
          for (
            var n = this._onceEvents && this._onceEvents[t], s = 0;
            s < i.length;
            s++
          ) {
            var o = i[s];
            n && n[o] && (this.off(t, o), delete n[o]), o.apply(this, e);
          }
          return this;
        }
      }),
      (e.allOff = function () {
        delete this._events, delete this._onceEvents;
      }),
      t
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("get-size/get-size", e)
      : "object" == typeof module && module.exports
      ? (module.exports = e())
      : (t.getSize = e());
  })(window, function () {
    "use strict";
    function t(t) {
      var e = parseFloat(t);
      return -1 == t.indexOf("%") && !isNaN(e) && e;
    }
    function e(t) {
      var e = getComputedStyle(t);
      return (
        e ||
          o(
            "Style returned " +
              e +
              ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"
          ),
        e
      );
    }
    function i() {
      if (!l) {
        l = !0;
        var i = document.createElement("div");
        (i.style.width = "200px"),
          (i.style.padding = "1px 2px 3px 4px"),
          (i.style.borderStyle = "solid"),
          (i.style.borderWidth = "1px 2px 3px 4px"),
          (i.style.boxSizing = "border-box");
        var o = document.body || document.documentElement;
        o.appendChild(i);
        var r = e(i);
        (s = 200 == Math.round(t(r.width))),
          (n.isBoxSizeOuter = s),
          o.removeChild(i);
      }
    }
    function n(n) {
      if (
        (i(),
        "string" == typeof n && (n = document.querySelector(n)),
        n && "object" == typeof n && n.nodeType)
      ) {
        var o = e(n);
        if ("none" == o.display)
          return (function () {
            for (
              var t = {
                  width: 0,
                  height: 0,
                  innerWidth: 0,
                  innerHeight: 0,
                  outerWidth: 0,
                  outerHeight: 0,
                },
                e = 0;
              a > e;
              e++
            )
              t[r[e]] = 0;
            return t;
          })();
        var l = {};
        (l.width = n.offsetWidth), (l.height = n.offsetHeight);
        for (
          var h = (l.isBorderBox = "border-box" == o.boxSizing), c = 0;
          a > c;
          c++
        ) {
          var u = r[c],
            d = o[u],
            p = parseFloat(d);
          l[u] = isNaN(p) ? 0 : p;
        }
        var f = l.paddingLeft + l.paddingRight,
          m = l.paddingTop + l.paddingBottom,
          g = l.marginLeft + l.marginRight,
          v = l.marginTop + l.marginBottom,
          _ = l.borderLeftWidth + l.borderRightWidth,
          y = l.borderTopWidth + l.borderBottomWidth,
          b = h && s,
          w = t(o.width);
        !1 !== w && (l.width = w + (b ? 0 : f + _));
        var x = t(o.height);
        return (
          !1 !== x && (l.height = x + (b ? 0 : m + y)),
          (l.innerWidth = l.width - (f + _)),
          (l.innerHeight = l.height - (m + y)),
          (l.outerWidth = l.width + g),
          (l.outerHeight = l.height + v),
          l
        );
      }
    }
    var s,
      o =
        "undefined" == typeof console
          ? function () {}
          : function (t) {
              console.error(t);
            },
      r = [
        "paddingLeft",
        "paddingRight",
        "paddingTop",
        "paddingBottom",
        "marginLeft",
        "marginRight",
        "marginTop",
        "marginBottom",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth",
        "borderBottomWidth",
      ],
      a = r.length,
      l = !1;
    return n;
  }),
  (function (t, e) {
    "use strict";
    "function" == typeof define && define.amd
      ? define("desandro-matches-selector/matches-selector", e)
      : "object" == typeof module && module.exports
      ? (module.exports = e())
      : (t.matchesSelector = e());
  })(window, function () {
    "use strict";
    var t = (function () {
      var t = window.Element.prototype;
      if (t.matches) return "matches";
      if (t.matchesSelector) return "matchesSelector";
      for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
        var n = e[i] + "MatchesSelector";
        if (t[n]) return n;
      }
    })();
    return function (e, i) {
      return e[t](i);
    };
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "fizzy-ui-utils/utils",
          ["desandro-matches-selector/matches-selector"],
          function (i) {
            return e(t, i);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(t, require("desandro-matches-selector")))
      : (t.fizzyUIUtils = e(t, t.matchesSelector));
  })(window, function (t, e) {
    var i = {
        extend: function (t, e) {
          for (var i in e) t[i] = e[i];
          return t;
        },
        modulo: function (t, e) {
          return ((t % e) + e) % e;
        },
      },
      n = Array.prototype.slice;
    (i.makeArray = function (t) {
      return Array.isArray(t)
        ? t
        : null == t
        ? []
        : "object" == typeof t && "number" == typeof t.length
        ? n.call(t)
        : [t];
    }),
      (i.removeFrom = function (t, e) {
        var i = t.indexOf(e);
        -1 != i && t.splice(i, 1);
      }),
      (i.getParent = function (t, i) {
        for (; t.parentNode && t != document.body; )
          if (((t = t.parentNode), e(t, i))) return t;
      }),
      (i.getQueryElement = function (t) {
        return "string" == typeof t ? document.querySelector(t) : t;
      }),
      (i.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t);
      }),
      (i.filterFindElements = function (t, n) {
        t = i.makeArray(t);
        var s = [];
        return (
          t.forEach(function (t) {
            if (t instanceof HTMLElement) {
              if (!n) return void s.push(t);
              e(t, n) && s.push(t);
              for (var i = t.querySelectorAll(n), o = 0; o < i.length; o++)
                s.push(i[o]);
            }
          }),
          s
        );
      }),
      (i.debounceMethod = function (t, e, i) {
        i = i || 100;
        var n = t.prototype[e],
          s = e + "Timeout";
        t.prototype[e] = function () {
          var t = this[s];
          clearTimeout(t);
          var e = arguments,
            o = this;
          this[s] = setTimeout(function () {
            n.apply(o, e), delete o[s];
          }, i);
        };
      }),
      (i.docReady = function (t) {
        var e = document.readyState;
        "complete" == e || "interactive" == e
          ? setTimeout(t)
          : document.addEventListener("DOMContentLoaded", t);
      }),
      (i.toDashed = function (t) {
        return t
          .replace(/(.)([A-Z])/g, function (t, e, i) {
            return e + "-" + i;
          })
          .toLowerCase();
      });
    var s = t.console;
    return (
      (i.htmlInit = function (e, n) {
        i.docReady(function () {
          var o = i.toDashed(n),
            r = "data-" + o,
            a = document.querySelectorAll("[" + r + "]"),
            l = document.querySelectorAll(".js-" + o),
            h = i.makeArray(a).concat(i.makeArray(l)),
            c = r + "-options",
            u = t.jQuery;
          h.forEach(function (t) {
            var i,
              o = t.getAttribute(r) || t.getAttribute(c);
            try {
              i = o && JSON.parse(o);
            } catch (e) {
              return void (
                s &&
                s.error("Error parsing " + r + " on " + t.className + ": " + e)
              );
            }
            var a = new e(t, i);
            u && u.data(t, n, a);
          });
        });
      }),
      i
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "outlayer/item",
          ["ev-emitter/ev-emitter", "get-size/get-size"],
          e
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(require("ev-emitter"), require("get-size")))
      : ((t.Outlayer = {}), (t.Outlayer.Item = e(t.EvEmitter, t.getSize)));
  })(window, function (t, e) {
    "use strict";
    function i(t, e) {
      t &&
        ((this.element = t),
        (this.layout = e),
        (this.position = { x: 0, y: 0 }),
        this._create());
    }
    var n = document.documentElement.style,
      s = "string" == typeof n.transition ? "transition" : "WebkitTransition",
      o = "string" == typeof n.transform ? "transform" : "WebkitTransform",
      r = {
        WebkitTransition: "webkitTransitionEnd",
        transition: "transitionend",
      }[s],
      a = {
        transform: o,
        transition: s,
        transitionDuration: s + "Duration",
        transitionProperty: s + "Property",
        transitionDelay: s + "Delay",
      },
      l = (i.prototype = Object.create(t.prototype));
    (l.constructor = i),
      (l._create = function () {
        (this._transn = { ingProperties: {}, clean: {}, onEnd: {} }),
          this.css({ position: "absolute" });
      }),
      (l.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t);
      }),
      (l.getSize = function () {
        this.size = e(this.element);
      }),
      (l.css = function (t) {
        var e = this.element.style;
        for (var i in t) {
          e[a[i] || i] = t[i];
        }
      }),
      (l.getPosition = function () {
        var t = getComputedStyle(this.element),
          e = this.layout._getOption("originLeft"),
          i = this.layout._getOption("originTop"),
          n = t[e ? "left" : "right"],
          s = t[i ? "top" : "bottom"],
          o = parseFloat(n),
          r = parseFloat(s),
          a = this.layout.size;
        -1 != n.indexOf("%") && (o = (o / 100) * a.width),
          -1 != s.indexOf("%") && (r = (r / 100) * a.height),
          (o = isNaN(o) ? 0 : o),
          (r = isNaN(r) ? 0 : r),
          (o -= e ? a.paddingLeft : a.paddingRight),
          (r -= i ? a.paddingTop : a.paddingBottom),
          (this.position.x = o),
          (this.position.y = r);
      }),
      (l.layoutPosition = function () {
        var t = this.layout.size,
          e = {},
          i = this.layout._getOption("originLeft"),
          n = this.layout._getOption("originTop"),
          s = i ? "paddingLeft" : "paddingRight",
          o = i ? "left" : "right",
          r = i ? "right" : "left",
          a = this.position.x + t[s];
        (e[o] = this.getXValue(a)), (e[r] = "");
        var l = n ? "paddingTop" : "paddingBottom",
          h = n ? "top" : "bottom",
          c = n ? "bottom" : "top",
          u = this.position.y + t[l];
        (e[h] = this.getYValue(u)),
          (e[c] = ""),
          this.css(e),
          this.emitEvent("layout", [this]);
      }),
      (l.getXValue = function (t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && !e
          ? (t / this.layout.size.width) * 100 + "%"
          : t + "px";
      }),
      (l.getYValue = function (t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && e
          ? (t / this.layout.size.height) * 100 + "%"
          : t + "px";
      }),
      (l._transitionTo = function (t, e) {
        this.getPosition();
        var i = this.position.x,
          n = this.position.y,
          s = t == this.position.x && e == this.position.y;
        if ((this.setPosition(t, e), !s || this.isTransitioning)) {
          var o = t - i,
            r = e - n,
            a = {};
          (a.transform = this.getTranslate(o, r)),
            this.transition({
              to: a,
              onTransitionEnd: { transform: this.layoutPosition },
              isCleaning: !0,
            });
        } else this.layoutPosition();
      }),
      (l.getTranslate = function (t, e) {
        return (
          "translate3d(" +
          (t = this.layout._getOption("originLeft") ? t : -t) +
          "px, " +
          (e = this.layout._getOption("originTop") ? e : -e) +
          "px, 0)"
        );
      }),
      (l.goTo = function (t, e) {
        this.setPosition(t, e), this.layoutPosition();
      }),
      (l.moveTo = l._transitionTo),
      (l.setPosition = function (t, e) {
        (this.position.x = parseFloat(t)), (this.position.y = parseFloat(e));
      }),
      (l._nonTransition = function (t) {
        for (var e in (this.css(t.to),
        t.isCleaning && this._removeStyles(t.to),
        t.onTransitionEnd))
          t.onTransitionEnd[e].call(this);
      }),
      (l.transition = function (t) {
        if (parseFloat(this.layout.options.transitionDuration)) {
          var e = this._transn;
          for (var i in t.onTransitionEnd) e.onEnd[i] = t.onTransitionEnd[i];
          for (i in t.to)
            (e.ingProperties[i] = !0), t.isCleaning && (e.clean[i] = !0);
          if (t.from) {
            this.css(t.from);
            this.element.offsetHeight;
            null;
          }
          this.enableTransition(t.to),
            this.css(t.to),
            (this.isTransitioning = !0);
        } else this._nonTransition(t);
      });
    var h =
      "opacity," +
      (function (t) {
        return t.replace(/([A-Z])/g, function (t) {
          return "-" + t.toLowerCase();
        });
      })(o);
    (l.enableTransition = function () {
      if (!this.isTransitioning) {
        var t = this.layout.options.transitionDuration;
        (t = "number" == typeof t ? t + "ms" : t),
          this.css({
            transitionProperty: h,
            transitionDuration: t,
            transitionDelay: this.staggerDelay || 0,
          }),
          this.element.addEventListener(r, this, !1);
      }
    }),
      (l.onwebkitTransitionEnd = function (t) {
        this.ontransitionend(t);
      }),
      (l.onotransitionend = function (t) {
        this.ontransitionend(t);
      });
    var c = { "-webkit-transform": "transform" };
    (l.ontransitionend = function (t) {
      if (t.target === this.element) {
        var e = this._transn,
          i = c[t.propertyName] || t.propertyName;
        if (
          (delete e.ingProperties[i],
          (function (t) {
            for (var e in t) return !1;
            return !0;
          })(e.ingProperties) && this.disableTransition(),
          i in e.clean &&
            ((this.element.style[t.propertyName] = ""), delete e.clean[i]),
          i in e.onEnd)
        )
          e.onEnd[i].call(this), delete e.onEnd[i];
        this.emitEvent("transitionEnd", [this]);
      }
    }),
      (l.disableTransition = function () {
        this.removeTransitionStyles(),
          this.element.removeEventListener(r, this, !1),
          (this.isTransitioning = !1);
      }),
      (l._removeStyles = function (t) {
        var e = {};
        for (var i in t) e[i] = "";
        this.css(e);
      });
    var u = {
      transitionProperty: "",
      transitionDuration: "",
      transitionDelay: "",
    };
    return (
      (l.removeTransitionStyles = function () {
        this.css(u);
      }),
      (l.stagger = function (t) {
        (t = isNaN(t) ? 0 : t), (this.staggerDelay = t + "ms");
      }),
      (l.removeElem = function () {
        this.element.parentNode.removeChild(this.element),
          this.css({ display: "" }),
          this.emitEvent("remove", [this]);
      }),
      (l.remove = function () {
        return s && parseFloat(this.layout.options.transitionDuration)
          ? (this.once("transitionEnd", function () {
              this.removeElem();
            }),
            void this.hide())
          : void this.removeElem();
      }),
      (l.reveal = function () {
        delete this.isHidden, this.css({ display: "" });
        var t = this.layout.options,
          e = {};
        (e[this.getHideRevealTransitionEndProperty("visibleStyle")] =
          this.onRevealTransitionEnd),
          this.transition({
            from: t.hiddenStyle,
            to: t.visibleStyle,
            isCleaning: !0,
            onTransitionEnd: e,
          });
      }),
      (l.onRevealTransitionEnd = function () {
        this.isHidden || this.emitEvent("reveal");
      }),
      (l.getHideRevealTransitionEndProperty = function (t) {
        var e = this.layout.options[t];
        if (e.opacity) return "opacity";
        for (var i in e) return i;
      }),
      (l.hide = function () {
        (this.isHidden = !0), this.css({ display: "" });
        var t = this.layout.options,
          e = {};
        (e[this.getHideRevealTransitionEndProperty("hiddenStyle")] =
          this.onHideTransitionEnd),
          this.transition({
            from: t.visibleStyle,
            to: t.hiddenStyle,
            isCleaning: !0,
            onTransitionEnd: e,
          });
      }),
      (l.onHideTransitionEnd = function () {
        this.isHidden &&
          (this.css({ display: "none" }), this.emitEvent("hide"));
      }),
      (l.destroy = function () {
        this.css({
          position: "",
          left: "",
          right: "",
          top: "",
          bottom: "",
          transition: "",
          transform: "",
        });
      }),
      i
    );
  }),
  (function (t, e) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(
          "outlayer/outlayer",
          [
            "ev-emitter/ev-emitter",
            "get-size/get-size",
            "fizzy-ui-utils/utils",
            "./item",
          ],
          function (i, n, s, o) {
            return e(t, i, n, s, o);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(
          t,
          require("ev-emitter"),
          require("get-size"),
          require("fizzy-ui-utils"),
          require("./item")
        ))
      : (t.Outlayer = e(
          t,
          t.EvEmitter,
          t.getSize,
          t.fizzyUIUtils,
          t.Outlayer.Item
        ));
  })(window, function (t, e, i, n, s) {
    "use strict";
    function o(t, e) {
      var i = n.getQueryElement(t);
      if (i) {
        (this.element = i),
          l && (this.$element = l(this.element)),
          (this.options = n.extend({}, this.constructor.defaults)),
          this.option(e);
        var s = ++c;
        (this.element.outlayerGUID = s),
          (u[s] = this),
          this._create(),
          this._getOption("initLayout") && this.layout();
      } else a && a.error("Bad element for " + this.constructor.namespace + ": " + (i || t));
    }
    function r(t) {
      function e() {
        t.apply(this, arguments);
      }
      return (
        (e.prototype = Object.create(t.prototype)),
        (e.prototype.constructor = e),
        e
      );
    }
    var a = t.console,
      l = t.jQuery,
      h = function () {},
      c = 0,
      u = {};
    (o.namespace = "outlayer"),
      (o.Item = s),
      (o.defaults = {
        containerStyle: { position: "relative" },
        initLayout: !0,
        originLeft: !0,
        originTop: !0,
        resize: !0,
        resizeContainer: !0,
        transitionDuration: "0.4s",
        hiddenStyle: { opacity: 0, transform: "scale(0.001)" },
        visibleStyle: { opacity: 1, transform: "scale(1)" },
      });
    var d = o.prototype;
    n.extend(d, e.prototype),
      (d.option = function (t) {
        n.extend(this.options, t);
      }),
      (d._getOption = function (t) {
        var e = this.constructor.compatOptions[t];
        return e && void 0 !== this.options[e]
          ? this.options[e]
          : this.options[t];
      }),
      (o.compatOptions = {
        initLayout: "isInitLayout",
        horizontal: "isHorizontal",
        layoutInstant: "isLayoutInstant",
        originLeft: "isOriginLeft",
        originTop: "isOriginTop",
        resize: "isResizeBound",
        resizeContainer: "isResizingContainer",
      }),
      (d._create = function () {
        this.reloadItems(),
          (this.stamps = []),
          this.stamp(this.options.stamp),
          n.extend(this.element.style, this.options.containerStyle),
          this._getOption("resize") && this.bindResize();
      }),
      (d.reloadItems = function () {
        this.items = this._itemize(this.element.children);
      }),
      (d._itemize = function (t) {
        for (
          var e = this._filterFindItemElements(t),
            i = this.constructor.Item,
            n = [],
            s = 0;
          s < e.length;
          s++
        ) {
          var o = new i(e[s], this);
          n.push(o);
        }
        return n;
      }),
      (d._filterFindItemElements = function (t) {
        return n.filterFindElements(t, this.options.itemSelector);
      }),
      (d.getItemElements = function () {
        return this.items.map(function (t) {
          return t.element;
        });
      }),
      (d.layout = function () {
        this._resetLayout(), this._manageStamps();
        var t = this._getOption("layoutInstant"),
          e = void 0 !== t ? t : !this._isLayoutInited;
        this.layoutItems(this.items, e), (this._isLayoutInited = !0);
      }),
      (d._init = d.layout),
      (d._resetLayout = function () {
        this.getSize();
      }),
      (d.getSize = function () {
        this.size = i(this.element);
      }),
      (d._getMeasurement = function (t, e) {
        var n,
          s = this.options[t];
        s
          ? ("string" == typeof s
              ? (n = this.element.querySelector(s))
              : s instanceof HTMLElement && (n = s),
            (this[t] = n ? i(n)[e] : s))
          : (this[t] = 0);
      }),
      (d.layoutItems = function (t, e) {
        (t = this._getItemsForLayout(t)),
          this._layoutItems(t, e),
          this._postLayout();
      }),
      (d._getItemsForLayout = function (t) {
        return t.filter(function (t) {
          return !t.isIgnored;
        });
      }),
      (d._layoutItems = function (t, e) {
        if ((this._emitCompleteOnItems("layout", t), t && t.length)) {
          var i = [];
          t.forEach(function (t) {
            var n = this._getItemLayoutPosition(t);
            (n.item = t), (n.isInstant = e || t.isLayoutInstant), i.push(n);
          }, this),
            this._processLayoutQueue(i);
        }
      }),
      (d._getItemLayoutPosition = function () {
        return { x: 0, y: 0 };
      }),
      (d._processLayoutQueue = function (t) {
        this.updateStagger(),
          t.forEach(function (t, e) {
            this._positionItem(t.item, t.x, t.y, t.isInstant, e);
          }, this);
      }),
      (d.updateStagger = function () {
        var t = this.options.stagger;
        return null == t
          ? void (this.stagger = 0)
          : ((this.stagger = (function (t) {
              if ("number" == typeof t) return t;
              var e = t.match(/(^\d*\.?\d*)(\w*)/),
                i = e && e[1],
                n = e && e[2];
              return i.length ? (i = parseFloat(i)) * (p[n] || 1) : 0;
            })(t)),
            this.stagger);
      }),
      (d._positionItem = function (t, e, i, n, s) {
        n ? t.goTo(e, i) : (t.stagger(s * this.stagger), t.moveTo(e, i));
      }),
      (d._postLayout = function () {
        this.resizeContainer();
      }),
      (d.resizeContainer = function () {
        if (this._getOption("resizeContainer")) {
          var t = this._getContainerSize();
          t &&
            (this._setContainerMeasure(t.width, !0),
            this._setContainerMeasure(t.height, !1));
        }
      }),
      (d._getContainerSize = h),
      (d._setContainerMeasure = function (t, e) {
        if (void 0 !== t) {
          var i = this.size;
          i.isBorderBox &&
            (t += e
              ? i.paddingLeft +
                i.paddingRight +
                i.borderLeftWidth +
                i.borderRightWidth
              : i.paddingBottom +
                i.paddingTop +
                i.borderTopWidth +
                i.borderBottomWidth),
            (t = Math.max(t, 0)),
            (this.element.style[e ? "width" : "height"] = t + "px");
        }
      }),
      (d._emitCompleteOnItems = function (t, e) {
        function i() {
          s.dispatchEvent(t + "Complete", null, [e]);
        }
        function n() {
          ++r == o && i();
        }
        var s = this,
          o = e.length;
        if (e && o) {
          var r = 0;
          e.forEach(function (e) {
            e.once(t, n);
          });
        } else i();
      }),
      (d.dispatchEvent = function (t, e, i) {
        var n = e ? [e].concat(i) : i;
        if ((this.emitEvent(t, n), l))
          if (((this.$element = this.$element || l(this.element)), e)) {
            var s = l.Event(e);
            (s.type = t), this.$element.trigger(s, i);
          } else this.$element.trigger(t, i);
      }),
      (d.ignore = function (t) {
        var e = this.getItem(t);
        e && (e.isIgnored = !0);
      }),
      (d.unignore = function (t) {
        var e = this.getItem(t);
        e && delete e.isIgnored;
      }),
      (d.stamp = function (t) {
        (t = this._find(t)) &&
          ((this.stamps = this.stamps.concat(t)), t.forEach(this.ignore, this));
      }),
      (d.unstamp = function (t) {
        (t = this._find(t)) &&
          t.forEach(function (t) {
            n.removeFrom(this.stamps, t), this.unignore(t);
          }, this);
      }),
      (d._find = function (t) {
        return t
          ? ("string" == typeof t && (t = this.element.querySelectorAll(t)),
            (t = n.makeArray(t)))
          : void 0;
      }),
      (d._manageStamps = function () {
        this.stamps &&
          this.stamps.length &&
          (this._getBoundingRect(),
          this.stamps.forEach(this._manageStamp, this));
      }),
      (d._getBoundingRect = function () {
        var t = this.element.getBoundingClientRect(),
          e = this.size;
        this._boundingRect = {
          left: t.left + e.paddingLeft + e.borderLeftWidth,
          top: t.top + e.paddingTop + e.borderTopWidth,
          right: t.right - (e.paddingRight + e.borderRightWidth),
          bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth),
        };
      }),
      (d._manageStamp = h),
      (d._getElementOffset = function (t) {
        var e = t.getBoundingClientRect(),
          n = this._boundingRect,
          s = i(t);
        return {
          left: e.left - n.left - s.marginLeft,
          top: e.top - n.top - s.marginTop,
          right: n.right - e.right - s.marginRight,
          bottom: n.bottom - e.bottom - s.marginBottom,
        };
      }),
      (d.handleEvent = n.handleEvent),
      (d.bindResize = function () {
        t.addEventListener("resize", this), (this.isResizeBound = !0);
      }),
      (d.unbindResize = function () {
        t.removeEventListener("resize", this), (this.isResizeBound = !1);
      }),
      (d.onresize = function () {
        this.resize();
      }),
      n.debounceMethod(o, "onresize", 100),
      (d.resize = function () {
        this.isResizeBound && this.needsResizeLayout() && this.layout();
      }),
      (d.needsResizeLayout = function () {
        var t = i(this.element);
        return this.size && t && t.innerWidth !== this.size.innerWidth;
      }),
      (d.addItems = function (t) {
        var e = this._itemize(t);
        return e.length && (this.items = this.items.concat(e)), e;
      }),
      (d.appended = function (t) {
        var e = this.addItems(t);
        e.length && (this.layoutItems(e, !0), this.reveal(e));
      }),
      (d.prepended = function (t) {
        var e = this._itemize(t);
        if (e.length) {
          var i = this.items.slice(0);
          (this.items = e.concat(i)),
            this._resetLayout(),
            this._manageStamps(),
            this.layoutItems(e, !0),
            this.reveal(e),
            this.layoutItems(i);
        }
      }),
      (d.reveal = function (t) {
        if ((this._emitCompleteOnItems("reveal", t), t && t.length)) {
          var e = this.updateStagger();
          t.forEach(function (t, i) {
            t.stagger(i * e), t.reveal();
          });
        }
      }),
      (d.hide = function (t) {
        if ((this._emitCompleteOnItems("hide", t), t && t.length)) {
          var e = this.updateStagger();
          t.forEach(function (t, i) {
            t.stagger(i * e), t.hide();
          });
        }
      }),
      (d.revealItemElements = function (t) {
        var e = this.getItems(t);
        this.reveal(e);
      }),
      (d.hideItemElements = function (t) {
        var e = this.getItems(t);
        this.hide(e);
      }),
      (d.getItem = function (t) {
        for (var e = 0; e < this.items.length; e++) {
          var i = this.items[e];
          if (i.element == t) return i;
        }
      }),
      (d.getItems = function (t) {
        t = n.makeArray(t);
        var e = [];
        return (
          t.forEach(function (t) {
            var i = this.getItem(t);
            i && e.push(i);
          }, this),
          e
        );
      }),
      (d.remove = function (t) {
        var e = this.getItems(t);
        this._emitCompleteOnItems("remove", e),
          e &&
            e.length &&
            e.forEach(function (t) {
              t.remove(), n.removeFrom(this.items, t);
            }, this);
      }),
      (d.destroy = function () {
        var t = this.element.style;
        (t.height = ""),
          (t.position = ""),
          (t.width = ""),
          this.items.forEach(function (t) {
            t.destroy();
          }),
          this.unbindResize();
        var e = this.element.outlayerGUID;
        delete u[e],
          delete this.element.outlayerGUID,
          l && l.removeData(this.element, this.constructor.namespace);
      }),
      (o.data = function (t) {
        var e = (t = n.getQueryElement(t)) && t.outlayerGUID;
        return e && u[e];
      }),
      (o.create = function (t, e) {
        var i = r(o);
        return (
          (i.defaults = n.extend({}, o.defaults)),
          n.extend(i.defaults, e),
          (i.compatOptions = n.extend({}, o.compatOptions)),
          (i.namespace = t),
          (i.data = o.data),
          (i.Item = r(s)),
          n.htmlInit(i, t),
          l && l.bridget && l.bridget(t, i),
          i
        );
      });
    var p = { ms: 1, s: 1e3 };
    return (o.Item = s), o;
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(["outlayer/outlayer", "get-size/get-size"], e)
      : "object" == typeof module && module.exports
      ? (module.exports = e(require("outlayer"), require("get-size")))
      : (t.Masonry = e(t.Outlayer, t.getSize));
  })(window, function (t, e) {
    var i = t.create("masonry");
    i.compatOptions.fitWidth = "isFitWidth";
    var n = i.prototype;
    return (
      (n._resetLayout = function () {
        this.getSize(),
          this._getMeasurement("columnWidth", "outerWidth"),
          this._getMeasurement("gutter", "outerWidth"),
          this.measureColumns(),
          (this.colYs = []);
        for (var t = 0; t < this.cols; t++) this.colYs.push(0);
        (this.maxY = 0), (this.horizontalColIndex = 0);
      }),
      (n.measureColumns = function () {
        if ((this.getContainerWidth(), !this.columnWidth)) {
          var t = this.items[0],
            i = t && t.element;
          this.columnWidth = (i && e(i).outerWidth) || this.containerWidth;
        }
        var n = (this.columnWidth += this.gutter),
          s = this.containerWidth + this.gutter,
          o = s / n,
          r = n - (s % n);
        (o = Math[r && 1 > r ? "round" : "floor"](o)),
          (this.cols = Math.max(o, 1));
      }),
      (n.getContainerWidth = function () {
        var t = this._getOption("fitWidth")
            ? this.element.parentNode
            : this.element,
          i = e(t);
        this.containerWidth = i && i.innerWidth;
      }),
      (n._getItemLayoutPosition = function (t) {
        t.getSize();
        var e = t.size.outerWidth % this.columnWidth,
          i = Math[e && 1 > e ? "round" : "ceil"](
            t.size.outerWidth / this.columnWidth
          );
        i = Math.min(i, this.cols);
        for (
          var n = this[
              this.options.horizontalOrder
                ? "_getHorizontalColPosition"
                : "_getTopColPosition"
            ](i, t),
            s = { x: this.columnWidth * n.col, y: n.y },
            o = n.y + t.size.outerHeight,
            r = i + n.col,
            a = n.col;
          r > a;
          a++
        )
          this.colYs[a] = o;
        return s;
      }),
      (n._getTopColPosition = function (t) {
        var e = this._getTopColGroup(t),
          i = Math.min.apply(Math, e);
        return { col: e.indexOf(i), y: i };
      }),
      (n._getTopColGroup = function (t) {
        if (2 > t) return this.colYs;
        for (var e = [], i = this.cols + 1 - t, n = 0; i > n; n++)
          e[n] = this._getColGroupY(n, t);
        return e;
      }),
      (n._getColGroupY = function (t, e) {
        if (2 > e) return this.colYs[t];
        var i = this.colYs.slice(t, t + e);
        return Math.max.apply(Math, i);
      }),
      (n._getHorizontalColPosition = function (t, e) {
        var i = this.horizontalColIndex % this.cols;
        i = t > 1 && i + t > this.cols ? 0 : i;
        var n = e.size.outerWidth && e.size.outerHeight;
        return (
          (this.horizontalColIndex = n ? i + t : this.horizontalColIndex),
          { col: i, y: this._getColGroupY(i, t) }
        );
      }),
      (n._manageStamp = function (t) {
        var i = e(t),
          n = this._getElementOffset(t),
          s = this._getOption("originLeft") ? n.left : n.right,
          o = s + i.outerWidth,
          r = Math.floor(s / this.columnWidth);
        r = Math.max(0, r);
        var a = Math.floor(o / this.columnWidth);
        (a -= o % this.columnWidth ? 0 : 1), (a = Math.min(this.cols - 1, a));
        for (
          var l =
              (this._getOption("originTop") ? n.top : n.bottom) + i.outerHeight,
            h = r;
          a >= h;
          h++
        )
          this.colYs[h] = Math.max(l, this.colYs[h]);
      }),
      (n._getContainerSize = function () {
        this.maxY = Math.max.apply(Math, this.colYs);
        var t = { height: this.maxY };
        return (
          this._getOption("fitWidth") &&
            (t.width = this._getContainerFitWidth()),
          t
        );
      }),
      (n._getContainerFitWidth = function () {
        for (var t = 0, e = this.cols; --e && 0 === this.colYs[e]; ) t++;
        return (this.cols - t) * this.columnWidth - this.gutter;
      }),
      (n.needsResizeLayout = function () {
        var t = this.containerWidth;
        return this.getContainerWidth(), t != this.containerWidth;
      }),
      i
    );
  }),
  (function (t) {
    "function" == typeof define && define.amd
      ? define(["jquery"], t)
      : t(jQuery);
  })(function (t) {
    t.ui = t.ui || {};
    t.ui.version = "1.12.1";
    var e,
      i = 0,
      n = Array.prototype.slice;
    (t.cleanData =
      ((e = t.cleanData),
      function (i) {
        var n, s, o;
        for (o = 0; null != (s = i[o]); o++)
          try {
            (n = t._data(s, "events")) &&
              n.remove &&
              t(s).triggerHandler("remove");
          } catch (t) {}
        e(i);
      })),
      (t.widget = function (e, i, n) {
        var s,
          o,
          r,
          a = {},
          l = e.split(".")[0],
          h = l + "-" + (e = e.split(".")[1]);
        return (
          n || ((n = i), (i = t.Widget)),
          t.isArray(n) && (n = t.extend.apply(null, [{}].concat(n))),
          (t.expr[":"][h.toLowerCase()] = function (e) {
            return !!t.data(e, h);
          }),
          (t[l] = t[l] || {}),
          (s = t[l][e]),
          (o = t[l][e] =
            function (t, e) {
              if (!this._createWidget) return new o(t, e);
              arguments.length && this._createWidget(t, e);
            }),
          t.extend(o, s, {
            version: n.version,
            _proto: t.extend({}, n),
            _childConstructors: [],
          }),
          ((r = new i()).options = t.widget.extend({}, r.options)),
          t.each(n, function (e, n) {
            t.isFunction(n)
              ? (a[e] = (function () {
                  function t() {
                    return i.prototype[e].apply(this, arguments);
                  }
                  function s(t) {
                    return i.prototype[e].apply(this, t);
                  }
                  return function () {
                    var e,
                      i = this._super,
                      o = this._superApply;
                    return (
                      (this._super = t),
                      (this._superApply = s),
                      (e = n.apply(this, arguments)),
                      (this._super = i),
                      (this._superApply = o),
                      e
                    );
                  };
                })())
              : (a[e] = n);
          }),
          (o.prototype = t.widget.extend(
            r,
            { widgetEventPrefix: (s && r.widgetEventPrefix) || e },
            a,
            { constructor: o, namespace: l, widgetName: e, widgetFullName: h }
          )),
          s
            ? (t.each(s._childConstructors, function (e, i) {
                var n = i.prototype;
                t.widget(n.namespace + "." + n.widgetName, o, i._proto);
              }),
              delete s._childConstructors)
            : i._childConstructors.push(o),
          t.widget.bridge(e, o),
          o
        );
      }),
      (t.widget.extend = function (e) {
        for (
          var i, s, o = n.call(arguments, 1), r = 0, a = o.length;
          r < a;
          r++
        )
          for (i in o[r])
            (s = o[r][i]),
              o[r].hasOwnProperty(i) &&
                void 0 !== s &&
                (t.isPlainObject(s)
                  ? (e[i] = t.isPlainObject(e[i])
                      ? t.widget.extend({}, e[i], s)
                      : t.widget.extend({}, s))
                  : (e[i] = s));
        return e;
      }),
      (t.widget.bridge = function (e, i) {
        var s = i.prototype.widgetFullName || e;
        t.fn[e] = function (o) {
          var r = "string" == typeof o,
            a = n.call(arguments, 1),
            l = this;
          return (
            r
              ? this.length || "instance" !== o
                ? this.each(function () {
                    var i,
                      n = t.data(this, s);
                    return "instance" === o
                      ? ((l = n), !1)
                      : n
                      ? t.isFunction(n[o]) && "_" !== o.charAt(0)
                        ? (i = n[o].apply(n, a)) !== n && void 0 !== i
                          ? ((l = i && i.jquery ? l.pushStack(i.get()) : i), !1)
                          : void 0
                        : t.error(
                            "no such method '" +
                              o +
                              "' for " +
                              e +
                              " widget instance"
                          )
                      : t.error(
                          "cannot call methods on " +
                            e +
                            " prior to initialization; attempted to call method '" +
                            o +
                            "'"
                        );
                  })
                : (l = void 0)
              : (a.length && (o = t.widget.extend.apply(null, [o].concat(a))),
                this.each(function () {
                  var e = t.data(this, s);
                  e
                    ? (e.option(o || {}), e._init && e._init())
                    : t.data(this, s, new i(o, this));
                })),
            l
          );
        };
      }),
      (t.Widget = function () {}),
      (t.Widget._childConstructors = []),
      (t.Widget.prototype = {
        widgetName: "widget",
        widgetEventPrefix: "",
        defaultElement: "<div>",
        options: { classes: {}, disabled: !1, create: null },
        _createWidget: function (e, n) {
          (n = t(n || this.defaultElement || this)[0]),
            (this.element = t(n)),
            (this.uuid = i++),
            (this.eventNamespace = "." + this.widgetName + this.uuid),
            (this.bindings = t()),
            (this.hoverable = t()),
            (this.focusable = t()),
            (this.classesElementLookup = {}),
            n !== this &&
              (t.data(n, this.widgetFullName, this),
              this._on(!0, this.element, {
                remove: function (t) {
                  t.target === n && this.destroy();
                },
              }),
              (this.document = t(n.style ? n.ownerDocument : n.document || n)),
              (this.window = t(
                this.document[0].defaultView || this.document[0].parentWindow
              ))),
            (this.options = t.widget.extend(
              {},
              this.options,
              this._getCreateOptions(),
              e
            )),
            this._create(),
            this.options.disabled &&
              this._setOptionDisabled(this.options.disabled),
            this._trigger("create", null, this._getCreateEventData()),
            this._init();
        },
        _getCreateOptions: function () {
          return {};
        },
        _getCreateEventData: t.noop,
        _create: t.noop,
        _init: t.noop,
        destroy: function () {
          var e = this;
          this._destroy(),
            t.each(this.classesElementLookup, function (t, i) {
              e._removeClass(i, t);
            }),
            this.element
              .off(this.eventNamespace)
              .removeData(this.widgetFullName),
            this.widget().off(this.eventNamespace).removeAttr("aria-disabled"),
            this.bindings.off(this.eventNamespace);
        },
        _destroy: t.noop,
        widget: function () {
          return this.element;
        },
        option: function (e, i) {
          var n,
            s,
            o,
            r = e;
          if (0 === arguments.length) return t.widget.extend({}, this.options);
          if ("string" == typeof e)
            if (((r = {}), (n = e.split(".")), (e = n.shift()), n.length)) {
              for (
                s = r[e] = t.widget.extend({}, this.options[e]), o = 0;
                o < n.length - 1;
                o++
              )
                (s[n[o]] = s[n[o]] || {}), (s = s[n[o]]);
              if (((e = n.pop()), 1 === arguments.length))
                return void 0 === s[e] ? null : s[e];
              s[e] = i;
            } else {
              if (1 === arguments.length)
                return void 0 === this.options[e] ? null : this.options[e];
              r[e] = i;
            }
          return this._setOptions(r), this;
        },
        _setOptions: function (t) {
          var e;
          for (e in t) this._setOption(e, t[e]);
          return this;
        },
        _setOption: function (t, e) {
          return (
            "classes" === t && this._setOptionClasses(e),
            (this.options[t] = e),
            "disabled" === t && this._setOptionDisabled(e),
            this
          );
        },
        _setOptionClasses: function (e) {
          var i, n, s;
          for (i in e)
            (s = this.classesElementLookup[i]),
              e[i] !== this.options.classes[i] &&
                s &&
                s.length &&
                ((n = t(s.get())),
                this._removeClass(s, i),
                n.addClass(
                  this._classes({ element: n, keys: i, classes: e, add: !0 })
                ));
        },
        _setOptionDisabled: function (t) {
          this._toggleClass(
            this.widget(),
            this.widgetFullName + "-disabled",
            null,
            !!t
          ),
            t &&
              (this._removeClass(this.hoverable, null, "ui-state-hover"),
              this._removeClass(this.focusable, null, "ui-state-focus"));
        },
        enable: function () {
          return this._setOptions({ disabled: !1 });
        },
        disable: function () {
          return this._setOptions({ disabled: !0 });
        },
        _classes: function (e) {
          var i = [],
            n = this;
          function s(s, o) {
            var r, a;
            for (a = 0; a < s.length; a++)
              (r = n.classesElementLookup[s[a]] || t()),
                (r = e.add
                  ? t(t.unique(r.get().concat(e.element.get())))
                  : t(r.not(e.element).get())),
                (n.classesElementLookup[s[a]] = r),
                i.push(s[a]),
                o && e.classes[s[a]] && i.push(e.classes[s[a]]);
          }
          return (
            (e = t.extend(
              { element: this.element, classes: this.options.classes || {} },
              e
            )),
            this._on(e.element, { remove: "_untrackClassesElement" }),
            e.keys && s(e.keys.match(/\S+/g) || [], !0),
            e.extra && s(e.extra.match(/\S+/g) || []),
            i.join(" ")
          );
        },
        _untrackClassesElement: function (e) {
          var i = this;
          t.each(i.classesElementLookup, function (n, s) {
            -1 !== t.inArray(e.target, s) &&
              (i.classesElementLookup[n] = t(s.not(e.target).get()));
          });
        },
        _removeClass: function (t, e, i) {
          return this._toggleClass(t, e, i, !1);
        },
        _addClass: function (t, e, i) {
          return this._toggleClass(t, e, i, !0);
        },
        _toggleClass: function (t, e, i, n) {
          n = "boolean" == typeof n ? n : i;
          var s = "string" == typeof t || null === t,
            o = {
              extra: s ? e : i,
              keys: s ? t : e,
              element: s ? this.element : t,
              add: n,
            };
          return o.element.toggleClass(this._classes(o), n), this;
        },
        _on: function (e, i, n) {
          var s,
            o = this;
          "boolean" != typeof e && ((n = i), (i = e), (e = !1)),
            n
              ? ((i = s = t(i)), (this.bindings = this.bindings.add(i)))
              : ((n = i), (i = this.element), (s = this.widget())),
            t.each(n, function (n, r) {
              function a() {
                if (
                  e ||
                  (!0 !== o.options.disabled &&
                    !t(this).hasClass("ui-state-disabled"))
                )
                  return ("string" == typeof r ? o[r] : r).apply(o, arguments);
              }
              "string" != typeof r &&
                (a.guid = r.guid = r.guid || a.guid || t.guid++);
              var l = n.match(/^([\w:-]*)\s*(.*)$/),
                h = l[1] + o.eventNamespace,
                c = l[2];
              c ? s.on(h, c, a) : i.on(h, a);
            });
        },
        _off: function (e, i) {
          (i =
            (i || "").split(" ").join(this.eventNamespace + " ") +
            this.eventNamespace),
            e.off(i).off(i),
            (this.bindings = t(this.bindings.not(e).get())),
            (this.focusable = t(this.focusable.not(e).get())),
            (this.hoverable = t(this.hoverable.not(e).get()));
        },
        _delay: function (t, e) {
          var i = this;
          return setTimeout(function () {
            return ("string" == typeof t ? i[t] : t).apply(i, arguments);
          }, e || 0);
        },
        _hoverable: function (e) {
          (this.hoverable = this.hoverable.add(e)),
            this._on(e, {
              mouseenter: function (e) {
                this._addClass(t(e.currentTarget), null, "ui-state-hover");
              },
              mouseleave: function (e) {
                this._removeClass(t(e.currentTarget), null, "ui-state-hover");
              },
            });
        },
        _focusable: function (e) {
          (this.focusable = this.focusable.add(e)),
            this._on(e, {
              focusin: function (e) {
                this._addClass(t(e.currentTarget), null, "ui-state-focus");
              },
              focusout: function (e) {
                this._removeClass(t(e.currentTarget), null, "ui-state-focus");
              },
            });
        },
        _trigger: function (e, i, n) {
          var s,
            o,
            r = this.options[e];
          if (
            ((n = n || {}),
            ((i = t.Event(i)).type = (
              e === this.widgetEventPrefix ? e : this.widgetEventPrefix + e
            ).toLowerCase()),
            (i.target = this.element[0]),
            (o = i.originalEvent))
          )
            for (s in o) s in i || (i[s] = o[s]);
          return (
            this.element.trigger(i, n),
            !(
              (t.isFunction(r) &&
                !1 === r.apply(this.element[0], [i].concat(n))) ||
              i.isDefaultPrevented()
            )
          );
        },
      }),
      t.each({ show: "fadeIn", hide: "fadeOut" }, function (e, i) {
        t.Widget.prototype["_" + e] = function (n, s, o) {
          var r;
          "string" == typeof s && (s = { effect: s });
          var a = s
            ? !0 === s || "number" == typeof s
              ? i
              : s.effect || i
            : e;
          "number" == typeof (s = s || {}) && (s = { duration: s }),
            (r = !t.isEmptyObject(s)),
            (s.complete = o),
            s.delay && n.delay(s.delay),
            r && t.effects && t.effects.effect[a]
              ? n[e](s)
              : a !== e && n[a]
              ? n[a](s.duration, s.easing, o)
              : n.queue(function (i) {
                  t(this)[e](), o && o.call(n[0]), i();
                });
        };
      });
    t.widget;
    !(function () {
      var e,
        i = Math.max,
        n = Math.abs,
        s = /left|center|right/,
        o = /top|center|bottom/,
        r = /[\+\-]\d+(\.[\d]+)?%?/,
        a = /^\w+/,
        l = /%$/,
        h = t.fn.position;
      function c(t, e, i) {
        return [
          parseFloat(t[0]) * (l.test(t[0]) ? e / 100 : 1),
          parseFloat(t[1]) * (l.test(t[1]) ? i / 100 : 1),
        ];
      }
      function u(e, i) {
        return parseInt(t.css(e, i), 10) || 0;
      }
      (t.position = {
        scrollbarWidth: function () {
          if (void 0 !== e) return e;
          var i,
            n,
            s = t(
              "<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>"
            ),
            o = s.children()[0];
          return (
            t("body").append(s),
            (i = o.offsetWidth),
            s.css("overflow", "scroll"),
            i === (n = o.offsetWidth) && (n = s[0].clientWidth),
            s.remove(),
            (e = i - n)
          );
        },
        getScrollInfo: function (e) {
          var i = e.isWindow || e.isDocument ? "" : e.element.css("overflow-x"),
            n = e.isWindow || e.isDocument ? "" : e.element.css("overflow-y"),
            s =
              "scroll" === i ||
              ("auto" === i && e.width < e.element[0].scrollWidth);
          return {
            width:
              "scroll" === n ||
              ("auto" === n && e.height < e.element[0].scrollHeight)
                ? t.position.scrollbarWidth()
                : 0,
            height: s ? t.position.scrollbarWidth() : 0,
          };
        },
        getWithinInfo: function (e) {
          var i = t(e || window),
            n = t.isWindow(i[0]),
            s = !!i[0] && 9 === i[0].nodeType;
          return {
            element: i,
            isWindow: n,
            isDocument: s,
            offset: !n && !s ? t(e).offset() : { left: 0, top: 0 },
            scrollLeft: i.scrollLeft(),
            scrollTop: i.scrollTop(),
            width: i.outerWidth(),
            height: i.outerHeight(),
          };
        },
      }),
        (t.fn.position = function (e) {
          if (!e || !e.of) return h.apply(this, arguments);
          e = t.extend({}, e);
          var l,
            d,
            p,
            f,
            m,
            g,
            v,
            _,
            y = t(e.of),
            b = t.position.getWithinInfo(e.within),
            w = t.position.getScrollInfo(b),
            x = (e.collision || "flip").split(" "),
            C = {};
          return (
            (g =
              9 === (_ = (v = y)[0]).nodeType
                ? {
                    width: v.width(),
                    height: v.height(),
                    offset: { top: 0, left: 0 },
                  }
                : t.isWindow(_)
                ? {
                    width: v.width(),
                    height: v.height(),
                    offset: { top: v.scrollTop(), left: v.scrollLeft() },
                  }
                : _.preventDefault
                ? {
                    width: 0,
                    height: 0,
                    offset: { top: _.pageY, left: _.pageX },
                  }
                : {
                    width: v.outerWidth(),
                    height: v.outerHeight(),
                    offset: v.offset(),
                  }),
            y[0].preventDefault && (e.at = "left top"),
            (d = g.width),
            (p = g.height),
            (f = g.offset),
            (m = t.extend({}, f)),
            t.each(["my", "at"], function () {
              var t,
                i,
                n = (e[this] || "").split(" ");
              1 === n.length &&
                (n = s.test(n[0])
                  ? n.concat(["center"])
                  : o.test(n[0])
                  ? ["center"].concat(n)
                  : ["center", "center"]),
                (n[0] = s.test(n[0]) ? n[0] : "center"),
                (n[1] = o.test(n[1]) ? n[1] : "center"),
                (t = r.exec(n[0])),
                (i = r.exec(n[1])),
                (C[this] = [t ? t[0] : 0, i ? i[0] : 0]),
                (e[this] = [a.exec(n[0])[0], a.exec(n[1])[0]]);
            }),
            1 === x.length && (x[1] = x[0]),
            "right" === e.at[0]
              ? (m.left += d)
              : "center" === e.at[0] && (m.left += d / 2),
            "bottom" === e.at[1]
              ? (m.top += p)
              : "center" === e.at[1] && (m.top += p / 2),
            (l = c(C.at, d, p)),
            (m.left += l[0]),
            (m.top += l[1]),
            this.each(function () {
              var s,
                o,
                r = t(this),
                a = r.outerWidth(),
                h = r.outerHeight(),
                g = u(this, "marginLeft"),
                v = u(this, "marginTop"),
                _ = a + g + u(this, "marginRight") + w.width,
                k = h + v + u(this, "marginBottom") + w.height,
                T = t.extend({}, m),
                D = c(C.my, r.outerWidth(), r.outerHeight());
              "right" === e.my[0]
                ? (T.left -= a)
                : "center" === e.my[0] && (T.left -= a / 2),
                "bottom" === e.my[1]
                  ? (T.top -= h)
                  : "center" === e.my[1] && (T.top -= h / 2),
                (T.left += D[0]),
                (T.top += D[1]),
                (s = { marginLeft: g, marginTop: v }),
                t.each(["left", "top"], function (i, n) {
                  t.ui.position[x[i]] &&
                    t.ui.position[x[i]][n](T, {
                      targetWidth: d,
                      targetHeight: p,
                      elemWidth: a,
                      elemHeight: h,
                      collisionPosition: s,
                      collisionWidth: _,
                      collisionHeight: k,
                      offset: [l[0] + D[0], l[1] + D[1]],
                      my: e.my,
                      at: e.at,
                      within: b,
                      elem: r,
                    });
                }),
                e.using &&
                  (o = function (t) {
                    var s = f.left - T.left,
                      o = s + d - a,
                      l = f.top - T.top,
                      c = l + p - h,
                      u = {
                        target: {
                          element: y,
                          left: f.left,
                          top: f.top,
                          width: d,
                          height: p,
                        },
                        element: {
                          element: r,
                          left: T.left,
                          top: T.top,
                          width: a,
                          height: h,
                        },
                        horizontal: o < 0 ? "left" : s > 0 ? "right" : "center",
                        vertical: c < 0 ? "top" : l > 0 ? "bottom" : "middle",
                      };
                    d < a && n(s + o) < d && (u.horizontal = "center"),
                      p < h && n(l + c) < p && (u.vertical = "middle"),
                      i(n(s), n(o)) > i(n(l), n(c))
                        ? (u.important = "horizontal")
                        : (u.important = "vertical"),
                      e.using.call(this, t, u);
                  }),
                r.offset(t.extend(T, { using: o }));
            })
          );
        }),
        (t.ui.position = {
          fit: {
            left: function (t, e) {
              var n,
                s = e.within,
                o = s.isWindow ? s.scrollLeft : s.offset.left,
                r = s.width,
                a = t.left - e.collisionPosition.marginLeft,
                l = o - a,
                h = a + e.collisionWidth - r - o;
              e.collisionWidth > r
                ? l > 0 && h <= 0
                  ? ((n = t.left + l + e.collisionWidth - r - o),
                    (t.left += l - n))
                  : (t.left =
                      h > 0 && l <= 0
                        ? o
                        : l > h
                        ? o + r - e.collisionWidth
                        : o)
                : l > 0
                ? (t.left += l)
                : h > 0
                ? (t.left -= h)
                : (t.left = i(t.left - a, t.left));
            },
            top: function (t, e) {
              var n,
                s = e.within,
                o = s.isWindow ? s.scrollTop : s.offset.top,
                r = e.within.height,
                a = t.top - e.collisionPosition.marginTop,
                l = o - a,
                h = a + e.collisionHeight - r - o;
              e.collisionHeight > r
                ? l > 0 && h <= 0
                  ? ((n = t.top + l + e.collisionHeight - r - o),
                    (t.top += l - n))
                  : (t.top =
                      h > 0 && l <= 0
                        ? o
                        : l > h
                        ? o + r - e.collisionHeight
                        : o)
                : l > 0
                ? (t.top += l)
                : h > 0
                ? (t.top -= h)
                : (t.top = i(t.top - a, t.top));
            },
          },
          flip: {
            left: function (t, e) {
              var i,
                s,
                o = e.within,
                r = o.offset.left + o.scrollLeft,
                a = o.width,
                l = o.isWindow ? o.scrollLeft : o.offset.left,
                h = t.left - e.collisionPosition.marginLeft,
                c = h - l,
                u = h + e.collisionWidth - a - l,
                d =
                  "left" === e.my[0]
                    ? -e.elemWidth
                    : "right" === e.my[0]
                    ? e.elemWidth
                    : 0,
                p =
                  "left" === e.at[0]
                    ? e.targetWidth
                    : "right" === e.at[0]
                    ? -e.targetWidth
                    : 0,
                f = -2 * e.offset[0];
              c < 0
                ? ((i = t.left + d + p + f + e.collisionWidth - a - r) < 0 ||
                    i < n(c)) &&
                  (t.left += d + p + f)
                : u > 0 &&
                  ((s =
                    t.left - e.collisionPosition.marginLeft + d + p + f - l) >
                    0 ||
                    n(s) < u) &&
                  (t.left += d + p + f);
            },
            top: function (t, e) {
              var i,
                s,
                o = e.within,
                r = o.offset.top + o.scrollTop,
                a = o.height,
                l = o.isWindow ? o.scrollTop : o.offset.top,
                h = t.top - e.collisionPosition.marginTop,
                c = h - l,
                u = h + e.collisionHeight - a - l,
                d =
                  "top" === e.my[1]
                    ? -e.elemHeight
                    : "bottom" === e.my[1]
                    ? e.elemHeight
                    : 0,
                p =
                  "top" === e.at[1]
                    ? e.targetHeight
                    : "bottom" === e.at[1]
                    ? -e.targetHeight
                    : 0,
                f = -2 * e.offset[1];
              c < 0
                ? ((s = t.top + d + p + f + e.collisionHeight - a - r) < 0 ||
                    s < n(c)) &&
                  (t.top += d + p + f)
                : u > 0 &&
                  ((i = t.top - e.collisionPosition.marginTop + d + p + f - l) >
                    0 ||
                    n(i) < u) &&
                  (t.top += d + p + f);
            },
          },
          flipfit: {
            left: function () {
              t.ui.position.flip.left.apply(this, arguments),
                t.ui.position.fit.left.apply(this, arguments);
            },
            top: function () {
              t.ui.position.flip.top.apply(this, arguments),
                t.ui.position.fit.top.apply(this, arguments);
            },
          },
        });
    })();
    t.ui.position,
      t.extend(t.expr[":"], {
        data: t.expr.createPseudo
          ? t.expr.createPseudo(function (e) {
              return function (i) {
                return !!t.data(i, e);
              };
            })
          : function (e, i, n) {
              return !!t.data(e, n[3]);
            },
      }),
      t.fn.extend({
        disableSelection:
          ((s =
            "onselectstart" in document.createElement("div")
              ? "selectstart"
              : "mousedown"),
          function () {
            return this.on(s + ".ui-disableSelection", function (t) {
              t.preventDefault();
            });
          }),
        enableSelection: function () {
          return this.off(".ui-disableSelection");
        },
      });
    var s,
      o,
      r = "ui-effects-animated",
      a = t;
    (t.effects = { effect: {} }),
      (function (t, e) {
        var i,
          n = /^([\-+])=\s*(\d+\.?\d*)/,
          s = [
            {
              re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
              parse: function (t) {
                return [t[1], t[2], t[3], t[4]];
              },
            },
            {
              re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
              parse: function (t) {
                return [2.55 * t[1], 2.55 * t[2], 2.55 * t[3], t[4]];
              },
            },
            {
              re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,
              parse: function (t) {
                return [
                  parseInt(t[1], 16),
                  parseInt(t[2], 16),
                  parseInt(t[3], 16),
                ];
              },
            },
            {
              re: /#([a-f0-9])([a-f0-9])([a-f0-9])/,
              parse: function (t) {
                return [
                  parseInt(t[1] + t[1], 16),
                  parseInt(t[2] + t[2], 16),
                  parseInt(t[3] + t[3], 16),
                ];
              },
            },
            {
              re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
              space: "hsla",
              parse: function (t) {
                return [t[1], t[2] / 100, t[3] / 100, t[4]];
              },
            },
          ],
          o = (t.Color = function (e, i, n, s) {
            return new t.Color.fn.parse(e, i, n, s);
          }),
          r = {
            rgba: {
              props: {
                red: { idx: 0, type: "byte" },
                green: { idx: 1, type: "byte" },
                blue: { idx: 2, type: "byte" },
              },
            },
            hsla: {
              props: {
                hue: { idx: 0, type: "degrees" },
                saturation: { idx: 1, type: "percent" },
                lightness: { idx: 2, type: "percent" },
              },
            },
          },
          a = {
            byte: { floor: !0, max: 255 },
            percent: { max: 1 },
            degrees: { mod: 360, floor: !0 },
          },
          l = (o.support = {}),
          h = t("<p>")[0],
          c = t.each;
        function u(t, e, i) {
          var n = a[e.type] || {};
          return null == t
            ? i || !e.def
              ? null
              : e.def
            : ((t = n.floor ? ~~t : parseFloat(t)),
              isNaN(t)
                ? e.def
                : n.mod
                ? (t + n.mod) % n.mod
                : 0 > t
                ? 0
                : n.max < t
                ? n.max
                : t);
        }
        function d(e) {
          var n = o(),
            a = (n._rgba = []);
          return (
            (e = e.toLowerCase()),
            c(s, function (t, i) {
              var s,
                o = i.re.exec(e),
                l = o && i.parse(o),
                h = i.space || "rgba";
              if (l)
                return (
                  (s = n[h](l)),
                  (n[r[h].cache] = s[r[h].cache]),
                  (a = n._rgba = s._rgba),
                  !1
                );
            }),
            a.length
              ? ("0,0,0,0" === a.join() && t.extend(a, i.transparent), n)
              : i[e]
          );
        }
        function p(t, e, i) {
          return 6 * (i = (i + 1) % 1) < 1
            ? t + (e - t) * i * 6
            : 2 * i < 1
            ? e
            : 3 * i < 2
            ? t + (e - t) * (2 / 3 - i) * 6
            : t;
        }
        (h.style.cssText = "background-color:rgba(1,1,1,.5)"),
          (l.rgba = h.style.backgroundColor.indexOf("rgba") > -1),
          c(r, function (t, e) {
            (e.cache = "_" + t),
              (e.props.alpha = { idx: 3, type: "percent", def: 1 });
          }),
          (o.fn = t.extend(o.prototype, {
            parse: function (e, n, s, a) {
              if (void 0 === e)
                return (this._rgba = [null, null, null, null]), this;
              (e.jquery || e.nodeType) && ((e = t(e).css(n)), (n = void 0));
              var l = this,
                h = t.type(e),
                p = (this._rgba = []);
              return (
                void 0 !== n && ((e = [e, n, s, a]), (h = "array")),
                "string" === h
                  ? this.parse(d(e) || i._default)
                  : "array" === h
                  ? (c(r.rgba.props, function (t, i) {
                      p[i.idx] = u(e[i.idx], i);
                    }),
                    this)
                  : "object" === h
                  ? (c(
                      r,
                      e instanceof o
                        ? function (t, i) {
                            e[i.cache] && (l[i.cache] = e[i.cache].slice());
                          }
                        : function (i, n) {
                            var s = n.cache;
                            c(n.props, function (t, i) {
                              if (!l[s] && n.to) {
                                if ("alpha" === t || null == e[t]) return;
                                l[s] = n.to(l._rgba);
                              }
                              l[s][i.idx] = u(e[t], i, !0);
                            }),
                              l[s] &&
                                t.inArray(null, l[s].slice(0, 3)) < 0 &&
                                ((l[s][3] = 1),
                                n.from && (l._rgba = n.from(l[s])));
                          }
                    ),
                    this)
                  : void 0
              );
            },
            is: function (t) {
              var e = o(t),
                i = !0,
                n = this;
              return (
                c(r, function (t, s) {
                  var o,
                    r = e[s.cache];
                  return (
                    r &&
                      ((o = n[s.cache] || (s.to && s.to(n._rgba)) || []),
                      c(s.props, function (t, e) {
                        if (null != r[e.idx])
                          return (i = r[e.idx] === o[e.idx]);
                      })),
                    i
                  );
                }),
                i
              );
            },
            _space: function () {
              var t = [],
                e = this;
              return (
                c(r, function (i, n) {
                  e[n.cache] && t.push(i);
                }),
                t.pop()
              );
            },
            transition: function (t, e) {
              var i = o(t),
                n = i._space(),
                s = r[n],
                l = 0 === this.alpha() ? o("transparent") : this,
                h = l[s.cache] || s.to(l._rgba),
                d = h.slice();
              return (
                (i = i[s.cache]),
                c(s.props, function (t, n) {
                  var s = n.idx,
                    o = h[s],
                    r = i[s],
                    l = a[n.type] || {};
                  null !== r &&
                    (null === o
                      ? (d[s] = r)
                      : (l.mod &&
                          (r - o > l.mod / 2
                            ? (o += l.mod)
                            : o - r > l.mod / 2 && (o -= l.mod)),
                        (d[s] = u((r - o) * e + o, n))));
                }),
                this[n](d)
              );
            },
            blend: function (e) {
              if (1 === this._rgba[3]) return this;
              var i = this._rgba.slice(),
                n = i.pop(),
                s = o(e)._rgba;
              return o(
                t.map(i, function (t, e) {
                  return (1 - n) * s[e] + n * t;
                })
              );
            },
            toRgbaString: function () {
              var e = "rgba(",
                i = t.map(this._rgba, function (t, e) {
                  return null == t ? (e > 2 ? 1 : 0) : t;
                });
              return 1 === i[3] && (i.pop(), (e = "rgb(")), e + i.join() + ")";
            },
            toHslaString: function () {
              var e = "hsla(",
                i = t.map(this.hsla(), function (t, e) {
                  return (
                    null == t && (t = e > 2 ? 1 : 0),
                    e && e < 3 && (t = Math.round(100 * t) + "%"),
                    t
                  );
                });
              return 1 === i[3] && (i.pop(), (e = "hsl(")), e + i.join() + ")";
            },
            toHexString: function (e) {
              var i = this._rgba.slice(),
                n = i.pop();
              return (
                e && i.push(~~(255 * n)),
                "#" +
                  t
                    .map(i, function (t) {
                      return 1 === (t = (t || 0).toString(16)).length
                        ? "0" + t
                        : t;
                    })
                    .join("")
              );
            },
            toString: function () {
              return 0 === this._rgba[3] ? "transparent" : this.toRgbaString();
            },
          })),
          (o.fn.parse.prototype = o.fn),
          (r.hsla.to = function (t) {
            if (null == t[0] || null == t[1] || null == t[2])
              return [null, null, null, t[3]];
            var e,
              i,
              n = t[0] / 255,
              s = t[1] / 255,
              o = t[2] / 255,
              r = t[3],
              a = Math.max(n, s, o),
              l = Math.min(n, s, o),
              h = a - l,
              c = a + l,
              u = 0.5 * c;
            return (
              (e =
                l === a
                  ? 0
                  : n === a
                  ? (60 * (s - o)) / h + 360
                  : s === a
                  ? (60 * (o - n)) / h + 120
                  : (60 * (n - s)) / h + 240),
              (i = 0 === h ? 0 : u <= 0.5 ? h / c : h / (2 - c)),
              [Math.round(e) % 360, i, u, null == r ? 1 : r]
            );
          }),
          (r.hsla.from = function (t) {
            if (null == t[0] || null == t[1] || null == t[2])
              return [null, null, null, t[3]];
            var e = t[0] / 360,
              i = t[1],
              n = t[2],
              s = t[3],
              o = n <= 0.5 ? n * (1 + i) : n + i - n * i,
              r = 2 * n - o;
            return [
              Math.round(255 * p(r, o, e + 1 / 3)),
              Math.round(255 * p(r, o, e)),
              Math.round(255 * p(r, o, e - 1 / 3)),
              s,
            ];
          }),
          c(r, function (e, i) {
            var s = i.props,
              r = i.cache,
              a = i.to,
              l = i.from;
            (o.fn[e] = function (e) {
              if ((a && !this[r] && (this[r] = a(this._rgba)), void 0 === e))
                return this[r].slice();
              var i,
                n = t.type(e),
                h = "array" === n || "object" === n ? e : arguments,
                d = this[r].slice();
              return (
                c(s, function (t, e) {
                  var i = h["object" === n ? t : e.idx];
                  null == i && (i = d[e.idx]), (d[e.idx] = u(i, e));
                }),
                l ? (((i = o(l(d)))[r] = d), i) : o(d)
              );
            }),
              c(s, function (i, s) {
                o.fn[i] ||
                  (o.fn[i] = function (o) {
                    var r,
                      a = t.type(o),
                      l = "alpha" === i ? (this._hsla ? "hsla" : "rgba") : e,
                      h = this[l](),
                      c = h[s.idx];
                    return "undefined" === a
                      ? c
                      : ("function" === a &&
                          ((o = o.call(this, c)), (a = t.type(o))),
                        null == o && s.empty
                          ? this
                          : ("string" === a &&
                              (r = n.exec(o)) &&
                              (o =
                                c + parseFloat(r[2]) * ("+" === r[1] ? 1 : -1)),
                            (h[s.idx] = o),
                            this[l](h)));
                  });
              });
          }),
          (o.hook = function (e) {
            var i = e.split(" ");
            c(i, function (e, i) {
              (t.cssHooks[i] = {
                set: function (e, n) {
                  var s,
                    r,
                    a = "";
                  if (
                    "transparent" !== n &&
                    ("string" !== t.type(n) || (s = d(n)))
                  ) {
                    if (((n = o(s || n)), !l.rgba && 1 !== n._rgba[3])) {
                      for (
                        r = "backgroundColor" === i ? e.parentNode : e;
                        ("" === a || "transparent" === a) && r && r.style;

                      )
                        try {
                          (a = t.css(r, "backgroundColor")), (r = r.parentNode);
                        } catch (t) {}
                      n = n.blend(a && "transparent" !== a ? a : "_default");
                    }
                    n = n.toRgbaString();
                  }
                  try {
                    e.style[i] = n;
                  } catch (t) {}
                },
              }),
                (t.fx.step[i] = function (e) {
                  e.colorInit ||
                    ((e.start = o(e.elem, i)),
                    (e.end = o(e.end)),
                    (e.colorInit = !0)),
                    t.cssHooks[i].set(e.elem, e.start.transition(e.end, e.pos));
                });
            });
          }),
          o.hook(
            "backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor"
          ),
          (t.cssHooks.borderColor = {
            expand: function (t) {
              var e = {};
              return (
                c(["Top", "Right", "Bottom", "Left"], function (i, n) {
                  e["border" + n + "Color"] = t;
                }),
                e
              );
            },
          }),
          (i = t.Color.names =
            {
              aqua: "#00ffff",
              black: "#000000",
              blue: "#0000ff",
              fuchsia: "#ff00ff",
              gray: "#808080",
              green: "#008000",
              lime: "#00ff00",
              maroon: "#800000",
              navy: "#000080",
              olive: "#808000",
              purple: "#800080",
              red: "#ff0000",
              silver: "#c0c0c0",
              teal: "#008080",
              white: "#ffffff",
              yellow: "#ffff00",
              transparent: [null, null, null, 0],
              _default: "#ffffff",
            });
      })(a),
      (function () {
        var e,
          i = ["add", "remove", "toggle"],
          n = {
            border: 1,
            borderBottom: 1,
            borderColor: 1,
            borderLeft: 1,
            borderRight: 1,
            borderTop: 1,
            borderWidth: 1,
            margin: 1,
            padding: 1,
          };
        function s(e) {
          var i,
            n,
            s = e.ownerDocument.defaultView
              ? e.ownerDocument.defaultView.getComputedStyle(e, null)
              : e.currentStyle,
            o = {};
          if (s && s.length && s[0] && s[s[0]])
            for (n = s.length; n--; )
              "string" == typeof s[(i = s[n])] && (o[t.camelCase(i)] = s[i]);
          else for (i in s) "string" == typeof s[i] && (o[i] = s[i]);
          return o;
        }
        t.each(
          [
            "borderLeftStyle",
            "borderRightStyle",
            "borderBottomStyle",
            "borderTopStyle",
          ],
          function (e, i) {
            t.fx.step[i] = function (t) {
              (("none" !== t.end && !t.setAttr) ||
                (1 === t.pos && !t.setAttr)) &&
                (a.style(t.elem, i, t.end), (t.setAttr = !0));
            };
          }
        ),
          t.fn.addBack ||
            (t.fn.addBack = function (t) {
              return this.add(
                null == t ? this.prevObject : this.prevObject.filter(t)
              );
            }),
          (t.effects.animateClass = function (e, o, r, a) {
            var l = t.speed(o, r, a);
            return this.queue(function () {
              var o,
                r = t(this),
                a = r.attr("class") || "",
                h = l.children ? r.find("*").addBack() : r;
              (h = h.map(function () {
                return { el: t(this), start: s(this) };
              })),
                (o = function () {
                  t.each(i, function (t, i) {
                    e[i] && r[i + "Class"](e[i]);
                  });
                })(),
                (h = h.map(function () {
                  return (
                    (this.end = s(this.el[0])),
                    (this.diff = (function (e, i) {
                      var s,
                        o,
                        r = {};
                      for (s in i)
                        (o = i[s]),
                          e[s] !== o &&
                            (n[s] ||
                              (!t.fx.step[s] && isNaN(parseFloat(o))) ||
                              (r[s] = o));
                      return r;
                    })(this.start, this.end)),
                    this
                  );
                })),
                r.attr("class", a),
                (h = h.map(function () {
                  var e = this,
                    i = t.Deferred(),
                    n = t.extend({}, l, {
                      queue: !1,
                      complete: function () {
                        i.resolve(e);
                      },
                    });
                  return this.el.animate(this.diff, n), i.promise();
                })),
                t.when.apply(t, h.get()).done(function () {
                  o(),
                    t.each(arguments, function () {
                      var e = this.el;
                      t.each(this.diff, function (t) {
                        e.css(t, "");
                      });
                    }),
                    l.complete.call(r[0]);
                });
            });
          }),
          t.fn.extend({
            addClass:
              ((e = t.fn.addClass),
              function (i, n, s, o) {
                return n
                  ? t.effects.animateClass.call(this, { add: i }, n, s, o)
                  : e.apply(this, arguments);
              }),
            removeClass: (function (e) {
              return function (i, n, s, o) {
                return arguments.length > 1
                  ? t.effects.animateClass.call(this, { remove: i }, n, s, o)
                  : e.apply(this, arguments);
              };
            })(t.fn.removeClass),
            toggleClass: (function (e) {
              return function (i, n, s, o, r) {
                return "boolean" == typeof n || void 0 === n
                  ? s
                    ? t.effects.animateClass.call(
                        this,
                        n ? { add: i } : { remove: i },
                        s,
                        o,
                        r
                      )
                    : e.apply(this, arguments)
                  : t.effects.animateClass.call(this, { toggle: i }, n, s, o);
              };
            })(t.fn.toggleClass),
            switchClass: function (e, i, n, s, o) {
              return t.effects.animateClass.call(
                this,
                { add: i, remove: e },
                n,
                s,
                o
              );
            },
          });
      })(),
      (function () {
        var e;
        function i(e, i, n, s) {
          return (
            t.isPlainObject(e) && ((i = e), (e = e.effect)),
            (e = { effect: e }),
            null == i && (i = {}),
            t.isFunction(i) && ((s = i), (n = null), (i = {})),
            ("number" == typeof i || t.fx.speeds[i]) &&
              ((s = n), (n = i), (i = {})),
            t.isFunction(n) && ((s = n), (n = null)),
            i && t.extend(e, i),
            (n = n || i.duration),
            (e.duration = t.fx.off
              ? 0
              : "number" == typeof n
              ? n
              : n in t.fx.speeds
              ? t.fx.speeds[n]
              : t.fx.speeds._default),
            (e.complete = s || i.complete),
            e
          );
        }
        function n(e) {
          return (
            !(e && "number" != typeof e && !t.fx.speeds[e]) ||
            ("string" == typeof e && !t.effects.effect[e]) ||
            !!t.isFunction(e) ||
            ("object" == typeof e && !e.effect)
          );
        }
        function s(t, e) {
          var i = e.outerWidth(),
            n = e.outerHeight(),
            s =
              /^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/.exec(
                t
              ) || ["", 0, i, n, 0];
          return {
            top: parseFloat(s[1]) || 0,
            right: "auto" === s[2] ? i : parseFloat(s[2]),
            bottom: "auto" === s[3] ? n : parseFloat(s[3]),
            left: parseFloat(s[4]) || 0,
          };
        }
        t.expr &&
          t.expr.filters &&
          t.expr.filters.animated &&
          (t.expr.filters.animated =
            ((e = t.expr.filters.animated),
            function (i) {
              return !!t(i).data(r) || e(i);
            })),
          !1 !== t.uiBackCompat &&
            t.extend(t.effects, {
              save: function (t, e) {
                for (var i = 0, n = e.length; i < n; i++)
                  null !== e[i] &&
                    t.data("ui-effects-" + e[i], t[0].style[e[i]]);
              },
              restore: function (t, e) {
                for (var i, n = 0, s = e.length; n < s; n++)
                  null !== e[n] &&
                    ((i = t.data("ui-effects-" + e[n])), t.css(e[n], i));
              },
              setMode: function (t, e) {
                return (
                  "toggle" === e && (e = t.is(":hidden") ? "show" : "hide"), e
                );
              },
              createWrapper: function (e) {
                if (e.parent().is(".ui-effects-wrapper")) return e.parent();
                var i = {
                    width: e.outerWidth(!0),
                    height: e.outerHeight(!0),
                    float: e.css("float"),
                  },
                  n = t("<div></div>").addClass("ui-effects-wrapper").css({
                    fontSize: "100%",
                    background: "transparent",
                    border: "none",
                    margin: 0,
                    padding: 0,
                  }),
                  s = { width: e.width(), height: e.height() },
                  o = document.activeElement;
                try {
                  o.id;
                } catch (t) {
                  o = document.body;
                }
                return (
                  e.wrap(n),
                  (e[0] === o || t.contains(e[0], o)) && t(o).trigger("focus"),
                  (n = e.parent()),
                  "static" === e.css("position")
                    ? (n.css({ position: "relative" }),
                      e.css({ position: "relative" }))
                    : (t.extend(i, {
                        position: e.css("position"),
                        zIndex: e.css("z-index"),
                      }),
                      t.each(
                        ["top", "left", "bottom", "right"],
                        function (t, n) {
                          (i[n] = e.css(n)),
                            isNaN(parseInt(i[n], 10)) && (i[n] = "auto");
                        }
                      ),
                      e.css({
                        position: "relative",
                        top: 0,
                        left: 0,
                        right: "auto",
                        bottom: "auto",
                      })),
                  e.css(s),
                  n.css(i).show()
                );
              },
              removeWrapper: function (e) {
                var i = document.activeElement;
                return (
                  e.parent().is(".ui-effects-wrapper") &&
                    (e.parent().replaceWith(e),
                    (e[0] === i || t.contains(e[0], i)) &&
                      t(i).trigger("focus")),
                  e
                );
              },
            }),
          t.extend(t.effects, {
            version: "1.12.1",
            define: function (e, i, n) {
              return (
                n || ((n = i), (i = "effect")),
                (t.effects.effect[e] = n),
                (t.effects.effect[e].mode = i),
                n
              );
            },
            scaledDimensions: function (t, e, i) {
              if (0 === e)
                return { height: 0, width: 0, outerHeight: 0, outerWidth: 0 };
              var n = "horizontal" !== i ? (e || 100) / 100 : 1,
                s = "vertical" !== i ? (e || 100) / 100 : 1;
              return {
                height: t.height() * s,
                width: t.width() * n,
                outerHeight: t.outerHeight() * s,
                outerWidth: t.outerWidth() * n,
              };
            },
            clipToBox: function (t) {
              return {
                width: t.clip.right - t.clip.left,
                height: t.clip.bottom - t.clip.top,
                left: t.clip.left,
                top: t.clip.top,
              };
            },
            unshift: function (t, e, i) {
              var n = t.queue();
              e > 1 && n.splice.apply(n, [1, 0].concat(n.splice(e, i))),
                t.dequeue();
            },
            saveStyle: function (t) {
              t.data("ui-effects-style", t[0].style.cssText);
            },
            restoreStyle: function (t) {
              (t[0].style.cssText = t.data("ui-effects-style") || ""),
                t.removeData("ui-effects-style");
            },
            mode: function (t, e) {
              var i = t.is(":hidden");
              return (
                "toggle" === e && (e = i ? "show" : "hide"),
                (i ? "hide" === e : "show" === e) && (e = "none"),
                e
              );
            },
            getBaseline: function (t, e) {
              var i, n;
              switch (t[0]) {
                case "top":
                  i = 0;
                  break;
                case "middle":
                  i = 0.5;
                  break;
                case "bottom":
                  i = 1;
                  break;
                default:
                  i = t[0] / e.height;
              }
              switch (t[1]) {
                case "left":
                  n = 0;
                  break;
                case "center":
                  n = 0.5;
                  break;
                case "right":
                  n = 1;
                  break;
                default:
                  n = t[1] / e.width;
              }
              return { x: n, y: i };
            },
            createPlaceholder: function (e) {
              var i,
                n = e.css("position"),
                s = e.position();
              return (
                e
                  .css({
                    marginTop: e.css("marginTop"),
                    marginBottom: e.css("marginBottom"),
                    marginLeft: e.css("marginLeft"),
                    marginRight: e.css("marginRight"),
                  })
                  .outerWidth(e.outerWidth())
                  .outerHeight(e.outerHeight()),
                /^(static|relative)/.test(n) &&
                  ((n = "absolute"),
                  (i = t("<" + e[0].nodeName + ">")
                    .insertAfter(e)
                    .css({
                      display: /^(inline|ruby)/.test(e.css("display"))
                        ? "inline-block"
                        : "block",
                      visibility: "hidden",
                      marginTop: e.css("marginTop"),
                      marginBottom: e.css("marginBottom"),
                      marginLeft: e.css("marginLeft"),
                      marginRight: e.css("marginRight"),
                      float: e.css("float"),
                    })
                    .outerWidth(e.outerWidth())
                    .outerHeight(e.outerHeight())
                    .addClass("ui-effects-placeholder")),
                  e.data("ui-effects-placeholder", i)),
                e.css({ position: n, left: s.left, top: s.top }),
                i
              );
            },
            removePlaceholder: function (t) {
              var e = "ui-effects-placeholder",
                i = t.data(e);
              i && (i.remove(), t.removeData(e));
            },
            cleanUp: function (e) {
              t.effects.restoreStyle(e), t.effects.removePlaceholder(e);
            },
            setTransition: function (e, i, n, s) {
              return (
                (s = s || {}),
                t.each(i, function (t, i) {
                  var o = e.cssUnit(i);
                  o[0] > 0 && (s[i] = o[0] * n + o[1]);
                }),
                s
              );
            },
          }),
          t.fn.extend({
            effect: function () {
              var e = i.apply(this, arguments),
                n = t.effects.effect[e.effect],
                s = n.mode,
                o = e.queue,
                a = o || "fx",
                l = e.complete,
                h = e.mode,
                c = [],
                u = function (e) {
                  var i = t(this),
                    n = t.effects.mode(i, h) || s;
                  i.data(r, !0),
                    c.push(n),
                    s &&
                      ("show" === n || (n === s && "hide" === n)) &&
                      i.show(),
                    (s && "none" === n) || t.effects.saveStyle(i),
                    t.isFunction(e) && e();
                };
              if (t.fx.off || !n)
                return h
                  ? this[h](e.duration, l)
                  : this.each(function () {
                      l && l.call(this);
                    });
              function d(i) {
                var o = t(this);
                function a() {
                  t.isFunction(l) && l.call(o[0]), t.isFunction(i) && i();
                }
                (e.mode = c.shift()),
                  !1 === t.uiBackCompat || s
                    ? "none" === e.mode
                      ? (o[h](), a())
                      : n.call(o[0], e, function () {
                          o.removeData(r),
                            t.effects.cleanUp(o),
                            "hide" === e.mode && o.hide(),
                            a();
                        })
                    : (o.is(":hidden") ? "hide" === h : "show" === h)
                    ? (o[h](), a())
                    : n.call(o[0], e, a);
              }
              return !1 === o
                ? this.each(u).each(d)
                : this.queue(a, u).queue(a, d);
            },
            show: (function (t) {
              return function (e) {
                if (n(e)) return t.apply(this, arguments);
                var s = i.apply(this, arguments);
                return (s.mode = "show"), this.effect.call(this, s);
              };
            })(t.fn.show),
            hide: (function (t) {
              return function (e) {
                if (n(e)) return t.apply(this, arguments);
                var s = i.apply(this, arguments);
                return (s.mode = "hide"), this.effect.call(this, s);
              };
            })(t.fn.hide),
            toggle: (function (t) {
              return function (e) {
                if (n(e) || "boolean" == typeof e)
                  return t.apply(this, arguments);
                var s = i.apply(this, arguments);
                return (s.mode = "toggle"), this.effect.call(this, s);
              };
            })(t.fn.toggle),
            cssUnit: function (e) {
              var i = this.css(e),
                n = [];
              return (
                t.each(["em", "px", "%", "pt"], function (t, e) {
                  i.indexOf(e) > 0 && (n = [parseFloat(i), e]);
                }),
                n
              );
            },
            cssClip: function (t) {
              return t
                ? this.css(
                    "clip",
                    "rect(" +
                      t.top +
                      "px " +
                      t.right +
                      "px " +
                      t.bottom +
                      "px " +
                      t.left +
                      "px)"
                  )
                : s(this.css("clip"), this);
            },
            transfer: function (e, i) {
              var n = t(this),
                s = t(e.to),
                o = "fixed" === s.css("position"),
                r = t("body"),
                a = o ? r.scrollTop() : 0,
                l = o ? r.scrollLeft() : 0,
                h = s.offset(),
                c = {
                  top: h.top - a,
                  left: h.left - l,
                  height: s.innerHeight(),
                  width: s.innerWidth(),
                },
                u = n.offset(),
                d = t("<div class='ui-effects-transfer'></div>")
                  .appendTo("body")
                  .addClass(e.className)
                  .css({
                    top: u.top - a,
                    left: u.left - l,
                    height: n.innerHeight(),
                    width: n.innerWidth(),
                    position: o ? "fixed" : "absolute",
                  })
                  .animate(c, e.duration, e.easing, function () {
                    d.remove(), t.isFunction(i) && i();
                  });
            },
          }),
          (t.fx.step.clip = function (e) {
            e.clipInit ||
              ((e.start = t(e.elem).cssClip()),
              "string" == typeof e.end && (e.end = s(e.end, e.elem)),
              (e.clipInit = !0)),
              t(e.elem).cssClip({
                top: e.pos * (e.end.top - e.start.top) + e.start.top,
                right: e.pos * (e.end.right - e.start.right) + e.start.right,
                bottom:
                  e.pos * (e.end.bottom - e.start.bottom) + e.start.bottom,
                left: e.pos * (e.end.left - e.start.left) + e.start.left,
              });
          });
      })(),
      (o = {}),
      t.each(["Quad", "Cubic", "Quart", "Quint", "Expo"], function (t, e) {
        o[e] = function (e) {
          return Math.pow(e, t + 2);
        };
      }),
      t.extend(o, {
        Sine: function (t) {
          return 1 - Math.cos((t * Math.PI) / 2);
        },
        Circ: function (t) {
          return 1 - Math.sqrt(1 - t * t);
        },
        Elastic: function (t) {
          return 0 === t || 1 === t
            ? t
            : -Math.pow(2, 8 * (t - 1)) *
                Math.sin(((80 * (t - 1) - 7.5) * Math.PI) / 15);
        },
        Back: function (t) {
          return t * t * (3 * t - 2);
        },
        Bounce: function (t) {
          for (var e, i = 4; t < ((e = Math.pow(2, --i)) - 1) / 11; );
          return (
            1 / Math.pow(4, 3 - i) - 7.5625 * Math.pow((3 * e - 2) / 22 - t, 2)
          );
        },
      }),
      t.each(o, function (e, i) {
        (t.easing["easeIn" + e] = i),
          (t.easing["easeOut" + e] = function (t) {
            return 1 - i(1 - t);
          }),
          (t.easing["easeInOut" + e] = function (t) {
            return t < 0.5 ? i(2 * t) / 2 : 1 - i(-2 * t + 2) / 2;
          });
      });
    t.effects,
      t.effects.define("blind", "hide", function (e, i) {
        var n = {
            up: ["bottom", "top"],
            vertical: ["bottom", "top"],
            down: ["top", "bottom"],
            left: ["right", "left"],
            horizontal: ["right", "left"],
            right: ["left", "right"],
          },
          s = t(this),
          o = e.direction || "up",
          r = s.cssClip(),
          a = { clip: t.extend({}, r) },
          l = t.effects.createPlaceholder(s);
        (a.clip[n[o][0]] = a.clip[n[o][1]]),
          "show" === e.mode &&
            (s.cssClip(a.clip),
            l && l.css(t.effects.clipToBox(a)),
            (a.clip = r)),
          l && l.animate(t.effects.clipToBox(a), e.duration, e.easing),
          s.animate(a, {
            queue: !1,
            duration: e.duration,
            easing: e.easing,
            complete: i,
          });
      }),
      t.effects.define("bounce", function (e, i) {
        var n,
          s,
          o,
          r = t(this),
          a = e.mode,
          l = "hide" === a,
          h = "show" === a,
          c = e.direction || "up",
          u = e.distance,
          d = e.times || 5,
          p = 2 * d + (h || l ? 1 : 0),
          f = e.duration / p,
          m = e.easing,
          g = "up" === c || "down" === c ? "top" : "left",
          v = "up" === c || "left" === c,
          _ = 0,
          y = r.queue().length;
        for (
          t.effects.createPlaceholder(r),
            o = r.css(g),
            u || (u = r["top" === g ? "outerHeight" : "outerWidth"]() / 3),
            h &&
              (((s = { opacity: 1 })[g] = o),
              r
                .css("opacity", 0)
                .css(g, v ? 2 * -u : 2 * u)
                .animate(s, f, m)),
            l && (u /= Math.pow(2, d - 1)),
            (s = {})[g] = o;
          _ < d;
          _++
        )
          ((n = {})[g] = (v ? "-=" : "+=") + u),
            r.animate(n, f, m).animate(s, f, m),
            (u = l ? 2 * u : u / 2);
        l &&
          (((n = { opacity: 0 })[g] = (v ? "-=" : "+=") + u),
          r.animate(n, f, m)),
          r.queue(i),
          t.effects.unshift(r, y, p + 1);
      }),
      t.effects.define("clip", "hide", function (e, i) {
        var n,
          s = {},
          o = t(this),
          r = e.direction || "vertical",
          a = "both" === r,
          l = a || "horizontal" === r,
          h = a || "vertical" === r;
        (n = o.cssClip()),
          (s.clip = {
            top: h ? (n.bottom - n.top) / 2 : n.top,
            right: l ? (n.right - n.left) / 2 : n.right,
            bottom: h ? (n.bottom - n.top) / 2 : n.bottom,
            left: l ? (n.right - n.left) / 2 : n.left,
          }),
          t.effects.createPlaceholder(o),
          "show" === e.mode && (o.cssClip(s.clip), (s.clip = n)),
          o.animate(s, {
            queue: !1,
            duration: e.duration,
            easing: e.easing,
            complete: i,
          });
      }),
      t.effects.define("drop", "hide", function (e, i) {
        var n,
          s = t(this),
          o = "show" === e.mode,
          r = e.direction || "left",
          a = "up" === r || "down" === r ? "top" : "left",
          l = "up" === r || "left" === r ? "-=" : "+=",
          h = "+=" === l ? "-=" : "+=",
          c = { opacity: 0 };
        t.effects.createPlaceholder(s),
          (n =
            e.distance ||
            s["top" === a ? "outerHeight" : "outerWidth"](!0) / 2),
          (c[a] = l + n),
          o && (s.css(c), (c[a] = h + n), (c.opacity = 1)),
          s.animate(c, {
            queue: !1,
            duration: e.duration,
            easing: e.easing,
            complete: i,
          });
      }),
      t.effects.define("explode", "hide", function (e, i) {
        var n,
          s,
          o,
          r,
          a,
          l,
          h = e.pieces ? Math.round(Math.sqrt(e.pieces)) : 3,
          c = h,
          u = t(this),
          d = "show" === e.mode,
          p = u.show().css("visibility", "hidden").offset(),
          f = Math.ceil(u.outerWidth() / c),
          m = Math.ceil(u.outerHeight() / h),
          g = [];
        function v() {
          g.push(this),
            g.length === h * c &&
              (u.css({ visibility: "visible" }), t(g).remove(), i());
        }
        for (n = 0; n < h; n++)
          for (r = p.top + n * m, l = n - (h - 1) / 2, s = 0; s < c; s++)
            (o = p.left + s * f),
              (a = s - (c - 1) / 2),
              u
                .clone()
                .appendTo("body")
                .wrap("<div></div>")
                .css({
                  position: "absolute",
                  visibility: "visible",
                  left: -s * f,
                  top: -n * m,
                })
                .parent()
                .addClass("ui-effects-explode")
                .css({
                  position: "absolute",
                  overflow: "hidden",
                  width: f,
                  height: m,
                  left: o + (d ? a * f : 0),
                  top: r + (d ? l * m : 0),
                  opacity: d ? 0 : 1,
                })
                .animate(
                  {
                    left: o + (d ? 0 : a * f),
                    top: r + (d ? 0 : l * m),
                    opacity: d ? 1 : 0,
                  },
                  e.duration || 500,
                  e.easing,
                  v
                );
      }),
      t.effects.define("fade", "toggle", function (e, i) {
        var n = "show" === e.mode;
        t(this)
          .css("opacity", n ? 0 : 1)
          .animate(
            { opacity: n ? 1 : 0 },
            { queue: !1, duration: e.duration, easing: e.easing, complete: i }
          );
      }),
      t.effects.define("fold", "hide", function (e, i) {
        var n = t(this),
          s = e.mode,
          o = "show" === s,
          r = "hide" === s,
          a = e.size || 15,
          l = /([0-9]+)%/.exec(a),
          h = !!e.horizFirst ? ["right", "bottom"] : ["bottom", "right"],
          c = e.duration / 2,
          u = t.effects.createPlaceholder(n),
          d = n.cssClip(),
          p = { clip: t.extend({}, d) },
          f = { clip: t.extend({}, d) },
          m = [d[h[0]], d[h[1]]],
          g = n.queue().length;
        l && (a = (parseInt(l[1], 10) / 100) * m[r ? 0 : 1]),
          (p.clip[h[0]] = a),
          (f.clip[h[0]] = a),
          (f.clip[h[1]] = 0),
          o &&
            (n.cssClip(f.clip),
            u && u.css(t.effects.clipToBox(f)),
            (f.clip = d)),
          n
            .queue(function (i) {
              u &&
                u
                  .animate(t.effects.clipToBox(p), c, e.easing)
                  .animate(t.effects.clipToBox(f), c, e.easing),
                i();
            })
            .animate(p, c, e.easing)
            .animate(f, c, e.easing)
            .queue(i),
          t.effects.unshift(n, g, 4);
      }),
      t.effects.define("highlight", "show", function (e, i) {
        var n = t(this),
          s = { backgroundColor: n.css("backgroundColor") };
        "hide" === e.mode && (s.opacity = 0),
          t.effects.saveStyle(n),
          n
            .css({
              backgroundImage: "none",
              backgroundColor: e.color || "#ffff99",
            })
            .animate(s, {
              queue: !1,
              duration: e.duration,
              easing: e.easing,
              complete: i,
            });
      }),
      t.effects.define("size", function (e, i) {
        var n,
          s,
          o,
          r = t(this),
          a = ["fontSize"],
          l = [
            "borderTopWidth",
            "borderBottomWidth",
            "paddingTop",
            "paddingBottom",
          ],
          h = [
            "borderLeftWidth",
            "borderRightWidth",
            "paddingLeft",
            "paddingRight",
          ],
          c = e.mode,
          u = "effect" !== c,
          d = e.scale || "both",
          p = e.origin || ["middle", "center"],
          f = r.css("position"),
          m = r.position(),
          g = t.effects.scaledDimensions(r),
          v = e.from || g,
          _ = e.to || t.effects.scaledDimensions(r, 0);
        t.effects.createPlaceholder(r),
          "show" === c && ((o = v), (v = _), (_ = o)),
          (s = {
            from: { y: v.height / g.height, x: v.width / g.width },
            to: { y: _.height / g.height, x: _.width / g.width },
          }),
          ("box" !== d && "both" !== d) ||
            (s.from.y !== s.to.y &&
              ((v = t.effects.setTransition(r, l, s.from.y, v)),
              (_ = t.effects.setTransition(r, l, s.to.y, _))),
            s.from.x !== s.to.x &&
              ((v = t.effects.setTransition(r, h, s.from.x, v)),
              (_ = t.effects.setTransition(r, h, s.to.x, _)))),
          ("content" !== d && "both" !== d) ||
            (s.from.y !== s.to.y &&
              ((v = t.effects.setTransition(r, a, s.from.y, v)),
              (_ = t.effects.setTransition(r, a, s.to.y, _)))),
          p &&
            ((n = t.effects.getBaseline(p, g)),
            (v.top = (g.outerHeight - v.outerHeight) * n.y + m.top),
            (v.left = (g.outerWidth - v.outerWidth) * n.x + m.left),
            (_.top = (g.outerHeight - _.outerHeight) * n.y + m.top),
            (_.left = (g.outerWidth - _.outerWidth) * n.x + m.left)),
          r.css(v),
          ("content" !== d && "both" !== d) ||
            ((l = l.concat(["marginTop", "marginBottom"]).concat(a)),
            (h = h.concat(["marginLeft", "marginRight"])),
            r.find("*[width]").each(function () {
              var i = t(this),
                n = t.effects.scaledDimensions(i),
                o = {
                  height: n.height * s.from.y,
                  width: n.width * s.from.x,
                  outerHeight: n.outerHeight * s.from.y,
                  outerWidth: n.outerWidth * s.from.x,
                },
                r = {
                  height: n.height * s.to.y,
                  width: n.width * s.to.x,
                  outerHeight: n.height * s.to.y,
                  outerWidth: n.width * s.to.x,
                };
              s.from.y !== s.to.y &&
                ((o = t.effects.setTransition(i, l, s.from.y, o)),
                (r = t.effects.setTransition(i, l, s.to.y, r))),
                s.from.x !== s.to.x &&
                  ((o = t.effects.setTransition(i, h, s.from.x, o)),
                  (r = t.effects.setTransition(i, h, s.to.x, r))),
                u && t.effects.saveStyle(i),
                i.css(o),
                i.animate(r, e.duration, e.easing, function () {
                  u && t.effects.restoreStyle(i);
                });
            })),
          r.animate(_, {
            queue: !1,
            duration: e.duration,
            easing: e.easing,
            complete: function () {
              var e = r.offset();
              0 === _.opacity && r.css("opacity", v.opacity),
                u ||
                  (r.css("position", "static" === f ? "relative" : f).offset(e),
                  t.effects.saveStyle(r)),
                i();
            },
          });
      }),
      t.effects.define("scale", function (e, i) {
        var n = t(this),
          s = e.mode,
          o =
            parseInt(e.percent, 10) ||
            (0 === parseInt(e.percent, 10) ? 0 : "effect" !== s ? 0 : 100),
          r = t.extend(
            !0,
            {
              from: t.effects.scaledDimensions(n),
              to: t.effects.scaledDimensions(n, o, e.direction || "both"),
              origin: e.origin || ["middle", "center"],
            },
            e
          );
        e.fade && ((r.from.opacity = 1), (r.to.opacity = 0)),
          t.effects.effect.size.call(this, r, i);
      }),
      t.effects.define("puff", "hide", function (e, i) {
        var n = t.extend(!0, {}, e, {
          fade: !0,
          percent: parseInt(e.percent, 10) || 150,
        });
        t.effects.effect.scale.call(this, n, i);
      }),
      t.effects.define("pulsate", "show", function (e, i) {
        var n = t(this),
          s = e.mode,
          o = "show" === s,
          r = o || "hide" === s,
          a = 2 * (e.times || 5) + (r ? 1 : 0),
          l = e.duration / a,
          h = 0,
          c = 1,
          u = n.queue().length;
        for (
          (!o && n.is(":visible")) || (n.css("opacity", 0).show(), (h = 1));
          c < a;
          c++
        )
          n.animate({ opacity: h }, l, e.easing), (h = 1 - h);
        n.animate({ opacity: h }, l, e.easing),
          n.queue(i),
          t.effects.unshift(n, u, a + 1);
      }),
      t.effects.define("shake", function (e, i) {
        var n = 1,
          s = t(this),
          o = e.direction || "left",
          r = e.distance || 20,
          a = e.times || 3,
          l = 2 * a + 1,
          h = Math.round(e.duration / l),
          c = "up" === o || "down" === o ? "top" : "left",
          u = "up" === o || "left" === o,
          d = {},
          p = {},
          f = {},
          m = s.queue().length;
        for (
          t.effects.createPlaceholder(s),
            d[c] = (u ? "-=" : "+=") + r,
            p[c] = (u ? "+=" : "-=") + 2 * r,
            f[c] = (u ? "-=" : "+=") + 2 * r,
            s.animate(d, h, e.easing);
          n < a;
          n++
        )
          s.animate(p, h, e.easing).animate(f, h, e.easing);
        s
          .animate(p, h, e.easing)
          .animate(d, h / 2, e.easing)
          .queue(i),
          t.effects.unshift(s, m, l + 1);
      }),
      t.effects.define("slide", "show", function (e, i) {
        var n,
          s,
          o = t(this),
          r = {
            up: ["bottom", "top"],
            down: ["top", "bottom"],
            left: ["right", "left"],
            right: ["left", "right"],
          },
          a = e.mode,
          l = e.direction || "left",
          h = "up" === l || "down" === l ? "top" : "left",
          c = "up" === l || "left" === l,
          u = e.distance || o["top" === h ? "outerHeight" : "outerWidth"](!0),
          d = {};
        t.effects.createPlaceholder(o),
          (n = o.cssClip()),
          (s = o.position()[h]),
          (d[h] = (c ? -1 : 1) * u + s),
          (d.clip = o.cssClip()),
          (d.clip[r[l][1]] = d.clip[r[l][0]]),
          "show" === a &&
            (o.cssClip(d.clip), o.css(h, d[h]), (d.clip = n), (d[h] = s)),
          o.animate(d, {
            queue: !1,
            duration: e.duration,
            easing: e.easing,
            complete: i,
          });
      });
    !1 !== t.uiBackCompat &&
      t.effects.define("transfer", function (e, i) {
        t(this).transfer(e, i);
      });
    (t.ui.focusable = function (e, i) {
      var n,
        s,
        o,
        r,
        a,
        l = e.nodeName.toLowerCase();
      return "area" === l
        ? ((s = (n = e.parentNode).name),
          !(!e.href || !s || "map" !== n.nodeName.toLowerCase()) &&
            (o = t("img[usemap='#" + s + "']")).length > 0 &&
            o.is(":visible"))
        : (/^(input|select|textarea|button|object)$/.test(l)
            ? (r = !e.disabled) &&
              (a = t(e).closest("fieldset")[0]) &&
              (r = !a.disabled)
            : (r = ("a" === l && e.href) || i),
          r &&
            t(e).is(":visible") &&
            (function (t) {
              var e = t.css("visibility");
              for (; "inherit" === e; )
                (t = t.parent()), (e = t.css("visibility"));
              return "hidden" !== e;
            })(t(e)));
    }),
      t.extend(t.expr[":"], {
        focusable: function (e) {
          return t.ui.focusable(e, null != t.attr(e, "tabindex"));
        },
      });
    t.ui.focusable,
      (t.fn.form = function () {
        return "string" == typeof this[0].form
          ? this.closest("form")
          : t(this[0].form);
      }),
      (t.ui.formResetMixin = {
        _formResetHandler: function () {
          var e = t(this);
          setTimeout(function () {
            var i = e.data("ui-form-reset-instances");
            t.each(i, function () {
              this.refresh();
            });
          });
        },
        _bindFormResetHandler: function () {
          if (((this.form = this.element.form()), this.form.length)) {
            var t = this.form.data("ui-form-reset-instances") || [];
            t.length ||
              this.form.on("reset.ui-form-reset", this._formResetHandler),
              t.push(this),
              this.form.data("ui-form-reset-instances", t);
          }
        },
        _unbindFormResetHandler: function () {
          if (this.form.length) {
            var e = this.form.data("ui-form-reset-instances");
            e.splice(t.inArray(this, e), 1),
              e.length
                ? this.form.data("ui-form-reset-instances", e)
                : this.form
                    .removeData("ui-form-reset-instances")
                    .off("reset.ui-form-reset");
          }
        },
      });
    "1.7" === t.fn.jquery.substring(0, 3) &&
      (t.each(["Width", "Height"], function (e, i) {
        var n = "Width" === i ? ["Left", "Right"] : ["Top", "Bottom"],
          s = i.toLowerCase(),
          o = {
            innerWidth: t.fn.innerWidth,
            innerHeight: t.fn.innerHeight,
            outerWidth: t.fn.outerWidth,
            outerHeight: t.fn.outerHeight,
          };
        function r(e, i, s, o) {
          return (
            t.each(n, function () {
              (i -= parseFloat(t.css(e, "padding" + this)) || 0),
                s &&
                  (i -= parseFloat(t.css(e, "border" + this + "Width")) || 0),
                o && (i -= parseFloat(t.css(e, "margin" + this)) || 0);
            }),
            i
          );
        }
        (t.fn["inner" + i] = function (e) {
          return void 0 === e
            ? o["inner" + i].call(this)
            : this.each(function () {
                t(this).css(s, r(this, e) + "px");
              });
        }),
          (t.fn["outer" + i] = function (e, n) {
            return "number" != typeof e
              ? o["outer" + i].call(this, e)
              : this.each(function () {
                  t(this).css(s, r(this, e, !0, n) + "px");
                });
          });
      }),
      (t.fn.addBack = function (t) {
        return this.add(
          null == t ? this.prevObject : this.prevObject.filter(t)
        );
      }));
    var l, h;
    (t.ui.keyCode = {
      BACKSPACE: 8,
      COMMA: 188,
      DELETE: 46,
      DOWN: 40,
      END: 35,
      ENTER: 13,
      ESCAPE: 27,
      HOME: 36,
      LEFT: 37,
      PAGE_DOWN: 34,
      PAGE_UP: 33,
      PERIOD: 190,
      RIGHT: 39,
      SPACE: 32,
      TAB: 9,
      UP: 38,
    }),
      (t.ui.escapeSelector =
        ((l = /([!"#$%&'()*+,.\/:;<=>?@[\]^`{|}~])/g),
        function (t) {
          return t.replace(l, "\\$1");
        })),
      (t.fn.labels = function () {
        var e, i, n, s, o;
        return this[0].labels && this[0].labels.length
          ? this.pushStack(this[0].labels)
          : ((s = this.eq(0).parents("label")),
            (n = this.attr("id")) &&
              ((o = (e = this.eq(0).parents().last()).add(
                e.length ? e.siblings() : this.siblings()
              )),
              (i = "label[for='" + t.ui.escapeSelector(n) + "']"),
              (s = s.add(o.find(i).addBack(i)))),
            this.pushStack(s));
      }),
      (t.fn.scrollParent = function (e) {
        var i = this.css("position"),
          n = "absolute" === i,
          s = e ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
          o = this.parents()
            .filter(function () {
              var e = t(this);
              return (
                (!n || "static" !== e.css("position")) &&
                s.test(
                  e.css("overflow") + e.css("overflow-y") + e.css("overflow-x")
                )
              );
            })
            .eq(0);
        return "fixed" !== i && o.length
          ? o
          : t(this[0].ownerDocument || document);
      }),
      t.extend(t.expr[":"], {
        tabbable: function (e) {
          var i = t.attr(e, "tabindex"),
            n = null != i;
          return (!n || i >= 0) && t.ui.focusable(e, n);
        },
      }),
      t.fn.extend({
        uniqueId:
          ((h = 0),
          function () {
            return this.each(function () {
              this.id || (this.id = "ui-id-" + ++h);
            });
          }),
        removeUniqueId: function () {
          return this.each(function () {
            /^ui-id-\d+$/.test(this.id) && t(this).removeAttr("id");
          });
        },
      }),
      t.widget("ui.accordion", {
        version: "1.12.1",
        options: {
          active: 0,
          animate: {},
          classes: {
            "ui-accordion-header": "ui-corner-top",
            "ui-accordion-header-collapsed": "ui-corner-all",
            "ui-accordion-content": "ui-corner-bottom",
          },
          collapsible: !1,
          event: "click",
          header: "> li > :first-child, > :not(li):even",
          heightStyle: "auto",
          icons: {
            activeHeader: "ui-icon-triangle-1-s",
            header: "ui-icon-triangle-1-e",
          },
          activate: null,
          beforeActivate: null,
        },
        hideProps: {
          borderTopWidth: "hide",
          borderBottomWidth: "hide",
          paddingTop: "hide",
          paddingBottom: "hide",
          height: "hide",
        },
        showProps: {
          borderTopWidth: "show",
          borderBottomWidth: "show",
          paddingTop: "show",
          paddingBottom: "show",
          height: "show",
        },
        _create: function () {
          var e = this.options;
          (this.prevShow = this.prevHide = t()),
            this._addClass("ui-accordion", "ui-widget ui-helper-reset"),
            this.element.attr("role", "tablist"),
            e.collapsible ||
              (!1 !== e.active && null != e.active) ||
              (e.active = 0),
            this._processPanels(),
            e.active < 0 && (e.active += this.headers.length),
            this._refresh();
        },
        _getCreateEventData: function () {
          return {
            header: this.active,
            panel: this.active.length ? this.active.next() : t(),
          };
        },
        _createIcons: function () {
          var e,
            i,
            n = this.options.icons;
          n &&
            ((e = t("<span>")),
            this._addClass(
              e,
              "ui-accordion-header-icon",
              "ui-icon " + n.header
            ),
            e.prependTo(this.headers),
            (i = this.active.children(".ui-accordion-header-icon")),
            this._removeClass(i, n.header)
              ._addClass(i, null, n.activeHeader)
              ._addClass(this.headers, "ui-accordion-icons"));
        },
        _destroyIcons: function () {
          this._removeClass(this.headers, "ui-accordion-icons"),
            this.headers.children(".ui-accordion-header-icon").remove();
        },
        _destroy: function () {
          var t;
          this.element.removeAttr("role"),
            this.headers
              .removeAttr(
                "role aria-expanded aria-selected aria-controls tabIndex"
              )
              .removeUniqueId(),
            this._destroyIcons(),
            (t = this.headers
              .next()
              .css("display", "")
              .removeAttr("role aria-hidden aria-labelledby")
              .removeUniqueId()),
            "content" !== this.options.heightStyle && t.css("height", "");
        },
        _setOption: function (t, e) {
          "active" !== t
            ? ("event" === t &&
                (this.options.event &&
                  this._off(this.headers, this.options.event),
                this._setupEvents(e)),
              this._super(t, e),
              "collapsible" !== t ||
                e ||
                !1 !== this.options.active ||
                this._activate(0),
              "icons" === t && (this._destroyIcons(), e && this._createIcons()))
            : this._activate(e);
        },
        _setOptionDisabled: function (t) {
          this._super(t),
            this.element.attr("aria-disabled", t),
            this._toggleClass(null, "ui-state-disabled", !!t),
            this._toggleClass(
              this.headers.add(this.headers.next()),
              null,
              "ui-state-disabled",
              !!t
            );
        },
        _keydown: function (e) {
          if (!e.altKey && !e.ctrlKey) {
            var i = t.ui.keyCode,
              n = this.headers.length,
              s = this.headers.index(e.target),
              o = !1;
            switch (e.keyCode) {
              case i.RIGHT:
              case i.DOWN:
                o = this.headers[(s + 1) % n];
                break;
              case i.LEFT:
              case i.UP:
                o = this.headers[(s - 1 + n) % n];
                break;
              case i.SPACE:
              case i.ENTER:
                this._eventHandler(e);
                break;
              case i.HOME:
                o = this.headers[0];
                break;
              case i.END:
                o = this.headers[n - 1];
            }
            o &&
              (t(e.target).attr("tabIndex", -1),
              t(o).attr("tabIndex", 0),
              t(o).trigger("focus"),
              e.preventDefault());
          }
        },
        _panelKeyDown: function (e) {
          e.keyCode === t.ui.keyCode.UP &&
            e.ctrlKey &&
            t(e.currentTarget).prev().trigger("focus");
        },
        refresh: function () {
          var e = this.options;
          this._processPanels(),
            (!1 === e.active && !0 === e.collapsible) || !this.headers.length
              ? ((e.active = !1), (this.active = t()))
              : !1 === e.active
              ? this._activate(0)
              : this.active.length &&
                !t.contains(this.element[0], this.active[0])
              ? this.headers.length ===
                this.headers.find(".ui-state-disabled").length
                ? ((e.active = !1), (this.active = t()))
                : this._activate(Math.max(0, e.active - 1))
              : (e.active = this.headers.index(this.active)),
            this._destroyIcons(),
            this._refresh();
        },
        _processPanels: function () {
          var t = this.headers,
            e = this.panels;
          (this.headers = this.element.find(this.options.header)),
            this._addClass(
              this.headers,
              "ui-accordion-header ui-accordion-header-collapsed",
              "ui-state-default"
            ),
            (this.panels = this.headers
              .next()
              .filter(":not(.ui-accordion-content-active)")
              .hide()),
            this._addClass(
              this.panels,
              "ui-accordion-content",
              "ui-helper-reset ui-widget-content"
            ),
            e &&
              (this._off(t.not(this.headers)), this._off(e.not(this.panels)));
        },
        _refresh: function () {
          var e,
            i = this.options,
            n = i.heightStyle,
            s = this.element.parent();
          (this.active = this._findActive(i.active)),
            this._addClass(
              this.active,
              "ui-accordion-header-active",
              "ui-state-active"
            )._removeClass(this.active, "ui-accordion-header-collapsed"),
            this._addClass(this.active.next(), "ui-accordion-content-active"),
            this.active.next().show(),
            this.headers
              .attr("role", "tab")
              .each(function () {
                var e = t(this),
                  i = e.uniqueId().attr("id"),
                  n = e.next(),
                  s = n.uniqueId().attr("id");
                e.attr("aria-controls", s), n.attr("aria-labelledby", i);
              })
              .next()
              .attr("role", "tabpanel"),
            this.headers
              .not(this.active)
              .attr({
                "aria-selected": "false",
                "aria-expanded": "false",
                tabIndex: -1,
              })
              .next()
              .attr({ "aria-hidden": "true" })
              .hide(),
            this.active.length
              ? this.active
                  .attr({
                    "aria-selected": "true",
                    "aria-expanded": "true",
                    tabIndex: 0,
                  })
                  .next()
                  .attr({ "aria-hidden": "false" })
              : this.headers.eq(0).attr("tabIndex", 0),
            this._createIcons(),
            this._setupEvents(i.event),
            "fill" === n
              ? ((e = s.height()),
                this.element.siblings(":visible").each(function () {
                  var i = t(this),
                    n = i.css("position");
                  "absolute" !== n && "fixed" !== n && (e -= i.outerHeight(!0));
                }),
                this.headers.each(function () {
                  e -= t(this).outerHeight(!0);
                }),
                this.headers
                  .next()
                  .each(function () {
                    t(this).height(
                      Math.max(0, e - t(this).innerHeight() + t(this).height())
                    );
                  })
                  .css("overflow", "auto"))
              : "auto" === n &&
                ((e = 0),
                this.headers
                  .next()
                  .each(function () {
                    var i = t(this).is(":visible");
                    i || t(this).show(),
                      (e = Math.max(e, t(this).css("height", "").height())),
                      i || t(this).hide();
                  })
                  .height(e));
        },
        _activate: function (e) {
          var i = this._findActive(e)[0];
          i !== this.active[0] &&
            ((i = i || this.active[0]),
            this._eventHandler({
              target: i,
              currentTarget: i,
              preventDefault: t.noop,
            }));
        },
        _findActive: function (e) {
          return "number" == typeof e ? this.headers.eq(e) : t();
        },
        _setupEvents: function (e) {
          var i = { keydown: "_keydown" };
          e &&
            t.each(e.split(" "), function (t, e) {
              i[e] = "_eventHandler";
            }),
            this._off(this.headers.add(this.headers.next())),
            this._on(this.headers, i),
            this._on(this.headers.next(), { keydown: "_panelKeyDown" }),
            this._hoverable(this.headers),
            this._focusable(this.headers);
        },
        _eventHandler: function (e) {
          var i,
            n,
            s = this.options,
            o = this.active,
            r = t(e.currentTarget),
            a = r[0] === o[0],
            l = a && s.collapsible,
            h = l ? t() : r.next(),
            c = o.next(),
            u = {
              oldHeader: o,
              oldPanel: c,
              newHeader: l ? t() : r,
              newPanel: h,
            };
          e.preventDefault(),
            (a && !s.collapsible) ||
              !1 === this._trigger("beforeActivate", e, u) ||
              ((s.active = !l && this.headers.index(r)),
              (this.active = a ? t() : r),
              this._toggle(u),
              this._removeClass(
                o,
                "ui-accordion-header-active",
                "ui-state-active"
              ),
              s.icons &&
                ((i = o.children(".ui-accordion-header-icon")),
                this._removeClass(i, null, s.icons.activeHeader)._addClass(
                  i,
                  null,
                  s.icons.header
                )),
              a ||
                (this._removeClass(
                  r,
                  "ui-accordion-header-collapsed"
                )._addClass(r, "ui-accordion-header-active", "ui-state-active"),
                s.icons &&
                  ((n = r.children(".ui-accordion-header-icon")),
                  this._removeClass(n, null, s.icons.header)._addClass(
                    n,
                    null,
                    s.icons.activeHeader
                  )),
                this._addClass(r.next(), "ui-accordion-content-active")));
        },
        _toggle: function (e) {
          var i = e.newPanel,
            n = this.prevShow.length ? this.prevShow : e.oldPanel;
          this.prevShow.add(this.prevHide).stop(!0, !0),
            (this.prevShow = i),
            (this.prevHide = n),
            this.options.animate
              ? this._animate(i, n, e)
              : (n.hide(), i.show(), this._toggleComplete(e)),
            n.attr({ "aria-hidden": "true" }),
            n
              .prev()
              .attr({ "aria-selected": "false", "aria-expanded": "false" }),
            i.length && n.length
              ? n.prev().attr({ tabIndex: -1, "aria-expanded": "false" })
              : i.length &&
                this.headers
                  .filter(function () {
                    return 0 === parseInt(t(this).attr("tabIndex"), 10);
                  })
                  .attr("tabIndex", -1),
            i.attr("aria-hidden", "false").prev().attr({
              "aria-selected": "true",
              "aria-expanded": "true",
              tabIndex: 0,
            });
        },
        _animate: function (t, e, i) {
          var n,
            s,
            o,
            r = this,
            a = 0,
            l = t.css("box-sizing"),
            h = t.length && (!e.length || t.index() < e.index()),
            c = this.options.animate || {},
            u = (h && c.down) || c,
            d = function () {
              r._toggleComplete(i);
            };
          return (
            "number" == typeof u && (o = u),
            "string" == typeof u && (s = u),
            (s = s || u.easing || c.easing),
            (o = o || u.duration || c.duration),
            e.length
              ? t.length
                ? ((n = t.show().outerHeight()),
                  e.animate(this.hideProps, {
                    duration: o,
                    easing: s,
                    step: function (t, e) {
                      e.now = Math.round(t);
                    },
                  }),
                  void t.hide().animate(this.showProps, {
                    duration: o,
                    easing: s,
                    complete: d,
                    step: function (t, i) {
                      (i.now = Math.round(t)),
                        "height" !== i.prop
                          ? "content-box" === l && (a += i.now)
                          : "content" !== r.options.heightStyle &&
                            ((i.now = Math.round(n - e.outerHeight() - a)),
                            (a = 0));
                    },
                  }))
                : e.animate(this.hideProps, o, s, d)
              : t.animate(this.showProps, o, s, d)
          );
        },
        _toggleComplete: function (t) {
          var e = t.oldPanel,
            i = e.prev();
          this._removeClass(e, "ui-accordion-content-active"),
            this._removeClass(i, "ui-accordion-header-active")._addClass(
              i,
              "ui-accordion-header-collapsed"
            ),
            e.length && (e.parent()[0].className = e.parent()[0].className),
            this._trigger("activate", null, t);
        },
      }),
      (t.ui.safeActiveElement = function (t) {
        var e;
        try {
          e = t.activeElement;
        } catch (i) {
          e = t.body;
        }
        return e || (e = t.body), e.nodeName || (e = t.body), e;
      }),
      t.widget("ui.menu", {
        version: "1.12.1",
        defaultElement: "<ul>",
        delay: 300,
        options: {
          icons: { submenu: "ui-icon-caret-1-e" },
          items: "> *",
          menus: "ul",
          position: { my: "left top", at: "right top" },
          role: "menu",
          blur: null,
          focus: null,
          select: null,
        },
        _create: function () {
          (this.activeMenu = this.element),
            (this.mouseHandled = !1),
            this.element
              .uniqueId()
              .attr({ role: this.options.role, tabIndex: 0 }),
            this._addClass("ui-menu", "ui-widget ui-widget-content"),
            this._on({
              "mousedown .ui-menu-item": function (t) {
                t.preventDefault();
              },
              "click .ui-menu-item": function (e) {
                var i = t(e.target),
                  n = t(t.ui.safeActiveElement(this.document[0]));
                !this.mouseHandled &&
                  i.not(".ui-state-disabled").length &&
                  (this.select(e),
                  e.isPropagationStopped() || (this.mouseHandled = !0),
                  i.has(".ui-menu").length
                    ? this.expand(e)
                    : !this.element.is(":focus") &&
                      n.closest(".ui-menu").length &&
                      (this.element.trigger("focus", [!0]),
                      this.active &&
                        1 === this.active.parents(".ui-menu").length &&
                        clearTimeout(this.timer)));
              },
              "mouseenter .ui-menu-item": function (e) {
                if (!this.previousFilter) {
                  var i = t(e.target).closest(".ui-menu-item"),
                    n = t(e.currentTarget);
                  i[0] === n[0] &&
                    (this._removeClass(
                      n.siblings().children(".ui-state-active"),
                      null,
                      "ui-state-active"
                    ),
                    this.focus(e, n));
                }
              },
              mouseleave: "collapseAll",
              "mouseleave .ui-menu": "collapseAll",
              focus: function (t, e) {
                var i =
                  this.active || this.element.find(this.options.items).eq(0);
                e || this.focus(t, i);
              },
              blur: function (e) {
                this._delay(function () {
                  !t.contains(
                    this.element[0],
                    t.ui.safeActiveElement(this.document[0])
                  ) && this.collapseAll(e);
                });
              },
              keydown: "_keydown",
            }),
            this.refresh(),
            this._on(this.document, {
              click: function (t) {
                this._closeOnDocumentClick(t) && this.collapseAll(t),
                  (this.mouseHandled = !1);
              },
            });
        },
        _destroy: function () {
          var e = this.element
            .find(".ui-menu-item")
            .removeAttr("role aria-disabled")
            .children(".ui-menu-item-wrapper")
            .removeUniqueId()
            .removeAttr("tabIndex role aria-haspopup");
          this.element
            .removeAttr("aria-activedescendant")
            .find(".ui-menu")
            .addBack()
            .removeAttr(
              "role aria-labelledby aria-expanded aria-hidden aria-disabled tabIndex"
            )
            .removeUniqueId()
            .show(),
            e.children().each(function () {
              var e = t(this);
              e.data("ui-menu-submenu-caret") && e.remove();
            });
        },
        _keydown: function (e) {
          var i,
            n,
            s,
            o,
            r = !0;
          switch (e.keyCode) {
            case t.ui.keyCode.PAGE_UP:
              this.previousPage(e);
              break;
            case t.ui.keyCode.PAGE_DOWN:
              this.nextPage(e);
              break;
            case t.ui.keyCode.HOME:
              this._move("first", "first", e);
              break;
            case t.ui.keyCode.END:
              this._move("last", "last", e);
              break;
            case t.ui.keyCode.UP:
              this.previous(e);
              break;
            case t.ui.keyCode.DOWN:
              this.next(e);
              break;
            case t.ui.keyCode.LEFT:
              this.collapse(e);
              break;
            case t.ui.keyCode.RIGHT:
              this.active &&
                !this.active.is(".ui-state-disabled") &&
                this.expand(e);
              break;
            case t.ui.keyCode.ENTER:
            case t.ui.keyCode.SPACE:
              this._activate(e);
              break;
            case t.ui.keyCode.ESCAPE:
              this.collapse(e);
              break;
            default:
              (r = !1),
                (n = this.previousFilter || ""),
                (o = !1),
                (s =
                  e.keyCode >= 96 && e.keyCode <= 105
                    ? (e.keyCode - 96).toString()
                    : String.fromCharCode(e.keyCode)),
                clearTimeout(this.filterTimer),
                s === n ? (o = !0) : (s = n + s),
                (i = this._filterMenuItems(s)),
                (i =
                  o && -1 !== i.index(this.active.next())
                    ? this.active.nextAll(".ui-menu-item")
                    : i).length ||
                  ((s = String.fromCharCode(e.keyCode)),
                  (i = this._filterMenuItems(s))),
                i.length
                  ? (this.focus(e, i),
                    (this.previousFilter = s),
                    (this.filterTimer = this._delay(function () {
                      delete this.previousFilter;
                    }, 1e3)))
                  : delete this.previousFilter;
          }
          r && e.preventDefault();
        },
        _activate: function (t) {
          this.active &&
            !this.active.is(".ui-state-disabled") &&
            (this.active.children("[aria-haspopup='true']").length
              ? this.expand(t)
              : this.select(t));
        },
        refresh: function () {
          var e,
            i,
            n,
            s,
            o = this,
            r = this.options.icons.submenu,
            a = this.element.find(this.options.menus);
          this._toggleClass(
            "ui-menu-icons",
            null,
            !!this.element.find(".ui-icon").length
          ),
            (i = a
              .filter(":not(.ui-menu)")
              .hide()
              .attr({
                role: this.options.role,
                "aria-hidden": "true",
                "aria-expanded": "false",
              })
              .each(function () {
                var e = t(this),
                  i = e.prev(),
                  n = t("<span>").data("ui-menu-submenu-caret", !0);
                o._addClass(n, "ui-menu-icon", "ui-icon " + r),
                  i.attr("aria-haspopup", "true").prepend(n),
                  e.attr("aria-labelledby", i.attr("id"));
              })),
            this._addClass(
              i,
              "ui-menu",
              "ui-widget ui-widget-content ui-front"
            ),
            (e = a.add(this.element).find(this.options.items))
              .not(".ui-menu-item")
              .each(function () {
                var e = t(this);
                o._isDivider(e) &&
                  o._addClass(e, "ui-menu-divider", "ui-widget-content");
              }),
            (s = (n = e.not(".ui-menu-item, .ui-menu-divider"))
              .children()
              .not(".ui-menu")
              .uniqueId()
              .attr({ tabIndex: -1, role: this._itemRole() })),
            this._addClass(n, "ui-menu-item")._addClass(
              s,
              "ui-menu-item-wrapper"
            ),
            e.filter(".ui-state-disabled").attr("aria-disabled", "true"),
            this.active &&
              !t.contains(this.element[0], this.active[0]) &&
              this.blur();
        },
        _itemRole: function () {
          return { menu: "menuitem", listbox: "option" }[this.options.role];
        },
        _setOption: function (t, e) {
          if ("icons" === t) {
            var i = this.element.find(".ui-menu-icon");
            this._removeClass(i, null, this.options.icons.submenu)._addClass(
              i,
              null,
              e.submenu
            );
          }
          this._super(t, e);
        },
        _setOptionDisabled: function (t) {
          this._super(t),
            this.element.attr("aria-disabled", String(t)),
            this._toggleClass(null, "ui-state-disabled", !!t);
        },
        focus: function (t, e) {
          var i, n, s;
          this.blur(t, t && "focus" === t.type),
            this._scrollIntoView(e),
            (this.active = e.first()),
            (n = this.active.children(".ui-menu-item-wrapper")),
            this._addClass(n, null, "ui-state-active"),
            this.options.role &&
              this.element.attr("aria-activedescendant", n.attr("id")),
            (s = this.active
              .parent()
              .closest(".ui-menu-item")
              .children(".ui-menu-item-wrapper")),
            this._addClass(s, null, "ui-state-active"),
            t && "keydown" === t.type
              ? this._close()
              : (this.timer = this._delay(function () {
                  this._close();
                }, this.delay)),
            (i = e.children(".ui-menu")).length &&
              t &&
              /^mouse/.test(t.type) &&
              this._startOpening(i),
            (this.activeMenu = e.parent()),
            this._trigger("focus", t, { item: e });
        },
        _scrollIntoView: function (e) {
          var i, n, s, o, r, a;
          this._hasScroll() &&
            ((i = parseFloat(t.css(this.activeMenu[0], "borderTopWidth")) || 0),
            (n = parseFloat(t.css(this.activeMenu[0], "paddingTop")) || 0),
            (s = e.offset().top - this.activeMenu.offset().top - i - n),
            (o = this.activeMenu.scrollTop()),
            (r = this.activeMenu.height()),
            (a = e.outerHeight()),
            s < 0
              ? this.activeMenu.scrollTop(o + s)
              : s + a > r && this.activeMenu.scrollTop(o + s - r + a));
        },
        blur: function (t, e) {
          e || clearTimeout(this.timer),
            this.active &&
              (this._removeClass(
                this.active.children(".ui-menu-item-wrapper"),
                null,
                "ui-state-active"
              ),
              this._trigger("blur", t, { item: this.active }),
              (this.active = null));
        },
        _startOpening: function (t) {
          clearTimeout(this.timer),
            "true" === t.attr("aria-hidden") &&
              (this.timer = this._delay(function () {
                this._close(), this._open(t);
              }, this.delay));
        },
        _open: function (e) {
          var i = t.extend({ of: this.active }, this.options.position);
          clearTimeout(this.timer),
            this.element
              .find(".ui-menu")
              .not(e.parents(".ui-menu"))
              .hide()
              .attr("aria-hidden", "true"),
            e
              .show()
              .removeAttr("aria-hidden")
              .attr("aria-expanded", "true")
              .position(i);
        },
        collapseAll: function (e, i) {
          clearTimeout(this.timer),
            (this.timer = this._delay(function () {
              var n = i
                ? this.element
                : t(e && e.target).closest(this.element.find(".ui-menu"));
              n.length || (n = this.element),
                this._close(n),
                this.blur(e),
                this._removeClass(
                  n.find(".ui-state-active"),
                  null,
                  "ui-state-active"
                ),
                (this.activeMenu = n);
            }, this.delay));
        },
        _close: function (t) {
          t || (t = this.active ? this.active.parent() : this.element),
            t
              .find(".ui-menu")
              .hide()
              .attr("aria-hidden", "true")
              .attr("aria-expanded", "false");
        },
        _closeOnDocumentClick: function (e) {
          return !t(e.target).closest(".ui-menu").length;
        },
        _isDivider: function (t) {
          return !/[^\-\u2014\u2013\s]/.test(t.text());
        },
        collapse: function (t) {
          var e =
            this.active &&
            this.active.parent().closest(".ui-menu-item", this.element);
          e && e.length && (this._close(), this.focus(t, e));
        },
        expand: function (t) {
          var e =
            this.active &&
            this.active.children(".ui-menu ").find(this.options.items).first();
          e &&
            e.length &&
            (this._open(e.parent()),
            this._delay(function () {
              this.focus(t, e);
            }));
        },
        next: function (t) {
          this._move("next", "first", t);
        },
        previous: function (t) {
          this._move("prev", "last", t);
        },
        isFirstItem: function () {
          return this.active && !this.active.prevAll(".ui-menu-item").length;
        },
        isLastItem: function () {
          return this.active && !this.active.nextAll(".ui-menu-item").length;
        },
        _move: function (t, e, i) {
          var n;
          this.active &&
            (n =
              "first" === t || "last" === t
                ? this.active["first" === t ? "prevAll" : "nextAll"](
                    ".ui-menu-item"
                  ).eq(-1)
                : this.active[t + "All"](".ui-menu-item").eq(0)),
            (n && n.length && this.active) ||
              (n = this.activeMenu.find(this.options.items)[e]()),
            this.focus(i, n);
        },
        nextPage: function (e) {
          var i, n, s;
          this.active
            ? this.isLastItem() ||
              (this._hasScroll()
                ? ((n = this.active.offset().top),
                  (s = this.element.height()),
                  this.active.nextAll(".ui-menu-item").each(function () {
                    return (i = t(this)).offset().top - n - s < 0;
                  }),
                  this.focus(e, i))
                : this.focus(
                    e,
                    this.activeMenu
                      .find(this.options.items)
                      [this.active ? "last" : "first"]()
                  ))
            : this.next(e);
        },
        previousPage: function (e) {
          var i, n, s;
          this.active
            ? this.isFirstItem() ||
              (this._hasScroll()
                ? ((n = this.active.offset().top),
                  (s = this.element.height()),
                  this.active.prevAll(".ui-menu-item").each(function () {
                    return (i = t(this)).offset().top - n + s > 0;
                  }),
                  this.focus(e, i))
                : this.focus(
                    e,
                    this.activeMenu.find(this.options.items).first()
                  ))
            : this.next(e);
        },
        _hasScroll: function () {
          return this.element.outerHeight() < this.element.prop("scrollHeight");
        },
        select: function (e) {
          this.active = this.active || t(e.target).closest(".ui-menu-item");
          var i = { item: this.active };
          this.active.has(".ui-menu").length || this.collapseAll(e, !0),
            this._trigger("select", e, i);
        },
        _filterMenuItems: function (e) {
          var i = e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&"),
            n = new RegExp("^" + i, "i");
          return this.activeMenu
            .find(this.options.items)
            .filter(".ui-menu-item")
            .filter(function () {
              return n.test(
                t.trim(t(this).children(".ui-menu-item-wrapper").text())
              );
            });
        },
      });
    t.widget("ui.autocomplete", {
      version: "1.12.1",
      defaultElement: "<input>",
      options: {
        appendTo: null,
        autoFocus: !1,
        delay: 300,
        minLength: 1,
        position: { my: "left top", at: "left bottom", collision: "none" },
        source: null,
        change: null,
        close: null,
        focus: null,
        open: null,
        response: null,
        search: null,
        select: null,
      },
      requestIndex: 0,
      pending: 0,
      _create: function () {
        var e,
          i,
          n,
          s = this.element[0].nodeName.toLowerCase(),
          o = "textarea" === s,
          r = "input" === s;
        (this.isMultiLine = o || (!r && this._isContentEditable(this.element))),
          (this.valueMethod = this.element[o || r ? "val" : "text"]),
          (this.isNewMenu = !0),
          this._addClass("ui-autocomplete-input"),
          this.element.attr("autocomplete", "off"),
          this._on(this.element, {
            keydown: function (s) {
              if (this.element.prop("readOnly"))
                return (e = !0), (n = !0), void (i = !0);
              (e = !1), (n = !1), (i = !1);
              var o = t.ui.keyCode;
              switch (s.keyCode) {
                case o.PAGE_UP:
                  (e = !0), this._move("previousPage", s);
                  break;
                case o.PAGE_DOWN:
                  (e = !0), this._move("nextPage", s);
                  break;
                case o.UP:
                  (e = !0), this._keyEvent("previous", s);
                  break;
                case o.DOWN:
                  (e = !0), this._keyEvent("next", s);
                  break;
                case o.ENTER:
                  this.menu.active &&
                    ((e = !0), s.preventDefault(), this.menu.select(s));
                  break;
                case o.TAB:
                  this.menu.active && this.menu.select(s);
                  break;
                case o.ESCAPE:
                  this.menu.element.is(":visible") &&
                    (this.isMultiLine || this._value(this.term),
                    this.close(s),
                    s.preventDefault());
                  break;
                default:
                  (i = !0), this._searchTimeout(s);
              }
            },
            keypress: function (n) {
              if (e)
                return (
                  (e = !1),
                  void (
                    (this.isMultiLine && !this.menu.element.is(":visible")) ||
                    n.preventDefault()
                  )
                );
              if (!i) {
                var s = t.ui.keyCode;
                switch (n.keyCode) {
                  case s.PAGE_UP:
                    this._move("previousPage", n);
                    break;
                  case s.PAGE_DOWN:
                    this._move("nextPage", n);
                    break;
                  case s.UP:
                    this._keyEvent("previous", n);
                    break;
                  case s.DOWN:
                    this._keyEvent("next", n);
                }
              }
            },
            input: function (t) {
              if (n) return (n = !1), void t.preventDefault();
              this._searchTimeout(t);
            },
            focus: function () {
              (this.selectedItem = null), (this.previous = this._value());
            },
            blur: function (t) {
              this.cancelBlur
                ? delete this.cancelBlur
                : (clearTimeout(this.searching),
                  this.close(t),
                  this._change(t));
            },
          }),
          this._initSource(),
          (this.menu = t("<ul>")
            .appendTo(this._appendTo())
            .menu({ role: null })
            .hide()
            .menu("instance")),
          this._addClass(this.menu.element, "ui-autocomplete", "ui-front"),
          this._on(this.menu.element, {
            mousedown: function (e) {
              e.preventDefault(),
                (this.cancelBlur = !0),
                this._delay(function () {
                  delete this.cancelBlur,
                    this.element[0] !==
                      t.ui.safeActiveElement(this.document[0]) &&
                      this.element.trigger("focus");
                });
            },
            menufocus: function (e, i) {
              var n, s;
              if (
                this.isNewMenu &&
                ((this.isNewMenu = !1),
                e.originalEvent && /^mouse/.test(e.originalEvent.type))
              )
                return (
                  this.menu.blur(),
                  void this.document.one("mousemove", function () {
                    t(e.target).trigger(e.originalEvent);
                  })
                );
              (s = i.item.data("ui-autocomplete-item")),
                !1 !== this._trigger("focus", e, { item: s }) &&
                  e.originalEvent &&
                  /^key/.test(e.originalEvent.type) &&
                  this._value(s.value),
                (n = i.item.attr("aria-label") || s.value) &&
                  t.trim(n).length &&
                  (this.liveRegion.children().hide(),
                  t("<div>").text(n).appendTo(this.liveRegion));
            },
            menuselect: function (e, i) {
              var n = i.item.data("ui-autocomplete-item"),
                s = this.previous;
              this.element[0] !== t.ui.safeActiveElement(this.document[0]) &&
                (this.element.trigger("focus"),
                (this.previous = s),
                this._delay(function () {
                  (this.previous = s), (this.selectedItem = n);
                })),
                !1 !== this._trigger("select", e, { item: n }) &&
                  this._value(n.value),
                (this.term = this._value()),
                this.close(e),
                (this.selectedItem = n);
            },
          }),
          (this.liveRegion = t("<div>", {
            role: "status",
            "aria-live": "assertive",
            "aria-relevant": "additions",
          }).appendTo(this.document[0].body)),
          this._addClass(this.liveRegion, null, "ui-helper-hidden-accessible"),
          this._on(this.window, {
            beforeunload: function () {
              this.element.removeAttr("autocomplete");
            },
          });
      },
      _destroy: function () {
        clearTimeout(this.searching),
          this.element.removeAttr("autocomplete"),
          this.menu.element.remove(),
          this.liveRegion.remove();
      },
      _setOption: function (t, e) {
        this._super(t, e),
          "source" === t && this._initSource(),
          "appendTo" === t && this.menu.element.appendTo(this._appendTo()),
          "disabled" === t && e && this.xhr && this.xhr.abort();
      },
      _isEventTargetInWidget: function (e) {
        var i = this.menu.element[0];
        return (
          e.target === this.element[0] ||
          e.target === i ||
          t.contains(i, e.target)
        );
      },
      _closeOnClickOutside: function (t) {
        this._isEventTargetInWidget(t) || this.close();
      },
      _appendTo: function () {
        var e = this.options.appendTo;
        return (
          e &&
            (e = e.jquery || e.nodeType ? t(e) : this.document.find(e).eq(0)),
          (e && e[0]) || (e = this.element.closest(".ui-front, dialog")),
          e.length || (e = this.document[0].body),
          e
        );
      },
      _initSource: function () {
        var e,
          i,
          n = this;
        t.isArray(this.options.source)
          ? ((e = this.options.source),
            (this.source = function (i, n) {
              n(t.ui.autocomplete.filter(e, i.term));
            }))
          : "string" == typeof this.options.source
          ? ((i = this.options.source),
            (this.source = function (e, s) {
              n.xhr && n.xhr.abort(),
                (n.xhr = t.ajax({
                  url: i,
                  data: e,
                  dataType: "json",
                  success: function (t) {
                    s(t);
                  },
                  error: function () {
                    s([]);
                  },
                }));
            }))
          : (this.source = this.options.source);
      },
      _searchTimeout: function (t) {
        clearTimeout(this.searching),
          (this.searching = this._delay(function () {
            var e = this.term === this._value(),
              i = this.menu.element.is(":visible"),
              n = t.altKey || t.ctrlKey || t.metaKey || t.shiftKey;
            (e && (!e || i || n)) ||
              ((this.selectedItem = null), this.search(null, t));
          }, this.options.delay));
      },
      search: function (t, e) {
        return (
          (t = null != t ? t : this._value()),
          (this.term = this._value()),
          t.length < this.options.minLength
            ? this.close(e)
            : !1 !== this._trigger("search", e)
            ? this._search(t)
            : void 0
        );
      },
      _search: function (t) {
        this.pending++,
          this._addClass("ui-autocomplete-loading"),
          (this.cancelSearch = !1),
          this.source({ term: t }, this._response());
      },
      _response: function () {
        var e = ++this.requestIndex;
        return t.proxy(function (t) {
          e === this.requestIndex && this.__response(t),
            this.pending--,
            this.pending || this._removeClass("ui-autocomplete-loading");
        }, this);
      },
      __response: function (t) {
        t && (t = this._normalize(t)),
          this._trigger("response", null, { content: t }),
          !this.options.disabled && t && t.length && !this.cancelSearch
            ? (this._suggest(t), this._trigger("open"))
            : this._close();
      },
      close: function (t) {
        (this.cancelSearch = !0), this._close(t);
      },
      _close: function (t) {
        this._off(this.document, "mousedown"),
          this.menu.element.is(":visible") &&
            (this.menu.element.hide(),
            this.menu.blur(),
            (this.isNewMenu = !0),
            this._trigger("close", t));
      },
      _change: function (t) {
        this.previous !== this._value() &&
          this._trigger("change", t, { item: this.selectedItem });
      },
      _normalize: function (e) {
        return e.length && e[0].label && e[0].value
          ? e
          : t.map(e, function (e) {
              return "string" == typeof e
                ? { label: e, value: e }
                : t.extend({}, e, {
                    label: e.label || e.value,
                    value: e.value || e.label,
                  });
            });
      },
      _suggest: function (e) {
        var i = this.menu.element.empty();
        this._renderMenu(i, e),
          (this.isNewMenu = !0),
          this.menu.refresh(),
          i.show(),
          this._resizeMenu(),
          i.position(t.extend({ of: this.element }, this.options.position)),
          this.options.autoFocus && this.menu.next(),
          this._on(this.document, { mousedown: "_closeOnClickOutside" });
      },
      _resizeMenu: function () {
        var t = this.menu.element;
        t.outerWidth(
          Math.max(t.width("").outerWidth() + 1, this.element.outerWidth())
        );
      },
      _renderMenu: function (e, i) {
        var n = this;
        t.each(i, function (t, i) {
          n._renderItemData(e, i);
        });
      },
      _renderItemData: function (t, e) {
        return this._renderItem(t, e).data("ui-autocomplete-item", e);
      },
      _renderItem: function (e, i) {
        return t("<li>").append(t("<div>").text(i.label)).appendTo(e);
      },
      _move: function (t, e) {
        if (this.menu.element.is(":visible"))
          return (this.menu.isFirstItem() && /^previous/.test(t)) ||
            (this.menu.isLastItem() && /^next/.test(t))
            ? (this.isMultiLine || this._value(this.term),
              void this.menu.blur())
            : void this.menu[t](e);
        this.search(null, e);
      },
      widget: function () {
        return this.menu.element;
      },
      _value: function () {
        return this.valueMethod.apply(this.element, arguments);
      },
      _keyEvent: function (t, e) {
        (this.isMultiLine && !this.menu.element.is(":visible")) ||
          (this._move(t, e), e.preventDefault());
      },
      _isContentEditable: function (t) {
        if (!t.length) return !1;
        var e = t.prop("contentEditable");
        return "inherit" === e
          ? this._isContentEditable(t.parent())
          : "true" === e;
      },
    }),
      t.extend(t.ui.autocomplete, {
        escapeRegex: function (t) {
          return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
        },
        filter: function (e, i) {
          var n = new RegExp(t.ui.autocomplete.escapeRegex(i), "i");
          return t.grep(e, function (t) {
            return n.test(t.label || t.value || t);
          });
        },
      }),
      t.widget("ui.autocomplete", t.ui.autocomplete, {
        options: {
          messages: {
            noResults: "No search results.",
            results: function (t) {
              return (
                t +
                (t > 1 ? " results are" : " result is") +
                " available, use up and down arrow keys to navigate."
              );
            },
          },
        },
        __response: function (e) {
          var i;
          this._superApply(arguments),
            this.options.disabled ||
              this.cancelSearch ||
              ((i =
                e && e.length
                  ? this.options.messages.results(e.length)
                  : this.options.messages.noResults),
              this.liveRegion.children().hide(),
              t("<div>").text(i).appendTo(this.liveRegion));
        },
      });
    t.ui.autocomplete;
    var c = /ui-corner-([a-z]){2,6}/g;
    t.widget("ui.controlgroup", {
      version: "1.12.1",
      defaultElement: "<div>",
      options: {
        direction: "horizontal",
        disabled: null,
        onlyVisible: !0,
        items: {
          button:
            "input[type=button], input[type=submit], input[type=reset], button, a",
          controlgroupLabel: ".ui-controlgroup-label",
          checkboxradio: "input[type='checkbox'], input[type='radio']",
          selectmenu: "select",
          spinner: ".ui-spinner-input",
        },
      },
      _create: function () {
        this._enhance();
      },
      _enhance: function () {
        this.element.attr("role", "toolbar"), this.refresh();
      },
      _destroy: function () {
        this._callChildMethod("destroy"),
          this.childWidgets.removeData("ui-controlgroup-data"),
          this.element.removeAttr("role"),
          this.options.items.controlgroupLabel &&
            this.element
              .find(this.options.items.controlgroupLabel)
              .find(".ui-controlgroup-label-contents")
              .contents()
              .unwrap();
      },
      _initWidgets: function () {
        var e = this,
          i = [];
        t.each(this.options.items, function (n, s) {
          var o,
            r = {};
          if (s)
            return "controlgroupLabel" === n
              ? ((o = e.element.find(s)).each(function () {
                  var e = t(this);
                  e.children(".ui-controlgroup-label-contents").length ||
                    e
                      .contents()
                      .wrapAll(
                        "<span class='ui-controlgroup-label-contents'></span>"
                      );
                }),
                e._addClass(
                  o,
                  null,
                  "ui-widget ui-widget-content ui-state-default"
                ),
                void (i = i.concat(o.get())))
              : void (
                  t.fn[n] &&
                  ((r = e["_" + n + "Options"]
                    ? e["_" + n + "Options"]("middle")
                    : { classes: {} }),
                  e.element.find(s).each(function () {
                    var s = t(this),
                      o = s[n]("instance"),
                      a = t.widget.extend({}, r);
                    if ("button" !== n || !s.parent(".ui-spinner").length) {
                      o || (o = s[n]()[n]("instance")),
                        o &&
                          (a.classes = e._resolveClassesValues(a.classes, o)),
                        s[n](a);
                      var l = s[n]("widget");
                      t.data(
                        l[0],
                        "ui-controlgroup-data",
                        o || s[n]("instance")
                      ),
                        i.push(l[0]);
                    }
                  }))
                );
        }),
          (this.childWidgets = t(t.unique(i))),
          this._addClass(this.childWidgets, "ui-controlgroup-item");
      },
      _callChildMethod: function (e) {
        this.childWidgets.each(function () {
          var i = t(this).data("ui-controlgroup-data");
          i && i[e] && i[e]();
        });
      },
      _updateCornerClass: function (t, e) {
        var i = this._buildSimpleOptions(e, "label").classes.label;
        this._removeClass(
          t,
          null,
          "ui-corner-top ui-corner-bottom ui-corner-left ui-corner-right ui-corner-all"
        ),
          this._addClass(t, null, i);
      },
      _buildSimpleOptions: function (t, e) {
        var i = "vertical" === this.options.direction,
          n = { classes: {} };
        return (
          (n.classes[e] = {
            middle: "",
            first: "ui-corner-" + (i ? "top" : "left"),
            last: "ui-corner-" + (i ? "bottom" : "right"),
            only: "ui-corner-all",
          }[t]),
          n
        );
      },
      _spinnerOptions: function (t) {
        var e = this._buildSimpleOptions(t, "ui-spinner");
        return (
          (e.classes["ui-spinner-up"] = ""),
          (e.classes["ui-spinner-down"] = ""),
          e
        );
      },
      _buttonOptions: function (t) {
        return this._buildSimpleOptions(t, "ui-button");
      },
      _checkboxradioOptions: function (t) {
        return this._buildSimpleOptions(t, "ui-checkboxradio-label");
      },
      _selectmenuOptions: function (t) {
        var e = "vertical" === this.options.direction;
        return {
          width: !!e && "auto",
          classes: {
            middle: {
              "ui-selectmenu-button-open": "",
              "ui-selectmenu-button-closed": "",
            },
            first: {
              "ui-selectmenu-button-open": "ui-corner-" + (e ? "top" : "tl"),
              "ui-selectmenu-button-closed":
                "ui-corner-" + (e ? "top" : "left"),
            },
            last: {
              "ui-selectmenu-button-open": e ? "" : "ui-corner-tr",
              "ui-selectmenu-button-closed":
                "ui-corner-" + (e ? "bottom" : "right"),
            },
            only: {
              "ui-selectmenu-button-open": "ui-corner-top",
              "ui-selectmenu-button-closed": "ui-corner-all",
            },
          }[t],
        };
      },
      _resolveClassesValues: function (e, i) {
        var n = {};
        return (
          t.each(e, function (s) {
            var o = i.options.classes[s] || "";
            (o = t.trim(o.replace(c, ""))),
              (n[s] = (o + " " + e[s]).replace(/\s+/g, " "));
          }),
          n
        );
      },
      _setOption: function (t, e) {
        "direction" === t &&
          this._removeClass("ui-controlgroup-" + this.options.direction),
          this._super(t, e),
          "disabled" !== t
            ? this.refresh()
            : this._callChildMethod(e ? "disable" : "enable");
      },
      refresh: function () {
        var e,
          i = this;
        this._addClass(
          "ui-controlgroup ui-controlgroup-" + this.options.direction
        ),
          "horizontal" === this.options.direction &&
            this._addClass(null, "ui-helper-clearfix"),
          this._initWidgets(),
          (e = this.childWidgets),
          this.options.onlyVisible && (e = e.filter(":visible")),
          e.length &&
            (t.each(["first", "last"], function (t, n) {
              var s = e[n]().data("ui-controlgroup-data");
              if (s && i["_" + s.widgetName + "Options"]) {
                var o = i["_" + s.widgetName + "Options"](
                  1 === e.length ? "only" : n
                );
                (o.classes = i._resolveClassesValues(o.classes, s)),
                  s.element[s.widgetName](o);
              } else i._updateCornerClass(e[n](), n);
            }),
            this._callChildMethod("refresh"));
      },
    });
    t.widget("ui.checkboxradio", [
      t.ui.formResetMixin,
      {
        version: "1.12.1",
        options: {
          disabled: null,
          label: null,
          icon: !0,
          classes: {
            "ui-checkboxradio-label": "ui-corner-all",
            "ui-checkboxradio-icon": "ui-corner-all",
          },
        },
        _getCreateOptions: function () {
          var e,
            i,
            n = this,
            s = this._super() || {};
          return (
            this._readType(),
            (i = this.element.labels()),
            (this.label = t(i[i.length - 1])),
            this.label.length ||
              t.error("No label found for checkboxradio widget"),
            (this.originalLabel = ""),
            this.label
              .contents()
              .not(this.element[0])
              .each(function () {
                n.originalLabel +=
                  3 === this.nodeType ? t(this).text() : this.outerHTML;
              }),
            this.originalLabel && (s.label = this.originalLabel),
            null != (e = this.element[0].disabled) && (s.disabled = e),
            s
          );
        },
        _create: function () {
          var t = this.element[0].checked;
          this._bindFormResetHandler(),
            null == this.options.disabled &&
              (this.options.disabled = this.element[0].disabled),
            this._setOption("disabled", this.options.disabled),
            this._addClass("ui-checkboxradio", "ui-helper-hidden-accessible"),
            this._addClass(
              this.label,
              "ui-checkboxradio-label",
              "ui-button ui-widget"
            ),
            "radio" === this.type &&
              this._addClass(this.label, "ui-checkboxradio-radio-label"),
            this.options.label && this.options.label !== this.originalLabel
              ? this._updateLabel()
              : this.originalLabel && (this.options.label = this.originalLabel),
            this._enhance(),
            t &&
              (this._addClass(
                this.label,
                "ui-checkboxradio-checked",
                "ui-state-active"
              ),
              this.icon && this._addClass(this.icon, null, "ui-state-hover")),
            this._on({
              change: "_toggleClasses",
              focus: function () {
                this._addClass(
                  this.label,
                  null,
                  "ui-state-focus ui-visual-focus"
                );
              },
              blur: function () {
                this._removeClass(
                  this.label,
                  null,
                  "ui-state-focus ui-visual-focus"
                );
              },
            });
        },
        _readType: function () {
          var e = this.element[0].nodeName.toLowerCase();
          (this.type = this.element[0].type),
            ("input" === e && /radio|checkbox/.test(this.type)) ||
              t.error(
                "Can't create checkboxradio on element.nodeName=" +
                  e +
                  " and element.type=" +
                  this.type
              );
        },
        _enhance: function () {
          this._updateIcon(this.element[0].checked);
        },
        widget: function () {
          return this.label;
        },
        _getRadioGroup: function () {
          var e = this.element[0].name,
            i = "input[name='" + t.ui.escapeSelector(e) + "']";
          return e
            ? (this.form.length
                ? t(this.form[0].elements).filter(i)
                : t(i).filter(function () {
                    return 0 === t(this).form().length;
                  })
              ).not(this.element)
            : t([]);
        },
        _toggleClasses: function () {
          var e = this.element[0].checked;
          this._toggleClass(
            this.label,
            "ui-checkboxradio-checked",
            "ui-state-active",
            e
          ),
            this.options.icon &&
              "checkbox" === this.type &&
              this._toggleClass(
                this.icon,
                null,
                "ui-icon-check ui-state-checked",
                e
              )._toggleClass(this.icon, null, "ui-icon-blank", !e),
            "radio" === this.type &&
              this._getRadioGroup().each(function () {
                var e = t(this).checkboxradio("instance");
                e &&
                  e._removeClass(
                    e.label,
                    "ui-checkboxradio-checked",
                    "ui-state-active"
                  );
              });
        },
        _destroy: function () {
          this._unbindFormResetHandler(),
            this.icon && (this.icon.remove(), this.iconSpace.remove());
        },
        _setOption: function (t, e) {
          if ("label" !== t || e) {
            if ((this._super(t, e), "disabled" === t))
              return (
                this._toggleClass(this.label, null, "ui-state-disabled", e),
                void (this.element[0].disabled = e)
              );
            this.refresh();
          }
        },
        _updateIcon: function (e) {
          var i = "ui-icon ui-icon-background ";
          this.options.icon
            ? (this.icon ||
                ((this.icon = t("<span>")),
                (this.iconSpace = t("<span> </span>")),
                this._addClass(this.iconSpace, "ui-checkboxradio-icon-space")),
              "checkbox" === this.type
                ? ((i += e
                    ? "ui-icon-check ui-state-checked"
                    : "ui-icon-blank"),
                  this._removeClass(
                    this.icon,
                    null,
                    e ? "ui-icon-blank" : "ui-icon-check"
                  ))
                : (i += "ui-icon-blank"),
              this._addClass(this.icon, "ui-checkboxradio-icon", i),
              e ||
                this._removeClass(
                  this.icon,
                  null,
                  "ui-icon-check ui-state-checked"
                ),
              this.icon.prependTo(this.label).after(this.iconSpace))
            : void 0 !== this.icon &&
              (this.icon.remove(), this.iconSpace.remove(), delete this.icon);
        },
        _updateLabel: function () {
          var t = this.label.contents().not(this.element[0]);
          this.icon && (t = t.not(this.icon[0])),
            this.iconSpace && (t = t.not(this.iconSpace[0])),
            t.remove(),
            this.label.append(this.options.label);
        },
        refresh: function () {
          var t = this.element[0].checked,
            e = this.element[0].disabled;
          this._updateIcon(t),
            this._toggleClass(
              this.label,
              "ui-checkboxradio-checked",
              "ui-state-active",
              t
            ),
            null !== this.options.label && this._updateLabel(),
            e !== this.options.disabled && this._setOptions({ disabled: e });
        },
      },
    ]);
    t.ui.checkboxradio;
    t.widget("ui.button", {
      version: "1.12.1",
      defaultElement: "<button>",
      options: {
        classes: { "ui-button": "ui-corner-all" },
        disabled: null,
        icon: null,
        iconPosition: "beginning",
        label: null,
        showLabel: !0,
      },
      _getCreateOptions: function () {
        var t,
          e = this._super() || {};
        return (
          (this.isInput = this.element.is("input")),
          null != (t = this.element[0].disabled) && (e.disabled = t),
          (this.originalLabel = this.isInput
            ? this.element.val()
            : this.element.html()),
          this.originalLabel && (e.label = this.originalLabel),
          e
        );
      },
      _create: function () {
        !this.option.showLabel & !this.options.icon &&
          (this.options.showLabel = !0),
          null == this.options.disabled &&
            (this.options.disabled = this.element[0].disabled || !1),
          (this.hasTitle = !!this.element.attr("title")),
          this.options.label &&
            this.options.label !== this.originalLabel &&
            (this.isInput
              ? this.element.val(this.options.label)
              : this.element.html(this.options.label)),
          this._addClass("ui-button", "ui-widget"),
          this._setOption("disabled", this.options.disabled),
          this._enhance(),
          this.element.is("a") &&
            this._on({
              keyup: function (e) {
                e.keyCode === t.ui.keyCode.SPACE &&
                  (e.preventDefault(),
                  this.element[0].click
                    ? this.element[0].click()
                    : this.element.trigger("click"));
              },
            });
      },
      _enhance: function () {
        this.element.is("button") || this.element.attr("role", "button"),
          this.options.icon &&
            (this._updateIcon("icon", this.options.icon),
            this._updateTooltip());
      },
      _updateTooltip: function () {
        (this.title = this.element.attr("title")),
          this.options.showLabel ||
            this.title ||
            this.element.attr("title", this.options.label);
      },
      _updateIcon: function (e, i) {
        var n = "iconPosition" !== e,
          s = n ? this.options.iconPosition : i,
          o = "top" === s || "bottom" === s;
        this.icon
          ? n && this._removeClass(this.icon, null, this.options.icon)
          : ((this.icon = t("<span>")),
            this._addClass(this.icon, "ui-button-icon", "ui-icon"),
            this.options.showLabel || this._addClass("ui-button-icon-only")),
          n && this._addClass(this.icon, null, i),
          this._attachIcon(s),
          o
            ? (this._addClass(this.icon, null, "ui-widget-icon-block"),
              this.iconSpace && this.iconSpace.remove())
            : (this.iconSpace ||
                ((this.iconSpace = t("<span> </span>")),
                this._addClass(this.iconSpace, "ui-button-icon-space")),
              this._removeClass(this.icon, null, "ui-wiget-icon-block"),
              this._attachIconSpace(s));
      },
      _destroy: function () {
        this.element.removeAttr("role"),
          this.icon && this.icon.remove(),
          this.iconSpace && this.iconSpace.remove(),
          this.hasTitle || this.element.removeAttr("title");
      },
      _attachIconSpace: function (t) {
        this.icon[/^(?:end|bottom)/.test(t) ? "before" : "after"](
          this.iconSpace
        );
      },
      _attachIcon: function (t) {
        this.element[/^(?:end|bottom)/.test(t) ? "append" : "prepend"](
          this.icon
        );
      },
      _setOptions: function (t) {
        var e = void 0 === t.showLabel ? this.options.showLabel : t.showLabel,
          i = void 0 === t.icon ? this.options.icon : t.icon;
        e || i || (t.showLabel = !0), this._super(t);
      },
      _setOption: function (t, e) {
        "icon" === t &&
          (e
            ? this._updateIcon(t, e)
            : this.icon &&
              (this.icon.remove(), this.iconSpace && this.iconSpace.remove())),
          "iconPosition" === t && this._updateIcon(t, e),
          "showLabel" === t &&
            (this._toggleClass("ui-button-icon-only", null, !e),
            this._updateTooltip()),
          "label" === t &&
            (this.isInput
              ? this.element.val(e)
              : (this.element.html(e),
                this.icon &&
                  (this._attachIcon(this.options.iconPosition),
                  this._attachIconSpace(this.options.iconPosition)))),
          this._super(t, e),
          "disabled" === t &&
            (this._toggleClass(null, "ui-state-disabled", e),
            (this.element[0].disabled = e),
            e && this.element.blur());
      },
      refresh: function () {
        var t = this.element.is("input, button")
          ? this.element[0].disabled
          : this.element.hasClass("ui-button-disabled");
        t !== this.options.disabled && this._setOptions({ disabled: t }),
          this._updateTooltip();
      },
    }),
      !1 !== t.uiBackCompat &&
        (t.widget("ui.button", t.ui.button, {
          options: { text: !0, icons: { primary: null, secondary: null } },
          _create: function () {
            this.options.showLabel &&
              !this.options.text &&
              (this.options.showLabel = this.options.text),
              !this.options.showLabel &&
                this.options.text &&
                (this.options.text = this.options.showLabel),
              this.options.icon ||
              (!this.options.icons.primary && !this.options.icons.secondary)
                ? this.options.icon &&
                  (this.options.icons.primary = this.options.icon)
                : this.options.icons.primary
                ? (this.options.icon = this.options.icons.primary)
                : ((this.options.icon = this.options.icons.secondary),
                  (this.options.iconPosition = "end")),
              this._super();
          },
          _setOption: function (t, e) {
            "text" !== t
              ? ("showLabel" === t && (this.options.text = e),
                "icon" === t && (this.options.icons.primary = e),
                "icons" === t &&
                  (e.primary
                    ? (this._super("icon", e.primary),
                      this._super("iconPosition", "beginning"))
                    : e.secondary &&
                      (this._super("icon", e.secondary),
                      this._super("iconPosition", "end"))),
                this._superApply(arguments))
              : this._super("showLabel", e);
          },
        }),
        (t.fn.button = (function (e) {
          return function () {
            return !this.length ||
              (this.length && "INPUT" !== this[0].tagName) ||
              (this.length &&
                "INPUT" === this[0].tagName &&
                "checkbox" !== this.attr("type") &&
                "radio" !== this.attr("type"))
              ? e.apply(this, arguments)
              : (t.ui.checkboxradio || t.error("Checkboxradio widget missing"),
                0 === arguments.length
                  ? this.checkboxradio({ icon: !1 })
                  : this.checkboxradio.apply(this, arguments));
          };
        })(t.fn.button)),
        (t.fn.buttonset = function () {
          return (
            t.ui.controlgroup || t.error("Controlgroup widget missing"),
            "option" === arguments[0] &&
            "items" === arguments[1] &&
            arguments[2]
              ? this.controlgroup.apply(this, [
                  arguments[0],
                  "items.button",
                  arguments[2],
                ])
              : "option" === arguments[0] && "items" === arguments[1]
              ? this.controlgroup.apply(this, [arguments[0], "items.button"])
              : ("object" == typeof arguments[0] &&
                  arguments[0].items &&
                  (arguments[0].items = { button: arguments[0].items }),
                this.controlgroup.apply(this, arguments))
          );
        }));
    var u;
    t.ui.button;
    function d() {
      (this._curInst = null),
        (this._keyEvent = !1),
        (this._disabledInputs = []),
        (this._datepickerShowing = !1),
        (this._inDialog = !1),
        (this._mainDivId = "ui-datepicker-div"),
        (this._inlineClass = "ui-datepicker-inline"),
        (this._appendClass = "ui-datepicker-append"),
        (this._triggerClass = "ui-datepicker-trigger"),
        (this._dialogClass = "ui-datepicker-dialog"),
        (this._disableClass = "ui-datepicker-disabled"),
        (this._unselectableClass = "ui-datepicker-unselectable"),
        (this._currentClass = "ui-datepicker-current-day"),
        (this._dayOverClass = "ui-datepicker-days-cell-over"),
        (this.regional = []),
        (this.regional[""] = {
          closeText: "Done",
          prevText: "Prev",
          nextText: "Next",
          currentText: "Today",
          monthNames: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ],
          monthNamesShort: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
          dayNames: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ],
          dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
          weekHeader: "Wk",
          dateFormat: "mm/dd/yy",
          firstDay: 0,
          isRTL: !1,
          showMonthAfterYear: !1,
          yearSuffix: "",
        }),
        (this._defaults = {
          showOn: "focus",
          showAnim: "fadeIn",
          showOptions: {},
          defaultDate: null,
          appendText: "",
          buttonText: "...",
          buttonImage: "",
          buttonImageOnly: !1,
          hideIfNoPrevNext: !1,
          navigationAsDateFormat: !1,
          gotoCurrent: !1,
          changeMonth: !1,
          changeYear: !1,
          yearRange: "c-10:c+10",
          showOtherMonths: !1,
          selectOtherMonths: !1,
          showWeek: !1,
          calculateWeek: this.iso8601Week,
          shortYearCutoff: "+10",
          minDate: null,
          maxDate: null,
          duration: "fast",
          beforeShowDay: null,
          beforeShow: null,
          onSelect: null,
          onChangeMonthYear: null,
          onClose: null,
          numberOfMonths: 1,
          showCurrentAtPos: 0,
          stepMonths: 1,
          stepBigMonths: 12,
          altField: "",
          altFormat: "",
          constrainInput: !0,
          showButtonPanel: !1,
          autoSize: !1,
          disabled: !1,
        }),
        t.extend(this._defaults, this.regional[""]),
        (this.regional.en = t.extend(!0, {}, this.regional[""])),
        (this.regional["en-US"] = t.extend(!0, {}, this.regional.en)),
        (this.dpDiv = p(
          t(
            "<div id='" +
              this._mainDivId +
              "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"
          )
        ));
    }
    function p(e) {
      var i =
        "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";
      return e
        .on("mouseout", i, function () {
          t(this).removeClass("ui-state-hover"),
            -1 !== this.className.indexOf("ui-datepicker-prev") &&
              t(this).removeClass("ui-datepicker-prev-hover"),
            -1 !== this.className.indexOf("ui-datepicker-next") &&
              t(this).removeClass("ui-datepicker-next-hover");
        })
        .on("mouseover", i, f);
    }
    function f() {
      t.datepicker._isDisabledDatepicker(
        u.inline ? u.dpDiv.parent()[0] : u.input[0]
      ) ||
        (t(this)
          .parents(".ui-datepicker-calendar")
          .find("a")
          .removeClass("ui-state-hover"),
        t(this).addClass("ui-state-hover"),
        -1 !== this.className.indexOf("ui-datepicker-prev") &&
          t(this).addClass("ui-datepicker-prev-hover"),
        -1 !== this.className.indexOf("ui-datepicker-next") &&
          t(this).addClass("ui-datepicker-next-hover"));
    }
    function m(e, i) {
      for (var n in (t.extend(e, i), i)) null == i[n] && (e[n] = i[n]);
      return e;
    }
    t.extend(t.ui, { datepicker: { version: "1.12.1" } }),
      t.extend(d.prototype, {
        markerClassName: "hasDatepicker",
        maxRows: 4,
        _widgetDatepicker: function () {
          return this.dpDiv;
        },
        setDefaults: function (t) {
          return m(this._defaults, t || {}), this;
        },
        _attachDatepicker: function (e, i) {
          var n, s, o;
          (s = "div" === (n = e.nodeName.toLowerCase()) || "span" === n),
            e.id || ((this.uuid += 1), (e.id = "dp" + this.uuid)),
            ((o = this._newInst(t(e), s)).settings = t.extend({}, i || {})),
            "input" === n
              ? this._connectDatepicker(e, o)
              : s && this._inlineDatepicker(e, o);
        },
        _newInst: function (e, i) {
          return {
            id: e[0].id.replace(/([^A-Za-z0-9_\-])/g, "\\\\$1"),
            input: e,
            selectedDay: 0,
            selectedMonth: 0,
            selectedYear: 0,
            drawMonth: 0,
            drawYear: 0,
            inline: i,
            dpDiv: i
              ? p(
                  t(
                    "<div class='" +
                      this._inlineClass +
                      " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"
                  )
                )
              : this.dpDiv,
          };
        },
        _connectDatepicker: function (e, i) {
          var n = t(e);
          (i.append = t([])),
            (i.trigger = t([])),
            n.hasClass(this.markerClassName) ||
              (this._attachments(n, i),
              n
                .addClass(this.markerClassName)
                .on("keydown", this._doKeyDown)
                .on("keypress", this._doKeyPress)
                .on("keyup", this._doKeyUp),
              this._autoSize(i),
              t.data(e, "datepicker", i),
              i.settings.disabled && this._disableDatepicker(e));
        },
        _attachments: function (e, i) {
          var n,
            s,
            o,
            r = this._get(i, "appendText"),
            a = this._get(i, "isRTL");
          i.append && i.append.remove(),
            r &&
              ((i.append = t(
                "<span class='" + this._appendClass + "'>" + r + "</span>"
              )),
              e[a ? "before" : "after"](i.append)),
            e.off("focus", this._showDatepicker),
            i.trigger && i.trigger.remove(),
            ("focus" !== (n = this._get(i, "showOn")) && "both" !== n) ||
              e.on("focus", this._showDatepicker),
            ("button" !== n && "both" !== n) ||
              ((s = this._get(i, "buttonText")),
              (o = this._get(i, "buttonImage")),
              (i.trigger = t(
                this._get(i, "buttonImageOnly")
                  ? t("<img/>")
                      .addClass(this._triggerClass)
                      .attr({ src: o, alt: s, title: s })
                  : t("<button type='button'></button>")
                      .addClass(this._triggerClass)
                      .html(
                        o ? t("<img/>").attr({ src: o, alt: s, title: s }) : s
                      )
              )),
              e[a ? "before" : "after"](i.trigger),
              i.trigger.on("click", function () {
                return (
                  t.datepicker._datepickerShowing &&
                  t.datepicker._lastInput === e[0]
                    ? t.datepicker._hideDatepicker()
                    : t.datepicker._datepickerShowing &&
                      t.datepicker._lastInput !== e[0]
                    ? (t.datepicker._hideDatepicker(),
                      t.datepicker._showDatepicker(e[0]))
                    : t.datepicker._showDatepicker(e[0]),
                  !1
                );
              }));
        },
        _autoSize: function (t) {
          if (this._get(t, "autoSize") && !t.inline) {
            var e,
              i,
              n,
              s,
              o = new Date(2009, 11, 20),
              r = this._get(t, "dateFormat");
            r.match(/[DM]/) &&
              ((e = function (t) {
                for (i = 0, n = 0, s = 0; s < t.length; s++)
                  t[s].length > i && ((i = t[s].length), (n = s));
                return n;
              }),
              o.setMonth(
                e(
                  this._get(t, r.match(/MM/) ? "monthNames" : "monthNamesShort")
                )
              ),
              o.setDate(
                e(this._get(t, r.match(/DD/) ? "dayNames" : "dayNamesShort")) +
                  20 -
                  o.getDay()
              )),
              t.input.attr("size", this._formatDate(t, o).length);
          }
        },
        _inlineDatepicker: function (e, i) {
          var n = t(e);
          n.hasClass(this.markerClassName) ||
            (n.addClass(this.markerClassName).append(i.dpDiv),
            t.data(e, "datepicker", i),
            this._setDate(i, this._getDefaultDate(i), !0),
            this._updateDatepicker(i),
            this._updateAlternate(i),
            i.settings.disabled && this._disableDatepicker(e),
            i.dpDiv.css("display", "block"));
        },
        _dialogDatepicker: function (e, i, n, s, o) {
          var r,
            a,
            l,
            h,
            c,
            u = this._dialogInst;
          return (
            u ||
              ((this.uuid += 1),
              (r = "dp" + this.uuid),
              (this._dialogInput = t(
                "<input type='text' id='" +
                  r +
                  "' style='position: absolute; top: -100px; width: 0px;'/>"
              )),
              this._dialogInput.on("keydown", this._doKeyDown),
              t("body").append(this._dialogInput),
              ((u = this._dialogInst =
                this._newInst(this._dialogInput, !1)).settings = {}),
              t.data(this._dialogInput[0], "datepicker", u)),
            m(u.settings, s || {}),
            (i = i && i.constructor === Date ? this._formatDate(u, i) : i),
            this._dialogInput.val(i),
            (this._pos = o ? (o.length ? o : [o.pageX, o.pageY]) : null),
            this._pos ||
              ((a = document.documentElement.clientWidth),
              (l = document.documentElement.clientHeight),
              (h =
                document.documentElement.scrollLeft ||
                document.body.scrollLeft),
              (c =
                document.documentElement.scrollTop || document.body.scrollTop),
              (this._pos = [a / 2 - 100 + h, l / 2 - 150 + c])),
            this._dialogInput
              .css("left", this._pos[0] + 20 + "px")
              .css("top", this._pos[1] + "px"),
            (u.settings.onSelect = n),
            (this._inDialog = !0),
            this.dpDiv.addClass(this._dialogClass),
            this._showDatepicker(this._dialogInput[0]),
            t.blockUI && t.blockUI(this.dpDiv),
            t.data(this._dialogInput[0], "datepicker", u),
            this
          );
        },
        _destroyDatepicker: function (e) {
          var i,
            n = t(e),
            s = t.data(e, "datepicker");
          n.hasClass(this.markerClassName) &&
            ((i = e.nodeName.toLowerCase()),
            t.removeData(e, "datepicker"),
            "input" === i
              ? (s.append.remove(),
                s.trigger.remove(),
                n
                  .removeClass(this.markerClassName)
                  .off("focus", this._showDatepicker)
                  .off("keydown", this._doKeyDown)
                  .off("keypress", this._doKeyPress)
                  .off("keyup", this._doKeyUp))
              : ("div" !== i && "span" !== i) ||
                n.removeClass(this.markerClassName).empty(),
            u === s && (u = null));
        },
        _enableDatepicker: function (e) {
          var i,
            n,
            s = t(e),
            o = t.data(e, "datepicker");
          s.hasClass(this.markerClassName) &&
            ("input" === (i = e.nodeName.toLowerCase())
              ? ((e.disabled = !1),
                o.trigger
                  .filter("button")
                  .each(function () {
                    this.disabled = !1;
                  })
                  .end()
                  .filter("img")
                  .css({ opacity: "1.0", cursor: "" }))
              : ("div" !== i && "span" !== i) ||
                ((n = s.children("." + this._inlineClass))
                  .children()
                  .removeClass("ui-state-disabled"),
                n
                  .find("select.ui-datepicker-month, select.ui-datepicker-year")
                  .prop("disabled", !1)),
            (this._disabledInputs = t.map(this._disabledInputs, function (t) {
              return t === e ? null : t;
            })));
        },
        _disableDatepicker: function (e) {
          var i,
            n,
            s = t(e),
            o = t.data(e, "datepicker");
          s.hasClass(this.markerClassName) &&
            ("input" === (i = e.nodeName.toLowerCase())
              ? ((e.disabled = !0),
                o.trigger
                  .filter("button")
                  .each(function () {
                    this.disabled = !0;
                  })
                  .end()
                  .filter("img")
                  .css({ opacity: "0.5", cursor: "default" }))
              : ("div" !== i && "span" !== i) ||
                ((n = s.children("." + this._inlineClass))
                  .children()
                  .addClass("ui-state-disabled"),
                n
                  .find("select.ui-datepicker-month, select.ui-datepicker-year")
                  .prop("disabled", !0)),
            (this._disabledInputs = t.map(this._disabledInputs, function (t) {
              return t === e ? null : t;
            })),
            (this._disabledInputs[this._disabledInputs.length] = e));
        },
        _isDisabledDatepicker: function (t) {
          if (!t) return !1;
          for (var e = 0; e < this._disabledInputs.length; e++)
            if (this._disabledInputs[e] === t) return !0;
          return !1;
        },
        _getInst: function (e) {
          try {
            return t.data(e, "datepicker");
          } catch (t) {
            throw "Missing instance data for this datepicker";
          }
        },
        _optionDatepicker: function (e, i, n) {
          var s,
            o,
            r,
            a,
            l = this._getInst(e);
          if (2 === arguments.length && "string" == typeof i)
            return "defaults" === i
              ? t.extend({}, t.datepicker._defaults)
              : l
              ? "all" === i
                ? t.extend({}, l.settings)
                : this._get(l, i)
              : null;
          (s = i || {}),
            "string" == typeof i && ((s = {})[i] = n),
            l &&
              (this._curInst === l && this._hideDatepicker(),
              (o = this._getDateDatepicker(e, !0)),
              (r = this._getMinMaxDate(l, "min")),
              (a = this._getMinMaxDate(l, "max")),
              m(l.settings, s),
              null !== r &&
                void 0 !== s.dateFormat &&
                void 0 === s.minDate &&
                (l.settings.minDate = this._formatDate(l, r)),
              null !== a &&
                void 0 !== s.dateFormat &&
                void 0 === s.maxDate &&
                (l.settings.maxDate = this._formatDate(l, a)),
              "disabled" in s &&
                (s.disabled
                  ? this._disableDatepicker(e)
                  : this._enableDatepicker(e)),
              this._attachments(t(e), l),
              this._autoSize(l),
              this._setDate(l, o),
              this._updateAlternate(l),
              this._updateDatepicker(l));
        },
        _changeDatepicker: function (t, e, i) {
          this._optionDatepicker(t, e, i);
        },
        _refreshDatepicker: function (t) {
          var e = this._getInst(t);
          e && this._updateDatepicker(e);
        },
        _setDateDatepicker: function (t, e) {
          var i = this._getInst(t);
          i &&
            (this._setDate(i, e),
            this._updateDatepicker(i),
            this._updateAlternate(i));
        },
        _getDateDatepicker: function (t, e) {
          var i = this._getInst(t);
          return (
            i && !i.inline && this._setDateFromField(i, e),
            i ? this._getDate(i) : null
          );
        },
        _doKeyDown: function (e) {
          var i,
            n,
            s,
            o = t.datepicker._getInst(e.target),
            r = !0,
            a = o.dpDiv.is(".ui-datepicker-rtl");
          if (((o._keyEvent = !0), t.datepicker._datepickerShowing))
            switch (e.keyCode) {
              case 9:
                t.datepicker._hideDatepicker(), (r = !1);
                break;
              case 13:
                return (
                  (s = t(
                    "td." +
                      t.datepicker._dayOverClass +
                      ":not(." +
                      t.datepicker._currentClass +
                      ")",
                    o.dpDiv
                  ))[0] &&
                    t.datepicker._selectDay(
                      e.target,
                      o.selectedMonth,
                      o.selectedYear,
                      s[0]
                    ),
                  (i = t.datepicker._get(o, "onSelect"))
                    ? ((n = t.datepicker._formatDate(o)),
                      i.apply(o.input ? o.input[0] : null, [n, o]))
                    : t.datepicker._hideDatepicker(),
                  !1
                );
              case 27:
                t.datepicker._hideDatepicker();
                break;
              case 33:
                t.datepicker._adjustDate(
                  e.target,
                  e.ctrlKey
                    ? -t.datepicker._get(o, "stepBigMonths")
                    : -t.datepicker._get(o, "stepMonths"),
                  "M"
                );
                break;
              case 34:
                t.datepicker._adjustDate(
                  e.target,
                  e.ctrlKey
                    ? +t.datepicker._get(o, "stepBigMonths")
                    : +t.datepicker._get(o, "stepMonths"),
                  "M"
                );
                break;
              case 35:
                (e.ctrlKey || e.metaKey) && t.datepicker._clearDate(e.target),
                  (r = e.ctrlKey || e.metaKey);
                break;
              case 36:
                (e.ctrlKey || e.metaKey) && t.datepicker._gotoToday(e.target),
                  (r = e.ctrlKey || e.metaKey);
                break;
              case 37:
                (e.ctrlKey || e.metaKey) &&
                  t.datepicker._adjustDate(e.target, a ? 1 : -1, "D"),
                  (r = e.ctrlKey || e.metaKey),
                  e.originalEvent.altKey &&
                    t.datepicker._adjustDate(
                      e.target,
                      e.ctrlKey
                        ? -t.datepicker._get(o, "stepBigMonths")
                        : -t.datepicker._get(o, "stepMonths"),
                      "M"
                    );
                break;
              case 38:
                (e.ctrlKey || e.metaKey) &&
                  t.datepicker._adjustDate(e.target, -7, "D"),
                  (r = e.ctrlKey || e.metaKey);
                break;
              case 39:
                (e.ctrlKey || e.metaKey) &&
                  t.datepicker._adjustDate(e.target, a ? -1 : 1, "D"),
                  (r = e.ctrlKey || e.metaKey),
                  e.originalEvent.altKey &&
                    t.datepicker._adjustDate(
                      e.target,
                      e.ctrlKey
                        ? +t.datepicker._get(o, "stepBigMonths")
                        : +t.datepicker._get(o, "stepMonths"),
                      "M"
                    );
                break;
              case 40:
                (e.ctrlKey || e.metaKey) &&
                  t.datepicker._adjustDate(e.target, 7, "D"),
                  (r = e.ctrlKey || e.metaKey);
                break;
              default:
                r = !1;
            }
          else
            36 === e.keyCode && e.ctrlKey
              ? t.datepicker._showDatepicker(this)
              : (r = !1);
          r && (e.preventDefault(), e.stopPropagation());
        },
        _doKeyPress: function (e) {
          var i,
            n,
            s = t.datepicker._getInst(e.target);
          if (t.datepicker._get(s, "constrainInput"))
            return (
              (i = t.datepicker._possibleChars(
                t.datepicker._get(s, "dateFormat")
              )),
              (n = String.fromCharCode(
                null == e.charCode ? e.keyCode : e.charCode
              )),
              e.ctrlKey || e.metaKey || n < " " || !i || i.indexOf(n) > -1
            );
        },
        _doKeyUp: function (e) {
          var i = t.datepicker._getInst(e.target);
          if (i.input.val() !== i.lastVal)
            try {
              t.datepicker.parseDate(
                t.datepicker._get(i, "dateFormat"),
                i.input ? i.input.val() : null,
                t.datepicker._getFormatConfig(i)
              ) &&
                (t.datepicker._setDateFromField(i),
                t.datepicker._updateAlternate(i),
                t.datepicker._updateDatepicker(i));
            } catch (t) {}
          return !0;
        },
        _showDatepicker: function (e) {
          var i, n, s, o, r, a, l;
          ("input" !== (e = e.target || e).nodeName.toLowerCase() &&
            (e = t("input", e.parentNode)[0]),
          t.datepicker._isDisabledDatepicker(e) ||
            t.datepicker._lastInput === e) ||
            ((i = t.datepicker._getInst(e)),
            t.datepicker._curInst &&
              t.datepicker._curInst !== i &&
              (t.datepicker._curInst.dpDiv.stop(!0, !0),
              i &&
                t.datepicker._datepickerShowing &&
                t.datepicker._hideDatepicker(t.datepicker._curInst.input[0])),
            !1 !==
              (s = (n = t.datepicker._get(i, "beforeShow"))
                ? n.apply(e, [e, i])
                : {}) &&
              (m(i.settings, s),
              (i.lastVal = null),
              (t.datepicker._lastInput = e),
              t.datepicker._setDateFromField(i),
              t.datepicker._inDialog && (e.value = ""),
              t.datepicker._pos ||
                ((t.datepicker._pos = t.datepicker._findPos(e)),
                (t.datepicker._pos[1] += e.offsetHeight)),
              (o = !1),
              t(e)
                .parents()
                .each(function () {
                  return !(o |= "fixed" === t(this).css("position"));
                }),
              (r = { left: t.datepicker._pos[0], top: t.datepicker._pos[1] }),
              (t.datepicker._pos = null),
              i.dpDiv.empty(),
              i.dpDiv.css({
                position: "absolute",
                display: "block",
                top: "-1000px",
              }),
              t.datepicker._updateDatepicker(i),
              (r = t.datepicker._checkOffset(i, r, o)),
              i.dpDiv.css({
                position:
                  t.datepicker._inDialog && t.blockUI
                    ? "static"
                    : o
                    ? "fixed"
                    : "absolute",
                display: "none",
                left: r.left + "px",
                top: r.top + "px",
              }),
              i.inline ||
                ((a = t.datepicker._get(i, "showAnim")),
                (l = t.datepicker._get(i, "duration")),
                i.dpDiv.css(
                  "z-index",
                  (function (t) {
                    for (var e, i; t.length && t[0] !== document; ) {
                      if (
                        ("absolute" === (e = t.css("position")) ||
                          "relative" === e ||
                          "fixed" === e) &&
                        ((i = parseInt(t.css("zIndex"), 10)),
                        !isNaN(i) && 0 !== i)
                      )
                        return i;
                      t = t.parent();
                    }
                    return 0;
                  })(t(e)) + 1
                ),
                (t.datepicker._datepickerShowing = !0),
                t.effects && t.effects.effect[a]
                  ? i.dpDiv.show(a, t.datepicker._get(i, "showOptions"), l)
                  : i.dpDiv[a || "show"](a ? l : null),
                t.datepicker._shouldFocusInput(i) && i.input.trigger("focus"),
                (t.datepicker._curInst = i))));
        },
        _updateDatepicker: function (e) {
          (this.maxRows = 4),
            (u = e),
            e.dpDiv.empty().append(this._generateHTML(e)),
            this._attachHandlers(e);
          var i,
            n = this._getNumberOfMonths(e),
            s = n[1],
            o = e.dpDiv.find("." + this._dayOverClass + " a");
          o.length > 0 && f.apply(o.get(0)),
            e.dpDiv
              .removeClass(
                "ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4"
              )
              .width(""),
            s > 1 &&
              e.dpDiv
                .addClass("ui-datepicker-multi-" + s)
                .css("width", 17 * s + "em"),
            e.dpDiv[(1 !== n[0] || 1 !== n[1] ? "add" : "remove") + "Class"](
              "ui-datepicker-multi"
            ),
            e.dpDiv[(this._get(e, "isRTL") ? "add" : "remove") + "Class"](
              "ui-datepicker-rtl"
            ),
            e === t.datepicker._curInst &&
              t.datepicker._datepickerShowing &&
              t.datepicker._shouldFocusInput(e) &&
              e.input.trigger("focus"),
            e.yearshtml &&
              ((i = e.yearshtml),
              setTimeout(function () {
                i === e.yearshtml &&
                  e.yearshtml &&
                  e.dpDiv
                    .find("select.ui-datepicker-year:first")
                    .replaceWith(e.yearshtml),
                  (i = e.yearshtml = null);
              }, 0));
        },
        _shouldFocusInput: function (t) {
          return (
            t.input &&
            t.input.is(":visible") &&
            !t.input.is(":disabled") &&
            !t.input.is(":focus")
          );
        },
        _checkOffset: function (e, i, n) {
          var s = e.dpDiv.outerWidth(),
            o = e.dpDiv.outerHeight(),
            r = e.input ? e.input.outerWidth() : 0,
            a = e.input ? e.input.outerHeight() : 0,
            l =
              document.documentElement.clientWidth +
              (n ? 0 : t(document).scrollLeft()),
            h =
              document.documentElement.clientHeight +
              (n ? 0 : t(document).scrollTop());
          return (
            (i.left -= this._get(e, "isRTL") ? s - r : 0),
            (i.left -=
              n && i.left === e.input.offset().left
                ? t(document).scrollLeft()
                : 0),
            (i.top -=
              n && i.top === e.input.offset().top + a
                ? t(document).scrollTop()
                : 0),
            (i.left -= Math.min(
              i.left,
              i.left + s > l && l > s ? Math.abs(i.left + s - l) : 0
            )),
            (i.top -= Math.min(
              i.top,
              i.top + o > h && h > o ? Math.abs(o + a) : 0
            )),
            i
          );
        },
        _findPos: function (e) {
          for (
            var i, n = this._getInst(e), s = this._get(n, "isRTL");
            e &&
            ("hidden" === e.type ||
              1 !== e.nodeType ||
              t.expr.filters.hidden(e));

          )
            e = e[s ? "previousSibling" : "nextSibling"];
          return [(i = t(e).offset()).left, i.top];
        },
        _hideDatepicker: function (e) {
          var i,
            n,
            s,
            o,
            r = this._curInst;
          !r ||
            (e && r !== t.data(e, "datepicker")) ||
            (this._datepickerShowing &&
              ((i = this._get(r, "showAnim")),
              (n = this._get(r, "duration")),
              (s = function () {
                t.datepicker._tidyDialog(r);
              }),
              t.effects && (t.effects.effect[i] || t.effects[i])
                ? r.dpDiv.hide(i, t.datepicker._get(r, "showOptions"), n, s)
                : r.dpDiv[
                    "slideDown" === i
                      ? "slideUp"
                      : "fadeIn" === i
                      ? "fadeOut"
                      : "hide"
                  ](i ? n : null, s),
              i || s(),
              (this._datepickerShowing = !1),
              (o = this._get(r, "onClose")) &&
                o.apply(r.input ? r.input[0] : null, [
                  r.input ? r.input.val() : "",
                  r,
                ]),
              (this._lastInput = null),
              this._inDialog &&
                (this._dialogInput.css({
                  position: "absolute",
                  left: "0",
                  top: "-100px",
                }),
                t.blockUI && (t.unblockUI(), t("body").append(this.dpDiv))),
              (this._inDialog = !1)));
        },
        _tidyDialog: function (t) {
          t.dpDiv.removeClass(this._dialogClass).off(".ui-datepicker-calendar");
        },
        _checkExternalClick: function (e) {
          if (t.datepicker._curInst) {
            var i = t(e.target),
              n = t.datepicker._getInst(i[0]);
            ((i[0].id === t.datepicker._mainDivId ||
              0 !== i.parents("#" + t.datepicker._mainDivId).length ||
              i.hasClass(t.datepicker.markerClassName) ||
              i.closest("." + t.datepicker._triggerClass).length ||
              !t.datepicker._datepickerShowing ||
              (t.datepicker._inDialog && t.blockUI)) &&
              (!i.hasClass(t.datepicker.markerClassName) ||
                t.datepicker._curInst === n)) ||
              t.datepicker._hideDatepicker();
          }
        },
        _adjustDate: function (e, i, n) {
          var s = t(e),
            o = this._getInst(s[0]);
          this._isDisabledDatepicker(s[0]) ||
            (this._adjustInstDate(
              o,
              i + ("M" === n ? this._get(o, "showCurrentAtPos") : 0),
              n
            ),
            this._updateDatepicker(o));
        },
        _gotoToday: function (e) {
          var i,
            n = t(e),
            s = this._getInst(n[0]);
          this._get(s, "gotoCurrent") && s.currentDay
            ? ((s.selectedDay = s.currentDay),
              (s.drawMonth = s.selectedMonth = s.currentMonth),
              (s.drawYear = s.selectedYear = s.currentYear))
            : ((i = new Date()),
              (s.selectedDay = i.getDate()),
              (s.drawMonth = s.selectedMonth = i.getMonth()),
              (s.drawYear = s.selectedYear = i.getFullYear())),
            this._notifyChange(s),
            this._adjustDate(n);
        },
        _selectMonthYear: function (e, i, n) {
          var s = t(e),
            o = this._getInst(s[0]);
          (o["selected" + ("M" === n ? "Month" : "Year")] = o[
            "draw" + ("M" === n ? "Month" : "Year")
          ] =
            parseInt(i.options[i.selectedIndex].value, 10)),
            this._notifyChange(o),
            this._adjustDate(s);
        },
        _selectDay: function (e, i, n, s) {
          var o,
            r = t(e);
          t(s).hasClass(this._unselectableClass) ||
            this._isDisabledDatepicker(r[0]) ||
            (((o = this._getInst(r[0])).selectedDay = o.currentDay =
              t("a", s).html()),
            (o.selectedMonth = o.currentMonth = i),
            (o.selectedYear = o.currentYear = n),
            this._selectDate(
              e,
              this._formatDate(o, o.currentDay, o.currentMonth, o.currentYear)
            ));
        },
        _clearDate: function (e) {
          var i = t(e);
          this._selectDate(i, "");
        },
        _selectDate: function (e, i) {
          var n,
            s = t(e),
            o = this._getInst(s[0]);
          (i = null != i ? i : this._formatDate(o)),
            o.input && o.input.val(i),
            this._updateAlternate(o),
            (n = this._get(o, "onSelect"))
              ? n.apply(o.input ? o.input[0] : null, [i, o])
              : o.input && o.input.trigger("change"),
            o.inline
              ? this._updateDatepicker(o)
              : (this._hideDatepicker(),
                (this._lastInput = o.input[0]),
                "object" != typeof o.input[0] && o.input.trigger("focus"),
                (this._lastInput = null));
        },
        _updateAlternate: function (e) {
          var i,
            n,
            s,
            o = this._get(e, "altField");
          o &&
            ((i = this._get(e, "altFormat") || this._get(e, "dateFormat")),
            (n = this._getDate(e)),
            (s = this.formatDate(i, n, this._getFormatConfig(e))),
            t(o).val(s));
        },
        noWeekends: function (t) {
          var e = t.getDay();
          return [e > 0 && e < 6, ""];
        },
        iso8601Week: function (t) {
          var e,
            i = new Date(t.getTime());
          return (
            i.setDate(i.getDate() + 4 - (i.getDay() || 7)),
            (e = i.getTime()),
            i.setMonth(0),
            i.setDate(1),
            Math.floor(Math.round((e - i) / 864e5) / 7) + 1
          );
        },
        parseDate: function (e, i, n) {
          if (null == e || null == i) throw "Invalid arguments";
          if ("" === (i = "object" == typeof i ? i.toString() : i + ""))
            return null;
          var s,
            o,
            r,
            a,
            l = 0,
            h =
              (n ? n.shortYearCutoff : null) || this._defaults.shortYearCutoff,
            c =
              "string" != typeof h
                ? h
                : (new Date().getFullYear() % 100) + parseInt(h, 10),
            u = (n ? n.dayNamesShort : null) || this._defaults.dayNamesShort,
            d = (n ? n.dayNames : null) || this._defaults.dayNames,
            p =
              (n ? n.monthNamesShort : null) || this._defaults.monthNamesShort,
            f = (n ? n.monthNames : null) || this._defaults.monthNames,
            m = -1,
            g = -1,
            v = -1,
            _ = -1,
            y = !1,
            b = function (t) {
              var i = s + 1 < e.length && e.charAt(s + 1) === t;
              return i && s++, i;
            },
            w = function (t) {
              var e = b(t),
                n =
                  "@" === t
                    ? 14
                    : "!" === t
                    ? 20
                    : "y" === t && e
                    ? 4
                    : "o" === t
                    ? 3
                    : 2,
                s = new RegExp("^\\d{" + ("y" === t ? n : 1) + "," + n + "}"),
                o = i.substring(l).match(s);
              if (!o) throw "Missing number at position " + l;
              return (l += o[0].length), parseInt(o[0], 10);
            },
            x = function (e, n, s) {
              var o = -1,
                r = t
                  .map(b(e) ? s : n, function (t, e) {
                    return [[e, t]];
                  })
                  .sort(function (t, e) {
                    return -(t[1].length - e[1].length);
                  });
              if (
                (t.each(r, function (t, e) {
                  var n = e[1];
                  if (i.substr(l, n.length).toLowerCase() === n.toLowerCase())
                    return (o = e[0]), (l += n.length), !1;
                }),
                -1 !== o)
              )
                return o + 1;
              throw "Unknown name at position " + l;
            },
            C = function () {
              if (i.charAt(l) !== e.charAt(s))
                throw "Unexpected literal at position " + l;
              l++;
            };
          for (s = 0; s < e.length; s++)
            if (y) "'" !== e.charAt(s) || b("'") ? C() : (y = !1);
            else
              switch (e.charAt(s)) {
                case "d":
                  v = w("d");
                  break;
                case "D":
                  x("D", u, d);
                  break;
                case "o":
                  _ = w("o");
                  break;
                case "m":
                  g = w("m");
                  break;
                case "M":
                  g = x("M", p, f);
                  break;
                case "y":
                  m = w("y");
                  break;
                case "@":
                  (m = (a = new Date(w("@"))).getFullYear()),
                    (g = a.getMonth() + 1),
                    (v = a.getDate());
                  break;
                case "!":
                  (m = (a = new Date(
                    (w("!") - this._ticksTo1970) / 1e4
                  )).getFullYear()),
                    (g = a.getMonth() + 1),
                    (v = a.getDate());
                  break;
                case "'":
                  b("'") ? C() : (y = !0);
                  break;
                default:
                  C();
              }
          if (l < i.length && ((r = i.substr(l)), !/^\s+/.test(r)))
            throw "Extra/unparsed characters found in date: " + r;
          if (
            (-1 === m
              ? (m = new Date().getFullYear())
              : m < 100 &&
                (m +=
                  new Date().getFullYear() -
                  (new Date().getFullYear() % 100) +
                  (m <= c ? 0 : -100)),
            _ > -1)
          )
            for (g = 1, v = _; ; ) {
              if (v <= (o = this._getDaysInMonth(m, g - 1))) break;
              g++, (v -= o);
            }
          if (
            (a = this._daylightSavingAdjust(
              new Date(m, g - 1, v)
            )).getFullYear() !== m ||
            a.getMonth() + 1 !== g ||
            a.getDate() !== v
          )
            throw "Invalid date";
          return a;
        },
        ATOM: "yy-mm-dd",
        COOKIE: "D, dd M yy",
        ISO_8601: "yy-mm-dd",
        RFC_822: "D, d M y",
        RFC_850: "DD, dd-M-y",
        RFC_1036: "D, d M y",
        RFC_1123: "D, d M yy",
        RFC_2822: "D, d M yy",
        RSS: "D, d M y",
        TICKS: "!",
        TIMESTAMP: "@",
        W3C: "yy-mm-dd",
        _ticksTo1970:
          24 *
          (718685 + Math.floor(492.5) - Math.floor(19.7) + Math.floor(4.925)) *
          60 *
          60 *
          1e7,
        formatDate: function (t, e, i) {
          if (!e) return "";
          var n,
            s = (i ? i.dayNamesShort : null) || this._defaults.dayNamesShort,
            o = (i ? i.dayNames : null) || this._defaults.dayNames,
            r =
              (i ? i.monthNamesShort : null) || this._defaults.monthNamesShort,
            a = (i ? i.monthNames : null) || this._defaults.monthNames,
            l = function (e) {
              var i = n + 1 < t.length && t.charAt(n + 1) === e;
              return i && n++, i;
            },
            h = function (t, e, i) {
              var n = "" + e;
              if (l(t)) for (; n.length < i; ) n = "0" + n;
              return n;
            },
            c = function (t, e, i, n) {
              return l(t) ? n[e] : i[e];
            },
            u = "",
            d = !1;
          if (e)
            for (n = 0; n < t.length; n++)
              if (d)
                "'" !== t.charAt(n) || l("'") ? (u += t.charAt(n)) : (d = !1);
              else
                switch (t.charAt(n)) {
                  case "d":
                    u += h("d", e.getDate(), 2);
                    break;
                  case "D":
                    u += c("D", e.getDay(), s, o);
                    break;
                  case "o":
                    u += h(
                      "o",
                      Math.round(
                        (new Date(
                          e.getFullYear(),
                          e.getMonth(),
                          e.getDate()
                        ).getTime() -
                          new Date(e.getFullYear(), 0, 0).getTime()) /
                          864e5
                      ),
                      3
                    );
                    break;
                  case "m":
                    u += h("m", e.getMonth() + 1, 2);
                    break;
                  case "M":
                    u += c("M", e.getMonth(), r, a);
                    break;
                  case "y":
                    u += l("y")
                      ? e.getFullYear()
                      : (e.getFullYear() % 100 < 10 ? "0" : "") +
                        (e.getFullYear() % 100);
                    break;
                  case "@":
                    u += e.getTime();
                    break;
                  case "!":
                    u += 1e4 * e.getTime() + this._ticksTo1970;
                    break;
                  case "'":
                    l("'") ? (u += "'") : (d = !0);
                    break;
                  default:
                    u += t.charAt(n);
                }
          return u;
        },
        _possibleChars: function (t) {
          var e,
            i = "",
            n = !1,
            s = function (i) {
              var n = e + 1 < t.length && t.charAt(e + 1) === i;
              return n && e++, n;
            };
          for (e = 0; e < t.length; e++)
            if (n)
              "'" !== t.charAt(e) || s("'") ? (i += t.charAt(e)) : (n = !1);
            else
              switch (t.charAt(e)) {
                case "d":
                case "m":
                case "y":
                case "@":
                  i += "0123456789";
                  break;
                case "D":
                case "M":
                  return null;
                case "'":
                  s("'") ? (i += "'") : (n = !0);
                  break;
                default:
                  i += t.charAt(e);
              }
          return i;
        },
        _get: function (t, e) {
          return void 0 !== t.settings[e] ? t.settings[e] : this._defaults[e];
        },
        _setDateFromField: function (t, e) {
          if (t.input.val() !== t.lastVal) {
            var i = this._get(t, "dateFormat"),
              n = (t.lastVal = t.input ? t.input.val() : null),
              s = this._getDefaultDate(t),
              o = s,
              r = this._getFormatConfig(t);
            try {
              o = this.parseDate(i, n, r) || s;
            } catch (t) {
              n = e ? "" : n;
            }
            (t.selectedDay = o.getDate()),
              (t.drawMonth = t.selectedMonth = o.getMonth()),
              (t.drawYear = t.selectedYear = o.getFullYear()),
              (t.currentDay = n ? o.getDate() : 0),
              (t.currentMonth = n ? o.getMonth() : 0),
              (t.currentYear = n ? o.getFullYear() : 0),
              this._adjustInstDate(t);
          }
        },
        _getDefaultDate: function (t) {
          return this._restrictMinMax(
            t,
            this._determineDate(t, this._get(t, "defaultDate"), new Date())
          );
        },
        _determineDate: function (e, i, n) {
          var s =
            null == i || "" === i
              ? n
              : "string" == typeof i
              ? (function (i) {
                  try {
                    return t.datepicker.parseDate(
                      t.datepicker._get(e, "dateFormat"),
                      i,
                      t.datepicker._getFormatConfig(e)
                    );
                  } catch (t) {}
                  for (
                    var n =
                        (i.toLowerCase().match(/^c/)
                          ? t.datepicker._getDate(e)
                          : null) || new Date(),
                      s = n.getFullYear(),
                      o = n.getMonth(),
                      r = n.getDate(),
                      a = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,
                      l = a.exec(i);
                    l;

                  ) {
                    switch (l[2] || "d") {
                      case "d":
                      case "D":
                        r += parseInt(l[1], 10);
                        break;
                      case "w":
                      case "W":
                        r += 7 * parseInt(l[1], 10);
                        break;
                      case "m":
                      case "M":
                        (o += parseInt(l[1], 10)),
                          (r = Math.min(r, t.datepicker._getDaysInMonth(s, o)));
                        break;
                      case "y":
                      case "Y":
                        (s += parseInt(l[1], 10)),
                          (r = Math.min(r, t.datepicker._getDaysInMonth(s, o)));
                    }
                    l = a.exec(i);
                  }
                  return new Date(s, o, r);
                })(i)
              : "number" == typeof i
              ? isNaN(i)
                ? n
                : (function (t) {
                    var e = new Date();
                    return e.setDate(e.getDate() + t), e;
                  })(i)
              : new Date(i.getTime());
          return (
            (s = s && "Invalid Date" === s.toString() ? n : s) &&
              (s.setHours(0),
              s.setMinutes(0),
              s.setSeconds(0),
              s.setMilliseconds(0)),
            this._daylightSavingAdjust(s)
          );
        },
        _daylightSavingAdjust: function (t) {
          return t
            ? (t.setHours(t.getHours() > 12 ? t.getHours() + 2 : 0), t)
            : null;
        },
        _setDate: function (t, e, i) {
          var n = !e,
            s = t.selectedMonth,
            o = t.selectedYear,
            r = this._restrictMinMax(t, this._determineDate(t, e, new Date()));
          (t.selectedDay = t.currentDay = r.getDate()),
            (t.drawMonth = t.selectedMonth = t.currentMonth = r.getMonth()),
            (t.drawYear = t.selectedYear = t.currentYear = r.getFullYear()),
            (s === t.selectedMonth && o === t.selectedYear) ||
              i ||
              this._notifyChange(t),
            this._adjustInstDate(t),
            t.input && t.input.val(n ? "" : this._formatDate(t));
        },
        _getDate: function (t) {
          return !t.currentYear || (t.input && "" === t.input.val())
            ? null
            : this._daylightSavingAdjust(
                new Date(t.currentYear, t.currentMonth, t.currentDay)
              );
        },
        _attachHandlers: function (e) {
          var i = this._get(e, "stepMonths"),
            n = "#" + e.id.replace(/\\\\/g, "\\");
          e.dpDiv.find("[data-handler]").map(function () {
            var e = {
              prev: function () {
                t.datepicker._adjustDate(n, -i, "M");
              },
              next: function () {
                t.datepicker._adjustDate(n, +i, "M");
              },
              hide: function () {
                t.datepicker._hideDatepicker();
              },
              today: function () {
                t.datepicker._gotoToday(n);
              },
              selectDay: function () {
                return (
                  t.datepicker._selectDay(
                    n,
                    +this.getAttribute("data-month"),
                    +this.getAttribute("data-year"),
                    this
                  ),
                  !1
                );
              },
              selectMonth: function () {
                return t.datepicker._selectMonthYear(n, this, "M"), !1;
              },
              selectYear: function () {
                return t.datepicker._selectMonthYear(n, this, "Y"), !1;
              },
            };
            t(this).on(
              this.getAttribute("data-event"),
              e[this.getAttribute("data-handler")]
            );
          });
        },
        _generateHTML: function (t) {
          var e,
            i,
            n,
            s,
            o,
            r,
            a,
            l,
            h,
            c,
            u,
            d,
            p,
            f,
            m,
            g,
            v,
            _,
            y,
            b,
            w,
            x,
            C,
            k,
            T,
            D,
            I,
            E,
            S,
            A,
            P,
            O,
            M,
            z,
            $,
            N,
            H,
            W,
            F,
            L = new Date(),
            R = this._daylightSavingAdjust(
              new Date(L.getFullYear(), L.getMonth(), L.getDate())
            ),
            j = this._get(t, "isRTL"),
            B = this._get(t, "showButtonPanel"),
            q = this._get(t, "hideIfNoPrevNext"),
            U = this._get(t, "navigationAsDateFormat"),
            Y = this._getNumberOfMonths(t),
            V = this._get(t, "showCurrentAtPos"),
            K = this._get(t, "stepMonths"),
            Q = 1 !== Y[0] || 1 !== Y[1],
            Z = this._daylightSavingAdjust(
              t.currentDay
                ? new Date(t.currentYear, t.currentMonth, t.currentDay)
                : new Date(9999, 9, 9)
            ),
            G = this._getMinMaxDate(t, "min"),
            X = this._getMinMaxDate(t, "max"),
            J = t.drawMonth - V,
            tt = t.drawYear;
          if ((J < 0 && ((J += 12), tt--), X))
            for (
              e = this._daylightSavingAdjust(
                new Date(
                  X.getFullYear(),
                  X.getMonth() - Y[0] * Y[1] + 1,
                  X.getDate()
                )
              ),
                e = G && e < G ? G : e;
              this._daylightSavingAdjust(new Date(tt, J, 1)) > e;

            )
              --J < 0 && ((J = 11), tt--);
          for (
            t.drawMonth = J,
              t.drawYear = tt,
              i = this._get(t, "prevText"),
              i = U
                ? this.formatDate(
                    i,
                    this._daylightSavingAdjust(new Date(tt, J - K, 1)),
                    this._getFormatConfig(t)
                  )
                : i,
              n = this._canAdjustMonth(t, -1, tt, J)
                ? "<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click' title='" +
                  i +
                  "'><span class='ui-icon ui-icon-circle-triangle-" +
                  (j ? "e" : "w") +
                  "'>" +
                  i +
                  "</span></a>"
                : q
                ? ""
                : "<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='" +
                  i +
                  "'><span class='ui-icon ui-icon-circle-triangle-" +
                  (j ? "e" : "w") +
                  "'>" +
                  i +
                  "</span></a>",
              s = this._get(t, "nextText"),
              s = U
                ? this.formatDate(
                    s,
                    this._daylightSavingAdjust(new Date(tt, J + K, 1)),
                    this._getFormatConfig(t)
                  )
                : s,
              o = this._canAdjustMonth(t, 1, tt, J)
                ? "<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click' title='" +
                  s +
                  "'><span class='ui-icon ui-icon-circle-triangle-" +
                  (j ? "w" : "e") +
                  "'>" +
                  s +
                  "</span></a>"
                : q
                ? ""
                : "<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='" +
                  s +
                  "'><span class='ui-icon ui-icon-circle-triangle-" +
                  (j ? "w" : "e") +
                  "'>" +
                  s +
                  "</span></a>",
              r = this._get(t, "currentText"),
              a = this._get(t, "gotoCurrent") && t.currentDay ? Z : R,
              r = U ? this.formatDate(r, a, this._getFormatConfig(t)) : r,
              l = t.inline
                ? ""
                : "<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>" +
                  this._get(t, "closeText") +
                  "</button>",
              h = B
                ? "<div class='ui-datepicker-buttonpane ui-widget-content'>" +
                  (j ? l : "") +
                  (this._isInRange(t, a)
                    ? "<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'>" +
                      r +
                      "</button>"
                    : "") +
                  (j ? "" : l) +
                  "</div>"
                : "",
              c = parseInt(this._get(t, "firstDay"), 10),
              c = isNaN(c) ? 0 : c,
              u = this._get(t, "showWeek"),
              d = this._get(t, "dayNames"),
              p = this._get(t, "dayNamesMin"),
              f = this._get(t, "monthNames"),
              m = this._get(t, "monthNamesShort"),
              g = this._get(t, "beforeShowDay"),
              v = this._get(t, "showOtherMonths"),
              _ = this._get(t, "selectOtherMonths"),
              y = this._getDefaultDate(t),
              b = "",
              x = 0;
            x < Y[0];
            x++
          ) {
            for (C = "", this.maxRows = 4, k = 0; k < Y[1]; k++) {
              if (
                ((T = this._daylightSavingAdjust(
                  new Date(tt, J, t.selectedDay)
                )),
                (D = " ui-corner-all"),
                (I = ""),
                Q)
              ) {
                if (((I += "<div class='ui-datepicker-group"), Y[1] > 1))
                  switch (k) {
                    case 0:
                      (I += " ui-datepicker-group-first"),
                        (D = " ui-corner-" + (j ? "right" : "left"));
                      break;
                    case Y[1] - 1:
                      (I += " ui-datepicker-group-last"),
                        (D = " ui-corner-" + (j ? "left" : "right"));
                      break;
                    default:
                      (I += " ui-datepicker-group-middle"), (D = "");
                  }
                I += "'>";
              }
              for (
                I +=
                  "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" +
                  D +
                  "'>" +
                  (/all|left/.test(D) && 0 === x ? (j ? o : n) : "") +
                  (/all|right/.test(D) && 0 === x ? (j ? n : o) : "") +
                  this._generateMonthYearHeader(
                    t,
                    J,
                    tt,
                    G,
                    X,
                    x > 0 || k > 0,
                    f,
                    m
                  ) +
                  "</div><table class='ui-datepicker-calendar'><thead><tr>",
                  E = u
                    ? "<th class='ui-datepicker-week-col'>" +
                      this._get(t, "weekHeader") +
                      "</th>"
                    : "",
                  w = 0;
                w < 7;
                w++
              )
                E +=
                  "<th scope='col'" +
                  ((w + c + 6) % 7 >= 5
                    ? " class='ui-datepicker-week-end'"
                    : "") +
                  "><span title='" +
                  d[(S = (w + c) % 7)] +
                  "'>" +
                  p[S] +
                  "</span></th>";
              for (
                I += E + "</tr></thead><tbody>",
                  A = this._getDaysInMonth(tt, J),
                  tt === t.selectedYear &&
                    J === t.selectedMonth &&
                    (t.selectedDay = Math.min(t.selectedDay, A)),
                  P = (this._getFirstDayOfMonth(tt, J) - c + 7) % 7,
                  O = Math.ceil((P + A) / 7),
                  M = Q && this.maxRows > O ? this.maxRows : O,
                  this.maxRows = M,
                  z = this._daylightSavingAdjust(new Date(tt, J, 1 - P)),
                  $ = 0;
                $ < M;
                $++
              ) {
                for (
                  I += "<tr>",
                    N = u
                      ? "<td class='ui-datepicker-week-col'>" +
                        this._get(t, "calculateWeek")(z) +
                        "</td>"
                      : "",
                    w = 0;
                  w < 7;
                  w++
                )
                  (H = g
                    ? g.apply(t.input ? t.input[0] : null, [z])
                    : [!0, ""]),
                    (F =
                      ((W = z.getMonth() !== J) && !_) ||
                      !H[0] ||
                      (G && z < G) ||
                      (X && z > X)),
                    (N +=
                      "<td class='" +
                      ((w + c + 6) % 7 >= 5 ? " ui-datepicker-week-end" : "") +
                      (W ? " ui-datepicker-other-month" : "") +
                      ((z.getTime() === T.getTime() &&
                        J === t.selectedMonth &&
                        t._keyEvent) ||
                      (y.getTime() === z.getTime() &&
                        y.getTime() === T.getTime())
                        ? " " + this._dayOverClass
                        : "") +
                      (F
                        ? " " + this._unselectableClass + " ui-state-disabled"
                        : "") +
                      (W && !v
                        ? ""
                        : " " +
                          H[1] +
                          (z.getTime() === Z.getTime()
                            ? " " + this._currentClass
                            : "") +
                          (z.getTime() === R.getTime()
                            ? " ui-datepicker-today"
                            : "")) +
                      "'" +
                      ((W && !v) || !H[2]
                        ? ""
                        : " title='" + H[2].replace(/'/g, "&#39;") + "'") +
                      (F
                        ? ""
                        : " data-handler='selectDay' data-event='click' data-month='" +
                          z.getMonth() +
                          "' data-year='" +
                          z.getFullYear() +
                          "'") +
                      ">" +
                      (W && !v
                        ? "&#xa0;"
                        : F
                        ? "<span class='ui-state-default'>" +
                          z.getDate() +
                          "</span>"
                        : "<a class='ui-state-default" +
                          (z.getTime() === R.getTime()
                            ? " ui-state-highlight"
                            : "") +
                          (z.getTime() === Z.getTime()
                            ? " ui-state-active"
                            : "") +
                          (W ? " ui-priority-secondary" : "") +
                          "' href='#'>" +
                          z.getDate() +
                          "</a>") +
                      "</td>"),
                    z.setDate(z.getDate() + 1),
                    (z = this._daylightSavingAdjust(z));
                I += N + "</tr>";
              }
              ++J > 11 && ((J = 0), tt++),
                (C += I +=
                  "</tbody></table>" +
                  (Q
                    ? "</div>" +
                      (Y[0] > 0 && k === Y[1] - 1
                        ? "<div class='ui-datepicker-row-break'></div>"
                        : "")
                    : ""));
            }
            b += C;
          }
          return (b += h), (t._keyEvent = !1), b;
        },
        _generateMonthYearHeader: function (t, e, i, n, s, o, r, a) {
          var l,
            h,
            c,
            u,
            d,
            p,
            f,
            m,
            g = this._get(t, "changeMonth"),
            v = this._get(t, "changeYear"),
            _ = this._get(t, "showMonthAfterYear"),
            y = "<div class='ui-datepicker-title'>",
            b = "";
          if (o || !g)
            b += "<span class='ui-datepicker-month'>" + r[e] + "</span>";
          else {
            for (
              l = n && n.getFullYear() === i,
                h = s && s.getFullYear() === i,
                b +=
                  "<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>",
                c = 0;
              c < 12;
              c++
            )
              (!l || c >= n.getMonth()) &&
                (!h || c <= s.getMonth()) &&
                (b +=
                  "<option value='" +
                  c +
                  "'" +
                  (c === e ? " selected='selected'" : "") +
                  ">" +
                  a[c] +
                  "</option>");
            b += "</select>";
          }
          if ((_ || (y += b + (!o && g && v ? "" : "&#xa0;")), !t.yearshtml))
            if (((t.yearshtml = ""), o || !v))
              y += "<span class='ui-datepicker-year'>" + i + "</span>";
            else {
              for (
                u = this._get(t, "yearRange").split(":"),
                  d = new Date().getFullYear(),
                  f = (p = function (t) {
                    var e = t.match(/c[+\-].*/)
                      ? i + parseInt(t.substring(1), 10)
                      : t.match(/[+\-].*/)
                      ? d + parseInt(t, 10)
                      : parseInt(t, 10);
                    return isNaN(e) ? d : e;
                  })(u[0]),
                  m = Math.max(f, p(u[1] || "")),
                  f = n ? Math.max(f, n.getFullYear()) : f,
                  m = s ? Math.min(m, s.getFullYear()) : m,
                  t.yearshtml +=
                    "<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";
                f <= m;
                f++
              )
                t.yearshtml +=
                  "<option value='" +
                  f +
                  "'" +
                  (f === i ? " selected='selected'" : "") +
                  ">" +
                  f +
                  "</option>";
              (t.yearshtml += "</select>"),
                (y += t.yearshtml),
                (t.yearshtml = null);
            }
          return (
            (y += this._get(t, "yearSuffix")),
            _ && (y += (!o && g && v ? "" : "&#xa0;") + b),
            (y += "</div>")
          );
        },
        _adjustInstDate: function (t, e, i) {
          var n = t.selectedYear + ("Y" === i ? e : 0),
            s = t.selectedMonth + ("M" === i ? e : 0),
            o =
              Math.min(t.selectedDay, this._getDaysInMonth(n, s)) +
              ("D" === i ? e : 0),
            r = this._restrictMinMax(
              t,
              this._daylightSavingAdjust(new Date(n, s, o))
            );
          (t.selectedDay = r.getDate()),
            (t.drawMonth = t.selectedMonth = r.getMonth()),
            (t.drawYear = t.selectedYear = r.getFullYear()),
            ("M" !== i && "Y" !== i) || this._notifyChange(t);
        },
        _restrictMinMax: function (t, e) {
          var i = this._getMinMaxDate(t, "min"),
            n = this._getMinMaxDate(t, "max"),
            s = i && e < i ? i : e;
          return n && s > n ? n : s;
        },
        _notifyChange: function (t) {
          var e = this._get(t, "onChangeMonthYear");
          e &&
            e.apply(t.input ? t.input[0] : null, [
              t.selectedYear,
              t.selectedMonth + 1,
              t,
            ]);
        },
        _getNumberOfMonths: function (t) {
          var e = this._get(t, "numberOfMonths");
          return null == e ? [1, 1] : "number" == typeof e ? [1, e] : e;
        },
        _getMinMaxDate: function (t, e) {
          return this._determineDate(t, this._get(t, e + "Date"), null);
        },
        _getDaysInMonth: function (t, e) {
          return 32 - this._daylightSavingAdjust(new Date(t, e, 32)).getDate();
        },
        _getFirstDayOfMonth: function (t, e) {
          return new Date(t, e, 1).getDay();
        },
        _canAdjustMonth: function (t, e, i, n) {
          var s = this._getNumberOfMonths(t),
            o = this._daylightSavingAdjust(
              new Date(i, n + (e < 0 ? e : s[0] * s[1]), 1)
            );
          return (
            e < 0 &&
              o.setDate(this._getDaysInMonth(o.getFullYear(), o.getMonth())),
            this._isInRange(t, o)
          );
        },
        _isInRange: function (t, e) {
          var i,
            n,
            s = this._getMinMaxDate(t, "min"),
            o = this._getMinMaxDate(t, "max"),
            r = null,
            a = null,
            l = this._get(t, "yearRange");
          return (
            l &&
              ((i = l.split(":")),
              (n = new Date().getFullYear()),
              (r = parseInt(i[0], 10)),
              (a = parseInt(i[1], 10)),
              i[0].match(/[+\-].*/) && (r += n),
              i[1].match(/[+\-].*/) && (a += n)),
            (!s || e.getTime() >= s.getTime()) &&
              (!o || e.getTime() <= o.getTime()) &&
              (!r || e.getFullYear() >= r) &&
              (!a || e.getFullYear() <= a)
          );
        },
        _getFormatConfig: function (t) {
          var e = this._get(t, "shortYearCutoff");
          return {
            shortYearCutoff: (e =
              "string" != typeof e
                ? e
                : (new Date().getFullYear() % 100) + parseInt(e, 10)),
            dayNamesShort: this._get(t, "dayNamesShort"),
            dayNames: this._get(t, "dayNames"),
            monthNamesShort: this._get(t, "monthNamesShort"),
            monthNames: this._get(t, "monthNames"),
          };
        },
        _formatDate: function (t, e, i, n) {
          e ||
            ((t.currentDay = t.selectedDay),
            (t.currentMonth = t.selectedMonth),
            (t.currentYear = t.selectedYear));
          var s = e
            ? "object" == typeof e
              ? e
              : this._daylightSavingAdjust(new Date(n, i, e))
            : this._daylightSavingAdjust(
                new Date(t.currentYear, t.currentMonth, t.currentDay)
              );
          return this.formatDate(
            this._get(t, "dateFormat"),
            s,
            this._getFormatConfig(t)
          );
        },
      }),
      (t.fn.datepicker = function (e) {
        if (!this.length) return this;
        t.datepicker.initialized ||
          (t(document).on("mousedown", t.datepicker._checkExternalClick),
          (t.datepicker.initialized = !0)),
          0 === t("#" + t.datepicker._mainDivId).length &&
            t("body").append(t.datepicker.dpDiv);
        var i = Array.prototype.slice.call(arguments, 1);
        return "string" != typeof e ||
          ("isDisabled" !== e && "getDate" !== e && "widget" !== e)
          ? "option" === e &&
            2 === arguments.length &&
            "string" == typeof arguments[1]
            ? t.datepicker["_" + e + "Datepicker"].apply(
                t.datepicker,
                [this[0]].concat(i)
              )
            : this.each(function () {
                "string" == typeof e
                  ? t.datepicker["_" + e + "Datepicker"].apply(
                      t.datepicker,
                      [this].concat(i)
                    )
                  : t.datepicker._attachDatepicker(this, e);
              })
          : t.datepicker["_" + e + "Datepicker"].apply(
              t.datepicker,
              [this[0]].concat(i)
            );
      }),
      (t.datepicker = new d()),
      (t.datepicker.initialized = !1),
      (t.datepicker.uuid = new Date().getTime()),
      (t.datepicker.version = "1.12.1");
    t.datepicker,
      (t.ui.ie = !!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase()));
    var g = !1;
    t(document).on("mouseup", function () {
      g = !1;
    });
    t.widget("ui.mouse", {
      version: "1.12.1",
      options: {
        cancel: "input, textarea, button, select, option",
        distance: 1,
        delay: 0,
      },
      _mouseInit: function () {
        var e = this;
        this.element
          .on("mousedown." + this.widgetName, function (t) {
            return e._mouseDown(t);
          })
          .on("click." + this.widgetName, function (i) {
            if (!0 === t.data(i.target, e.widgetName + ".preventClickEvent"))
              return (
                t.removeData(i.target, e.widgetName + ".preventClickEvent"),
                i.stopImmediatePropagation(),
                !1
              );
          }),
          (this.started = !1);
      },
      _mouseDestroy: function () {
        this.element.off("." + this.widgetName),
          this._mouseMoveDelegate &&
            this.document
              .off("mousemove." + this.widgetName, this._mouseMoveDelegate)
              .off("mouseup." + this.widgetName, this._mouseUpDelegate);
      },
      _mouseDown: function (e) {
        if (!g) {
          (this._mouseMoved = !1),
            this._mouseStarted && this._mouseUp(e),
            (this._mouseDownEvent = e);
          var i = this,
            n = 1 === e.which,
            s =
              !("string" != typeof this.options.cancel || !e.target.nodeName) &&
              t(e.target).closest(this.options.cancel).length;
          return (
            !(n && !s && this._mouseCapture(e)) ||
            ((this.mouseDelayMet = !this.options.delay),
            this.mouseDelayMet ||
              (this._mouseDelayTimer = setTimeout(function () {
                i.mouseDelayMet = !0;
              }, this.options.delay)),
            this._mouseDistanceMet(e) &&
            this._mouseDelayMet(e) &&
            ((this._mouseStarted = !1 !== this._mouseStart(e)),
            !this._mouseStarted)
              ? (e.preventDefault(), !0)
              : (!0 ===
                  t.data(e.target, this.widgetName + ".preventClickEvent") &&
                  t.removeData(
                    e.target,
                    this.widgetName + ".preventClickEvent"
                  ),
                (this._mouseMoveDelegate = function (t) {
                  return i._mouseMove(t);
                }),
                (this._mouseUpDelegate = function (t) {
                  return i._mouseUp(t);
                }),
                this.document
                  .on("mousemove." + this.widgetName, this._mouseMoveDelegate)
                  .on("mouseup." + this.widgetName, this._mouseUpDelegate),
                e.preventDefault(),
                (g = !0),
                !0))
          );
        }
      },
      _mouseMove: function (e) {
        if (this._mouseMoved) {
          if (
            t.ui.ie &&
            (!document.documentMode || document.documentMode < 9) &&
            !e.button
          )
            return this._mouseUp(e);
          if (!e.which)
            if (
              e.originalEvent.altKey ||
              e.originalEvent.ctrlKey ||
              e.originalEvent.metaKey ||
              e.originalEvent.shiftKey
            )
              this.ignoreMissingWhich = !0;
            else if (!this.ignoreMissingWhich) return this._mouseUp(e);
        }
        return (
          (e.which || e.button) && (this._mouseMoved = !0),
          this._mouseStarted
            ? (this._mouseDrag(e), e.preventDefault())
            : (this._mouseDistanceMet(e) &&
                this._mouseDelayMet(e) &&
                ((this._mouseStarted =
                  !1 !== this._mouseStart(this._mouseDownEvent, e)),
                this._mouseStarted ? this._mouseDrag(e) : this._mouseUp(e)),
              !this._mouseStarted)
        );
      },
      _mouseUp: function (e) {
        this.document
          .off("mousemove." + this.widgetName, this._mouseMoveDelegate)
          .off("mouseup." + this.widgetName, this._mouseUpDelegate),
          this._mouseStarted &&
            ((this._mouseStarted = !1),
            e.target === this._mouseDownEvent.target &&
              t.data(e.target, this.widgetName + ".preventClickEvent", !0),
            this._mouseStop(e)),
          this._mouseDelayTimer &&
            (clearTimeout(this._mouseDelayTimer), delete this._mouseDelayTimer),
          (this.ignoreMissingWhich = !1),
          (g = !1),
          e.preventDefault();
      },
      _mouseDistanceMet: function (t) {
        return (
          Math.max(
            Math.abs(this._mouseDownEvent.pageX - t.pageX),
            Math.abs(this._mouseDownEvent.pageY - t.pageY)
          ) >= this.options.distance
        );
      },
      _mouseDelayMet: function () {
        return this.mouseDelayMet;
      },
      _mouseStart: function () {},
      _mouseDrag: function () {},
      _mouseStop: function () {},
      _mouseCapture: function () {
        return !0;
      },
    }),
      (t.ui.plugin = {
        add: function (e, i, n) {
          var s,
            o = t.ui[e].prototype;
          for (s in n)
            (o.plugins[s] = o.plugins[s] || []), o.plugins[s].push([i, n[s]]);
        },
        call: function (t, e, i, n) {
          var s,
            o = t.plugins[e];
          if (
            o &&
            (n ||
              (t.element[0].parentNode &&
                11 !== t.element[0].parentNode.nodeType))
          )
            for (s = 0; s < o.length; s++)
              t.options[o[s][0]] && o[s][1].apply(t.element, i);
        },
      }),
      (t.ui.safeBlur = function (e) {
        e && "body" !== e.nodeName.toLowerCase() && t(e).trigger("blur");
      });
    t.widget("ui.draggable", t.ui.mouse, {
      version: "1.12.1",
      widgetEventPrefix: "drag",
      options: {
        addClasses: !0,
        appendTo: "parent",
        axis: !1,
        connectToSortable: !1,
        containment: !1,
        cursor: "auto",
        cursorAt: !1,
        grid: !1,
        handle: !1,
        helper: "original",
        iframeFix: !1,
        opacity: !1,
        refreshPositions: !1,
        revert: !1,
        revertDuration: 500,
        scope: "default",
        scroll: !0,
        scrollSensitivity: 20,
        scrollSpeed: 20,
        snap: !1,
        snapMode: "both",
        snapTolerance: 20,
        stack: !1,
        zIndex: !1,
        drag: null,
        start: null,
        stop: null,
      },
      _create: function () {
        "original" === this.options.helper && this._setPositionRelative(),
          this.options.addClasses && this._addClass("ui-draggable"),
          this._setHandleClassName(),
          this._mouseInit();
      },
      _setOption: function (t, e) {
        this._super(t, e),
          "handle" === t &&
            (this._removeHandleClassName(), this._setHandleClassName());
      },
      _destroy: function () {
        (this.helper || this.element).is(".ui-draggable-dragging")
          ? (this.destroyOnClear = !0)
          : (this._removeHandleClassName(), this._mouseDestroy());
      },
      _mouseCapture: function (e) {
        var i = this.options;
        return (
          !(
            this.helper ||
            i.disabled ||
            t(e.target).closest(".ui-resizable-handle").length > 0
          ) &&
          ((this.handle = this._getHandle(e)),
          !!this.handle &&
            (this._blurActiveElement(e),
            this._blockFrames(!0 === i.iframeFix ? "iframe" : i.iframeFix),
            !0))
        );
      },
      _blockFrames: function (e) {
        this.iframeBlocks = this.document.find(e).map(function () {
          var e = t(this);
          return t("<div>")
            .css("position", "absolute")
            .appendTo(e.parent())
            .outerWidth(e.outerWidth())
            .outerHeight(e.outerHeight())
            .offset(e.offset())[0];
        });
      },
      _unblockFrames: function () {
        this.iframeBlocks &&
          (this.iframeBlocks.remove(), delete this.iframeBlocks);
      },
      _blurActiveElement: function (e) {
        var i = t.ui.safeActiveElement(this.document[0]);
        t(e.target).closest(i).length || t.ui.safeBlur(i);
      },
      _mouseStart: function (e) {
        var i = this.options;
        return (
          (this.helper = this._createHelper(e)),
          this._addClass(this.helper, "ui-draggable-dragging"),
          this._cacheHelperProportions(),
          t.ui.ddmanager && (t.ui.ddmanager.current = this),
          this._cacheMargins(),
          (this.cssPosition = this.helper.css("position")),
          (this.scrollParent = this.helper.scrollParent(!0)),
          (this.offsetParent = this.helper.offsetParent()),
          (this.hasFixedAncestor =
            this.helper.parents().filter(function () {
              return "fixed" === t(this).css("position");
            }).length > 0),
          (this.positionAbs = this.element.offset()),
          this._refreshOffsets(e),
          (this.originalPosition = this.position =
            this._generatePosition(e, !1)),
          (this.originalPageX = e.pageX),
          (this.originalPageY = e.pageY),
          i.cursorAt && this._adjustOffsetFromHelper(i.cursorAt),
          this._setContainment(),
          !1 === this._trigger("start", e)
            ? (this._clear(), !1)
            : (this._cacheHelperProportions(),
              t.ui.ddmanager &&
                !i.dropBehaviour &&
                t.ui.ddmanager.prepareOffsets(this, e),
              this._mouseDrag(e, !0),
              t.ui.ddmanager && t.ui.ddmanager.dragStart(this, e),
              !0)
        );
      },
      _refreshOffsets: function (t) {
        (this.offset = {
          top: this.positionAbs.top - this.margins.top,
          left: this.positionAbs.left - this.margins.left,
          scroll: !1,
          parent: this._getParentOffset(),
          relative: this._getRelativeOffset(),
        }),
          (this.offset.click = {
            left: t.pageX - this.offset.left,
            top: t.pageY - this.offset.top,
          });
      },
      _mouseDrag: function (e, i) {
        if (
          (this.hasFixedAncestor &&
            (this.offset.parent = this._getParentOffset()),
          (this.position = this._generatePosition(e, !0)),
          (this.positionAbs = this._convertPositionTo("absolute")),
          !i)
        ) {
          var n = this._uiHash();
          if (!1 === this._trigger("drag", e, n))
            return this._mouseUp(new t.Event("mouseup", e)), !1;
          this.position = n.position;
        }
        return (
          (this.helper[0].style.left = this.position.left + "px"),
          (this.helper[0].style.top = this.position.top + "px"),
          t.ui.ddmanager && t.ui.ddmanager.drag(this, e),
          !1
        );
      },
      _mouseStop: function (e) {
        var i = this,
          n = !1;
        return (
          t.ui.ddmanager &&
            !this.options.dropBehaviour &&
            (n = t.ui.ddmanager.drop(this, e)),
          this.dropped && ((n = this.dropped), (this.dropped = !1)),
          ("invalid" === this.options.revert && !n) ||
          ("valid" === this.options.revert && n) ||
          !0 === this.options.revert ||
          (t.isFunction(this.options.revert) &&
            this.options.revert.call(this.element, n))
            ? t(this.helper).animate(
                this.originalPosition,
                parseInt(this.options.revertDuration, 10),
                function () {
                  !1 !== i._trigger("stop", e) && i._clear();
                }
              )
            : !1 !== this._trigger("stop", e) && this._clear(),
          !1
        );
      },
      _mouseUp: function (e) {
        return (
          this._unblockFrames(),
          t.ui.ddmanager && t.ui.ddmanager.dragStop(this, e),
          this.handleElement.is(e.target) && this.element.trigger("focus"),
          t.ui.mouse.prototype._mouseUp.call(this, e)
        );
      },
      cancel: function () {
        return (
          this.helper.is(".ui-draggable-dragging")
            ? this._mouseUp(new t.Event("mouseup", { target: this.element[0] }))
            : this._clear(),
          this
        );
      },
      _getHandle: function (e) {
        return (
          !this.options.handle ||
          !!t(e.target).closest(this.element.find(this.options.handle)).length
        );
      },
      _setHandleClassName: function () {
        (this.handleElement = this.options.handle
          ? this.element.find(this.options.handle)
          : this.element),
          this._addClass(this.handleElement, "ui-draggable-handle");
      },
      _removeHandleClassName: function () {
        this._removeClass(this.handleElement, "ui-draggable-handle");
      },
      _createHelper: function (e) {
        var i = this.options,
          n = t.isFunction(i.helper),
          s = n
            ? t(i.helper.apply(this.element[0], [e]))
            : "clone" === i.helper
            ? this.element.clone().removeAttr("id")
            : this.element;
        return (
          s.parents("body").length ||
            s.appendTo(
              "parent" === i.appendTo ? this.element[0].parentNode : i.appendTo
            ),
          n && s[0] === this.element[0] && this._setPositionRelative(),
          s[0] === this.element[0] ||
            /(fixed|absolute)/.test(s.css("position")) ||
            s.css("position", "absolute"),
          s
        );
      },
      _setPositionRelative: function () {
        /^(?:r|a|f)/.test(this.element.css("position")) ||
          (this.element[0].style.position = "relative");
      },
      _adjustOffsetFromHelper: function (e) {
        "string" == typeof e && (e = e.split(" ")),
          t.isArray(e) && (e = { left: +e[0], top: +e[1] || 0 }),
          "left" in e && (this.offset.click.left = e.left + this.margins.left),
          "right" in e &&
            (this.offset.click.left =
              this.helperProportions.width - e.right + this.margins.left),
          "top" in e && (this.offset.click.top = e.top + this.margins.top),
          "bottom" in e &&
            (this.offset.click.top =
              this.helperProportions.height - e.bottom + this.margins.top);
      },
      _isRootNode: function (t) {
        return /(html|body)/i.test(t.tagName) || t === this.document[0];
      },
      _getParentOffset: function () {
        var e = this.offsetParent.offset(),
          i = this.document[0];
        return (
          "absolute" === this.cssPosition &&
            this.scrollParent[0] !== i &&
            t.contains(this.scrollParent[0], this.offsetParent[0]) &&
            ((e.left += this.scrollParent.scrollLeft()),
            (e.top += this.scrollParent.scrollTop())),
          this._isRootNode(this.offsetParent[0]) && (e = { top: 0, left: 0 }),
          {
            top:
              e.top +
              (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0),
            left:
              e.left +
              (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0),
          }
        );
      },
      _getRelativeOffset: function () {
        if ("relative" !== this.cssPosition) return { top: 0, left: 0 };
        var t = this.element.position(),
          e = this._isRootNode(this.scrollParent[0]);
        return {
          top:
            t.top -
            (parseInt(this.helper.css("top"), 10) || 0) +
            (e ? 0 : this.scrollParent.scrollTop()),
          left:
            t.left -
            (parseInt(this.helper.css("left"), 10) || 0) +
            (e ? 0 : this.scrollParent.scrollLeft()),
        };
      },
      _cacheMargins: function () {
        this.margins = {
          left: parseInt(this.element.css("marginLeft"), 10) || 0,
          top: parseInt(this.element.css("marginTop"), 10) || 0,
          right: parseInt(this.element.css("marginRight"), 10) || 0,
          bottom: parseInt(this.element.css("marginBottom"), 10) || 0,
        };
      },
      _cacheHelperProportions: function () {
        this.helperProportions = {
          width: this.helper.outerWidth(),
          height: this.helper.outerHeight(),
        };
      },
      _setContainment: function () {
        var e,
          i,
          n,
          s = this.options,
          o = this.document[0];
        (this.relativeContainer = null),
          s.containment
            ? "window" !== s.containment
              ? "document" !== s.containment
                ? s.containment.constructor !== Array
                  ? ("parent" === s.containment &&
                      (s.containment = this.helper[0].parentNode),
                    (n = (i = t(s.containment))[0]) &&
                      ((e = /(scroll|auto)/.test(i.css("overflow"))),
                      (this.containment = [
                        (parseInt(i.css("borderLeftWidth"), 10) || 0) +
                          (parseInt(i.css("paddingLeft"), 10) || 0),
                        (parseInt(i.css("borderTopWidth"), 10) || 0) +
                          (parseInt(i.css("paddingTop"), 10) || 0),
                        (e
                          ? Math.max(n.scrollWidth, n.offsetWidth)
                          : n.offsetWidth) -
                          (parseInt(i.css("borderRightWidth"), 10) || 0) -
                          (parseInt(i.css("paddingRight"), 10) || 0) -
                          this.helperProportions.width -
                          this.margins.left -
                          this.margins.right,
                        (e
                          ? Math.max(n.scrollHeight, n.offsetHeight)
                          : n.offsetHeight) -
                          (parseInt(i.css("borderBottomWidth"), 10) || 0) -
                          (parseInt(i.css("paddingBottom"), 10) || 0) -
                          this.helperProportions.height -
                          this.margins.top -
                          this.margins.bottom,
                      ]),
                      (this.relativeContainer = i)))
                  : (this.containment = s.containment)
                : (this.containment = [
                    0,
                    0,
                    t(o).width() -
                      this.helperProportions.width -
                      this.margins.left,
                    (t(o).height() || o.body.parentNode.scrollHeight) -
                      this.helperProportions.height -
                      this.margins.top,
                  ])
              : (this.containment = [
                  t(window).scrollLeft() -
                    this.offset.relative.left -
                    this.offset.parent.left,
                  t(window).scrollTop() -
                    this.offset.relative.top -
                    this.offset.parent.top,
                  t(window).scrollLeft() +
                    t(window).width() -
                    this.helperProportions.width -
                    this.margins.left,
                  t(window).scrollTop() +
                    (t(window).height() || o.body.parentNode.scrollHeight) -
                    this.helperProportions.height -
                    this.margins.top,
                ])
            : (this.containment = null);
      },
      _convertPositionTo: function (t, e) {
        e || (e = this.position);
        var i = "absolute" === t ? 1 : -1,
          n = this._isRootNode(this.scrollParent[0]);
        return {
          top:
            e.top +
            this.offset.relative.top * i +
            this.offset.parent.top * i -
            ("fixed" === this.cssPosition
              ? -this.offset.scroll.top
              : n
              ? 0
              : this.offset.scroll.top) *
              i,
          left:
            e.left +
            this.offset.relative.left * i +
            this.offset.parent.left * i -
            ("fixed" === this.cssPosition
              ? -this.offset.scroll.left
              : n
              ? 0
              : this.offset.scroll.left) *
              i,
        };
      },
      _generatePosition: function (t, e) {
        var i,
          n,
          s,
          o,
          r = this.options,
          a = this._isRootNode(this.scrollParent[0]),
          l = t.pageX,
          h = t.pageY;
        return (
          (a && this.offset.scroll) ||
            (this.offset.scroll = {
              top: this.scrollParent.scrollTop(),
              left: this.scrollParent.scrollLeft(),
            }),
          e &&
            (this.containment &&
              (this.relativeContainer
                ? ((n = this.relativeContainer.offset()),
                  (i = [
                    this.containment[0] + n.left,
                    this.containment[1] + n.top,
                    this.containment[2] + n.left,
                    this.containment[3] + n.top,
                  ]))
                : (i = this.containment),
              t.pageX - this.offset.click.left < i[0] &&
                (l = i[0] + this.offset.click.left),
              t.pageY - this.offset.click.top < i[1] &&
                (h = i[1] + this.offset.click.top),
              t.pageX - this.offset.click.left > i[2] &&
                (l = i[2] + this.offset.click.left),
              t.pageY - this.offset.click.top > i[3] &&
                (h = i[3] + this.offset.click.top)),
            r.grid &&
              ((s = r.grid[1]
                ? this.originalPageY +
                  Math.round((h - this.originalPageY) / r.grid[1]) * r.grid[1]
                : this.originalPageY),
              (h = i
                ? s - this.offset.click.top >= i[1] ||
                  s - this.offset.click.top > i[3]
                  ? s
                  : s - this.offset.click.top >= i[1]
                  ? s - r.grid[1]
                  : s + r.grid[1]
                : s),
              (o = r.grid[0]
                ? this.originalPageX +
                  Math.round((l - this.originalPageX) / r.grid[0]) * r.grid[0]
                : this.originalPageX),
              (l = i
                ? o - this.offset.click.left >= i[0] ||
                  o - this.offset.click.left > i[2]
                  ? o
                  : o - this.offset.click.left >= i[0]
                  ? o - r.grid[0]
                  : o + r.grid[0]
                : o)),
            "y" === r.axis && (l = this.originalPageX),
            "x" === r.axis && (h = this.originalPageY)),
          {
            top:
              h -
              this.offset.click.top -
              this.offset.relative.top -
              this.offset.parent.top +
              ("fixed" === this.cssPosition
                ? -this.offset.scroll.top
                : a
                ? 0
                : this.offset.scroll.top),
            left:
              l -
              this.offset.click.left -
              this.offset.relative.left -
              this.offset.parent.left +
              ("fixed" === this.cssPosition
                ? -this.offset.scroll.left
                : a
                ? 0
                : this.offset.scroll.left),
          }
        );
      },
      _clear: function () {
        this._removeClass(this.helper, "ui-draggable-dragging"),
          this.helper[0] === this.element[0] ||
            this.cancelHelperRemoval ||
            this.helper.remove(),
          (this.helper = null),
          (this.cancelHelperRemoval = !1),
          this.destroyOnClear && this.destroy();
      },
      _trigger: function (e, i, n) {
        return (
          (n = n || this._uiHash()),
          t.ui.plugin.call(this, e, [i, n, this], !0),
          /^(drag|start|stop)/.test(e) &&
            ((this.positionAbs = this._convertPositionTo("absolute")),
            (n.offset = this.positionAbs)),
          t.Widget.prototype._trigger.call(this, e, i, n)
        );
      },
      plugins: {},
      _uiHash: function () {
        return {
          helper: this.helper,
          position: this.position,
          originalPosition: this.originalPosition,
          offset: this.positionAbs,
        };
      },
    }),
      t.ui.plugin.add("draggable", "connectToSortable", {
        start: function (e, i, n) {
          var s = t.extend({}, i, { item: n.element });
          (n.sortables = []),
            t(n.options.connectToSortable).each(function () {
              var i = t(this).sortable("instance");
              i &&
                !i.options.disabled &&
                (n.sortables.push(i),
                i.refreshPositions(),
                i._trigger("activate", e, s));
            });
        },
        stop: function (e, i, n) {
          var s = t.extend({}, i, { item: n.element });
          (n.cancelHelperRemoval = !1),
            t.each(n.sortables, function () {
              this.isOver
                ? ((this.isOver = 0),
                  (n.cancelHelperRemoval = !0),
                  (this.cancelHelperRemoval = !1),
                  (this._storedCSS = {
                    position: this.placeholder.css("position"),
                    top: this.placeholder.css("top"),
                    left: this.placeholder.css("left"),
                  }),
                  this._mouseStop(e),
                  (this.options.helper = this.options._helper))
                : ((this.cancelHelperRemoval = !0),
                  this._trigger("deactivate", e, s));
            });
        },
        drag: function (e, i, n) {
          t.each(n.sortables, function () {
            var s = !1,
              o = this;
            (o.positionAbs = n.positionAbs),
              (o.helperProportions = n.helperProportions),
              (o.offset.click = n.offset.click),
              o._intersectsWith(o.containerCache) &&
                ((s = !0),
                t.each(n.sortables, function () {
                  return (
                    (this.positionAbs = n.positionAbs),
                    (this.helperProportions = n.helperProportions),
                    (this.offset.click = n.offset.click),
                    this !== o &&
                      this._intersectsWith(this.containerCache) &&
                      t.contains(o.element[0], this.element[0]) &&
                      (s = !1),
                    s
                  );
                })),
              s
                ? (o.isOver ||
                    ((o.isOver = 1),
                    (n._parent = i.helper.parent()),
                    (o.currentItem = i.helper
                      .appendTo(o.element)
                      .data("ui-sortable-item", !0)),
                    (o.options._helper = o.options.helper),
                    (o.options.helper = function () {
                      return i.helper[0];
                    }),
                    (e.target = o.currentItem[0]),
                    o._mouseCapture(e, !0),
                    o._mouseStart(e, !0, !0),
                    (o.offset.click.top = n.offset.click.top),
                    (o.offset.click.left = n.offset.click.left),
                    (o.offset.parent.left -=
                      n.offset.parent.left - o.offset.parent.left),
                    (o.offset.parent.top -=
                      n.offset.parent.top - o.offset.parent.top),
                    n._trigger("toSortable", e),
                    (n.dropped = o.element),
                    t.each(n.sortables, function () {
                      this.refreshPositions();
                    }),
                    (n.currentItem = n.element),
                    (o.fromOutside = n)),
                  o.currentItem && (o._mouseDrag(e), (i.position = o.position)))
                : o.isOver &&
                  ((o.isOver = 0),
                  (o.cancelHelperRemoval = !0),
                  (o.options._revert = o.options.revert),
                  (o.options.revert = !1),
                  o._trigger("out", e, o._uiHash(o)),
                  o._mouseStop(e, !0),
                  (o.options.revert = o.options._revert),
                  (o.options.helper = o.options._helper),
                  o.placeholder && o.placeholder.remove(),
                  i.helper.appendTo(n._parent),
                  n._refreshOffsets(e),
                  (i.position = n._generatePosition(e, !0)),
                  n._trigger("fromSortable", e),
                  (n.dropped = !1),
                  t.each(n.sortables, function () {
                    this.refreshPositions();
                  }));
          });
        },
      }),
      t.ui.plugin.add("draggable", "cursor", {
        start: function (e, i, n) {
          var s = t("body"),
            o = n.options;
          s.css("cursor") && (o._cursor = s.css("cursor")),
            s.css("cursor", o.cursor);
        },
        stop: function (e, i, n) {
          var s = n.options;
          s._cursor && t("body").css("cursor", s._cursor);
        },
      }),
      t.ui.plugin.add("draggable", "opacity", {
        start: function (e, i, n) {
          var s = t(i.helper),
            o = n.options;
          s.css("opacity") && (o._opacity = s.css("opacity")),
            s.css("opacity", o.opacity);
        },
        stop: function (e, i, n) {
          var s = n.options;
          s._opacity && t(i.helper).css("opacity", s._opacity);
        },
      }),
      t.ui.plugin.add("draggable", "scroll", {
        start: function (t, e, i) {
          i.scrollParentNotHidden ||
            (i.scrollParentNotHidden = i.helper.scrollParent(!1)),
            i.scrollParentNotHidden[0] !== i.document[0] &&
              "HTML" !== i.scrollParentNotHidden[0].tagName &&
              (i.overflowOffset = i.scrollParentNotHidden.offset());
        },
        drag: function (e, i, n) {
          var s = n.options,
            o = !1,
            r = n.scrollParentNotHidden[0],
            a = n.document[0];
          r !== a && "HTML" !== r.tagName
            ? ((s.axis && "x" === s.axis) ||
                (n.overflowOffset.top + r.offsetHeight - e.pageY <
                s.scrollSensitivity
                  ? (r.scrollTop = o = r.scrollTop + s.scrollSpeed)
                  : e.pageY - n.overflowOffset.top < s.scrollSensitivity &&
                    (r.scrollTop = o = r.scrollTop - s.scrollSpeed)),
              (s.axis && "y" === s.axis) ||
                (n.overflowOffset.left + r.offsetWidth - e.pageX <
                s.scrollSensitivity
                  ? (r.scrollLeft = o = r.scrollLeft + s.scrollSpeed)
                  : e.pageX - n.overflowOffset.left < s.scrollSensitivity &&
                    (r.scrollLeft = o = r.scrollLeft - s.scrollSpeed)))
            : ((s.axis && "x" === s.axis) ||
                (e.pageY - t(a).scrollTop() < s.scrollSensitivity
                  ? (o = t(a).scrollTop(t(a).scrollTop() - s.scrollSpeed))
                  : t(window).height() - (e.pageY - t(a).scrollTop()) <
                      s.scrollSensitivity &&
                    (o = t(a).scrollTop(t(a).scrollTop() + s.scrollSpeed))),
              (s.axis && "y" === s.axis) ||
                (e.pageX - t(a).scrollLeft() < s.scrollSensitivity
                  ? (o = t(a).scrollLeft(t(a).scrollLeft() - s.scrollSpeed))
                  : t(window).width() - (e.pageX - t(a).scrollLeft()) <
                      s.scrollSensitivity &&
                    (o = t(a).scrollLeft(t(a).scrollLeft() + s.scrollSpeed)))),
            !1 !== o &&
              t.ui.ddmanager &&
              !s.dropBehaviour &&
              t.ui.ddmanager.prepareOffsets(n, e);
        },
      }),
      t.ui.plugin.add("draggable", "snap", {
        start: function (e, i, n) {
          var s = n.options;
          (n.snapElements = []),
            t(
              s.snap.constructor !== String
                ? s.snap.items || ":data(ui-draggable)"
                : s.snap
            ).each(function () {
              var e = t(this),
                i = e.offset();
              this !== n.element[0] &&
                n.snapElements.push({
                  item: this,
                  width: e.outerWidth(),
                  height: e.outerHeight(),
                  top: i.top,
                  left: i.left,
                });
            });
        },
        drag: function (e, i, n) {
          var s,
            o,
            r,
            a,
            l,
            h,
            c,
            u,
            d,
            p,
            f = n.options,
            m = f.snapTolerance,
            g = i.offset.left,
            v = g + n.helperProportions.width,
            _ = i.offset.top,
            y = _ + n.helperProportions.height;
          for (d = n.snapElements.length - 1; d >= 0; d--)
            (h =
              (l = n.snapElements[d].left - n.margins.left) +
              n.snapElements[d].width),
              (u =
                (c = n.snapElements[d].top - n.margins.top) +
                n.snapElements[d].height),
              v < l - m ||
              g > h + m ||
              y < c - m ||
              _ > u + m ||
              !t.contains(
                n.snapElements[d].item.ownerDocument,
                n.snapElements[d].item
              )
                ? (n.snapElements[d].snapping &&
                    n.options.snap.release &&
                    n.options.snap.release.call(
                      n.element,
                      e,
                      t.extend(n._uiHash(), {
                        snapItem: n.snapElements[d].item,
                      })
                    ),
                  (n.snapElements[d].snapping = !1))
                : ("inner" !== f.snapMode &&
                    ((s = Math.abs(c - y) <= m),
                    (o = Math.abs(u - _) <= m),
                    (r = Math.abs(l - v) <= m),
                    (a = Math.abs(h - g) <= m),
                    s &&
                      (i.position.top = n._convertPositionTo("relative", {
                        top: c - n.helperProportions.height,
                        left: 0,
                      }).top),
                    o &&
                      (i.position.top = n._convertPositionTo("relative", {
                        top: u,
                        left: 0,
                      }).top),
                    r &&
                      (i.position.left = n._convertPositionTo("relative", {
                        top: 0,
                        left: l - n.helperProportions.width,
                      }).left),
                    a &&
                      (i.position.left = n._convertPositionTo("relative", {
                        top: 0,
                        left: h,
                      }).left)),
                  (p = s || o || r || a),
                  "outer" !== f.snapMode &&
                    ((s = Math.abs(c - _) <= m),
                    (o = Math.abs(u - y) <= m),
                    (r = Math.abs(l - g) <= m),
                    (a = Math.abs(h - v) <= m),
                    s &&
                      (i.position.top = n._convertPositionTo("relative", {
                        top: c,
                        left: 0,
                      }).top),
                    o &&
                      (i.position.top = n._convertPositionTo("relative", {
                        top: u - n.helperProportions.height,
                        left: 0,
                      }).top),
                    r &&
                      (i.position.left = n._convertPositionTo("relative", {
                        top: 0,
                        left: l,
                      }).left),
                    a &&
                      (i.position.left = n._convertPositionTo("relative", {
                        top: 0,
                        left: h - n.helperProportions.width,
                      }).left)),
                  !n.snapElements[d].snapping &&
                    (s || o || r || a || p) &&
                    n.options.snap.snap &&
                    n.options.snap.snap.call(
                      n.element,
                      e,
                      t.extend(n._uiHash(), {
                        snapItem: n.snapElements[d].item,
                      })
                    ),
                  (n.snapElements[d].snapping = s || o || r || a || p));
        },
      }),
      t.ui.plugin.add("draggable", "stack", {
        start: function (e, i, n) {
          var s,
            o = n.options,
            r = t.makeArray(t(o.stack)).sort(function (e, i) {
              return (
                (parseInt(t(e).css("zIndex"), 10) || 0) -
                (parseInt(t(i).css("zIndex"), 10) || 0)
              );
            });
          r.length &&
            ((s = parseInt(t(r[0]).css("zIndex"), 10) || 0),
            t(r).each(function (e) {
              t(this).css("zIndex", s + e);
            }),
            this.css("zIndex", s + r.length));
        },
      }),
      t.ui.plugin.add("draggable", "zIndex", {
        start: function (e, i, n) {
          var s = t(i.helper),
            o = n.options;
          s.css("zIndex") && (o._zIndex = s.css("zIndex")),
            s.css("zIndex", o.zIndex);
        },
        stop: function (e, i, n) {
          var s = n.options;
          s._zIndex && t(i.helper).css("zIndex", s._zIndex);
        },
      });
    t.ui.draggable;
    t.widget("ui.resizable", t.ui.mouse, {
      version: "1.12.1",
      widgetEventPrefix: "resize",
      options: {
        alsoResize: !1,
        animate: !1,
        animateDuration: "slow",
        animateEasing: "swing",
        aspectRatio: !1,
        autoHide: !1,
        classes: { "ui-resizable-se": "ui-icon ui-icon-gripsmall-diagonal-se" },
        containment: !1,
        ghost: !1,
        grid: !1,
        handles: "e,s,se",
        helper: !1,
        maxHeight: null,
        maxWidth: null,
        minHeight: 10,
        minWidth: 10,
        zIndex: 90,
        resize: null,
        start: null,
        stop: null,
      },
      _num: function (t) {
        return parseFloat(t) || 0;
      },
      _isNumber: function (t) {
        return !isNaN(parseFloat(t));
      },
      _hasScroll: function (e, i) {
        if ("hidden" === t(e).css("overflow")) return !1;
        var n,
          s = i && "left" === i ? "scrollLeft" : "scrollTop";
        return e[s] > 0 || ((e[s] = 1), (n = e[s] > 0), (e[s] = 0), n);
      },
      _create: function () {
        var e,
          i = this.options,
          n = this;
        this._addClass("ui-resizable"),
          t.extend(this, {
            _aspectRatio: !!i.aspectRatio,
            aspectRatio: i.aspectRatio,
            originalElement: this.element,
            _proportionallyResizeElements: [],
            _helper:
              i.helper || i.ghost || i.animate
                ? i.helper || "ui-resizable-helper"
                : null,
          }),
          this.element[0].nodeName.match(
            /^(canvas|textarea|input|select|button|img)$/i
          ) &&
            (this.element.wrap(
              t("<div class='ui-wrapper' style='overflow: hidden;'></div>").css(
                {
                  position: this.element.css("position"),
                  width: this.element.outerWidth(),
                  height: this.element.outerHeight(),
                  top: this.element.css("top"),
                  left: this.element.css("left"),
                }
              )
            ),
            (this.element = this.element
              .parent()
              .data("ui-resizable", this.element.resizable("instance"))),
            (this.elementIsWrapper = !0),
            (e = {
              marginTop: this.originalElement.css("marginTop"),
              marginRight: this.originalElement.css("marginRight"),
              marginBottom: this.originalElement.css("marginBottom"),
              marginLeft: this.originalElement.css("marginLeft"),
            }),
            this.element.css(e),
            this.originalElement.css("margin", 0),
            (this.originalResizeStyle = this.originalElement.css("resize")),
            this.originalElement.css("resize", "none"),
            this._proportionallyResizeElements.push(
              this.originalElement.css({
                position: "static",
                zoom: 1,
                display: "block",
              })
            ),
            this.originalElement.css(e),
            this._proportionallyResize()),
          this._setupHandles(),
          i.autoHide &&
            t(this.element)
              .on("mouseenter", function () {
                i.disabled ||
                  (n._removeClass("ui-resizable-autohide"), n._handles.show());
              })
              .on("mouseleave", function () {
                i.disabled ||
                  n.resizing ||
                  (n._addClass("ui-resizable-autohide"), n._handles.hide());
              }),
          this._mouseInit();
      },
      _destroy: function () {
        this._mouseDestroy();
        var e,
          i = function (e) {
            t(e)
              .removeData("resizable")
              .removeData("ui-resizable")
              .off(".resizable")
              .find(".ui-resizable-handle")
              .remove();
          };
        return (
          this.elementIsWrapper &&
            (i(this.element),
            (e = this.element),
            this.originalElement
              .css({
                position: e.css("position"),
                width: e.outerWidth(),
                height: e.outerHeight(),
                top: e.css("top"),
                left: e.css("left"),
              })
              .insertAfter(e),
            e.remove()),
          this.originalElement.css("resize", this.originalResizeStyle),
          i(this.originalElement),
          this
        );
      },
      _setOption: function (t, e) {
        switch ((this._super(t, e), t)) {
          case "handles":
            this._removeHandles(), this._setupHandles();
        }
      },
      _setupHandles: function () {
        var e,
          i,
          n,
          s,
          o,
          r = this.options,
          a = this;
        if (
          ((this.handles =
            r.handles ||
            (t(".ui-resizable-handle", this.element).length
              ? {
                  n: ".ui-resizable-n",
                  e: ".ui-resizable-e",
                  s: ".ui-resizable-s",
                  w: ".ui-resizable-w",
                  se: ".ui-resizable-se",
                  sw: ".ui-resizable-sw",
                  ne: ".ui-resizable-ne",
                  nw: ".ui-resizable-nw",
                }
              : "e,s,se")),
          (this._handles = t()),
          this.handles.constructor === String)
        )
          for (
            "all" === this.handles && (this.handles = "n,e,s,w,se,sw,ne,nw"),
              n = this.handles.split(","),
              this.handles = {},
              i = 0;
            i < n.length;
            i++
          )
            (s = "ui-resizable-" + (e = t.trim(n[i]))),
              (o = t("<div>")),
              this._addClass(o, "ui-resizable-handle " + s),
              o.css({ zIndex: r.zIndex }),
              (this.handles[e] = ".ui-resizable-" + e),
              this.element.append(o);
        (this._renderAxis = function (e) {
          var i, n, s, o;
          for (i in ((e = e || this.element), this.handles))
            this.handles[i].constructor === String
              ? (this.handles[i] = this.element
                  .children(this.handles[i])
                  .first()
                  .show())
              : (this.handles[i].jquery || this.handles[i].nodeType) &&
                ((this.handles[i] = t(this.handles[i])),
                this._on(this.handles[i], { mousedown: a._mouseDown })),
              this.elementIsWrapper &&
                this.originalElement[0].nodeName.match(
                  /^(textarea|input|select|button)$/i
                ) &&
                ((n = t(this.handles[i], this.element)),
                (o = /sw|ne|nw|se|n|s/.test(i)
                  ? n.outerHeight()
                  : n.outerWidth()),
                (s = [
                  "padding",
                  /ne|nw|n/.test(i)
                    ? "Top"
                    : /se|sw|s/.test(i)
                    ? "Bottom"
                    : /^e$/.test(i)
                    ? "Right"
                    : "Left",
                ].join("")),
                e.css(s, o),
                this._proportionallyResize()),
              (this._handles = this._handles.add(this.handles[i]));
        }),
          this._renderAxis(this.element),
          (this._handles = this._handles.add(
            this.element.find(".ui-resizable-handle")
          )),
          this._handles.disableSelection(),
          this._handles.on("mouseover", function () {
            a.resizing ||
              (this.className &&
                (o = this.className.match(
                  /ui-resizable-(se|sw|ne|nw|n|e|s|w)/i
                )),
              (a.axis = o && o[1] ? o[1] : "se"));
          }),
          r.autoHide &&
            (this._handles.hide(), this._addClass("ui-resizable-autohide"));
      },
      _removeHandles: function () {
        this._handles.remove();
      },
      _mouseCapture: function (e) {
        var i,
          n,
          s = !1;
        for (i in this.handles)
          ((n = t(this.handles[i])[0]) === e.target ||
            t.contains(n, e.target)) &&
            (s = !0);
        return !this.options.disabled && s;
      },
      _mouseStart: function (e) {
        var i,
          n,
          s,
          o = this.options,
          r = this.element;
        return (
          (this.resizing = !0),
          this._renderProxy(),
          (i = this._num(this.helper.css("left"))),
          (n = this._num(this.helper.css("top"))),
          o.containment &&
            ((i += t(o.containment).scrollLeft() || 0),
            (n += t(o.containment).scrollTop() || 0)),
          (this.offset = this.helper.offset()),
          (this.position = { left: i, top: n }),
          (this.size = this._helper
            ? { width: this.helper.width(), height: this.helper.height() }
            : { width: r.width(), height: r.height() }),
          (this.originalSize = this._helper
            ? { width: r.outerWidth(), height: r.outerHeight() }
            : { width: r.width(), height: r.height() }),
          (this.sizeDiff = {
            width: r.outerWidth() - r.width(),
            height: r.outerHeight() - r.height(),
          }),
          (this.originalPosition = { left: i, top: n }),
          (this.originalMousePosition = { left: e.pageX, top: e.pageY }),
          (this.aspectRatio =
            "number" == typeof o.aspectRatio
              ? o.aspectRatio
              : this.originalSize.width / this.originalSize.height || 1),
          (s = t(".ui-resizable-" + this.axis).css("cursor")),
          t("body").css("cursor", "auto" === s ? this.axis + "-resize" : s),
          this._addClass("ui-resizable-resizing"),
          this._propagate("start", e),
          !0
        );
      },
      _mouseDrag: function (e) {
        var i,
          n,
          s = this.originalMousePosition,
          o = this.axis,
          r = e.pageX - s.left || 0,
          a = e.pageY - s.top || 0,
          l = this._change[o];
        return (
          this._updatePrevProperties(),
          !!l &&
            ((i = l.apply(this, [e, r, a])),
            this._updateVirtualBoundaries(e.shiftKey),
            (this._aspectRatio || e.shiftKey) && (i = this._updateRatio(i, e)),
            (i = this._respectSize(i, e)),
            this._updateCache(i),
            this._propagate("resize", e),
            (n = this._applyChanges()),
            !this._helper &&
              this._proportionallyResizeElements.length &&
              this._proportionallyResize(),
            t.isEmptyObject(n) ||
              (this._updatePrevProperties(),
              this._trigger("resize", e, this.ui()),
              this._applyChanges()),
            !1)
        );
      },
      _mouseStop: function (e) {
        this.resizing = !1;
        var i,
          n,
          s,
          o,
          r,
          a,
          l,
          h = this.options;
        return (
          this._helper &&
            ((s =
              (n =
                (i = this._proportionallyResizeElements).length &&
                /textarea/i.test(i[0].nodeName)) &&
              this._hasScroll(i[0], "left")
                ? 0
                : this.sizeDiff.height),
            (o = n ? 0 : this.sizeDiff.width),
            (r = {
              width: this.helper.width() - o,
              height: this.helper.height() - s,
            }),
            (a =
              parseFloat(this.element.css("left")) +
                (this.position.left - this.originalPosition.left) || null),
            (l =
              parseFloat(this.element.css("top")) +
                (this.position.top - this.originalPosition.top) || null),
            h.animate || this.element.css(t.extend(r, { top: l, left: a })),
            this.helper.height(this.size.height),
            this.helper.width(this.size.width),
            this._helper && !h.animate && this._proportionallyResize()),
          t("body").css("cursor", "auto"),
          this._removeClass("ui-resizable-resizing"),
          this._propagate("stop", e),
          this._helper && this.helper.remove(),
          !1
        );
      },
      _updatePrevProperties: function () {
        (this.prevPosition = {
          top: this.position.top,
          left: this.position.left,
        }),
          (this.prevSize = {
            width: this.size.width,
            height: this.size.height,
          });
      },
      _applyChanges: function () {
        var t = {};
        return (
          this.position.top !== this.prevPosition.top &&
            (t.top = this.position.top + "px"),
          this.position.left !== this.prevPosition.left &&
            (t.left = this.position.left + "px"),
          this.size.width !== this.prevSize.width &&
            (t.width = this.size.width + "px"),
          this.size.height !== this.prevSize.height &&
            (t.height = this.size.height + "px"),
          this.helper.css(t),
          t
        );
      },
      _updateVirtualBoundaries: function (t) {
        var e,
          i,
          n,
          s,
          o,
          r = this.options;
        (o = {
          minWidth: this._isNumber(r.minWidth) ? r.minWidth : 0,
          maxWidth: this._isNumber(r.maxWidth) ? r.maxWidth : 1 / 0,
          minHeight: this._isNumber(r.minHeight) ? r.minHeight : 0,
          maxHeight: this._isNumber(r.maxHeight) ? r.maxHeight : 1 / 0,
        }),
          (this._aspectRatio || t) &&
            ((e = o.minHeight * this.aspectRatio),
            (n = o.minWidth / this.aspectRatio),
            (i = o.maxHeight * this.aspectRatio),
            (s = o.maxWidth / this.aspectRatio),
            e > o.minWidth && (o.minWidth = e),
            n > o.minHeight && (o.minHeight = n),
            i < o.maxWidth && (o.maxWidth = i),
            s < o.maxHeight && (o.maxHeight = s)),
          (this._vBoundaries = o);
      },
      _updateCache: function (t) {
        (this.offset = this.helper.offset()),
          this._isNumber(t.left) && (this.position.left = t.left),
          this._isNumber(t.top) && (this.position.top = t.top),
          this._isNumber(t.height) && (this.size.height = t.height),
          this._isNumber(t.width) && (this.size.width = t.width);
      },
      _updateRatio: function (t) {
        var e = this.position,
          i = this.size,
          n = this.axis;
        return (
          this._isNumber(t.height)
            ? (t.width = t.height * this.aspectRatio)
            : this._isNumber(t.width) &&
              (t.height = t.width / this.aspectRatio),
          "sw" === n &&
            ((t.left = e.left + (i.width - t.width)), (t.top = null)),
          "nw" === n &&
            ((t.top = e.top + (i.height - t.height)),
            (t.left = e.left + (i.width - t.width))),
          t
        );
      },
      _respectSize: function (t) {
        var e = this._vBoundaries,
          i = this.axis,
          n = this._isNumber(t.width) && e.maxWidth && e.maxWidth < t.width,
          s = this._isNumber(t.height) && e.maxHeight && e.maxHeight < t.height,
          o = this._isNumber(t.width) && e.minWidth && e.minWidth > t.width,
          r = this._isNumber(t.height) && e.minHeight && e.minHeight > t.height,
          a = this.originalPosition.left + this.originalSize.width,
          l = this.originalPosition.top + this.originalSize.height,
          h = /sw|nw|w/.test(i),
          c = /nw|ne|n/.test(i);
        return (
          o && (t.width = e.minWidth),
          r && (t.height = e.minHeight),
          n && (t.width = e.maxWidth),
          s && (t.height = e.maxHeight),
          o && h && (t.left = a - e.minWidth),
          n && h && (t.left = a - e.maxWidth),
          r && c && (t.top = l - e.minHeight),
          s && c && (t.top = l - e.maxHeight),
          t.width || t.height || t.left || !t.top
            ? t.width || t.height || t.top || !t.left || (t.left = null)
            : (t.top = null),
          t
        );
      },
      _getPaddingPlusBorderDimensions: function (t) {
        for (
          var e = 0,
            i = [],
            n = [
              t.css("borderTopWidth"),
              t.css("borderRightWidth"),
              t.css("borderBottomWidth"),
              t.css("borderLeftWidth"),
            ],
            s = [
              t.css("paddingTop"),
              t.css("paddingRight"),
              t.css("paddingBottom"),
              t.css("paddingLeft"),
            ];
          e < 4;
          e++
        )
          (i[e] = parseFloat(n[e]) || 0), (i[e] += parseFloat(s[e]) || 0);
        return { height: i[0] + i[2], width: i[1] + i[3] };
      },
      _proportionallyResize: function () {
        if (this._proportionallyResizeElements.length)
          for (
            var t, e = 0, i = this.helper || this.element;
            e < this._proportionallyResizeElements.length;
            e++
          )
            (t = this._proportionallyResizeElements[e]),
              this.outerDimensions ||
                (this.outerDimensions =
                  this._getPaddingPlusBorderDimensions(t)),
              t.css({
                height: i.height() - this.outerDimensions.height || 0,
                width: i.width() - this.outerDimensions.width || 0,
              });
      },
      _renderProxy: function () {
        var e = this.element,
          i = this.options;
        (this.elementOffset = e.offset()),
          this._helper
            ? ((this.helper =
                this.helper || t("<div style='overflow:hidden;'></div>")),
              this._addClass(this.helper, this._helper),
              this.helper.css({
                width: this.element.outerWidth(),
                height: this.element.outerHeight(),
                position: "absolute",
                left: this.elementOffset.left + "px",
                top: this.elementOffset.top + "px",
                zIndex: ++i.zIndex,
              }),
              this.helper.appendTo("body").disableSelection())
            : (this.helper = this.element);
      },
      _change: {
        e: function (t, e) {
          return { width: this.originalSize.width + e };
        },
        w: function (t, e) {
          var i = this.originalSize;
          return { left: this.originalPosition.left + e, width: i.width - e };
        },
        n: function (t, e, i) {
          var n = this.originalSize;
          return { top: this.originalPosition.top + i, height: n.height - i };
        },
        s: function (t, e, i) {
          return { height: this.originalSize.height + i };
        },
        se: function (e, i, n) {
          return t.extend(
            this._change.s.apply(this, arguments),
            this._change.e.apply(this, [e, i, n])
          );
        },
        sw: function (e, i, n) {
          return t.extend(
            this._change.s.apply(this, arguments),
            this._change.w.apply(this, [e, i, n])
          );
        },
        ne: function (e, i, n) {
          return t.extend(
            this._change.n.apply(this, arguments),
            this._change.e.apply(this, [e, i, n])
          );
        },
        nw: function (e, i, n) {
          return t.extend(
            this._change.n.apply(this, arguments),
            this._change.w.apply(this, [e, i, n])
          );
        },
      },
      _propagate: function (e, i) {
        t.ui.plugin.call(this, e, [i, this.ui()]),
          "resize" !== e && this._trigger(e, i, this.ui());
      },
      plugins: {},
      ui: function () {
        return {
          originalElement: this.originalElement,
          element: this.element,
          helper: this.helper,
          position: this.position,
          size: this.size,
          originalSize: this.originalSize,
          originalPosition: this.originalPosition,
        };
      },
    }),
      t.ui.plugin.add("resizable", "animate", {
        stop: function (e) {
          var i = t(this).resizable("instance"),
            n = i.options,
            s = i._proportionallyResizeElements,
            o = s.length && /textarea/i.test(s[0].nodeName),
            r = o && i._hasScroll(s[0], "left") ? 0 : i.sizeDiff.height,
            a = o ? 0 : i.sizeDiff.width,
            l = { width: i.size.width - a, height: i.size.height - r },
            h =
              parseFloat(i.element.css("left")) +
                (i.position.left - i.originalPosition.left) || null,
            c =
              parseFloat(i.element.css("top")) +
                (i.position.top - i.originalPosition.top) || null;
          i.element.animate(t.extend(l, c && h ? { top: c, left: h } : {}), {
            duration: n.animateDuration,
            easing: n.animateEasing,
            step: function () {
              var n = {
                width: parseFloat(i.element.css("width")),
                height: parseFloat(i.element.css("height")),
                top: parseFloat(i.element.css("top")),
                left: parseFloat(i.element.css("left")),
              };
              s &&
                s.length &&
                t(s[0]).css({ width: n.width, height: n.height }),
                i._updateCache(n),
                i._propagate("resize", e);
            },
          });
        },
      }),
      t.ui.plugin.add("resizable", "containment", {
        start: function () {
          var e,
            i,
            n,
            s,
            o,
            r,
            a,
            l = t(this).resizable("instance"),
            h = l.options,
            c = l.element,
            u = h.containment,
            d =
              u instanceof t
                ? u.get(0)
                : /parent/.test(u)
                ? c.parent().get(0)
                : u;
          d &&
            ((l.containerElement = t(d)),
            /document/.test(u) || u === document
              ? ((l.containerOffset = { left: 0, top: 0 }),
                (l.containerPosition = { left: 0, top: 0 }),
                (l.parentData = {
                  element: t(document),
                  left: 0,
                  top: 0,
                  width: t(document).width(),
                  height:
                    t(document).height() ||
                    document.body.parentNode.scrollHeight,
                }))
              : ((e = t(d)),
                (i = []),
                t(["Top", "Right", "Left", "Bottom"]).each(function (t, n) {
                  i[t] = l._num(e.css("padding" + n));
                }),
                (l.containerOffset = e.offset()),
                (l.containerPosition = e.position()),
                (l.containerSize = {
                  height: e.innerHeight() - i[3],
                  width: e.innerWidth() - i[1],
                }),
                (n = l.containerOffset),
                (s = l.containerSize.height),
                (o = l.containerSize.width),
                (r = l._hasScroll(d, "left") ? d.scrollWidth : o),
                (a = l._hasScroll(d) ? d.scrollHeight : s),
                (l.parentData = {
                  element: d,
                  left: n.left,
                  top: n.top,
                  width: r,
                  height: a,
                })));
        },
        resize: function (e) {
          var i,
            n,
            s,
            o,
            r = t(this).resizable("instance"),
            a = r.options,
            l = r.containerOffset,
            h = r.position,
            c = r._aspectRatio || e.shiftKey,
            u = { top: 0, left: 0 },
            d = r.containerElement,
            p = !0;
          d[0] !== document && /static/.test(d.css("position")) && (u = l),
            h.left < (r._helper ? l.left : 0) &&
              ((r.size.width =
                r.size.width +
                (r._helper
                  ? r.position.left - l.left
                  : r.position.left - u.left)),
              c && ((r.size.height = r.size.width / r.aspectRatio), (p = !1)),
              (r.position.left = a.helper ? l.left : 0)),
            h.top < (r._helper ? l.top : 0) &&
              ((r.size.height =
                r.size.height +
                (r._helper ? r.position.top - l.top : r.position.top)),
              c && ((r.size.width = r.size.height * r.aspectRatio), (p = !1)),
              (r.position.top = r._helper ? l.top : 0)),
            (s = r.containerElement.get(0) === r.element.parent().get(0)),
            (o = /relative|absolute/.test(r.containerElement.css("position"))),
            s && o
              ? ((r.offset.left = r.parentData.left + r.position.left),
                (r.offset.top = r.parentData.top + r.position.top))
              : ((r.offset.left = r.element.offset().left),
                (r.offset.top = r.element.offset().top)),
            (i = Math.abs(
              r.sizeDiff.width +
                (r._helper ? r.offset.left - u.left : r.offset.left - l.left)
            )),
            (n = Math.abs(
              r.sizeDiff.height +
                (r._helper ? r.offset.top - u.top : r.offset.top - l.top)
            )),
            i + r.size.width >= r.parentData.width &&
              ((r.size.width = r.parentData.width - i),
              c && ((r.size.height = r.size.width / r.aspectRatio), (p = !1))),
            n + r.size.height >= r.parentData.height &&
              ((r.size.height = r.parentData.height - n),
              c && ((r.size.width = r.size.height * r.aspectRatio), (p = !1))),
            p ||
              ((r.position.left = r.prevPosition.left),
              (r.position.top = r.prevPosition.top),
              (r.size.width = r.prevSize.width),
              (r.size.height = r.prevSize.height));
        },
        stop: function () {
          var e = t(this).resizable("instance"),
            i = e.options,
            n = e.containerOffset,
            s = e.containerPosition,
            o = e.containerElement,
            r = t(e.helper),
            a = r.offset(),
            l = r.outerWidth() - e.sizeDiff.width,
            h = r.outerHeight() - e.sizeDiff.height;
          e._helper &&
            !i.animate &&
            /relative/.test(o.css("position")) &&
            t(this).css({
              left: a.left - s.left - n.left,
              width: l,
              height: h,
            }),
            e._helper &&
              !i.animate &&
              /static/.test(o.css("position")) &&
              t(this).css({
                left: a.left - s.left - n.left,
                width: l,
                height: h,
              });
        },
      }),
      t.ui.plugin.add("resizable", "alsoResize", {
        start: function () {
          var e = t(this).resizable("instance").options;
          t(e.alsoResize).each(function () {
            var e = t(this);
            e.data("ui-resizable-alsoresize", {
              width: parseFloat(e.width()),
              height: parseFloat(e.height()),
              left: parseFloat(e.css("left")),
              top: parseFloat(e.css("top")),
            });
          });
        },
        resize: function (e, i) {
          var n = t(this).resizable("instance"),
            s = n.options,
            o = n.originalSize,
            r = n.originalPosition,
            a = {
              height: n.size.height - o.height || 0,
              width: n.size.width - o.width || 0,
              top: n.position.top - r.top || 0,
              left: n.position.left - r.left || 0,
            };
          t(s.alsoResize).each(function () {
            var e = t(this),
              n = t(this).data("ui-resizable-alsoresize"),
              s = {},
              o = e.parents(i.originalElement[0]).length
                ? ["width", "height"]
                : ["width", "height", "top", "left"];
            t.each(o, function (t, e) {
              var i = (n[e] || 0) + (a[e] || 0);
              i && i >= 0 && (s[e] = i || null);
            }),
              e.css(s);
          });
        },
        stop: function () {
          t(this).removeData("ui-resizable-alsoresize");
        },
      }),
      t.ui.plugin.add("resizable", "ghost", {
        start: function () {
          var e = t(this).resizable("instance"),
            i = e.size;
          (e.ghost = e.originalElement.clone()),
            e.ghost.css({
              opacity: 0.25,
              display: "block",
              position: "relative",
              height: i.height,
              width: i.width,
              margin: 0,
              left: 0,
              top: 0,
            }),
            e._addClass(e.ghost, "ui-resizable-ghost"),
            !1 !== t.uiBackCompat &&
              "string" == typeof e.options.ghost &&
              e.ghost.addClass(this.options.ghost),
            e.ghost.appendTo(e.helper);
        },
        resize: function () {
          var e = t(this).resizable("instance");
          e.ghost &&
            e.ghost.css({
              position: "relative",
              height: e.size.height,
              width: e.size.width,
            });
        },
        stop: function () {
          var e = t(this).resizable("instance");
          e.ghost && e.helper && e.helper.get(0).removeChild(e.ghost.get(0));
        },
      }),
      t.ui.plugin.add("resizable", "grid", {
        resize: function () {
          var e,
            i = t(this).resizable("instance"),
            n = i.options,
            s = i.size,
            o = i.originalSize,
            r = i.originalPosition,
            a = i.axis,
            l = "number" == typeof n.grid ? [n.grid, n.grid] : n.grid,
            h = l[0] || 1,
            c = l[1] || 1,
            u = Math.round((s.width - o.width) / h) * h,
            d = Math.round((s.height - o.height) / c) * c,
            p = o.width + u,
            f = o.height + d,
            m = n.maxWidth && n.maxWidth < p,
            g = n.maxHeight && n.maxHeight < f,
            v = n.minWidth && n.minWidth > p,
            _ = n.minHeight && n.minHeight > f;
          (n.grid = l),
            v && (p += h),
            _ && (f += c),
            m && (p -= h),
            g && (f -= c),
            /^(se|s|e)$/.test(a)
              ? ((i.size.width = p), (i.size.height = f))
              : /^(ne)$/.test(a)
              ? ((i.size.width = p),
                (i.size.height = f),
                (i.position.top = r.top - d))
              : /^(sw)$/.test(a)
              ? ((i.size.width = p),
                (i.size.height = f),
                (i.position.left = r.left - u))
              : ((f - c <= 0 || p - h <= 0) &&
                  (e = i._getPaddingPlusBorderDimensions(this)),
                f - c > 0
                  ? ((i.size.height = f), (i.position.top = r.top - d))
                  : ((f = c - e.height),
                    (i.size.height = f),
                    (i.position.top = r.top + o.height - f)),
                p - h > 0
                  ? ((i.size.width = p), (i.position.left = r.left - u))
                  : ((p = h - e.width),
                    (i.size.width = p),
                    (i.position.left = r.left + o.width - p)));
        },
      });
    t.ui.resizable;
    t.widget("ui.dialog", {
      version: "1.12.1",
      options: {
        appendTo: "body",
        autoOpen: !0,
        buttons: [],
        classes: {
          "ui-dialog": "ui-corner-all",
          "ui-dialog-titlebar": "ui-corner-all",
        },
        closeOnEscape: !0,
        closeText: "Close",
        draggable: !0,
        hide: null,
        height: "auto",
        maxHeight: null,
        maxWidth: null,
        minHeight: 150,
        minWidth: 150,
        modal: !1,
        position: {
          my: "center",
          at: "center",
          of: window,
          collision: "fit",
          using: function (e) {
            var i = t(this).css(e).offset().top;
            i < 0 && t(this).css("top", e.top - i);
          },
        },
        resizable: !0,
        show: null,
        title: null,
        width: 300,
        beforeClose: null,
        close: null,
        drag: null,
        dragStart: null,
        dragStop: null,
        focus: null,
        open: null,
        resize: null,
        resizeStart: null,
        resizeStop: null,
      },
      sizeRelatedOptions: {
        buttons: !0,
        height: !0,
        maxHeight: !0,
        maxWidth: !0,
        minHeight: !0,
        minWidth: !0,
        width: !0,
      },
      resizableRelatedOptions: {
        maxHeight: !0,
        maxWidth: !0,
        minHeight: !0,
        minWidth: !0,
      },
      _create: function () {
        (this.originalCss = {
          display: this.element[0].style.display,
          width: this.element[0].style.width,
          minHeight: this.element[0].style.minHeight,
          maxHeight: this.element[0].style.maxHeight,
          height: this.element[0].style.height,
        }),
          (this.originalPosition = {
            parent: this.element.parent(),
            index: this.element.parent().children().index(this.element),
          }),
          (this.originalTitle = this.element.attr("title")),
          null == this.options.title &&
            null != this.originalTitle &&
            (this.options.title = this.originalTitle),
          this.options.disabled && (this.options.disabled = !1),
          this._createWrapper(),
          this.element.show().removeAttr("title").appendTo(this.uiDialog),
          this._addClass("ui-dialog-content", "ui-widget-content"),
          this._createTitlebar(),
          this._createButtonPane(),
          this.options.draggable && t.fn.draggable && this._makeDraggable(),
          this.options.resizable && t.fn.resizable && this._makeResizable(),
          (this._isOpen = !1),
          this._trackFocus();
      },
      _init: function () {
        this.options.autoOpen && this.open();
      },
      _appendTo: function () {
        var e = this.options.appendTo;
        return e && (e.jquery || e.nodeType)
          ? t(e)
          : this.document.find(e || "body").eq(0);
      },
      _destroy: function () {
        var t,
          e = this.originalPosition;
        this._untrackInstance(),
          this._destroyOverlay(),
          this.element.removeUniqueId().css(this.originalCss).detach(),
          this.uiDialog.remove(),
          this.originalTitle && this.element.attr("title", this.originalTitle),
          (t = e.parent.children().eq(e.index)).length &&
          t[0] !== this.element[0]
            ? t.before(this.element)
            : e.parent.append(this.element);
      },
      widget: function () {
        return this.uiDialog;
      },
      disable: t.noop,
      enable: t.noop,
      close: function (e) {
        var i = this;
        this._isOpen &&
          !1 !== this._trigger("beforeClose", e) &&
          ((this._isOpen = !1),
          (this._focusedElement = null),
          this._destroyOverlay(),
          this._untrackInstance(),
          this.opener.filter(":focusable").trigger("focus").length ||
            t.ui.safeBlur(t.ui.safeActiveElement(this.document[0])),
          this._hide(this.uiDialog, this.options.hide, function () {
            i._trigger("close", e);
          }));
      },
      isOpen: function () {
        return this._isOpen;
      },
      moveToTop: function () {
        this._moveToTop();
      },
      _moveToTop: function (e, i) {
        var n = !1,
          s = this.uiDialog
            .siblings(".ui-front:visible")
            .map(function () {
              return +t(this).css("z-index");
            })
            .get(),
          o = Math.max.apply(null, s);
        return (
          o >= +this.uiDialog.css("z-index") &&
            (this.uiDialog.css("z-index", o + 1), (n = !0)),
          n && !i && this._trigger("focus", e),
          n
        );
      },
      open: function () {
        var e = this;
        this._isOpen
          ? this._moveToTop() && this._focusTabbable()
          : ((this._isOpen = !0),
            (this.opener = t(t.ui.safeActiveElement(this.document[0]))),
            this._size(),
            this._position(),
            this._createOverlay(),
            this._moveToTop(null, !0),
            this.overlay &&
              this.overlay.css("z-index", this.uiDialog.css("z-index") - 1),
            this._show(this.uiDialog, this.options.show, function () {
              e._focusTabbable(), e._trigger("focus");
            }),
            this._makeFocusTarget(),
            this._trigger("open"));
      },
      _focusTabbable: function () {
        var t = this._focusedElement;
        t || (t = this.element.find("[autofocus]")),
          t.length || (t = this.element.find(":tabbable")),
          t.length || (t = this.uiDialogButtonPane.find(":tabbable")),
          t.length || (t = this.uiDialogTitlebarClose.filter(":tabbable")),
          t.length || (t = this.uiDialog),
          t.eq(0).trigger("focus");
      },
      _keepFocus: function (e) {
        function i() {
          var e = t.ui.safeActiveElement(this.document[0]);
          this.uiDialog[0] === e ||
            t.contains(this.uiDialog[0], e) ||
            this._focusTabbable();
        }
        e.preventDefault(), i.call(this), this._delay(i);
      },
      _createWrapper: function () {
        (this.uiDialog = t("<div>")
          .hide()
          .attr({ tabIndex: -1, role: "dialog" })
          .appendTo(this._appendTo())),
          this._addClass(
            this.uiDialog,
            "ui-dialog",
            "ui-widget ui-widget-content ui-front"
          ),
          this._on(this.uiDialog, {
            keydown: function (e) {
              if (
                this.options.closeOnEscape &&
                !e.isDefaultPrevented() &&
                e.keyCode &&
                e.keyCode === t.ui.keyCode.ESCAPE
              )
                return e.preventDefault(), void this.close(e);
              if (e.keyCode === t.ui.keyCode.TAB && !e.isDefaultPrevented()) {
                var i = this.uiDialog.find(":tabbable"),
                  n = i.filter(":first"),
                  s = i.filter(":last");
                (e.target !== s[0] && e.target !== this.uiDialog[0]) ||
                e.shiftKey
                  ? (e.target !== n[0] && e.target !== this.uiDialog[0]) ||
                    !e.shiftKey ||
                    (this._delay(function () {
                      s.trigger("focus");
                    }),
                    e.preventDefault())
                  : (this._delay(function () {
                      n.trigger("focus");
                    }),
                    e.preventDefault());
              }
            },
            mousedown: function (t) {
              this._moveToTop(t) && this._focusTabbable();
            },
          }),
          this.element.find("[aria-describedby]").length ||
            this.uiDialog.attr({
              "aria-describedby": this.element.uniqueId().attr("id"),
            });
      },
      _createTitlebar: function () {
        var e;
        (this.uiDialogTitlebar = t("<div>")),
          this._addClass(
            this.uiDialogTitlebar,
            "ui-dialog-titlebar",
            "ui-widget-header ui-helper-clearfix"
          ),
          this._on(this.uiDialogTitlebar, {
            mousedown: function (e) {
              t(e.target).closest(".ui-dialog-titlebar-close") ||
                this.uiDialog.trigger("focus");
            },
          }),
          (this.uiDialogTitlebarClose = t("<button type='button'></button>")
            .button({
              label: t("<a>").text(this.options.closeText).html(),
              icon: "ui-icon-closethick",
              showLabel: !1,
            })
            .appendTo(this.uiDialogTitlebar)),
          this._addClass(
            this.uiDialogTitlebarClose,
            "ui-dialog-titlebar-close"
          ),
          this._on(this.uiDialogTitlebarClose, {
            click: function (t) {
              t.preventDefault(), this.close(t);
            },
          }),
          (e = t("<span>").uniqueId().prependTo(this.uiDialogTitlebar)),
          this._addClass(e, "ui-dialog-title"),
          this._title(e),
          this.uiDialogTitlebar.prependTo(this.uiDialog),
          this.uiDialog.attr({ "aria-labelledby": e.attr("id") });
      },
      _title: function (t) {
        this.options.title ? t.text(this.options.title) : t.html("&#160;");
      },
      _createButtonPane: function () {
        (this.uiDialogButtonPane = t("<div>")),
          this._addClass(
            this.uiDialogButtonPane,
            "ui-dialog-buttonpane",
            "ui-widget-content ui-helper-clearfix"
          ),
          (this.uiButtonSet = t("<div>").appendTo(this.uiDialogButtonPane)),
          this._addClass(this.uiButtonSet, "ui-dialog-buttonset"),
          this._createButtons();
      },
      _createButtons: function () {
        var e = this,
          i = this.options.buttons;
        this.uiDialogButtonPane.remove(),
          this.uiButtonSet.empty(),
          t.isEmptyObject(i) || (t.isArray(i) && !i.length)
            ? this._removeClass(this.uiDialog, "ui-dialog-buttons")
            : (t.each(i, function (i, n) {
                var s, o;
                (n = t.isFunction(n) ? { click: n, text: i } : n),
                  (n = t.extend({ type: "button" }, n)),
                  (s = n.click),
                  (o = {
                    icon: n.icon,
                    iconPosition: n.iconPosition,
                    showLabel: n.showLabel,
                    icons: n.icons,
                    text: n.text,
                  }),
                  delete n.click,
                  delete n.icon,
                  delete n.iconPosition,
                  delete n.showLabel,
                  delete n.icons,
                  "boolean" == typeof n.text && delete n.text,
                  t("<button></button>", n)
                    .button(o)
                    .appendTo(e.uiButtonSet)
                    .on("click", function () {
                      s.apply(e.element[0], arguments);
                    });
              }),
              this._addClass(this.uiDialog, "ui-dialog-buttons"),
              this.uiDialogButtonPane.appendTo(this.uiDialog));
      },
      _makeDraggable: function () {
        var e = this,
          i = this.options;
        function n(t) {
          return { position: t.position, offset: t.offset };
        }
        this.uiDialog.draggable({
          cancel: ".ui-dialog-content, .ui-dialog-titlebar-close",
          handle: ".ui-dialog-titlebar",
          containment: "document",
          start: function (i, s) {
            e._addClass(t(this), "ui-dialog-dragging"),
              e._blockFrames(),
              e._trigger("dragStart", i, n(s));
          },
          drag: function (t, i) {
            e._trigger("drag", t, n(i));
          },
          stop: function (s, o) {
            var r = o.offset.left - e.document.scrollLeft(),
              a = o.offset.top - e.document.scrollTop();
            (i.position = {
              my: "left top",
              at:
                "left" +
                (r >= 0 ? "+" : "") +
                r +
                " top" +
                (a >= 0 ? "+" : "") +
                a,
              of: e.window,
            }),
              e._removeClass(t(this), "ui-dialog-dragging"),
              e._unblockFrames(),
              e._trigger("dragStop", s, n(o));
          },
        });
      },
      _makeResizable: function () {
        var e = this,
          i = this.options,
          n = i.resizable,
          s = this.uiDialog.css("position"),
          o = "string" == typeof n ? n : "n,e,s,w,se,sw,ne,nw";
        function r(t) {
          return {
            originalPosition: t.originalPosition,
            originalSize: t.originalSize,
            position: t.position,
            size: t.size,
          };
        }
        this.uiDialog
          .resizable({
            cancel: ".ui-dialog-content",
            containment: "document",
            alsoResize: this.element,
            maxWidth: i.maxWidth,
            maxHeight: i.maxHeight,
            minWidth: i.minWidth,
            minHeight: this._minHeight(),
            handles: o,
            start: function (i, n) {
              e._addClass(t(this), "ui-dialog-resizing"),
                e._blockFrames(),
                e._trigger("resizeStart", i, r(n));
            },
            resize: function (t, i) {
              e._trigger("resize", t, r(i));
            },
            stop: function (n, s) {
              var o = e.uiDialog.offset(),
                a = o.left - e.document.scrollLeft(),
                l = o.top - e.document.scrollTop();
              (i.height = e.uiDialog.height()),
                (i.width = e.uiDialog.width()),
                (i.position = {
                  my: "left top",
                  at:
                    "left" +
                    (a >= 0 ? "+" : "") +
                    a +
                    " top" +
                    (l >= 0 ? "+" : "") +
                    l,
                  of: e.window,
                }),
                e._removeClass(t(this), "ui-dialog-resizing"),
                e._unblockFrames(),
                e._trigger("resizeStop", n, r(s));
            },
          })
          .css("position", s);
      },
      _trackFocus: function () {
        this._on(this.widget(), {
          focusin: function (e) {
            this._makeFocusTarget(), (this._focusedElement = t(e.target));
          },
        });
      },
      _makeFocusTarget: function () {
        this._untrackInstance(), this._trackingInstances().unshift(this);
      },
      _untrackInstance: function () {
        var e = this._trackingInstances(),
          i = t.inArray(this, e);
        -1 !== i && e.splice(i, 1);
      },
      _trackingInstances: function () {
        var t = this.document.data("ui-dialog-instances");
        return t || ((t = []), this.document.data("ui-dialog-instances", t)), t;
      },
      _minHeight: function () {
        var t = this.options;
        return "auto" === t.height
          ? t.minHeight
          : Math.min(t.minHeight, t.height);
      },
      _position: function () {
        var t = this.uiDialog.is(":visible");
        t || this.uiDialog.show(),
          this.uiDialog.position(this.options.position),
          t || this.uiDialog.hide();
      },
      _setOptions: function (e) {
        var i = this,
          n = !1,
          s = {};
        t.each(e, function (t, e) {
          i._setOption(t, e),
            t in i.sizeRelatedOptions && (n = !0),
            t in i.resizableRelatedOptions && (s[t] = e);
        }),
          n && (this._size(), this._position()),
          this.uiDialog.is(":data(ui-resizable)") &&
            this.uiDialog.resizable("option", s);
      },
      _setOption: function (e, i) {
        var n,
          s,
          o = this.uiDialog;
        "disabled" !== e &&
          (this._super(e, i),
          "appendTo" === e && this.uiDialog.appendTo(this._appendTo()),
          "buttons" === e && this._createButtons(),
          "closeText" === e &&
            this.uiDialogTitlebarClose.button({
              label: t("<a>")
                .text("" + this.options.closeText)
                .html(),
            }),
          "draggable" === e &&
            ((n = o.is(":data(ui-draggable)")) && !i && o.draggable("destroy"),
            !n && i && this._makeDraggable()),
          "position" === e && this._position(),
          "resizable" === e &&
            ((s = o.is(":data(ui-resizable)")) && !i && o.resizable("destroy"),
            s && "string" == typeof i && o.resizable("option", "handles", i),
            s || !1 === i || this._makeResizable()),
          "title" === e &&
            this._title(this.uiDialogTitlebar.find(".ui-dialog-title")));
      },
      _size: function () {
        var t,
          e,
          i,
          n = this.options;
        this.element
          .show()
          .css({ width: "auto", minHeight: 0, maxHeight: "none", height: 0 }),
          n.minWidth > n.width && (n.width = n.minWidth),
          (t = this.uiDialog
            .css({ height: "auto", width: n.width })
            .outerHeight()),
          (e = Math.max(0, n.minHeight - t)),
          (i =
            "number" == typeof n.maxHeight
              ? Math.max(0, n.maxHeight - t)
              : "none"),
          "auto" === n.height
            ? this.element.css({ minHeight: e, maxHeight: i, height: "auto" })
            : this.element.height(Math.max(0, n.height - t)),
          this.uiDialog.is(":data(ui-resizable)") &&
            this.uiDialog.resizable("option", "minHeight", this._minHeight());
      },
      _blockFrames: function () {
        this.iframeBlocks = this.document.find("iframe").map(function () {
          var e = t(this);
          return t("<div>")
            .css({
              position: "absolute",
              width: e.outerWidth(),
              height: e.outerHeight(),
            })
            .appendTo(e.parent())
            .offset(e.offset())[0];
        });
      },
      _unblockFrames: function () {
        this.iframeBlocks &&
          (this.iframeBlocks.remove(), delete this.iframeBlocks);
      },
      _allowInteraction: function (e) {
        return (
          !!t(e.target).closest(".ui-dialog").length ||
          !!t(e.target).closest(".ui-datepicker").length
        );
      },
      _createOverlay: function () {
        if (this.options.modal) {
          var e = !0;
          this._delay(function () {
            e = !1;
          }),
            this.document.data("ui-dialog-overlays") ||
              this._on(this.document, {
                focusin: function (t) {
                  e ||
                    this._allowInteraction(t) ||
                    (t.preventDefault(),
                    this._trackingInstances()[0]._focusTabbable());
                },
              }),
            (this.overlay = t("<div>").appendTo(this._appendTo())),
            this._addClass(this.overlay, null, "ui-widget-overlay ui-front"),
            this._on(this.overlay, { mousedown: "_keepFocus" }),
            this.document.data(
              "ui-dialog-overlays",
              (this.document.data("ui-dialog-overlays") || 0) + 1
            );
        }
      },
      _destroyOverlay: function () {
        if (this.options.modal && this.overlay) {
          var t = this.document.data("ui-dialog-overlays") - 1;
          t
            ? this.document.data("ui-dialog-overlays", t)
            : (this._off(this.document, "focusin"),
              this.document.removeData("ui-dialog-overlays")),
            this.overlay.remove(),
            (this.overlay = null);
        }
      },
    }),
      !1 !== t.uiBackCompat &&
        t.widget("ui.dialog", t.ui.dialog, {
          options: { dialogClass: "" },
          _createWrapper: function () {
            this._super(), this.uiDialog.addClass(this.options.dialogClass);
          },
          _setOption: function (t, e) {
            "dialogClass" === t &&
              this.uiDialog.removeClass(this.options.dialogClass).addClass(e),
              this._superApply(arguments);
          },
        });
    t.ui.dialog;
    t.widget("ui.droppable", {
      version: "1.12.1",
      widgetEventPrefix: "drop",
      options: {
        accept: "*",
        addClasses: !0,
        greedy: !1,
        scope: "default",
        tolerance: "intersect",
        activate: null,
        deactivate: null,
        drop: null,
        out: null,
        over: null,
      },
      _create: function () {
        var e,
          i = this.options,
          n = i.accept;
        (this.isover = !1),
          (this.isout = !0),
          (this.accept = t.isFunction(n)
            ? n
            : function (t) {
                return t.is(n);
              }),
          (this.proportions = function () {
            if (!arguments.length)
              return (
                e ||
                (e = {
                  width: this.element[0].offsetWidth,
                  height: this.element[0].offsetHeight,
                })
              );
            e = arguments[0];
          }),
          this._addToManager(i.scope),
          i.addClasses && this._addClass("ui-droppable");
      },
      _addToManager: function (e) {
        (t.ui.ddmanager.droppables[e] = t.ui.ddmanager.droppables[e] || []),
          t.ui.ddmanager.droppables[e].push(this);
      },
      _splice: function (t) {
        for (var e = 0; e < t.length; e++) t[e] === this && t.splice(e, 1);
      },
      _destroy: function () {
        var e = t.ui.ddmanager.droppables[this.options.scope];
        this._splice(e);
      },
      _setOption: function (e, i) {
        if ("accept" === e)
          this.accept = t.isFunction(i)
            ? i
            : function (t) {
                return t.is(i);
              };
        else if ("scope" === e) {
          var n = t.ui.ddmanager.droppables[this.options.scope];
          this._splice(n), this._addToManager(i);
        }
        this._super(e, i);
      },
      _activate: function (e) {
        var i = t.ui.ddmanager.current;
        this._addActiveClass(), i && this._trigger("activate", e, this.ui(i));
      },
      _deactivate: function (e) {
        var i = t.ui.ddmanager.current;
        this._removeActiveClass(),
          i && this._trigger("deactivate", e, this.ui(i));
      },
      _over: function (e) {
        var i = t.ui.ddmanager.current;
        i &&
          (i.currentItem || i.element)[0] !== this.element[0] &&
          this.accept.call(this.element[0], i.currentItem || i.element) &&
          (this._addHoverClass(), this._trigger("over", e, this.ui(i)));
      },
      _out: function (e) {
        var i = t.ui.ddmanager.current;
        i &&
          (i.currentItem || i.element)[0] !== this.element[0] &&
          this.accept.call(this.element[0], i.currentItem || i.element) &&
          (this._removeHoverClass(), this._trigger("out", e, this.ui(i)));
      },
      _drop: function (e, i) {
        var n = i || t.ui.ddmanager.current,
          s = !1;
        return (
          !(!n || (n.currentItem || n.element)[0] === this.element[0]) &&
          (this.element
            .find(":data(ui-droppable)")
            .not(".ui-draggable-dragging")
            .each(function () {
              var i = t(this).droppable("instance");
              if (
                i.options.greedy &&
                !i.options.disabled &&
                i.options.scope === n.options.scope &&
                i.accept.call(i.element[0], n.currentItem || n.element) &&
                v(
                  n,
                  t.extend(i, { offset: i.element.offset() }),
                  i.options.tolerance,
                  e
                )
              )
                return (s = !0), !1;
            }),
          !s &&
            !!this.accept.call(this.element[0], n.currentItem || n.element) &&
            (this._removeActiveClass(),
            this._removeHoverClass(),
            this._trigger("drop", e, this.ui(n)),
            this.element))
        );
      },
      ui: function (t) {
        return {
          draggable: t.currentItem || t.element,
          helper: t.helper,
          position: t.position,
          offset: t.positionAbs,
        };
      },
      _addHoverClass: function () {
        this._addClass("ui-droppable-hover");
      },
      _removeHoverClass: function () {
        this._removeClass("ui-droppable-hover");
      },
      _addActiveClass: function () {
        this._addClass("ui-droppable-active");
      },
      _removeActiveClass: function () {
        this._removeClass("ui-droppable-active");
      },
    });
    var v = (t.ui.intersect = (function () {
      function t(t, e, i) {
        return t >= e && t < e + i;
      }
      return function (e, i, n, s) {
        if (!i.offset) return !1;
        var o = (e.positionAbs || e.position.absolute).left + e.margins.left,
          r = (e.positionAbs || e.position.absolute).top + e.margins.top,
          a = o + e.helperProportions.width,
          l = r + e.helperProportions.height,
          h = i.offset.left,
          c = i.offset.top,
          u = h + i.proportions().width,
          d = c + i.proportions().height;
        switch (n) {
          case "fit":
            return h <= o && a <= u && c <= r && l <= d;
          case "intersect":
            return (
              h < o + e.helperProportions.width / 2 &&
              a - e.helperProportions.width / 2 < u &&
              c < r + e.helperProportions.height / 2 &&
              l - e.helperProportions.height / 2 < d
            );
          case "pointer":
            return (
              t(s.pageY, c, i.proportions().height) &&
              t(s.pageX, h, i.proportions().width)
            );
          case "touch":
            return (
              ((r >= c && r <= d) || (l >= c && l <= d) || (r < c && l > d)) &&
              ((o >= h && o <= u) || (a >= h && a <= u) || (o < h && a > u))
            );
          default:
            return !1;
        }
      };
    })());
    (t.ui.ddmanager = {
      current: null,
      droppables: { default: [] },
      prepareOffsets: function (e, i) {
        var n,
          s,
          o = t.ui.ddmanager.droppables[e.options.scope] || [],
          r = i ? i.type : null,
          a = (e.currentItem || e.element)
            .find(":data(ui-droppable)")
            .addBack();
        t: for (n = 0; n < o.length; n++)
          if (
            !(
              o[n].options.disabled ||
              (e &&
                !o[n].accept.call(o[n].element[0], e.currentItem || e.element))
            )
          ) {
            for (s = 0; s < a.length; s++)
              if (a[s] === o[n].element[0]) {
                o[n].proportions().height = 0;
                continue t;
              }
            (o[n].visible = "none" !== o[n].element.css("display")),
              o[n].visible &&
                ("mousedown" === r && o[n]._activate.call(o[n], i),
                (o[n].offset = o[n].element.offset()),
                o[n].proportions({
                  width: o[n].element[0].offsetWidth,
                  height: o[n].element[0].offsetHeight,
                }));
          }
      },
      drop: function (e, i) {
        var n = !1;
        return (
          t.each(
            (t.ui.ddmanager.droppables[e.options.scope] || []).slice(),
            function () {
              this.options &&
                (!this.options.disabled &&
                  this.visible &&
                  v(e, this, this.options.tolerance, i) &&
                  (n = this._drop.call(this, i) || n),
                !this.options.disabled &&
                  this.visible &&
                  this.accept.call(
                    this.element[0],
                    e.currentItem || e.element
                  ) &&
                  ((this.isout = !0),
                  (this.isover = !1),
                  this._deactivate.call(this, i)));
            }
          ),
          n
        );
      },
      dragStart: function (e, i) {
        e.element.parentsUntil("body").on("scroll.droppable", function () {
          e.options.refreshPositions || t.ui.ddmanager.prepareOffsets(e, i);
        });
      },
      drag: function (e, i) {
        e.options.refreshPositions && t.ui.ddmanager.prepareOffsets(e, i),
          t.each(t.ui.ddmanager.droppables[e.options.scope] || [], function () {
            if (!this.options.disabled && !this.greedyChild && this.visible) {
              var n,
                s,
                o,
                r = v(e, this, this.options.tolerance, i),
                a =
                  !r && this.isover
                    ? "isout"
                    : r && !this.isover
                    ? "isover"
                    : null;
              a &&
                (this.options.greedy &&
                  ((s = this.options.scope),
                  (o = this.element
                    .parents(":data(ui-droppable)")
                    .filter(function () {
                      return t(this).droppable("instance").options.scope === s;
                    })).length &&
                    ((n = t(o[0]).droppable("instance")).greedyChild =
                      "isover" === a)),
                n &&
                  "isover" === a &&
                  ((n.isover = !1), (n.isout = !0), n._out.call(n, i)),
                (this[a] = !0),
                (this["isout" === a ? "isover" : "isout"] = !1),
                this["isover" === a ? "_over" : "_out"].call(this, i),
                n &&
                  "isout" === a &&
                  ((n.isout = !1), (n.isover = !0), n._over.call(n, i)));
            }
          });
      },
      dragStop: function (e, i) {
        e.element.parentsUntil("body").off("scroll.droppable"),
          e.options.refreshPositions || t.ui.ddmanager.prepareOffsets(e, i);
      },
    }),
      !1 !== t.uiBackCompat &&
        t.widget("ui.droppable", t.ui.droppable, {
          options: { hoverClass: !1, activeClass: !1 },
          _addActiveClass: function () {
            this._super(),
              this.options.activeClass &&
                this.element.addClass(this.options.activeClass);
          },
          _removeActiveClass: function () {
            this._super(),
              this.options.activeClass &&
                this.element.removeClass(this.options.activeClass);
          },
          _addHoverClass: function () {
            this._super(),
              this.options.hoverClass &&
                this.element.addClass(this.options.hoverClass);
          },
          _removeHoverClass: function () {
            this._super(),
              this.options.hoverClass &&
                this.element.removeClass(this.options.hoverClass);
          },
        });
    t.ui.droppable,
      t.widget("ui.progressbar", {
        version: "1.12.1",
        options: {
          classes: {
            "ui-progressbar": "ui-corner-all",
            "ui-progressbar-value": "ui-corner-left",
            "ui-progressbar-complete": "ui-corner-right",
          },
          max: 100,
          value: 0,
          change: null,
          complete: null,
        },
        min: 0,
        _create: function () {
          (this.oldValue = this.options.value = this._constrainedValue()),
            this.element.attr({
              role: "progressbar",
              "aria-valuemin": this.min,
            }),
            this._addClass("ui-progressbar", "ui-widget ui-widget-content"),
            (this.valueDiv = t("<div>").appendTo(this.element)),
            this._addClass(
              this.valueDiv,
              "ui-progressbar-value",
              "ui-widget-header"
            ),
            this._refreshValue();
        },
        _destroy: function () {
          this.element.removeAttr(
            "role aria-valuemin aria-valuemax aria-valuenow"
          ),
            this.valueDiv.remove();
        },
        value: function (t) {
          if (void 0 === t) return this.options.value;
          (this.options.value = this._constrainedValue(t)),
            this._refreshValue();
        },
        _constrainedValue: function (t) {
          return (
            void 0 === t && (t = this.options.value),
            (this.indeterminate = !1 === t),
            "number" != typeof t && (t = 0),
            !this.indeterminate &&
              Math.min(this.options.max, Math.max(this.min, t))
          );
        },
        _setOptions: function (t) {
          var e = t.value;
          delete t.value,
            this._super(t),
            (this.options.value = this._constrainedValue(e)),
            this._refreshValue();
        },
        _setOption: function (t, e) {
          "max" === t && (e = Math.max(this.min, e)), this._super(t, e);
        },
        _setOptionDisabled: function (t) {
          this._super(t),
            this.element.attr("aria-disabled", t),
            this._toggleClass(null, "ui-state-disabled", !!t);
        },
        _percentage: function () {
          return this.indeterminate
            ? 100
            : (100 * (this.options.value - this.min)) /
                (this.options.max - this.min);
        },
        _refreshValue: function () {
          var e = this.options.value,
            i = this._percentage();
          this.valueDiv
            .toggle(this.indeterminate || e > this.min)
            .width(i.toFixed(0) + "%"),
            this._toggleClass(
              this.valueDiv,
              "ui-progressbar-complete",
              null,
              e === this.options.max
            )._toggleClass(
              "ui-progressbar-indeterminate",
              null,
              this.indeterminate
            ),
            this.indeterminate
              ? (this.element.removeAttr("aria-valuenow"),
                this.overlayDiv ||
                  ((this.overlayDiv = t("<div>").appendTo(this.valueDiv)),
                  this._addClass(this.overlayDiv, "ui-progressbar-overlay")))
              : (this.element.attr({
                  "aria-valuemax": this.options.max,
                  "aria-valuenow": e,
                }),
                this.overlayDiv &&
                  (this.overlayDiv.remove(), (this.overlayDiv = null))),
            this.oldValue !== e &&
              ((this.oldValue = e), this._trigger("change")),
            e === this.options.max && this._trigger("complete");
        },
      }),
      t.widget("ui.selectable", t.ui.mouse, {
        version: "1.12.1",
        options: {
          appendTo: "body",
          autoRefresh: !0,
          distance: 0,
          filter: "*",
          tolerance: "touch",
          selected: null,
          selecting: null,
          start: null,
          stop: null,
          unselected: null,
          unselecting: null,
        },
        _create: function () {
          var e = this;
          this._addClass("ui-selectable"),
            (this.dragged = !1),
            (this.refresh = function () {
              (e.elementPos = t(e.element[0]).offset()),
                (e.selectees = t(e.options.filter, e.element[0])),
                e._addClass(e.selectees, "ui-selectee"),
                e.selectees.each(function () {
                  var i = t(this),
                    n = i.offset(),
                    s = {
                      left: n.left - e.elementPos.left,
                      top: n.top - e.elementPos.top,
                    };
                  t.data(this, "selectable-item", {
                    element: this,
                    $element: i,
                    left: s.left,
                    top: s.top,
                    right: s.left + i.outerWidth(),
                    bottom: s.top + i.outerHeight(),
                    startselected: !1,
                    selected: i.hasClass("ui-selected"),
                    selecting: i.hasClass("ui-selecting"),
                    unselecting: i.hasClass("ui-unselecting"),
                  });
                });
            }),
            this.refresh(),
            this._mouseInit(),
            (this.helper = t("<div>")),
            this._addClass(this.helper, "ui-selectable-helper");
        },
        _destroy: function () {
          this.selectees.removeData("selectable-item"), this._mouseDestroy();
        },
        _mouseStart: function (e) {
          var i = this,
            n = this.options;
          (this.opos = [e.pageX, e.pageY]),
            (this.elementPos = t(this.element[0]).offset()),
            this.options.disabled ||
              ((this.selectees = t(n.filter, this.element[0])),
              this._trigger("start", e),
              t(n.appendTo).append(this.helper),
              this.helper.css({
                left: e.pageX,
                top: e.pageY,
                width: 0,
                height: 0,
              }),
              n.autoRefresh && this.refresh(),
              this.selectees.filter(".ui-selected").each(function () {
                var n = t.data(this, "selectable-item");
                (n.startselected = !0),
                  e.metaKey ||
                    e.ctrlKey ||
                    (i._removeClass(n.$element, "ui-selected"),
                    (n.selected = !1),
                    i._addClass(n.$element, "ui-unselecting"),
                    (n.unselecting = !0),
                    i._trigger("unselecting", e, { unselecting: n.element }));
              }),
              t(e.target)
                .parents()
                .addBack()
                .each(function () {
                  var n,
                    s = t.data(this, "selectable-item");
                  if (s)
                    return (
                      (n =
                        (!e.metaKey && !e.ctrlKey) ||
                        !s.$element.hasClass("ui-selected")),
                      i
                        ._removeClass(
                          s.$element,
                          n ? "ui-unselecting" : "ui-selected"
                        )
                        ._addClass(
                          s.$element,
                          n ? "ui-selecting" : "ui-unselecting"
                        ),
                      (s.unselecting = !n),
                      (s.selecting = n),
                      (s.selected = n),
                      n
                        ? i._trigger("selecting", e, { selecting: s.element })
                        : i._trigger("unselecting", e, {
                            unselecting: s.element,
                          }),
                      !1
                    );
                }));
        },
        _mouseDrag: function (e) {
          if (((this.dragged = !0), !this.options.disabled)) {
            var i,
              n = this,
              s = this.options,
              o = this.opos[0],
              r = this.opos[1],
              a = e.pageX,
              l = e.pageY;
            return (
              o > a && ((i = a), (a = o), (o = i)),
              r > l && ((i = l), (l = r), (r = i)),
              this.helper.css({ left: o, top: r, width: a - o, height: l - r }),
              this.selectees.each(function () {
                var i = t.data(this, "selectable-item"),
                  h = !1,
                  c = {};
                i &&
                  i.element !== n.element[0] &&
                  ((c.left = i.left + n.elementPos.left),
                  (c.right = i.right + n.elementPos.left),
                  (c.top = i.top + n.elementPos.top),
                  (c.bottom = i.bottom + n.elementPos.top),
                  "touch" === s.tolerance
                    ? (h = !(
                        c.left > a ||
                        c.right < o ||
                        c.top > l ||
                        c.bottom < r
                      ))
                    : "fit" === s.tolerance &&
                      (h =
                        c.left > o && c.right < a && c.top > r && c.bottom < l),
                  h
                    ? (i.selected &&
                        (n._removeClass(i.$element, "ui-selected"),
                        (i.selected = !1)),
                      i.unselecting &&
                        (n._removeClass(i.$element, "ui-unselecting"),
                        (i.unselecting = !1)),
                      i.selecting ||
                        (n._addClass(i.$element, "ui-selecting"),
                        (i.selecting = !0),
                        n._trigger("selecting", e, { selecting: i.element })))
                    : (i.selecting &&
                        ((e.metaKey || e.ctrlKey) && i.startselected
                          ? (n._removeClass(i.$element, "ui-selecting"),
                            (i.selecting = !1),
                            n._addClass(i.$element, "ui-selected"),
                            (i.selected = !0))
                          : (n._removeClass(i.$element, "ui-selecting"),
                            (i.selecting = !1),
                            i.startselected &&
                              (n._addClass(i.$element, "ui-unselecting"),
                              (i.unselecting = !0)),
                            n._trigger("unselecting", e, {
                              unselecting: i.element,
                            }))),
                      i.selected &&
                        (e.metaKey ||
                          e.ctrlKey ||
                          i.startselected ||
                          (n._removeClass(i.$element, "ui-selected"),
                          (i.selected = !1),
                          n._addClass(i.$element, "ui-unselecting"),
                          (i.unselecting = !0),
                          n._trigger("unselecting", e, {
                            unselecting: i.element,
                          })))));
              }),
              !1
            );
          }
        },
        _mouseStop: function (e) {
          var i = this;
          return (
            (this.dragged = !1),
            t(".ui-unselecting", this.element[0]).each(function () {
              var n = t.data(this, "selectable-item");
              i._removeClass(n.$element, "ui-unselecting"),
                (n.unselecting = !1),
                (n.startselected = !1),
                i._trigger("unselected", e, { unselected: n.element });
            }),
            t(".ui-selecting", this.element[0]).each(function () {
              var n = t.data(this, "selectable-item");
              i
                ._removeClass(n.$element, "ui-selecting")
                ._addClass(n.$element, "ui-selected"),
                (n.selecting = !1),
                (n.selected = !0),
                (n.startselected = !0),
                i._trigger("selected", e, { selected: n.element });
            }),
            this._trigger("stop", e),
            this.helper.remove(),
            !1
          );
        },
      }),
      t.widget("ui.selectmenu", [
        t.ui.formResetMixin,
        {
          version: "1.12.1",
          defaultElement: "<select>",
          options: {
            appendTo: null,
            classes: {
              "ui-selectmenu-button-open": "ui-corner-top",
              "ui-selectmenu-button-closed": "ui-corner-all",
            },
            disabled: null,
            icons: { button: "ui-icon-triangle-1-s" },
            position: { my: "left top", at: "left bottom", collision: "none" },
            width: !1,
            change: null,
            close: null,
            focus: null,
            open: null,
            select: null,
          },
          _create: function () {
            var e = this.element.uniqueId().attr("id");
            (this.ids = {
              element: e,
              button: e + "-button",
              menu: e + "-menu",
            }),
              this._drawButton(),
              this._drawMenu(),
              this._bindFormResetHandler(),
              (this._rendered = !1),
              (this.menuItems = t());
          },
          _drawButton: function () {
            var e,
              i = this,
              n = this._parseOption(
                this.element.find("option:selected"),
                this.element[0].selectedIndex
              );
            (this.labels = this.element.labels().attr("for", this.ids.button)),
              this._on(this.labels, {
                click: function (t) {
                  this.button.focus(), t.preventDefault();
                },
              }),
              this.element.hide(),
              (this.button = t("<span>", {
                tabindex: this.options.disabled ? -1 : 0,
                id: this.ids.button,
                role: "combobox",
                "aria-expanded": "false",
                "aria-autocomplete": "list",
                "aria-owns": this.ids.menu,
                "aria-haspopup": "true",
                title: this.element.attr("title"),
              }).insertAfter(this.element)),
              this._addClass(
                this.button,
                "ui-selectmenu-button ui-selectmenu-button-closed",
                "ui-button ui-widget"
              ),
              (e = t("<span>").appendTo(this.button)),
              this._addClass(
                e,
                "ui-selectmenu-icon",
                "ui-icon " + this.options.icons.button
              ),
              (this.buttonItem = this._renderButtonItem(n).appendTo(
                this.button
              )),
              !1 !== this.options.width && this._resizeButton(),
              this._on(this.button, this._buttonEvents),
              this.button.one("focusin", function () {
                i._rendered || i._refreshMenu();
              });
          },
          _drawMenu: function () {
            var e = this;
            (this.menu = t("<ul>", {
              "aria-hidden": "true",
              "aria-labelledby": this.ids.button,
              id: this.ids.menu,
            })),
              (this.menuWrap = t("<div>").append(this.menu)),
              this._addClass(this.menuWrap, "ui-selectmenu-menu", "ui-front"),
              this.menuWrap.appendTo(this._appendTo()),
              (this.menuInstance = this.menu
                .menu({
                  classes: { "ui-menu": "ui-corner-bottom" },
                  role: "listbox",
                  select: function (t, i) {
                    t.preventDefault(),
                      e._setSelection(),
                      e._select(i.item.data("ui-selectmenu-item"), t);
                  },
                  focus: function (t, i) {
                    var n = i.item.data("ui-selectmenu-item");
                    null != e.focusIndex &&
                      n.index !== e.focusIndex &&
                      (e._trigger("focus", t, { item: n }),
                      e.isOpen || e._select(n, t)),
                      (e.focusIndex = n.index),
                      e.button.attr(
                        "aria-activedescendant",
                        e.menuItems.eq(n.index).attr("id")
                      );
                  },
                })
                .menu("instance")),
              this.menuInstance._off(this.menu, "mouseleave"),
              (this.menuInstance._closeOnDocumentClick = function () {
                return !1;
              }),
              (this.menuInstance._isDivider = function () {
                return !1;
              });
          },
          refresh: function () {
            this._refreshMenu(),
              this.buttonItem.replaceWith(
                (this.buttonItem = this._renderButtonItem(
                  this._getSelectedItem().data("ui-selectmenu-item") || {}
                ))
              ),
              null === this.options.width && this._resizeButton();
          },
          _refreshMenu: function () {
            var t,
              e = this.element.find("option");
            this.menu.empty(),
              this._parseOptions(e),
              this._renderMenu(this.menu, this.items),
              this.menuInstance.refresh(),
              (this.menuItems = this.menu
                .find("li")
                .not(".ui-selectmenu-optgroup")
                .find(".ui-menu-item-wrapper")),
              (this._rendered = !0),
              e.length &&
                ((t = this._getSelectedItem()),
                this.menuInstance.focus(null, t),
                this._setAria(t.data("ui-selectmenu-item")),
                this._setOption("disabled", this.element.prop("disabled")));
          },
          open: function (t) {
            this.options.disabled ||
              (this._rendered
                ? (this._removeClass(
                    this.menu.find(".ui-state-active"),
                    null,
                    "ui-state-active"
                  ),
                  this.menuInstance.focus(null, this._getSelectedItem()))
                : this._refreshMenu(),
              this.menuItems.length &&
                ((this.isOpen = !0),
                this._toggleAttr(),
                this._resizeMenu(),
                this._position(),
                this._on(this.document, this._documentClick),
                this._trigger("open", t)));
          },
          _position: function () {
            this.menuWrap.position(
              t.extend({ of: this.button }, this.options.position)
            );
          },
          close: function (t) {
            this.isOpen &&
              ((this.isOpen = !1),
              this._toggleAttr(),
              (this.range = null),
              this._off(this.document),
              this._trigger("close", t));
          },
          widget: function () {
            return this.button;
          },
          menuWidget: function () {
            return this.menu;
          },
          _renderButtonItem: function (e) {
            var i = t("<span>");
            return (
              this._setText(i, e.label),
              this._addClass(i, "ui-selectmenu-text"),
              i
            );
          },
          _renderMenu: function (e, i) {
            var n = this,
              s = "";
            t.each(i, function (i, o) {
              var r;
              o.optgroup !== s &&
                ((r = t("<li>", { text: o.optgroup })),
                n._addClass(
                  r,
                  "ui-selectmenu-optgroup",
                  "ui-menu-divider" +
                    (o.element.parent("optgroup").prop("disabled")
                      ? " ui-state-disabled"
                      : "")
                ),
                r.appendTo(e),
                (s = o.optgroup)),
                n._renderItemData(e, o);
            });
          },
          _renderItemData: function (t, e) {
            return this._renderItem(t, e).data("ui-selectmenu-item", e);
          },
          _renderItem: function (e, i) {
            var n = t("<li>"),
              s = t("<div>", { title: i.element.attr("title") });
            return (
              i.disabled && this._addClass(n, null, "ui-state-disabled"),
              this._setText(s, i.label),
              n.append(s).appendTo(e)
            );
          },
          _setText: function (t, e) {
            e ? t.text(e) : t.html("&#160;");
          },
          _move: function (t, e) {
            var i,
              n,
              s = ".ui-menu-item";
            this.isOpen
              ? (i = this.menuItems.eq(this.focusIndex).parent("li"))
              : ((i = this.menuItems
                  .eq(this.element[0].selectedIndex)
                  .parent("li")),
                (s += ":not(.ui-state-disabled)")),
              (n =
                "first" === t || "last" === t
                  ? i["first" === t ? "prevAll" : "nextAll"](s).eq(-1)
                  : i[t + "All"](s).eq(0)).length &&
                this.menuInstance.focus(e, n);
          },
          _getSelectedItem: function () {
            return this.menuItems
              .eq(this.element[0].selectedIndex)
              .parent("li");
          },
          _toggle: function (t) {
            this[this.isOpen ? "close" : "open"](t);
          },
          _setSelection: function () {
            var t;
            this.range &&
              (window.getSelection
                ? ((t = window.getSelection()).removeAllRanges(),
                  t.addRange(this.range))
                : this.range.select(),
              this.button.focus());
          },
          _documentClick: {
            mousedown: function (e) {
              this.isOpen &&
                (t(e.target).closest(
                  ".ui-selectmenu-menu, #" +
                    t.ui.escapeSelector(this.ids.button)
                ).length ||
                  this.close(e));
            },
          },
          _buttonEvents: {
            mousedown: function () {
              var t;
              window.getSelection
                ? (t = window.getSelection()).rangeCount &&
                  (this.range = t.getRangeAt(0))
                : (this.range = document.selection.createRange());
            },
            click: function (t) {
              this._setSelection(), this._toggle(t);
            },
            keydown: function (e) {
              var i = !0;
              switch (e.keyCode) {
                case t.ui.keyCode.TAB:
                case t.ui.keyCode.ESCAPE:
                  this.close(e), (i = !1);
                  break;
                case t.ui.keyCode.ENTER:
                  this.isOpen && this._selectFocusedItem(e);
                  break;
                case t.ui.keyCode.UP:
                  e.altKey ? this._toggle(e) : this._move("prev", e);
                  break;
                case t.ui.keyCode.DOWN:
                  e.altKey ? this._toggle(e) : this._move("next", e);
                  break;
                case t.ui.keyCode.SPACE:
                  this.isOpen ? this._selectFocusedItem(e) : this._toggle(e);
                  break;
                case t.ui.keyCode.LEFT:
                  this._move("prev", e);
                  break;
                case t.ui.keyCode.RIGHT:
                  this._move("next", e);
                  break;
                case t.ui.keyCode.HOME:
                case t.ui.keyCode.PAGE_UP:
                  this._move("first", e);
                  break;
                case t.ui.keyCode.END:
                case t.ui.keyCode.PAGE_DOWN:
                  this._move("last", e);
                  break;
                default:
                  this.menu.trigger(e), (i = !1);
              }
              i && e.preventDefault();
            },
          },
          _selectFocusedItem: function (t) {
            var e = this.menuItems.eq(this.focusIndex).parent("li");
            e.hasClass("ui-state-disabled") ||
              this._select(e.data("ui-selectmenu-item"), t);
          },
          _select: function (t, e) {
            var i = this.element[0].selectedIndex;
            (this.element[0].selectedIndex = t.index),
              this.buttonItem.replaceWith(
                (this.buttonItem = this._renderButtonItem(t))
              ),
              this._setAria(t),
              this._trigger("select", e, { item: t }),
              t.index !== i && this._trigger("change", e, { item: t }),
              this.close(e);
          },
          _setAria: function (t) {
            var e = this.menuItems.eq(t.index).attr("id");
            this.button.attr({
              "aria-labelledby": e,
              "aria-activedescendant": e,
            }),
              this.menu.attr("aria-activedescendant", e);
          },
          _setOption: function (t, e) {
            if ("icons" === t) {
              var i = this.button.find("span.ui-icon");
              this._removeClass(i, null, this.options.icons.button)._addClass(
                i,
                null,
                e.button
              );
            }
            this._super(t, e),
              "appendTo" === t && this.menuWrap.appendTo(this._appendTo()),
              "width" === t && this._resizeButton();
          },
          _setOptionDisabled: function (t) {
            this._super(t),
              this.menuInstance.option("disabled", t),
              this.button.attr("aria-disabled", t),
              this._toggleClass(this.button, null, "ui-state-disabled", t),
              this.element.prop("disabled", t),
              t
                ? (this.button.attr("tabindex", -1), this.close())
                : this.button.attr("tabindex", 0);
          },
          _appendTo: function () {
            var e = this.options.appendTo;
            return (
              e &&
                (e =
                  e.jquery || e.nodeType ? t(e) : this.document.find(e).eq(0)),
              (e && e[0]) || (e = this.element.closest(".ui-front, dialog")),
              e.length || (e = this.document[0].body),
              e
            );
          },
          _toggleAttr: function () {
            this.button.attr("aria-expanded", this.isOpen),
              this._removeClass(
                this.button,
                "ui-selectmenu-button-" + (this.isOpen ? "closed" : "open")
              )
                ._addClass(
                  this.button,
                  "ui-selectmenu-button-" + (this.isOpen ? "open" : "closed")
                )
                ._toggleClass(
                  this.menuWrap,
                  "ui-selectmenu-open",
                  null,
                  this.isOpen
                ),
              this.menu.attr("aria-hidden", !this.isOpen);
          },
          _resizeButton: function () {
            var t = this.options.width;
            !1 !== t
              ? (null === t &&
                  ((t = this.element.show().outerWidth()), this.element.hide()),
                this.button.outerWidth(t))
              : this.button.css("width", "");
          },
          _resizeMenu: function () {
            this.menu.outerWidth(
              Math.max(
                this.button.outerWidth(),
                this.menu.width("").outerWidth() + 1
              )
            );
          },
          _getCreateOptions: function () {
            var t = this._super();
            return (t.disabled = this.element.prop("disabled")), t;
          },
          _parseOptions: function (e) {
            var i = this,
              n = [];
            e.each(function (e, s) {
              n.push(i._parseOption(t(s), e));
            }),
              (this.items = n);
          },
          _parseOption: function (t, e) {
            var i = t.parent("optgroup");
            return {
              element: t,
              index: e,
              value: t.val(),
              label: t.text(),
              optgroup: i.attr("label") || "",
              disabled: i.prop("disabled") || t.prop("disabled"),
            };
          },
          _destroy: function () {
            this._unbindFormResetHandler(),
              this.menuWrap.remove(),
              this.button.remove(),
              this.element.show(),
              this.element.removeUniqueId(),
              this.labels.attr("for", this.ids.element);
          },
        },
      ]),
      t.widget("ui.slider", t.ui.mouse, {
        version: "1.12.1",
        widgetEventPrefix: "slide",
        options: {
          animate: !1,
          classes: {
            "ui-slider": "ui-corner-all",
            "ui-slider-handle": "ui-corner-all",
            "ui-slider-range": "ui-corner-all ui-widget-header",
          },
          distance: 0,
          max: 100,
          min: 0,
          orientation: "horizontal",
          range: !1,
          step: 1,
          value: 0,
          values: null,
          change: null,
          slide: null,
          start: null,
          stop: null,
        },
        numPages: 5,
        _create: function () {
          (this._keySliding = !1),
            (this._mouseSliding = !1),
            (this._animateOff = !0),
            (this._handleIndex = null),
            this._detectOrientation(),
            this._mouseInit(),
            this._calculateNewMax(),
            this._addClass(
              "ui-slider ui-slider-" + this.orientation,
              "ui-widget ui-widget-content"
            ),
            this._refresh(),
            (this._animateOff = !1);
        },
        _refresh: function () {
          this._createRange(),
            this._createHandles(),
            this._setupEvents(),
            this._refreshValue();
        },
        _createHandles: function () {
          var e,
            i,
            n = this.options,
            s = this.element.find(".ui-slider-handle"),
            o = [];
          for (
            i = (n.values && n.values.length) || 1,
              s.length > i && (s.slice(i).remove(), (s = s.slice(0, i))),
              e = s.length;
            e < i;
            e++
          )
            o.push("<span tabindex='0'></span>");
          (this.handles = s.add(t(o.join("")).appendTo(this.element))),
            this._addClass(
              this.handles,
              "ui-slider-handle",
              "ui-state-default"
            ),
            (this.handle = this.handles.eq(0)),
            this.handles.each(function (e) {
              t(this).data("ui-slider-handle-index", e).attr("tabIndex", 0);
            });
        },
        _createRange: function () {
          var e = this.options;
          e.range
            ? (!0 === e.range &&
                (e.values
                  ? e.values.length && 2 !== e.values.length
                    ? (e.values = [e.values[0], e.values[0]])
                    : t.isArray(e.values) && (e.values = e.values.slice(0))
                  : (e.values = [this._valueMin(), this._valueMin()])),
              this.range && this.range.length
                ? (this._removeClass(
                    this.range,
                    "ui-slider-range-min ui-slider-range-max"
                  ),
                  this.range.css({ left: "", bottom: "" }))
                : ((this.range = t("<div>").appendTo(this.element)),
                  this._addClass(this.range, "ui-slider-range")),
              ("min" !== e.range && "max" !== e.range) ||
                this._addClass(this.range, "ui-slider-range-" + e.range))
            : (this.range && this.range.remove(), (this.range = null));
        },
        _setupEvents: function () {
          this._off(this.handles),
            this._on(this.handles, this._handleEvents),
            this._hoverable(this.handles),
            this._focusable(this.handles);
        },
        _destroy: function () {
          this.handles.remove(),
            this.range && this.range.remove(),
            this._mouseDestroy();
        },
        _mouseCapture: function (e) {
          var i,
            n,
            s,
            o,
            r,
            a,
            l,
            h = this,
            c = this.options;
          return (
            !c.disabled &&
            ((this.elementSize = {
              width: this.element.outerWidth(),
              height: this.element.outerHeight(),
            }),
            (this.elementOffset = this.element.offset()),
            (i = { x: e.pageX, y: e.pageY }),
            (n = this._normValueFromMouse(i)),
            (s = this._valueMax() - this._valueMin() + 1),
            this.handles.each(function (e) {
              var i = Math.abs(n - h.values(e));
              (s > i ||
                (s === i &&
                  (e === h._lastChangedValue || h.values(e) === c.min))) &&
                ((s = i), (o = t(this)), (r = e));
            }),
            !1 !== this._start(e, r) &&
              ((this._mouseSliding = !0),
              (this._handleIndex = r),
              this._addClass(o, null, "ui-state-active"),
              o.trigger("focus"),
              (a = o.offset()),
              (l = !t(e.target).parents().addBack().is(".ui-slider-handle")),
              (this._clickOffset = l
                ? { left: 0, top: 0 }
                : {
                    left: e.pageX - a.left - o.width() / 2,
                    top:
                      e.pageY -
                      a.top -
                      o.height() / 2 -
                      (parseInt(o.css("borderTopWidth"), 10) || 0) -
                      (parseInt(o.css("borderBottomWidth"), 10) || 0) +
                      (parseInt(o.css("marginTop"), 10) || 0),
                  }),
              this.handles.hasClass("ui-state-hover") || this._slide(e, r, n),
              (this._animateOff = !0),
              !0))
          );
        },
        _mouseStart: function () {
          return !0;
        },
        _mouseDrag: function (t) {
          var e = { x: t.pageX, y: t.pageY },
            i = this._normValueFromMouse(e);
          return this._slide(t, this._handleIndex, i), !1;
        },
        _mouseStop: function (t) {
          return (
            this._removeClass(this.handles, null, "ui-state-active"),
            (this._mouseSliding = !1),
            this._stop(t, this._handleIndex),
            this._change(t, this._handleIndex),
            (this._handleIndex = null),
            (this._clickOffset = null),
            (this._animateOff = !1),
            !1
          );
        },
        _detectOrientation: function () {
          this.orientation =
            "vertical" === this.options.orientation ? "vertical" : "horizontal";
        },
        _normValueFromMouse: function (t) {
          var e, i, n, s, o;
          return (
            "horizontal" === this.orientation
              ? ((e = this.elementSize.width),
                (i =
                  t.x -
                  this.elementOffset.left -
                  (this._clickOffset ? this._clickOffset.left : 0)))
              : ((e = this.elementSize.height),
                (i =
                  t.y -
                  this.elementOffset.top -
                  (this._clickOffset ? this._clickOffset.top : 0))),
            (n = i / e) > 1 && (n = 1),
            n < 0 && (n = 0),
            "vertical" === this.orientation && (n = 1 - n),
            (s = this._valueMax() - this._valueMin()),
            (o = this._valueMin() + n * s),
            this._trimAlignValue(o)
          );
        },
        _uiHash: function (t, e, i) {
          var n = {
            handle: this.handles[t],
            handleIndex: t,
            value: void 0 !== e ? e : this.value(),
          };
          return (
            this._hasMultipleValues() &&
              ((n.value = void 0 !== e ? e : this.values(t)),
              (n.values = i || this.values())),
            n
          );
        },
        _hasMultipleValues: function () {
          return this.options.values && this.options.values.length;
        },
        _start: function (t, e) {
          return this._trigger("start", t, this._uiHash(e));
        },
        _slide: function (t, e, i) {
          var n,
            s = this.value(),
            o = this.values();
          this._hasMultipleValues() &&
            ((n = this.values(e ? 0 : 1)),
            (s = this.values(e)),
            2 === this.options.values.length &&
              !0 === this.options.range &&
              (i = 0 === e ? Math.min(n, i) : Math.max(n, i)),
            (o[e] = i)),
            i !== s &&
              !1 !== this._trigger("slide", t, this._uiHash(e, i, o)) &&
              (this._hasMultipleValues() ? this.values(e, i) : this.value(i));
        },
        _stop: function (t, e) {
          this._trigger("stop", t, this._uiHash(e));
        },
        _change: function (t, e) {
          this._keySliding ||
            this._mouseSliding ||
            ((this._lastChangedValue = e),
            this._trigger("change", t, this._uiHash(e)));
        },
        value: function (t) {
          return arguments.length
            ? ((this.options.value = this._trimAlignValue(t)),
              this._refreshValue(),
              void this._change(null, 0))
            : this._value();
        },
        values: function (e, i) {
          var n, s, o;
          if (arguments.length > 1)
            return (
              (this.options.values[e] = this._trimAlignValue(i)),
              this._refreshValue(),
              void this._change(null, e)
            );
          if (!arguments.length) return this._values();
          if (!t.isArray(arguments[0]))
            return this._hasMultipleValues() ? this._values(e) : this.value();
          for (
            n = this.options.values, s = arguments[0], o = 0;
            o < n.length;
            o += 1
          )
            (n[o] = this._trimAlignValue(s[o])), this._change(null, o);
          this._refreshValue();
        },
        _setOption: function (e, i) {
          var n,
            s = 0;
          switch (
            ("range" === e &&
              !0 === this.options.range &&
              ("min" === i
                ? ((this.options.value = this._values(0)),
                  (this.options.values = null))
                : "max" === i &&
                  ((this.options.value = this._values(
                    this.options.values.length - 1
                  )),
                  (this.options.values = null))),
            t.isArray(this.options.values) && (s = this.options.values.length),
            this._super(e, i),
            e)
          ) {
            case "orientation":
              this._detectOrientation(),
                this._removeClass(
                  "ui-slider-horizontal ui-slider-vertical"
                )._addClass("ui-slider-" + this.orientation),
                this._refreshValue(),
                this.options.range && this._refreshRange(i),
                this.handles.css("horizontal" === i ? "bottom" : "left", "");
              break;
            case "value":
              (this._animateOff = !0),
                this._refreshValue(),
                this._change(null, 0),
                (this._animateOff = !1);
              break;
            case "values":
              for (
                this._animateOff = !0, this._refreshValue(), n = s - 1;
                n >= 0;
                n--
              )
                this._change(null, n);
              this._animateOff = !1;
              break;
            case "step":
            case "min":
            case "max":
              (this._animateOff = !0),
                this._calculateNewMax(),
                this._refreshValue(),
                (this._animateOff = !1);
              break;
            case "range":
              (this._animateOff = !0), this._refresh(), (this._animateOff = !1);
          }
        },
        _setOptionDisabled: function (t) {
          this._super(t), this._toggleClass(null, "ui-state-disabled", !!t);
        },
        _value: function () {
          var t = this.options.value;
          return (t = this._trimAlignValue(t));
        },
        _values: function (t) {
          var e, i, n;
          if (arguments.length)
            return (e = this.options.values[t]), (e = this._trimAlignValue(e));
          if (this._hasMultipleValues()) {
            for (i = this.options.values.slice(), n = 0; n < i.length; n += 1)
              i[n] = this._trimAlignValue(i[n]);
            return i;
          }
          return [];
        },
        _trimAlignValue: function (t) {
          if (t <= this._valueMin()) return this._valueMin();
          if (t >= this._valueMax()) return this._valueMax();
          var e = this.options.step > 0 ? this.options.step : 1,
            i = (t - this._valueMin()) % e,
            n = t - i;
          return (
            2 * Math.abs(i) >= e && (n += i > 0 ? e : -e),
            parseFloat(n.toFixed(5))
          );
        },
        _calculateNewMax: function () {
          var t = this.options.max,
            e = this._valueMin(),
            i = this.options.step;
          (t = Math.round((t - e) / i) * i + e) > this.options.max && (t -= i),
            (this.max = parseFloat(t.toFixed(this._precision())));
        },
        _precision: function () {
          var t = this._precisionOf(this.options.step);
          return (
            null !== this.options.min &&
              (t = Math.max(t, this._precisionOf(this.options.min))),
            t
          );
        },
        _precisionOf: function (t) {
          var e = t.toString(),
            i = e.indexOf(".");
          return -1 === i ? 0 : e.length - i - 1;
        },
        _valueMin: function () {
          return this.options.min;
        },
        _valueMax: function () {
          return this.max;
        },
        _refreshRange: function (t) {
          "vertical" === t && this.range.css({ width: "", left: "" }),
            "horizontal" === t && this.range.css({ height: "", bottom: "" });
        },
        _refreshValue: function () {
          var e,
            i,
            n,
            s,
            o,
            r = this.options.range,
            a = this.options,
            l = this,
            h = !this._animateOff && a.animate,
            c = {};
          this._hasMultipleValues()
            ? this.handles.each(function (n) {
                (i =
                  ((l.values(n) - l._valueMin()) /
                    (l._valueMax() - l._valueMin())) *
                  100),
                  (c["horizontal" === l.orientation ? "left" : "bottom"] =
                    i + "%"),
                  t(this).stop(1, 1)[h ? "animate" : "css"](c, a.animate),
                  !0 === l.options.range &&
                    ("horizontal" === l.orientation
                      ? (0 === n &&
                          l.range
                            .stop(1, 1)
                            [h ? "animate" : "css"](
                              { left: i + "%" },
                              a.animate
                            ),
                        1 === n &&
                          l.range[h ? "animate" : "css"](
                            { width: i - e + "%" },
                            { queue: !1, duration: a.animate }
                          ))
                      : (0 === n &&
                          l.range
                            .stop(1, 1)
                            [h ? "animate" : "css"](
                              { bottom: i + "%" },
                              a.animate
                            ),
                        1 === n &&
                          l.range[h ? "animate" : "css"](
                            { height: i - e + "%" },
                            { queue: !1, duration: a.animate }
                          ))),
                  (e = i);
              })
            : ((n = this.value()),
              (s = this._valueMin()),
              (o = this._valueMax()),
              (i = o !== s ? ((n - s) / (o - s)) * 100 : 0),
              (c["horizontal" === this.orientation ? "left" : "bottom"] =
                i + "%"),
              this.handle.stop(1, 1)[h ? "animate" : "css"](c, a.animate),
              "min" === r &&
                "horizontal" === this.orientation &&
                this.range
                  .stop(1, 1)
                  [h ? "animate" : "css"]({ width: i + "%" }, a.animate),
              "max" === r &&
                "horizontal" === this.orientation &&
                this.range
                  .stop(1, 1)
                  [h ? "animate" : "css"]({ width: 100 - i + "%" }, a.animate),
              "min" === r &&
                "vertical" === this.orientation &&
                this.range
                  .stop(1, 1)
                  [h ? "animate" : "css"]({ height: i + "%" }, a.animate),
              "max" === r &&
                "vertical" === this.orientation &&
                this.range
                  .stop(1, 1)
                  [h ? "animate" : "css"](
                    { height: 100 - i + "%" },
                    a.animate
                  ));
        },
        _handleEvents: {
          keydown: function (e) {
            var i,
              n,
              s,
              o = t(e.target).data("ui-slider-handle-index");
            switch (e.keyCode) {
              case t.ui.keyCode.HOME:
              case t.ui.keyCode.END:
              case t.ui.keyCode.PAGE_UP:
              case t.ui.keyCode.PAGE_DOWN:
              case t.ui.keyCode.UP:
              case t.ui.keyCode.RIGHT:
              case t.ui.keyCode.DOWN:
              case t.ui.keyCode.LEFT:
                if (
                  (e.preventDefault(),
                  !this._keySliding &&
                    ((this._keySliding = !0),
                    this._addClass(t(e.target), null, "ui-state-active"),
                    !1 === this._start(e, o)))
                )
                  return;
            }
            switch (
              ((s = this.options.step),
              (i = n =
                this._hasMultipleValues() ? this.values(o) : this.value()),
              e.keyCode)
            ) {
              case t.ui.keyCode.HOME:
                n = this._valueMin();
                break;
              case t.ui.keyCode.END:
                n = this._valueMax();
                break;
              case t.ui.keyCode.PAGE_UP:
                n = this._trimAlignValue(
                  i + (this._valueMax() - this._valueMin()) / this.numPages
                );
                break;
              case t.ui.keyCode.PAGE_DOWN:
                n = this._trimAlignValue(
                  i - (this._valueMax() - this._valueMin()) / this.numPages
                );
                break;
              case t.ui.keyCode.UP:
              case t.ui.keyCode.RIGHT:
                if (i === this._valueMax()) return;
                n = this._trimAlignValue(i + s);
                break;
              case t.ui.keyCode.DOWN:
              case t.ui.keyCode.LEFT:
                if (i === this._valueMin()) return;
                n = this._trimAlignValue(i - s);
            }
            this._slide(e, o, n);
          },
          keyup: function (e) {
            var i = t(e.target).data("ui-slider-handle-index");
            this._keySliding &&
              ((this._keySliding = !1),
              this._stop(e, i),
              this._change(e, i),
              this._removeClass(t(e.target), null, "ui-state-active"));
          },
        },
      }),
      t.widget("ui.sortable", t.ui.mouse, {
        version: "1.12.1",
        widgetEventPrefix: "sort",
        ready: !1,
        options: {
          appendTo: "parent",
          axis: !1,
          connectWith: !1,
          containment: !1,
          cursor: "auto",
          cursorAt: !1,
          dropOnEmpty: !0,
          forcePlaceholderSize: !1,
          forceHelperSize: !1,
          grid: !1,
          handle: !1,
          helper: "original",
          items: "> *",
          opacity: !1,
          placeholder: !1,
          revert: !1,
          scroll: !0,
          scrollSensitivity: 20,
          scrollSpeed: 20,
          scope: "default",
          tolerance: "intersect",
          zIndex: 1e3,
          activate: null,
          beforeStop: null,
          change: null,
          deactivate: null,
          out: null,
          over: null,
          receive: null,
          remove: null,
          sort: null,
          start: null,
          stop: null,
          update: null,
        },
        _isOverAxis: function (t, e, i) {
          return t >= e && t < e + i;
        },
        _isFloating: function (t) {
          return (
            /left|right/.test(t.css("float")) ||
            /inline|table-cell/.test(t.css("display"))
          );
        },
        _create: function () {
          (this.containerCache = {}),
            this._addClass("ui-sortable"),
            this.refresh(),
            (this.offset = this.element.offset()),
            this._mouseInit(),
            this._setHandleClassName(),
            (this.ready = !0);
        },
        _setOption: function (t, e) {
          this._super(t, e), "handle" === t && this._setHandleClassName();
        },
        _setHandleClassName: function () {
          var e = this;
          this._removeClass(
            this.element.find(".ui-sortable-handle"),
            "ui-sortable-handle"
          ),
            t.each(this.items, function () {
              e._addClass(
                this.instance.options.handle
                  ? this.item.find(this.instance.options.handle)
                  : this.item,
                "ui-sortable-handle"
              );
            });
        },
        _destroy: function () {
          this._mouseDestroy();
          for (var t = this.items.length - 1; t >= 0; t--)
            this.items[t].item.removeData(this.widgetName + "-item");
          return this;
        },
        _mouseCapture: function (e, i) {
          var n = null,
            s = !1,
            o = this;
          return (
            !this.reverting &&
            !this.options.disabled &&
            "static" !== this.options.type &&
            (this._refreshItems(e),
            t(e.target)
              .parents()
              .each(function () {
                if (t.data(this, o.widgetName + "-item") === o)
                  return (n = t(this)), !1;
              }),
            t.data(e.target, o.widgetName + "-item") === o && (n = t(e.target)),
            !!n &&
              !(
                this.options.handle &&
                !i &&
                (t(this.options.handle, n)
                  .find("*")
                  .addBack()
                  .each(function () {
                    this === e.target && (s = !0);
                  }),
                !s)
              ) &&
              ((this.currentItem = n), this._removeCurrentsFromItems(), !0))
          );
        },
        _mouseStart: function (e, i, n) {
          var s,
            o,
            r = this.options;
          if (
            ((this.currentContainer = this),
            this.refreshPositions(),
            (this.helper = this._createHelper(e)),
            this._cacheHelperProportions(),
            this._cacheMargins(),
            (this.scrollParent = this.helper.scrollParent()),
            (this.offset = this.currentItem.offset()),
            (this.offset = {
              top: this.offset.top - this.margins.top,
              left: this.offset.left - this.margins.left,
            }),
            t.extend(this.offset, {
              click: {
                left: e.pageX - this.offset.left,
                top: e.pageY - this.offset.top,
              },
              parent: this._getParentOffset(),
              relative: this._getRelativeOffset(),
            }),
            this.helper.css("position", "absolute"),
            (this.cssPosition = this.helper.css("position")),
            (this.originalPosition = this._generatePosition(e)),
            (this.originalPageX = e.pageX),
            (this.originalPageY = e.pageY),
            r.cursorAt && this._adjustOffsetFromHelper(r.cursorAt),
            (this.domPosition = {
              prev: this.currentItem.prev()[0],
              parent: this.currentItem.parent()[0],
            }),
            this.helper[0] !== this.currentItem[0] && this.currentItem.hide(),
            this._createPlaceholder(),
            r.containment && this._setContainment(),
            r.cursor &&
              "auto" !== r.cursor &&
              ((o = this.document.find("body")),
              (this.storedCursor = o.css("cursor")),
              o.css("cursor", r.cursor),
              (this.storedStylesheet = t(
                "<style>*{ cursor: " + r.cursor + " !important; }</style>"
              ).appendTo(o))),
            r.opacity &&
              (this.helper.css("opacity") &&
                (this._storedOpacity = this.helper.css("opacity")),
              this.helper.css("opacity", r.opacity)),
            r.zIndex &&
              (this.helper.css("zIndex") &&
                (this._storedZIndex = this.helper.css("zIndex")),
              this.helper.css("zIndex", r.zIndex)),
            this.scrollParent[0] !== this.document[0] &&
              "HTML" !== this.scrollParent[0].tagName &&
              (this.overflowOffset = this.scrollParent.offset()),
            this._trigger("start", e, this._uiHash()),
            this._preserveHelperProportions || this._cacheHelperProportions(),
            !n)
          )
            for (s = this.containers.length - 1; s >= 0; s--)
              this.containers[s]._trigger("activate", e, this._uiHash(this));
          return (
            t.ui.ddmanager && (t.ui.ddmanager.current = this),
            t.ui.ddmanager &&
              !r.dropBehaviour &&
              t.ui.ddmanager.prepareOffsets(this, e),
            (this.dragging = !0),
            this._addClass(this.helper, "ui-sortable-helper"),
            this._mouseDrag(e),
            !0
          );
        },
        _mouseDrag: function (e) {
          var i,
            n,
            s,
            o,
            r = this.options,
            a = !1;
          for (
            this.position = this._generatePosition(e),
              this.positionAbs = this._convertPositionTo("absolute"),
              this.lastPositionAbs || (this.lastPositionAbs = this.positionAbs),
              this.options.scroll &&
                (this.scrollParent[0] !== this.document[0] &&
                "HTML" !== this.scrollParent[0].tagName
                  ? (this.overflowOffset.top +
                      this.scrollParent[0].offsetHeight -
                      e.pageY <
                    r.scrollSensitivity
                      ? (this.scrollParent[0].scrollTop = a =
                          this.scrollParent[0].scrollTop + r.scrollSpeed)
                      : e.pageY - this.overflowOffset.top <
                          r.scrollSensitivity &&
                        (this.scrollParent[0].scrollTop = a =
                          this.scrollParent[0].scrollTop - r.scrollSpeed),
                    this.overflowOffset.left +
                      this.scrollParent[0].offsetWidth -
                      e.pageX <
                    r.scrollSensitivity
                      ? (this.scrollParent[0].scrollLeft = a =
                          this.scrollParent[0].scrollLeft + r.scrollSpeed)
                      : e.pageX - this.overflowOffset.left <
                          r.scrollSensitivity &&
                        (this.scrollParent[0].scrollLeft = a =
                          this.scrollParent[0].scrollLeft - r.scrollSpeed))
                  : (e.pageY - this.document.scrollTop() < r.scrollSensitivity
                      ? (a = this.document.scrollTop(
                          this.document.scrollTop() - r.scrollSpeed
                        ))
                      : this.window.height() -
                          (e.pageY - this.document.scrollTop()) <
                          r.scrollSensitivity &&
                        (a = this.document.scrollTop(
                          this.document.scrollTop() + r.scrollSpeed
                        )),
                    e.pageX - this.document.scrollLeft() < r.scrollSensitivity
                      ? (a = this.document.scrollLeft(
                          this.document.scrollLeft() - r.scrollSpeed
                        ))
                      : this.window.width() -
                          (e.pageX - this.document.scrollLeft()) <
                          r.scrollSensitivity &&
                        (a = this.document.scrollLeft(
                          this.document.scrollLeft() + r.scrollSpeed
                        ))),
                !1 !== a &&
                  t.ui.ddmanager &&
                  !r.dropBehaviour &&
                  t.ui.ddmanager.prepareOffsets(this, e)),
              this.positionAbs = this._convertPositionTo("absolute"),
              (this.options.axis && "y" === this.options.axis) ||
                (this.helper[0].style.left = this.position.left + "px"),
              (this.options.axis && "x" === this.options.axis) ||
                (this.helper[0].style.top = this.position.top + "px"),
              i = this.items.length - 1;
            i >= 0;
            i--
          )
            if (
              ((s = (n = this.items[i]).item[0]),
              (o = this._intersectsWithPointer(n)) &&
                n.instance === this.currentContainer &&
                !(
                  s === this.currentItem[0] ||
                  this.placeholder[1 === o ? "next" : "prev"]()[0] === s ||
                  t.contains(this.placeholder[0], s) ||
                  ("semi-dynamic" === this.options.type &&
                    t.contains(this.element[0], s))
                ))
            ) {
              if (
                ((this.direction = 1 === o ? "down" : "up"),
                "pointer" !== this.options.tolerance &&
                  !this._intersectsWithSides(n))
              )
                break;
              this._rearrange(e, n), this._trigger("change", e, this._uiHash());
              break;
            }
          return (
            this._contactContainers(e),
            t.ui.ddmanager && t.ui.ddmanager.drag(this, e),
            this._trigger("sort", e, this._uiHash()),
            (this.lastPositionAbs = this.positionAbs),
            !1
          );
        },
        _mouseStop: function (e, i) {
          if (e) {
            if (
              (t.ui.ddmanager &&
                !this.options.dropBehaviour &&
                t.ui.ddmanager.drop(this, e),
              this.options.revert)
            ) {
              var n = this,
                s = this.placeholder.offset(),
                o = this.options.axis,
                r = {};
              (o && "x" !== o) ||
                (r.left =
                  s.left -
                  this.offset.parent.left -
                  this.margins.left +
                  (this.offsetParent[0] === this.document[0].body
                    ? 0
                    : this.offsetParent[0].scrollLeft)),
                (o && "y" !== o) ||
                  (r.top =
                    s.top -
                    this.offset.parent.top -
                    this.margins.top +
                    (this.offsetParent[0] === this.document[0].body
                      ? 0
                      : this.offsetParent[0].scrollTop)),
                (this.reverting = !0),
                t(this.helper).animate(
                  r,
                  parseInt(this.options.revert, 10) || 500,
                  function () {
                    n._clear(e);
                  }
                );
            } else this._clear(e, i);
            return !1;
          }
        },
        cancel: function () {
          if (this.dragging) {
            this._mouseUp(new t.Event("mouseup", { target: null })),
              "original" === this.options.helper
                ? (this.currentItem.css(this._storedCSS),
                  this._removeClass(this.currentItem, "ui-sortable-helper"))
                : this.currentItem.show();
            for (var e = this.containers.length - 1; e >= 0; e--)
              this.containers[e]._trigger(
                "deactivate",
                null,
                this._uiHash(this)
              ),
                this.containers[e].containerCache.over &&
                  (this.containers[e]._trigger("out", null, this._uiHash(this)),
                  (this.containers[e].containerCache.over = 0));
          }
          return (
            this.placeholder &&
              (this.placeholder[0].parentNode &&
                this.placeholder[0].parentNode.removeChild(this.placeholder[0]),
              "original" !== this.options.helper &&
                this.helper &&
                this.helper[0].parentNode &&
                this.helper.remove(),
              t.extend(this, {
                helper: null,
                dragging: !1,
                reverting: !1,
                _noFinalSort: null,
              }),
              this.domPosition.prev
                ? t(this.domPosition.prev).after(this.currentItem)
                : t(this.domPosition.parent).prepend(this.currentItem)),
            this
          );
        },
        serialize: function (e) {
          var i = this._getItemsAsjQuery(e && e.connected),
            n = [];
          return (
            (e = e || {}),
            t(i).each(function () {
              var i = (t(e.item || this).attr(e.attribute || "id") || "").match(
                e.expression || /(.+)[\-=_](.+)/
              );
              i &&
                n.push(
                  (e.key || i[1] + "[]") +
                    "=" +
                    (e.key && e.expression ? i[1] : i[2])
                );
            }),
            !n.length && e.key && n.push(e.key + "="),
            n.join("&")
          );
        },
        toArray: function (e) {
          var i = this._getItemsAsjQuery(e && e.connected),
            n = [];
          return (
            (e = e || {}),
            i.each(function () {
              n.push(t(e.item || this).attr(e.attribute || "id") || "");
            }),
            n
          );
        },
        _intersectsWith: function (t) {
          var e = this.positionAbs.left,
            i = e + this.helperProportions.width,
            n = this.positionAbs.top,
            s = n + this.helperProportions.height,
            o = t.left,
            r = o + t.width,
            a = t.top,
            l = a + t.height,
            h = this.offset.click.top,
            c = this.offset.click.left,
            u = "x" === this.options.axis || (n + h > a && n + h < l),
            d = "y" === this.options.axis || (e + c > o && e + c < r),
            p = u && d;
          return "pointer" === this.options.tolerance ||
            this.options.forcePointerForContainers ||
            ("pointer" !== this.options.tolerance &&
              this.helperProportions[this.floating ? "width" : "height"] >
                t[this.floating ? "width" : "height"])
            ? p
            : o < e + this.helperProportions.width / 2 &&
                i - this.helperProportions.width / 2 < r &&
                a < n + this.helperProportions.height / 2 &&
                s - this.helperProportions.height / 2 < l;
        },
        _intersectsWithPointer: function (t) {
          var e,
            i,
            n =
              "x" === this.options.axis ||
              this._isOverAxis(
                this.positionAbs.top + this.offset.click.top,
                t.top,
                t.height
              ),
            s =
              "y" === this.options.axis ||
              this._isOverAxis(
                this.positionAbs.left + this.offset.click.left,
                t.left,
                t.width
              );
          return (
            !(!n || !s) &&
            ((e = this._getDragVerticalDirection()),
            (i = this._getDragHorizontalDirection()),
            this.floating
              ? "right" === i || "down" === e
                ? 2
                : 1
              : e && ("down" === e ? 2 : 1))
          );
        },
        _intersectsWithSides: function (t) {
          var e = this._isOverAxis(
              this.positionAbs.top + this.offset.click.top,
              t.top + t.height / 2,
              t.height
            ),
            i = this._isOverAxis(
              this.positionAbs.left + this.offset.click.left,
              t.left + t.width / 2,
              t.width
            ),
            n = this._getDragVerticalDirection(),
            s = this._getDragHorizontalDirection();
          return this.floating && s
            ? ("right" === s && i) || ("left" === s && !i)
            : n && (("down" === n && e) || ("up" === n && !e));
        },
        _getDragVerticalDirection: function () {
          var t = this.positionAbs.top - this.lastPositionAbs.top;
          return 0 !== t && (t > 0 ? "down" : "up");
        },
        _getDragHorizontalDirection: function () {
          var t = this.positionAbs.left - this.lastPositionAbs.left;
          return 0 !== t && (t > 0 ? "right" : "left");
        },
        refresh: function (t) {
          return (
            this._refreshItems(t),
            this._setHandleClassName(),
            this.refreshPositions(),
            this
          );
        },
        _connectWith: function () {
          var t = this.options;
          return t.connectWith.constructor === String
            ? [t.connectWith]
            : t.connectWith;
        },
        _getItemsAsjQuery: function (e) {
          var i,
            n,
            s,
            o,
            r = [],
            a = [],
            l = this._connectWith();
          if (l && e)
            for (i = l.length - 1; i >= 0; i--)
              for (n = (s = t(l[i], this.document[0])).length - 1; n >= 0; n--)
                (o = t.data(s[n], this.widgetFullName)) &&
                  o !== this &&
                  !o.options.disabled &&
                  a.push([
                    t.isFunction(o.options.items)
                      ? o.options.items.call(o.element)
                      : t(o.options.items, o.element)
                          .not(".ui-sortable-helper")
                          .not(".ui-sortable-placeholder"),
                    o,
                  ]);
          function h() {
            r.push(this);
          }
          for (
            a.push([
              t.isFunction(this.options.items)
                ? this.options.items.call(this.element, null, {
                    options: this.options,
                    item: this.currentItem,
                  })
                : t(this.options.items, this.element)
                    .not(".ui-sortable-helper")
                    .not(".ui-sortable-placeholder"),
              this,
            ]),
              i = a.length - 1;
            i >= 0;
            i--
          )
            a[i][0].each(h);
          return t(r);
        },
        _removeCurrentsFromItems: function () {
          var e = this.currentItem.find(":data(" + this.widgetName + "-item)");
          this.items = t.grep(this.items, function (t) {
            for (var i = 0; i < e.length; i++)
              if (e[i] === t.item[0]) return !1;
            return !0;
          });
        },
        _refreshItems: function (e) {
          (this.items = []), (this.containers = [this]);
          var i,
            n,
            s,
            o,
            r,
            a,
            l,
            h,
            c = this.items,
            u = [
              [
                t.isFunction(this.options.items)
                  ? this.options.items.call(this.element[0], e, {
                      item: this.currentItem,
                    })
                  : t(this.options.items, this.element),
                this,
              ],
            ],
            d = this._connectWith();
          if (d && this.ready)
            for (i = d.length - 1; i >= 0; i--)
              for (n = (s = t(d[i], this.document[0])).length - 1; n >= 0; n--)
                (o = t.data(s[n], this.widgetFullName)) &&
                  o !== this &&
                  !o.options.disabled &&
                  (u.push([
                    t.isFunction(o.options.items)
                      ? o.options.items.call(o.element[0], e, {
                          item: this.currentItem,
                        })
                      : t(o.options.items, o.element),
                    o,
                  ]),
                  this.containers.push(o));
          for (i = u.length - 1; i >= 0; i--)
            for (r = u[i][1], n = 0, h = (a = u[i][0]).length; n < h; n++)
              (l = t(a[n])).data(this.widgetName + "-item", r),
                c.push({
                  item: l,
                  instance: r,
                  width: 0,
                  height: 0,
                  left: 0,
                  top: 0,
                });
        },
        refreshPositions: function (e) {
          var i, n, s, o;
          for (
            this.floating =
              !!this.items.length &&
              ("x" === this.options.axis ||
                this._isFloating(this.items[0].item)),
              this.offsetParent &&
                this.helper &&
                (this.offset.parent = this._getParentOffset()),
              i = this.items.length - 1;
            i >= 0;
            i--
          )
            ((n = this.items[i]).instance !== this.currentContainer &&
              this.currentContainer &&
              n.item[0] !== this.currentItem[0]) ||
              ((s = this.options.toleranceElement
                ? t(this.options.toleranceElement, n.item)
                : n.item),
              e || ((n.width = s.outerWidth()), (n.height = s.outerHeight())),
              (o = s.offset()),
              (n.left = o.left),
              (n.top = o.top));
          if (this.options.custom && this.options.custom.refreshContainers)
            this.options.custom.refreshContainers.call(this);
          else
            for (i = this.containers.length - 1; i >= 0; i--)
              (o = this.containers[i].element.offset()),
                (this.containers[i].containerCache.left = o.left),
                (this.containers[i].containerCache.top = o.top),
                (this.containers[i].containerCache.width =
                  this.containers[i].element.outerWidth()),
                (this.containers[i].containerCache.height =
                  this.containers[i].element.outerHeight());
          return this;
        },
        _createPlaceholder: function (e) {
          var i,
            n = (e = e || this).options;
          (n.placeholder && n.placeholder.constructor !== String) ||
            ((i = n.placeholder),
            (n.placeholder = {
              element: function () {
                var n = e.currentItem[0].nodeName.toLowerCase(),
                  s = t("<" + n + ">", e.document[0]);
                return (
                  e
                    ._addClass(
                      s,
                      "ui-sortable-placeholder",
                      i || e.currentItem[0].className
                    )
                    ._removeClass(s, "ui-sortable-helper"),
                  "tbody" === n
                    ? e._createTrPlaceholder(
                        e.currentItem.find("tr").eq(0),
                        t("<tr>", e.document[0]).appendTo(s)
                      )
                    : "tr" === n
                    ? e._createTrPlaceholder(e.currentItem, s)
                    : "img" === n && s.attr("src", e.currentItem.attr("src")),
                  i || s.css("visibility", "hidden"),
                  s
                );
              },
              update: function (t, s) {
                (i && !n.forcePlaceholderSize) ||
                  (s.height() ||
                    s.height(
                      e.currentItem.innerHeight() -
                        parseInt(e.currentItem.css("paddingTop") || 0, 10) -
                        parseInt(e.currentItem.css("paddingBottom") || 0, 10)
                    ),
                  s.width() ||
                    s.width(
                      e.currentItem.innerWidth() -
                        parseInt(e.currentItem.css("paddingLeft") || 0, 10) -
                        parseInt(e.currentItem.css("paddingRight") || 0, 10)
                    ));
              },
            })),
            (e.placeholder = t(
              n.placeholder.element.call(e.element, e.currentItem)
            )),
            e.currentItem.after(e.placeholder),
            n.placeholder.update(e, e.placeholder);
        },
        _createTrPlaceholder: function (e, i) {
          var n = this;
          e.children().each(function () {
            t("<td>&#160;</td>", n.document[0])
              .attr("colspan", t(this).attr("colspan") || 1)
              .appendTo(i);
          });
        },
        _contactContainers: function (e) {
          var i,
            n,
            s,
            o,
            r,
            a,
            l,
            h,
            c,
            u,
            d = null,
            p = null;
          for (i = this.containers.length - 1; i >= 0; i--)
            if (!t.contains(this.currentItem[0], this.containers[i].element[0]))
              if (this._intersectsWith(this.containers[i].containerCache)) {
                if (
                  d &&
                  t.contains(this.containers[i].element[0], d.element[0])
                )
                  continue;
                (d = this.containers[i]), (p = i);
              } else
                this.containers[i].containerCache.over &&
                  (this.containers[i]._trigger("out", e, this._uiHash(this)),
                  (this.containers[i].containerCache.over = 0));
          if (d)
            if (1 === this.containers.length)
              this.containers[p].containerCache.over ||
                (this.containers[p]._trigger("over", e, this._uiHash(this)),
                (this.containers[p].containerCache.over = 1));
            else {
              for (
                s = 1e4,
                  o = null,
                  r = (c = d.floating || this._isFloating(this.currentItem))
                    ? "left"
                    : "top",
                  a = c ? "width" : "height",
                  u = c ? "pageX" : "pageY",
                  n = this.items.length - 1;
                n >= 0;
                n--
              )
                t.contains(
                  this.containers[p].element[0],
                  this.items[n].item[0]
                ) &&
                  this.items[n].item[0] !== this.currentItem[0] &&
                  ((l = this.items[n].item.offset()[r]),
                  (h = !1),
                  e[u] - l > this.items[n][a] / 2 && (h = !0),
                  Math.abs(e[u] - l) < s &&
                    ((s = Math.abs(e[u] - l)),
                    (o = this.items[n]),
                    (this.direction = h ? "up" : "down")));
              if (!o && !this.options.dropOnEmpty) return;
              if (this.currentContainer === this.containers[p])
                return void (
                  this.currentContainer.containerCache.over ||
                  (this.containers[p]._trigger("over", e, this._uiHash()),
                  (this.currentContainer.containerCache.over = 1))
                );
              o
                ? this._rearrange(e, o, null, !0)
                : this._rearrange(e, null, this.containers[p].element, !0),
                this._trigger("change", e, this._uiHash()),
                this.containers[p]._trigger("change", e, this._uiHash(this)),
                (this.currentContainer = this.containers[p]),
                this.options.placeholder.update(
                  this.currentContainer,
                  this.placeholder
                ),
                this.containers[p]._trigger("over", e, this._uiHash(this)),
                (this.containers[p].containerCache.over = 1);
            }
        },
        _createHelper: function (e) {
          var i = this.options,
            n = t.isFunction(i.helper)
              ? t(i.helper.apply(this.element[0], [e, this.currentItem]))
              : "clone" === i.helper
              ? this.currentItem.clone()
              : this.currentItem;
          return (
            n.parents("body").length ||
              t(
                "parent" !== i.appendTo
                  ? i.appendTo
                  : this.currentItem[0].parentNode
              )[0].appendChild(n[0]),
            n[0] === this.currentItem[0] &&
              (this._storedCSS = {
                width: this.currentItem[0].style.width,
                height: this.currentItem[0].style.height,
                position: this.currentItem.css("position"),
                top: this.currentItem.css("top"),
                left: this.currentItem.css("left"),
              }),
            (n[0].style.width && !i.forceHelperSize) ||
              n.width(this.currentItem.width()),
            (n[0].style.height && !i.forceHelperSize) ||
              n.height(this.currentItem.height()),
            n
          );
        },
        _adjustOffsetFromHelper: function (e) {
          "string" == typeof e && (e = e.split(" ")),
            t.isArray(e) && (e = { left: +e[0], top: +e[1] || 0 }),
            "left" in e &&
              (this.offset.click.left = e.left + this.margins.left),
            "right" in e &&
              (this.offset.click.left =
                this.helperProportions.width - e.right + this.margins.left),
            "top" in e && (this.offset.click.top = e.top + this.margins.top),
            "bottom" in e &&
              (this.offset.click.top =
                this.helperProportions.height - e.bottom + this.margins.top);
        },
        _getParentOffset: function () {
          this.offsetParent = this.helper.offsetParent();
          var e = this.offsetParent.offset();
          return (
            "absolute" === this.cssPosition &&
              this.scrollParent[0] !== this.document[0] &&
              t.contains(this.scrollParent[0], this.offsetParent[0]) &&
              ((e.left += this.scrollParent.scrollLeft()),
              (e.top += this.scrollParent.scrollTop())),
            (this.offsetParent[0] === this.document[0].body ||
              (this.offsetParent[0].tagName &&
                "html" === this.offsetParent[0].tagName.toLowerCase() &&
                t.ui.ie)) &&
              (e = { top: 0, left: 0 }),
            {
              top:
                e.top +
                (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0),
              left:
                e.left +
                (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0),
            }
          );
        },
        _getRelativeOffset: function () {
          if ("relative" === this.cssPosition) {
            var t = this.currentItem.position();
            return {
              top:
                t.top -
                (parseInt(this.helper.css("top"), 10) || 0) +
                this.scrollParent.scrollTop(),
              left:
                t.left -
                (parseInt(this.helper.css("left"), 10) || 0) +
                this.scrollParent.scrollLeft(),
            };
          }
          return { top: 0, left: 0 };
        },
        _cacheMargins: function () {
          this.margins = {
            left: parseInt(this.currentItem.css("marginLeft"), 10) || 0,
            top: parseInt(this.currentItem.css("marginTop"), 10) || 0,
          };
        },
        _cacheHelperProportions: function () {
          this.helperProportions = {
            width: this.helper.outerWidth(),
            height: this.helper.outerHeight(),
          };
        },
        _setContainment: function () {
          var e,
            i,
            n,
            s = this.options;
          "parent" === s.containment &&
            (s.containment = this.helper[0].parentNode),
            ("document" !== s.containment && "window" !== s.containment) ||
              (this.containment = [
                0 - this.offset.relative.left - this.offset.parent.left,
                0 - this.offset.relative.top - this.offset.parent.top,
                "document" === s.containment
                  ? this.document.width()
                  : this.window.width() -
                    this.helperProportions.width -
                    this.margins.left,
                ("document" === s.containment
                  ? this.document.height() ||
                    document.body.parentNode.scrollHeight
                  : this.window.height() ||
                    this.document[0].body.parentNode.scrollHeight) -
                  this.helperProportions.height -
                  this.margins.top,
              ]),
            /^(document|window|parent)$/.test(s.containment) ||
              ((e = t(s.containment)[0]),
              (i = t(s.containment).offset()),
              (n = "hidden" !== t(e).css("overflow")),
              (this.containment = [
                i.left +
                  (parseInt(t(e).css("borderLeftWidth"), 10) || 0) +
                  (parseInt(t(e).css("paddingLeft"), 10) || 0) -
                  this.margins.left,
                i.top +
                  (parseInt(t(e).css("borderTopWidth"), 10) || 0) +
                  (parseInt(t(e).css("paddingTop"), 10) || 0) -
                  this.margins.top,
                i.left +
                  (n ? Math.max(e.scrollWidth, e.offsetWidth) : e.offsetWidth) -
                  (parseInt(t(e).css("borderLeftWidth"), 10) || 0) -
                  (parseInt(t(e).css("paddingRight"), 10) || 0) -
                  this.helperProportions.width -
                  this.margins.left,
                i.top +
                  (n
                    ? Math.max(e.scrollHeight, e.offsetHeight)
                    : e.offsetHeight) -
                  (parseInt(t(e).css("borderTopWidth"), 10) || 0) -
                  (parseInt(t(e).css("paddingBottom"), 10) || 0) -
                  this.helperProportions.height -
                  this.margins.top,
              ]));
        },
        _convertPositionTo: function (e, i) {
          i || (i = this.position);
          var n = "absolute" === e ? 1 : -1,
            s =
              "absolute" !== this.cssPosition ||
              (this.scrollParent[0] !== this.document[0] &&
                t.contains(this.scrollParent[0], this.offsetParent[0]))
                ? this.scrollParent
                : this.offsetParent,
            o = /(html|body)/i.test(s[0].tagName);
          return {
            top:
              i.top +
              this.offset.relative.top * n +
              this.offset.parent.top * n -
              ("fixed" === this.cssPosition
                ? -this.scrollParent.scrollTop()
                : o
                ? 0
                : s.scrollTop()) *
                n,
            left:
              i.left +
              this.offset.relative.left * n +
              this.offset.parent.left * n -
              ("fixed" === this.cssPosition
                ? -this.scrollParent.scrollLeft()
                : o
                ? 0
                : s.scrollLeft()) *
                n,
          };
        },
        _generatePosition: function (e) {
          var i,
            n,
            s = this.options,
            o = e.pageX,
            r = e.pageY,
            a =
              "absolute" !== this.cssPosition ||
              (this.scrollParent[0] !== this.document[0] &&
                t.contains(this.scrollParent[0], this.offsetParent[0]))
                ? this.scrollParent
                : this.offsetParent,
            l = /(html|body)/i.test(a[0].tagName);
          return (
            "relative" !== this.cssPosition ||
              (this.scrollParent[0] !== this.document[0] &&
                this.scrollParent[0] !== this.offsetParent[0]) ||
              (this.offset.relative = this._getRelativeOffset()),
            this.originalPosition &&
              (this.containment &&
                (e.pageX - this.offset.click.left < this.containment[0] &&
                  (o = this.containment[0] + this.offset.click.left),
                e.pageY - this.offset.click.top < this.containment[1] &&
                  (r = this.containment[1] + this.offset.click.top),
                e.pageX - this.offset.click.left > this.containment[2] &&
                  (o = this.containment[2] + this.offset.click.left),
                e.pageY - this.offset.click.top > this.containment[3] &&
                  (r = this.containment[3] + this.offset.click.top)),
              s.grid &&
                ((i =
                  this.originalPageY +
                  Math.round((r - this.originalPageY) / s.grid[1]) * s.grid[1]),
                (r = this.containment
                  ? i - this.offset.click.top >= this.containment[1] &&
                    i - this.offset.click.top <= this.containment[3]
                    ? i
                    : i - this.offset.click.top >= this.containment[1]
                    ? i - s.grid[1]
                    : i + s.grid[1]
                  : i),
                (n =
                  this.originalPageX +
                  Math.round((o - this.originalPageX) / s.grid[0]) * s.grid[0]),
                (o = this.containment
                  ? n - this.offset.click.left >= this.containment[0] &&
                    n - this.offset.click.left <= this.containment[2]
                    ? n
                    : n - this.offset.click.left >= this.containment[0]
                    ? n - s.grid[0]
                    : n + s.grid[0]
                  : n))),
            {
              top:
                r -
                this.offset.click.top -
                this.offset.relative.top -
                this.offset.parent.top +
                ("fixed" === this.cssPosition
                  ? -this.scrollParent.scrollTop()
                  : l
                  ? 0
                  : a.scrollTop()),
              left:
                o -
                this.offset.click.left -
                this.offset.relative.left -
                this.offset.parent.left +
                ("fixed" === this.cssPosition
                  ? -this.scrollParent.scrollLeft()
                  : l
                  ? 0
                  : a.scrollLeft()),
            }
          );
        },
        _rearrange: function (t, e, i, n) {
          i
            ? i[0].appendChild(this.placeholder[0])
            : e.item[0].parentNode.insertBefore(
                this.placeholder[0],
                "down" === this.direction ? e.item[0] : e.item[0].nextSibling
              ),
            (this.counter = this.counter ? ++this.counter : 1);
          var s = this.counter;
          this._delay(function () {
            s === this.counter && this.refreshPositions(!n);
          });
        },
        _clear: function (t, e) {
          this.reverting = !1;
          var i,
            n = [];
          if (
            (!this._noFinalSort &&
              this.currentItem.parent().length &&
              this.placeholder.before(this.currentItem),
            (this._noFinalSort = null),
            this.helper[0] === this.currentItem[0])
          ) {
            for (i in this._storedCSS)
              ("auto" !== this._storedCSS[i] &&
                "static" !== this._storedCSS[i]) ||
                (this._storedCSS[i] = "");
            this.currentItem.css(this._storedCSS),
              this._removeClass(this.currentItem, "ui-sortable-helper");
          } else this.currentItem.show();
          function s(t, e, i) {
            return function (n) {
              i._trigger(t, n, e._uiHash(e));
            };
          }
          for (
            this.fromOutside &&
              !e &&
              n.push(function (t) {
                this._trigger("receive", t, this._uiHash(this.fromOutside));
              }),
              (!this.fromOutside &&
                this.domPosition.prev ===
                  this.currentItem.prev().not(".ui-sortable-helper")[0] &&
                this.domPosition.parent === this.currentItem.parent()[0]) ||
                e ||
                n.push(function (t) {
                  this._trigger("update", t, this._uiHash());
                }),
              this !== this.currentContainer &&
                (e ||
                  (n.push(function (t) {
                    this._trigger("remove", t, this._uiHash());
                  }),
                  n.push(
                    function (t) {
                      return function (e) {
                        t._trigger("receive", e, this._uiHash(this));
                      };
                    }.call(this, this.currentContainer)
                  ),
                  n.push(
                    function (t) {
                      return function (e) {
                        t._trigger("update", e, this._uiHash(this));
                      };
                    }.call(this, this.currentContainer)
                  ))),
              i = this.containers.length - 1;
            i >= 0;
            i--
          )
            e || n.push(s("deactivate", this, this.containers[i])),
              this.containers[i].containerCache.over &&
                (n.push(s("out", this, this.containers[i])),
                (this.containers[i].containerCache.over = 0));
          if (
            (this.storedCursor &&
              (this.document.find("body").css("cursor", this.storedCursor),
              this.storedStylesheet.remove()),
            this._storedOpacity &&
              this.helper.css("opacity", this._storedOpacity),
            this._storedZIndex &&
              this.helper.css(
                "zIndex",
                "auto" === this._storedZIndex ? "" : this._storedZIndex
              ),
            (this.dragging = !1),
            e || this._trigger("beforeStop", t, this._uiHash()),
            this.placeholder[0].parentNode.removeChild(this.placeholder[0]),
            this.cancelHelperRemoval ||
              (this.helper[0] !== this.currentItem[0] && this.helper.remove(),
              (this.helper = null)),
            !e)
          ) {
            for (i = 0; i < n.length; i++) n[i].call(this, t);
            this._trigger("stop", t, this._uiHash());
          }
          return (this.fromOutside = !1), !this.cancelHelperRemoval;
        },
        _trigger: function () {
          !1 === t.Widget.prototype._trigger.apply(this, arguments) &&
            this.cancel();
        },
        _uiHash: function (e) {
          var i = e || this;
          return {
            helper: i.helper,
            placeholder: i.placeholder || t([]),
            position: i.position,
            originalPosition: i.originalPosition,
            offset: i.positionAbs,
            item: i.currentItem,
            sender: e ? e.element : null,
          };
        },
      });
    function _(t) {
      return function () {
        var e = this.element.val();
        t.apply(this, arguments),
          this._refresh(),
          e !== this.element.val() && this._trigger("change");
      };
    }
    t.widget("ui.spinner", {
      version: "1.12.1",
      defaultElement: "<input>",
      widgetEventPrefix: "spin",
      options: {
        classes: {
          "ui-spinner": "ui-corner-all",
          "ui-spinner-down": "ui-corner-br",
          "ui-spinner-up": "ui-corner-tr",
        },
        culture: null,
        icons: { down: "ui-icon-triangle-1-s", up: "ui-icon-triangle-1-n" },
        incremental: !0,
        max: null,
        min: null,
        numberFormat: null,
        page: 10,
        step: 1,
        change: null,
        spin: null,
        start: null,
        stop: null,
      },
      _create: function () {
        this._setOption("max", this.options.max),
          this._setOption("min", this.options.min),
          this._setOption("step", this.options.step),
          "" !== this.value() && this._value(this.element.val(), !0),
          this._draw(),
          this._on(this._events),
          this._refresh(),
          this._on(this.window, {
            beforeunload: function () {
              this.element.removeAttr("autocomplete");
            },
          });
      },
      _getCreateOptions: function () {
        var e = this._super(),
          i = this.element;
        return (
          t.each(["min", "max", "step"], function (t, n) {
            var s = i.attr(n);
            null != s && s.length && (e[n] = s);
          }),
          e
        );
      },
      _events: {
        keydown: function (t) {
          this._start(t) && this._keydown(t) && t.preventDefault();
        },
        keyup: "_stop",
        focus: function () {
          this.previous = this.element.val();
        },
        blur: function (t) {
          this.cancelBlur
            ? delete this.cancelBlur
            : (this._stop(),
              this._refresh(),
              this.previous !== this.element.val() &&
                this._trigger("change", t));
        },
        mousewheel: function (t, e) {
          if (e) {
            if (!this.spinning && !this._start(t)) return !1;
            this._spin((e > 0 ? 1 : -1) * this.options.step, t),
              clearTimeout(this.mousewheelTimer),
              (this.mousewheelTimer = this._delay(function () {
                this.spinning && this._stop(t);
              }, 100)),
              t.preventDefault();
          }
        },
        "mousedown .ui-spinner-button": function (e) {
          var i;
          function n() {
            this.element[0] === t.ui.safeActiveElement(this.document[0]) ||
              (this.element.trigger("focus"),
              (this.previous = i),
              this._delay(function () {
                this.previous = i;
              }));
          }
          (i =
            this.element[0] === t.ui.safeActiveElement(this.document[0])
              ? this.previous
              : this.element.val()),
            e.preventDefault(),
            n.call(this),
            (this.cancelBlur = !0),
            this._delay(function () {
              delete this.cancelBlur, n.call(this);
            }),
            !1 !== this._start(e) &&
              this._repeat(
                null,
                t(e.currentTarget).hasClass("ui-spinner-up") ? 1 : -1,
                e
              );
        },
        "mouseup .ui-spinner-button": "_stop",
        "mouseenter .ui-spinner-button": function (e) {
          if (t(e.currentTarget).hasClass("ui-state-active"))
            return (
              !1 !== this._start(e) &&
              void this._repeat(
                null,
                t(e.currentTarget).hasClass("ui-spinner-up") ? 1 : -1,
                e
              )
            );
        },
        "mouseleave .ui-spinner-button": "_stop",
      },
      _enhance: function () {
        this.uiSpinner = this.element
          .attr("autocomplete", "off")
          .wrap("<span>")
          .parent()
          .append("<a></a><a></a>");
      },
      _draw: function () {
        this._enhance(),
          this._addClass(
            this.uiSpinner,
            "ui-spinner",
            "ui-widget ui-widget-content"
          ),
          this._addClass("ui-spinner-input"),
          this.element.attr("role", "spinbutton"),
          (this.buttons = this.uiSpinner
            .children("a")
            .attr("tabIndex", -1)
            .attr("aria-hidden", !0)
            .button({ classes: { "ui-button": "" } })),
          this._removeClass(this.buttons, "ui-corner-all"),
          this._addClass(
            this.buttons.first(),
            "ui-spinner-button ui-spinner-up"
          ),
          this._addClass(
            this.buttons.last(),
            "ui-spinner-button ui-spinner-down"
          ),
          this.buttons
            .first()
            .button({ icon: this.options.icons.up, showLabel: !1 }),
          this.buttons
            .last()
            .button({ icon: this.options.icons.down, showLabel: !1 }),
          this.buttons.height() > Math.ceil(0.5 * this.uiSpinner.height()) &&
            this.uiSpinner.height() > 0 &&
            this.uiSpinner.height(this.uiSpinner.height());
      },
      _keydown: function (e) {
        var i = this.options,
          n = t.ui.keyCode;
        switch (e.keyCode) {
          case n.UP:
            return this._repeat(null, 1, e), !0;
          case n.DOWN:
            return this._repeat(null, -1, e), !0;
          case n.PAGE_UP:
            return this._repeat(null, i.page, e), !0;
          case n.PAGE_DOWN:
            return this._repeat(null, -i.page, e), !0;
        }
        return !1;
      },
      _start: function (t) {
        return (
          !(!this.spinning && !1 === this._trigger("start", t)) &&
          (this.counter || (this.counter = 1), (this.spinning = !0), !0)
        );
      },
      _repeat: function (t, e, i) {
        (t = t || 500),
          clearTimeout(this.timer),
          (this.timer = this._delay(function () {
            this._repeat(40, e, i);
          }, t)),
          this._spin(e * this.options.step, i);
      },
      _spin: function (t, e) {
        var i = this.value() || 0;
        this.counter || (this.counter = 1),
          (i = this._adjustValue(i + t * this._increment(this.counter))),
          (this.spinning && !1 === this._trigger("spin", e, { value: i })) ||
            (this._value(i), this.counter++);
      },
      _increment: function (e) {
        var i = this.options.incremental;
        return i
          ? t.isFunction(i)
            ? i(e)
            : Math.floor((e * e * e) / 5e4 - (e * e) / 500 + (17 * e) / 200 + 1)
          : 1;
      },
      _precision: function () {
        var t = this._precisionOf(this.options.step);
        return (
          null !== this.options.min &&
            (t = Math.max(t, this._precisionOf(this.options.min))),
          t
        );
      },
      _precisionOf: function (t) {
        var e = t.toString(),
          i = e.indexOf(".");
        return -1 === i ? 0 : e.length - i - 1;
      },
      _adjustValue: function (t) {
        var e,
          i,
          n = this.options;
        return (
          (i = t - (e = null !== n.min ? n.min : 0)),
          (t = e + (i = Math.round(i / n.step) * n.step)),
          (t = parseFloat(t.toFixed(this._precision()))),
          null !== n.max && t > n.max
            ? n.max
            : null !== n.min && t < n.min
            ? n.min
            : t
        );
      },
      _stop: function (t) {
        this.spinning &&
          (clearTimeout(this.timer),
          clearTimeout(this.mousewheelTimer),
          (this.counter = 0),
          (this.spinning = !1),
          this._trigger("stop", t));
      },
      _setOption: function (t, e) {
        var i, n, s;
        if ("culture" === t || "numberFormat" === t)
          return (
            (i = this._parse(this.element.val())),
            (this.options[t] = e),
            void this.element.val(this._format(i))
          );
        ("max" !== t && "min" !== t && "step" !== t) ||
          ("string" == typeof e && (e = this._parse(e))),
          "icons" === t &&
            ((n = this.buttons.first().find(".ui-icon")),
            this._removeClass(n, null, this.options.icons.up),
            this._addClass(n, null, e.up),
            (s = this.buttons.last().find(".ui-icon")),
            this._removeClass(s, null, this.options.icons.down),
            this._addClass(s, null, e.down)),
          this._super(t, e);
      },
      _setOptionDisabled: function (t) {
        this._super(t),
          this._toggleClass(this.uiSpinner, null, "ui-state-disabled", !!t),
          this.element.prop("disabled", !!t),
          this.buttons.button(t ? "disable" : "enable");
      },
      _setOptions: _(function (t) {
        this._super(t);
      }),
      _parse: function (t) {
        return (
          "string" == typeof t &&
            "" !== t &&
            (t =
              window.Globalize && this.options.numberFormat
                ? Globalize.parseFloat(t, 10, this.options.culture)
                : +t),
          "" === t || isNaN(t) ? null : t
        );
      },
      _format: function (t) {
        return "" === t
          ? ""
          : window.Globalize && this.options.numberFormat
          ? Globalize.format(t, this.options.numberFormat, this.options.culture)
          : t;
      },
      _refresh: function () {
        this.element.attr({
          "aria-valuemin": this.options.min,
          "aria-valuemax": this.options.max,
          "aria-valuenow": this._parse(this.element.val()),
        });
      },
      isValid: function () {
        var t = this.value();
        return null !== t && t === this._adjustValue(t);
      },
      _value: function (t, e) {
        var i;
        "" !== t &&
          null !== (i = this._parse(t)) &&
          (e || (i = this._adjustValue(i)), (t = this._format(i))),
          this.element.val(t),
          this._refresh();
      },
      _destroy: function () {
        this.element
          .prop("disabled", !1)
          .removeAttr(
            "autocomplete role aria-valuemin aria-valuemax aria-valuenow"
          ),
          this.uiSpinner.replaceWith(this.element);
      },
      stepUp: _(function (t) {
        this._stepUp(t);
      }),
      _stepUp: function (t) {
        this._start() &&
          (this._spin((t || 1) * this.options.step), this._stop());
      },
      stepDown: _(function (t) {
        this._stepDown(t);
      }),
      _stepDown: function (t) {
        this._start() &&
          (this._spin((t || 1) * -this.options.step), this._stop());
      },
      pageUp: _(function (t) {
        this._stepUp((t || 1) * this.options.page);
      }),
      pageDown: _(function (t) {
        this._stepDown((t || 1) * this.options.page);
      }),
      value: function (t) {
        if (!arguments.length) return this._parse(this.element.val());
        _(this._value).call(this, t);
      },
      widget: function () {
        return this.uiSpinner;
      },
    }),
      !1 !== t.uiBackCompat &&
        t.widget("ui.spinner", t.ui.spinner, {
          _enhance: function () {
            this.uiSpinner = this.element
              .attr("autocomplete", "off")
              .wrap(this._uiSpinnerHtml())
              .parent()
              .append(this._buttonHtml());
          },
          _uiSpinnerHtml: function () {
            return "<span>";
          },
          _buttonHtml: function () {
            return "<a></a><a></a>";
          },
        });
    var y;
    t.ui.spinner;
    t.widget("ui.tabs", {
      version: "1.12.1",
      delay: 300,
      options: {
        active: null,
        classes: {
          "ui-tabs": "ui-corner-all",
          "ui-tabs-nav": "ui-corner-all",
          "ui-tabs-panel": "ui-corner-bottom",
          "ui-tabs-tab": "ui-corner-top",
        },
        collapsible: !1,
        event: "click",
        heightStyle: "content",
        hide: null,
        show: null,
        activate: null,
        beforeActivate: null,
        beforeLoad: null,
        load: null,
      },
      _isLocal:
        ((y = /#.*$/),
        function (t) {
          var e, i;
          (e = t.href.replace(y, "")), (i = location.href.replace(y, ""));
          try {
            e = decodeURIComponent(e);
          } catch (t) {}
          try {
            i = decodeURIComponent(i);
          } catch (t) {}
          return t.hash.length > 1 && e === i;
        }),
      _create: function () {
        var e = this,
          i = this.options;
        (this.running = !1),
          this._addClass("ui-tabs", "ui-widget ui-widget-content"),
          this._toggleClass("ui-tabs-collapsible", null, i.collapsible),
          this._processTabs(),
          (i.active = this._initialActive()),
          t.isArray(i.disabled) &&
            (i.disabled = t
              .unique(
                i.disabled.concat(
                  t.map(this.tabs.filter(".ui-state-disabled"), function (t) {
                    return e.tabs.index(t);
                  })
                )
              )
              .sort()),
          !1 !== this.options.active && this.anchors.length
            ? (this.active = this._findActive(i.active))
            : (this.active = t()),
          this._refresh(),
          this.active.length && this.load(i.active);
      },
      _initialActive: function () {
        var e = this.options.active,
          i = this.options.collapsible,
          n = location.hash.substring(1);
        return (
          null === e &&
            (n &&
              this.tabs.each(function (i, s) {
                if (t(s).attr("aria-controls") === n) return (e = i), !1;
              }),
            null === e &&
              (e = this.tabs.index(this.tabs.filter(".ui-tabs-active"))),
            (null !== e && -1 !== e) || (e = !!this.tabs.length && 0)),
          !1 !== e &&
            -1 === (e = this.tabs.index(this.tabs.eq(e))) &&
            (e = !i && 0),
          !i && !1 === e && this.anchors.length && (e = 0),
          e
        );
      },
      _getCreateEventData: function () {
        return {
          tab: this.active,
          panel: this.active.length ? this._getPanelForTab(this.active) : t(),
        };
      },
      _tabKeydown: function (e) {
        var i = t(t.ui.safeActiveElement(this.document[0])).closest("li"),
          n = this.tabs.index(i),
          s = !0;
        if (!this._handlePageNav(e)) {
          switch (e.keyCode) {
            case t.ui.keyCode.RIGHT:
            case t.ui.keyCode.DOWN:
              n++;
              break;
            case t.ui.keyCode.UP:
            case t.ui.keyCode.LEFT:
              (s = !1), n--;
              break;
            case t.ui.keyCode.END:
              n = this.anchors.length - 1;
              break;
            case t.ui.keyCode.HOME:
              n = 0;
              break;
            case t.ui.keyCode.SPACE:
              return (
                e.preventDefault(),
                clearTimeout(this.activating),
                void this._activate(n)
              );
            case t.ui.keyCode.ENTER:
              return (
                e.preventDefault(),
                clearTimeout(this.activating),
                void this._activate(n !== this.options.active && n)
              );
            default:
              return;
          }
          e.preventDefault(),
            clearTimeout(this.activating),
            (n = this._focusNextTab(n, s)),
            e.ctrlKey ||
              e.metaKey ||
              (i.attr("aria-selected", "false"),
              this.tabs.eq(n).attr("aria-selected", "true"),
              (this.activating = this._delay(function () {
                this.option("active", n);
              }, this.delay)));
        }
      },
      _panelKeydown: function (e) {
        this._handlePageNav(e) ||
          (e.ctrlKey &&
            e.keyCode === t.ui.keyCode.UP &&
            (e.preventDefault(), this.active.trigger("focus")));
      },
      _handlePageNav: function (e) {
        return e.altKey && e.keyCode === t.ui.keyCode.PAGE_UP
          ? (this._activate(this._focusNextTab(this.options.active - 1, !1)),
            !0)
          : e.altKey && e.keyCode === t.ui.keyCode.PAGE_DOWN
          ? (this._activate(this._focusNextTab(this.options.active + 1, !0)),
            !0)
          : void 0;
      },
      _findNextTab: function (e, i) {
        var n = this.tabs.length - 1;
        for (
          ;
          -1 !==
          t.inArray(
            (e > n && (e = 0), e < 0 && (e = n), e),
            this.options.disabled
          );

        )
          e = i ? e + 1 : e - 1;
        return e;
      },
      _focusNextTab: function (t, e) {
        return (
          (t = this._findNextTab(t, e)), this.tabs.eq(t).trigger("focus"), t
        );
      },
      _setOption: function (t, e) {
        "active" !== t
          ? (this._super(t, e),
            "collapsible" === t &&
              (this._toggleClass("ui-tabs-collapsible", null, e),
              e || !1 !== this.options.active || this._activate(0)),
            "event" === t && this._setupEvents(e),
            "heightStyle" === t && this._setupHeightStyle(e))
          : this._activate(e);
      },
      _sanitizeSelector: function (t) {
        return t
          ? t.replace(/[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g, "\\$&")
          : "";
      },
      refresh: function () {
        var e = this.options,
          i = this.tablist.children(":has(a[href])");
        (e.disabled = t.map(i.filter(".ui-state-disabled"), function (t) {
          return i.index(t);
        })),
          this._processTabs(),
          !1 !== e.active && this.anchors.length
            ? this.active.length && !t.contains(this.tablist[0], this.active[0])
              ? this.tabs.length === e.disabled.length
                ? ((e.active = !1), (this.active = t()))
                : this._activate(
                    this._findNextTab(Math.max(0, e.active - 1), !1)
                  )
              : (e.active = this.tabs.index(this.active))
            : ((e.active = !1), (this.active = t())),
          this._refresh();
      },
      _refresh: function () {
        this._setOptionDisabled(this.options.disabled),
          this._setupEvents(this.options.event),
          this._setupHeightStyle(this.options.heightStyle),
          this.tabs.not(this.active).attr({
            "aria-selected": "false",
            "aria-expanded": "false",
            tabIndex: -1,
          }),
          this.panels
            .not(this._getPanelForTab(this.active))
            .hide()
            .attr({ "aria-hidden": "true" }),
          this.active.length
            ? (this.active.attr({
                "aria-selected": "true",
                "aria-expanded": "true",
                tabIndex: 0,
              }),
              this._addClass(this.active, "ui-tabs-active", "ui-state-active"),
              this._getPanelForTab(this.active)
                .show()
                .attr({ "aria-hidden": "false" }))
            : this.tabs.eq(0).attr("tabIndex", 0);
      },
      _processTabs: function () {
        var e = this,
          i = this.tabs,
          n = this.anchors,
          s = this.panels;
        (this.tablist = this._getList().attr("role", "tablist")),
          this._addClass(
            this.tablist,
            "ui-tabs-nav",
            "ui-helper-reset ui-helper-clearfix ui-widget-header"
          ),
          this.tablist
            .on("mousedown" + this.eventNamespace, "> li", function (e) {
              t(this).is(".ui-state-disabled") && e.preventDefault();
            })
            .on("focus" + this.eventNamespace, ".ui-tabs-anchor", function () {
              t(this).closest("li").is(".ui-state-disabled") && this.blur();
            }),
          (this.tabs = this.tablist
            .find("> li:has(a[href])")
            .attr({ role: "tab", tabIndex: -1 })),
          this._addClass(this.tabs, "ui-tabs-tab", "ui-state-default"),
          (this.anchors = this.tabs
            .map(function () {
              return t("a", this)[0];
            })
            .attr({ role: "presentation", tabIndex: -1 })),
          this._addClass(this.anchors, "ui-tabs-anchor"),
          (this.panels = t()),
          this.anchors.each(function (i, n) {
            var s,
              o,
              r,
              a = t(n).uniqueId().attr("id"),
              l = t(n).closest("li"),
              h = l.attr("aria-controls");
            e._isLocal(n)
              ? ((r = (s = n.hash).substring(1)),
                (o = e.element.find(e._sanitizeSelector(s))))
              : ((s =
                  "#" +
                  (r = l.attr("aria-controls") || t({}).uniqueId()[0].id)),
                (o = e.element.find(s)).length ||
                  (o = e._createPanel(r)).insertAfter(
                    e.panels[i - 1] || e.tablist
                  ),
                o.attr("aria-live", "polite")),
              o.length && (e.panels = e.panels.add(o)),
              h && l.data("ui-tabs-aria-controls", h),
              l.attr({ "aria-controls": r, "aria-labelledby": a }),
              o.attr("aria-labelledby", a);
          }),
          this.panels.attr("role", "tabpanel"),
          this._addClass(this.panels, "ui-tabs-panel", "ui-widget-content"),
          i &&
            (this._off(i.not(this.tabs)),
            this._off(n.not(this.anchors)),
            this._off(s.not(this.panels)));
      },
      _getList: function () {
        return this.tablist || this.element.find("ol, ul").eq(0);
      },
      _createPanel: function (e) {
        return t("<div>").attr("id", e).data("ui-tabs-destroy", !0);
      },
      _setOptionDisabled: function (e) {
        var i, n, s;
        for (
          t.isArray(e) &&
            (e.length
              ? e.length === this.anchors.length && (e = !0)
              : (e = !1)),
            s = 0;
          (n = this.tabs[s]);
          s++
        )
          (i = t(n)),
            !0 === e || -1 !== t.inArray(s, e)
              ? (i.attr("aria-disabled", "true"),
                this._addClass(i, null, "ui-state-disabled"))
              : (i.removeAttr("aria-disabled"),
                this._removeClass(i, null, "ui-state-disabled"));
        (this.options.disabled = e),
          this._toggleClass(
            this.widget(),
            this.widgetFullName + "-disabled",
            null,
            !0 === e
          );
      },
      _setupEvents: function (e) {
        var i = {};
        e &&
          t.each(e.split(" "), function (t, e) {
            i[e] = "_eventHandler";
          }),
          this._off(this.anchors.add(this.tabs).add(this.panels)),
          this._on(!0, this.anchors, {
            click: function (t) {
              t.preventDefault();
            },
          }),
          this._on(this.anchors, i),
          this._on(this.tabs, { keydown: "_tabKeydown" }),
          this._on(this.panels, { keydown: "_panelKeydown" }),
          this._focusable(this.tabs),
          this._hoverable(this.tabs);
      },
      _setupHeightStyle: function (e) {
        var i,
          n = this.element.parent();
        "fill" === e
          ? ((i = n.height()),
            (i -= this.element.outerHeight() - this.element.height()),
            this.element.siblings(":visible").each(function () {
              var e = t(this),
                n = e.css("position");
              "absolute" !== n && "fixed" !== n && (i -= e.outerHeight(!0));
            }),
            this.element
              .children()
              .not(this.panels)
              .each(function () {
                i -= t(this).outerHeight(!0);
              }),
            this.panels
              .each(function () {
                t(this).height(
                  Math.max(0, i - t(this).innerHeight() + t(this).height())
                );
              })
              .css("overflow", "auto"))
          : "auto" === e &&
            ((i = 0),
            this.panels
              .each(function () {
                i = Math.max(i, t(this).height("").height());
              })
              .height(i));
      },
      _eventHandler: function (e) {
        var i = this.options,
          n = this.active,
          s = t(e.currentTarget).closest("li"),
          o = s[0] === n[0],
          r = o && i.collapsible,
          a = r ? t() : this._getPanelForTab(s),
          l = n.length ? this._getPanelForTab(n) : t(),
          h = { oldTab: n, oldPanel: l, newTab: r ? t() : s, newPanel: a };
        e.preventDefault(),
          s.hasClass("ui-state-disabled") ||
            s.hasClass("ui-tabs-loading") ||
            this.running ||
            (o && !i.collapsible) ||
            !1 === this._trigger("beforeActivate", e, h) ||
            ((i.active = !r && this.tabs.index(s)),
            (this.active = o ? t() : s),
            this.xhr && this.xhr.abort(),
            l.length ||
              a.length ||
              t.error("jQuery UI Tabs: Mismatching fragment identifier."),
            a.length && this.load(this.tabs.index(s), e),
            this._toggle(e, h));
      },
      _toggle: function (e, i) {
        var n = this,
          s = i.newPanel,
          o = i.oldPanel;
        function r() {
          (n.running = !1), n._trigger("activate", e, i);
        }
        function a() {
          n._addClass(
            i.newTab.closest("li"),
            "ui-tabs-active",
            "ui-state-active"
          ),
            s.length && n.options.show
              ? n._show(s, n.options.show, r)
              : (s.show(), r());
        }
        (this.running = !0),
          o.length && this.options.hide
            ? this._hide(o, this.options.hide, function () {
                n._removeClass(
                  i.oldTab.closest("li"),
                  "ui-tabs-active",
                  "ui-state-active"
                ),
                  a();
              })
            : (this._removeClass(
                i.oldTab.closest("li"),
                "ui-tabs-active",
                "ui-state-active"
              ),
              o.hide(),
              a()),
          o.attr("aria-hidden", "true"),
          i.oldTab.attr({ "aria-selected": "false", "aria-expanded": "false" }),
          s.length && o.length
            ? i.oldTab.attr("tabIndex", -1)
            : s.length &&
              this.tabs
                .filter(function () {
                  return 0 === t(this).attr("tabIndex");
                })
                .attr("tabIndex", -1),
          s.attr("aria-hidden", "false"),
          i.newTab.attr({
            "aria-selected": "true",
            "aria-expanded": "true",
            tabIndex: 0,
          });
      },
      _activate: function (e) {
        var i,
          n = this._findActive(e);
        n[0] !== this.active[0] &&
          (n.length || (n = this.active),
          (i = n.find(".ui-tabs-anchor")[0]),
          this._eventHandler({
            target: i,
            currentTarget: i,
            preventDefault: t.noop,
          }));
      },
      _findActive: function (e) {
        return !1 === e ? t() : this.tabs.eq(e);
      },
      _getIndex: function (e) {
        return (
          "string" == typeof e &&
            (e = this.anchors.index(
              this.anchors.filter("[href$='" + t.ui.escapeSelector(e) + "']")
            )),
          e
        );
      },
      _destroy: function () {
        this.xhr && this.xhr.abort(),
          this.tablist.removeAttr("role").off(this.eventNamespace),
          this.anchors.removeAttr("role tabIndex").removeUniqueId(),
          this.tabs.add(this.panels).each(function () {
            t.data(this, "ui-tabs-destroy")
              ? t(this).remove()
              : t(this).removeAttr(
                  "role tabIndex aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded"
                );
          }),
          this.tabs.each(function () {
            var e = t(this),
              i = e.data("ui-tabs-aria-controls");
            i
              ? e.attr("aria-controls", i).removeData("ui-tabs-aria-controls")
              : e.removeAttr("aria-controls");
          }),
          this.panels.show(),
          "content" !== this.options.heightStyle &&
            this.panels.css("height", "");
      },
      enable: function (e) {
        var i = this.options.disabled;
        !1 !== i &&
          (void 0 === e
            ? (i = !1)
            : ((e = this._getIndex(e)),
              (i = t.isArray(i)
                ? t.map(i, function (t) {
                    return t !== e ? t : null;
                  })
                : t.map(this.tabs, function (t, i) {
                    return i !== e ? i : null;
                  }))),
          this._setOptionDisabled(i));
      },
      disable: function (e) {
        var i = this.options.disabled;
        if (!0 !== i) {
          if (void 0 === e) i = !0;
          else {
            if (((e = this._getIndex(e)), -1 !== t.inArray(e, i))) return;
            i = t.isArray(i) ? t.merge([e], i).sort() : [e];
          }
          this._setOptionDisabled(i);
        }
      },
      load: function (e, i) {
        e = this._getIndex(e);
        var n = this,
          s = this.tabs.eq(e),
          o = s.find(".ui-tabs-anchor"),
          r = this._getPanelForTab(s),
          a = { tab: s, panel: r },
          l = function (t, e) {
            "abort" === e && n.panels.stop(!1, !0),
              n._removeClass(s, "ui-tabs-loading"),
              r.removeAttr("aria-busy"),
              t === n.xhr && delete n.xhr;
          };
        this._isLocal(o[0]) ||
          ((this.xhr = t.ajax(this._ajaxSettings(o, i, a))),
          this.xhr &&
            "canceled" !== this.xhr.statusText &&
            (this._addClass(s, "ui-tabs-loading"),
            r.attr("aria-busy", "true"),
            this.xhr
              .done(function (t, e, s) {
                setTimeout(function () {
                  r.html(t), n._trigger("load", i, a), l(s, e);
                }, 1);
              })
              .fail(function (t, e) {
                setTimeout(function () {
                  l(t, e);
                }, 1);
              })));
      },
      _ajaxSettings: function (e, i, n) {
        var s = this;
        return {
          url: e.attr("href").replace(/#.*$/, ""),
          beforeSend: function (e, o) {
            return s._trigger(
              "beforeLoad",
              i,
              t.extend({ jqXHR: e, ajaxSettings: o }, n)
            );
          },
        };
      },
      _getPanelForTab: function (e) {
        var i = t(e).attr("aria-controls");
        return this.element.find(this._sanitizeSelector("#" + i));
      },
    }),
      !1 !== t.uiBackCompat &&
        t.widget("ui.tabs", t.ui.tabs, {
          _processTabs: function () {
            this._superApply(arguments), this._addClass(this.tabs, "ui-tab");
          },
        });
    t.ui.tabs;
    t.widget("ui.tooltip", {
      version: "1.12.1",
      options: {
        classes: { "ui-tooltip": "ui-corner-all ui-widget-shadow" },
        content: function () {
          var e = t(this).attr("title") || "";
          return t("<a>").text(e).html();
        },
        hide: !0,
        items: "[title]:not([disabled])",
        position: {
          my: "left top+15",
          at: "left bottom",
          collision: "flipfit flip",
        },
        show: !0,
        track: !1,
        close: null,
        open: null,
      },
      _addDescribedBy: function (e, i) {
        var n = (e.attr("aria-describedby") || "").split(/\s+/);
        n.push(i),
          e
            .data("ui-tooltip-id", i)
            .attr("aria-describedby", t.trim(n.join(" ")));
      },
      _removeDescribedBy: function (e) {
        var i = e.data("ui-tooltip-id"),
          n = (e.attr("aria-describedby") || "").split(/\s+/),
          s = t.inArray(i, n);
        -1 !== s && n.splice(s, 1),
          e.removeData("ui-tooltip-id"),
          (n = t.trim(n.join(" ")))
            ? e.attr("aria-describedby", n)
            : e.removeAttr("aria-describedby");
      },
      _create: function () {
        this._on({ mouseover: "open", focusin: "open" }),
          (this.tooltips = {}),
          (this.parents = {}),
          (this.liveRegion = t("<div>")
            .attr({
              role: "log",
              "aria-live": "assertive",
              "aria-relevant": "additions",
            })
            .appendTo(this.document[0].body)),
          this._addClass(this.liveRegion, null, "ui-helper-hidden-accessible"),
          (this.disabledTitles = t([]));
      },
      _setOption: function (e, i) {
        var n = this;
        this._super(e, i),
          "content" === e &&
            t.each(this.tooltips, function (t, e) {
              n._updateContent(e.element);
            });
      },
      _setOptionDisabled: function (t) {
        this[t ? "_disable" : "_enable"]();
      },
      _disable: function () {
        var e = this;
        t.each(this.tooltips, function (i, n) {
          var s = t.Event("blur");
          (s.target = s.currentTarget = n.element[0]), e.close(s, !0);
        }),
          (this.disabledTitles = this.disabledTitles.add(
            this.element
              .find(this.options.items)
              .addBack()
              .filter(function () {
                var e = t(this);
                if (e.is("[title]"))
                  return e
                    .data("ui-tooltip-title", e.attr("title"))
                    .removeAttr("title");
              })
          ));
      },
      _enable: function () {
        this.disabledTitles.each(function () {
          var e = t(this);
          e.data("ui-tooltip-title") &&
            e.attr("title", e.data("ui-tooltip-title"));
        }),
          (this.disabledTitles = t([]));
      },
      open: function (e) {
        var i = this,
          n = t(e ? e.target : this.element).closest(this.options.items);
        n.length &&
          !n.data("ui-tooltip-id") &&
          (n.attr("title") && n.data("ui-tooltip-title", n.attr("title")),
          n.data("ui-tooltip-open", !0),
          e &&
            "mouseover" === e.type &&
            n.parents().each(function () {
              var e,
                n = t(this);
              n.data("ui-tooltip-open") &&
                (((e = t.Event("blur")).target = e.currentTarget = this),
                i.close(e, !0)),
                n.attr("title") &&
                  (n.uniqueId(),
                  (i.parents[this.id] = {
                    element: this,
                    title: n.attr("title"),
                  }),
                  n.attr("title", ""));
            }),
          this._registerCloseHandlers(e, n),
          this._updateContent(n, e));
      },
      _updateContent: function (t, e) {
        var i,
          n = this.options.content,
          s = this,
          o = e ? e.type : null;
        if ("string" == typeof n || n.nodeType || n.jquery)
          return this._open(e, t, n);
        (i = n.call(t[0], function (i) {
          s._delay(function () {
            t.data("ui-tooltip-open") &&
              (e && (e.type = o), this._open(e, t, i));
          });
        })) && this._open(e, t, i);
      },
      _open: function (e, i, n) {
        var s,
          o,
          r,
          a,
          l = t.extend({}, this.options.position);
        function h(t) {
          (l.of = t), o.is(":hidden") || o.position(l);
        }
        n &&
          ((s = this._find(i))
            ? s.tooltip.find(".ui-tooltip-content").html(n)
            : (i.is("[title]") &&
                (e && "mouseover" === e.type
                  ? i.attr("title", "")
                  : i.removeAttr("title")),
              (s = this._tooltip(i)),
              (o = s.tooltip),
              this._addDescribedBy(i, o.attr("id")),
              o.find(".ui-tooltip-content").html(n),
              this.liveRegion.children().hide(),
              (a = t("<div>").html(o.find(".ui-tooltip-content").html()))
                .removeAttr("name")
                .find("[name]")
                .removeAttr("name"),
              a.removeAttr("id").find("[id]").removeAttr("id"),
              a.appendTo(this.liveRegion),
              this.options.track && e && /^mouse/.test(e.type)
                ? (this._on(this.document, { mousemove: h }), h(e))
                : o.position(t.extend({ of: i }, this.options.position)),
              o.hide(),
              this._show(o, this.options.show),
              this.options.track &&
                this.options.show &&
                this.options.show.delay &&
                (r = this.delayedShow =
                  setInterval(function () {
                    o.is(":visible") && (h(l.of), clearInterval(r));
                  }, t.fx.interval)),
              this._trigger("open", e, { tooltip: o })));
      },
      _registerCloseHandlers: function (e, i) {
        var n = {
          keyup: function (e) {
            if (e.keyCode === t.ui.keyCode.ESCAPE) {
              var n = t.Event(e);
              (n.currentTarget = i[0]), this.close(n, !0);
            }
          },
        };
        i[0] !== this.element[0] &&
          (n.remove = function () {
            this._removeTooltip(this._find(i).tooltip);
          }),
          (e && "mouseover" !== e.type) || (n.mouseleave = "close"),
          (e && "focusin" !== e.type) || (n.focusout = "close"),
          this._on(!0, i, n);
      },
      close: function (e) {
        var i,
          n = this,
          s = t(e ? e.currentTarget : this.element),
          o = this._find(s);
        o
          ? ((i = o.tooltip),
            o.closing ||
              (clearInterval(this.delayedShow),
              s.data("ui-tooltip-title") &&
                !s.attr("title") &&
                s.attr("title", s.data("ui-tooltip-title")),
              this._removeDescribedBy(s),
              (o.hiding = !0),
              i.stop(!0),
              this._hide(i, this.options.hide, function () {
                n._removeTooltip(t(this));
              }),
              s.removeData("ui-tooltip-open"),
              this._off(s, "mouseleave focusout keyup"),
              s[0] !== this.element[0] && this._off(s, "remove"),
              this._off(this.document, "mousemove"),
              e &&
                "mouseleave" === e.type &&
                t.each(this.parents, function (e, i) {
                  t(i.element).attr("title", i.title), delete n.parents[e];
                }),
              (o.closing = !0),
              this._trigger("close", e, { tooltip: i }),
              o.hiding || (o.closing = !1)))
          : s.removeData("ui-tooltip-open");
      },
      _tooltip: function (e) {
        var i = t("<div>").attr("role", "tooltip"),
          n = t("<div>").appendTo(i),
          s = i.uniqueId().attr("id");
        return (
          this._addClass(n, "ui-tooltip-content"),
          this._addClass(i, "ui-tooltip", "ui-widget ui-widget-content"),
          i.appendTo(this._appendTo(e)),
          (this.tooltips[s] = { element: e, tooltip: i })
        );
      },
      _find: function (t) {
        var e = t.data("ui-tooltip-id");
        return e ? this.tooltips[e] : null;
      },
      _removeTooltip: function (t) {
        t.remove(), delete this.tooltips[t.attr("id")];
      },
      _appendTo: function (t) {
        var e = t.closest(".ui-front, dialog");
        return e.length || (e = this.document[0].body), e;
      },
      _destroy: function () {
        var e = this;
        t.each(this.tooltips, function (i, n) {
          var s = t.Event("blur"),
            o = n.element;
          (s.target = s.currentTarget = o[0]),
            e.close(s, !0),
            t("#" + i).remove(),
            o.data("ui-tooltip-title") &&
              (o.attr("title") || o.attr("title", o.data("ui-tooltip-title")),
              o.removeData("ui-tooltip-title"));
        }),
          this.liveRegion.remove();
      },
    }),
      !1 !== t.uiBackCompat &&
        t.widget("ui.tooltip", t.ui.tooltip, {
          options: { tooltipClass: null },
          _tooltip: function () {
            var t = this._superApply(arguments);
            return (
              this.options.tooltipClass &&
                t.tooltip.addClass(this.options.tooltipClass),
              t
            );
          },
        });
    t.ui.tooltip;
  }),
  (function (t) {
    var e = (function (t, e, i) {
      "use strict";
      var n, s;
      if (
        ((function () {
          var e,
            i = {
              lazyClass: "lazyload",
              loadedClass: "lazyloaded",
              loadingClass: "lazyloading",
              preloadClass: "lazypreload",
              errorClass: "lazyerror",
              autosizesClass: "lazyautosizes",
              srcAttr: "data-src",
              srcsetAttr: "data-srcset",
              sizesAttr: "data-sizes",
              minSize: 40,
              customMedia: {},
              init: !0,
              expFactor: 1.5,
              hFac: 0.8,
              loadMode: 2,
              loadHidden: !0,
              ricTimeout: 0,
              throttleDelay: 125,
            };
          for (e in ((s = t.lazySizesConfig || t.lazysizesConfig || {}), i))
            e in s || (s[e] = i[e]);
        })(),
        !e || !e.getElementsByClassName)
      )
        return { init: function () {}, cfg: s, noSupport: !0 };
      var o = e.documentElement,
        r = t.HTMLPictureElement,
        a = "addEventListener",
        l = "getAttribute",
        h = t[a].bind(t),
        c = t.setTimeout,
        u = t.requestAnimationFrame || c,
        d = t.requestIdleCallback,
        p = /^picture$/i,
        f = ["load", "error", "lazyincluded", "_lazyloaded"],
        m = {},
        g = Array.prototype.forEach,
        v = function (t, e) {
          return (
            m[e] || (m[e] = new RegExp("(\\s|^)" + e + "(\\s|$)")),
            m[e].test(t[l]("class") || "") && m[e]
          );
        },
        _ = function (t, e) {
          v(t, e) ||
            t.setAttribute("class", (t[l]("class") || "").trim() + " " + e);
        },
        y = function (t, e) {
          var i;
          (i = v(t, e)) &&
            t.setAttribute("class", (t[l]("class") || "").replace(i, " "));
        },
        b = function (t, e, i) {
          var n = i ? a : "removeEventListener";
          i && b(t, e),
            f.forEach(function (i) {
              t[n](i, e);
            });
        },
        w = function (t, i, s, o, r) {
          var a = e.createEvent("Event");
          return (
            s || (s = {}),
            (s.instance = n),
            a.initEvent(i, !o, !r),
            (a.detail = s),
            t.dispatchEvent(a),
            a
          );
        },
        x = function (e, i) {
          var n;
          !r && (n = t.picturefill || s.pf)
            ? (i && i.src && !e[l]("srcset") && e.setAttribute("srcset", i.src),
              n({ reevaluate: !0, elements: [e] }))
            : i && i.src && (e.src = i.src);
        },
        C = function (t, e) {
          return (getComputedStyle(t, null) || {})[e];
        },
        k = function (t, e, i) {
          for (
            i = i || t.offsetWidth;
            i < s.minSize && e && !t._lazysizesWidth;

          )
            (i = e.offsetWidth), (e = e.parentNode);
          return i;
        },
        T = (function () {
          var t,
            i,
            n = [],
            s = [],
            o = n,
            r = function () {
              var e = o;
              for (o = n.length ? s : n, t = !0, i = !1; e.length; )
                e.shift()();
              t = !1;
            },
            a = function (n, s) {
              t && !s
                ? n.apply(this, arguments)
                : (o.push(n), i || ((i = !0), (e.hidden ? c : u)(r)));
            };
          return (a._lsFlush = r), a;
        })(),
        D = function (t, e) {
          return e
            ? function () {
                T(t);
              }
            : function () {
                var e = this,
                  i = arguments;
                T(function () {
                  t.apply(e, i);
                });
              };
        },
        I = function (t) {
          var e,
            n = 0,
            o = s.throttleDelay,
            r = s.ricTimeout,
            a = function () {
              (e = !1), (n = i.now()), t();
            },
            l =
              d && r > 49
                ? function () {
                    d(a, { timeout: r }),
                      r !== s.ricTimeout && (r = s.ricTimeout);
                  }
                : D(function () {
                    c(a);
                  }, !0);
          return function (t) {
            var s;
            (t = !0 === t) && (r = 33),
              e ||
                ((e = !0),
                (s = o - (i.now() - n)) < 0 && (s = 0),
                t || s < 9 ? l() : c(l, s));
          };
        },
        E = function (t) {
          var e,
            n,
            s = function () {
              (e = null), t();
            },
            o = function () {
              var t = i.now() - n;
              t < 99 ? c(o, 99 - t) : (d || s)(s);
            };
          return function () {
            (n = i.now()), e || (e = c(o, 99));
          };
        },
        S = (function () {
          var r,
            d,
            f,
            m,
            k,
            S,
            P,
            O,
            M,
            z,
            $,
            N,
            H = /^img$/i,
            W = /^iframe$/i,
            F = "onscroll" in t && !/(gle|ing)bot/.test(navigator.userAgent),
            L = 0,
            R = 0,
            j = -1,
            B = function (t) {
              R--, (!t || R < 0 || !t.target) && (R = 0);
            },
            q = function (t) {
              return (
                null == N && (N = "hidden" == C(e.body, "visibility")),
                N ||
                  !(
                    "hidden" == C(t.parentNode, "visibility") &&
                    "hidden" == C(t, "visibility")
                  )
              );
            },
            U = function (t, i) {
              var n,
                s = t,
                r = q(t);
              for (
                O -= i, $ += i, M -= i, z += i;
                r && (s = s.offsetParent) && s != e.body && s != o;

              )
                (r = (C(s, "opacity") || 1) > 0) &&
                  "visible" != C(s, "overflow") &&
                  ((n = s.getBoundingClientRect()),
                  (r =
                    z > n.left &&
                    M < n.right &&
                    $ > n.top - 1 &&
                    O < n.bottom + 1));
              return r;
            },
            Y = function () {
              var t,
                i,
                a,
                h,
                c,
                u,
                p,
                f,
                g,
                v,
                _,
                y,
                b = n.elements;
              if ((m = s.loadMode) && R < 8 && (t = b.length)) {
                for (i = 0, j++; i < t; i++)
                  if (b[i] && !b[i]._lazyRace)
                    if (!F || (n.prematureUnveil && n.prematureUnveil(b[i])))
                      J(b[i]);
                    else if (
                      (((f = b[i][l]("data-expand")) && (u = 1 * f)) || (u = L),
                      v ||
                        ((v =
                          !s.expand || s.expand < 1
                            ? o.clientHeight > 500 && o.clientWidth > 500
                              ? 500
                              : 370
                            : s.expand),
                        (n._defEx = v),
                        (_ = v * s.expFactor),
                        (y = s.hFac),
                        (N = null),
                        L < _ && R < 1 && j > 2 && m > 2 && !e.hidden
                          ? ((L = _), (j = 0))
                          : (L = m > 1 && j > 1 && R < 6 ? v : 0)),
                      g !== u &&
                        ((S = innerWidth + u * y),
                        (P = innerHeight + u),
                        (p = -1 * u),
                        (g = u)),
                      (a = b[i].getBoundingClientRect()),
                      ($ = a.bottom) >= p &&
                        (O = a.top) <= P &&
                        (z = a.right) >= p * y &&
                        (M = a.left) <= S &&
                        ($ || z || M || O) &&
                        (s.loadHidden || q(b[i])) &&
                        ((d && R < 3 && !f && (m < 3 || j < 4)) || U(b[i], u)))
                    ) {
                      if ((J(b[i]), (c = !0), R > 9)) break;
                    } else
                      !c &&
                        d &&
                        !h &&
                        R < 4 &&
                        j < 4 &&
                        m > 2 &&
                        (r[0] || s.preloadAfterLoad) &&
                        (r[0] ||
                          (!f &&
                            ($ ||
                              z ||
                              M ||
                              O ||
                              "auto" != b[i][l](s.sizesAttr)))) &&
                        (h = r[0] || b[i]);
                h && !c && J(h);
              }
            },
            V = I(Y),
            K = function (t) {
              var e = t.target;
              e._lazyCache
                ? delete e._lazyCache
                : (B(t),
                  _(e, s.loadedClass),
                  y(e, s.loadingClass),
                  b(e, Z),
                  w(e, "lazyloaded"));
            },
            Q = D(K),
            Z = function (t) {
              Q({ target: t.target });
            },
            G = function (t) {
              var e,
                i = t[l](s.srcsetAttr);
              (e = s.customMedia[t[l]("data-media") || t[l]("media")]) &&
                t.setAttribute("media", e),
                i && t.setAttribute("srcset", i);
            },
            X = D(function (t, e, i, n, o) {
              var r, a, h, u, d, m;
              (d = w(t, "lazybeforeunveil", e)).defaultPrevented ||
                (n && (i ? _(t, s.autosizesClass) : t.setAttribute("sizes", n)),
                (a = t[l](s.srcsetAttr)),
                (r = t[l](s.srcAttr)),
                o && (u = (h = t.parentNode) && p.test(h.nodeName || "")),
                (m = e.firesLoad || ("src" in t && (a || r || u))),
                (d = { target: t }),
                _(t, s.loadingClass),
                m && (clearTimeout(f), (f = c(B, 2500)), b(t, Z, !0)),
                u && g.call(h.getElementsByTagName("source"), G),
                a
                  ? t.setAttribute("srcset", a)
                  : r &&
                    !u &&
                    (W.test(t.nodeName)
                      ? (function (t, e) {
                          try {
                            t.contentWindow.location.replace(e);
                          } catch (i) {
                            t.src = e;
                          }
                        })(t, r)
                      : (t.src = r)),
                o && (a || u) && x(t, { src: r })),
                t._lazyRace && delete t._lazyRace,
                y(t, s.lazyClass),
                T(function () {
                  var e = t.complete && t.naturalWidth > 1;
                  (m && !e) ||
                    (e && _(t, "ls-is-cached"),
                    K(d),
                    (t._lazyCache = !0),
                    c(function () {
                      "_lazyCache" in t && delete t._lazyCache;
                    }, 9)),
                    "lazy" == t.loading && R--;
                }, !0);
            }),
            J = function (t) {
              if (!t._lazyRace) {
                var e,
                  i = H.test(t.nodeName),
                  n = i && (t[l](s.sizesAttr) || t[l]("sizes")),
                  o = "auto" == n;
                ((!o && d) ||
                  !i ||
                  (!t[l]("src") && !t.srcset) ||
                  t.complete ||
                  v(t, s.errorClass) ||
                  !v(t, s.lazyClass)) &&
                  ((e = w(t, "lazyunveilread").detail),
                  o && A.updateElem(t, !0, t.offsetWidth),
                  (t._lazyRace = !0),
                  R++,
                  X(t, e, o, n, i));
              }
            },
            tt = E(function () {
              (s.loadMode = 3), V();
            }),
            et = function () {
              3 == s.loadMode && (s.loadMode = 2), tt();
            },
            it = function () {
              d ||
                (i.now() - k < 999
                  ? c(it, 999)
                  : ((d = !0), (s.loadMode = 3), V(), h("scroll", et, !0)));
            };
          return {
            _: function () {
              (k = i.now()),
                (n.elements = e.getElementsByClassName(s.lazyClass)),
                (r = e.getElementsByClassName(
                  s.lazyClass + " " + s.preloadClass
                )),
                h("scroll", V, !0),
                h("resize", V, !0),
                h("pageshow", function (t) {
                  if (t.persisted) {
                    var i = e.querySelectorAll("." + s.loadingClass);
                    i.length &&
                      i.forEach &&
                      u(function () {
                        i.forEach(function (t) {
                          t.complete && J(t);
                        });
                      });
                  }
                }),
                t.MutationObserver
                  ? new MutationObserver(V).observe(o, {
                      childList: !0,
                      subtree: !0,
                      attributes: !0,
                    })
                  : (o[a]("DOMNodeInserted", V, !0),
                    o[a]("DOMAttrModified", V, !0),
                    setInterval(V, 999)),
                h("hashchange", V, !0),
                [
                  "focus",
                  "mouseover",
                  "click",
                  "load",
                  "transitionend",
                  "animationend",
                ].forEach(function (t) {
                  e[a](t, V, !0);
                }),
                /d$|^c/.test(e.readyState)
                  ? it()
                  : (h("load", it), e[a]("DOMContentLoaded", V), c(it, 2e4)),
                n.elements.length ? (Y(), T._lsFlush()) : V();
            },
            checkElems: V,
            unveil: J,
            _aLSL: et,
          };
        })(),
        A = (function () {
          var t,
            i = D(function (t, e, i, n) {
              var s, o, r;
              if (
                ((t._lazysizesWidth = n),
                (n += "px"),
                t.setAttribute("sizes", n),
                p.test(e.nodeName || ""))
              )
                for (
                  o = 0, r = (s = e.getElementsByTagName("source")).length;
                  o < r;
                  o++
                )
                  s[o].setAttribute("sizes", n);
              i.detail.dataAttr || x(t, i.detail);
            }),
            n = function (t, e, n) {
              var s,
                o = t.parentNode;
              o &&
                ((n = k(t, o, n)),
                (s = w(t, "lazybeforesizes", { width: n, dataAttr: !!e }))
                  .defaultPrevented ||
                  ((n = s.detail.width) &&
                    n !== t._lazysizesWidth &&
                    i(t, o, s, n)));
            },
            o = E(function () {
              var e,
                i = t.length;
              if (i) for (e = 0; e < i; e++) n(t[e]);
            });
          return {
            _: function () {
              (t = e.getElementsByClassName(s.autosizesClass)), h("resize", o);
            },
            checkElems: o,
            updateElem: n,
          };
        })(),
        P = function () {
          !P.i && e.getElementsByClassName && ((P.i = !0), A._(), S._());
        };
      return (
        c(function () {
          s.init && P();
        }),
        (n = {
          cfg: s,
          autoSizer: A,
          loader: S,
          init: P,
          uP: x,
          aC: _,
          rC: y,
          hC: v,
          fire: w,
          gW: k,
          rAF: T,
        })
      );
    })(t, t.document, Date);
    (t.lazySizes = e),
      "object" == typeof module && module.exports && (module.exports = e);
  })("undefined" != typeof window ? window : {}),
  $(document).ready(function () {
    var t = setInterval(function () {
      $("#weekly-curation .owl-carousel .owl-next").length > 0 &&
        ($("#weekly-curation .owl-carousel .owl-next").addClass("active"),
        clearInterval(t));
    }, 100);
    if (
      ($("body").on(
        "animationend webkitAnimationEnd oAnimationEnd",
        "#weekly-curation .owl-carousel .owl-next svg circle",
        function () {
          $("#weekly-curation .owl-carousel").trigger("next.owl.carousel"),
            $("#weekly-curation .owl-carousel .owl-next").removeClass("active"),
            setTimeout(function () {
              $("#weekly-curation .owl-carousel .owl-next").addClass("active");
            }, 50);
        }
      ),
      $("body").on(
        "click",
        "#weekly-curation .owl-carousel .owl-next, #weekly-curation .owl-carousel .owl-prev",
        function () {
          $("#weekly-curation .owl-carousel .owl-next").removeClass("active");
        }
      ),
      setInterval(function () {
        "Out of stock" == $(".product-form__cart-submit").attr("aria-label")
          ? ($(".notify-me").removeClass("d-none"),
            $(".product-form__cart-submit").addClass("d-none"))
          : ($(".notify-me").addClass("d-none"),
            $(".product-form__cart-submit").removeClass("d-none"));
      }, 100),
      $(
        ".product-info .product-center .add-to-cart .product-form__item--submit .div-wishlist .nothearted input"
      ).addClass("addToFavorite"),
      setInterval(function () {
        "Add to Cart" ==
          $(
            ".sa_wishlist_page .sa_wishlist_main #products-html .prd_divv .prod_divv_addtocart .sw_full-block input[type='submit']"
          ).attr("value") &&
          $(
            ".sa_wishlist_page .sa_wishlist_main #products-html .prd_divv .prod_divv_addtocart .sw_full-block input[type='submit']"
          ).attr("value", "Add to Bag");
      }, 100),
      $(".nothearted input").click(function () {
        $.notify("To view your wishlist, please create an account.", "success");
      }),
      $(
        "#cart .custom-container .cart-summary .cart .table tbody tr td.price .edit"
      ).click(function () {
        $(this).parent().parent().parent().addClass("active");
        var t = $(this).parent().parent().parent().attr("data-level");
        return (
          $(
            "#cart .custom-container .cart-summary .cart .table tbody tr.cart-update[data-level='" +
              t +
              "']"
          ).addClass("active"),
          !1
        );
      }),
      $(
        "#cart .custom-container .cart-summary .cart .table tbody tr td.price .delete"
      ).click(function () {
        $(this).parent().parent().parent().removeClass("active");
        var t = $(this).parent().parent().parent().attr("data-level");
        return (
          $(
            "#cart .custom-container .cart-summary .cart .table tbody tr.cart-update[data-level='" +
              t +
              "']"
          ).removeClass("active"),
          !1
        );
      }),
      $.cookie("cookie") || $("#cookie").addClass("active"),
      $("#cookie .agree").click(function () {
        return (
          $.cookie("cookie", "true", { expires: 72e3 }),
          $("#cookie").removeClass("active"),
          !1
        );
      }),
      $("form.search").on("keyup keypress", function (t) {
        if (13 === (t.keyCode || t.which)) return t.preventDefault(), !1;
      }),
      $(".datepicker").datepicker(),
      $("body").on("change", "input[name='specific_occasion']", function () {
        "no" == $(this).val()
          ? $(".datepicker").addClass("active")
          : $(".datepicker").removeClass("active");
      }),
      $("body").on("change", "input[name='own_pair']", function () {
        "no" == $(this).val()
          ? ($(
              ".page--made-to-order__content__left__form .form__row.size"
            ).addClass("active"),
            $(
              ".page--made-to-order__content__left__form .form__row.size-and-style"
            ).removeClass("active"))
          : ($(
              ".page--made-to-order__content__left__form .form__row.size"
            ).removeClass("active"),
            $(
              ".page--made-to-order__content__left__form .form__row.size-and-style"
            ).addClass("active"));
      }),
      $(".page--customercare__content__left h3").click(function () {
        $(this).parent().hasClass("active")
          ? $(this).parent().removeClass("active")
          : $(this).parent().addClass("active");
      }),
      $("#blog .posts").length > 0)
    ) {
      setTimeout(function () {
        $("#blog .posts").addClass("active");
        new Masonry("#blog .posts", {});
      }, 1500);
      var e = 1;
      $("#blog .posts .post.level-2").length > 0
        ? ($("#blog #more .button span").html(
            $("#blog .posts .post.level-2").length
          ),
          $("#blog #more .button").click(function () {
            e++, $("#blog .posts").attr("data-level", e);
            new Masonry("#blog .posts", {});
            var t = e + 1;
            return (
              $("#blog .posts .post.level-" + t).length > 0
                ? $("#blog #more .button span").html(
                    $("#blog .posts .post.level-" + t).length
                  )
                : $("#blog #more").hide(),
              !1
            );
          }))
        : $("#blog #more").hide();
    }
    $(".quantity_up").click(function () {
      var t = parseInt($(this).parent().find("input").val());
      return (
        isNaN(t) && (t = 0),
        $(this)
          .parent()
          .find("input")
          .val(t + 1)
          .keyup(),
        $(
          "#cart .custom-container .cart-summary .summary button[name='update']"
        ).addClass("active"),
        !1
      );
    }),
      $(".quantity_down").click(function () {
        var t = parseInt($(this).parent().find("input").val());
        return (
          isNaN(t) && (t = 0),
          t > 1 &&
            $(this)
              .parent()
              .find("input")
              .val(t - 1)
              .keyup(),
          $(
            "#cart .custom-container .cart-summary .summary button[name='update']"
          ).addClass("active"),
          !1
        );
      }),
      $(".quantity_up2").click(function () {
        var t = parseInt($(this).parent().find("input").val());
        isNaN(t) && (t = 0),
          $(this)
            .parent()
            .find("input")
            .val(t + 1)
            .keyup();
        var e = $(this).parent().parent().parent().attr("data-level");
        return (
          $(this)
            .parent()
            .parent()
            .parent()
            .parent()
            .find("tr[data-level='" + e + "'] input")
            .val(t + 1)
            .keyup(),
          $(
            "#cart .custom-container .cart-summary .summary button[name='update']"
          ).addClass("active"),
          !1
        );
      }),
      $(".quantity_down2").click(function () {
        var t = parseInt($(this).parent().find("input").val());
        if ((isNaN(t) && (t = 0), t > 1)) {
          $(this)
            .parent()
            .find("input")
            .val(t - 1)
            .keyup();
          var e = $(this).parent().parent().parent().attr("data-level");
          $(this)
            .parent()
            .parent()
            .parent()
            .parent()
            .find("tr[data-level='" + e + "'] input")
            .val(t - 1)
            .keyup();
        }
        return (
          $(
            "#cart .custom-container .cart-summary .summary button[name='update']"
          ).addClass("active"),
          !1
        );
      }),
      // $("#shop .filter-sort .filter .dropdown > a").click(function () {
      //     $("#shop .filter-sort .filter .dropdown .dropdown-menu").hasClass("show")
      //         ? $("#shop .filter-sort .filter .dropdown .dropdown-menu").stop(!0, !0).hide()
      //         : $("#shop .filter-sort .filter .dropdown .dropdown-menu").stop(!0, !0).show();
      // }),
      // $("#shop .filter-sort .sort .dropdown > a").click(function () {
      //     $("#shop .filter-sort .sort .dropdown .dropdown-menu").hasClass("show")
      //         ? $("#shop .filter-sort .sort .dropdown .dropdown-menu").stop(!0, !0).hide()
      //         : $("#shop .filter-sort .sort .dropdown .dropdown-menu").stop(!0, !0).show();
      // }),
      $("#login select").selectric(),
      $("#product .variations select").selectric({
        optionsItemBuilder: function (itemData) {
          return itemData.element[0].dataset.postFix.length
            ? itemData.text +
                '<span class="ms-fs-xs ms-col-grey">' +
                itemData.element[0].dataset.postFix +
                "</span>"
            : itemData.text;
        },
        labelBuilder: function (itemData) {
          return itemData.element[0].dataset.label.length
            ? '<span class="ms-fs-xs ms-col-grey mr-2">' +
                itemData.element[0].dataset.label +
                "</span>" +
                itemData.text
            : itemData.text;
        },
      }),
      $("#shop #more a").length > 0 &&
        $.ajax({ url: $("#shop #more a").attr("href"), type: "GET" }).done(
          function (t) {
            var e = $(t).find(".item").length;
            $("#shop #more a span").html(e);
          }
        ),
      $("#shop").on("click", "#more a", function () {
        return (
          $.ajax({
            url: $(this).attr("href"),
            type: "GET",
            beforeSend: function () {
              $("#more").fadeOut();
              var t = $("#more");
              setTimeout(function () {
                t.remove();
              }, 500);
            },
          }).done(function (t) {
            $(".filter-content .products").append(
              $(t).find(".filter-content .products").html()
            ),
              $("#shop #more a").length
                ? ""
                : $(".ms-collection__products").addClass(
                    "ms-collection__products--last-page"
                  ),
              $("#shop #more a").length > 0 &&
                $.ajax({
                  url: $("#shop #more a").attr("href"),
                  type: "GET",
                }).done(function (t) {
                  var e = $(t).find(".item").length;
                  $("#shop #more a span").html(e);
                });
          }),
          !1
        );
      }),
      $(document).on(
        "click",
        ".filter-sort .filter .dropdown-menu",
        function (t) {
          t.stopPropagation();
        }
      ),
      $("body").on("click", ".mfilter-content .filter_title", function () {
        $(this).parent().hasClass("active")
          ? ($(this)
              .parent()
              .find(".filter_container")
              .stop(!0, !0)
              .slideUp(300),
            $(this).parent().removeClass("active"))
          : ($(this)
              .parent()
              .find(".filter_container")
              .stop(!0, !0)
              .slideDown(300),
            $(this).parent().addClass("active"));
      }),
      (Shopify.queryParams = {}),
      (Shopify.queryParams.sort_by = $(".sort-by")
        .find("a.active")
        .attr("data-value"));
    var i = [];
    function n() {
      return "" == Shopify.queryParams.constraint
        ? $(".filter-content").attr("data-url") +
            "?sort_by=" +
            Shopify.queryParams.sort_by
        : $(".filter-content").attr("data-url") +
            "/" +
            Shopify.queryParams.constraint +
            "?sort_by=" +
            Shopify.queryParams.sort_by;
    }
    function s(t) {
      $.ajax({
        type: "get",
        url: t,
        beforeSend: function () {
          $("body").addClass("is_loading");
        },
        success: function (e) {
          var i = e.match("<title>(.*?)</title>")[1];
          History.pushState({ param: Shopify.queryParams }, i, t),
            $(".filter-content").html($(e).find(".filter-content").html()),
            $(".sort .dropdown > a").html(
              $(e).find(".sort .dropdown > a").html()
            ),
            $(".active-filters__list").html(
              $(e).find(".active-filters__list").html()
            ),
            $(".ms-collection__items-count").html(
              $(e).find(".ms-collection__items-count").html()
            ),
            $(".ms-collection__products").attr(
              "data-filtered",
              $(e).find(".ms-collection__products").attr("data-filtered")
            ),
            $("body").removeClass("is_loading"),
            $("#shop #more a").length > 0 &&
              $.ajax({
                url: $("#shop #more a").attr("href"),
                type: "GET",
              }).done(function (t) {
                var e = $(t).find(".item").length;
                $("#shop #more a span").html(
                  e
                ); /*if(typeof updateHeartsOnCollectionPage == 'function'){updateHeartsOnCollectionPage();}*/
              }); /*if(typeof updateHeartsOnCollectionPage == 'function'){updateHeartsOnCollectionPage();}*/
        },
        error: function () {
          $("body").removeClass("is_loading");
        },
      });
    }
    $(".field input").each(function () {
      $(this).is(":checked") && i.push($(this).attr("value"));
    }),
      (Shopify.queryParams.constraint = i.join("+")),
      $(".field input").each(function () {
        $(this).is(":checked") && $("#shop .active-filters").addClass("active");
      }),
      $("body").on("click", ".apply-filters a", function (t) {
        var e = [];
        return (
          $(".field input").each(function () {
            $(this).is(":checked") && e.push($(this).attr("value"));
          }),
          (Shopify.queryParams.constraint = e.join("+")),
          s(n()),
          $("#shop .filter-sort .filter .dropdown > a").click(),
          $("#shop .active-filters").addClass("active"),
          !1
        );
      }),
      $("body").on(
        "click",
        "#shop .active-filters__list-item-button",
        function () {
          var activeFilters = [];
          var removeFilter = $(this).data("tag");
          return (
            $(".field input").each(function () {
              $(this).is(":checked") &&
                activeFilters.push($(this).attr("value"));
              if ($(this).attr("value") === removeFilter) {
                $(this).prop("checked", !1);
              }
            }),
            (activeFilters = $.grep(activeFilters, function (value) {
              return value !== removeFilter;
            })),
            activeFilters.length < 1
              ? $("#shop .active-filters").removeClass("active")
              : "",
            (Shopify.queryParams.constraint = activeFilters.join("+")),
            s(n()),
            !1
          );
        }
      ),
      $("#shop .close-filter").click(function () {
        $("#shop .active-filters").removeClass("active"),
          $(".field .checkbox").each(function () {
            $(this).prop("checked", !1);
          });
        return (Shopify.queryParams.constraint = [].join("+")), s(n()), !1;
      }),
      $("body").on("click", ".sort-by a", function (t) {
        return (
          $(".sort-by a").removeClass("active"),
          $(this).addClass("active"),
          (Shopify.queryParams.sort_by = $(this).attr("data-value")),
          s(n()),
          t.preventDefault(),
          $("#shop .filter-sort .sort .dropdown > a").click(),
          !1
        );
      });
  }),
  (function (t) {
    "use strict";
    malone = {
      init: function () {
        this.lazyImages();
      },
      lazyImages: function () {
        function e() {
          return window.devicePixelRatio > 1;
        }
        function i() {
          return !(t(document).outerWidth() > 767);
        }
        t(".lazy-img").each(function () {
          var n = t(this),
            s = setInterval(function () {
              if (t(n).isInViewport() || t(n).hasClass("immediately")) {
                var o = t(n).attr("data-src");
                e() &&
                  i() &&
                  null != t(n).attr("data-retina-mobile-src") &&
                  (o = t(n).attr("data-retina-mobile-src")),
                  !e() &&
                    i() &&
                    null != t(n).attr("data-mobile-src") &&
                    (o = t(n).attr("data-mobile-src")),
                  e() &&
                    !i() &&
                    null != t(n).attr("data-retina-src") &&
                    (o = t(n).attr("data-retina-src")),
                  "" == o && (o = t(n).attr("data-src")),
                  t(n).attr("src", o),
                  t(n)
                    .parent()
                    .waitForImages(function () {
                      setTimeout(function () {
                        t(n).parent().addClass("active");
                      }, 100),
                        clearInterval(s);
                    });
              }
            }, 200);
        });
      },
    };
  })(jQuery),
  $(document).ready(function () {
    malone.init();
  }),
  window.Shopify.designMode &&
    jQuery(document)
      .on("shopify:section:load", function () {
        malone.init();
      })
      .on("shopify:section:unload", function () {
        malone.init();
      })
      .on("shopify:section:select", function () {
        malone.init();
      })
      .on("shopify:section:deselect", function () {
        malone.init();
      })
      .on("shopify:block:select", function () {
        malone.init();
      })
      .on("shopify:block:deselect", function () {
        malone.init();
      }),
  ($.fn.isInViewport = function () {
    var t = $(this).offset().top,
      e = t + $(this).outerHeight(),
      i = $(window).scrollTop(),
      n = i + 0.7 * $(window).height();
    return e > i && t < n;
  }),
  (function (t) {
    "function" == typeof define && define.amd
      ? define(["jquery"], t)
      : "object" == typeof exports
      ? (module.exports = t(require("jquery")))
      : t(jQuery);
  })(function (t) {
    var e = "waitForImages",
      i = (function (t) {
        return t.srcset && t.sizes;
      })(new Image());
    (t.waitForImages = {
      hasImageProperties: [
        "backgroundImage",
        "listStyleImage",
        "borderImage",
        "borderCornerImage",
        "cursor",
      ],
      hasImageAttributes: ["srcset"],
    }),
      (t.expr.pseudos["has-src"] = function (e) {
        return t(e).is('img[src][src!=""]');
      }),
      (t.expr.pseudos.uncached = function (e) {
        return !!t(e).is(":has-src") && !e.complete;
      }),
      (t.fn.waitForImages = function () {
        var n,
          s,
          o,
          r,
          a = 0,
          l = t.Deferred(),
          h = this,
          c = [],
          u = t.waitForImages.hasImageProperties || [],
          d = t.waitForImages.hasImageAttributes || [],
          p = /url\(\s*(['"]?)(.*?)\1\s*\)/g;
        if (
          (t.isPlainObject(arguments[0])
            ? ((o = arguments[0].waitForAll),
              (s = arguments[0].each),
              (n = arguments[0].finished))
            : 1 === arguments.length && "boolean" === t.type(arguments[0])
            ? (o = arguments[0])
            : ((n = arguments[0]), (s = arguments[1]), (o = arguments[2])),
          (n = n || t.noop),
          (s = s || t.noop),
          (o = !!o),
          !t.isFunction(n) || !t.isFunction(s))
        )
          throw new TypeError("An invalid callback was supplied.");
        return (
          this.each(function () {
            var e = t(this);
            o
              ? e
                  .find("*")
                  .addBack()
                  .each(function () {
                    var e = t(this);
                    e.is("img:has-src") &&
                      !e.is("[srcset]") &&
                      c.push({ src: e.attr("src"), element: e[0] }),
                      t.each(u, function (t, i) {
                        var n,
                          s = e.css(i);
                        if (!s) return !0;
                        for (; (n = p.exec(s)); )
                          c.push({ src: n[2], element: e[0] });
                      }),
                      t.each(d, function (t, i) {
                        return (
                          !e.attr(i) ||
                          void c.push({
                            src: e.attr("src"),
                            srcset: e.attr("srcset"),
                            element: e[0],
                          })
                        );
                      });
                  })
              : e.find("img:has-src").each(function () {
                  c.push({ src: this.src, element: this });
                });
          }),
          (r = c.length),
          (a = 0),
          0 === r && (n.call(h), l.resolveWith(h)),
          t.each(c, function (o, c) {
            var u = new Image(),
              d = "load." + e + " error." + e;
            t(u).one(d, function e(i) {
              var o = [a, r, "load" == i.type];
              if (
                (a++,
                s.apply(c.element, o),
                l.notifyWith(c.element, o),
                t(this).off(d, e),
                a == r)
              )
                return n.call(h[0]), l.resolveWith(h[0]), !1;
            }),
              i && c.srcset && ((u.srcset = c.srcset), (u.sizes = c.sizes)),
              (u.src = c.src);
          }),
          l.promise()
        );
      });
  }),
  (function (t) {
    var e = {};
    function i(n) {
      if (e[n]) return e[n].exports;
      var s = (e[n] = { i: n, l: !1, exports: {} });
      return t[n].call(s.exports, s, s.exports, i), (s.l = !0), s.exports;
    }
    (i.m = t),
      (i.c = e),
      (i.d = function (t, e, n) {
        i.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: n });
      }),
      (i.r = function (t) {
        "undefined" != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }),
          Object.defineProperty(t, "__esModule", { value: !0 });
      }),
      (i.t = function (t, e) {
        if ((1 & e && (t = i(t)), 8 & e)) return t;
        if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
        var n = Object.create(null);
        if (
          (i.r(n),
          Object.defineProperty(n, "default", { enumerable: !0, value: t }),
          2 & e && "string" != typeof t)
        )
          for (var s in t)
            i.d(
              n,
              s,
              function (e) {
                return t[e];
              }.bind(null, s)
            );
        return n;
      }),
      (i.n = function (t) {
        var e =
          t && t.__esModule
            ? function () {
                return t.default;
              }
            : function () {
                return t;
              };
        return i.d(e, "a", e), e;
      }),
      (i.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }),
      (i.p = ""),
      i((i.s = 1));
  })([
    function (t, e, i) {
      (function (e) {
        t.exports = (function () {
          "use strict";
          var t =
              "undefined" != typeof window
                ? window
                : void 0 !== e
                ? e
                : "undefined" != typeof self
                ? self
                : {},
            i = "Expected a function",
            n = /^\s+|\s+$/g,
            s = /^[-+]0x[0-9a-f]+$/i,
            o = /^0b[01]+$/i,
            r = /^0o[0-7]+$/i,
            a = parseInt,
            l = "object" == _typeof(t) && t && t.Object === Object && t,
            h =
              "object" ==
                ("undefined" == typeof self ? "undefined" : _typeof(self)) &&
              self &&
              self.Object === Object &&
              self,
            c = l || h || Function("return this")(),
            u = Object.prototype.toString,
            d = Math.max,
            p = Math.min,
            f = function () {
              return c.Date.now();
            };
          function m(t) {
            var e = _typeof(t);
            return !!t && ("object" == e || "function" == e);
          }
          function g(t) {
            if ("number" == typeof t) return t;
            if (
              (function (t) {
                return (
                  "symbol" == _typeof(t) ||
                  ((function (t) {
                    return !!t && "object" == _typeof(t);
                  })(t) &&
                    "[object Symbol]" == u.call(t))
                );
              })(t)
            )
              return NaN;
            if (m(t)) {
              var e = "function" == typeof t.valueOf ? t.valueOf() : t;
              t = m(e) ? e + "" : e;
            }
            if ("string" != typeof t) return 0 === t ? t : +t;
            t = t.replace(n, "");
            var i = o.test(t);
            return i || r.test(t)
              ? a(t.slice(2), i ? 2 : 8)
              : s.test(t)
              ? NaN
              : +t;
          }
          var v = /^\s+|\s+$/g,
            _ = /^[-+]0x[0-9a-f]+$/i,
            y = /^0b[01]+$/i,
            b = /^0o[0-7]+$/i,
            w = parseInt,
            x = "object" == _typeof(t) && t && t.Object === Object && t,
            C =
              "object" ==
                ("undefined" == typeof self ? "undefined" : _typeof(self)) &&
              self &&
              self.Object === Object &&
              self,
            k = x || C || Function("return this")(),
            T = Object.prototype.toString,
            D = Math.max,
            I = Math.min,
            E = function () {
              return k.Date.now();
            };
          function S(t) {
            var e = _typeof(t);
            return !!t && ("object" == e || "function" == e);
          }
          function A(t) {
            if ("number" == typeof t) return t;
            if (
              (function (t) {
                return (
                  "symbol" == _typeof(t) ||
                  ((function (t) {
                    return !!t && "object" == _typeof(t);
                  })(t) &&
                    "[object Symbol]" == T.call(t))
                );
              })(t)
            )
              return NaN;
            if (S(t)) {
              var e = "function" == typeof t.valueOf ? t.valueOf() : t;
              t = S(e) ? e + "" : e;
            }
            if ("string" != typeof t) return 0 === t ? t : +t;
            t = t.replace(v, "");
            var i = y.test(t);
            return i || b.test(t)
              ? w(t.slice(2), i ? 2 : 8)
              : _.test(t)
              ? NaN
              : +t;
          }
          var P = function (t, e, i) {
              var n,
                s,
                o,
                r,
                a,
                l,
                h = 0,
                c = !1,
                u = !1,
                d = !0;
              if ("function" != typeof t)
                throw new TypeError("Expected a function");
              function p(e) {
                var i = n,
                  o = s;
                return (n = s = void 0), (h = e), (r = t.apply(o, i));
              }
              function f(t) {
                var i = t - l;
                return void 0 === l || i >= e || i < 0 || (u && t - h >= o);
              }
              function m() {
                var t = E();
                if (f(t)) return g(t);
                a = setTimeout(
                  m,
                  (function (t) {
                    var i = e - (t - l);
                    return u ? I(i, o - (t - h)) : i;
                  })(t)
                );
              }
              function g(t) {
                return (a = void 0), d && n ? p(t) : ((n = s = void 0), r);
              }
              function v() {
                var t = E(),
                  i = f(t);
                if (((n = arguments), (s = this), (l = t), i)) {
                  if (void 0 === a)
                    return (function (t) {
                      return (h = t), (a = setTimeout(m, e)), c ? p(t) : r;
                    })(l);
                  if (u) return (a = setTimeout(m, e)), p(l);
                }
                return void 0 === a && (a = setTimeout(m, e)), r;
              }
              return (
                (e = A(e) || 0),
                S(i) &&
                  ((c = !!i.leading),
                  (o = (u = "maxWait" in i) ? D(A(i.maxWait) || 0, e) : o),
                  (d = "trailing" in i ? !!i.trailing : d)),
                (v.cancel = function () {
                  void 0 !== a && clearTimeout(a),
                    (h = 0),
                    (n = l = s = a = void 0);
                }),
                (v.flush = function () {
                  return void 0 === a ? r : g(E());
                }),
                v
              );
            },
            O = function () {};
          function M(t) {
            t &&
              t.forEach(function (t) {
                var e = Array.prototype.slice.call(t.addedNodes),
                  i = Array.prototype.slice.call(t.removedNodes);
                if (
                  (function t(e) {
                    var i = void 0,
                      n = void 0;
                    for (i = 0; i < e.length; i += 1) {
                      if ((n = e[i]).dataset && n.dataset.aos) return !0;
                      if (n.children && t(n.children)) return !0;
                    }
                    return !1;
                  })(e.concat(i))
                )
                  return O();
              });
          }
          function z() {
            return (
              window.MutationObserver ||
              window.WebKitMutationObserver ||
              window.MozMutationObserver
            );
          }
          var $ = (function () {
              function t(t, e) {
                for (var i = 0; i < e.length; i++) {
                  var n = e[i];
                  (n.enumerable = n.enumerable || !1),
                    (n.configurable = !0),
                    "value" in n && (n.writable = !0),
                    Object.defineProperty(t, n.key, n);
                }
              }
              return function (e, i, n) {
                return i && t(e.prototype, i), n && t(e, n), e;
              };
            })(),
            N =
              Object.assign ||
              function (t) {
                for (var e = 1; e < arguments.length; e++) {
                  var i = arguments[e];
                  for (var n in i)
                    Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
                }
                return t;
              },
            H =
              /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
            W =
              /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
            F =
              /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,
            L =
              /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;
          function R() {
            return (
              navigator.userAgent || navigator.vendor || window.opera || ""
            );
          }
          var j = new ((function () {
              function t() {
                !(function (t, e) {
                  if (!(t instanceof e))
                    throw new TypeError("Cannot call a class as a function");
                })(this, t);
              }
              return (
                $(t, [
                  {
                    key: "phone",
                    value: function () {
                      var t = R();
                      return !(!H.test(t) && !W.test(t.substr(0, 4)));
                    },
                  },
                  {
                    key: "mobile",
                    value: function () {
                      var t = R();
                      return !(!F.test(t) && !L.test(t.substr(0, 4)));
                    },
                  },
                  {
                    key: "tablet",
                    value: function () {
                      return this.mobile() && !this.phone();
                    },
                  },
                  {
                    key: "ie11",
                    value: function () {
                      return (
                        "-ms-scroll-limit" in document.documentElement.style &&
                        "-ms-ime-align" in document.documentElement.style
                      );
                    },
                  },
                ]),
                t
              );
            })())(),
            B = function (t, e) {
              var i = void 0;
              return (
                j.ie11()
                  ? (i = document.createEvent("CustomEvent")).initCustomEvent(
                      t,
                      !0,
                      !0,
                      { detail: e }
                    )
                  : (i = new CustomEvent(t, { detail: e })),
                document.dispatchEvent(i)
              );
            },
            q = function (t) {
              return t.forEach(function (t, e) {
                return (function (t, e) {
                  var i = t.options,
                    n = t.position,
                    s = t.node,
                    o =
                      (t.data,
                      function () {
                        t.animated &&
                          ((function (t, e) {
                            e &&
                              e.forEach(function (e) {
                                return t.classList.remove(e);
                              });
                          })(s, i.animatedClassNames),
                          B("aos:out", s),
                          t.options.id && B("aos:in:" + t.options.id, s),
                          (t.animated = !1));
                      });
                  i.mirror && e >= n.out && !i.once
                    ? o()
                    : e >= n.in
                    ? t.animated ||
                      ((function (t, e) {
                        e &&
                          e.forEach(function (e) {
                            return t.classList.add(e);
                          });
                      })(s, i.animatedClassNames),
                      B("aos:in", s),
                      t.options.id && B("aos:in:" + t.options.id, s),
                      (t.animated = !0))
                    : t.animated && !i.once && o();
                })(t, window.pageYOffset);
              });
            },
            U = function (t) {
              for (
                var e = 0, i = 0;
                t && !isNaN(t.offsetLeft) && !isNaN(t.offsetTop);

              )
                (e += t.offsetLeft - ("BODY" != t.tagName ? t.scrollLeft : 0)),
                  (i += t.offsetTop - ("BODY" != t.tagName ? t.scrollTop : 0)),
                  (t = t.offsetParent);
              return { top: i, left: e };
            },
            Y = function (t, e, i) {
              var n = t.getAttribute("data-aos-" + e);
              if (void 0 !== n) {
                if ("true" === n) return !0;
                if ("false" === n) return !1;
              }
              return n || i;
            },
            V = function () {
              var t = document.querySelectorAll("[data-aos]");
              return Array.prototype.map.call(t, function (t) {
                return { node: t };
              });
            },
            K = [],
            Q = !1,
            Z = {
              offset: 120,
              delay: 0,
              easing: "ease",
              duration: 400,
              disable: !1,
              once: !1,
              mirror: !1,
              anchorPlacement: "top-bottom",
              startEvent: "DOMContentLoaded",
              animatedClassName: "aos-animate",
              initClassName: "aos-init",
              useClassNames: !1,
              disableMutationObserver: !1,
              throttleDelay: 99,
              debounceDelay: 50,
            },
            G = function () {
              return document.all && !window.atob;
            },
            X = function () {
              var t, e;
              arguments.length > 0 &&
                void 0 !== arguments[0] &&
                arguments[0] &&
                (Q = !0),
                Q &&
                  ((e = Z),
                  (t = K).forEach(function (t, i) {
                    var n = Y(t.node, "mirror", e.mirror),
                      s = Y(t.node, "once", e.once),
                      o = Y(t.node, "id"),
                      r = e.useClassNames && t.node.getAttribute("data-aos"),
                      a = [e.animatedClassName]
                        .concat(r ? r.split(" ") : [])
                        .filter(function (t) {
                          return "string" == typeof t;
                        });
                    e.initClassName && t.node.classList.add(e.initClassName),
                      (t.position = {
                        in: (function (t, e, i) {
                          var n = window.innerHeight,
                            s = Y(t, "anchor"),
                            o = Y(t, "anchor-placement"),
                            r = Number(Y(t, "offset", o ? 0 : e)),
                            a = o || i,
                            l = t;
                          s &&
                            document.querySelectorAll(s) &&
                            (l = document.querySelectorAll(s)[0]);
                          var h = U(l).top - n;
                          switch (a) {
                            case "top-bottom":
                              break;
                            case "center-bottom":
                              h += l.offsetHeight / 2;
                              break;
                            case "bottom-bottom":
                              h += l.offsetHeight;
                              break;
                            case "top-center":
                              h += n / 2;
                              break;
                            case "center-center":
                              h += n / 2 + l.offsetHeight / 2;
                              break;
                            case "bottom-center":
                              h += n / 2 + l.offsetHeight;
                              break;
                            case "top-top":
                              h += n;
                              break;
                            case "bottom-top":
                              h += n + l.offsetHeight;
                              break;
                            case "center-top":
                              h += n + l.offsetHeight / 2;
                          }
                          return h + r;
                        })(t.node, e.offset, e.anchorPlacement),
                        out:
                          n &&
                          (function (t, e) {
                            window.innerHeight;
                            var i = Y(t, "anchor"),
                              n = Y(t, "offset", e),
                              s = t;
                            return (
                              i &&
                                document.querySelectorAll(i) &&
                                (s = document.querySelectorAll(i)[0]),
                              U(s).top + s.offsetHeight - n
                            );
                          })(t.node, e.offset),
                      }),
                      (t.options = {
                        once: s,
                        mirror: n,
                        animatedClassNames: a,
                        id: o,
                      });
                  }),
                  q((K = t)),
                  window.addEventListener(
                    "scroll",
                    (function (t, e, n) {
                      var s = !0,
                        o = !0;
                      if ("function" != typeof t) throw new TypeError(i);
                      return (
                        m(n) &&
                          ((s = "leading" in n ? !!n.leading : s),
                          (o = "trailing" in n ? !!n.trailing : o)),
                        (function (t, e, n) {
                          var s,
                            o,
                            r,
                            a,
                            l,
                            h,
                            c = 0,
                            u = !1,
                            v = !1,
                            _ = !0;
                          if ("function" != typeof t) throw new TypeError(i);
                          function y(e) {
                            var i = s,
                              n = o;
                            return (
                              (s = o = void 0), (c = e), (a = t.apply(n, i))
                            );
                          }
                          function b(t) {
                            var i = t - h;
                            return (
                              void 0 === h ||
                              i >= e ||
                              i < 0 ||
                              (v && t - c >= r)
                            );
                          }
                          function w() {
                            var t = f();
                            if (b(t)) return x(t);
                            l = setTimeout(
                              w,
                              (function (t) {
                                var i = e - (t - h);
                                return v ? p(i, r - (t - c)) : i;
                              })(t)
                            );
                          }
                          function x(t) {
                            return (
                              (l = void 0),
                              _ && s ? y(t) : ((s = o = void 0), a)
                            );
                          }
                          function C() {
                            var t = f(),
                              i = b(t);
                            if (((s = arguments), (o = this), (h = t), i)) {
                              if (void 0 === l)
                                return (function (t) {
                                  return (
                                    (c = t),
                                    (l = setTimeout(w, e)),
                                    u ? y(t) : a
                                  );
                                })(h);
                              if (v) return (l = setTimeout(w, e)), y(h);
                            }
                            return void 0 === l && (l = setTimeout(w, e)), a;
                          }
                          return (
                            (e = g(e) || 0),
                            m(n) &&
                              ((u = !!n.leading),
                              (r = (v = "maxWait" in n)
                                ? d(g(n.maxWait) || 0, e)
                                : r),
                              (_ = "trailing" in n ? !!n.trailing : _)),
                            (C.cancel = function () {
                              void 0 !== l && clearTimeout(l),
                                (c = 0),
                                (s = h = o = l = void 0);
                            }),
                            (C.flush = function () {
                              return void 0 === l ? a : x(f());
                            }),
                            C
                          );
                        })(t, e, { leading: s, maxWait: e, trailing: o })
                      );
                    })(function () {
                      q(K, Z.once);
                    }, Z.throttleDelay)
                  ));
            },
            J = function () {
              if (((K = V()), et(Z.disable) || G())) return tt();
              X();
            },
            tt = function () {
              K.forEach(function (t, e) {
                t.node.removeAttribute("data-aos"),
                  t.node.removeAttribute("data-aos-easing"),
                  t.node.removeAttribute("data-aos-duration"),
                  t.node.removeAttribute("data-aos-delay"),
                  Z.initClassName && t.node.classList.remove(Z.initClassName),
                  Z.animatedClassName &&
                    t.node.classList.remove(Z.animatedClassName);
              });
            },
            et = function (t) {
              return (
                !0 === t ||
                ("mobile" === t && j.mobile()) ||
                ("phone" === t && j.phone()) ||
                ("tablet" === t && j.tablet()) ||
                ("function" == typeof t && !0 === t())
              );
            };
          return {
            init: function (t) {
              return (
                (Z = N(Z, t)),
                (K = V()),
                Z.disableMutationObserver ||
                  !!z() ||
                  (console.info(
                    '\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '
                  ),
                  (Z.disableMutationObserver = !0)),
                Z.disableMutationObserver ||
                  ((e = J),
                  (i = window.document),
                  (n = new (z())(M)),
                  (O = e),
                  n.observe(i.documentElement, {
                    childList: !0,
                    subtree: !0,
                    removedNodes: !0,
                  })),
                et(Z.disable) || G()
                  ? tt()
                  : (document
                      .querySelector("body")
                      .setAttribute("data-aos-easing", Z.easing),
                    document
                      .querySelector("body")
                      .setAttribute("data-aos-duration", Z.duration),
                    document
                      .querySelector("body")
                      .setAttribute("data-aos-delay", Z.delay),
                    -1 === ["DOMContentLoaded", "load"].indexOf(Z.startEvent)
                      ? document.addEventListener(Z.startEvent, function () {
                          X(!0);
                        })
                      : window.addEventListener("load", function () {
                          X(!0);
                        }),
                    "DOMContentLoaded" === Z.startEvent &&
                      ["complete", "interactive"].indexOf(document.readyState) >
                        -1 &&
                      X(!0),
                    window.addEventListener(
                      "resize",
                      P(X, Z.debounceDelay, !0)
                    ),
                    window.addEventListener(
                      "orientationchange",
                      P(X, Z.debounceDelay, !0)
                    ),
                    K)
              );
              var e, i, n;
            },
            refresh: X,
            refreshHard: J,
          };
        })();
      }).call(this, i(2));
    },
    function (t, e, i) {
      t.exports = i(3);
    },
    function (t, e) {
      var i;
      i = (function () {
        return this;
      })();
      try {
        i = i || new Function("return this")();
      } catch (t) {
        "object" ==
          ("undefined" == typeof window ? "undefined" : _typeof(window)) &&
          (i = window);
      }
      t.exports = i;
    },
    function (t, e, i) {
      "use strict";
      i.r(e),
        new ((function () {
          function t() {
            _classCallCheck(this, t),
              $(document).ready($.proxy(this.init, this));
          }
          return (
            _createClass(t, [
              {
                key: "init",
                value: function () {},
              },
            ]),
            t
          );
        })())();
      var n = i(0),
        s = i.n(n);
      new ((function () {
        function t() {
          _classCallCheck(this, t), $(document).ready($.proxy(this.init, this));
        }
        return (
          _createClass(t, [
            {
              key: "init",
              value: function () {
                s.a.init({ once: !0 });
              },
            },
          ]),
          t
        );
      })())(),
        new ((function () {
          function t() {
            _classCallCheck(this, t),
              $(document).ready($.proxy(this.init, this));
          }
          return (
            _createClass(t, [
              {
                key: "init",
                value: function () {
                  this.initSlider();
                },
              },
              {
                key: "initSlider",
                value: function () {
                  $(
                    ".section-weekly-curation__elements.owl-carousel"
                  ).owlCarousel({
                    touchDrag: !0,
                    mouseDrag: !0,
                    items: 3,
                    margin: 68,
                    nav: !0,
                    navText: [
                      '<svg><circle class="outer" cx="17" cy="17" r="17" transform="rotate(-90, 17, 17)"></circle></svg>',
                      '<svg><circle class="outer" cx="17" cy="17" r="17" transform="rotate(-90, 17, 17)"></circle></svg>',
                    ],
                    dotsData: !0,
                    responsive: {
                      0: { items: 1, margin: 30 },
                      768: { items: 2, margin: 68 },
                      1000: { items: 3, margin: 68 },
                    },
                  });
                },
              },
            ]),
            t
          );
        })())();
    },
  ]);
